export type OdProtosCommon_Date = {
  __typename?: 'OdProtosCommon_Date';
  day: number;
  month: number;
  year: number;
};

export type OdProtosCommon_Time = {
  __typename?: 'OdProtosCommon_Time';
  hours: number;
  minutes: number;
};

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: OdProtosCommon_Date; output: OdProtosCommon_Date; }
  DateString: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  DateTimeISO: { input: string; output: string; }
  JSON: { input: unknown; output: unknown; }
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  RubyTimestamp: { input: string; output: string; }
  Time: { input: OdProtosCommon_Time; output: OdProtosCommon_Time; }
};

export enum AbraAssessmentHandoffType {
  EXPERT = 'EXPERT',
  INVITATION = 'INVITATION',
  UNKNOWN = 'UNKNOWN'
}

export type AbraCancelAssessmentHandoffInput = {
  handoffId: Scalars['String']['input'];
  humanToken: Scalars['String']['input'];
};

export type AbraEnsureAssessmentTaskWithHandoffExpertInput = {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  customerMobilePhone?: InputMaybe<Scalars['String']['input']>;
  scheduledAt: Scalars['DateTime']['input'];
};

export type AbraEnsureAssessmentTaskWithHandoffInput = {
  expert?: InputMaybe<AbraEnsureAssessmentTaskWithHandoffExpertInput>;
  flipToken: Scalars['String']['input'];
  humanToken: Scalars['String']['input'];
};

export type AbraGetAssessmentHandoffsFiltersInput = {
  taskHandoffIds: Array<Scalars['String']['input']>;
};

export type AbraGetAssessmentHandoffsInput = {
  filters?: InputMaybe<AbraGetAssessmentHandoffsFiltersInput>;
};

export type AgentContactInput = {
  brokerage_names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customer_uuid: Scalars['String']['input'];
  license_number?: InputMaybe<Scalars['String']['input']>;
  mls: Scalars['String']['input'];
  mls_id?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthorizationType {
  /** any human that is marked as an agent */
  AGENT_ACCESS = 'AGENT_ACCESS',
  /** any human that is authenticated */
  ANY_AUTHENTICATED = 'ANY_AUTHENTICATED',
  /** any human that is in an organization */
  ANY_MEMBERSHIP = 'ANY_MEMBERSHIP',
  /** 3rd party contractors that do assessments for us */
  ASSESSMENT_CONTRACTOR_MEMBERSHIP = 'ASSESSMENT_CONTRACTOR_MEMBERSHIP',
  /** belongs to the Day One Walk Partners - National org */
  D1W_PARTNER_MEMBERSHIP = 'D1W_PARTNER_MEMBERSHIP',
  /** belongs to OD Homefield-HOC Contractors Organization */
  HOC_CONTRACTOR_MEMBERSHIP = 'HOC_CONTRACTOR_MEMBERSHIP',
  /** belongs to 24/7 InTouch (G Team) */
  INTOUCH_CX_ORG_MEMBERSHIP = 'INTOUCH_CX_ORG_MEMBERSHIP',
  LWOD_AGENT_ORG_MEMBERSHIP = 'LWOD_AGENT_ORG_MEMBERSHIP',
  /** allows any actor (without a login) to access this resource */
  NO_AUTHENTICATION = 'NO_AUTHENTICATION',
  /** belongs to an ODA reit with access to BwODA */
  ODA_REIT_ORG_MEMBERSHIP = 'ODA_REIT_ORG_MEMBERSHIP',
  /** belongs to the ODHL organization */
  ODHL_ORG_MEMBERSHIP = 'ODHL_ORG_MEMBERSHIP',
  /** combination of OPENDOOR_INTERNAL_ACCESS, OSN_ORG_MEMBERSHIP, ODHL_ORG_MEMBERSHIP */
  OPENDOOR_AND_JVS_INTERNAL_ACCESS = 'OPENDOOR_AND_JVS_INTERNAL_ACCESS',
  /** the web "has_internal_access" boolean */
  OPENDOOR_INTERNAL_ACCESS = 'OPENDOOR_INTERNAL_ACCESS',
  /** belongs to the OSN organization */
  OSN_ORG_MEMBERSHIP = 'OSN_ORG_MEMBERSHIP',
  /** belongs to Utilities BPO Team Organization */
  UTILITIES_CONTRACTOR_MEMBERSHIP = 'UTILITIES_CONTRACTOR_MEMBERSHIP',
  /** humans that are assigned to vendor branches */
  VENDOR_ACCESS = 'VENDOR_ACCESS'
}

export enum Badge {
  AVAILABLE_SOON = 'AVAILABLE_SOON',
  IN_CONTRACT = 'IN_CONTRACT',
  IS_EXCLUSIVE = 'IS_EXCLUSIVE',
  ON_THE_MARKET = 'ON_THE_MARKET',
  RECENTLY_SOLD = 'RECENTLY_SOLD',
  /** A property that is possibly still for sale but is unactionable at the moment */
  TEMP_UNAVAILABLE = 'TEMP_UNAVAILABLE',
  /** A home that is for sale but cannot be self-toured, must be bought with an agent via MLS */
  TRADITIONAL = 'TRADITIONAL',
  UNKNOWN = 'UNKNOWN'
}

/** Types of brokerage assignments for listing products */
export enum BrokerageAssignmentType {
  /** Brokerage is assigned to the listing */
  ASSIGNED = 'ASSIGNED',
  /** Brokerage is proposed for the listing */
  PROPOSED = 'PROPOSED'
}

/**
 * A list of task types a customer may be required to complete in order to facilitate
 * their transaction, both OBO and non-OBO
 */
export enum BuyClosingTaskType {
  APPRAISAL = 'APPRAISAL',
  BUY_DIRECT_EARNEST_MONEY = 'BUY_DIRECT_EARNEST_MONEY',
  BUY_DIRECT_FINAL_WALKTHROUGH = 'BUY_DIRECT_FINAL_WALKTHROUGH',
  BUY_DIRECT_INFO_TITLE_ESCROW = 'BUY_DIRECT_INFO_TITLE_ESCROW',
  BUY_DIRECT_REVIEW_DISCLOSURES = 'BUY_DIRECT_REVIEW_DISCLOSURES',
  BUY_DIRECT_SCHEDULE_INSPECTION = 'BUY_DIRECT_SCHEDULE_INSPECTION',
  BUY_DIRECT_SIGN_CONTRACT = 'BUY_DIRECT_SIGN_CONTRACT',
  FEED_FILTERS = 'FEED_FILTERS',
  INFORMATION_CONFIRMATION = 'INFORMATION_CONFIRMATION',
  INSPECTIONS = 'INSPECTIONS',
  LOAN_APPLICATION = 'LOAN_APPLICATION',
  LOAN_FINALIZATION = 'LOAN_FINALIZATION',
  MARKET_TRENDS = 'MARKET_TRENDS',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  RESALE_CONTRACT = 'RESALE_CONTRACT',
  UTILITIES = 'UTILITIES'
}

export enum BuyDirectContractStatus {
  BACKUP = 'BACKUP',
  BUY_IT_NOW = 'BUY_IT_NOW',
  HIGHEST_AND_BEST = 'HIGHEST_AND_BEST',
  UNAVAILABLE = 'UNAVAILABLE'
}

/** A set of Document types that are of interest for a customer in Buy experience */
export enum BuyDocumentType {
  APPRAISAL = 'APPRAISAL',
  DOCUMENT = 'DOCUMENT',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  MULTIPLE_DOCUMENTS = 'MULTIPLE_DOCUMENTS',
  OFFER_ADDENDUM = 'OFFER_ADDENDUM',
  PREAPPROVAL_LETTER = 'PREAPPROVAL_LETTER',
  PROGRAM_AGREEMENT = 'PROGRAM_AGREEMENT',
  PURCHASE_AGREEMENT = 'PURCHASE_AGREEMENT'
}

/** Uploaded files in S3 can have one of three states */
export enum BuyFileScanStatus {
  /** The file is safe to download/preview/share */
  CLEAN = 'CLEAN',
  /** OLA will maintain a record of infected files, but they are auto-deleted in S3 to ensure security standards */
  INFECTED = 'INFECTED',
  /** The file is currently being scanned */
  IN_PROGRESS = 'IN_PROGRESS'
}

export type BuyerDataInput = {
  qual_move_timeline?: InputMaybe<QualMoveTimelineOption>;
};

/** Options for the scope of a cached object. */
export enum CacheControlScope {
  /** Each caller will receive a unique cached version of this object. */
  PRIVATE = 'PRIVATE',
  /** Cached value will be shared between all callers. */
  PUBLIC = 'PUBLIC'
}

export type CancelExteriorAssessmentInput = {
  cancellationReason?: InputMaybe<CancellationReasonInput>;
  sellerInputUUID: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type CancellationReasonInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  structuredReasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Possible options for getting prequalified for cash offers */
export enum CashOfferEligibilityLender {
  ODHB = 'ODHB',
  ODHL = 'ODHL',
  other = 'other'
}

export type ClosingTasksInput = {
  hoaFees?: InputMaybe<HoaFeesTaskInput>;
  hvacRoof?: InputMaybe<HvacRoofTaskInput>;
  lateCheckout?: InputMaybe<LateCheckoutTaskInput>;
  otherHomeInfo?: InputMaybe<OtherHomeInfoTaskInput>;
  serviceAccounts?: InputMaybe<ServiceAccountsTaskInput>;
  setCloseDate?: InputMaybe<SetCloseDateTaskInput>;
  setSignatories?: InputMaybe<SetSignatoriesTaskInput>;
};

export enum CommissionType {
  FLAT_CENTS = 'FLAT_CENTS',
  RATE_BPS = 'RATE_BPS'
}

export type CompsInput = {
  compsAddressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerAccountRegisterDeviceInput = {
  appVersion: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  platform: OdProtosCommunicationData_DevicePlatform;
};

export type CustomerAccountUnregisterDeviceInput = {
  deviceId: Scalars['String']['input'];
};

export type CustomerFacingAssessmentHandoffDataForTaskInput = {
  taskId: Scalars['String']['input'];
};

export type CustomerFacingAssessmentHandoffDataInput = {
  handoffId: Scalars['String']['input'];
};

export enum CustomerFacingAssessmentHandoffType {
  EXPERT = 'EXPERT',
  INVITATION = 'INVITATION',
  UNKNOWN = 'UNKNOWN'
}

export enum CustomerFacingAssessmentProcessStep {
  HANDOFF = 'HANDOFF'
}

export type CustomerFacingAssessmentTasksInput = {
  owner?: InputMaybe<CustomerFacingTaskOwnerInput>;
  pagination?: InputMaybe<CustomerFacingPaginationInput>;
  sources?: InputMaybe<Array<CustomerFacingTaskSourceInput>>;
};

export type CustomerFacingCancelAssessmentHandoffInput = {
  flipToken: Scalars['String']['input'];
  handoffId: Scalars['String']['input'];
};

export type CustomerFacingCreateAssessmentHandoffExpertInput = {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  customerMobilePhone?: InputMaybe<Scalars['String']['input']>;
  scheduledAt: Scalars['DateTime']['input'];
};

export type CustomerFacingCreateAssessmentHandoffForTaskInput = {
  expert?: InputMaybe<CustomerFacingCreateAssessmentHandoffExpertInput>;
  flipToken: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type CustomerFacingEnsureAssessmentTaskWithHandoffInput = {
  expert?: InputMaybe<CustomerFacingCreateAssessmentHandoffExpertInput>;
  flipToken: Scalars['String']['input'];
};

export type CustomerFacingGenerateSelfMagicLinkInput = {
  redirectUrl: Scalars['String']['input'];
};

export type CustomerFacingPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum CustomerFacingPromptType {
  AUDIO_INPUT = 'AUDIO_INPUT',
  FREEFORM = 'FREEFORM',
  MULTIPLE_SELECT = 'MULTIPLE_SELECT',
  PHOTO_INPUT = 'PHOTO_INPUT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT_BOX = 'TEXT_BOX',
  UNKNOWN = 'UNKNOWN',
  VIDEO_INPUT = 'VIDEO_INPUT',
  YEAR_SELECT = 'YEAR_SELECT'
}

export type CustomerFacingRescheduleExpertAssessmentHandoffInput = {
  flipToken: Scalars['String']['input'];
  handoffId: Scalars['String']['input'];
  scheduledAt: Scalars['DateTime']['input'];
};

export type CustomerFacingRubricReportForTaskInput = {
  taskId: Scalars['String']['input'];
};

export type CustomerFacingSetTaskStatusExpectedCurrentStatusInput = {
  status: CustomerFacingTaskStatus;
};

export type CustomerFacingSetTaskStatusInput = {
  expectedCurrentStatus?: InputMaybe<CustomerFacingSetTaskStatusExpectedCurrentStatusInput>;
  flipToken: Scalars['String']['input'];
  newStatus: CustomerFacingTaskStatus;
  newStatusReason?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};

export type CustomerFacingTaskOwnerInput = {
  userId: Scalars['String']['input'];
};

export type CustomerFacingTaskSourceInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum CustomerFacingTaskStatus {
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  CONFIRMED = 'CONFIRMED',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN',
  PENDING = 'PENDING'
}

export type CustomerFacingTasksInput = {
  owner?: InputMaybe<CustomerFacingTaskOwnerInput>;
  pagination?: InputMaybe<CustomerFacingPaginationInput>;
  sources?: InputMaybe<Array<CustomerFacingTaskSourceInput>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerFacingTimeSlotsForAssessmentProcessStepInput = {
  addressToken: Scalars['String']['input'];
  processStep: CustomerFacingAssessmentProcessStep;
};

/** The completion state of a customer task */
export enum CustomerTaskState {
  /** Task has been completed */
  COMPLETE = 'COMPLETE',
  /** Task has not been completed */
  PENDING = 'PENDING'
}

/** The type of task for mutation identification */
export enum CustomerTaskType {
  ACCESS_KEYS = 'ACCESS_KEYS',
  BOOK_INSPECTION = 'BOOK_INSPECTION',
  CONFIRM_FINANCING = 'CONFIRM_FINANCING',
  FINALIZE_CLOSING = 'FINALIZE_CLOSING',
  MAKE_DEPOSIT = 'MAKE_DEPOSIT',
  MORTGAGE_APPLICATION = 'MORTGAGE_APPLICATION',
  MORTGAGE_TASKS = 'MORTGAGE_TASKS',
  RECEIVE_ACCESS_CODE = 'RECEIVE_ACCESS_CODE',
  REVIEW_OFFER = 'REVIEW_OFFER',
  SIGN_CONTRACT = 'SIGN_CONTRACT'
}

export type DetailsInput = {
  addressUuid: Scalars['String']['input'];
};

export type DigitalCheckoutInput = {
  declaration: Scalars['String']['input'];
  lockboxLocation: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  photos?: InputMaybe<Array<PhotoInput>>;
};

export enum DwellingType {
  APARTMENT = 'APARTMENT',
  CHURCH = 'CHURCH',
  COMMERCIAL = 'COMMERCIAL',
  COOP = 'COOP',
  FARM = 'FARM',
  HALF_DUPLEX = 'HALF_DUPLEX',
  HOTEL = 'HOTEL',
  INDUSTRIAL = 'INDUSTRIAL',
  MANUFACTURED = 'MANUFACTURED',
  MIXED = 'MIXED',
  MOBILE_HOME = 'MOBILE_HOME',
  MULTI_FAMILY = 'MULTI_FAMILY',
  OFFICE = 'OFFICE',
  OTHER = 'OTHER',
  RETAIL = 'RETAIL',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
  SPECIAL_PURPOSE = 'SPECIAL_PURPOSE',
  TOWNHOUSE = 'TOWNHOUSE',
  UNKNOWN = 'UNKNOWN',
  VACANT = 'VACANT',
  WAREHOUSE = 'WAREHOUSE'
}

/** Types of seller experiences available in the platform */
export enum ExperienceType {
  /** Agent-led offers experience (legacy typo - kept for backward compatibility) */
  AGENT_LED_OFERS = 'AGENT_LED_OFERS',
  /** Agent-led offers experience */
  AGENT_LED_OFFERS = 'AGENT_LED_OFFERS',
  /** Direct to Customer (multi-product) */
  DIRECT_TO_CUSTOMER = 'DIRECT_TO_CUSTOMER',
  /** Sell direct via Agent referral */
  SELL_DIRECT_AGENT = 'SELL_DIRECT_AGENT',
  /** Core sell direct experience (cash offer) */
  SELL_DIRECT_CORE = 'SELL_DIRECT_CORE',
  /** The multi-product experience available to the customer */
  SELL_YOUR_WAY = 'SELL_YOUR_WAY',
  /** Unknown or unrecognized experience type */
  UNKNOWN = 'UNKNOWN'
}

export enum FinancingSource {
  AWAITING_MORTGAGE_PARTNER_APPROVAL = 'AWAITING_MORTGAGE_PARTNER_APPROVAL',
  CASH = 'CASH',
  PRE_APPROVAL = 'PRE_APPROVAL'
}

/**
 * GeoBoundary is used to build a geographic boundary for a property search
 *
 * This is a boundary defined by two points at opposite corners of a rectangle.
 * This is how Indextrious exposes their GeoBoundary type and while it's not
 * ideal to have to design the input shape around their type, it's necessary
 * to make this ergonmic for clients.
 *
 * Keep in mind, this prevents us from having more complex shapes like any arbitrary polygon.
 * By taking a northwest coordinate and a southeast coordinate, I'm guessing Indextrious figures out
 * how to determine the remaining points of the rectangular polygon and build the "box" it searches within
 */
export type GeoBoundaryInput = {
  /** Southeast coordinate of the boundary */
  bottomRight: GeoPoint;
  /** Northwest coordinate of the boundary */
  topLeft: GeoPoint;
};

/** GeoPoint is a coordinate pair used for geospatial queries and identifying a location */
export type GeoPoint = {
  /** 'They say your attitude determines your latitude' - Kanye West */
  lat: Scalars['Float']['input'];
  /** Longitude is the angular distance of a place east or west of the meridian at Greenwich, England */
  lon: Scalars['Float']['input'];
};

export type GetEngagementDetailsRequestInput = {
  propertyEngagementId: Scalars['String']['input'];
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type GetMarketConfigByMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type GetUserAvatarInput = {
  /** The user email to look up in Slack. */
  email: Scalars['String']['input'];
};

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 *
 * Example 1: Pack and unpack a message in C++.
 *
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 *
 * Example 2: Pack and unpack a message in Java.
 *
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 *
 *  Example 3: Pack and unpack a message in Python.
 *
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 *
 *  Example 4: Pack and unpack a message in Go
 *
 *      foo := &pb.Foo{...}
 *      any, err := anypb.New(foo)
 *      if err != nil {
 *        ...
 *      }
 *      ...
 *      foo := &pb.Foo{}
 *      if err := any.UnmarshalTo(foo); err != nil {
 *        ...
 *      }
 *
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 *
 *
 * JSON
 * ====
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 *
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 *
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 *
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 *
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 */
export type GoogleProtobuf_AnyInput = {
  /**
   * A URL/resource name that uniquely identifies the type of the serialized
   * protocol buffer message. This string must contain at least
   * one "/" character. The last segment of the URL's path must represent
   * the fully qualified name of the type (as in
   * `path/google.protobuf.Duration`). The name should be in a canonical form
   * (e.g., leading "." is not accepted).
   *
   * In practice, teams usually precompile into the binary all types that they
   * expect it to use in the context of Any. However, for URLs which use the
   * scheme `http`, `https`, or no scheme, one can optionally set up a type
   * server that maps type URLs to message definitions as follows:
   *
   * * If no scheme is provided, `https` is assumed.
   * * An HTTP GET on the URL must yield a [google.protobuf.Type][]
   *   value in binary format, or produce an error.
   * * Applications are allowed to cache lookup results based on the
   *   URL, or have them precompiled into a binary to avoid any
   *   lookup. Therefore, binary compatibility needs to be preserved
   *   on changes to types. (Use versioned type names to manage
   *   breaking changes.)
   *
   * Note: this functionality is not currently available in the official
   * protobuf release, and it is not used for type URLs beginning with
   * type.googleapis.com.
   *
   * Schemes other than `http`, `https` (or the empty scheme) might be
   * used with implementation specific semantics.
   */
  typeUrl?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid serialized protocol buffer of the above specified type. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Api is a light-weight descriptor for an API Interface.
 *
 * Interfaces are also described as "protocol buffer services" in some contexts,
 * such as by the "service" keyword in a .proto file, but they are different
 * from API Services, which represent a concrete implementation of an interface
 * as opposed to simply a description of methods and bindings. They are also
 * sometimes simply referred to as "APIs" in other contexts, such as the name of
 * this message itself. See https://cloud.google.com/apis/design/glossary for
 * detailed terminology.
 */
export type GoogleProtobuf_ApiInput = {
  /** The methods of this interface, in unspecified order. */
  methods?: InputMaybe<Array<GoogleProtobuf_MethodInput>>;
  /** Included interfaces. See [Mixin][]. */
  mixins?: InputMaybe<Array<GoogleProtobuf_MixinInput>>;
  /**
   * The fully qualified name of this interface, including package name
   * followed by the interface's simple name.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Any metadata attached to the interface. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /**
   * Source context for the protocol buffer service represented by this
   * message.
   */
  sourceContext?: InputMaybe<GoogleProtobuf_SourceContextInput>;
  /** The source syntax of the service. */
  syntax?: InputMaybe<GoogleProtobuf_Syntax>;
  /**
   * A version string for this interface. If specified, must have the form
   * `major-version.minor-version`, as in `1.10`. If the minor version is
   * omitted, it defaults to zero. If the entire version field is empty, the
   * major version is derived from the package name, as outlined below. If the
   * field is not empty, the version in the package name will be verified to be
   * consistent with what is provided here.
   *
   * The versioning schema uses [semantic
   * versioning](http://semver.org) where the major version number
   * indicates a breaking change and the minor version an additive,
   * non-breaking change. Both version numbers are signals to users
   * what to expect from different versions, and should be carefully
   * chosen based on the product plan.
   *
   * The major version is also reflected in the package name of the
   * interface, which must end in `v<major-version>`, as in
   * `google.feature.v1`. For major versions 0 and 1, the suffix can
   * be omitted. Zero major versions must only be used for
   * experimental, non-GA interfaces.
   */
  version?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Wrapper message for `bool`.
 *
 * The JSON representation for `BoolValue` is JSON `true` and `false`.
 */
export type GoogleProtobuf_BoolValueInput = {
  /** The bool value. */
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Wrapper message for `bytes`.
 *
 * The JSON representation for `BytesValue` is JSON string.
 */
export type GoogleProtobuf_BytesValueInput = {
  /** The bytes value. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Describes a message type. */
export type GoogleProtobuf_DescriptorProtoInput = {
  enumType?: InputMaybe<Array<GoogleProtobuf_EnumDescriptorProtoInput>>;
  extension?: InputMaybe<Array<GoogleProtobuf_FieldDescriptorProtoInput>>;
  extensionRange?: InputMaybe<Array<GoogleProtobuf_DescriptorProto_ExtensionRangeInput>>;
  field?: InputMaybe<Array<GoogleProtobuf_FieldDescriptorProtoInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nestedType?: InputMaybe<Array<GoogleProtobuf_DescriptorProtoInput>>;
  oneofDecl?: InputMaybe<Array<GoogleProtobuf_OneofDescriptorProtoInput>>;
  options?: InputMaybe<GoogleProtobuf_MessageOptionsInput>;
  /**
   * Reserved field names, which may not be used by fields in the same message.
   * A given name may only be reserved once.
   */
  reservedName?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedRange?: InputMaybe<Array<GoogleProtobuf_DescriptorProto_ReservedRangeInput>>;
};

export type GoogleProtobuf_DescriptorProto_ExtensionRangeInput = {
  /** Exclusive. */
  end?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<GoogleProtobuf_ExtensionRangeOptionsInput>;
  /** Inclusive. */
  start?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Range of reserved tag numbers. Reserved tag numbers may not be used by
 * fields or extension ranges in the same message. Reserved ranges may
 * not overlap.
 */
export type GoogleProtobuf_DescriptorProto_ReservedRangeInput = {
  /** Exclusive. */
  end?: InputMaybe<Scalars['Float']['input']>;
  /** Inclusive. */
  start?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Wrapper message for `double`.
 *
 * The JSON representation for `DoubleValue` is JSON number.
 */
export type GoogleProtobuf_DoubleValueInput = {
  /** The double value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * A Duration represents a signed, fixed-length span of time represented
 * as a count of seconds and fractions of seconds at nanosecond
 * resolution. It is independent of any calendar and concepts like "day"
 * or "month". It is related to Timestamp in that the difference between
 * two Timestamp values is a Duration and it can be added or subtracted
 * from a Timestamp. Range is approximately +-10,000 years.
 *
 * # Examples
 *
 * Example 1: Compute Duration from two Timestamps in pseudo code.
 *
 *     Timestamp start = ...;
 *     Timestamp end = ...;
 *     Duration duration = ...;
 *
 *     duration.seconds = end.seconds - start.seconds;
 *     duration.nanos = end.nanos - start.nanos;
 *
 *     if (duration.seconds < 0 && duration.nanos > 0) {
 *       duration.seconds += 1;
 *       duration.nanos -= 1000000000;
 *     } else if (duration.seconds > 0 && duration.nanos < 0) {
 *       duration.seconds -= 1;
 *       duration.nanos += 1000000000;
 *     }
 *
 * Example 2: Compute Timestamp from Timestamp + Duration in pseudo code.
 *
 *     Timestamp start = ...;
 *     Duration duration = ...;
 *     Timestamp end = ...;
 *
 *     end.seconds = start.seconds + duration.seconds;
 *     end.nanos = start.nanos + duration.nanos;
 *
 *     if (end.nanos < 0) {
 *       end.seconds -= 1;
 *       end.nanos += 1000000000;
 *     } else if (end.nanos >= 1000000000) {
 *       end.seconds += 1;
 *       end.nanos -= 1000000000;
 *     }
 *
 * Example 3: Compute Duration from datetime.timedelta in Python.
 *
 *     td = datetime.timedelta(days=3, minutes=10)
 *     duration = Duration()
 *     duration.FromTimedelta(td)
 *
 * # JSON Mapping
 *
 * In JSON format, the Duration type is encoded as a string rather than an
 * object, where the string ends in the suffix "s" (indicating seconds) and
 * is preceded by the number of seconds, with nanoseconds expressed as
 * fractional seconds. For example, 3 seconds with 0 nanoseconds should be
 * encoded in JSON format as "3s", while 3 seconds and 1 nanosecond should
 * be expressed in JSON format as "3.000000001s", and 3 seconds and 1
 * microsecond should be expressed in JSON format as "3.000001s".
 */
export type GoogleProtobuf_DurationInput = {
  /**
   * Signed fractions of a second at nanosecond resolution of the span
   * of time. Durations less than one second are represented with a 0
   * `seconds` field and a positive or negative `nanos` field. For durations
   * of one second or more, a non-zero value for the `nanos` field must be
   * of the same sign as the `seconds` field. Must be from -999,999,999
   * to +999,999,999 inclusive.
   */
  nanos?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Signed seconds of the span of time. Must be from -315,576,000,000
   * to +315,576,000,000 inclusive. Note: these bounds are computed from:
   * 60 sec/min * 60 min/hr * 24 hr/day * 365.25 days/year * 10000 years
   */
  seconds?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * A generic empty message that you can re-use to avoid defining duplicated
 * empty messages in your APIs. A typical example is to use it as the request
 * or the response type of an API method. For instance:
 *
 *     service Foo {
 *       rpc Bar(google.protobuf.Empty) returns (google.protobuf.Empty);
 *     }
 *
 * The JSON representation for `Empty` is empty JSON object `{}`.
 */
export type GoogleProtobuf_EmptyInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Describes an enum type. */
export type GoogleProtobuf_EnumDescriptorProtoInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<GoogleProtobuf_EnumOptionsInput>;
  /**
   * Reserved enum value names, which may not be reused. A given name may only
   * be reserved once.
   */
  reservedName?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Range of reserved numeric values. Reserved numeric values may not be used
   * by enum values in the same enum declaration. Reserved ranges may not
   * overlap.
   */
  reservedRange?: InputMaybe<Array<GoogleProtobuf_EnumDescriptorProto_EnumReservedRangeInput>>;
  value?: InputMaybe<Array<GoogleProtobuf_EnumValueDescriptorProtoInput>>;
};

/**
 * Range of reserved numeric values. Reserved values may not be used by
 * entries in the same enum. Reserved ranges may not overlap.
 *
 * Note that this is distinct from DescriptorProto.ReservedRange in that it
 * is inclusive such that it can appropriately represent the entire int32
 * domain.
 */
export type GoogleProtobuf_EnumDescriptorProto_EnumReservedRangeInput = {
  /** Inclusive. */
  end?: InputMaybe<Scalars['Float']['input']>;
  /** Inclusive. */
  start?: InputMaybe<Scalars['Float']['input']>;
};

/** Enum type definition. */
export type GoogleProtobuf_EnumInput = {
  /** Enum value definitions. */
  enumvalue?: InputMaybe<Array<GoogleProtobuf_EnumValueInput>>;
  /** Enum type name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Protocol buffer options. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /** The source context. */
  sourceContext?: InputMaybe<GoogleProtobuf_SourceContextInput>;
  /** The source syntax. */
  syntax?: InputMaybe<GoogleProtobuf_Syntax>;
};

export type GoogleProtobuf_EnumOptionsInput = {
  /**
   * Set this option to true to allow mapping different tag names to the same
   * value.
   */
  allowAlias?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Is this enum deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the enum, or it will be completely ignored; in the very least, this
   * is a formalization for deprecating enums.
   */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/** Describes a value within an enum. */
export type GoogleProtobuf_EnumValueDescriptorProtoInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<GoogleProtobuf_EnumValueOptionsInput>;
};

/** Enum value definition. */
export type GoogleProtobuf_EnumValueInput = {
  /** Enum value name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Enum value number. */
  number?: InputMaybe<Scalars['Float']['input']>;
  /** Protocol buffer options. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
};

export type GoogleProtobuf_EnumValueOptionsInput = {
  /**
   * Is this enum value deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the enum value, or it will be completely ignored; in the very least,
   * this is a formalization for deprecating enum values.
   */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

export type GoogleProtobuf_ExtensionRangeOptionsInput = {
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/** Describes a field within a message. */
export type GoogleProtobuf_FieldDescriptorProtoInput = {
  /**
   * For numeric types, contains the original text representation of the value.
   * For booleans, "true" or "false".
   * For strings, contains the default text contents (not escaped in any way).
   * For bytes, contains the C escaped value.  All bytes >= 128 are escaped.
   * TODO(kenton):  Base-64 encode?
   */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /**
   * For extensions, this is the name of the type being extended.  It is
   * resolved in the same manner as type_name.
   */
  extendee?: InputMaybe<Scalars['String']['input']>;
  /**
   * JSON name of this field. The value is set by protocol compiler. If the
   * user has set a "json_name" option on this field, that option's value
   * will be used. Otherwise, it's deduced from the field's name by converting
   * it to camelCase.
   */
  jsonName?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<GoogleProtobuf_FieldDescriptorProto_Label>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  /**
   * If set, gives the index of a oneof in the containing type's oneof_decl
   * list.  This field is a member of that oneof.
   */
  oneofIndex?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<GoogleProtobuf_FieldOptionsInput>;
  /**
   * If true, this is a proto3 "optional". When a proto3 field is optional, it
   * tracks presence regardless of field type.
   *
   * When proto3_optional is true, this field must be belong to a oneof to
   * signal to old proto3 clients that presence is tracked for this field. This
   * oneof is known as a "synthetic" oneof, and this field must be its sole
   * member (each proto3 optional field gets its own synthetic oneof). Synthetic
   * oneofs exist in the descriptor only, and do not generate any API. Synthetic
   * oneofs must be ordered after all "real" oneofs.
   *
   * For message fields, proto3_optional doesn't create any semantic change,
   * since non-repeated message fields always track presence. However it still
   * indicates the semantic detail of whether the user wrote "optional" or not.
   * This can be useful for round-tripping the .proto file. For consistency we
   * give message fields a synthetic oneof also, even though it is not required
   * to track presence. This is especially important because the parser can't
   * tell if a field is a message or an enum, so it must always create a
   * synthetic oneof.
   *
   * Proto2 optional fields do not set this flag, because they already indicate
   * optional with `LABEL_OPTIONAL`.
   */
  proto3Optional?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If type_name is set, this need not be set.  If both this and type_name
   * are set, this must be one of TYPE_ENUM, TYPE_MESSAGE or TYPE_GROUP.
   */
  type?: InputMaybe<GoogleProtobuf_FieldDescriptorProto_Type>;
  /**
   * For message and enum types, this is the name of the type.  If the name
   * starts with a '.', it is fully-qualified.  Otherwise, C++-like scoping
   * rules are used to find the type (i.e. first the nested types within this
   * message are searched, then within the parent, on up to the root
   * namespace).
   */
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export enum GoogleProtobuf_FieldDescriptorProto_Label {
  /** 0 is reserved for errors */
  LABEL_OPTIONAL = 'LABEL_OPTIONAL',
  LABEL_REPEATED = 'LABEL_REPEATED',
  LABEL_REQUIRED = 'LABEL_REQUIRED'
}

export enum GoogleProtobuf_FieldDescriptorProto_Type {
  TYPE_BOOL = 'TYPE_BOOL',
  /** New in version 2. */
  TYPE_BYTES = 'TYPE_BYTES',
  /**
   * 0 is reserved for errors.
   * Order is weird for historical reasons.
   */
  TYPE_DOUBLE = 'TYPE_DOUBLE',
  TYPE_ENUM = 'TYPE_ENUM',
  TYPE_FIXED32 = 'TYPE_FIXED32',
  TYPE_FIXED64 = 'TYPE_FIXED64',
  TYPE_FLOAT = 'TYPE_FLOAT',
  /**
   * Tag-delimited aggregate.
   * Group type is deprecated and not supported in proto3. However, Proto3
   * implementations should still be able to parse the group wire format and
   * treat group fields as unknown fields.
   */
  TYPE_GROUP = 'TYPE_GROUP',
  /**
   * Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
   * negative values are likely.
   */
  TYPE_INT32 = 'TYPE_INT32',
  /**
   * Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
   * negative values are likely.
   */
  TYPE_INT64 = 'TYPE_INT64',
  /** Length-delimited aggregate. */
  TYPE_MESSAGE = 'TYPE_MESSAGE',
  TYPE_SFIXED32 = 'TYPE_SFIXED32',
  TYPE_SFIXED64 = 'TYPE_SFIXED64',
  /** Uses ZigZag encoding. */
  TYPE_SINT32 = 'TYPE_SINT32',
  /** Uses ZigZag encoding. */
  TYPE_SINT64 = 'TYPE_SINT64',
  TYPE_STRING = 'TYPE_STRING',
  TYPE_UINT32 = 'TYPE_UINT32',
  TYPE_UINT64 = 'TYPE_UINT64'
}

/** A single field of a message type. */
export type GoogleProtobuf_FieldInput = {
  /** The field cardinality. */
  cardinality?: InputMaybe<GoogleProtobuf_Field_Cardinality>;
  /** The string value of the default value of this field. Proto2 syntax only. */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** The field JSON name. */
  jsonName?: InputMaybe<Scalars['String']['input']>;
  /** The field type. */
  kind?: InputMaybe<GoogleProtobuf_Field_Kind>;
  /** The field name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The field number. */
  number?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The index of the field type in `Type.oneofs`, for message or enumeration
   * types. The first type has index 1; zero means the type is not in the list.
   */
  oneofIndex?: InputMaybe<Scalars['Float']['input']>;
  /** The protocol buffer options. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /** Whether to use alternative packed wire representation. */
  packed?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The field type URL, without the scheme, for message or enumeration
   * types. Example: `"type.googleapis.com/google.protobuf.Timestamp"`.
   */
  typeUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * `FieldMask` represents a set of symbolic field paths, for example:
 *
 *     paths: "f.a"
 *     paths: "f.b.d"
 *
 * Here `f` represents a field in some root message, `a` and `b`
 * fields in the message found in `f`, and `d` a field found in the
 * message in `f.b`.
 *
 * Field masks are used to specify a subset of fields that should be
 * returned by a get operation or modified by an update operation.
 * Field masks also have a custom JSON encoding (see below).
 *
 * # Field Masks in Projections
 *
 * When used in the context of a projection, a response message or
 * sub-message is filtered by the API to only contain those fields as
 * specified in the mask. For example, if the mask in the previous
 * example is applied to a response message as follows:
 *
 *     f {
 *       a : 22
 *       b {
 *         d : 1
 *         x : 2
 *       }
 *       y : 13
 *     }
 *     z: 8
 *
 * The result will not contain specific values for fields x,y and z
 * (their value will be set to the default, and omitted in proto text
 * output):
 *
 *
 *     f {
 *       a : 22
 *       b {
 *         d : 1
 *       }
 *     }
 *
 * A repeated field is not allowed except at the last position of a
 * paths string.
 *
 * If a FieldMask object is not present in a get operation, the
 * operation applies to all fields (as if a FieldMask of all fields
 * had been specified).
 *
 * Note that a field mask does not necessarily apply to the
 * top-level response message. In case of a REST get operation, the
 * field mask applies directly to the response, but in case of a REST
 * list operation, the mask instead applies to each individual message
 * in the returned resource list. In case of a REST custom method,
 * other definitions may be used. Where the mask applies will be
 * clearly documented together with its declaration in the API.  In
 * any case, the effect on the returned resource/resources is required
 * behavior for APIs.
 *
 * # Field Masks in Update Operations
 *
 * A field mask in update operations specifies which fields of the
 * targeted resource are going to be updated. The API is required
 * to only change the values of the fields as specified in the mask
 * and leave the others untouched. If a resource is passed in to
 * describe the updated values, the API ignores the values of all
 * fields not covered by the mask.
 *
 * If a repeated field is specified for an update operation, new values will
 * be appended to the existing repeated field in the target resource. Note that
 * a repeated field is only allowed in the last position of a `paths` string.
 *
 * If a sub-message is specified in the last position of the field mask for an
 * update operation, then new value will be merged into the existing sub-message
 * in the target resource.
 *
 * For example, given the target message:
 *
 *     f {
 *       b {
 *         d: 1
 *         x: 2
 *       }
 *       c: [1]
 *     }
 *
 * And an update message:
 *
 *     f {
 *       b {
 *         d: 10
 *       }
 *       c: [2]
 *     }
 *
 * then if the field mask is:
 *
 *  paths: ["f.b", "f.c"]
 *
 * then the result will be:
 *
 *     f {
 *       b {
 *         d: 10
 *         x: 2
 *       }
 *       c: [1, 2]
 *     }
 *
 * An implementation may provide options to override this default behavior for
 * repeated and message fields.
 *
 * In order to reset a field's value to the default, the field must
 * be in the mask and set to the default value in the provided resource.
 * Hence, in order to reset all fields of a resource, provide a default
 * instance of the resource and set all fields in the mask, or do
 * not provide a mask as described below.
 *
 * If a field mask is not present on update, the operation applies to
 * all fields (as if a field mask of all fields has been specified).
 * Note that in the presence of schema evolution, this may mean that
 * fields the client does not know and has therefore not filled into
 * the request will be reset to their default. If this is unwanted
 * behavior, a specific service may require a client to always specify
 * a field mask, producing an error if not.
 *
 * As with get operations, the location of the resource which
 * describes the updated values in the request message depends on the
 * operation kind. In any case, the effect of the field mask is
 * required to be honored by the API.
 *
 * ## Considerations for HTTP REST
 *
 * The HTTP kind of an update operation which uses a field mask must
 * be set to PATCH instead of PUT in order to satisfy HTTP semantics
 * (PUT must only be used for full updates).
 *
 * # JSON Encoding of Field Masks
 *
 * In JSON, a field mask is encoded as a single string where paths are
 * separated by a comma. Fields name in each path are converted
 * to/from lower-camel naming conventions.
 *
 * As an example, consider the following message declarations:
 *
 *     message Profile {
 *       User user = 1;
 *       Photo photo = 2;
 *     }
 *     message User {
 *       string display_name = 1;
 *       string address = 2;
 *     }
 *
 * In proto a field mask for `Profile` may look as such:
 *
 *     mask {
 *       paths: "user.display_name"
 *       paths: "photo"
 *     }
 *
 * In JSON, the same mask is represented as below:
 *
 *     {
 *       mask: "user.displayName,photo"
 *     }
 *
 * # Field Masks and Oneof Fields
 *
 * Field masks treat fields in oneofs just as regular fields. Consider the
 * following message:
 *
 *     message SampleMessage {
 *       oneof test_oneof {
 *         string name = 4;
 *         SubMessage sub_message = 9;
 *       }
 *     }
 *
 * The field mask can be:
 *
 *     mask {
 *       paths: "name"
 *     }
 *
 * Or:
 *
 *     mask {
 *       paths: "sub_message"
 *     }
 *
 * Note that oneof type names ("test_oneof" in this case) cannot be used in
 * paths.
 *
 * ## Field Mask Verification
 *
 * The implementation of any API method which has a FieldMask type field in the
 * request should verify the included field paths, and return an
 * `INVALID_ARGUMENT` error if any path is unmappable.
 */
export type GoogleProtobuf_FieldMaskInput = {
  /** The set of field mask paths. */
  paths?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GoogleProtobuf_FieldOptionsInput = {
  /**
   * The ctype option instructs the C++ code generator to use a different
   * representation of the field than it normally would.  See the specific
   * options below.  This option is not yet implemented in the open source
   * release -- sorry, we'll try to include it in a future version!
   */
  ctype?: InputMaybe<GoogleProtobuf_FieldOptions_CType>;
  /**
   * Is this field deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for accessors, or it will be completely ignored; in the very least, this
   * is a formalization for deprecating fields.
   */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The jstype option determines the JavaScript type used for values of the
   * field.  The option is permitted only for 64 bit integral and fixed types
   * (int64, uint64, sint64, fixed64, sfixed64).  A field with jstype JS_STRING
   * is represented as JavaScript string, which avoids loss of precision that
   * can happen when a large value is converted to a floating point JavaScript.
   * Specifying JS_NUMBER for the jstype causes the generated JavaScript code to
   * use the JavaScript "number" type.  The behavior of the default option
   * JS_NORMAL is implementation dependent.
   *
   * This option is an enum to permit additional types to be added, e.g.
   * goog.math.Integer.
   */
  jstype?: InputMaybe<GoogleProtobuf_FieldOptions_JsType>;
  /**
   * Should this field be parsed lazily?  Lazy applies only to message-type
   * fields.  It means that when the outer message is initially parsed, the
   * inner message's contents will not be parsed but instead stored in encoded
   * form.  The inner message will actually be parsed when it is first accessed.
   *
   * This is only a hint.  Implementations are free to choose whether to use
   * eager or lazy parsing regardless of the value of this option.  However,
   * setting this option true suggests that the protocol author believes that
   * using lazy parsing on this field is worth the additional bookkeeping
   * overhead typically needed to implement it.
   *
   * This option does not affect the public interface of any generated code;
   * all method signatures remain the same.  Furthermore, thread-safety of the
   * interface is not affected by this option; const methods remain safe to
   * call from multiple threads concurrently, while non-const methods continue
   * to require exclusive access.
   *
   *
   * Note that implementations may choose not to check required fields within
   * a lazy sub-message.  That is, calling IsInitialized() on the outer message
   * may return true even if the inner message has missing required fields.
   * This is necessary because otherwise the inner message would have to be
   * parsed in order to perform the check, defeating the purpose of lazy
   * parsing.  An implementation which chooses not to check required fields
   * must be consistent about it.  That is, for any particular sub-message, the
   * implementation must either *always* check its required fields, or *never*
   * check its required fields, regardless of whether or not the message has
   * been parsed.
   */
  lazy?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The packed option can be enabled for repeated primitive fields to enable
   * a more efficient representation on the wire. Rather than repeatedly
   * writing the tag and type for each element, the entire array is encoded as
   * a single length-delimited blob. In proto3, only explicit setting it to
   * false will avoid using packed encoding.
   */
  packed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
  /** For Google-internal migration only. Do not use. */
  weak?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GoogleProtobuf_FieldOptions_CType {
  CORD = 'CORD',
  /** Default mode. */
  STRING = 'STRING',
  STRING_PIECE = 'STRING_PIECE'
}

export enum GoogleProtobuf_FieldOptions_JsType {
  /** Use the default type. */
  JS_NORMAL = 'JS_NORMAL',
  /** Use JavaScript numbers. */
  JS_NUMBER = 'JS_NUMBER',
  /** Use JavaScript strings. */
  JS_STRING = 'JS_STRING'
}

/** Whether a field is optional, required, or repeated. */
export enum GoogleProtobuf_Field_Cardinality {
  /** For optional fields. */
  CARDINALITY_OPTIONAL = 'CARDINALITY_OPTIONAL',
  /** For repeated fields. */
  CARDINALITY_REPEATED = 'CARDINALITY_REPEATED',
  /** For required fields. Proto2 syntax only. */
  CARDINALITY_REQUIRED = 'CARDINALITY_REQUIRED',
  /** For fields with unknown cardinality. */
  CARDINALITY_UNKNOWN = 'CARDINALITY_UNKNOWN'
}

/** Basic field types. */
export enum GoogleProtobuf_Field_Kind {
  /** Field type bool. */
  TYPE_BOOL = 'TYPE_BOOL',
  /** Field type bytes. */
  TYPE_BYTES = 'TYPE_BYTES',
  /** Field type double. */
  TYPE_DOUBLE = 'TYPE_DOUBLE',
  /** Field type enum. */
  TYPE_ENUM = 'TYPE_ENUM',
  /** Field type fixed32. */
  TYPE_FIXED32 = 'TYPE_FIXED32',
  /** Field type fixed64. */
  TYPE_FIXED64 = 'TYPE_FIXED64',
  /** Field type float. */
  TYPE_FLOAT = 'TYPE_FLOAT',
  /** Field type group. Proto2 syntax only, and deprecated. */
  TYPE_GROUP = 'TYPE_GROUP',
  /** Field type int32. */
  TYPE_INT32 = 'TYPE_INT32',
  /** Field type int64. */
  TYPE_INT64 = 'TYPE_INT64',
  /** Field type message. */
  TYPE_MESSAGE = 'TYPE_MESSAGE',
  /** Field type sfixed32. */
  TYPE_SFIXED32 = 'TYPE_SFIXED32',
  /** Field type sfixed64. */
  TYPE_SFIXED64 = 'TYPE_SFIXED64',
  /** Field type sint32. */
  TYPE_SINT32 = 'TYPE_SINT32',
  /** Field type sint64. */
  TYPE_SINT64 = 'TYPE_SINT64',
  /** Field type string. */
  TYPE_STRING = 'TYPE_STRING',
  /** Field type uint32. */
  TYPE_UINT32 = 'TYPE_UINT32',
  /** Field type uint64. */
  TYPE_UINT64 = 'TYPE_UINT64',
  /** Field type unknown. */
  TYPE_UNKNOWN = 'TYPE_UNKNOWN'
}

/** Describes a complete .proto file. */
export type GoogleProtobuf_FileDescriptorProtoInput = {
  /** Names of files imported by this file. */
  dependency?: InputMaybe<Array<Scalars['String']['input']>>;
  enumType?: InputMaybe<Array<GoogleProtobuf_EnumDescriptorProtoInput>>;
  extension?: InputMaybe<Array<GoogleProtobuf_FieldDescriptorProtoInput>>;
  /** All top-level definitions in this file. */
  messageType?: InputMaybe<Array<GoogleProtobuf_DescriptorProtoInput>>;
  /** file name, relative to root of source tree */
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<GoogleProtobuf_FileOptionsInput>;
  /** e.g. "foo", "foo.bar", etc. */
  package?: InputMaybe<Scalars['String']['input']>;
  /** Indexes of the public imported files in the dependency list above. */
  publicDependency?: InputMaybe<Array<Scalars['Float']['input']>>;
  service?: InputMaybe<Array<GoogleProtobuf_ServiceDescriptorProtoInput>>;
  /**
   * This field contains optional information about the original source code.
   * You may safely remove this entire field without harming runtime
   * functionality of the descriptors -- the information is needed only by
   * development tools.
   */
  sourceCodeInfo?: InputMaybe<GoogleProtobuf_SourceCodeInfoInput>;
  /**
   * The syntax of the proto file.
   * The supported values are "proto2" and "proto3".
   */
  syntax?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indexes of the weak imported files in the dependency list.
   * For Google-internal migration only. Do not use.
   */
  weakDependency?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/**
 * The protocol compiler can output a FileDescriptorSet containing the .proto
 * files it parses.
 */
export type GoogleProtobuf_FileDescriptorSetInput = {
  file?: InputMaybe<Array<GoogleProtobuf_FileDescriptorProtoInput>>;
};

export type GoogleProtobuf_FileOptionsInput = {
  /**
   * Enables the use of arenas for the proto messages in this file. This applies
   * only to generated classes for C++.
   */
  ccEnableArenas?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Should generic services be generated in each language?  "Generic" services
   * are not specific to any particular RPC system.  They are generated by the
   * main code generators in each language (without additional plugins).
   * Generic services were the only kind of service generation supported by
   * early versions of google.protobuf.
   *
   * Generic services are now considered deprecated in favor of using plugins
   * that generate code specific to your particular RPC system.  Therefore,
   * these default to false.  Old code which depends on generic services should
   * explicitly set them to true.
   */
  ccGenericServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Namespace for generated classes; defaults to the package. */
  csharpNamespace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Is this file deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for everything in the file, or it will be completely ignored; in the very
   * least, this is a formalization for deprecating files.
   */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the Go package where structs generated from this .proto will be
   * placed. If omitted, the Go package will be derived from the following:
   *   - The basename of the package import path, if provided.
   *   - Otherwise, the package statement in the .proto file, if present.
   *   - Otherwise, the basename of the .proto file, without extension.
   */
  goPackage?: InputMaybe<Scalars['String']['input']>;
  /** This option does nothing. */
  javaGenerateEqualsAndHash?: InputMaybe<Scalars['Boolean']['input']>;
  javaGenericServices?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If enabled, then the Java code generator will generate a separate .java
   * file for each top-level message, enum, and service defined in the .proto
   * file.  Thus, these types will *not* be nested inside the wrapper class
   * named by java_outer_classname.  However, the wrapper class will still be
   * generated to contain the file's getDescriptor() method as well as any
   * top-level extensions defined in the file.
   */
  javaMultipleFiles?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Controls the name of the wrapper Java class generated for the .proto file.
   * That class will always contain the .proto file's getDescriptor() method as
   * well as any top-level extensions defined in the .proto file.
   * If java_multiple_files is disabled, then all the other classes from the
   * .proto file will be nested inside the single wrapper outer class.
   */
  javaOuterClassname?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sets the Java package where classes generated from this .proto will be
   * placed.  By default, the proto package is used, but this is often
   * inappropriate because proto packages do not normally start with backwards
   * domain names.
   */
  javaPackage?: InputMaybe<Scalars['String']['input']>;
  /**
   * If set true, then the Java2 code generator will generate code that
   * throws an exception whenever an attempt is made to assign a non-UTF-8
   * byte sequence to a string field.
   * Message reflection will do the same.
   * However, an extension field still accepts non-UTF-8 byte sequences.
   * This option has no effect on when used with the lite runtime.
   */
  javaStringCheckUtf8?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sets the objective c class prefix which is prepended to all objective c
   * generated classes from this .proto. There is no default.
   */
  objcClassPrefix?: InputMaybe<Scalars['String']['input']>;
  optimizeFor?: InputMaybe<GoogleProtobuf_FileOptions_OptimizeMode>;
  /**
   * Sets the php class prefix which is prepended to all php generated classes
   * from this .proto. Default is empty.
   */
  phpClassPrefix?: InputMaybe<Scalars['String']['input']>;
  phpGenericServices?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Use this option to change the namespace of php generated metadata classes.
   * Default is empty. When this option is empty, the proto file name will be
   * used for determining the namespace.
   */
  phpMetadataNamespace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Use this option to change the namespace of php generated classes. Default
   * is empty. When this option is empty, the package name will be used for
   * determining the namespace.
   */
  phpNamespace?: InputMaybe<Scalars['String']['input']>;
  pyGenericServices?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Use this option to change the package of ruby generated classes. Default
   * is empty. When this option is not set, the package name will be used for
   * determining the ruby package.
   */
  rubyPackage?: InputMaybe<Scalars['String']['input']>;
  /**
   * By default Swift generators will take the proto package and CamelCase it
   * replacing '.' with underscore and use that to prefix the types/symbols
   * defined. When this options is provided, they will use this value instead
   * to prefix the types/symbols defined.
   */
  swiftPrefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The parser stores options it doesn't recognize here.
   * See the documentation for the "Options" section above.
   */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/** Generated classes can be optimized for speed or code size. */
export enum GoogleProtobuf_FileOptions_OptimizeMode {
  /**
   * etc.
   *
   * Use ReflectionOps to implement these methods.
   */
  CODE_SIZE = 'CODE_SIZE',
  /** Generate code using MessageLite and the lite runtime. */
  LITE_RUNTIME = 'LITE_RUNTIME',
  /** Generate complete code for parsing, serialization, */
  SPEED = 'SPEED'
}

/**
 * Wrapper message for `float`.
 *
 * The JSON representation for `FloatValue` is JSON number.
 */
export type GoogleProtobuf_FloatValueInput = {
  /** The float value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Describes the relationship between generated code and its original source
 * file. A GeneratedCodeInfo message is associated with only one generated
 * source file, but may contain references to different source .proto files.
 */
export type GoogleProtobuf_GeneratedCodeInfoInput = {
  /**
   * An Annotation connects some span of text in generated code to an element
   * of its generating .proto file.
   */
  annotation?: InputMaybe<Array<GoogleProtobuf_GeneratedCodeInfo_AnnotationInput>>;
};

export type GoogleProtobuf_GeneratedCodeInfo_AnnotationInput = {
  /**
   * Identifies the starting offset in bytes in the generated code
   * that relates to the identified object.
   */
  begin?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Identifies the ending offset in bytes in the generated code that
   * relates to the identified offset. The end offset should be one past
   * the last relevant byte (so the length of the text = end - begin).
   */
  end?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Identifies the element in the original source .proto file. This field
   * is formatted the same as SourceCodeInfo.Location.path.
   */
  path?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Identifies the filesystem path to the original source .proto. */
  sourceFile?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Wrapper message for `int32`.
 *
 * The JSON representation for `Int32Value` is JSON number.
 */
export type GoogleProtobuf_Int32ValueInput = {
  /** The int32 value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Wrapper message for `int64`.
 *
 * The JSON representation for `Int64Value` is JSON string.
 */
export type GoogleProtobuf_Int64ValueInput = {
  /** The int64 value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * `ListValue` is a wrapper around a repeated field of values.
 *
 * The JSON representation for `ListValue` is JSON array.
 */
export type GoogleProtobuf_ListValueInput = {
  /** Repeated field of dynamically typed values. */
  values?: InputMaybe<Array<GoogleProtobuf_ValueInput>>;
};

export type GoogleProtobuf_MessageOptionsInput = {
  /**
   * Is this message deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the message, or it will be completely ignored; in the very least,
   * this is a formalization for deprecating messages.
   */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the message is an automatically generated map entry type for the
   * maps field.
   *
   * For maps fields:
   *     map<KeyType, ValueType> map_field = 1;
   * The parsed descriptor looks like:
   *     message MapFieldEntry {
   *         option map_entry = true;
   *         optional KeyType key = 1;
   *         optional ValueType value = 2;
   *     }
   *     repeated MapFieldEntry map_field = 1;
   *
   * Implementations may choose not to generate the map_entry=true message, but
   * use a native map in the target language to hold the keys and values.
   * The reflection APIs in such implementations still need to work as
   * if the field is a repeated message field.
   *
   * NOTE: Do not set the option in .proto files. Always use the maps syntax
   * instead. The option should only be implicitly set by the proto compiler
   * parser.
   */
  mapEntry?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Set true to use the old proto1 MessageSet wire format for extensions.
   * This is provided for backwards-compatibility with the MessageSet wire
   * format.  You should not use this for any other reason:  It's less
   * efficient, has fewer features, and is more complicated.
   *
   * The message must be defined exactly as follows:
   *   message Foo {
   *     option message_set_wire_format = true;
   *     extensions 4 to max;
   *   }
   * Note that the message cannot have any defined fields; MessageSets only
   * have extensions.
   *
   * All extensions of your type must be singular messages; e.g. they cannot
   * be int32s, enums, or repeated messages.
   *
   * Because this is an option, the above two restrictions are not enforced by
   * the protocol compiler.
   */
  messageSetWireFormat?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Disables the generation of the standard "descriptor()" accessor, which can
   * conflict with a field of the same name.  This is meant to make migration
   * from proto1 easier; new code should avoid fields named "descriptor".
   */
  noStandardDescriptorAccessor?: InputMaybe<Scalars['Boolean']['input']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/** Describes a method of a service. */
export type GoogleProtobuf_MethodDescriptorProtoInput = {
  /** Identifies if client streams multiple client messages */
  clientStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Input and output type names.  These are resolved in the same way as
   * FieldDescriptorProto.type_name, but must refer to a message type.
   */
  inputType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<GoogleProtobuf_MethodOptionsInput>;
  outputType?: InputMaybe<Scalars['String']['input']>;
  /** Identifies if server streams multiple server messages */
  serverStreaming?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Method represents a method of an API interface. */
export type GoogleProtobuf_MethodInput = {
  /** The simple name of this method. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Any metadata attached to the method. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /** If true, the request is streamed. */
  requestStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  /** A URL of the input message type. */
  requestTypeUrl?: InputMaybe<Scalars['String']['input']>;
  /** If true, the response is streamed. */
  responseStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  /** The URL of the output message type. */
  responseTypeUrl?: InputMaybe<Scalars['String']['input']>;
  /** The source syntax of this method. */
  syntax?: InputMaybe<GoogleProtobuf_Syntax>;
};

export type GoogleProtobuf_MethodOptionsInput = {
  /**
   * Is this method deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the method, or it will be completely ignored; in the very least,
   * this is a formalization for deprecating methods.
   */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyLevel?: InputMaybe<GoogleProtobuf_MethodOptions_IdempotencyLevel>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/**
 * Is this method side-effect-free (or safe in HTTP parlance), or idempotent,
 * or neither? HTTP based RPC implementation may choose GET verb for safe
 * methods, and PUT verb for idempotent methods instead of the default POST.
 */
export enum GoogleProtobuf_MethodOptions_IdempotencyLevel {
  IDEMPOTENCY_UNKNOWN = 'IDEMPOTENCY_UNKNOWN',
  /** idempotent, but may have side effects */
  IDEMPOTENT = 'IDEMPOTENT',
  /** implies idempotent */
  NO_SIDE_EFFECTS = 'NO_SIDE_EFFECTS'
}

/**
 * Declares an API Interface to be included in this interface. The including
 * interface must redeclare all the methods from the included interface, but
 * documentation and options are inherited as follows:
 *
 * - If after comment and whitespace stripping, the documentation
 *   string of the redeclared method is empty, it will be inherited
 *   from the original method.
 *
 * - Each annotation belonging to the service config (http,
 *   visibility) which is not set in the redeclared method will be
 *   inherited.
 *
 * - If an http annotation is inherited, the path pattern will be
 *   modified as follows. Any version prefix will be replaced by the
 *   version of the including interface plus the [root][] path if
 *   specified.
 *
 * Example of a simple mixin:
 *
 *     package google.acl.v1;
 *     service AccessControl {
 *       // Get the underlying ACL object.
 *       rpc GetAcl(GetAclRequest) returns (Acl) {
 *         option (google.api.http).get = "/v1/{resource=**}:getAcl";
 *       }
 *     }
 *
 *     package google.storage.v2;
 *     service Storage {
 *       rpc GetAcl(GetAclRequest) returns (Acl);
 *
 *       // Get a data record.
 *       rpc GetData(GetDataRequest) returns (Data) {
 *         option (google.api.http).get = "/v2/{resource=**}";
 *       }
 *     }
 *
 * Example of a mixin configuration:
 *
 *     apis:
 *     - name: google.storage.v2.Storage
 *       mixins:
 *       - name: google.acl.v1.AccessControl
 *
 * The mixin construct implies that all methods in `AccessControl` are
 * also declared with same name and request/response types in
 * `Storage`. A documentation generator or annotation processor will
 * see the effective `Storage.GetAcl` method after inheriting
 * documentation and annotations as follows:
 *
 *     service Storage {
 *       // Get the underlying ACL object.
 *       rpc GetAcl(GetAclRequest) returns (Acl) {
 *         option (google.api.http).get = "/v2/{resource=**}:getAcl";
 *       }
 *       ...
 *     }
 *
 * Note how the version in the path pattern changed from `v1` to `v2`.
 *
 * If the `root` field in the mixin is specified, it should be a
 * relative path under which inherited HTTP paths are placed. Example:
 *
 *     apis:
 *     - name: google.storage.v2.Storage
 *       mixins:
 *       - name: google.acl.v1.AccessControl
 *         root: acls
 *
 * This implies the following inherited HTTP annotation:
 *
 *     service Storage {
 *       // Get the underlying ACL object.
 *       rpc GetAcl(GetAclRequest) returns (Acl) {
 *         option (google.api.http).get = "/v2/acls/{resource=**}:getAcl";
 *       }
 *       ...
 *     }
 */
export type GoogleProtobuf_MixinInput = {
  /** The fully qualified name of the interface which is included. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * If non-empty specifies a path under which inherited HTTP paths
   * are rooted.
   */
  root?: InputMaybe<Scalars['String']['input']>;
};

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 *  The JSON representation for `NullValue` is JSON `null`.
 */
export enum GoogleProtobuf_NullValue {
  /** Null value. */
  NULL_VALUE = 'NULL_VALUE'
}

/** Describes a oneof. */
export type GoogleProtobuf_OneofDescriptorProtoInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<GoogleProtobuf_OneofOptionsInput>;
};

export type GoogleProtobuf_OneofOptionsInput = {
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/**
 * A protocol buffer option, which can be attached to a message, field,
 * enumeration, etc.
 */
export type GoogleProtobuf_OptionInput = {
  /**
   * The option's name. For protobuf built-in options (options defined in
   * descriptor.proto), this is the short name. For example, `"map_entry"`.
   * For custom options, it should be the fully-qualified name. For example,
   * `"google.api.http"`.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The option's value packed in an Any message. If the value is a primitive,
   * the corresponding wrapper type defined in google/protobuf/wrappers.proto
   * should be used. If the value is an enum, it should be stored as an int32
   * value using the google.protobuf.Int32Value type.
   */
  value?: InputMaybe<GoogleProtobuf_AnyInput>;
};

/** Describes a service. */
export type GoogleProtobuf_ServiceDescriptorProtoInput = {
  method?: InputMaybe<Array<GoogleProtobuf_MethodDescriptorProtoInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<GoogleProtobuf_ServiceOptionsInput>;
};

export type GoogleProtobuf_ServiceOptionsInput = {
  /**
   * Is this service deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the service, or it will be completely ignored; in the very least,
   * this is a formalization for deprecating services.
   */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/**
 * Encapsulates information about the original source file from which a
 * FileDescriptorProto was generated.
 */
export type GoogleProtobuf_SourceCodeInfoInput = {
  /**
   * A Location identifies a piece of source code in a .proto file which
   * corresponds to a particular definition.  This information is intended
   * to be useful to IDEs, code indexers, documentation generators, and similar
   * tools.
   *
   * For example, say we have a file like:
   *   message Foo {
   *     optional string foo = 1;
   *   }
   * Let's look at just the field definition:
   *   optional string foo = 1;
   *   ^       ^^     ^^  ^  ^^^
   *   a       bc     de  f  ghi
   * We have the following locations:
   *   span   path               represents
   *   [a,i)  [ 4, 0, 2, 0 ]     The whole field definition.
   *   [a,b)  [ 4, 0, 2, 0, 4 ]  The label (optional).
   *   [c,d)  [ 4, 0, 2, 0, 5 ]  The type (string).
   *   [e,f)  [ 4, 0, 2, 0, 1 ]  The name (foo).
   *   [g,h)  [ 4, 0, 2, 0, 3 ]  The number (1).
   *
   * Notes:
   * - A location may refer to a repeated field itself (i.e. not to any
   *   particular index within it).  This is used whenever a set of elements are
   *   logically enclosed in a single code segment.  For example, an entire
   *   extend block (possibly containing multiple extension definitions) will
   *   have an outer location whose path refers to the "extensions" repeated
   *   field without an index.
   * - Multiple locations may have the same path.  This happens when a single
   *   logical declaration is spread out across multiple places.  The most
   *   obvious example is the "extend" block again -- there may be multiple
   *   extend blocks in the same scope, each of which will have the same path.
   * - A location's span is not always a subset of its parent's span.  For
   *   example, the "extendee" of an extension declaration appears at the
   *   beginning of the "extend" block and is shared by all extensions within
   *   the block.
   * - Just because a location's span is a subset of some other location's span
   *   does not mean that it is a descendant.  For example, a "group" defines
   *   both a type and a field in a single declaration.  Thus, the locations
   *   corresponding to the type and field and their components will overlap.
   * - Code which tries to interpret locations should probably be designed to
   *   ignore those that it doesn't understand, as more types of locations could
   *   be recorded in the future.
   */
  location?: InputMaybe<Array<GoogleProtobuf_SourceCodeInfo_LocationInput>>;
};

export type GoogleProtobuf_SourceCodeInfo_LocationInput = {
  /**
   * If this SourceCodeInfo represents a complete declaration, these are any
   * comments appearing before and after the declaration which appear to be
   * attached to the declaration.
   *
   * A series of line comments appearing on consecutive lines, with no other
   * tokens appearing on those lines, will be treated as a single comment.
   *
   * leading_detached_comments will keep paragraphs of comments that appear
   * before (but not connected to) the current element. Each paragraph,
   * separated by empty lines, will be one comment element in the repeated
   * field.
   *
   * Only the comment content is provided; comment markers (e.g. //) are
   * stripped out.  For block comments, leading whitespace and an asterisk
   * will be stripped from the beginning of each line other than the first.
   * Newlines are included in the output.
   *
   * Examples:
   *
   *   optional int32 foo = 1;  // Comment attached to foo.
   *   // Comment attached to bar.
   *   optional int32 bar = 2;
   *
   *   optional string baz = 3;
   *   // Comment attached to baz.
   *   // Another line attached to baz.
   *
   *   // Comment attached to qux.
   *   //
   *   // Another line attached to qux.
   *   optional double qux = 4;
   *
   *   // Detached comment for corge. This is not leading or trailing comments
   *   // to qux or corge because there are blank lines separating it from
   *   // both.
   *
   *   // Detached comment for corge paragraph 2.
   *
   *   optional string corge = 5;
   *   /* Block comment attached
   *    * to corge.  Leading asterisks
   *    * will be removed. *\/
   *   /* Block comment attached to
   *    * grault. *\/
   *   optional int32 grault = 6;
   *
   *   // ignored detached comments.
   */
  leadingComments?: InputMaybe<Scalars['String']['input']>;
  leadingDetachedComments?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Identifies which part of the FileDescriptorProto was defined at this
   * location.
   *
   * Each element is a field number or an index.  They form a path from
   * the root FileDescriptorProto to the place where the definition.  For
   * example, this path:
   *   [ 4, 3, 2, 7, 1 ]
   * refers to:
   *   file.message_type(3)  // 4, 3
   *       .field(7)         // 2, 7
   *       .name()           // 1
   * This is because FileDescriptorProto.message_type has field number 4:
   *   repeated DescriptorProto message_type = 4;
   * and DescriptorProto.field has field number 2:
   *   repeated FieldDescriptorProto field = 2;
   * and FieldDescriptorProto.name has field number 1:
   *   optional string name = 1;
   *
   * Thus, the above path gives the location of a field name.  If we removed
   * the last element:
   *   [ 4, 3, 2, 7 ]
   * this path refers to the whole field declaration (from the beginning
   * of the label to the terminating semicolon).
   */
  path?: InputMaybe<Array<Scalars['Float']['input']>>;
  /**
   * Always has exactly three or four elements: start line, start column,
   * end line (optional, otherwise assumed same as start line), end column.
   * These are packed into a single field for efficiency.  Note that line
   * and column numbers are zero-based -- typically you will want to add
   * 1 to each before displaying to a user.
   */
  span?: InputMaybe<Array<Scalars['Float']['input']>>;
  trailingComments?: InputMaybe<Scalars['String']['input']>;
};

/**
 * `SourceContext` represents information about the source of a
 * protobuf element, like the file in which it is defined.
 */
export type GoogleProtobuf_SourceContextInput = {
  /**
   * The path-qualified name of the .proto file that contained the associated
   * protobuf element.  For example: `"google/protobuf/source_context.proto"`.
   */
  fileName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Wrapper message for `string`.
 *
 * The JSON representation for `StringValue` is JSON string.
 */
export type GoogleProtobuf_StringValueInput = {
  /** The string value. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * `Struct` represents a structured data value, consisting of fields
 * which map to dynamically typed values. In some languages, `Struct`
 * might be supported by a native representation. For example, in
 * scripting languages like JS a struct is represented as an
 * object. The details of that representation are described together
 * with the proto support for the language.
 *
 * The JSON representation for `Struct` is JSON object.
 */
export type GoogleProtobuf_StructInput = {
  /** Unordered map of dynamically typed values. */
  fields?: InputMaybe<Array<GoogleProtobuf_Struct_FieldsEntryInput>>;
};

/** `GoogleProtobuf_Struct_FieldsEntryInput` represents the `fields` map in `google.protobuf.Struct`. */
export type GoogleProtobuf_Struct_FieldsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<GoogleProtobuf_ValueInput>;
};

/** The syntax in which a protocol buffer element is defined. */
export enum GoogleProtobuf_Syntax {
  /** Syntax `proto2`. */
  SYNTAX_PROTO2 = 'SYNTAX_PROTO2',
  /** Syntax `proto3`. */
  SYNTAX_PROTO3 = 'SYNTAX_PROTO3'
}

/**
 * A Timestamp represents a point in time independent of any time zone or local
 * calendar, encoded as a count of seconds and fractions of seconds at
 * nanosecond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 *
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 *
 * The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By
 * restricting to that range, we ensure that we can convert to and from [RFC
 * 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.
 *
 * # Examples
 *
 * Example 1: Compute Timestamp from POSIX `time()`.
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(time(NULL));
 *     timestamp.set_nanos(0);
 *
 * Example 2: Compute Timestamp from POSIX `gettimeofday()`.
 *
 *     struct timeval tv;
 *     gettimeofday(&tv, NULL);
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(tv.tv_sec);
 *     timestamp.set_nanos(tv.tv_usec * 1000);
 *
 * Example 3: Compute Timestamp from Win32 `GetSystemTimeAsFileTime()`.
 *
 *     FILETIME ft;
 *     GetSystemTimeAsFileTime(&ft);
 *     UINT64 ticks = (((UINT64)ft.dwHighDateTime) << 32) | ft.dwLowDateTime;
 *
 *     // A Windows tick is 100 nanoseconds. Windows epoch 1601-01-01T00:00:00Z
 *     // is 11644473600 seconds before Unix epoch 1970-01-01T00:00:00Z.
 *     Timestamp timestamp;
 *     timestamp.set_seconds((INT64) ((ticks / 10000000) - 11644473600LL));
 *     timestamp.set_nanos((INT32) ((ticks % 10000000) * 100));
 *
 * Example 4: Compute Timestamp from Java `System.currentTimeMillis()`.
 *
 *     long millis = System.currentTimeMillis();
 *
 *     Timestamp timestamp = Timestamp.newBuilder().setSeconds(millis / 1000)
 *         .setNanos((int) ((millis % 1000) * 1000000)).build();
 *
 *
 * Example 5: Compute Timestamp from Java `Instant.now()`.
 *
 *     Instant now = Instant.now();
 *
 *     Timestamp timestamp =
 *         Timestamp.newBuilder().setSeconds(now.getEpochSecond())
 *             .setNanos(now.getNano()).build();
 *
 *
 * Example 6: Compute Timestamp from current time in Python.
 *
 *     timestamp = Timestamp()
 *     timestamp.GetCurrentTime()
 *
 * # JSON Mapping
 *
 * In JSON format, the Timestamp type is encoded as a string in the
 * [RFC 3339](https://www.ietf.org/rfc/rfc3339.txt) format. That is, the
 * format is "{year}-{month}-{day}T{hour}:{min}:{sec}[.{frac_sec}]Z"
 * where {year} is always expressed using four digits while {month}, {day},
 * {hour}, {min}, and {sec} are zero-padded to two digits each. The fractional
 * seconds, which can go up to 9 digits (i.e. up to 1 nanosecond resolution),
 * are optional. The "Z" suffix indicates the timezone ("UTC"); the timezone
 * is required. A proto3 JSON serializer should always use UTC (as indicated by
 * "Z") when printing the Timestamp type and a proto3 JSON parser should be
 * able to accept both UTC and other timezones (as indicated by an offset).
 *
 * For example, "2017-01-15T01:30:15.01Z" encodes 15.01 seconds past
 * 01:30 UTC on January 15, 2017.
 *
 * In JavaScript, one can convert a Date object to this format using the
 * standard
 * [toISOString()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString)
 * method. In Python, a standard `datetime.datetime` object can be converted
 * to this format using
 * [`strftime`](https://docs.python.org/2/library/time.html#time.strftime) with
 * the time format spec '%Y-%m-%dT%H:%M:%S.%fZ'. Likewise, in Java, one can use
 * the Joda Time's [`ISODateTimeFormat.dateTime()`](
 * http://www.joda.org/joda-time/apidocs/org/joda/time/format/ISODateTimeFormat.html#dateTime%2D%2D
 * ) to obtain a formatter capable of generating timestamps in this format.
 */
export type GoogleProtobuf_TimestampInput = {
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999
   * inclusive.
   */
  nanos?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   */
  seconds?: InputMaybe<Scalars['Float']['input']>;
};

/** A protocol buffer message type. */
export type GoogleProtobuf_TypeInput = {
  /** The list of fields. */
  fields?: InputMaybe<Array<GoogleProtobuf_FieldInput>>;
  /** The fully qualified message name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The list of types appearing in `oneof` definitions in this type. */
  oneofs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The protocol buffer options. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /** The source context. */
  sourceContext?: InputMaybe<GoogleProtobuf_SourceContextInput>;
  /** The source syntax. */
  syntax?: InputMaybe<GoogleProtobuf_Syntax>;
};

/**
 * Wrapper message for `uint32`.
 *
 * The JSON representation for `UInt32Value` is JSON number.
 */
export type GoogleProtobuf_UInt32ValueInput = {
  /** The uint32 value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Wrapper message for `uint64`.
 *
 * The JSON representation for `UInt64Value` is JSON string.
 */
export type GoogleProtobuf_UInt64ValueInput = {
  /** The uint64 value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * A message representing a option the parser does not recognize. This only
 * appears in options protos created by the compiler::Parser class.
 * DescriptorPool resolves these when building Descriptor objects. Therefore,
 * options protos in descriptor objects (e.g. returned by Descriptor::options(),
 * or produced by Descriptor::CopyTo()) will never have UninterpretedOptions
 * in them.
 */
export type GoogleProtobuf_UninterpretedOptionInput = {
  aggregateValue?: InputMaybe<Scalars['String']['input']>;
  doubleValue?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The value of the uninterpreted option, in whatever type the tokenizer
   * identified it as during parsing. Exactly one of these should be set.
   */
  identifierValue?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Array<GoogleProtobuf_UninterpretedOption_NamePartInput>>;
  negativeIntValue?: InputMaybe<Scalars['Float']['input']>;
  positiveIntValue?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The name of the uninterpreted option.  Each string represents a segment in
 * a dot-separated name.  is_extension is true iff a segment represents an
 * extension (denoted with parentheses in options specs in .proto files).
 * E.g.,{ ["foo", false], ["bar.baz", true], ["qux", false] } represents
 * "foo.(bar.baz).qux".
 */
export type GoogleProtobuf_UninterpretedOption_NamePartInput = {
  isExtension?: InputMaybe<Scalars['Boolean']['input']>;
  namePart?: InputMaybe<Scalars['String']['input']>;
};

/**
 * `Value` represents a dynamically typed value which can be either
 * null, a number, a string, a boolean, a recursive struct value, or a
 * list of values. A producer of value is expected to set one of these
 * variants. Absence of any variant indicates an error.
 *
 * The JSON representation for `Value` is JSON value.
 */
export type GoogleProtobuf_ValueInput = {
  /** The kind of value. */
  kind?: InputMaybe<GoogleProtobuf_Value_KindOneofInput>;
};

export type GoogleProtobuf_Value_KindOneofInput = {
  /** Represents a boolean value. */
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents a repeated `Value`. */
  listValue?: InputMaybe<GoogleProtobuf_ListValueInput>;
  /** Represents a null value. */
  nullValue?: InputMaybe<GoogleProtobuf_NullValue>;
  /** Represents a double value. */
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  /** Represents a string value. */
  stringValue?: InputMaybe<Scalars['String']['input']>;
  /** Represents a structured value. */
  structValue?: InputMaybe<GoogleProtobuf_StructInput>;
};

/**
 * The canonical error codes for gRPC APIs.
 *
 *
 * Sometimes multiple error codes may apply.  Services should return
 * the most specific error code that applies.  For example, prefer
 * `OUT_OF_RANGE` over `FAILED_PRECONDITION` if both codes apply.
 * Similarly prefer `NOT_FOUND` or `ALREADY_EXISTS` over `FAILED_PRECONDITION`.
 */
export enum GoogleRpc_Code {
  /**
   * The operation was aborted, typically due to a concurrency issue such as
   * a sequencer check failure or transaction abort.
   *
   * See the guidelines above for deciding between `FAILED_PRECONDITION`,
   * `ABORTED`, and `UNAVAILABLE`.
   *
   * HTTP Mapping: 409 Conflict
   */
  ABORTED = 'ABORTED',
  /**
   * The entity that a client attempted to create (e.g., file or directory)
   * already exists.
   *
   * HTTP Mapping: 409 Conflict
   */
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  /**
   * The operation was cancelled, typically by the caller.
   *
   * HTTP Mapping: 499 Client Closed Request
   */
  CANCELLED = 'CANCELLED',
  /**
   * Unrecoverable data loss or corruption.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  DATA_LOSS = 'DATA_LOSS',
  /**
   * The deadline expired before the operation could complete. For operations
   * that change the state of the system, this error may be returned
   * even if the operation has completed successfully.  For example, a
   * successful response from a server could have been delayed long
   * enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   */
  DEADLINE_EXCEEDED = 'DEADLINE_EXCEEDED',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementors can use the following guidelines to decide
   * between `FAILED_PRECONDITION`, `ABORTED`, and `UNAVAILABLE`:
   *  (a) Use `UNAVAILABLE` if the client can retry just the failing call.
   *  (b) Use `ABORTED` if the client should retry at a higher level
   *      (e.g., when a client-specified test-and-set fails, indicating the
   *      client should restart a read-modify-write sequence).
   *  (c) Use `FAILED_PRECONDITION` if the client should not retry until
   *      the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   *      should be returned since the client should not retry unless
   *      the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request
   */
  FAILED_PRECONDITION = 'FAILED_PRECONDITION',
  /**
   * Internal errors.  This means that some invariants expected by the
   * underlying system have been broken.  This error code is reserved
   * for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  INTERNAL = 'INTERNAL',
  /**
   * The client specified an invalid argument.  Note that this differs
   * from `FAILED_PRECONDITION`.  `INVALID_ARGUMENT` indicates arguments
   * that are problematic regardless of the state of the system
   * (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   */
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  /**
   * Some requested entity (e.g., file or directory) was not found.
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented whitelist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NOT_FOUND = 'NOT_FOUND',
  /**
   * Not an error; returned on success
   *
   * HTTP Mapping: 200 OK
   */
  OK = 'OK',
  /**
   * The operation was attempted past the valid range.  E.g., seeking or
   * reading past end-of-file.
   *
   * Unlike `INVALID_ARGUMENT`, this error indicates a problem that may
   * be fixed if the system state changes. For example, a 32-bit file
   * system will generate `INVALID_ARGUMENT` if asked to read at an
   * offset that is not in the range [0,2^32-1], but it will generate
   * `OUT_OF_RANGE` if asked to read from an offset past the current
   * file size.
   *
   * There is a fair bit of overlap between `FAILED_PRECONDITION` and
   * `OUT_OF_RANGE`.  We recommend using `OUT_OF_RANGE` (the more specific
   * error) when it applies so that callers who are iterating through
   * a space can easily look for an `OUT_OF_RANGE` error to detect when
   * they are done.
   *
   * HTTP Mapping: 400 Bad Request
   */
  OUT_OF_RANGE = 'OUT_OF_RANGE',
  /**
   * The caller does not have permission to execute the specified
   * operation. `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource (use `RESOURCE_EXHAUSTED`
   * instead for those errors). `PERMISSION_DENIED` must not be
   * used if the caller can not be identified (use `UNAUTHENTICATED`
   * instead for those errors). This error code does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  /**
   * Some resource has been exhausted, perhaps a per-user quota, or
   * perhaps the entire file system is out of space.
   *
   * HTTP Mapping: 429 Too Many Requests
   */
  RESOURCE_EXHAUSTED = 'RESOURCE_EXHAUSTED',
  /**
   * The request does not have valid authentication credentials for the
   * operation.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  /**
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff. Note that it is not always safe to retry
   * non-idempotent operations.
   *
   * See the guidelines above for deciding between `FAILED_PRECONDITION`,
   * `ABORTED`, and `UNAVAILABLE`.
   *
   * HTTP Mapping: 503 Service Unavailable
   */
  UNAVAILABLE = 'UNAVAILABLE',
  /**
   * The operation is not implemented or is not supported/enabled in this
   * service.
   *
   * HTTP Mapping: 501 Not Implemented
   */
  UNIMPLEMENTED = 'UNIMPLEMENTED',
  /**
   * Unknown error.  For example, this error may be returned when
   * a `Status` value received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  UNKNOWN = 'UNKNOWN'
}

export type HoaAmenitiesInput = {
  clubhouse?: InputMaybe<Scalars['Boolean']['input']>;
  dogPark?: InputMaybe<Scalars['Boolean']['input']>;
  golf?: InputMaybe<Scalars['Boolean']['input']>;
  gym?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  otherInfo?: InputMaybe<Scalars['String']['input']>;
  park?: InputMaybe<Scalars['Boolean']['input']>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  sauna?: InputMaybe<Scalars['Boolean']['input']>;
  sportsCourts?: InputMaybe<Scalars['Boolean']['input']>;
  tennisCourt?: InputMaybe<Scalars['Boolean']['input']>;
  trails?: InputMaybe<Scalars['Boolean']['input']>;
  trashRecycling?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HoaFeeInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
};

export type HoaFeesTaskInput = {
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  hoaAmenities?: InputMaybe<HoaAmenitiesInput>;
  hoaAnswered?: InputMaybe<Scalars['Boolean']['input']>;
  hoaFees?: InputMaybe<Array<InputMaybe<HoaFeeInput>>>;
  hoaName?: InputMaybe<Scalars['String']['input']>;
};

export type HomeCompsInput = {
  compsAddressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HomeDetailsInput = {
  addressUuid: Scalars['String']['input'];
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Query and mutation resolvers for HTTP requests can choose to include an HttpResponseType.
 * This enum is simple since clients don't need to worry about raw HTTP response status codes
 * and can instead use something simpler.
 */
export enum HttpResponseType {
  /** 3XXs, 4XXs, 5XXs */
  FAILURE = 'FAILURE',
  /** 2XXs */
  SUCCESS = 'SUCCESS'
}

export type HubSpotCallEngagementPropertiesInput = {
  hsActivityType?: InputMaybe<Scalars['String']['input']>;
  hsCallBody?: InputMaybe<Scalars['String']['input']>;
  hsCallDirection?: InputMaybe<Scalars['String']['input']>;
  hsCallDisposition?: InputMaybe<Scalars['String']['input']>;
  hsCallDuration?: InputMaybe<Scalars['String']['input']>;
  hsCallFromNumber?: InputMaybe<Scalars['String']['input']>;
  hsCallRecordingUrl?: InputMaybe<Scalars['String']['input']>;
  hsCallSource?: InputMaybe<Scalars['String']['input']>;
  hsCallStatus?: InputMaybe<Scalars['String']['input']>;
  hsCallToNumber?: InputMaybe<Scalars['String']['input']>;
};

export type HubSpotGenerateTwilioTokenInput = {
  humanEmail: Scalars['String']['input'];
};

export type HubSpotGetContactPhoneInput = {
  contactId: Scalars['String']['input'];
};

export type HubSpotGetEngagementInput = {
  engagementId: Scalars['String']['input'];
};

export type HubSpotRecordCallEndedInput = {
  callSid: Scalars['String']['input'];
  callStatus?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  recordingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type HubSpotRecordCallStartedInput = {
  callSid: Scalars['String']['input'];
  direction: Scalars['String']['input'];
  fromNumber: Scalars['String']['input'];
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  humanEmail: Scalars['String']['input'];
  toNumber: Scalars['String']['input'];
};

export type HubSpotUpdateEngagementInput = {
  engagementId: Scalars['String']['input'];
  properties?: InputMaybe<HubSpotCallEngagementPropertiesInput>;
};

export type HvacRoofTaskInput = {
  damageClaimDetails?: InputMaybe<Scalars['String']['input']>;
  filedClaim?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolybutenePiping?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeptic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSprinklerOrIrrigation?: InputMaybe<Scalars['Boolean']['input']>;
  hasSumpPump?: InputMaybe<Scalars['Boolean']['input']>;
  hasWellWaterSupply?: InputMaybe<Scalars['Boolean']['input']>;
  hvacAge?: InputMaybe<Scalars['String']['input']>;
  lastFoundationEvaluation?: InputMaybe<Scalars['String']['input']>;
  receivedProceeds?: InputMaybe<Scalars['Boolean']['input']>;
  roofAge?: InputMaybe<Scalars['String']['input']>;
  roofStormDamage?: InputMaybe<Scalars['Boolean']['input']>;
  sprinklerTimerType?: InputMaybe<SprinklerTimer>;
  workingSprinkler?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for initiating a customer task */
export type InitiateCustomerTaskInput = {
  /** The unique identifier for this resource instance */
  id: Scalars['String']['input'];
  /** The type of task being initiated */
  taskType: CustomerTaskType;
};

/** From HDS: granite_slab, granite_tile, other_tile, corian, formica, quartz to enum values */
export enum KitchenCountertop {
  CORIAN = 'CORIAN',
  FORMICA = 'FORMICA',
  GRANITE_SLAB = 'GRANITE_SLAB',
  GRANITE_TILE = 'GRANITE_TILE',
  OTHER_TILE = 'OTHER_TILE',
  QUARTZ = 'QUARTZ',
  UNKNOWN = 'UNKNOWN'
}

export type LateCheckoutTaskInput = {
  costPerDayCents?: InputMaybe<Scalars['Int']['input']>;
  fixedCostCents?: InputMaybe<Scalars['Int']['input']>;
  lateCheckoutDate?: InputMaybe<Scalars['String']['input']>;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
  sellerInterested?: InputMaybe<Scalars['Boolean']['input']>;
  totalCostCents?: InputMaybe<Scalars['Int']['input']>;
};

export enum LenderTourGateAnswerEnum {
  all_cash = 'all_cash',
  not_yet = 'not_yet',
  qualified_or_approved = 'qualified_or_approved'
}

export enum ListingHistoryEventType {
  CLOSE_PRICE_CHANGE = 'CLOSE_PRICE_CHANGE',
  FOR_SALE = 'FOR_SALE',
  LIST_PRICE_CHANGE = 'LIST_PRICE_CHANGE',
  OFF_MARKET = 'OFF_MARKET',
  PENDING = 'PENDING',
  SOLD = 'SOLD'
}

export enum ListingHistoryState {
  COMING_SOON = 'COMING_SOON',
  FOR_SALE = 'FOR_SALE',
  OFF_MARKET = 'OFF_MARKET',
  PRIVATELY_LISTED = 'PRIVATELY_LISTED',
  SALE_PENDING = 'SALE_PENDING',
  SOLD = 'SOLD',
  TEMP_OFF_MARKET = 'TEMP_OFF_MARKET',
  UNKNOWN = 'UNKNOWN',
  WITHDRAWN = 'WITHDRAWN'
}

/** ListingState represents the current state of a property listing */
export enum ListingState {
  AVAILABLE_SOON = 'AVAILABLE_SOON',
  IN_CONTRACT = 'IN_CONTRACT',
  ON_THE_MARKET = 'ON_THE_MARKET',
  RECENTLY_SOLD = 'RECENTLY_SOLD',
  UNKNOWN = 'UNKNOWN'
}

export enum ListingTag {
  BUY_DIRECT_ELIGIBLE = 'BUY_DIRECT_ELIGIBLE',
  BUY_DIRECT_MULTIPLE_OFFERS = 'BUY_DIRECT_MULTIPLE_OFFERS',
  BUY_DIRECT_SALE_PENDING = 'BUY_DIRECT_SALE_PENDING',
  BUY_DIRECT_VERBAL_AGREEMENT = 'BUY_DIRECT_VERBAL_AGREEMENT'
}

export enum MlsDisplayPermission {
  FULL = 'FULL',
  LIMITED_ADDRESS = 'LIMITED_ADDRESS',
  LIMITED_PHOTO = 'LIMITED_PHOTO',
  NONE = 'NONE'
}

export type MailgunEmailInput = {
  email: Scalars['String']['input'];
};

export type MarketDataInput = {
  addressUuid: Scalars['String']['input'];
};

/** From HDS: entry_level, first_floor, second_floor, third_floor, basement to enum values */
export enum MasterBedroomLocation {
  BASEMENT = 'BASEMENT',
  FIRST_FLOOR = 'FIRST_FLOOR',
  SECOND_FLOOR = 'SECOND_FLOOR',
  THIRD_FLOOR = 'THIRD_FLOOR',
  UNKNOWN = 'UNKNOWN'
}

export type MinMaxFilter = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type MinMaxFloatFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** See https://docs.aws.amazon.com/AWSJavaScriptSDK/v3/latest/clients/client-s3/enums/objectstorageclass.html */
export enum ObjectStorageClass {
  DEEP_ARCHIVE = 'DEEP_ARCHIVE',
  GLACIER = 'GLACIER',
  GLACIER_IR = 'GLACIER_IR',
  INTELLIGENT_TIERING = 'INTELLIGENT_TIERING',
  ONEZONE_IA = 'ONEZONE_IA',
  OUTPOSTS = 'OUTPOSTS',
  REDUCED_REDUNDANCY = 'REDUCED_REDUNDANCY',
  STANDARD = 'STANDARD',
  STANDARD_IA = 'STANDARD_IA'
}

export type OccupantInfo = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Data_AssessmentAddressInputInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAbraV0Data_AssessmentHandoffType {
  ASSESSMENT_HANDOFF_TYPE_EXPERT = 'ASSESSMENT_HANDOFF_TYPE_EXPERT',
  ASSESSMENT_HANDOFF_TYPE_INVITATION = 'ASSESSMENT_HANDOFF_TYPE_INVITATION',
  ASSESSMENT_HANDOFF_TYPE_UNKNOWN = 'ASSESSMENT_HANDOFF_TYPE_UNKNOWN'
}

export type OdProtosAbraV0Data_AssessmentHandoffTypeExpertInput = {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  customerMobilePhone?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosAbraV0Data_AssessmentHandoffTypeInvitationInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosAbraV0Data_AssessmentProcessStep {
  ASSESSMENT_PROCESS_STEP_HANDOFF = 'ASSESSMENT_PROCESS_STEP_HANDOFF',
  ASSESSMENT_PROCESS_STEP_UNKNOWN = 'ASSESSMENT_PROCESS_STEP_UNKNOWN'
}

export enum OdProtosAbraV0Data_AssessmentReviewEscalation_EscalationType {
  DEAL_BREAKERS = 'DEAL_BREAKERS',
  /** Specialty inspections */
  ELECTRICAL = 'ELECTRICAL',
  FOUNDATION = 'FOUNDATION',
  HIGH_PRELIMS_COST = 'HIGH_PRELIMS_COST',
  HIGH_REPAIR_COST = 'HIGH_REPAIR_COST',
  HVAC = 'HVAC',
  LAND_SURVEYING = 'LAND_SURVEYING',
  LIVING_AREA_MEASUREMENT = 'LIVING_AREA_MEASUREMENT',
  MANUAL = 'MANUAL',
  MISSING_PRICE = 'MISSING_PRICE',
  MISSING_QUANTITY = 'MISSING_QUANTITY',
  MOLD_REMEDIATION = 'MOLD_REMEDIATION',
  NON_OD_ASSESSMENT = 'NON_OD_ASSESSMENT',
  ODOR_REMEDIATION = 'ODOR_REMEDIATION',
  OTHER_ELEMENTS = 'OTHER_ELEMENTS',
  PLUMBING = 'PLUMBING',
  POOL = 'POOL',
  PREVIOUS_WALK = 'PREVIOUS_WALK',
  RADON = 'RADON',
  REPORTS_SUBMITTED = 'REPORTS_SUBMITTED',
  REVIEW_OLD_SPECIALTY_INSPECTION = 'REVIEW_OLD_SPECIALTY_INSPECTION',
  ROOF = 'ROOF',
  SEPTIC = 'SEPTIC',
  STRUCTURAL = 'STRUCTURAL',
  TERMITE = 'TERMITE',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  WELLS = 'WELLS'
}

export enum OdProtosAbraV0Data_AssessmentReviewEscalation_State {
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosAbraV0Data_AssessmentReviewState {
  ASSESSMENT_REVIEW_STATE_COMPLETED = 'ASSESSMENT_REVIEW_STATE_COMPLETED',
  ASSESSMENT_REVIEW_STATE_DISCREPANCIES_REVIEW_COMPLETED = 'ASSESSMENT_REVIEW_STATE_DISCREPANCIES_REVIEW_COMPLETED',
  ASSESSMENT_REVIEW_STATE_PENDING = 'ASSESSMENT_REVIEW_STATE_PENDING',
  ASSESSMENT_REVIEW_STATE_SKIPPED = 'ASSESSMENT_REVIEW_STATE_SKIPPED',
  ASSESSMENT_REVIEW_STATE_SKIPPED_NOT_ELIGIBLE = 'ASSESSMENT_REVIEW_STATE_SKIPPED_NOT_ELIGIBLE',
  ASSESSMENT_REVIEW_STATE_UNSPECIFIED = 'ASSESSMENT_REVIEW_STATE_UNSPECIFIED'
}

export enum OdProtosAbraV0Data_AssessmentState {
  ASSESSMENT_STATE_CANCELED = 'ASSESSMENT_STATE_CANCELED',
  ASSESSMENT_STATE_COMPLETED = 'ASSESSMENT_STATE_COMPLETED',
  ASSESSMENT_STATE_SCHEDULED = 'ASSESSMENT_STATE_SCHEDULED',
  ASSESSMENT_STATE_UNKNOWN = 'ASSESSMENT_STATE_UNKNOWN'
}

export enum OdProtosAbraV0Data_Assessment_State {
  SUBMITTED = 'SUBMITTED',
  UNKNOWN = 'UNKNOWN',
  UNSAFE = 'UNSAFE'
}

export type OdProtosAbraV0Data_BookingSlotInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Represents a component of an addendum */
export type OdProtosAbraV0Data_DecisionAddendumComponentInput = {
  /** The monetary amount associated with this component */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The source category that contributed to this component */
  source?: InputMaybe<OdProtosAbraV0Data_DecisionAddendumSource>;
};

/**
 * Decision outcome indicating an addendum is required before proceeding
 * to closing, typically due to discovered issues or changed circumstances
 */
export type OdProtosAbraV0Data_DecisionAddendumRequiredInput = {
  /**
   * Breakdown of the adjustment by source category for transparency, communication
   * with sellers, etc. funds_adjustment = sum of each component amount in decomposition
   */
  decomposition?: InputMaybe<Array<OdProtosAbraV0Data_DecisionAddendumComponentInput>>;
  /** The total funds adjustment to be added as an addendum */
  fundsAdjustment?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/**
 * Represents the source or category that contributed to a contract addendum
 * calculated after the diligence visit
 */
export enum OdProtosAbraV0Data_DecisionAddendumSource {
  /** Use when addendum component is due to home detail changes that affect valuation */
  PRICING = 'PRICING',
  /** Use when addendum component is due to repair scope changes or discoveries */
  REPAIR_SCOPES = 'REPAIR_SCOPES',
  UNDERWRITING = 'UNDERWRITING',
  /** Default/unknown source - should not be used in practice */
  UNSPECIFIED = 'UNSPECIFIED'
}

/**
 * Decision outcome indicating the transaction can proceed to closing
 * without any additional requirements or adjustments
 */
export type OdProtosAbraV0Data_DecisionClearToCloseInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Decision outcome indicating the transaction should be withdrawn
 * due to issues discovered during the diligence visit
 */
export type OdProtosAbraV0Data_DecisionWithdrawInput = {
  /** Human-readable explanation for why the transaction is being withdrawn */
  reasoning?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAbraV0Data_InspectionType {
  FLOOR_PLAN = 'FLOOR_PLAN',
  HOME_INSPECTION = 'HOME_INSPECTION',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosAbraV0Data_LaborCostInput = {
  totalCents?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosAbraV0Data_MaterialCostInput = {
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<OdProtosAbraV0Data_UnitType>;
  unitCents?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosAbraV0Data_OnSiteContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAbraV0Data_OrderStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  INITIALIZED = 'INITIALIZED',
  ORDER_STATUS_UNKNOWN = 'ORDER_STATUS_UNKNOWN',
  RESCHEDULE_REQUESTED = 'RESCHEDULE_REQUESTED',
  SCHEDULED = 'SCHEDULED'
}

/**
 * Represents the outcome of a post-contract diligence review process,
 * capturing the decision made and when it was finalized
 */
export type OdProtosAbraV0Data_PostContractDiligenceReviewInput = {
  decision?: InputMaybe<OdProtosAbraV0Data_PostContractDiligenceReview_DecisionOneofInput>;
  /** Timestamp when the review decision was finalized */
  reviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosAbraV0Data_PostContractDiligenceReview_DecisionOneofInput = {
  addendumRequired?: InputMaybe<OdProtosAbraV0Data_DecisionAddendumRequiredInput>;
  clearToClose?: InputMaybe<OdProtosAbraV0Data_DecisionClearToCloseInput>;
  withdraw?: InputMaybe<OdProtosAbraV0Data_DecisionWithdrawInput>;
};

export enum OdProtosAbraV0Data_PostDiligenceAddendumType {
  POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_BUYER = 'POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_BUYER',
  POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_SELLER = 'POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_SELLER',
  POST_DILIGENCE_ADDENDUM_TYPE_UNKNOWN = 'POST_DILIGENCE_ADDENDUM_TYPE_UNKNOWN'
}

export enum OdProtosAbraV0Data_ProcessStep {
  PROCESS_STEP_TRADE_IN_ASSESSMENT = 'PROCESS_STEP_TRADE_IN_ASSESSMENT',
  PROCESS_STEP_UNKNOWN = 'PROCESS_STEP_UNKNOWN'
}

export type OdProtosAbraV0Data_Reno911RepairScopeInputInput = {
  cost?: InputMaybe<OdProtosAbraV0Data_MaterialCostInput>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAbraV0Data_RepairScopeOrigin {
  REPAIRSCOPEORIGIN_ASSESSMENT_REVIEW = 'REPAIRSCOPEORIGIN_ASSESSMENT_REVIEW',
  REPAIRSCOPEORIGIN_CONDITION_SCOPING = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING',
  REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI',
  REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_FEEDBACK = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_FEEDBACK',
  REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_HIDDEN = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_HIDDEN',
  /** manual */
  REPAIRSCOPEORIGIN_CONDITION_SCOPING_M = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_M',
  REPAIRSCOPEORIGIN_POST_CONTRACT_DILIGENCE_SCOPING = 'REPAIRSCOPEORIGIN_POST_CONTRACT_DILIGENCE_SCOPING',
  REPAIRSCOPEORIGIN_RENO911 = 'REPAIRSCOPEORIGIN_RENO911',
  REPAIRSCOPEORIGIN_UNSPECIFIED = 'REPAIRSCOPEORIGIN_UNSPECIFIED'
}

export type OdProtosAbraV0Data_SourceReferenceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosAbraV0Data_SourceReference_SourceReferenceType>;
};

export enum OdProtosAbraV0Data_SourceReference_SourceReferenceType {
  PROMPT = 'PROMPT',
  PROMPT_GROUP = 'PROMPT_GROUP',
  SOURCE_REFERENCE_TYPE_UNSPECIFIED = 'SOURCE_REFERENCE_TYPE_UNSPECIFIED'
}

export enum OdProtosAbraV0Data_State {
  APPROVED = 'APPROVED',
  DELETED = 'DELETED',
  INVALID = 'INVALID',
  OPEN = 'OPEN'
}

export enum OdProtosAbraV0Data_UnitType {
  EACH = 'EACH',
  LINEAR_FEET = 'LINEAR_FEET',
  SQUARE_FEET = 'SQUARE_FEET'
}

/** Who completed an assessment phase. Top-level for reuse across events. */
export enum OdProtosAbraV0Events_CompletedBy {
  /** Agent app-based task */
  COMPLETED_BY_AGENT = 'COMPLETED_BY_AGENT',
  /** Virtual assessment or seller app-based */
  COMPLETED_BY_CUSTOMER = 'COMPLETED_BY_CUSTOMER',
  /** Visit-based assessment */
  COMPLETED_BY_HPM = 'COMPLETED_BY_HPM',
  COMPLETED_BY_UNSPECIFIED = 'COMPLETED_BY_UNSPECIFIED'
}

/** Next ID: 2 */
export type OdProtosAbraV0Services_AcquisitionWithdrawnRequestInput = {
  casaId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_BatchGetInspectionPipelineRequestInput = {
  offerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAbraV0Services_CancelAssessmentHandoffRequestInput = {
  handoffId?: InputMaybe<Scalars['String']['input']>;
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_CancelDvScopingAndCreateWithdrawTaskRequestInput = {
  reasoning?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_CancelInspectionOrderRequestInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_CancelShowingRequestInput = {
  shouldCleanupHandoff?: InputMaybe<Scalars['Boolean']['input']>;
  showingId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_ChangeAddressRequestInput = {
  newAddressId?: InputMaybe<Scalars['String']['input']>;
  oldAddressId?: InputMaybe<Scalars['String']['input']>;
  taskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAbraV0Services_CompleteAssessmentReviewRequestInput = {
  assessmentReviewId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_CompleteDiscrepancyReviewRequestInput = {
  assessmentReviewId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_CreateAssessmentHandoffRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosAbraV0Services_CreateAssessmentHandoffRequest_TypeOneofInput>;
};

export type OdProtosAbraV0Services_CreateAssessmentHandoffRequest_TypeOneofInput = {
  expert?: InputMaybe<OdProtosAbraV0Data_AssessmentHandoffTypeExpertInput>;
  invitation?: InputMaybe<OdProtosAbraV0Data_AssessmentHandoffTypeInvitationInput>;
};

export type OdProtosAbraV0Services_CreateAssessmentTaskWithRubricRequestInput = {
  addressInput?: InputMaybe<OdProtosAbraV0Data_AssessmentAddressInputInput>;
  humanToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_CreateHomeAccessInformationRequestInput = {
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  addressToken?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  /** optional field. Will be present if gated_community = true */
  gateCode?: InputMaybe<Scalars['String']['input']>;
  gateCodeNotes?: InputMaybe<Scalars['String']['input']>;
  /** represents if the home is in a gated community */
  gatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  keypadAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** optional field. Will be present if keypad_access = true */
  keypadCode?: InputMaybe<Scalars['String']['input']>;
  lockboxAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** optional field. Will be present if lockbox_access = true */
  lockboxCode?: InputMaybe<Scalars['String']['input']>;
  /** represents the assessment visit_id */
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_CreateInspectionOrderRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
};

export type OdProtosAbraV0Services_CreatePostContractDiligenceReviewRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<OdProtosAbraV0Data_PostContractDiligenceReviewInput>;
};

export type OdProtosAbraV0Services_CreateReno911RepairScopesRequestInput = {
  repairScopeInputs?: InputMaybe<Array<OdProtosAbraV0Data_Reno911RepairScopeInputInput>>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_CreateRepairScopeRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  areaId?: InputMaybe<Scalars['String']['input']>;
  createdFromSource?: InputMaybe<Scalars['String']['input']>;
  createdFromSourceReference?: InputMaybe<OdProtosAbraV0Data_SourceReferenceInput>;
  defectId?: InputMaybe<Scalars['String']['input']>;
  deferred?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosAbraV0Data_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosAbraV0Data_MaterialCostInput>;
  origin?: InputMaybe<OdProtosAbraV0Data_RepairScopeOrigin>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_DeleteRepairScopeRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_DeleteRepairScopesRequestInput = {
  repairScopeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAbraV0Services_DownloadInspectifyPdFsRequestInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_EnsureAssessmentTaskWithHandoffRequestInput = {
  customerHumanToken?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosAbraV0Services_EnsureAssessmentTaskWithHandoffRequest_TypeOneofInput>;
};

export type OdProtosAbraV0Services_EnsureAssessmentTaskWithHandoffRequest_TypeOneofInput = {
  expert?: InputMaybe<OdProtosAbraV0Data_AssessmentHandoffTypeExpertInput>;
  invitation?: InputMaybe<OdProtosAbraV0Data_AssessmentHandoffTypeInvitationInput>;
};

export type OdProtosAbraV0Services_EnsureRepairScopePrelimsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_ExpediteDeficienciesRequestInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_ExpediteLimitationsRequestInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_ExpediteReportProcessingRequestInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetAreaAssetsByHomeRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  sizeModifiers?: InputMaybe<Array<OdProtosCabinetData_SizeModifierInput>>;
};

export type OdProtosAbraV0Services_GetAssessmentByAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetAssessmentHandoffsFiltersInput = {
  taskHandoffIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAbraV0Services_GetAssessmentHandoffsRequestInput = {
  filters?: InputMaybe<OdProtosAbraV0Services_GetAssessmentHandoffsFiltersInput>;
};

export type OdProtosAbraV0Services_GetAssessmentReviewRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetAvailableBookingSlotsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  processStep?: InputMaybe<OdProtosAbraV0Data_ProcessStep>;
};

export type OdProtosAbraV0Services_GetAvailableBookingTimesRequestInput = {
  inspectionOrderReference?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetCompletedAssessmentStepsRequestInput = {
  /**
   * In the future we can add the different steps here.
   * So that the caller can specify which steps they are interested in.
   */
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetCurrentRepairScopesForFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetHomeRiskFactorsByHomeRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetHumanReadableAssessmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetIsHomeQualifiedForVirtualExteriorAssessmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  isHomebuilderLead?: InputMaybe<Scalars['Boolean']['input']>;
  preferredHomeDetailIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAbraV0Services_GetLatestInspectionReportsRequestInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetOnsiteAssessmentTaskTypesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAbraV0Services_GetOrderForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetOrderForVisitRequestInput = {
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetOrderLimitationsRequestInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetOrdersForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  statusesIn?: InputMaybe<Array<OdProtosAbraV0Data_OrderStatus>>;
};

export type OdProtosAbraV0Services_GetOrdersForOfferRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  statusesIn?: InputMaybe<Array<OdProtosAbraV0Data_OrderStatus>>;
};

export type OdProtosAbraV0Services_GetPostContractDiligenceAddendumByExternalIdRequestInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetPostContractDiligenceAddendumRequestInput = {
  postContractDiligenceReviewId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetPostContractDiligenceReviewRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetPostDvScopesTotalRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetRepairScopeSuggestionsRequestInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_GetRepairScopesByAddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  originIn?: InputMaybe<Array<OdProtosAbraV0Data_RepairScopeOrigin>>;
};

export type OdProtosAbraV0Services_GetRepairScopesByHomeRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  originIn?: InputMaybe<Array<OdProtosAbraV0Data_RepairScopeOrigin>>;
};

export type OdProtosAbraV0Services_GetRepairScopesSnapshotsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OdProtosAbraV0Services_RepairScopeSnapshotFiltersInput>;
};

export type OdProtosAbraV0Services_GetRepairScopesTotalFiltersInput = {
  originIn?: InputMaybe<Array<OdProtosAbraV0Data_RepairScopeOrigin>>;
  snapshotTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosAbraV0Services_GetRepairScopesTotalRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OdProtosAbraV0Services_GetRepairScopesTotalFiltersInput>;
};

export type OdProtosAbraV0Services_GetTimeSlotsForAssessmentProcessStepRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  processStep?: InputMaybe<OdProtosAbraV0Data_AssessmentProcessStep>;
};

export type OdProtosAbraV0Services_GetVisitsForInspectionRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  processStep?: InputMaybe<OdProtosAbraV0Data_ProcessStep>;
};

export type OdProtosAbraV0Services_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAbraV0Services_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_IsAssessmentCompletedRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  completionCutoffDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * ignore_pending true means we return is completed true
   * even if there are oustanding parts of the assessment
   * e.g ignore_pending: true
   * Interior & Exterior submitted means completed
   * If an interior and an exterior are submitted it will return true
   * even if there is another interior that is not submitted
   */
  ignorePending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAbraV0Services_IsAssessmentReviewPerformedInAbraRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_IsDiligenceInspectionCompletedRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_ListAssessmentScopeCostsForAddressesRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAbraV0Services_MockAssessmentTaskForFlipRequestInput = {
  copyFromTaskId?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  ownedByHumanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_RegenerateAddendumReasoningRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  refetchInput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAbraV0Services_RepairScopeSnapshotFiltersInput = {
  excludeDeletedSnapshots?: InputMaybe<Scalars['Boolean']['input']>;
  originIn?: InputMaybe<Array<OdProtosAbraV0Data_RepairScopeOrigin>>;
};

export type OdProtosAbraV0Services_RepostShowingRequestInput = {
  allowConfirmedRepost?: InputMaybe<Scalars['Boolean']['input']>;
  newPriceDollars?: InputMaybe<Scalars['Float']['input']>;
  showingId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_RequestSpecialtyInspectionRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  inspectionType?: InputMaybe<Scalars['String']['input']>;
  visitSchedulingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_RescheduleExpertAssessmentHandoffRequestInput = {
  handoffId?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** TODO: deprecate, use UpdateInspectionOrder instead */
export type OdProtosAbraV0Services_RescheduleInspectionOrderRequestInput = {
  bookingTime?: InputMaybe<Scalars['DateTime']['input']>;
  inspectionOrderReference?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** updates only present fields */
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
};

export type OdProtosAbraV0Services_RestoreDeletedRepairScopeRequestInput = {
  repairScopeId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_ReviewAssessmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  adminUrl?: InputMaybe<Scalars['String']['input']>;
  ccOnSpecialtyInspection?: InputMaybe<Array<Scalars['String']['input']>>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_SelectBookingSlotRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  bookingSlot?: InputMaybe<OdProtosAbraV0Data_BookingSlotInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
  processStep?: InputMaybe<OdProtosAbraV0Data_ProcessStep>;
};

export type OdProtosAbraV0Services_SelectBookingTimeRequestInput = {
  bookingTime?: InputMaybe<Scalars['DateTime']['input']>;
  inspectionOrderReference?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
};

export type OdProtosAbraV0Services_SendPostContractDiligenceAddendumRequestInput = {
  addendumId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_TriggerAssessmentCompletionNotificationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  scopingTaskType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_TriggerConditionScopingRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  rubricReportId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_TriggerHomeInspectionDiligenceScopingCompletionRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_TriggerInspectifyReportsHandlingRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  cubicasaReportId?: InputMaybe<Scalars['String']['input']>;
  homeInspectionReportId?: InputMaybe<Scalars['String']['input']>;
  /** Optional: if not provided new visit will be created */
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAbraV0Services_UpdateInspectionOrderRequestInput = {
  bookingTime?: InputMaybe<Scalars['DateTime']['input']>;
  inspectionOrderReference?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** updates only present fields */
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
};

/** The non null values will be updated */
export type OdProtosAbraV0Services_UpdateRepairScopeRequestInput = {
  areaId?: InputMaybe<Scalars['String']['input']>;
  defectId?: InputMaybe<Scalars['String']['input']>;
  deferred?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosAbraV0Data_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosAbraV0Data_MaterialCostInput>;
  origin?: InputMaybe<OdProtosAbraV0Data_RepairScopeOrigin>;
  updatedFromSource?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosAbraV0Services_WalkApprovedRequestInput = {
  casaId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosAbraV0Services_WalkProposedRequestInput = {
  casaId?: InputMaybe<Scalars['String']['input']>;
  proposerHumanToken?: InputMaybe<Scalars['String']['input']>;
  resolutionUrl?: InputMaybe<Scalars['String']['input']>;
  walkDetails?: InputMaybe<Scalars['String']['input']>;
  walkReason?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosAbraV0Services_WalkRejectedRequestInput = {
  casaId?: InputMaybe<Scalars['String']['input']>;
  isBudgetReviewNeeded?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Type enumerates the kinds of offer types that can be accepted by a property
 * owner.
 */
export enum OdProtosAcceptedOfferTypeData_Type {
  /**
   * The property is accepting backup offers, as it currently has a committed
   * buyer.
   */
  BACKUP = 'BACKUP',
  /**
   * A qualified offer may buy the property instantly at a set "Buy it now"
   * price
   */
  BUY_IT_NOW = 'BUY_IT_NOW',
  /**
   * The property owner is collecting competing offers which it will examine on
   * a set deadline.
   */
  HIGHEST_AND_BEST = 'HIGHEST_AND_BEST',
  /**
   * Offers to purchase the property at a price chosen by the buyer may be
   * submitted which will be considered by property owner and responded to
   */
  NEGOTIABLE = 'NEGOTIABLE',
  UNKNOWN_ACCEPTED_OFFER_TYPE = 'UNKNOWN_ACCEPTED_OFFER_TYPE'
}

export type OdProtosAccountingData_JournalEntryInput = {
  currency?: InputMaybe<Scalars['Float']['input']>;
  line?: InputMaybe<OdProtosAccountingData_LineInput>;
  memoHeader?: InputMaybe<Scalars['String']['input']>;
  postingDate?: InputMaybe<Scalars['DateTime']['input']>;
  refNumber?: InputMaybe<Scalars['Float']['input']>;
  reversalDate?: InputMaybe<Scalars['DateTime']['input']>;
  subsidiary?: InputMaybe<Scalars['Float']['input']>;
  unitsType?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosAccountingData_LineInput = {
  items?: InputMaybe<Array<OdProtosAccountingData_LineItemInput>>;
};

export type OdProtosAccountingData_LineItemInput = {
  account?: InputMaybe<Scalars['Float']['input']>;
  accountingBucket?: InputMaybe<Scalars['Float']['input']>;
  customer?: InputMaybe<Scalars['Float']['input']>;
  debit?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['Float']['input']>;
  fileNumber?: InputMaybe<Scalars['Float']['input']>;
  inactiveToken?: InputMaybe<Scalars['Float']['input']>;
  market?: InputMaybe<Scalars['Float']['input']>;
  memoLine?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['Float']['input']>;
  vendor?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosAccountingServices_CreateSynchronizationJobRequestInput = {
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAccountingServices_PostJournalEntryRequestInput = {
  endpoint?: InputMaybe<Scalars['String']['input']>;
  journalEntry?: InputMaybe<OdProtosAccountingData_JournalEntryInput>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAccountingServices_RetryNetsuitePostRequestInput = {
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 7 */
export type OdProtosAcquisitionServices_GetListedPriceCeilingRequestInput = {
  /** Address of the property to compute the listed price ceiling for. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Market that the property belongs to. */
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Time at which we want to evaluate the listed price ceiling. */
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Whether to use the dynamic DOM rules. */
  useDom?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Valuation of the property post repairs. This is usually the OVM valuation
   * at offer time and an ensembled valuation at underwriting time.
   */
  valuationPostRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 27 */
export type OdProtosAcquisitionServices_GetNetCashPresentationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Date, to the best of our knowledge, that the offer will be sent on */
  asOfDate?: InputMaybe<OdProtosCommon_DateInput>;
  /**
   * Additional credit line item that will impact fee (and consequently
   * margin). Expressed as a percentage of valuation
   */
  creditCustomOfferAdjustmentPercentage?: InputMaybe<Scalars['Float']['input']>;
  /**
   * This is used to set fee based on experiment treatment
   * DEPRECATED: No longer used. The continuous net cash experiment has ended.
   */
  experimentFlags?: InputMaybe<OdProtosPricesAcquisitionData_FeeExperimentFlagsInput>;
  /** Overrides */
  feeOverrides?: InputMaybe<OdProtosPricesAcquisitionData_FeeOverridesInput>;
  /** A recent presentation that may be used in grandfathering logic. */
  grandfatheredPresentation?: InputMaybe<OdProtosAcquisitionServices_GrandfatheredPresentationInput>;
  /** True if the offer relevant to this request is part of Opendoor Exclusives */
  inExclusiveOffers?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the offer is eligible for CashPlus/SellWithUpside */
  isSellWithUpsideEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** DEPRECATED: Net cash presentation no longer uses LGM overrides. */
  lgmOverride?: InputMaybe<OdProtosAcquisitionServices_LgmOverrideInput>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Homebuilder partner if any. Deprecated in favor of partner_referrals */
  partner?: InputMaybe<OdProtosPricesCommon_Partner>;
  /** The partners that referred this lead */
  partnerReferrals?: InputMaybe<Array<OdProtosPricesCommon_PartnerReferralInput>>;
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  postValuationAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetNetCashPresentationRequest_PostValuationAdjustmentLineItemsEntryInput>>;
  /** The net cash in cents from the prelim offer NCP. May be used to calculate the RFO adjustment. */
  prelimOfferNetCashCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Selects which pricing graph to use */
  pricingType?: InputMaybe<OdProtosAcquisitionServices_PricingType>;
  /** This is used as an input to calculate addendum */
  repairsCharge?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** This is used as an input to calculate addendum */
  subsidySellerCx?: InputMaybe<OdProtosCommon_MoneyInput>;
  targetInternalFee?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** This is used as an input to determining a cap on homebuilder partner subsidy */
  targetLeveredGrossMargin?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** `OdProtosAcquisitionServices_GetNetCashPresentationRequest_PostValuationAdjustmentLineItemsEntryInput` represents the `post_valuation_adjustment_line_items` map in `od_protos.acquisition.services.GetNetCashPresentationRequest`. */
export type OdProtosAcquisitionServices_GetNetCashPresentationRequest_PostValuationAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 32 */
export type OdProtosAcquisitionServices_GetTargetNetCashRequestInput = {
  /**
   * The Abacus fee version to use, defaults to the latest version. This should
   * only be used in special circumstances as we always want to use the latest
   * version of fees in production. If we want to grandfather (i.e. freeze) an
   * earlier fee, then we should add a subsidy for the difference, e.g. see
   * GrandfatheredPresentation.
   */
  abacusVersion?: InputMaybe<Scalars['String']['input']>;
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Date, to the best of our knowledge, that the offer will be sent on */
  asOfDate?: InputMaybe<OdProtosCommon_DateInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  /** Coefficients for days to pend adjustments */
  daysToPendAdjustmentCoefficients?: InputMaybe<Array<OdProtosAcquisitionServices_GetTargetNetCashRequest_DaysToPendAdjustmentCoefficientsEntryInput>>;
  /** Type of Dwelling ('single_family', 'apartment', etc.) */
  dwellingTypeLabel?: InputMaybe<Scalars['String']['input']>;
  enableNsc?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * This is used to set fee based on experiment treatment
   * DEPRECATED: No longer used. The continuous net cash experiment has ended.
   */
  experimentFlags?: InputMaybe<OdProtosPricesAcquisitionData_FeeExperimentFlagsInput>;
  /** Whether or not the home is part of a Homeowners Association (HOA) */
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  includeOfferBuffers?: InputMaybe<Scalars['Boolean']['input']>;
  /** An override for LGM */
  lgmOverride?: InputMaybe<OdProtosAcquisitionServices_LgmOverrideInput>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Allow passing NSC from external system */
  nscOverrideCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** The partners that referred this lead */
  partnerReferrals?: InputMaybe<Array<OdProtosPricesCommon_PartnerReferralInput>>;
  /** Whether or not the home has a private pool */
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  /** Line items used when calculating baseline net cash post inspection */
  postInspectionLineItems?: InputMaybe<OdProtosAcquisitionServices_PostInspectionLineItemsInput>;
  /** Valuation after repairs */
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  postValuationAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetTargetNetCashRequest_PostValuationAdjustmentLineItemsEntryInput>>;
  /** Selects which pricing graph to use */
  pricingType?: InputMaybe<OdProtosAcquisitionServices_PricingType>;
  sqFt?: InputMaybe<Scalars['Float']['input']>;
  /** Address information for geo-based constants. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Individual adjustments that affect val gain, to be summed into total valgain in Abacus */
  valGainAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetTargetNetCashRequest_ValGainAdjustmentLineItemsEntryInput>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosAcquisitionServices_GetTargetNetCashRequest_DaysToPendAdjustmentCoefficientsEntryInput` represents the `days_to_pend_adjustment_coefficients` map in `od_protos.acquisition.services.GetTargetNetCashRequest`. */
export type OdProtosAcquisitionServices_GetTargetNetCashRequest_DaysToPendAdjustmentCoefficientsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** `OdProtosAcquisitionServices_GetTargetNetCashRequest_PostValuationAdjustmentLineItemsEntryInput` represents the `post_valuation_adjustment_line_items` map in `od_protos.acquisition.services.GetTargetNetCashRequest`. */
export type OdProtosAcquisitionServices_GetTargetNetCashRequest_PostValuationAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** `OdProtosAcquisitionServices_GetTargetNetCashRequest_ValGainAdjustmentLineItemsEntryInput` represents the `val_gain_adjustment_line_items` map in `od_protos.acquisition.services.GetTargetNetCashRequest`. */
export type OdProtosAcquisitionServices_GetTargetNetCashRequest_ValGainAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 36 */
export type OdProtosAcquisitionServices_GetUnitEconomicsRequestInput = {
  abacusVersion?: InputMaybe<Scalars['String']['input']>;
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Date, to the best of our knowledge, that the offer will be sent on */
  asOfDate?: InputMaybe<OdProtosCommon_DateInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  /** Coefficients for days to pend adjustments */
  daysToPendAdjustmentCoefficients?: InputMaybe<Array<OdProtosAcquisitionServices_GetUnitEconomicsRequest_DaysToPendAdjustmentCoefficientsEntryInput>>;
  /** Type of Dwelling ('single_family', 'apartment', etc.) */
  dwellingTypeLabel?: InputMaybe<Scalars['String']['input']>;
  enableNsc?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * This is used to set fee based on experiment treatment
   * DEPRECATED: No longer used. The continuous net cash experiment has ended.
   */
  experimentFlags?: InputMaybe<OdProtosPricesAcquisitionData_FeeExperimentFlagsInput>;
  /** The list of credits and subsidies that were applied, e.g. rounding, flooring */
  feeAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_LineItemInput>>;
  /** Whether or not the home is part of a Homeowners Association (HOA) */
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  includeOfferBuffers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Internal fee cents */
  internalFeeCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** An override for LGM */
  lgmOverride?: InputMaybe<OdProtosAcquisitionServices_LgmOverrideInput>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Allows the skipping of negative selection charge calculation */
  nscOverrideCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Whether or not the home has a private pool */
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  /** Line items used when calculating unit economics post inspection */
  postInspectionLineItems?: InputMaybe<OdProtosAcquisitionServices_PostInspectionLineItemsInput>;
  /** Valuation after repairs */
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  postValuationAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetUnitEconomicsRequest_PostValuationAdjustmentLineItemsEntryInput>>;
  /** Selects which pricing graph to use */
  pricingType?: InputMaybe<OdProtosAcquisitionServices_PricingType>;
  sqFt?: InputMaybe<Scalars['Float']['input']>;
  /** Geo details about the property */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Individual adjustments that affect valgain, to be summed into total valgain in Abacus */
  valGainAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetUnitEconomicsRequest_ValGainAdjustmentLineItemsEntryInput>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosAcquisitionServices_GetUnitEconomicsRequest_DaysToPendAdjustmentCoefficientsEntryInput` represents the `days_to_pend_adjustment_coefficients` map in `od_protos.acquisition.services.GetUnitEconomicsRequest`. */
export type OdProtosAcquisitionServices_GetUnitEconomicsRequest_DaysToPendAdjustmentCoefficientsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** `OdProtosAcquisitionServices_GetUnitEconomicsRequest_PostValuationAdjustmentLineItemsEntryInput` represents the `post_valuation_adjustment_line_items` map in `od_protos.acquisition.services.GetUnitEconomicsRequest`. */
export type OdProtosAcquisitionServices_GetUnitEconomicsRequest_PostValuationAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** `OdProtosAcquisitionServices_GetUnitEconomicsRequest_ValGainAdjustmentLineItemsEntryInput` represents the `val_gain_adjustment_line_items` map in `od_protos.acquisition.services.GetUnitEconomicsRequest`. */
export type OdProtosAcquisitionServices_GetUnitEconomicsRequest_ValGainAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 10 */
export type OdProtosAcquisitionServices_GrandfatheredPresentationInput = {
  /**
   * Additional charge that gets added to the purchase and sale agreement
   * This field is just like addendum in GetNetCashPresentationResponse below.
   */
  addendum?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** When the original presentation was produced. */
  asOfDate?: InputMaybe<OdProtosCommon_DateInput>;
  /**
   * The fee we will show the customer (modulo co-broke)
   * This field is just like external_fee in GetNetCashPresentationResponse below.
   */
  externalFee?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * The price we show the customer (aka headline price).
   * This field is just like external_price in GetNetCashPresentationResponse below.
   */
  externalPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * The list of credits and subsidies that were applied, e.g. rounding, flooring
   * This field is just like fee_adjustment_line_items in GetNetCashPresentationResponse below.
   */
  feeAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_LineItemInput>>;
  internalFee?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Specifies how acquisition should handle this `GrandfatheredPresentation`. */
  policy?: InputMaybe<OdProtosAcquisitionServices_GrandfatheredPresentation_GrandfatheringPolicy>;
  postValuationAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GrandfatheredPresentation_PostValuationAdjustmentLineItemsEntryInput>>;
  valuationPostRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export enum OdProtosAcquisitionServices_GrandfatheredPresentation_GrandfatheringPolicy {
  /**
   * Get difference of post-UW net cash and prelim net cash. If difference > 0, take
   * some percentage (efo_inertia_percentage) of this increase as a fee on final offer.
   * @deprecated No longer supported
   */
  ENGAGEMENT_OPTIMIZED_FINAL_OFFER = 'ENGAGEMENT_OPTIMIZED_FINAL_OFFER',
  /**
   * Keep the same external price and fee from prelim offer at underwriting time.
   * @deprecated No longer supported
   */
  GUARANTEE_AT_PRELIM_OFFER = 'GUARANTEE_AT_PRELIM_OFFER',
  /**
   * Keep the same internal fee less post valuation adjustments (e.g. risk
   * based pricing, listed price ceiling, etc) from prelim offer at
   * underwriting time.
   * @deprecated No longer supported
   */
  OFFER_TO_UW_INTERNAL_FEE_LESS_POST_VAL_ADJUSTMENTS = 'OFFER_TO_UW_INTERNAL_FEE_LESS_POST_VAL_ADJUSTMENTS',
  /** Re-use the external_price and external_fee. Compute addendum like normal. */
  PRESERVE_EXTERNAL_PRICE_AND_EXTERNAL_FEE_RECALCULATE_ADDENDUM = 'PRESERVE_EXTERNAL_PRICE_AND_EXTERNAL_FEE_RECALCULATE_ADDENDUM',
  UNKNOWN = 'UNKNOWN'
}

/** `OdProtosAcquisitionServices_GrandfatheredPresentation_PostValuationAdjustmentLineItemsEntryInput` represents the `post_valuation_adjustment_line_items` map in `od_protos.acquisition.services.GrandfatheredPresentation`. */
export type OdProtosAcquisitionServices_GrandfatheredPresentation_PostValuationAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 3 */
export type OdProtosAcquisitionServices_LgmOverrideInput = {
  /**
   * Determines if we apply the override post-NCP adjustments (rounding, flooring, etc.).
   * Null by default, implying we'll apply pre-adjustments if unset.
   * DEPRECATED: This field is no longer used. Adjustments are now always applied.
   */
  applyPostAdjustments?: InputMaybe<Scalars['Boolean']['input']>;
  /** An override for our target LGM */
  overrideBps?: InputMaybe<Scalars['Int']['input']>;
};

/** Next ID: 4 */
export type OdProtosAcquisitionServices_LineItemInput = {
  account?: InputMaybe<Array<Scalars['String']['input']>>;
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 13 */
export type OdProtosAcquisitionServices_PostInspectionLineItemsInput = {
  costNitpickyRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** "predicted" because a model determines this estimate */
  costPredictedBrn?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** "predicted" because a model determines this estimate */
  costPredictedPostlistRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  costPrelims?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Today, this is essentially postlist repairs + BRN */
  costScopedDeferredRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * TODO: We should begin using/reading prelist, postlist, and BRN rather than
   * cost_scoped_immediate_repairs and cost_scoped_deferred_repairs
   *
   * Today, this is essentially prelist repairs
   */
  costScopedImmediateRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * "scoped" because humans determine this estimate, though it will be ensembled with model
   * predictions in the future
   */
  costScopedPrelistRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  costScopedRenovations?: InputMaybe<OdProtosCommon_MoneyInput>;
  scopedSellerRepairsCharge?: InputMaybe<OdProtosCommon_MoneyInput>;
  subsidySellerCx?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export enum OdProtosAcquisitionServices_PricingType {
  DEFAULT = 'DEFAULT',
  LENNAR_PILOT = 'LENNAR_PILOT',
  ONLINE_REAL_ESTATE = 'ONLINE_REAL_ESTATE',
  UNDERWRITTEN_OUTBOUNDS = 'UNDERWRITTEN_OUTBOUNDS'
}

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingData_DirectOverrideInput = {
  ci50Margin?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<OdProtosCommon_MoneyInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosAcquisitionUnderwritingData_LgmOverrideInput = {
  bps?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Decision data for Pricing Decision tasks.
 *
 * Next ID: 4
 */
export type OdProtosAcquisitionUnderwritingData_PricingDecisionInput = {
  decision?: InputMaybe<OdProtosAcquisitionUnderwritingData_PricingDecision_DecisionOneofInput>;
};

export type OdProtosAcquisitionUnderwritingData_PricingDecision_DecisionOneofInput = {
  pricingAdjustment?: InputMaybe<OdProtosAcquisitionUnderwritingData_PricingDecision_PricingAdjustmentInput>;
  skip?: InputMaybe<OdProtosAcquisitionUnderwritingData_PricingDecision_SkipInput>;
  walk?: InputMaybe<OdProtosAcquisitionUnderwritingData_WalkInput>;
};

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingData_PricingDecision_PricingAdjustmentInput = {
  directOverride?: InputMaybe<OdProtosAcquisitionUnderwritingData_DirectOverrideInput>;
  lgmOverride?: InputMaybe<OdProtosAcquisitionUnderwritingData_LgmOverrideInput>;
  valGainAdjustment?: InputMaybe<OdProtosAcquisitionUnderwritingData_ValGainAdjustmentInput>;
};

export type OdProtosAcquisitionUnderwritingData_PricingDecision_SkipInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 3 */
export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcomeInput = {
  outcome?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_OutcomeOneofInput>;
};

export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_OutcomeOneofInput = {
  /** we can proceed to next steps */
  proceed?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_ProceedInput>;
  /** underwriting completed with an accepted walk */
  walk?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_WalkInput>;
};

export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_ProceedInput = {
  eligibility?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_Proceed_EligibilityInput>;
};

export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_Proceed_EligibilityInput = {
  listWithOpendoor?: InputMaybe<Scalars['Boolean']['input']>;
  sellDirect?: InputMaybe<Scalars['Boolean']['input']>;
  sellWithUpside?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_WalkInput = {
  proposalDetails?: InputMaybe<Scalars['String']['input']>;
  proposalReason?: InputMaybe<Scalars['String']['input']>;
  resolutionNote?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosPricingData_WalkResolutionType>;
};

/** Next ID: 2 */
export type OdProtosAcquisitionUnderwritingData_ValGainAdjustmentInput = {
  /** additive to our valgain projection, not a complete override */
  bps?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 3 */
export type OdProtosAcquisitionUnderwritingData_WalkInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  walkProposalId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_CancelUnderwritingRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_CancelUnderwritingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_ComputeUnderwritingOutcomeRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_ComputeUnderwritingOutcomeResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 6 */
export type OdProtosAcquisitionUnderwritingServices_CreateUnderwritingWalkRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  proposal?: InputMaybe<OdProtosPricingData_WalkProposalInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  resolution?: InputMaybe<OdProtosPricingData_WalkResolutionInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_CreateUnderwritingWalkResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_CreateWalkProposalRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  walkProposal?: InputMaybe<OdProtosPricingData_WalkProposalInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_CreateWalkProposalResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionDirectOverrideValuationRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  overrideValuationCi50margin?: InputMaybe<Scalars['Float']['input']>;
  overrideValuationPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  valuatorToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionDirectOverrideValuationResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  walkResolution?: InputMaybe<OdProtosPricingData_WalkResolutionInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionTaskRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionTaskResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetEngagementPricingsRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetEngagementRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_GetEngagementResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetPricingDecisionRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_GetPricingDecisionResponse_Error_Code {
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetSubEngagementRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_GetSubEngagementResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetWalkProposalsRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

/** Next ID: 10 */
export type OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesRequestInput = {
  /** Required only when lgm_override is set without direct_override. */
  baseValuation?: InputMaybe<OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesRequest_BaseValuationOneofInput>;
  directOverride?: InputMaybe<OdProtosAcquisitionUnderwritingData_DirectOverrideInput>;
  humanToken?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lgmOverride?: InputMaybe<OdProtosAcquisitionUnderwritingData_LgmOverrideInput>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesRequest_BaseValuationOneofInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
  singleValuationId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceCreationRequestInput = {
  camundaProcessInstance?: InputMaybe<OdProtosPricingData_CamundaProcessInstanceInput>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceCreationResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceFinishRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceFinishResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 6 */
export type OdProtosAcquisitionUnderwritingServices_RecordEngagementCompletedRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcomeInput>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_RecordEngagementCompletedResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 7 */
export type OdProtosAcquisitionUnderwritingServices_RecordEngagementPricingRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  webUnitEconomicId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAcquisitionUnderwritingServices_RecordEngagementPricingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 8 */
export type OdProtosAcquisitionUnderwritingServices_RecordNewEngagementRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Mock configurations, if present, will short-circuit the process */
  mockConfiguration?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwritingInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_RecordNewEngagementResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 16 */
export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** PE ID for the overaching UW property engagement (which is triggering this sub engagement) */
  parentPropertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Typically, you should not set this field and one will be idempotently generated by the server.
   * This field is left available for testing purposes (temporarily).
   */
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  subEngagement?: InputMaybe<OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneofInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_EnsembledValuationArgsInput = {
  /**
   * Temporary flag — when true, web consumer skips ensembled valuation and Casey task creation.
   * Will be removed once all workflows use the AUS-managed path.
   */
  ausManaged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_OverrideValuationArgsInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_PreRenoValuationArgsInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_PricingDecisionArgsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneofInput = {
  dataLabeling?: InputMaybe<GoogleProtobuf_EmptyInput>;
  ensembledValuation?: InputMaybe<OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_EnsembledValuationArgsInput>;
  lgmReview?: InputMaybe<GoogleProtobuf_EmptyInput>;
  overrideValuation?: InputMaybe<OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_OverrideValuationArgsInput>;
  postRenoValuation?: InputMaybe<GoogleProtobuf_EmptyInput>;
  preRenoValuation?: InputMaybe<OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_PreRenoValuationArgsInput>;
  pricingDecision?: InputMaybe<OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_PricingDecisionArgsInput>;
  repairBudgetReview?: InputMaybe<GoogleProtobuf_EmptyInput>;
  riskAssessment?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_RecordSubEngagementCompletedRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** PE ID of the sub engagement */
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_RecordSubEngagementCompletedResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_RecordSubEngagementStoppedRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** PE ID of the sub engagement */
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_RecordSubEngagementStoppedResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 7 */
export type OdProtosAcquisitionUnderwritingServices_ResolvePricingDecisionRequestInput = {
  decision?: InputMaybe<OdProtosAcquisitionUnderwritingData_PricingDecisionInput>;
  humanToken?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_ResolvePricingDecisionResponse_Error_Code {
  ALREADY_RESOLVED = 'ALREADY_RESOLVED',
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 10 */
export type OdProtosAcquisitionUnderwritingServices_StartUnderwritingRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  executionTiming?: InputMaybe<OdProtosPricingData_UnderwritingExecutionTiming>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  inputContext?: InputMaybe<OdProtosPricingData_UnderwritingInputContext>;
  mockConfiguration?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwritingInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_TerminatePropertyEngagementRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosAcquisitionUnderwritingServices_TerminatePropertyEngagementResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosAddressParserServices_AddressIdentifierInput = {
  /** String that will be parsed for address components. */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAddressParserServices_ParseRequestInput = {
  addressIdentifiers?: InputMaybe<Array<OdProtosAddressParserServices_AddressIdentifierInput>>;
};

export enum OdProtosAdmiralData_AttributedEvent_UserAssociationReason {
  CODELESS_UNLOCK = 'CODELESS_UNLOCK',
  CODE_HANDOUT = 'CODE_HANDOUT',
  UNKNOWN_ASSOCIATION_REASON = 'UNKNOWN_ASSOCIATION_REASON'
}

export enum OdProtosAdmiralData_AttributedEvent_UserType {
  CUSTOMER = 'CUSTOMER',
  EMPLOYEE = 'EMPLOYEE',
  SECURITY = 'SECURITY',
  UNKNOWN_USER_TYPE = 'UNKNOWN_USER_TYPE',
  VENDOR = 'VENDOR'
}

export enum OdProtosAdmiralData_ConnectivityRating {
  BAD = 'BAD',
  GOOD = 'GOOD',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosAdmiralData_DeviceInstallFeedbackInput = {
  deviceNotInstalledReason?: InputMaybe<Scalars['String']['input']>;
  installationSchemaDeviceId?: InputMaybe<Scalars['Float']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

/** Structured input reasons that say why a device schema is non-default */
export enum OdProtosAdmiralData_DeviceSchema_Reason {
  ELEVATED_HOME_RISK = 'ELEVATED_HOME_RISK'
}

export type OdProtosAdmiralData_DeviceTeardownFeedbackInput = {
  deviceNotTornDownReason?: InputMaybe<Scalars['String']['input']>;
  installationSchemaDeviceId?: InputMaybe<Scalars['Float']['input']>;
  tornDown?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosAdmiralData_EventKind {
  CAMERA_MOTION_DETECTED = 'CAMERA_MOTION_DETECTED',
  /**
   * Contact sensor events
   * (starting at 20 to leave room for more unlock events)
   */
  CONTACT_SENSOR_BROKEN = 'CONTACT_SENSOR_BROKEN',
  CONTACT_SENSOR_CLOSED = 'CONTACT_SENSOR_CLOSED',
  CONTACT_SENSOR_LEFT_OPEN = 'CONTACT_SENSOR_LEFT_OPEN',
  DEVICE_OFFLINE = 'DEVICE_OFFLINE',
  DEVICE_ONLINE = 'DEVICE_ONLINE',
  DOOR_AUTO_LOCKED = 'DOOR_AUTO_LOCKED',
  /**
   * We get separate events for code usages from "door unlocked with code" events
   * so we'll distinguish the two with a different event kind
   */
  DOOR_CODE_USAGE = 'DOOR_CODE_USAGE',
  DOOR_JAMMED_WHILE_LOCKING = 'DOOR_JAMMED_WHILE_LOCKING',
  DOOR_JAMMED_WHILE_UNLOCKING = 'DOOR_JAMMED_WHILE_UNLOCKING',
  DOOR_LOCKED = 'DOOR_LOCKED',
  /** Door lock events */
  DOOR_LOCKED_MANUALLY = 'DOOR_LOCKED_MANUALLY',
  DOOR_LOCKED_REMOTELY = 'DOOR_LOCKED_REMOTELY',
  DOOR_UNLOCKED = 'DOOR_UNLOCKED',
  DOOR_UNLOCKED_MANUALLY = 'DOOR_UNLOCKED_MANUALLY',
  /** Door unlocks */
  DOOR_UNLOCKED_REMOTELY = 'DOOR_UNLOCKED_REMOTELY',
  DOOR_UNLOCKED_WITH_CODE = 'DOOR_UNLOCKED_WITH_CODE',
  DOOR_UNLOCK_EXCEEDED_ATTEMPTS = 'DOOR_UNLOCK_EXCEEDED_ATTEMPTS',
  EVENT_KIND_UNKNOWN = 'EVENT_KIND_UNKNOWN',
  HUB_OFFLINE = 'HUB_OFFLINE',
  HUB_ONLINE = 'HUB_ONLINE',
  LOW_BATTERY_ALERT = 'LOW_BATTERY_ALERT',
  /** Motion events */
  MOTION_DETECTED = 'MOTION_DETECTED',
  MOTION_STOPPED = 'MOTION_STOPPED',
  TAMPER = 'TAMPER',
  TEMPERATURE_ALERT = 'TEMPERATURE_ALERT',
  /** General device events */
  TEMPERATURE_READING = 'TEMPERATURE_READING'
}

export enum OdProtosAdmiralData_EventType {
  BATTERY_EVENT = 'BATTERY_EVENT',
  CONTACT_SENSOR_EVENT = 'CONTACT_SENSOR_EVENT',
  DEVICE_CONNECTIVITY_EVENT = 'DEVICE_CONNECTIVITY_EVENT',
  DOOR_LOCK_EVENT = 'DOOR_LOCK_EVENT',
  DOOR_UNLOCK_EVENT = 'DOOR_UNLOCK_EVENT',
  EVENT_TYPE_UNKNOWN = 'EVENT_TYPE_UNKNOWN',
  HUB_CONNECTIVITY_EVENT = 'HUB_CONNECTIVITY_EVENT',
  MOTION_EVENT = 'MOTION_EVENT',
  TAMPER_EVENT = 'TAMPER_EVENT',
  TEMPERATURE_EVENT = 'TEMPERATURE_EVENT'
}

/** Structured input reasons that say why a device schema is non-default */
export enum OdProtosAdmiralData_ExpectedDevice_Reason {
  CAMERA_EXPERIMENT = 'CAMERA_EXPERIMENT',
  DEFAULT = 'DEFAULT',
  ELEVATED_HOME_RISK = 'ELEVATED_HOME_RISK',
  SIGNAGE_EXPERIMENT = 'SIGNAGE_EXPERIMENT',
  SMART_BULB_EXPERIMENT = 'SMART_BULB_EXPERIMENT'
}

export enum OdProtosAdmiralData_ExpectedDevice_Type {
  CAMERA = 'CAMERA',
  CONTACT_SENSOR = 'CONTACT_SENSOR',
  DOOR_LOCK = 'DOOR_LOCK',
  MOTION_SENSOR = 'MOTION_SENSOR',
  SECURITY_SIGNAGE = 'SECURITY_SIGNAGE',
  SIREN = 'SIREN',
  SMART_BULB = 'SMART_BULB',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosAdmiralData_HomeAccessMethod {
  ACCESS_METHOD_DOOR_CODE = 'ACCESS_METHOD_DOOR_CODE',
  ACCESS_METHOD_LOCKBOX = 'ACCESS_METHOD_LOCKBOX',
  ACCESS_METHOD_MARKET_CODE = 'ACCESS_METHOD_MARKET_CODE',
  ACCESS_METHOD_REMOTE_UNLOCK = 'ACCESS_METHOD_REMOTE_UNLOCK',
  ACCESS_METHOD_ROTATING_CODE = 'ACCESS_METHOD_ROTATING_CODE',
  ACCESS_METHOD_STATIC_CODE = 'ACCESS_METHOD_STATIC_CODE',
  ACCESS_METHOD_VENDOR_CODE = 'ACCESS_METHOD_VENDOR_CODE'
}

export enum OdProtosAdmiralData_HomeAccessUserType {
  CUSTOMER = 'CUSTOMER',
  EMPLOYEE = 'EMPLOYEE',
  SECURITY = 'SECURITY',
  UNKNOWN_USER_TYPE = 'UNKNOWN_USER_TYPE',
  VENDOR = 'VENDOR'
}

/** Next ID: 4 */
export type OdProtosAdmiralData_HubParamsInput = {
  certificateId?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralData_InstallationReportV2ParamsInput = {
  fleetUuid?: InputMaybe<Scalars['String']['input']>;
  issueFilter?: InputMaybe<OdProtosAdmiralData_InstallationReportV2Params_IssueFilter>;
  troubleReportType?: InputMaybe<OdProtosAdmiralData_InstallationReportV2Params_TroubleReportType>;
};

export enum OdProtosAdmiralData_InstallationReportV2Params_IssueFilter {
  /** Filters devices with battery issues or unknown battery status */
  BATTERY = 'BATTERY',
  /** Filters any motion sensors that have a high temperature reading or unknown */
  HIGH_TEMPERATURE = 'HIGH_TEMPERATURE',
  /** Filters locks that have been jammed */
  LOCK_JAMMED = 'LOCK_JAMMED',
  /** Filters any motion sensors that have a low temperature reading or unknown */
  LOW_TEMPERATURE = 'LOW_TEMPERATURE',
  /** Returns all results without a filter */
  NO_FILTER = 'NO_FILTER',
  /** Filters devices with pairing issues or unknown pairing status */
  PAIRING = 'PAIRING',
  /** Filters silent devices that have not reported status in a while */
  SILENT = 'SILENT'
}

/** (optional) TroubleReportType allows filtering reports based on specific issue types */
export enum OdProtosAdmiralData_InstallationReportV2Params_TroubleReportType {
  ANY = 'ANY',
  HUB = 'HUB',
  LOCK = 'LOCK',
  MOTION_SENSOR = 'MOTION_SENSOR',
  NONE = 'NONE',
  SIREN = 'SIREN',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosAdmiralData_LockBoltAction {
  LOCK = 'LOCK',
  UNKNOWN_LOCK_ACTION = 'UNKNOWN_LOCK_ACTION',
  UNLOCK = 'UNLOCK'
}

export enum OdProtosAdmiralData_SirenActivationAction {
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
  UNKNOWN_SIREN_ACTION = 'UNKNOWN_SIREN_ACTION'
}

export enum OdProtosAdmiralData_SmartRentDeviceStatusFromCache_InstallationStatus {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export enum OdProtosAdmiralData_SmartRentDeviceStatusFromCache_Type {
  CAMERA = 'CAMERA',
  CONTACT_SENSOR = 'CONTACT_SENSOR',
  DOOR_LOCK = 'DOOR_LOCK',
  MOTION_SENSOR = 'MOTION_SENSOR',
  SIREN = 'SIREN',
  SMART_BULB = 'SMART_BULB',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosAdmiralData_SmartRentDeviceStatus_InstallationStatus {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export enum OdProtosAdmiralData_SmartRentDeviceStatus_Type {
  CAMERA = 'CAMERA',
  CONTACT_SENSOR = 'CONTACT_SENSOR',
  DOOR_LOCK = 'DOOR_LOCK',
  MOTION_SENSOR = 'MOTION_SENSOR',
  SIREN = 'SIREN',
  SMART_BULB = 'SMART_BULB',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosAdmiralData_SmartRentDoorCodeType {
  MARKET_CODE = 'MARKET_CODE',
  ROTATING_CODE = 'ROTATING_CODE',
  STATIC_CODE = 'STATIC_CODE',
  UNKNOWN_CODE_TYPE = 'UNKNOWN_CODE_TYPE'
}

/** SELECT DISTINCT upper(kind) FROM smartrent_events; */
export enum OdProtosAdmiralData_SmartRentEvent_EventKindTypes {
  KIND_MANUAL_UNLOCK = 'KIND_MANUAL_UNLOCK',
  KIND_MOTION = 'KIND_MOTION',
  KIND_UNSPECIFIED = 'KIND_UNSPECIFIED'
}

/** SELECT DISTINCT upper(trigger) FROM smartrent_events; */
export enum OdProtosAdmiralData_SmartRentEvent_EventTriggerTypes {
  TRIGGER_DEVICE_LOCK = 'TRIGGER_DEVICE_LOCK',
  TRIGGER_DEVICE_MOTION_SENSOR = 'TRIGGER_DEVICE_MOTION_SENSOR',
  TRIGGER_HUB_OFFLINE = 'TRIGGER_HUB_OFFLINE',
  TRIGGER_HUB_ONLINE = 'TRIGGER_HUB_ONLINE',
  TRIGGER_UNSPECIFIED = 'TRIGGER_UNSPECIFIED'
}

export enum OdProtosAdmiralData_Timeframe {
  LAST_HOUR = 'LAST_HOUR',
  LAST_NINETY_DAYS = 'LAST_NINETY_DAYS',
  LAST_SEVEN_DAYS = 'LAST_SEVEN_DAYS',
  LAST_TWENTY_EIGHT_DAYS = 'LAST_TWENTY_EIGHT_DAYS',
  LAST_TWENTY_FOUR_HOURS = 'LAST_TWENTY_FOUR_HOURS',
  MONTH_TO_DATE = 'MONTH_TO_DATE',
  NONE = 'NONE'
}

export type OdProtosAdmiralServices_AssociateRingAccountToAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  ringAccountId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosAdmiralServices_BackfillSessionEventRequestInput = {
  eventId?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_BulkSetLockboxCodesRequestInput = {
  pairs?: InputMaybe<Array<OdProtosAdmiralServices_CodePairInput>>;
};

export type OdProtosAdmiralServices_CheckHubSchemaRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  hubIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAdmiralServices_ClientType {
  CUSTOMER = 'CUSTOMER',
  HOME_ACCESS = 'HOME_ACCESS',
  HPM = 'HPM',
  NON_ACCESS = 'NON_ACCESS',
  VENDOR = 'VENDOR'
}

export type OdProtosAdmiralServices_CodePairInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_CompleteKnoxSetupRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  hubIdentifier?: InputMaybe<Scalars['String']['input']>;
  skipListingTypeChange?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Creates or updates the link between an Address UUID and a hub identifier. A partial hub identifier, as long as it's
 * unique, is acceptable.
 */
export type OdProtosAdmiralServices_CreateInstallationV2RequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  hubIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_CreateSmartrentUnitRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_DeactivateInstallationV2RequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  deleteReason?: InputMaybe<OdProtosAdmiralServices_DeleteReason>;
  hubIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAdmiralServices_DeleteReason {
  CLEANUP = 'CLEANUP',
  MANUALLY_DELETED = 'MANUALLY_DELETED',
  TEAR_DOWN = 'TEAR_DOWN',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosAdmiralServices_DeviceSchemaRequests_GetDeviceSchemaInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_GetAfterVisitingHoursRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_GetAttributedEventsRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** Get events where occurred_at < end_time descending */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  includeEventTypes?: InputMaybe<Array<OdProtosAdmiralData_EventType>>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  /** Get events where occurred_at > start_time descending */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosAdmiralServices_GetCameraReviewRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 4 */
export type OdProtosAdmiralServices_GetCustomerCodeRequestInput = {
  /** Required: UUID for the home you want to fetch a door code for */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional (but encouraged!): Client that request was sent from (buyer, scout, vendor portal) */
  client?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional (but encouraged!): the token for the customer who is requesting the code.
   * Used for attribution. Ignored if blank.
   */
  customerToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_GetDoorCodeForHubRequestInput = {
  alwaysFetchNewCode?: InputMaybe<Scalars['Boolean']['input']>;
  handedOutToToken?: InputMaybe<Scalars['String']['input']>;
  hubIdentifier?: InputMaybe<Scalars['String']['input']>;
  trippyVisitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_GetHomeAccessHistoryRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sort?: InputMaybe<OdProtosAdmiralServices_SortRequestInput>;
};

export type OdProtosAdmiralServices_GetHomeRiskAssessmentRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_GetLockboxCodeRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<OdProtosAdmiralServices_ClientType>;
  handedOutToToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_GetOrCreateDoorCodeForVendorRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  /**
   * allow_expiration_extension: if an expiration_timestamp is provided
   * and an existing code is found the expires before the desired time,
   * extend the expiration time
   */
  allowExpirationExtension?: InputMaybe<Scalars['Boolean']['input']>;
  /** expiration_timestamp: the time that this code will expire. */
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_GetSmartRentDeviceEventsRequestInput = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  smartrentDeviceIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosAdmiralServices_GetSmartRentDeviceStatusesRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosAdmiralServices_GetStaticCodeRequestInput = {
  /** Required: UUID for the home you want to fetch a door code for */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<OdProtosAdmiralServices_ClientType>;
  handedOutToToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_HubRequests_FindUniqueInput = {
  identifierPart?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_HubRequests_GetByCertificateIdInput = {
  certificateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_HubRequests_GetInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_HubRequests_ToggleHubWifiInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAdmiralServices_HubRequests_UpdateHubWifiPassphraseInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  passphrase?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_HubRequests_UpsertInput = {
  hub?: InputMaybe<OdProtosAdmiralData_HubParamsInput>;
};

export enum OdProtosAdmiralServices_HubSchemaStatus_DeviceKind {
  CRITICAL = 'CRITICAL',
  REQUIRED = 'REQUIRED'
}

export type OdProtosAdmiralServices_InstallationReportV2Requests_GetInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  params?: InputMaybe<OdProtosAdmiralData_InstallationReportV2ParamsInput>;
};

export type OdProtosAdmiralServices_InstallationRequests_GetInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_InstallationRequests_ListByAddressUuidInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_InstallationRequests_ListProtectionsInTimeRangeInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  includeShadows?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosAdmiralServices_InstallationRequests_ProtectionsForAddressInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_ListCustomerHomeAccessesRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export enum OdProtosAdmiralServices_ListCustomerHomeAccessesResponse_AccessMethod {
  DOOR_CODE = 'DOOR_CODE',
  REMOTE_UNLOCK = 'REMOTE_UNLOCK'
}

export type OdProtosAdmiralServices_ListHomeRiskAssessmentsRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAdmiralServices_ListRingAccountAssociationsRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAdmiralServices_ListRingAccountsRequestInput = {
  markets?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAdmiralServices_MergeCustomerAccessDataRequestInput = {
  mergedCustomerUuid?: InputMaybe<Scalars['String']['input']>;
  mergedIntoCustomerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_PatrolResponseRequests_GetInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosAdmiralServices_PatrolResponseRequests_ListByAddressInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_PatrolResponseRequests_UpdateInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  incidentReportId?: InputMaybe<Scalars['String']['input']>;
  reportingError?: InputMaybe<Scalars['Boolean']['input']>;
  reportingErrorReasons?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAdmiralServices_ProvideDeviceInstallationFeedbackRequestInput = {
  feedback?: InputMaybe<Array<OdProtosAdmiralData_DeviceInstallFeedbackInput>>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_ProvideDeviceTeardownFeedbackRequestInput = {
  feedback?: InputMaybe<Array<OdProtosAdmiralData_DeviceTeardownFeedbackInput>>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_ProvideKnoxInstallationFeedbackRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  connectivityRating?: InputMaybe<OdProtosAdmiralData_ConnectivityRating>;
  knoxNotInstalledReason?: InputMaybe<Scalars['String']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
  willInstallLater?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAdmiralServices_RandomizeLockCodeRequestInput = {
  /** device_identifier accepts full or partial identifiers. Admiral does not expect callers to have full identifier. */
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  slotNumber?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosAdmiralServices_ResolveCameraReviewRequestInput = {
  cameraReviewId?: InputMaybe<Scalars['Float']['input']>;
  resolution?: InputMaybe<OdProtosAdmiralServices_ResolveCameraReviewRequest_ResolutionOneofInput>;
};

export type OdProtosAdmiralServices_ResolveCameraReviewRequest_ResolutionOneofInput = {
  falseAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  incidentReportId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_SearchRequestInput = {
  /** search allows partial/full hub identifier, partial/full addressUUID, and partial/full readable address. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_SetHomeToHighRiskRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  incidentReportId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_SetLockboxCodeRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  lockboxCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_SmartrentUnitByAddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAdmiralServices_SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type OdProtosAdmiralServices_SortRequestInput = {
  direction?: InputMaybe<OdProtosAdmiralServices_SortDirection>;
};

/** Next ID: 7 */
export type OdProtosAdmiralServices_UnlockHomeRequestInput = {
  /** Optional (but encouraged!): Client that request was sent from (buyer, scout, vendor portal) */
  client?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional (but encouraged!): the token for the customer who is requesting the codeless unlock.
   * Used for attribution and analytics tracking. Ignored if blank.
   */
  customerToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional (but encouraged!): the token for the user who is requesting the codeless unlock.
   * This is meant for codeless unlock by internal users.
   * Used for attribution and analytics tracking. Ignored if blank.
   * Only needed if customer_token is blank.
   */
  humanToken?: InputMaybe<Scalars['String']['input']>;
  /** Required: identifying information for home to unlock */
  identifier?: InputMaybe<OdProtosAdmiralServices_UnlockHomeRequest_IdentifierOneofInput>;
  /**
   * The home's listing slug, only required for unlock requests that will be proxied to knox.
   * if listing_slug is provided, hub_identifier MUST also be provided
   */
  listingSlug?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAdmiralServices_UnlockHomeRequest_IdentifierOneofInput = {
  /** UUID for the home you want to unlock */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** identifier for the Hub to unlock */
  hubIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAgentDataStore_AgentVerificationStatus {
  AGENT_STATUS_DENIED = 'AGENT_STATUS_DENIED',
  AGENT_STATUS_FULLY_VERIFIED = 'AGENT_STATUS_FULLY_VERIFIED',
  AGENT_STATUS_REQUIRES_VERIFICATION = 'AGENT_STATUS_REQUIRES_VERIFICATION',
  AGENT_STATUS_UNKNOWN = 'AGENT_STATUS_UNKNOWN',
  AGENT_STATUS_VERIFIED = 'AGENT_STATUS_VERIFIED'
}

export type OdProtosAgentDataStore_CreateAgentContactRequestInput = {
  brokerageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  mlsId?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<OdProtosAgentDataStore_CreateAgentContactRequest_SourceSystem>;
  verifiedPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAgentDataStore_CreateAgentContactRequest_SourceSystem {
  ADMIN = 'ADMIN',
  APP = 'APP',
  NOMAD = 'NOMAD',
  SHOWINGTIME = 'SHOWINGTIME',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosAgentDataStore_GetAgentContactRequestInput = {
  identifier?: InputMaybe<OdProtosAgentDataStore_GetAgentContactRequest_IdentifierOneofInput>;
};

export type OdProtosAgentDataStore_GetAgentContactRequest_IdentifierOneofInput = {
  /** The ID of the contact from Custard. See protobuf/custard/v1/data/contact.proto */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** The ID owned by this service for the agent_contact */
  id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * An MLSAgent represents a standardized version of the data being ingested from the different MLSs for agents
 *
 * Context: Different MLSs give us different versions of raw data which must be mapped into a standard form
 *
 * A MLSAgent is uniquely identified by the (mls_name, mls_id) tuple.
 *
 * Next ID: 15
 */
export type OdProtosAgentDataStore_MlsAgentInput = {
  /** Name of brokerage agent belongs to */
  brokerage?: InputMaybe<Scalars['String']['input']>;
  /** Agents email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the agent */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Flag to represent if the agent is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name of the agent */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** License number for the agent. This does not need to match the MLS ID */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Name of MLS for this agent. Required */
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  /** MLS_ID for this agent. Can contain letters and special characters. Required */
  mlsId?: InputMaybe<Scalars['String']['input']>;
  /** Internal MLS_ID for this agent. Can contain letters and special characters. */
  mlsInternalId?: InputMaybe<Scalars['String']['input']>;
  /** Mod timestamp for the agent. Required */
  modTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Agents primary phone number */
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Agents secondary phone number */
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp representing when the agent was updated in the ADS database. */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * List of params on which MLS Agents can be searched on
 * This purposely does not include everything in the MLSAgent message as only certain fields are indexed
 * and expected to be searched on
 *
 * Next ID: 5
 */
export type OdProtosAgentDataStore_MlsAgentSearchParamsInput = {
  /** Name of the mls for which the agent is being searched for */
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  /**
   * Unique ID from the MLS which identifies the agent. Its usually semi private and different from the license
   * number which can be public on an agent's website. Required
   */
  mlsId?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID from the MLS which identifies the agent. It is usually private. Either mls_id or mls_internal_id is needed to search. If both are provided, it does 'And' on both. */
  mlsInternalId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentDataStore_MlsAgentSearchRequestInput = {
  /** params being used to search for the MLS agent */
  mlsAgentSearchParams?: InputMaybe<OdProtosAgentDataStore_MlsAgentSearchParamsInput>;
};

export type OdProtosAgentDataStore_MlsAgentWriteRequestInput = {
  /** MLSAgent to be added to the records */
  mlsAgent?: InputMaybe<OdProtosAgentDataStore_MlsAgentInput>;
};

export type OdProtosAgentDataStore_MlsAgentsSearchRequestInput = {
  /** params being used to search for the MLS agents */
  mlsAgentSearchParams?: InputMaybe<Array<OdProtosAgentDataStore_MlsAgentSearchParamsInput>>;
};

export type OdProtosAgentDataStore_MergeAgentContactsRequestInput = {
  mergedContactId?: InputMaybe<Scalars['String']['input']>;
  mergedIntoContactId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentDataStore_UpdateAgentContactRequestInput = {
  brokerageNames?: InputMaybe<OdProtosAgentDataStore_UpdateAgentContactRequest_BrokerageNamesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Non-null fields will be updated. */
  mlsIdentifier?: InputMaybe<OdProtosAgentDataStore_UpdateAgentContactRequest_MlsIdentifierInput>;
};

export type OdProtosAgentDataStore_UpdateAgentContactRequest_BrokerageNamesInput = {
  brokerageNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAgentDataStore_UpdateAgentContactRequest_MlsIdentifierInput = {
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  mlsId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentDataStore_UpdateAgentVerificationStatusRequestInput = {
  agentVerificationStatus?: InputMaybe<OdProtosAgentDataStore_AgentVerificationStatus>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  humanIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsData_AgentFilterInput = {
  /**
   * Only Agents which have a state found in the states list will
   * be returned. If no states filter is provided, all Agents found
   * in the ACTIVE state will be returned
   */
  states?: InputMaybe<Array<OdProtosAgentsData_Agent_State>>;
};

export enum OdProtosAgentsData_AgentLead_LeadType {
  AGENT_LED_OFFERS_LISTING = 'AGENT_LED_OFFERS_LISTING',
  LIST_WITH_CERTAINTY_LISTING = 'LIST_WITH_CERTAINTY_LISTING',
  PARN_LISTING = 'PARN_LISTING',
  UNKNOWN_LEAD_TYPE = 'UNKNOWN_LEAD_TYPE'
}

export enum OdProtosAgentsData_AgentLead_State {
  AGENTS_PROPOSED = 'AGENTS_PROPOSED',
  /** @deprecated No longer supported */
  ASSIGNED = 'ASSIGNED',
  /** @deprecated No longer supported */
  ASSIGNMENT_NOT_POSSIBLE = 'ASSIGNMENT_NOT_POSSIBLE',
  BROKERAGE_ACCEPTED = 'BROKERAGE_ACCEPTED',
  BROKERAGE_PROPOSED = 'BROKERAGE_PROPOSED',
  /** @deprecated No longer supported */
  CANDIDATE_AGENTS_PROPOSED = 'CANDIDATE_AGENTS_PROPOSED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  IN_PROGRESS = 'IN_PROGRESS',
  MANUAL_ASSIGNMENT_REQUIRED = 'MANUAL_ASSIGNMENT_REQUIRED',
  SELECTING_AGENT = 'SELECTING_AGENT',
  SELECTING_BROKERAGE = 'SELECTING_BROKERAGE',
  /** @deprecated No longer supported */
  SELECT_AGENT_CANDIDATE = 'SELECT_AGENT_CANDIDATE',
  UNKNOWN = 'UNKNOWN',
  UNSERVICEABLE = 'UNSERVICEABLE'
}

export type OdProtosAgentsData_Agent_ScheduleUnavailabilityInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosAgentsData_Agent_State {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 4 */
export type OdProtosAgentsData_Agent_SupportedLeadInput = {
  market?: InputMaybe<Scalars['String']['input']>;
  serviceRegion?: InputMaybe<OdProtosAgentsData_ServiceRegionInput>;
  type?: InputMaybe<OdProtosAgentsData_LeadType>;
};

export type OdProtosAgentsData_Agent_WeeklyScheduleSlotInput = {
  dayOfWeek?: InputMaybe<OdProtosCommon_DayOfWeek>;
  endTime?: InputMaybe<OdProtosAgentsData_TimeOfDayInput>;
  startTime?: InputMaybe<OdProtosAgentsData_TimeOfDayInput>;
};

export type OdProtosAgentsData_BrokerageInput = {
  agentAssignmentType?: InputMaybe<OdProtosAgentsData_Brokerage_AgentAssignmentType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opendoorManagingHumanId?: InputMaybe<Scalars['String']['input']>;
  publicDisplayPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  publicDisplayPhotoCabinetId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosAgentsData_Brokerage_State>;
  supportedLeads?: InputMaybe<Array<OdProtosAgentsData_Brokerage_SupportedLeadInput>>;
  teamLeadAgentId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosAgentsData_Brokerage_AgentAssignmentType {
  AUTOMATIC_AGENT_ASSIGNMENT = 'AUTOMATIC_AGENT_ASSIGNMENT',
  MANUAL_AGENT_ASSIGNMENT = 'MANUAL_AGENT_ASSIGNMENT',
  UNKNOWN_AGENT_ASSIGNMENT = 'UNKNOWN_AGENT_ASSIGNMENT'
}

export enum OdProtosAgentsData_Brokerage_State {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 6 */
export type OdProtosAgentsData_Brokerage_SupportedLeadInput = {
  market?: InputMaybe<Scalars['String']['input']>;
  serviceRegion?: InputMaybe<OdProtosAgentsData_ServiceRegionInput>;
  supportsSpanish?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<OdProtosAgentsData_LeadType>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** NEXT ID: 20 */
export enum OdProtosAgentsData_LeadType {
  AGENT_LED_OFFERS_LISTING = 'AGENT_LED_OFFERS_LISTING',
  APPRAISAL_VISIT = 'APPRAISAL_VISIT',
  AVID = 'AVID',
  /** @deprecated No longer supported */
  EXCLUSIVES_MARKETPLACE_OPEN_HOUSE = 'EXCLUSIVES_MARKETPLACE_OPEN_HOUSE',
  /** @deprecated No longer supported */
  EXCLUSIVES_MARKETPLACE_SHOWING = 'EXCLUSIVES_MARKETPLACE_SHOWING',
  EXTRAORDINARY_EVENT_PAY = 'EXTRAORDINARY_EVENT_PAY',
  FINAL_WALKTHROUGH = 'FINAL_WALKTHROUGH',
  FLIER_DELIVERY = 'FLIER_DELIVERY',
  INSPECTION = 'INSPECTION',
  LIST_WITH_CERTAINTY_LISTING = 'LIST_WITH_CERTAINTY_LISTING',
  LOCK_CHECK = 'LOCK_CHECK',
  OD_OWNED_HOME_AUDIT = 'OD_OWNED_HOME_AUDIT',
  OPEN_HOUSE = 'OPEN_HOUSE',
  PARN_LISTING = 'PARN_LISTING',
  PHOTOGRAPHER_MEETING = 'PHOTOGRAPHER_MEETING',
  PICK_UP_AND_DELIVERY = 'PICK_UP_AND_DELIVERY',
  POST_MUTUAL_VISIT = 'POST_MUTUAL_VISIT',
  THREE_SIXTY_SCANS = 'THREE_SIXTY_SCANS',
  TOUR = 'TOUR',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosAgentsData_OfficeMlsIdsAction {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

/** Next ID: 3 */
export type OdProtosAgentsData_ServiceRegionInput = {
  region?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosAgentsData_ServiceRegion_Type>;
};

/** Next ID: 4 */
export enum OdProtosAgentsData_ServiceRegion_Type {
  GLOBAL = 'GLOBAL',
  MARKET = 'MARKET',
  UNKNOWN = 'UNKNOWN',
  ZIP_CODE = 'ZIP_CODE'
}

export type OdProtosAgentsData_TimeOfDayInput = {
  hour?: InputMaybe<Scalars['Float']['input']>;
  minute?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosAgentsServices_AcceptLeadRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
  agentLeadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_ActivateAgentRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_AddBrokeragesMlsRequestInput = {
  brokerageId?: InputMaybe<Scalars['String']['input']>;
  mlsName?: InputMaybe<Scalars['String']['input']>;
  officeMlsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAgentsServices_AddScheduleUnavailabilityRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  scheduleUnavailability?: InputMaybe<OdProtosAgentsData_Agent_ScheduleUnavailabilityInput>;
};

export type OdProtosAgentsServices_AddWeeklyScheduleSlotRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  weeklyScheduleSlot?: InputMaybe<OdProtosAgentsData_Agent_WeeklyScheduleSlotInput>;
};

export type OdProtosAgentsServices_AdminAssignLeadRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  agentLeadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_AssignLeadRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  agentLeadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_CreateAgentRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
  brokerageId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_CreateAgentWithoutBrokerageRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_CreateBrokerageRequestInput = {
  brokerage?: InputMaybe<OdProtosAgentsData_BrokerageInput>;
};

export type OdProtosAgentsServices_DeactivateAgentRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_GetAgentByIdRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_GetAgentRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_GetBrokerageAgentsRequestInput = {
  brokerageId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OdProtosAgentsData_AgentFilterInput>;
};

export type OdProtosAgentsServices_GetBrokerageRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_ListBrokeragesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAgentsServices_RejectLeadRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
  agentLeadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_RemoveAgentSupportedLeadRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  supportedLead?: InputMaybe<OdProtosAgentsData_Agent_SupportedLeadInput>;
};

export type OdProtosAgentsServices_RemoveBrokerageSupportedLeadRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  supportedLead?: InputMaybe<OdProtosAgentsData_Brokerage_SupportedLeadInput>;
};

export type OdProtosAgentsServices_RemoveHeadshotRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_RemoveScheduleUnavailabilityRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  scheduleUnavailability?: InputMaybe<OdProtosAgentsData_Agent_ScheduleUnavailabilityInput>;
};

export type OdProtosAgentsServices_RemoveWeeklyScheduleSlotRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  weeklyScheduleSlot?: InputMaybe<OdProtosAgentsData_Agent_WeeklyScheduleSlotInput>;
};

export type OdProtosAgentsServices_SetAgentLicenseRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licenseState?: InputMaybe<OdProtosCommonState_State>;
};

export type OdProtosAgentsServices_SetAgentSupportedLeadRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  supportedLead?: InputMaybe<OdProtosAgentsData_Agent_SupportedLeadInput>;
};

export type OdProtosAgentsServices_SetAgentSupportedLeadsInBulkRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  supportedLeads?: InputMaybe<Array<OdProtosAgentsData_Agent_SupportedLeadInput>>;
};

export type OdProtosAgentsServices_SetBrokerageSupportedLeadRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  supportedLead?: InputMaybe<OdProtosAgentsData_Brokerage_SupportedLeadInput>;
};

export type OdProtosAgentsServices_SetBrokerageSupportedLeadsInBulkRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  supportedLeads?: InputMaybe<Array<OdProtosAgentsData_Brokerage_SupportedLeadInput>>;
};

export type OdProtosAgentsServices_SetHeadshotRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  headshotUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_UpdateAgentRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['String']['input']>;
  headshotCabinetId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAgentsServices_UpdateBrokerageRequestInput = {
  brokerage?: InputMaybe<OdProtosAgentsData_BrokerageInput>;
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

export type OdProtosAgentsServices_UpdateBrokeragesMlsRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  mlsName?: InputMaybe<Scalars['String']['input']>;
  officeMlsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  officeMlsIdsAction?: InputMaybe<OdProtosAgentsData_OfficeMlsIdsAction>;
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

export enum OdProtosAthleteData_Bank {
  JP_MORGAN = 'JP_MORGAN',
  NONE = 'NONE',
  /** @deprecated No longer supported */
  WELLS_FARGO = 'WELLS_FARGO'
}

export type OdProtosAthleteData_CreateTemplateInputInput = {
  bank?: InputMaybe<OdProtosAthleteData_Bank>;
  escrowAgency?: InputMaybe<Scalars['String']['input']>;
  financier?: InputMaybe<Scalars['String']['input']>;
  fromAccountId?: InputMaybe<Scalars['String']['input']>;
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  osnJpmStr?: InputMaybe<Scalars['String']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  templateUuid?: InputMaybe<Scalars['String']['input']>;
  toAccountId?: InputMaybe<Scalars['String']['input']>;
  wireType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * EscrowTemplateLookup is used to find the unique template
 * identified by each of the three attributes,
 * where the template in turn identifies the payer/payee
 */
export type OdProtosAthleteData_EscrowTemplateLookupInput = {
  /** the name of the escrow agency executing the transaction */
  escrowAgencyName?: InputMaybe<Scalars['String']['input']>;
  financierName?: InputMaybe<Scalars['String']['input']>;
  /** snake case, from web/Market.rb */
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  scroogeEntityId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAthleteData_TemplateAccountOrderingInput = {
  column?: InputMaybe<OdProtosAthleteData_TemplateAccountOrdering_Column>;
  isDescending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosAthleteData_TemplateAccountOrdering_Column {
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  COUNTRY = 'COUNTRY',
  NAME = 'NAME'
}

export type OdProtosAthleteData_TemplateOrderingInput = {
  column?: InputMaybe<OdProtosAthleteData_TemplateOrdering_Column>;
  isDescending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosAthleteData_TemplateOrdering_Column {
  BANK = 'BANK',
  ESCROW_AGENCY_NAME = 'ESCROW_AGENCY_NAME',
  FINANCIER_NAME = 'FINANCIER_NAME',
  MARKET_IDENTIFIER = 'MARKET_IDENTIFIER',
  NAME = 'NAME',
  OSN_JPM = 'OSN_JPM',
  REGION_NAME = 'REGION_NAME'
}

export type OdProtosAthleteData_UpdateTemplateInputInput = {
  bank?: InputMaybe<OdProtosAthleteData_Bank>;
  escrowAgency?: InputMaybe<Scalars['String']['input']>;
  financier?: InputMaybe<Scalars['String']['input']>;
  fromAccountId?: InputMaybe<Scalars['String']['input']>;
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  osnJpmStr?: InputMaybe<Scalars['String']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  templateUuid?: InputMaybe<Scalars['String']['input']>;
  toAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Wire represents a wire transfer */
export type OdProtosAthleteData_WireInput = {
  /** bank used to send the wire */
  bank?: InputMaybe<OdProtosAthleteData_Bank>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** when the wire was created */
  creationDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  /** non-unique external id (likely flip token) of the wire */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** name of user who intiated wire */
  initiatorFullName?: InputMaybe<Scalars['String']['input']>;
  /** arbitrary internal note */
  note?: InputMaybe<Scalars['String']['input']>;
  /** the amount of the wire */
  paymentAmountCents?: InputMaybe<Scalars['Float']['input']>;
  /** this is the id that will be shared with the bank */
  publicId?: InputMaybe<Scalars['String']['input']>;
  /** arbitrary strings that indicate the reason / additional details for the wire */
  remittanceInfo?: InputMaybe<OdProtosAthleteData_Wire_RemittanceInfoInput>;
  /** remittance status of wire */
  status?: InputMaybe<OdProtosAthleteData_Wire_WireStatus>;
  /** Opendoor-understood wire type */
  type?: InputMaybe<OdProtosAthleteData_Wire_WireType>;
  /** uuid of the wire */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** the date the wire will be transferred (have value) */
  valueDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/**
 * RemittanceInfo are four text fields describing
 * to payee the intended purpose of the wire –
 * for each escrow wire they indicate which escrow account to fund
 */
export type OdProtosAthleteData_Wire_RemittanceInfoInput = {
  field1?: InputMaybe<Scalars['String']['input']>;
  field2?: InputMaybe<Scalars['String']['input']>;
  field3?: InputMaybe<Scalars['String']['input']>;
  field4?: InputMaybe<Scalars['String']['input']>;
};

/**
 * WireStatus represents the Wells-Fargo-indicated/JP Morgan status
 * of each initiated wire transfer
 */
export enum OdProtosAthleteData_Wire_WireStatus {
  ACCEPTED = 'ACCEPTED',
  /**
   * Wells Fargo
   * @deprecated No longer supported
   */
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  /** @deprecated No longer supported */
  AWAITING_RATE = 'AWAITING_RATE',
  /** @deprecated No longer supported */
  AWAITING_REPAIR = 'AWAITING_REPAIR',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FUTURE_VALUE_DATE = 'FUTURE_VALUE_DATE',
  INTERNAL_UNINITIALIZED = 'INTERNAL_UNINITIALIZED',
  /** General */
  MARK_FOR_DELETION = 'MARK_FOR_DELETION',
  /** JP Morgan */
  PENDING = 'PENDING',
  PENDING_CLIENT_REVIEW = 'PENDING_CLIENT_REVIEW',
  PENDING_COMPLIANCE_REVIEW = 'PENDING_COMPLIANCE_REVIEW',
  PENDING_CREDIT_DECISION = 'PENDING_CREDIT_DECISION',
  PROCESSING_BY_BANK = 'PROCESSING_BY_BANK',
  /** @deprecated No longer supported */
  QUEUED = 'QUEUED',
  REJECTED = 'REJECTED',
  REJECTED_BY_BANK = 'REJECTED_BY_BANK',
  /** @deprecated No longer supported */
  SUCCESSFUL = 'SUCCESSFUL',
  UNKNOWN = 'UNKNOWN',
  /** @deprecated No longer supported */
  UNSUCCESSFUL = 'UNSUCCESSFUL'
}

/**
 * WireType is used for validations per flip
 * to ensure that no more than one wire of each type
 * (save CORRECTION) is submitted for a home
 */
export enum OdProtosAthleteData_Wire_WireType {
  AMOUNT_DUE_FROM_BUYER = 'AMOUNT_DUE_FROM_BUYER',
  CORRECTION = 'CORRECTION',
  EARNEST_DEPOSIT = 'EARNEST_DEPOSIT',
  OPTION_FEE = 'OPTION_FEE'
}

export type OdProtosAthleteServices_BulkConfirmTemplateAccountApprovalRequestInput = {
  approve?: InputMaybe<Scalars['Boolean']['input']>;
  templateAccountApprovalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAthleteServices_BulkConfirmTemplateApprovalRequestInput = {
  approve?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAthleteServices_CreateTemplateAccountApprovalInputInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  agentCountry?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  templateAccountUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAthleteServices_CreateTemplateAccountApprovalsRequestInput = {
  inputs?: InputMaybe<Array<OdProtosAthleteServices_CreateTemplateAccountApprovalInputInput>>;
};

export type OdProtosAthleteServices_CreateTemplateApprovalsRequestInput = {
  templateApprovals?: InputMaybe<Array<OdProtosAthleteData_CreateTemplateInputInput>>;
};

export type OdProtosAthleteServices_CreateTemplatesRequestInput = {
  templates?: InputMaybe<Array<OdProtosAthleteData_CreateTemplateInputInput>>;
};

export type OdProtosAthleteServices_DeleteTemplateAccountRequestInput = {
  templateAccountUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAthleteServices_DeleteTemplatesRequestInput = {
  templateUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAthleteServices_GetWiresForExternalIdRequestInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAthleteServices_InitiateEscrowWireRequestInput = {
  templateLookup?: InputMaybe<OdProtosAthleteData_EscrowTemplateLookupInput>;
  wire?: InputMaybe<OdProtosAthleteData_WireInput>;
};

export type OdProtosAthleteServices_ListTemplateAccountApprovalsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosAthleteServices_SearchTemplateAccountsRequestInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordering?: InputMaybe<Array<OdProtosAthleteData_TemplateAccountOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  templateAccountUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAthleteServices_SearchTemplatesRequestInput = {
  escrowAgencyName?: InputMaybe<Scalars['String']['input']>;
  financierName?: InputMaybe<Scalars['String']['input']>;
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordering?: InputMaybe<Array<OdProtosAthleteData_TemplateOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  templateUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAthleteServices_UpdateTemplateRequestInput = {
  template?: InputMaybe<OdProtosAthleteData_UpdateTemplateInputInput>;
};

export type OdProtosAthleteServices_VerifyTemplateRequestInput = {
  templateLookup?: InputMaybe<OdProtosAthleteData_EscrowTemplateLookupInput>;
};

export enum OdProtosAuthAuthzData_Grant_Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type OdProtosAuthAuthzData_ScopeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Must be of the format `([a-z][a-z0-9\-]+)(\.([a-z][a-z0-9\-])+)?`
   * use `.` to separate segments
   */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAuthAuthzServices_RoleConditionInput = {
  /** Must have at least one of these roles if non-empty. */
  authorizedRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosAuthAuthzServices_UserAuthorizedBranches_RequestInput = {
  /** Required role conditions that must be satisfied */
  roleConditions?: InputMaybe<OdProtosAuthAuthzServices_RoleConditionInput>;
  /** Required scope. Must be present in the grant (or you must be a direct member of the branch) */
  scope?: InputMaybe<OdProtosAuthAuthzData_ScopeInput>;
  /** If you do not specify the user id, the currently authenticated user will be used. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAuthAuthzServices_UserAuthorized_RequestInput = {
  /** Branch in bender to check for */
  branchId?: InputMaybe<Scalars['String']['input']>;
  /** Required role conditions that must be satisfied */
  roleConditions?: InputMaybe<OdProtosAuthAuthzServices_RoleConditionInput>;
  /** Required scope. Must be present in the grant (or you must be a direct member of the branch) */
  scope?: InputMaybe<OdProtosAuthAuthzData_ScopeInput>;
  /** If you do not specify the user id, the currently authenticated user will be used. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosAuthzProxyReferenceServiceServices_MessageInput = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosBallparkData_Source {
  BULK_OVM = 'BULK_OVM',
  NATIONWIDE_VALUATIONS_ENSEMBLER = 'NATIONWIDE_VALUATIONS_ENSEMBLER',
  REALTY_TRAC = 'REALTY_TRAC',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE'
}

/** Next ID: 2 */
export type OdProtosBallparkServices_GetHomeFeeRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosBallparkServices_GetHomeFeesRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 5 */
export type OdProtosBallparkServices_GetHomeValueRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosBallparkServices_GetHomeValuesRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBanditData_LaborCostInput = {
  totalCents?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosBanditData_MaterialCostInput = {
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<OdProtosBanditData_UnitType>;
  unitCents?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosBanditData_RepairScopeOrigin {
  REPAIRSCOPEORIGIN_ASSESSMENT_REVIEW = 'REPAIRSCOPEORIGIN_ASSESSMENT_REVIEW',
  REPAIRSCOPEORIGIN_CONDITION_SCOPING = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING',
  REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI',
  REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_FEEDBACK = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_FEEDBACK',
  REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_HIDDEN = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_HIDDEN',
  /** manual */
  REPAIRSCOPEORIGIN_CONDITION_SCOPING_M = 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_M',
  REPAIRSCOPEORIGIN_POST_CONTRACT_DILIGENCE_SCOPING = 'REPAIRSCOPEORIGIN_POST_CONTRACT_DILIGENCE_SCOPING',
  REPAIRSCOPEORIGIN_RENO911 = 'REPAIRSCOPEORIGIN_RENO911',
  REPAIRSCOPEORIGIN_UNSPECIFIED = 'REPAIRSCOPEORIGIN_UNSPECIFIED'
}

export type OdProtosBanditData_SourceReferenceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosBanditData_SourceReference_SourceReferenceType>;
};

export enum OdProtosBanditData_SourceReference_SourceReferenceType {
  PROMPT = 'PROMPT',
  PROMPT_GROUP = 'PROMPT_GROUP',
  SOURCE_REFERENCE_TYPE_UNSPECIFIED = 'SOURCE_REFERENCE_TYPE_UNSPECIFIED'
}

export enum OdProtosBanditData_State {
  APPROVED = 'APPROVED',
  DELETED = 'DELETED',
  INVALID = 'INVALID',
  OPEN = 'OPEN'
}

export enum OdProtosBanditData_UnitType {
  EACH = 'EACH',
  LINEAR_FEET = 'LINEAR_FEET',
  SQUARE_FEET = 'SQUARE_FEET'
}

export type OdProtosBanditServices_ChangeAddressRequestInput = {
  newAddressId?: InputMaybe<Scalars['String']['input']>;
  oldAddressId?: InputMaybe<Scalars['String']['input']>;
  taskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBanditServices_CreateRepairScopeRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  areaId?: InputMaybe<Scalars['String']['input']>;
  createdFromSource?: InputMaybe<Scalars['String']['input']>;
  createdFromSourceReference?: InputMaybe<OdProtosBanditData_SourceReferenceInput>;
  defectId?: InputMaybe<Scalars['String']['input']>;
  deferred?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosBanditData_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosBanditData_MaterialCostInput>;
  origin?: InputMaybe<OdProtosBanditData_RepairScopeOrigin>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBanditServices_DeleteRepairScopeRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBanditServices_DeleteRepairScopesRequestInput = {
  repairScopeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBanditServices_EnsureRepairScopePrelimsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBanditServices_GetPostDvScopesTotalRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBanditServices_GetRepairScopesByHomeRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  originIn?: InputMaybe<Array<OdProtosBanditData_RepairScopeOrigin>>;
};

export type OdProtosBanditServices_GetRepairScopesSnapshotsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OdProtosBanditServices_RepairScopeSnapshotFiltersInput>;
};

export type OdProtosBanditServices_GetRepairScopesTotalFiltersInput = {
  originIn?: InputMaybe<Array<OdProtosBanditData_RepairScopeOrigin>>;
  snapshotTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosBanditServices_GetRepairScopesTotalRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OdProtosBanditServices_GetRepairScopesTotalFiltersInput>;
};

export type OdProtosBanditServices_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBanditServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBanditServices_ListAssessmentScopeCostsForAddressesRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBanditServices_RepairScopeSnapshotFiltersInput = {
  excludeDeletedSnapshots?: InputMaybe<Scalars['Boolean']['input']>;
  originIn?: InputMaybe<Array<OdProtosBanditData_RepairScopeOrigin>>;
};

export type OdProtosBanditServices_RestoreDeletedRepairScopeRequestInput = {
  repairScopeId?: InputMaybe<Scalars['String']['input']>;
};

/** The non null values will be updated */
export type OdProtosBanditServices_UpdateRepairScopeRequestInput = {
  areaId?: InputMaybe<Scalars['String']['input']>;
  defectId?: InputMaybe<Scalars['String']['input']>;
  deferred?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosBanditData_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosBanditData_MaterialCostInput>;
  origin?: InputMaybe<OdProtosBanditData_RepairScopeOrigin>;
  updatedFromSource?: InputMaybe<Scalars['String']['input']>;
};

/** An ID issues by an MLS. */
export type OdProtosBrokeragesData_MlsidInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
};

/** A real estate license issued by a state. */
export type OdProtosBrokeragesData_RealEstateLicenseInput = {
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosCommonState_State>;
};

/** initial map region to be displayed for a market, to be used inside MarketConfig */
export type OdProtosBuyConfig_InitialMapRegionInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  latitudeDelta?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  longitudeDelta?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Config keyed by Market.
 * PBDB Key: market
 */
export type OdProtosBuyConfig_MarketConfigInput = {
  /** flag for if market is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** number of days on market on average */
  averageDaysOnMarket?: InputMaybe<Scalars['Float']['input']>;
  /** flag to turn on bwod for market */
  buyingExperience?: InputMaybe<Scalars['Boolean']['input']>;
  /** contact email for non bwod markets */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** contact email for bwod markets */
  contactEmailBx?: InputMaybe<Scalars['String']['input']>;
  /** contact number for non bwod markets */
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** contact number for bwod markets */
  contactPhoneNumberBx?: InputMaybe<Scalars['String']['input']>;
  /** flag for whether direct buy is on */
  directBuy?: InputMaybe<Scalars['Boolean']['input']>;
  /** displayable name of the market (e.g "Phoenix"). */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** displayable name of the state (e.g "Arizona") */
  displayState?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Feed filter defaults set during onboarding process */
  feedDefaults?: InputMaybe<OdProtosBuyConfig_PropertiesFilterInput>;
  /** flag for buyer incentive */
  hasBuyerIncentive?: InputMaybe<Scalars['Boolean']['input']>;
  /** flag on whether to hide sale prices */
  hideSalePrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** path of homes in web */
  homesPath?: InputMaybe<Scalars['String']['input']>;
  /** integer id of the market. */
  id?: InputMaybe<Scalars['Float']['input']>;
  /** name of the market. This is also the identifier (e.g. "phoenix"). */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** map region for the market */
  initialMapRegion?: InputMaybe<OdProtosBuyConfig_InitialMapRegionInput>;
  /** how wide of a map should we show */
  initialMapRegionLatitudeDelta?: InputMaybe<Scalars['Float']['input']>;
  /** how tall of a map should we show */
  initialMapRegionLongitudeDelta?: InputMaybe<Scalars['Float']['input']>;
  /** how tall of a map should we show (typo) */
  intitialMapRegionLongitudeDelta?: InputMaybe<Scalars['Float']['input']>;
  /** market center latitude */
  marketCenterLatitude?: InputMaybe<Scalars['Float']['input']>;
  /** market center longitude */
  marketCenterLongitude?: InputMaybe<Scalars['Float']['input']>;
  /** primary MLS name for the market */
  mlsName?: InputMaybe<Scalars['String']['input']>;
  /** all the MLS that are associated with this market */
  mlses?: InputMaybe<Array<OdProtosBuyConfig_MlsInput>>;
  /** name of the market (e.g "Phoenix"). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** flag to determine if open listings is active */
  openListingsActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ops region for market */
  opsRegion?: InputMaybe<Scalars['String']['input']>;
  /** Fence ID of the region covered by this market. This is also the identifier (e.g. "phoenix"). */
  regionId?: InputMaybe<Scalars['String']['input']>;
  /** secondary MLS name for the market (optional, not all markets have a secondary MLS) */
  secondaryMlsName?: InputMaybe<Scalars['String']['input']>;
  /** Enable same-day tours/showings? */
  serviceSameDayShowings?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable SMS verification? */
  serviceSmsVerification?: InputMaybe<Scalars['Boolean']['input']>;
  /** appreviated name of the state (e.g "AZ"). */
  state?: InputMaybe<Scalars['String']['input']>;
  /** full name of the state (e.g "Arizona") */
  stateName?: InputMaybe<Scalars['String']['input']>;
  /** time zone for the market */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** message for trade in incentive */
  tradeInIncentive?: InputMaybe<OdProtosBuyConfig_TradeInIncentiveInput>;
  /** flag for treatment */
  treatment?: InputMaybe<Scalars['Boolean']['input']>;
};

/** MLS */
export type OdProtosBuyConfig_MlsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Deprecated: User properties filter (used for feed) */
export type OdProtosBuyConfig_PropertiesFilterInput = {
  bathrooms?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  bedrooms?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  forFlippers?: InputMaybe<Scalars['Boolean']['input']>;
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  includeHomebuilder?: InputMaybe<Scalars['Boolean']['input']>;
  lotSqft?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  maxMonthlyHoaFee?: InputMaybe<Scalars['Float']['input']>;
  onlyFhaEligible?: InputMaybe<Scalars['Boolean']['input']>;
  onlyInstantTours?: InputMaybe<Scalars['Boolean']['input']>;
  onlyOpendoor?: InputMaybe<Scalars['Boolean']['input']>;
  onlySingleStory?: InputMaybe<Scalars['Boolean']['input']>;
  openHouses?: InputMaybe<Scalars['Boolean']['input']>;
  poolType?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  propertyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sqft?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  yearBuilt?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  zips?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Integer range */
export type OdProtosBuyConfig_RangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** trade in incentive structure to be used inside Market Config */
export type OdProtosBuyConfig_TradeInIncentiveInput = {
  fixedAmountCents?: InputMaybe<Scalars['Float']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * State represents the possible high-level states that a buy direct
 * channel's Originator can be in
 */
export enum OdProtosBuydirectData_Channel_Originator_State {
  /** The property being sold by the Originator entity has a buyer committed to it */
  COMMITTED_BUYER = 'COMMITTED_BUYER',
  /**
   * The property being sold by the Originator entity is pending commitment (it hasn't
   * been acquired yet or the selling has not been committed to)
   */
  PENDING_COMMITMENT = 'PENDING_COMMITMENT',
  /** The property being sold by the Originator entity is being prepared for listing */
  PREPARING = 'PREPARING',
  /** The property being sold by the Originator entity is sellable */
  SELLABLE = 'SELLABLE',
  /** The property being sold by the Originator entity is no longer being sold */
  TERMINATED = 'TERMINATED',
  /** The State of the Originator entity is unknown */
  UNKNOWN_ORIGINATOR_STATE = 'UNKNOWN_ORIGINATOR_STATE'
}

/**
 * Originator type represents the possible types of entities that can be the
 * originator of a buy direct channel
 */
export enum OdProtosBuydirectData_Channel_Originator_Type {
  /** The originator of the buy direct channel is Opendoor */
  OPENDOOR = 'OPENDOOR',
  /**
   * The originator of the buy direct channel is a third party seller
   * @deprecated No longer supported
   */
  THIRD_PARTY_SELLER = 'THIRD_PARTY_SELLER',
  /** The originator of the buy direct channel is unknown */
  UNKNOWN_ORIGINATOR_TYPE = 'UNKNOWN_ORIGINATOR_TYPE'
}

/**
 * State represents the possible high-level states that a buy direct channel
 * can be in during its lifecycle
 */
export enum OdProtosBuydirectData_Channel_State {
  /**
   * The buy direct channel is currently inactive and the property is not
   * available through buy direct
   */
  INACTIVE = 'INACTIVE',
  /** The property is available to be purchased through the buy direct channel */
  ON_THE_MARKET = 'ON_THE_MARKET',
  /**
   * The BuyDirect Channel preparing to publish the property as being
   * available through buy direct
   */
  PREPARING = 'PREPARING',
  /** The buy direct lifecycle for the property has terminated */
  TERMINATED = 'TERMINATED',
  /** The State of the BuyDirect Channel is unknown */
  UNKNOWN_STATE = 'UNKNOWN_STATE',
  /**
   * The property is available to be seen through the buy direct channel,
   * however it is not available to be purchased yet
   */
  VISIBLE = 'VISIBLE'
}

/** TerminationReason indicates the reason a buy direct channel has terminated */
export enum OdProtosBuydirectData_Channel_TerminationReason {
  /**
   * The channel has been terminated explicitly through a command as opposed
   * to naturally by the lifecycle of its parent
   */
  EXPLICIT = 'EXPLICIT',
  /**
   * The channel has terminated because its parent (Resale) has been
   * canceled, meaning that Opendoor has terminated its intent to sell the
   * property at this time.
   */
  RESALE_CANCELED = 'RESALE_CANCELED',
  /**
   * The channel has terminated because its parent (Resale) has indicated
   * that the property was never acquired and hence does not need to be sold
   */
  RESALE_NOT_ACQUIRED = 'RESALE_NOT_ACQUIRED',
  /**
   * The channel has terminated because its parent (Resale) has indicated
   * that the property has been sold
   */
  RESALE_SOLD = 'RESALE_SOLD',
  /** The channel has terminated for an unknown reason */
  UNKNOWN_TERMINATION_REASON = 'UNKNOWN_TERMINATION_REASON'
}

/**
 * ResaleState represents the possible high-level states that a buy direct
 * channel's Resale parent can be in
 */
export enum OdProtosBuydirectData_Resale_ResaleState {
  /** The property being sold by the Resale entity has a buyer committed to it */
  COMMITTED_BUYER = 'COMMITTED_BUYER',
  /**
   * The property being sold by the Resale entity is being prepared for
   * resale
   */
  PREPARING = 'PREPARING',
  /**
   * The property being sold by the Resale entity is pre-inventory (it hasn't
   * been acquired yet)
   */
  PRE_INVENTORY = 'PRE_INVENTORY',
  /** The property being sold by the Resale entity is sellable */
  SELLABLE = 'SELLABLE',
  /** The property being sold by the Resale entity is no longer being sold */
  TERMINATED = 'TERMINATED',
  /** The State of the Resale entity is unknown */
  UNKNOWN_RESALE_STATE = 'UNKNOWN_RESALE_STATE'
}

/** Type is the enumeration of valid selling statuses */
export enum OdProtosBuydirectData_SellingStatus_Type {
  /** The property will be available for sale soon */
  AVAILABLE_SOON = 'AVAILABLE_SOON',
  /** The property is currently available for sale */
  FOR_SALE = 'FOR_SALE',
  /**
   * The property is currently available for sale, but is under contract
   * with a buyer
   */
  IN_CONTRACT = 'IN_CONTRACT',
  /** The property has been sold */
  SOLD = 'SOLD',
  /** The property is not available for sale */
  UNAVAILABLE = 'UNAVAILABLE',
  /** Tnknown selling status */
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosBuydirectServices_GetBuyDirectChannelRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuydirectServices_GetMostRecentBuyDirectChannelByAddressIdRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosBuyerData_Document_DocumentType {
  /** @deprecated No longer supported */
  ADDENDUM_COUNTER_SIGNATURE_DOCS = 'ADDENDUM_COUNTER_SIGNATURE_DOCS',
  /** @deprecated No longer supported */
  ADDITIONAL_CLOSING_DOCS = 'ADDITIONAL_CLOSING_DOCS',
  /** @deprecated No longer supported */
  ADDITIONAL_DOCS = 'ADDITIONAL_DOCS',
  /** @deprecated No longer supported */
  CASH_OFFER_PROGRAM_AGREEMENT_DOCS = 'CASH_OFFER_PROGRAM_AGREEMENT_DOCS',
  /** @deprecated No longer supported */
  CCPA_SCRUBBED_TYPE = 'CCPA_SCRUBBED_TYPE',
  /** @deprecated No longer supported */
  COMMISSION_INSTRUCTIONS_DOCS = 'COMMISSION_INSTRUCTIONS_DOCS',
  /** @deprecated No longer supported */
  COUNTER_OFFER_DOCS = 'COUNTER_OFFER_DOCS',
  /** @deprecated No longer supported */
  DEED_DOCS = 'DEED_DOCS',
  /** @deprecated No longer supported */
  DISCLOSURE_DOCS = 'DISCLOSURE_DOCS',
  /** @deprecated No longer supported */
  DOCUMENT_TYPE_UNKNOWN = 'DOCUMENT_TYPE_UNKNOWN',
  /** @deprecated No longer supported */
  EARNEST_MONEY_RECEIPT_DOCS = 'EARNEST_MONEY_RECEIPT_DOCS',
  /** @deprecated No longer supported */
  FINAL_SETTLEMENT_STATEMENTS_DOCS = 'FINAL_SETTLEMENT_STATEMENTS_DOCS',
  /** @deprecated No longer supported */
  HOA_DEMAND_DOCS = 'HOA_DEMAND_DOCS',
  /** @deprecated No longer supported */
  HOME_SALE_DOCS = 'HOME_SALE_DOCS',
  /** @deprecated No longer supported */
  INSPECTION_REPORT_DOCS = 'INSPECTION_REPORT_DOCS',
  /** @deprecated No longer supported */
  LAND_SURVEY_DOCS = 'LAND_SURVEY_DOCS',
  /** @deprecated No longer supported */
  MORTGAGE_PREAPPROVAL_DOCS = 'MORTGAGE_PREAPPROVAL_DOCS',
  /** @deprecated No longer supported */
  OBO_APPRAISAL_DOCS = 'OBO_APPRAISAL_DOCS',
  /** @deprecated No longer supported */
  OBO_EARLY_OCCUPANCY_DOCS = 'OBO_EARLY_OCCUPANCY_DOCS',
  /** @deprecated No longer supported */
  OBO_OPERATOR_APPRAISAL_DOCS = 'OBO_OPERATOR_APPRAISAL_DOCS',
  /** @deprecated No longer supported */
  PROOF_OF_FUNDS_DOCS = 'PROOF_OF_FUNDS_DOCS',
  /** @deprecated No longer supported */
  PURCHASE_AGREEMENT_DOCS = 'PURCHASE_AGREEMENT_DOCS',
  /** @deprecated No longer supported */
  TAX_CERTIFICATE_DOCS = 'TAX_CERTIFICATE_DOCS',
  /** @deprecated No longer supported */
  TITLE_COMMITMENT_DOCS = 'TITLE_COMMITMENT_DOCS'
}

export enum OdProtosBuyerData_Document_FileScanStatus {
  /** @deprecated No longer supported */
  CLEAN = 'CLEAN',
  /** @deprecated No longer supported */
  FILE_SCAN_STATUS_UNKNOWN = 'FILE_SCAN_STATUS_UNKNOWN',
  /** @deprecated No longer supported */
  INFECTED = 'INFECTED',
  /** @deprecated No longer supported */
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum OdProtosBuyerData_Offer_FundingSource {
  /** @deprecated No longer supported */
  CASH = 'CASH',
  /** @deprecated No longer supported */
  MORTGAGE = 'MORTGAGE',
  /** @deprecated No longer supported */
  UNKNOWN_FUNDING_SOURCE = 'UNKNOWN_FUNDING_SOURCE'
}

export enum OdProtosBuyerData_Offer_OboStatus {
  /** @deprecated No longer supported */
  OBO_CLOSED_OPENDOOR_BOUGHT = 'OBO_CLOSED_OPENDOOR_BOUGHT',
  /** @deprecated No longer supported */
  OBO_REASSIGNMENT_STARTED = 'OBO_REASSIGNMENT_STARTED',
  /** @deprecated No longer supported */
  OBO_STATUS_UNKNOWN = 'OBO_STATUS_UNKNOWN',
  /** @deprecated No longer supported */
  RESALE_CANCELED = 'RESALE_CANCELED',
  /** @deprecated No longer supported */
  RESALE_CONTRACT_SENT = 'RESALE_CONTRACT_SENT',
  /** @deprecated No longer supported */
  RESALE_IN_CONTRACT = 'RESALE_IN_CONTRACT',
  /** @deprecated No longer supported */
  TRANSACTION_COMPLETE_OPENDOOR_BOUGHT = 'TRANSACTION_COMPLETE_OPENDOOR_BOUGHT'
}

export enum OdProtosBuyerData_Offer_State {
  /** @deprecated No longer supported */
  AWAITING_RESPONSE = 'AWAITING_RESPONSE',
  /** @deprecated No longer supported */
  AWAITING_SIGNATURE = 'AWAITING_SIGNATURE',
  /** @deprecated No longer supported */
  CANCELED_BEFORE_SUBMITTING = 'CANCELED_BEFORE_SUBMITTING',
  /** @deprecated No longer supported */
  CANCELED_BY_BUYER = 'CANCELED_BY_BUYER',
  /** @deprecated No longer supported */
  CANCELED_ESCROW = 'CANCELED_ESCROW',
  /** @deprecated No longer supported */
  CLOSED_ESCROW = 'CLOSED_ESCROW',
  /** @deprecated No longer supported */
  COUNTERED = 'COUNTERED',
  /** @deprecated No longer supported */
  DRAFT = 'DRAFT',
  /** @deprecated No longer supported */
  INCOMPLETE = 'INCOMPLETE',
  /** @deprecated No longer supported */
  IN_CONTRACT = 'IN_CONTRACT',
  /** @deprecated No longer supported */
  IN_REVIEW = 'IN_REVIEW',
  /** @deprecated No longer supported */
  READY_TO_SUBMIT = 'READY_TO_SUBMIT',
  /** @deprecated No longer supported */
  REJECTED = 'REJECTED',
  /** @deprecated No longer supported */
  SUBMITTED_AS_BACKUP = 'SUBMITTED_AS_BACKUP',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosBuyerData_PricingRequest_ContactPreference {
  /** @deprecated No longer supported */
  CALL = 'CALL',
  /** @deprecated No longer supported */
  EMAIL = 'EMAIL',
  /** @deprecated No longer supported */
  TEXT = 'TEXT',
  /** @deprecated No longer supported */
  UNKNOWN_CONTACT_PREFERENCE = 'UNKNOWN_CONTACT_PREFERENCE'
}

export enum OdProtosBuyerData_Property_PoolType {
  /** @deprecated No longer supported */
  ABOVE_GROUND = 'ABOVE_GROUND',
  /** @deprecated No longer supported */
  COMMUNITY = 'COMMUNITY',
  /** @deprecated No longer supported */
  NONE = 'NONE',
  /** @deprecated No longer supported */
  NO_POOL = 'NO_POOL',
  /** @deprecated No longer supported */
  PRIVATE = 'PRIVATE',
  /** @deprecated No longer supported */
  PRIVATE_SPA = 'PRIVATE_SPA',
  /** @deprecated No longer supported */
  UNKNOWN_POOL_TYPE = 'UNKNOWN_POOL_TYPE'
}

export enum OdProtosBuyerData_Property_PropertyType {
  /** @deprecated No longer supported */
  APARTMENT = 'APARTMENT',
  /** @deprecated No longer supported */
  COMMERCIAL = 'COMMERCIAL',
  /** @deprecated No longer supported */
  HOME = 'HOME',
  /** @deprecated No longer supported */
  LAND = 'LAND',
  /** @deprecated No longer supported */
  MOBILE_HOME = 'MOBILE_HOME',
  /** @deprecated No longer supported */
  MULTI_FAMILY = 'MULTI_FAMILY',
  /** @deprecated No longer supported */
  RENTAL = 'RENTAL',
  /** @deprecated No longer supported */
  TOWNHOME = 'TOWNHOME',
  /** @deprecated No longer supported */
  UNCLASSIFIED = 'UNCLASSIFIED',
  /** @deprecated No longer supported */
  UNKNOWN_PROPERTY_TYPE = 'UNKNOWN_PROPERTY_TYPE'
}

export enum OdProtosBuyerData_Rating_RatingContext {
  /** @deprecated No longer supported */
  ACCEPTED = 'ACCEPTED',
  /** @deprecated No longer supported */
  CANCELED = 'CANCELED',
  /** @deprecated No longer supported */
  CHECK_IN = 'CHECK_IN',
  /** @deprecated No longer supported */
  CLOSED = 'CLOSED',
  /** @deprecated No longer supported */
  MANUAL = 'MANUAL',
  /** @deprecated No longer supported */
  PRICING_REQUEST = 'PRICING_REQUEST',
  /** @deprecated No longer supported */
  REJECTED = 'REJECTED',
  /** @deprecated No longer supported */
  TOUR_COMPLETED = 'TOUR_COMPLETED',
  /**
   * Context enum used to identify review timeline
   * @deprecated No longer supported
   */
  UNKNOWN = 'UNKNOWN',
  /** @deprecated No longer supported */
  UNPAIR_REQUEST = 'UNPAIR_REQUEST'
}

export enum OdProtosBuyerData_ShowingRequest_InactiveReason {
  /** @deprecated No longer supported */
  ADMIN_REJECTED = 'ADMIN_REJECTED',
  /** @deprecated No longer supported */
  BUYER_CANCELED_AGENT = 'BUYER_CANCELED_AGENT',
  /** @deprecated No longer supported */
  BUYER_CANCELED_BEFORE = 'BUYER_CANCELED_BEFORE',
  /** @deprecated No longer supported */
  BUYER_NO_SHOW = 'BUYER_NO_SHOW',
  /** @deprecated No longer supported */
  BUYER_OPEN_HOUSE = 'BUYER_OPEN_HOUSE',
  /** @deprecated No longer supported */
  BUYER_TOURED_INDEPENDENTLY = 'BUYER_TOURED_INDEPENDENTLY',
  /** @deprecated No longer supported */
  CANT_BE_SHOWN = 'CANT_BE_SHOWN',
  /** @deprecated No longer supported */
  CANT_BE_SHOWN_WITH_TOUR = 'CANT_BE_SHOWN_WITH_TOUR',
  /** @deprecated No longer supported */
  NO_AGENT = 'NO_AGENT',
  /** @deprecated No longer supported */
  OFF_MARKET = 'OFF_MARKET',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN',
  /** @deprecated No longer supported */
  UNRESPONSIVE_BUYER = 'UNRESPONSIVE_BUYER'
}

export enum OdProtosBuyerData_ShowingRequest_VirtualPlatform {
  /** @deprecated No longer supported */
  FACETIME = 'FACETIME',
  /** @deprecated No longer supported */
  GOOGLE_DUO = 'GOOGLE_DUO',
  /** @deprecated No longer supported */
  SKYPE = 'SKYPE',
  /** @deprecated No longer supported */
  UNKNOWN_VIRTUAL_PLATFORM = 'UNKNOWN_VIRTUAL_PLATFORM',
  /** @deprecated No longer supported */
  WHATSAPP = 'WHATSAPP',
  /** @deprecated No longer supported */
  ZOOM = 'ZOOM'
}

export enum OdProtosBuyerData_Task_TaskType {
  /** @deprecated No longer supported */
  APPRAISAL = 'APPRAISAL',
  /** @deprecated No longer supported */
  FEED_FILTERS = 'FEED_FILTERS',
  /** @deprecated No longer supported */
  INFORMATION_CONFIRMATION = 'INFORMATION_CONFIRMATION',
  /** @deprecated No longer supported */
  INSPECTIONS = 'INSPECTIONS',
  /** @deprecated No longer supported */
  LOAN_APPLICATION = 'LOAN_APPLICATION',
  /** @deprecated No longer supported */
  LOAN_FINALIZATION = 'LOAN_FINALIZATION',
  /** @deprecated No longer supported */
  MARKET_TRENDS = 'MARKET_TRENDS',
  /** @deprecated No longer supported */
  RESALE_CONTRACT = 'RESALE_CONTRACT',
  /** @deprecated No longer supported */
  UNKNOWN_TASK_TYPE = 'UNKNOWN_TASK_TYPE',
  /** @deprecated No longer supported */
  UTILITIES = 'UTILITIES'
}

export enum OdProtosBuyerData_Tour_RequestType {
  /** @deprecated No longer supported */
  FINAL_WALKTHROUGH = 'FINAL_WALKTHROUGH',
  /** @deprecated No longer supported */
  INSPECTION = 'INSPECTION',
  /** @deprecated No longer supported */
  OPEN_HOUSE = 'OPEN_HOUSE',
  /** @deprecated No longer supported */
  SHOWING = 'SHOWING',
  /** @deprecated No longer supported */
  UNKNOWN_REQUEST_TYPE = 'UNKNOWN_REQUEST_TYPE'
}

export enum OdProtosBuyerData_Tour_State {
  /** @deprecated No longer supported */
  COMPLETED = 'COMPLETED',
  /** @deprecated No longer supported */
  CONFIRMED = 'CONFIRMED',
  /** @deprecated No longer supported */
  EMPTY = 'EMPTY',
  /** @deprecated No longer supported */
  INACTIVE = 'INACTIVE',
  /** @deprecated No longer supported */
  PENDING = 'PENDING',
  /** @deprecated No longer supported */
  PROPERTY_CONFIRMED = 'PROPERTY_CONFIRMED',
  /** @deprecated No longer supported */
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosBuyerData_Tour_TourVibe {
  /** @deprecated No longer supported */
  DOOR_OPENER = 'DOOR_OPENER',
  /** @deprecated No longer supported */
  HANDS_ON = 'HANDS_ON',
  /** @deprecated No longer supported */
  UNKNOWN_TOUR_VIBE = 'UNKNOWN_TOUR_VIBE'
}

export enum OdProtosBuyerData_User_CreditRating {
  /** @deprecated No longer supported */
  AVERAGE = 'AVERAGE',
  /** @deprecated No longer supported */
  EXCELLENT = 'EXCELLENT',
  /** @deprecated No longer supported */
  GOOD = 'GOOD',
  /** @deprecated No longer supported */
  LOW = 'LOW',
  /** @deprecated No longer supported */
  UNKNOWN_CREDIT_RATING = 'UNKNOWN_CREDIT_RATING'
}

/** DEPRECATED: Use SavedSearches in v2 buyer service */
export type OdProtosBuyerData_User_FeedPropertiesFilterInput = {
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  isFhaEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleStory?: InputMaybe<Scalars['Boolean']['input']>;
  maxLotSqft?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyHoaFee?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  maxSqft?: InputMaybe<Scalars['Int']['input']>;
  maxYearBuilt?: InputMaybe<Scalars['Int']['input']>;
  minBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minBedrooms?: InputMaybe<Scalars['Int']['input']>;
  minLotSqft?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  minSqft?: InputMaybe<Scalars['Int']['input']>;
  minYearBuilt?: InputMaybe<Scalars['Int']['input']>;
  onlyHomebuilder?: InputMaybe<Scalars['Boolean']['input']>;
  propertyTypes?: InputMaybe<Array<OdProtosBuyerData_Property_PropertyType>>;
  zones?: InputMaybe<Array<OdProtosBuyerData_ZoneInput>>;
};

/** DEPRECATED: Use FeedPropertiesFilter */
export type OdProtosBuyerData_User_PropertiesFilterInput = {
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  isFhaEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleStory?: InputMaybe<Scalars['Boolean']['input']>;
  maxLotSqft?: InputMaybe<Scalars['Float']['input']>;
  maxMonthlyHoaFee?: InputMaybe<Scalars['Float']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  maxSqft?: InputMaybe<Scalars['Float']['input']>;
  maxYearBuilt?: InputMaybe<Scalars['Float']['input']>;
  minBathrooms?: InputMaybe<Scalars['Float']['input']>;
  minBedrooms?: InputMaybe<Scalars['Float']['input']>;
  minLotSqft?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  minSqft?: InputMaybe<Scalars['Float']['input']>;
  minYearBuilt?: InputMaybe<Scalars['Float']['input']>;
  onlyHomebuilder?: InputMaybe<Scalars['Boolean']['input']>;
  propertyTypes?: InputMaybe<Array<OdProtosBuyerData_Property_PropertyType>>;
  zones?: InputMaybe<Array<OdProtosBuyerData_ZoneInput>>;
};

export type OdProtosBuyerData_ZoneInput = {
  gdsId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_AgentRequests_GetAgentByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_AgentRequests_GetAgentByParamsIdInput = {
  paramsId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_AgentRequests_GetAgentProfileInfoByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_AgentRequests_GetAgentsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_DocumentRequests_AddAppraisalDocumentByOfferIdInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the file, ex: pre_approval.pdf */
  name?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_DocumentRequests_AddPreApprovalDocumentByOfferIdInput = {
  /** The name of the file, ex: pre_approval.pdf */
  name?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_DocumentRequests_GetDocumentsByOfferIdInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_DocumentRequests_GetFileUploadUrlInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUserInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  sortKey?: InputMaybe<OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUser_SortKey>;
  type?: InputMaybe<OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUser_Type>;
};

export enum OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUser_SortKey {
  /** @deprecated No longer supported */
  SORT_KEY_CREATED_AT_DESC = 'SORT_KEY_CREATED_AT_DESC',
  /** @deprecated No longer supported */
  SORT_KEY_DEFAULT = 'SORT_KEY_DEFAULT'
}

export enum OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUser_Type {
  /** @deprecated No longer supported */
  OBO_PROGRAM_AGREEMENT_LATEST_VERSION = 'OBO_PROGRAM_AGREEMENT_LATEST_VERSION',
  /** @deprecated No longer supported */
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

export type OdProtosBuyerServicesBuyer_MarketConfigRequests_GetMarketConfigByMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerServicesBuyer_MarketConfigRequests_GetPostalCodesByMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_CancelOfferByIdInput = {
  cancelationDescription?: InputMaybe<Scalars['String']['input']>;
  cancelationReason?: InputMaybe<OdProtosBuyerServicesBuyer_OfferRequests_CancelOfferById_CancelationReason>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosBuyerServicesBuyer_OfferRequests_CancelOfferById_CancelationReason {
  /** @deprecated No longer supported */
  BUYER_TEST = 'BUYER_TEST',
  /** @deprecated No longer supported */
  CANT_DECIDE_PRICE = 'CANT_DECIDE_PRICE',
  /** @deprecated No longer supported */
  CHOOSE_MY_AGENT = 'CHOOSE_MY_AGENT',
  /** @deprecated No longer supported */
  NOT_GOOD_EXPERIENCE = 'NOT_GOOD_EXPERIENCE',
  /** @deprecated No longer supported */
  NO_LONGER_AVAILABLE = 'NO_LONGER_AVAILABLE',
  /** @deprecated No longer supported */
  NO_LONGER_INTERESTED = 'NO_LONGER_INTERESTED',
  /** @deprecated No longer supported */
  OTHER = 'OTHER',
  /** @deprecated No longer supported */
  TOO_MANY_COMPETING = 'TOO_MANY_COMPETING',
  /** @deprecated No longer supported */
  UNKNOWN_CANCELATION_REASON = 'UNKNOWN_CANCELATION_REASON'
}

export type OdProtosBuyerServicesBuyer_OfferRequests_CreateOfferInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOfferByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOffersByHumanTokenInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
  offerFilters?: InputMaybe<OdProtosBuyerServicesBuyer_OfferRequests_GetOffersByHumanToken_OfferFilters>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export enum OdProtosBuyerServicesBuyer_OfferRequests_GetOffersByHumanToken_OfferFilters {
  /** @deprecated No longer supported */
  ACTIVE = 'ACTIVE',
  /** @deprecated No longer supported */
  ALL = 'ALL',
  /** @deprecated No longer supported */
  INACTIVE = 'INACTIVE'
}

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOffersByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUserInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerFilters?: InputMaybe<OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUser_OfferFilters>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export enum OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUser_OfferFilters {
  /** @deprecated No longer supported */
  ACTIVE = 'ACTIVE',
  /** @deprecated No longer supported */
  ALL = 'ALL',
  /** @deprecated No longer supported */
  INACTIVE = 'INACTIVE'
}

export type OdProtosBuyerServicesBuyer_OfferRequests_SubmitOfferInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferAgentInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  ownAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferDownPaymentInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  mortgageDownPaymentAmount?: InputMaybe<Scalars['Int']['input']>;
  mortgageDownPaymentBps?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferFinancingInput = {
  fundingSource?: InputMaybe<OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferFinancing_FundingSource>;
  id?: InputMaybe<Scalars['String']['input']>;
  loanContingencyDays?: InputMaybe<Scalars['Int']['input']>;
  mortgagePreapproval?: InputMaybe<Scalars['Boolean']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferFinancing_FundingSource {
  /** @deprecated No longer supported */
  CASH = 'CASH',
  /** @deprecated No longer supported */
  MORTGAGE = 'MORTGAGE',
  /** @deprecated No longer supported */
  UNKNOWN_FUNDING_SOURCE = 'UNKNOWN_FUNDING_SOURCE'
}

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferLenderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  lenderCompanyName?: InputMaybe<Scalars['String']['input']>;
  lenderEmail?: InputMaybe<Scalars['String']['input']>;
  lenderName?: InputMaybe<Scalars['String']['input']>;
  lenderPhone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferPriceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  pricingAssistance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosBuyerServicesBuyer_PartnerTourRequestRequests_CreatePartnerTourRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  timeslot?: InputMaybe<OdProtosCommonBuyer_TimeslotInput>;
};

export type OdProtosBuyerServicesBuyer_PhoneVerificationRequests_CheckVerificationStatusForCurrentUserInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PhoneVerificationRequests_SendVerificationCodeInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PhoneVerificationRequests_VerifyPhoneInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PricingRequestRequests_GetPricingRequestByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyPhotoRequests_GetPropertyPhotosByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyPhotoRequests_GetPropertyPhotosByAddressIdsInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_FavoritePropertyInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetAddressIdByPropertyIdInput = {
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetFavoritePropertiesForCurrentUserInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUserInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sortKey?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUser_SortKey>;
};

export enum OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUser_SortKey {
  /** @deprecated No longer supported */
  SORT_KEY_DEFAULT = 'SORT_KEY_DEFAULT',
  /** @deprecated No longer supported */
  SORT_KEY_POPULAR_AT_DESC = 'SORT_KEY_POPULAR_AT_DESC'
}

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetHomebuilderDetailsByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetHomebuilderPropertiesByCommunityInput = {
  builderName?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetIsFavoritePropertyByAddressIdsInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetIsFavoritePropertyByIdsInput = {
  propertyIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetMlsListingAgentByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetOpenHousesForPropertiesInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByAddressIdsInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByGeometryInput = {
  /** If specified, filter criteria will be applied to limit the search results */
  filters?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  /** GeoJSON shape (must be polygon or multipolygon) */
  shape?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_SortKey>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQueryInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQuery_LocationInput>;
  queryString?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQuery_LocationInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesStatsByMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesStatsForPropertiesFilterInput = {
  feedPropertiesFilter?: InputMaybe<OdProtosBuyerData_User_FeedPropertiesFilterInput>;
  /** DEPRECATED: Use feed_properties_filter */
  propertiesFilter?: InputMaybe<OdProtosBuyerData_User_PropertiesFilterInput>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyByParamsIdInput = {
  paramsId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyCompsByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyMarkersByGeometryInput = {
  /** If specified, filter criteria will be applied to limit the search results */
  filters?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput>;
  /** GeoJSON shape (must be polygon or multipolygon) */
  shape?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_SortKey>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetSimilarPropertiesByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

/** Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry */
export type OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry */
export type OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFloatFilterInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry */
export type OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput = {
  /** Only min value is used for bathrooms */
  bathroomsTotal?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFloatFilterInput>;
  /** Only min value is used for bedrooms */
  bedrooms?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  currentListPrice?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  dwellingTypes?: InputMaybe<Array<OdProtosBuyerData_Property_PropertyType>>;
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  isFhaEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isOpendoorBackedOfferEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isOpendoorOwned?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleStory?: InputMaybe<Scalars['Boolean']['input']>;
  lotSqFt?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  /** Only max value is used for monthly hoa dues */
  monthlyHoaDues?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  onlyHomebuilder?: InputMaybe<Scalars['Boolean']['input']>;
  onlyInstantTourable?: InputMaybe<Scalars['Boolean']['input']>;
  totalLivingSqFt?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  yearBuilt?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_RemoveFavoritePropertyInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

/** Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry */
export enum OdProtosBuyerServicesBuyer_PropertyRequests_SortKey {
  /** @deprecated No longer supported */
  SORT_KEY_CURRENT_LIST_PRICE_ASC = 'SORT_KEY_CURRENT_LIST_PRICE_ASC',
  /** @deprecated No longer supported */
  SORT_KEY_CURRENT_LIST_PRICE_DESC = 'SORT_KEY_CURRENT_LIST_PRICE_DESC',
  /** @deprecated No longer supported */
  SORT_KEY_DEFAULT = 'SORT_KEY_DEFAULT',
  /** @deprecated No longer supported */
  SORT_KEY_LISTED_AT_ASC = 'SORT_KEY_LISTED_AT_ASC',
  /** @deprecated No longer supported */
  SORT_KEY_LISTED_AT_DESC = 'SORT_KEY_LISTED_AT_DESC',
  /** @deprecated No longer supported */
  SORT_KEY_TOTAL_LIVING_SQ_FT_ASC = 'SORT_KEY_TOTAL_LIVING_SQ_FT_ASC',
  /** @deprecated No longer supported */
  SORT_KEY_TOTAL_LIVING_SQ_FT_DESC = 'SORT_KEY_TOTAL_LIVING_SQ_FT_DESC'
}

export type OdProtosBuyerServicesBuyer_RatingRequests_GetRatingDetailsByIdInput = {
  /** BSON::ObjectId of the rating */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_RatingRequests_GetRatingsByAgentIdInput = {
  /** BSON::ObjectId of the agent */
  agentId?: InputMaybe<Scalars['String']['input']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_CancelShowingRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  inactiveReason?: InputMaybe<OdProtosBuyerData_ShowingRequest_InactiveReason>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_CreateShowingRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  odPhoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  openCallEligible?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  timeslots?: InputMaybe<Array<OdProtosCommonBuyer_TimeslotInput>>;
  tourId?: InputMaybe<Scalars['String']['input']>;
  trialTour?: InputMaybe<Scalars['Boolean']['input']>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  virtualContact?: InputMaybe<Scalars['String']['input']>;
  virtualPlatform?: InputMaybe<OdProtosBuyerData_ShowingRequest_VirtualPlatform>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestOperationalDataByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsByTourIdsInput = {
  tourIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsForCurrentUserInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  showingRequestFilter?: InputMaybe<OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsForCurrentUser_ShowingRequestFilter>;
};

export enum OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsForCurrentUser_ShowingRequestFilter {
  /** @deprecated No longer supported */
  ACTIVE = 'ACTIVE',
  /** @deprecated No longer supported */
  ALL = 'ALL',
  /** @deprecated No longer supported */
  INACTIVE = 'INACTIVE'
}

export type OdProtosBuyerServicesBuyer_TaskRequests_GetTaskByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_TaskRequests_GetTasksByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_TaskRequests_GetTasksByOfferIdInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatusInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatus_Status>;
};

export enum OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatus_Status {
  /** @deprecated No longer supported */
  CANCELED = 'CANCELED',
  /** @deprecated No longer supported */
  COMPLETED = 'COMPLETED',
  /** @deprecated No longer supported */
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type OdProtosBuyerServicesBuyer_TourRequests_CancelTourInput = {
  cancelationReason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetTourByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetTourDetailsByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetToursByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUserInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  tourFilter?: InputMaybe<OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUser_TourFilter>;
};

export enum OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUser_TourFilter {
  /** @deprecated No longer supported */
  ALL = 'ALL',
  /** @deprecated No longer supported */
  FUTURE = 'FUTURE',
  /** @deprecated No longer supported */
  NEEDS_FOLLOWUP = 'NEEDS_FOLLOWUP',
  /** @deprecated No longer supported */
  PAST = 'PAST'
}

export type OdProtosBuyerServicesBuyer_TourRequests_UpdateTourTimeslotInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  timeslot?: InputMaybe<OdProtosCommonBuyer_TimeslotInput>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_GetCurrentUserInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_GetUserByHumanTokenInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_GetUserByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_GetUsersByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserBuyingPowerInput = {
  annualHouseholdIncome?: InputMaybe<Scalars['Float']['input']>;
  creditScoreIndicated?: InputMaybe<OdProtosBuyerData_User_CreditRating>;
  downPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  monthlyDebt?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserContactInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserFinancingInput = {
  attribution?: InputMaybe<OdProtosCommonBuyer_AttributionInput>;
  ownLender?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserHubBaseRouteInput = {
  hubBaseRoute?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserLearnMoreRequestedInput = {
  learnMoreRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserMarketIdentifierInput = {
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserPropertiesFilterForCurrentUserInput = {
  feedPropertiesFilter?: InputMaybe<OdProtosBuyerData_User_FeedPropertiesFilterInput>;
  /** DEPRECATED: Use feed_properties_filter */
  propertiesFilter?: InputMaybe<OdProtosBuyerData_User_PropertiesFilterInput>;
};

export type OdProtosBuyerServicesBuyer_ViewingAppointmentRequests_GetViewingAppointmentByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_ViewingAppointmentRequests_GetViewingAppointmentsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_VisitRequests_GetVisitByIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerServicesBuyer_VisitRequests_GetVisitsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_VisitRequests_GetVisitsForCurrentUserInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosBuyerServicesBuyer_ZoneRequests_GetZoneSuggestionsByGdsZoneIdsInput = {
  forAutoFeedSetup?: InputMaybe<Scalars['Boolean']['input']>;
  gdsZoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerServicesBuyer_ZoneRequests_GetZonesByTextQueryInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosBuyerV2Data_PropertyType {
  PROPERTY_TYPE_CONDO = 'PROPERTY_TYPE_CONDO',
  PROPERTY_TYPE_HOME = 'PROPERTY_TYPE_HOME',
  PROPERTY_TYPE_TOWNHOME = 'PROPERTY_TYPE_TOWNHOME',
  PROPERTY_TYPE_UNKNOWN = 'PROPERTY_TYPE_UNKNOWN'
}

export enum OdProtosBuyerV2Data_Reaction {
  REACTION_DISLIKE = 'REACTION_DISLIKE',
  REACTION_LIKE = 'REACTION_LIKE',
  REACTION_UNKNOWN = 'REACTION_UNKNOWN'
}

export enum OdProtosBuyerV2Data_ReactionSource {
  REACTION_SOURCE_AVAILABLE_SOON_SIGNAGE_EMAIL_UPDATES = 'REACTION_SOURCE_AVAILABLE_SOON_SIGNAGE_EMAIL_UPDATES',
  REACTION_SOURCE_GALLERY = 'REACTION_SOURCE_GALLERY',
  /**
   * deprecated
   * @deprecated No longer supported
   */
  REACTION_SOURCE_SAVED_HOMES_FAVORITE = 'REACTION_SOURCE_SAVED_HOMES_FAVORITE',
  REACTION_SOURCE_SELF_UNLOCK_GET_EMAIL_UPDATES = 'REACTION_SOURCE_SELF_UNLOCK_GET_EMAIL_UPDATES',
  REACTION_SOURCE_SELF_UNLOCK_SWIPE = 'REACTION_SOURCE_SELF_UNLOCK_SWIPE',
  REACTION_SOURCE_UNKNOWN = 'REACTION_SOURCE_UNKNOWN',
  /**
   * deprecated in favor of more specific sources
   * @deprecated No longer supported
   */
  REACTION_SOURCE_WEB_PDP = 'REACTION_SOURCE_WEB_PDP',
  REACTION_SOURCE_WEB_PDP_ADD_TOUR_REQUEST_TO_CART = 'REACTION_SOURCE_WEB_PDP_ADD_TOUR_REQUEST_TO_CART',
  /**
   * deprecated
   * @deprecated No longer supported
   */
  REACTION_SOURCE_WEB_PDP_BUYER_DRIVEN_SUPPLY_INTERESTED_IN_TOURING = 'REACTION_SOURCE_WEB_PDP_BUYER_DRIVEN_SUPPLY_INTERESTED_IN_TOURING',
  /**
   * deprecated
   * @deprecated No longer supported
   */
  REACTION_SOURCE_WEB_PDP_BUYER_DRIVEN_SUPPLY_START_AN_OFFER = 'REACTION_SOURCE_WEB_PDP_BUYER_DRIVEN_SUPPLY_START_AN_OFFER',
  REACTION_SOURCE_WEB_PDP_EMAIL_UPDATES = 'REACTION_SOURCE_WEB_PDP_EMAIL_UPDATES',
  REACTION_SOURCE_WEB_PDP_FAVORITE = 'REACTION_SOURCE_WEB_PDP_FAVORITE',
  REACTION_SOURCE_WEB_PDP_OFFER = 'REACTION_SOURCE_WEB_PDP_OFFER',
  REACTION_SOURCE_WEB_PDP_SELF_TOUR = 'REACTION_SOURCE_WEB_PDP_SELF_TOUR',
  /**
   * deprecated
   * @deprecated No longer supported
   */
  REACTION_SOURCE_WEB_PDP_SELLER_DISCLOSURE_REQUEST = 'REACTION_SOURCE_WEB_PDP_SELLER_DISCLOSURE_REQUEST',
  REACTION_SOURCE_WEB_PDP_TOUR_REQUEST = 'REACTION_SOURCE_WEB_PDP_TOUR_REQUEST'
}

/**
 * User-defined search criteria for the properties they're looking for. This is
 * used for the feed, and map.
 *
 * Boolean values should be named with an "Only" suffix so that false values
 * aren't ambiguous with "don't apply this filter" vs "exclude things matching
 * this" (which is never the case).
 *
 * Saved Search was formerly known as Property Filters in the now deprecated
 * version of the "buyer" service. This replaces the PropertyFilters and
 * FeedPropertyFilters defined in user.proto
 */
export type OdProtosBuyerV2Data_SavedSearchInput = {
  bathrooms?: InputMaybe<OdProtosCommon_FloatRangeInput>;
  bedrooms?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  fhaEligibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoolOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier for the SavedSearch */
  id?: InputMaybe<Scalars['String']['input']>;
  lotSqft?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  maxMonthlyHoaFee?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** The customer-facing name for the SavedSearch */
  name?: InputMaybe<Scalars['String']['input']>;
  opendoorOwnedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The reason that the SavedSearch was created */
  origin?: InputMaybe<OdProtosBuyerV2Data_SearchOrigin>;
  price?: InputMaybe<OdProtosCommon_MoneyRangeInput>;
  propertyTypes?: InputMaybe<Array<OdProtosBuyerV2Data_PropertyType>>;
  selfTourableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  singleStoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sqft?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  yearBuilt?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** SearchOrigin enumerates the entities who can create Buyer's saved searches. */
export enum OdProtosBuyerV2Data_SearchOrigin {
  /** The Buyer directly created the SaveSearch */
  SEARCH_ORIGIN_BUYER = 'SEARCH_ORIGIN_BUYER',
  /** The SavedSearch was created for the Buyer by their buying agent */
  SEARCH_ORIGIN_BUYERS_AGENT = 'SEARCH_ORIGIN_BUYERS_AGENT',
  SEARCH_ORIGIN_UNKNOWN = 'SEARCH_ORIGIN_UNKNOWN'
}

/**
 * Buyer-provided feedback fields safe to emit in events.
 * Excludes free_text (may contain PII).
 * Next ID: 6
 */
export type OdProtosBuyerV2Data_TourFeedbackInputInput = {
  /** Aspects the buyer disliked (e.g., "small_bedrooms", "busy_street", "no_garage") */
  dislikedAspects?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Aspects the buyer liked about the property (e.g., "layout", "kitchen", "backyard") */
  likedAspects?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Overall sentiment about the tour experience */
  sentiment?: InputMaybe<OdProtosBuyerV2Data_TourFeedbackSentiment>;
  /** How the feedback was collected */
  source?: InputMaybe<OdProtosBuyerV2Data_TourFeedbackSource>;
  /** Whether the buyer wants to see similar properties */
  wantsSimilarHomes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sentiment expressed by a buyer after completing a tour */
export enum OdProtosBuyerV2Data_TourFeedbackSentiment {
  TOUR_FEEDBACK_SENTIMENT_NEGATIVE = 'TOUR_FEEDBACK_SENTIMENT_NEGATIVE',
  TOUR_FEEDBACK_SENTIMENT_NEUTRAL = 'TOUR_FEEDBACK_SENTIMENT_NEUTRAL',
  TOUR_FEEDBACK_SENTIMENT_POSITIVE = 'TOUR_FEEDBACK_SENTIMENT_POSITIVE',
  TOUR_FEEDBACK_SENTIMENT_UNKNOWN = 'TOUR_FEEDBACK_SENTIMENT_UNKNOWN'
}

/** Source/trigger for collecting the feedback */
export enum OdProtosBuyerV2Data_TourFeedbackSource {
  TOUR_FEEDBACK_SOURCE_EMAIL_PROMPT = 'TOUR_FEEDBACK_SOURCE_EMAIL_PROMPT',
  TOUR_FEEDBACK_SOURCE_MANUAL = 'TOUR_FEEDBACK_SOURCE_MANUAL',
  TOUR_FEEDBACK_SOURCE_MOBILE_CAROUSEL = 'TOUR_FEEDBACK_SOURCE_MOBILE_CAROUSEL',
  TOUR_FEEDBACK_SOURCE_POST_TOUR_MODAL = 'TOUR_FEEDBACK_SOURCE_POST_TOUR_MODAL',
  TOUR_FEEDBACK_SOURCE_PUSH_NOTIFICATION = 'TOUR_FEEDBACK_SOURCE_PUSH_NOTIFICATION',
  TOUR_FEEDBACK_SOURCE_UNKNOWN = 'TOUR_FEEDBACK_SOURCE_UNKNOWN'
}

/** Why this property was recommended */
export enum OdProtosBuyerV2Data_TourRecommendationReason {
  TOUR_RECOMMENDATION_REASON_MATCHES_PREFERENCES = 'TOUR_RECOMMENDATION_REASON_MATCHES_PREFERENCES',
  TOUR_RECOMMENDATION_REASON_NEW_LISTING = 'TOUR_RECOMMENDATION_REASON_NEW_LISTING',
  TOUR_RECOMMENDATION_REASON_POPULAR_IN_AREA = 'TOUR_RECOMMENDATION_REASON_POPULAR_IN_AREA',
  TOUR_RECOMMENDATION_REASON_PRICE_REDUCED = 'TOUR_RECOMMENDATION_REASON_PRICE_REDUCED',
  TOUR_RECOMMENDATION_REASON_SIMILAR_TO_LIKED = 'TOUR_RECOMMENDATION_REASON_SIMILAR_TO_LIKED',
  TOUR_RECOMMENDATION_REASON_UNKNOWN = 'TOUR_RECOMMENDATION_REASON_UNKNOWN'
}

export type OdProtosBuyerV2ServicesBuyer_AddSavedSearchRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  savedSearch?: InputMaybe<OdProtosBuyerV2Data_SavedSearchInput>;
};

/**
 * Specify a time range to get the number of times a buyer liked a home
 * within that time range.
 */
export type OdProtosBuyerV2ServicesBuyer_AddressReactionCountsForTimeRangeRequestInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  reactionType?: InputMaybe<OdProtosBuyerV2Data_Reaction>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_FindBuyersByPropertyReactionRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  /** only return buyers whose reacted after this timestamp */
  reactedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  reaction?: InputMaybe<OdProtosBuyerV2Data_Reaction>;
};

export type OdProtosBuyerV2ServicesBuyer_FindBuyersBySavedSearchesRequestInput = {
  bathrooms?: InputMaybe<OdProtosCommon_FloatRangeInput>;
  bedrooms?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  /** must be > 0 */
  limit?: InputMaybe<Scalars['Float']['input']>;
  lotSqft?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  price?: InputMaybe<OdProtosCommon_MoneyRangeInput>;
  /** required */
  propertyType?: InputMaybe<OdProtosBuyerV2Data_PropertyType>;
  sqft?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  yearBuilt?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  /** required */
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosBuyerV2ServicesBuyer_GetBuyerRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_GetBuyersByAgentIdRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_GetBuyersWithAgentsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_GetPropertyReactionsByCustomerIdRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<OdProtosBuyerV2Data_Reaction>;
};

/** GetTourFeedbacksByCustomer - Get feedback history for a customer */
export type OdProtosBuyerV2ServicesBuyer_GetTourFeedbacksByCustomerRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
};

/** GetTourRecommendations - Get recommended properties to tour */
export type OdProtosBuyerV2ServicesBuyer_GetTourRecommendationsRequestInput = {
  /** Optional address UUID to anchor recommendations against (e.g., the most recent tour). */
  anchorAddressId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: use anchor_address_id instead. */
  anchorChannelId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: use anchor_address_id instead. */
  anchorListingId?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  /** Default 5, max 20 */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional market slug to scope recommendations to (e.g., "atlanta", "phoenix").
   * When set, overrides the market derived from tour feedback history.
   */
  market?: InputMaybe<Scalars['String']['input']>;
};

/** GetUserTourPreferences - Get the user's current tour preferences/state */
export type OdProtosBuyerV2ServicesBuyer_GetUserTourPreferencesRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_OverrideBuyerTimestampsRequestInput = {
  /** the web customer id */
  customerId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  /** the timestamp the buyer was created in OLA */
  olaBuyerCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the timestamp the filter was updated in OLA */
  olaPropertyFilterUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_RemoveAgentIdRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_RemovePropertyReactionRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_RemoveSavedSearchRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_SetAgentIdRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_SetPropertyReactionRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<OdProtosBuyerV2Data_Reaction>;
  source?: InputMaybe<OdProtosBuyerV2Data_ReactionSource>;
};

export type OdProtosBuyerV2ServicesBuyer_SetSavedSearchRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  savedSearch?: InputMaybe<OdProtosBuyerV2Data_SavedSearchInput>;
};

export type OdProtosBuyerV2ServicesBuyer_SetSelectedMarketRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** SubmitTourFeedback - Submit feedback after completing a tour */
export type OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  /** Buyer-provided feedback fields safe to emit in events. */
  feedback?: InputMaybe<OdProtosBuyerV2Data_TourFeedbackInputInput>;
  /**
   * Optional free-form text feedback. This may contain PII and is intentionally not emitted
   * in TourFeedbackEvent.
   */
  freeText?: InputMaybe<Scalars['String']['input']>;
  /**
   * The home that was toured. Only one identifier should be provided; the server can
   * resolve the others to avoid mismatches between IDs.
   */
  touredHome?: InputMaybe<OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequest_TouredHomeOneofInput>;
  /** Viewing Appointments identifier for the tour booking (preferred over Visitante visit_id). */
  viewingAppointmentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequest_TouredHomeOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Channel identifier for the home (e.g., BuyDirect channel ID).
   * format: UUID string representation
   */
  channelId?: InputMaybe<Scalars['String']['input']>;
  /** Web listing identifier (od_protos.web.data.Listing.listing_id). */
  listingId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosBuyerV2ServicesBuyer_UpdateSavedSearchRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  savedSearch?: InputMaybe<OdProtosBuyerV2Data_SavedSearchInput>;
};

export type OdProtosCabinetData_AssetInput = {
  attachments?: InputMaybe<Array<OdProtosCabinetData_AttachmentInput>>;
  /** true if the attachments have been loaded for this asset */
  attachmentsLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageData?: InputMaybe<OdProtosCabinetData_ImageDataInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** The immutable name of this asset. May be empty. */
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** A public URL or a signed URL to access the asset (default validity: 7 days). */
  rawDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** The source service name */
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosCabinetData_Asset_Type>;
};

export enum OdProtosCabinetData_Asset_Type {
  AUDIO = 'AUDIO',
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  /** Error if unknown. Must be specified when creating the asset */
  UNKNOWN = 'UNKNOWN',
  VIDEO = 'VIDEO'
}

export type OdProtosCabinetData_AttachmentInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The major of the attachment.
   * This may be an identifier of an object like "SellRequest#123" | "Address#123"
   */
  major?: InputMaybe<Scalars['String']['input']>;
  /**
   * An additional categorization of the attachment
   * e.g. "seller" | "external" | "internal" etc.
   */
  minor?: InputMaybe<Scalars['String']['input']>;
  /** The source of the attached object. i.e. the host system that owns the attachment */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCabinetData_ImageDataInput = {
  /** Only present if type is `IMAGE` */
  sizedDownloadUrls?: InputMaybe<Array<OdProtosCabinetData_SizedDownloadUrlInput>>;
};

/**
 * Sets the size modifier for photos.
 *
 * If both horizontal size and vertical size is unset, the raw image will be returned
 */
export type OdProtosCabinetData_SizeModifierInput = {
  /** Sets the horizontal size. If blank will be resized proportionally */
  horizontalSize?: InputMaybe<Scalars['Float']['input']>;
  /** The name of the size modifier */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sets the vertical size. If blank will be resized proportionally */
  verticalSize?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCabinetData_SizedDownloadUrlInput = {
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Attaches assets to an external entity. O(len(ids) * len(attached_to)). */
export type OdProtosCabinetService_AssetRequests_AttachInput = {
  /**
   * The assets to attach to the assets with the ids from `ids`. The
   * `asset_id` fields of the attachments are ignored.
   */
  attachedTo?: InputMaybe<Array<OdProtosCabinetData_AttachmentInput>>;
  /** The assets to attach each of the attachments to. */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCabinetService_AssetRequests_BulkCreateAssetsInput = {
  createAssets?: InputMaybe<Array<OdProtosCabinetService_AssetRequests_CreateAssetInput>>;
};

export type OdProtosCabinetService_AssetRequests_CompleteMultipartUploadInput = {
  fullPath?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<OdProtosCabinetService_AssetRequests_CompleteMultipartUpload_CompletedPartInput>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCabinetService_AssetRequests_CompleteMultipartUpload_CompletedPartInput = {
  etag?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCabinetService_AssetRequests_CreateAssetInput = {
  /**
   * The asset type to use.
   * The type you choose will affect the downloading and behaviour of what can be done with the asset
   */
  assetType?: InputMaybe<OdProtosCabinetData_Asset_Type>;
  attachTo?: InputMaybe<Array<OdProtosCabinetData_AttachmentInput>>;
  /** the path of the uploaded file (including prefix) */
  fullPath?: InputMaybe<Scalars['String']['input']>;
  /**
   * For async requests, if a request is marked as high_priority=true
   * the asset will be processed in a faster queue
   */
  highPriority?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optionaly set the UUID for this upload.
   * If not set, a UUID will be issued to you
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Returns the asset with sized images, works the same as 'GetAssets' */
  imageSizes?: InputMaybe<Array<OdProtosCabinetData_SizeModifierInput>>;
  /** The immutable name of this asset. May be empty. */
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCabinetService_AssetRequests_CreateMultipartUploadInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  partCount?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCabinetService_AssetRequests_GetAssetsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  imageFormat?: InputMaybe<OdProtosCabinetService_AssetRequests_ImageFormat>;
  /** Add size modifiers for requesting images */
  imageSizes?: InputMaybe<Array<OdProtosCabinetData_SizeModifierInput>>;
  includeAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  preventAclSync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCabinetService_AssetRequests_GetUploadCredentialsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCabinetService_AssetRequests_GetUploadUrlInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCabinetService_AssetRequests_GetUploadUrLsInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosCabinetService_AssetRequests_ImageFormat {
  IMAGE_FORMAT_JPEG = 'IMAGE_FORMAT_JPEG',
  IMAGE_FORMAT_UNSPECIFIED = 'IMAGE_FORMAT_UNSPECIFIED',
  IMAGE_FORMAT_WEBP = 'IMAGE_FORMAT_WEBP'
}

/** Replaces the underlying file that the asset points to */
export type OdProtosCabinetService_AssetRequests_ReplaceAssetInput = {
  fullPath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCabinetService_AssetRequests_SearchInput = {
  attachedTo?: InputMaybe<Array<OdProtosCabinetData_AttachmentInput>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  imageFormat?: InputMaybe<OdProtosCabinetService_AssetRequests_ImageFormat>;
  imageSizes?: InputMaybe<Array<OdProtosCabinetData_SizeModifierInput>>;
  includeAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  includeTypes?: InputMaybe<Array<OdProtosCabinetData_Asset_Type>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosCabinetService_AssetRequests_TriggerConversionInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 32 */
export type OdProtosCasaData_AddressInput = {
  censusBlock?: InputMaybe<Scalars['String']['input']>;
  censusTract?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  countyFips?: InputMaybe<Scalars['String']['input']>;
  geoAccuracy?: InputMaybe<OdProtosCasaData_GeoAccuracy>;
  isMissingUnitNumber?: InputMaybe<Scalars['Boolean']['input']>;
  lastLine?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  placeName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Array<OdProtosCasaData_Result>>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  updatedToUuid?: InputMaybe<Scalars['String']['input']>;
  /** UUID identifier for the address. Previously known as address_token. */
  uuid: Scalars['ID']['input'];
  zipPlus4?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosCasaData_GeoAccuracy {
  GEO_APPROXIMATE = 'GEO_APPROXIMATE',
  GEO_ERROR = 'GEO_ERROR',
  GEO_ROOFTOP = 'GEO_ROOFTOP',
  GEO_ROOFTOP_INTERPOLATED = 'GEO_ROOFTOP_INTERPOLATED',
  GEO_STREET_LEVEL = 'GEO_STREET_LEVEL',
  GEO_UNKNOWN = 'GEO_UNKNOWN'
}

export enum OdProtosCasaData_Result {
  /** The address has been detected as an upcoming area. */
  ADDRESS_COMING_SOON = 'ADDRESS_COMING_SOON',
  /** The address contains unnecessary sub-premise or other information. */
  ADDRESS_EXTRANEOUS_INPUT = 'ADDRESS_EXTRANEOUS_INPUT',
  /** The address is invalid. */
  ADDRESS_INVALID = 'ADDRESS_INVALID',
  /** The address has an invalid box number. */
  ADDRESS_INVALID_BOX_NUMBER = 'ADDRESS_INVALID_BOX_NUMBER',
  /** The address has an invalid street number. */
  ADDRESS_INVALID_PREMISE = 'ADDRESS_INVALID_PREMISE',
  /** The address street is invalid. */
  ADDRESS_INVALID_STREET = 'ADDRESS_INVALID_STREET',
  /** The address has an invalid sub-premise (e.g. suite). */
  ADDRESS_INVALID_SUB_PREMISE = 'ADDRESS_INVALID_SUB_PREMISE',
  /** The address is missing the box number. */
  ADDRESS_MISSING_BOX_NUMBER = 'ADDRESS_MISSING_BOX_NUMBER',
  /** The address is missing a street number. */
  ADDRESS_MISSING_PREMISE = 'ADDRESS_MISSING_PREMISE',
  /** The address is missing the sub-premise (e.g. suite). */
  ADDRESS_MISSING_SUB_PREMISE = 'ADDRESS_MISSING_SUB_PREMISE',
  /**
   * The address is the "nil" address. This address is used globally as the alias
   * for all bad addresses. The definition of bad address will change over time,
   * but is currently used for completely invalid inputs, e.g. missing the postal
   * code and city/state/country information to locate, or has an obviously invalid
   * input such as a street name that looks like a UUID.
   */
  ADDRESS_NIL = 'ADDRESS_NIL',
  /** The address is not "real" (e.g. PO box, military address). */
  ADDRESS_NOT_REAL = 'ADDRESS_NOT_REAL',
  /** The address is not supported (e.g. overseas). */
  ADDRESS_NOT_SUPPORTED = 'ADDRESS_NOT_SUPPORTED',
  ADDRESS_UNKNOWN = 'ADDRESS_UNKNOWN',
  /** The address is unoccupied. */
  ADDRESS_VACANT = 'ADDRESS_VACANT',
  /** The address is completely valid. */
  ADDRESS_VALID = 'ADDRESS_VALID',
  /** The address is valid at the street level. */
  ADDRESS_VALID_STREET = 'ADDRESS_VALID_STREET'
}

export type OdProtosCasaServices_CasaRequest_BulkManualCreateInput = {
  addresses?: InputMaybe<Array<OdProtosCasaData_AddressInput>>;
  /**
   * Usually Casa requires these to be non-null: street, city, state, postal_code
   * Set AllowIncompleteAddress=true to skip these checks. Used if you don't want Casa to error for any reason.
   */
  allowIncompleteAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCasaServices_CasaRequest_CreateAliasInput = {
  editorComments?: InputMaybe<Scalars['String']['input']>;
  /** editor info is not used, will be discarded */
  editorEmail?: InputMaybe<Scalars['String']['input']>;
  updatedToUuid?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_FindAliasInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_FindByFieldsInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** An alternative to specifying city, state, postal code. */
  lastLine?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_FindCountyFipsInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_FindInput = {
  /** UUID identifier for the address. Previously known as address_token. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_FindReferencesInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_FindSignaturesInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_GetRestandardizeStateInput = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_InvalidateSignatureInput = {
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_ListAliasInput = {
  uuid?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCasaServices_CasaRequest_ListInput = {
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCasaServices_CasaRequest_ListUnitsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_ManualCreateInput = {
  address?: InputMaybe<OdProtosCasaData_AddressInput>;
  /**
   * Usually Casa requires these to be non-null: street, city, state, postal_code
   * Set AllowIncompleteAddress=true to skip these checks. Used if you don't want Casa to error for any reason.
   */
  allowIncompleteAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCasaServices_CasaRequest_RandomInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCasaServices_CasaRequest_RestandardizeInput = {
  skipUpdateEvent?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_SetRestandardizeStateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_UuiDsInput = {
  afterUuid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCasaServices_CasaRequest_UpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  geoAccuracy?: InputMaybe<OdProtosCasaData_GeoAccuracy>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Array<OdProtosCasaData_Result>>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCasaServices_CasaRequest_UpdateSignatureInput = {
  signature?: InputMaybe<Scalars['String']['input']>;
  updatedToUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Data_PermissionsInput = {
  owningBranchId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Empty here means all roles not no roles have access.
   * There is no way to restrict access to no roles.
   */
  rolesWithAccess?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCaseyV0Data_SlaInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OdProtosCaseyV0Data_Sla_SlaType>;
};

export enum OdProtosCaseyV0Data_Sla_SlaType {
  RESOLUTION = 'RESOLUTION'
}

export type OdProtosCaseyV0Data_SourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Use string instead of an enum because we could end up keying out task data on other data models,
   * and we wouldn't want to have to update Casey every time we introduce a new data model.
   * Use lower case, snake case representation of your model's name as the type,
   * e.g. address, offer, valuation, pricing_qa.
   */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Data_StartWorkRequestInput = {
  /** Human/Service starting the task */
  actor?: InputMaybe<OdProtosCaseyV0Data_WorkLog_ActorInput>;
  /** NOW() used if blank */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV0Data_TaskInput = {
  /**
   * The time this task became active. If not set, defaults to time of creation.
   * Example1: we need to run a backfill, that involves deleting and recreating tasks,
   * so the rows will have a created_at time of now, but keep the original activated_at
   * time to refer to when the task was available to be worked on so that our metrics
   * (time to close/time to claim/etc) are still accurate.
   * Example2: a job creates tasks at midnight, but they are not intended to be able to
   * be worked on until 9am, so the activated_at time gets set to 9am, while the created_at
   * time is still midnight. This ensures that we don't have big lags between activated_at and
   * claimed due to the task not being workable until 9am, to maintain accurate metrics.
   */
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Close code is used to identify why a task is CLOSED.
   * Example: happy path, duplicated task, etc.
   */
  closeCode?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  escalationLevel?: InputMaybe<Scalars['Float']['input']>;
  /**
   * A snapshot of this task input and output when task is CLOSED.
   * for OPEN task: it should be empty.
   * for CLOSED task: it should be consistent with the most recent snapshot in the worklogs.
   */
  finalSnapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OdProtosCaseyV0Data_Task_OwnerInput>;
  permissions?: InputMaybe<OdProtosCaseyV0Data_PermissionsInput>;
  regionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  slas?: InputMaybe<Array<OdProtosCaseyV0Data_SlaInput>>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  sources?: InputMaybe<Array<OdProtosCaseyV0Data_SourceInput>>;
  status?: InputMaybe<OdProtosCaseyV0Data_Task_Status>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Arbitrary task data.
   * Document the source proto in task_data.type_url
   */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  workLogs?: InputMaybe<Array<OdProtosCaseyV0Data_WorkLogInput>>;
};

export type OdProtosCaseyV0Data_TaskSearchFiltersInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Leave empty for including all tasks */
  excludeTasksByActor?: InputMaybe<OdProtosCaseyV0Data_WorkLog_ActorInput>;
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxActivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxEscalationLevel?: InputMaybe<Scalars['Int']['input']>;
  minActivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minEscalationLevel?: InputMaybe<Scalars['Int']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, results will show only tasks that have no owner */
  onlyNilOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, results will show only tasks that have an owner */
  onlyNotNilOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Leave empty for tasks owned by anyone */
  owner?: InputMaybe<OdProtosCaseyV0Data_Task_OwnerInput>;
  owningBranchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  regionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sla?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFilters_SlaInput>>;
  /** Optional; if unspecified sorting behavior is undefined */
  sorting?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_SortingInput>;
  /**
   * Take the union of sources of the same type and intersection of sources of different types.
   * E.g. if we have the following sources specified:
   * [{id: "A", type: ADDRESS}, {id: "B", type: ADDRESS}, {id: "C", type: Contact}]
   * then we will look up tasks that has (address == "A" || address == "B") && (contact == "C").
   * Note: There cannot be more than 100 source IDs passed for the filter
   */
  sources?: InputMaybe<Array<OdProtosCaseyV0Data_SourceInput>>;
  /** Leave empty for all statuses */
  statuses?: InputMaybe<Array<OdProtosCaseyV0Data_Task_Status>>;
  /**
   * Input a name and value to filter on task data. If you omit the value,
   * you can filter for all tasks where the task_type matches the name.
   */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  workLog?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_WorkLogInput>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_SlaInput = {
  completedAt?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_TimeRestrictionInput>;
  deadlineAt?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_TimeRestrictionInput>;
  /** Deprecated don't use me!!! */
  dueRestrictions?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sla_DueRestrictionsOneofInput>;
  type?: InputMaybe<OdProtosCaseyV0Data_Sla_SlaType>;
};

/** DO NOT USE - deprecated */
export enum OdProtosCaseyV0Data_TaskSearchFilters_Sla_Due {
  /**
   * this will get converted to time restriction with dueAfter = time.now
   * @deprecated No longer supported
   */
  NOT_DUE = 'NOT_DUE',
  /**
   * not valid - must set a restriction if you plan on filtering by SLA
   * @deprecated No longer supported
   */
  NO_FILTER = 'NO_FILTER',
  /**
   * this will get converted to time restriction with dueOnOrBefore = time.now
   * @deprecated No longer supported
   */
  OVERDUE = 'OVERDUE'
}

export type OdProtosCaseyV0Data_TaskSearchFilters_Sla_DueRestrictionsOneofInput = {
  due?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sla_Due>;
  timeRestriction?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sla_TimeRestrictionInput>;
};

/** DO NOT USE - deprecated */
export type OdProtosCaseyV0Data_TaskSearchFilters_Sla_TimeRestrictionInput = {
  /**
   * Must set either due_after or due_before
   * Tasks without the specified SLA will be excluded
   */
  dueAfter?: InputMaybe<Scalars['DateTime']['input']>;
  dueAtOrBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_SortingInput = {
  /** Today we only have singular order by (i.e. no secondary order by column). */
  primarySortingRule?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sorting_RuleInput>;
};

export enum OdProtosCaseyV0Data_TaskSearchFilters_Sorting_Direction {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  INVALID_DIRECTION = 'INVALID_DIRECTION'
}

export enum OdProtosCaseyV0Data_TaskSearchFilters_Sorting_Field {
  INVALID_FIELD = 'INVALID_FIELD',
  /**
   * Tasks without RESOLUTION_SLAs will be sorted after tasks with RESOLUTION_SLAs regardless
   * of direection
   *
   * Sorting by RESOLUTION_SLA_RATIO sorts by what percentage of the time from activation to deadline has passed,
   * thus taking into account that tasks that originally had deadlines in the very near future may have worse
   * consequences for missing that deadline by a small amount than those that were long.
   * If this assumption is not true for your use case, this is not the sort for you!
   */
  RESOLUTION_SLA = 'RESOLUTION_SLA',
  /**
   * Formula: (slas.deadline - current_time) / (slas.deadline - tasks.activated_at)
   * e.g. a task activated 10 hours ago, currently due in 1 hour,
   * is the same ratio as a task activated 10 days ago, currently due in 1 day
   * Overdue example
   * Task A is due 30 minutes ago, and activated 4 hours ago has a ratio ~ -0.14
   * Task B is due 30 minutes ago, and activated 40 hours ago has a ratio of ~ -0.013
   * Task A will sort before Task B since it has the lower ratio
   * (aka it's late by a larger % of the overall time it has been activated)
   */
  RESOLUTION_SLA_RATIO = 'RESOLUTION_SLA_RATIO'
}

export type OdProtosCaseyV0Data_TaskSearchFilters_Sorting_RuleInput = {
  direction?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sorting_Direction>;
  field?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sorting_Field>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_TimeRestrictionInput = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  atOrBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_WorkLogInput = {
  inProgress?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_WorkLog_InProgress>;
};

export enum OdProtosCaseyV0Data_TaskSearchFilters_WorkLog_InProgress {
  NO_FILTER = 'NO_FILTER',
  NO_WORK_IN_PROGRESS = 'NO_WORK_IN_PROGRESS',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS'
}

export type OdProtosCaseyV0Data_Task_OwnerInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosCaseyV0Data_Task_Status {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export type OdProtosCaseyV0Data_WorkLogInput = {
  actor?: InputMaybe<OdProtosCaseyV0Data_WorkLog_ActorInput>;
  duration?: InputMaybe<GoogleProtobuf_DurationInput>;
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  stopTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV0Data_WorkLog_ActorInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_Assign_RequestInput = {
  newOwner?: InputMaybe<OdProtosCaseyV0Data_Task_OwnerInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_CompleteSla_RequestInput = {
  /** NOW() used if blank */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slaType?: InputMaybe<OdProtosCaseyV0Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_Count_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFiltersInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV0Services_Create_RequestInput = {
  /** If allow duplicates is true tasks with all the same attributes may be created multiple times */
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** we'll ignore your task.id tho. */
  task?: InputMaybe<OdProtosCaseyV0Data_TaskInput>;
};

export type OdProtosCaseyV0Services_Deescalate_RequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_Escalate_RequestInput = {
  /** A snapshot of the task input and output. */
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_FindTask_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFiltersInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV0Services_GetTaskById_RequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_ListTasksByIds_RequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCaseyV0Services_RelatedObjectInput = {
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_SearchAndStart_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFiltersInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFiltersInput>>;
  startWorkRequest?: InputMaybe<OdProtosCaseyV0Data_StartWorkRequestInput>;
};

export type OdProtosCaseyV0Services_Search_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV0Services_SetSla_RequestInput = {
  newDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  slaType?: InputMaybe<OdProtosCaseyV0Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_SetStatus_RequestInput = {
  /** set this if you are going to set the task to CLOSED. */
  closeCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * set this if you want to set a new status
   * conditional on the current status matching
   */
  expectedCurrentStatus?: InputMaybe<OdProtosCaseyV0Services_SetStatus_Request_ExpectedCurrentStatusInput>;
  newStatus?: InputMaybe<OdProtosCaseyV0Data_Task_Status>;
  /** A snapshot of the task input and output. */
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_SetStatus_Request_ExpectedCurrentStatusInput = {
  status?: InputMaybe<OdProtosCaseyV0Data_Task_Status>;
};

export type OdProtosCaseyV0Services_Snooze_RequestInput = {
  /** unsnoozed if blank */
  newSnoozedUntil?: InputMaybe<OdProtosCaseyV0Services_Task_TimeInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_StartWork_RequestInput = {
  startWorkRequest?: InputMaybe<OdProtosCaseyV0Data_StartWorkRequestInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_Task_TimeInput = {
  time?: InputMaybe<OdProtosCaseyV0Services_Task_Time_TimeOneofInput>;
};

export type OdProtosCaseyV0Services_Task_Time_TimeOneofInput = {
  exactTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV0Services_UpdateFields_RequestInput = {
  sources?: InputMaybe<Array<OdProtosCaseyV0Data_SourceInput>>;
  /** usually for migrating from one task data type to another, do not use this in any usual cases or automated flows */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_UpdateRelatedObjectReference_RequestInput = {
  fromObjectId?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<OdProtosCaseyV0Services_UpdateRelatedObjectReference_Request_SearchByOneofInput>;
  toObjectId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV0Services_UpdateRelatedObjectReference_Request_SearchByOneofInput = {
  relatedObject?: InputMaybe<OdProtosCaseyV0Services_RelatedObjectInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Data_HandoffInput = {
  assigneeToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Data_PermissionsInput = {
  owningBranchId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Empty here means all roles not no roles have access.
   * There is no way to restrict access to no roles.
   */
  rolesWithAccess?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCaseyV1Data_SlaInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
};

export enum OdProtosCaseyV1Data_Sla_SlaType {
  RESOLUTION = 'RESOLUTION'
}

export type OdProtosCaseyV1Data_SourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Use string instead of an enum because we could end up keying out task data on other data models,
   * and we wouldn't want to have to update Casey every time we introduce a new data model.
   * Use lower case, snake case representation of your model's name as the type,
   * e.g. address, offer, valuation, pricing_qa.
   */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Data_StartWorkRequestInput = {
  /** Human/Service starting the task */
  actor?: InputMaybe<OdProtosCaseyV1Data_WorkLog_ActorInput>;
  /** NOW() used if blank */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV1Data_TaskInput = {
  /**
   * The time this task became active. If not set, defaults to time of creation.
   * Example1: we need to run a backfill, that involves deleting and recreating tasks,
   * so the rows will have a created_at time of now, but keep the original activated_at
   * time to refer to when the task was available to be worked on so that our metrics
   * (time to close/time to claim/etc) are still accurate.
   * Example2: a job creates tasks at midnight, but they are not intended to be able to
   * be worked on until 9am, so the activated_at time gets set to 9am, while the created_at
   * time is still midnight. This ensures that we don't have big lags between activated_at and
   * claimed due to the task not being workable until 9am, to maintain accurate metrics.
   */
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Hydrated fields for easy access and for graphql foreign entity reference (will be deprecated) */
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  childTasks?: InputMaybe<Array<OdProtosCaseyV1Data_Task_TaskDependencyInput>>;
  /**
   * Close code is used to identify why a task is CLOSED.
   * Example: happy path, duplicated task, etc.
   */
  closeCode?: InputMaybe<Scalars['String']['input']>;
  closingEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** To understand how a task was completed (automatically or manually) */
  completionMethod?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  escalationLevel?: InputMaybe<Scalars['Float']['input']>;
  handoff?: InputMaybe<OdProtosCaseyV1Data_HandoffInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  parentTasks?: InputMaybe<Array<OdProtosCaseyV1Data_Task_TaskDependencyInput>>;
  /** Used to determine who can see the task based on branch and role */
  permissions?: InputMaybe<OdProtosCaseyV1Data_PermissionsInput>;
  /** Fields used in v0 that are not deprecated */
  regionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Used to determine who is responsible for the task and who can see it, ex: acq_tc, resale_cc, etc. */
  responsibilityRole?: InputMaybe<Scalars['String']['input']>;
  slas?: InputMaybe<Array<OdProtosCaseyV1Data_SlaInput>>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  sources?: InputMaybe<Array<OdProtosCaseyV1Data_SourceInput>>;
  status?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
  statusReason?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Arbitrary task data.
   * Document the source proto in task_data.type_url
   */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskTiming?: InputMaybe<OdProtosCaseyV1Data_TaskTimingInput>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  visibilityRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Controls when the task becomes visible in search/list operations.
   * If set to a future time, the task will be hidden from SearchTasks, FindTask, Count, and Search APIs
   * until that time is reached. Tasks can still be retrieved by ID via GetTask and ListTasksByIds.
   * If NULL or not set, the task is immediately visible in all operations.
   */
  visibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Backward reference to web task - will be deprecated once the web task migration is complete */
  webTaskId?: InputMaybe<Scalars['Float']['input']>;
  workLogs?: InputMaybe<Array<OdProtosCaseyV1Data_WorkLogInput>>;
};

export type OdProtosCaseyV1Data_TaskSearchFiltersInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Leave empty for including all tasks */
  excludeTasksByActor?: InputMaybe<OdProtosCaseyV1Data_WorkLog_ActorInput>;
  maxActivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxEscalationLevel?: InputMaybe<Scalars['Int']['input']>;
  minActivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minEscalationLevel?: InputMaybe<Scalars['Int']['input']>;
  /** If true, results will show only tasks that have no owner */
  onlyNilOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, results will show only tasks that have an owner */
  onlyNotNilOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Leave empty for tasks owned by anyone */
  owner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  owningBranchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  regionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sla?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFilters_SlaInput>>;
  /** Optional; if unspecified sorting behavior is undefined */
  sorting?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_SortingInput>;
  /**
   * Take the union of sources of the same type and intersection of sources of different types.
   * E.g. if we have the following sources specified:
   * [{id: "A", type: ADDRESS}, {id: "B", type: ADDRESS}, {id: "C", type: Contact}]
   * then we will look up tasks that has (address == "A" || address == "B") && (contact == "C").
   * Note: There cannot be more than 100 source IDs passed for the filter
   */
  sources?: InputMaybe<Array<OdProtosCaseyV1Data_SourceInput>>;
  /** Leave empty for all statuses */
  statuses?: InputMaybe<Array<OdProtosCaseyV1Data_Task_Status>>;
  /**
   * Input a name and value to filter on task data. If you omit the value,
   * you can filter for all tasks where the task_type matches the name.
   */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  workLog?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_WorkLogInput>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_SlaInput = {
  completedAt?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_TimeRestrictionInput>;
  deadlineAt?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_TimeRestrictionInput>;
  type?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_SortingInput = {
  /** Today we only have singular order by (i.e. no secondary order by column). */
  primarySortingRule?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_Sorting_RuleInput>;
};

export enum OdProtosCaseyV1Data_TaskSearchFilters_Sorting_Direction {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  INVALID_DIRECTION = 'INVALID_DIRECTION'
}

export enum OdProtosCaseyV1Data_TaskSearchFilters_Sorting_Field {
  INVALID_FIELD = 'INVALID_FIELD',
  /**
   * Tasks without RESOLUTION_SLAs will be sorted after tasks with RESOLUTION_SLAs regardless
   * of direection
   *
   * Sorting by RESOLUTION_SLA_RATIO sorts by what percentage of the time from activation to deadline has passed,
   * thus taking into account that tasks that originally had deadlines in the very near future may have worse
   * consequences for missing that deadline by a small amount than those that were long.
   * If this assumption is not true for your use case, this is not the sort for you!
   */
  RESOLUTION_SLA = 'RESOLUTION_SLA',
  /**
   * Formula: (slas.deadline - current_time) / (slas.deadline - tasks.activated_at)
   * e.g. a task activated 10 hours ago, currently due in 1 hour,
   * is the same ratio as a task activated 10 days ago, currently due in 1 day
   * Overdue example
   * Task A is due 30 minutes ago, and activated 4 hours ago has a ratio ~ -0.14
   * Task B is due 30 minutes ago, and activated 40 hours ago has a ratio of ~ -0.013
   * Task A will sort before Task B since it has the lower ratio
   * (aka it's late by a larger % of the overall time it has been activated)
   */
  RESOLUTION_SLA_RATIO = 'RESOLUTION_SLA_RATIO'
}

export type OdProtosCaseyV1Data_TaskSearchFilters_Sorting_RuleInput = {
  direction?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_Sorting_Direction>;
  field?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_Sorting_Field>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_TimeRestrictionInput = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  atOrBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_WorkLogInput = {
  inProgress?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_WorkLog_InProgress>;
};

export enum OdProtosCaseyV1Data_TaskSearchFilters_WorkLog_InProgress {
  NO_FILTER = 'NO_FILTER',
  NO_WORK_IN_PROGRESS = 'NO_WORK_IN_PROGRESS',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS'
}

export type OdProtosCaseyV1Data_TaskTimingInput = {
  checkInAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStop?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV1Data_Task_OwnerInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosCaseyV1Data_Task_Status {
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  CONFIRMED = 'CONFIRMED',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN',
  PENDING = 'PENDING'
}

export type OdProtosCaseyV1Data_Task_TaskDependencyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
  taskType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Data_WorkLogInput = {
  actor?: InputMaybe<OdProtosCaseyV1Data_WorkLog_ActorInput>;
  duration?: InputMaybe<GoogleProtobuf_DurationInput>;
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  stopTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV1Data_WorkLog_ActorInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_AcknowledgeWorkflowTask_RequestInput = {
  runId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_Assign_RequestInput = {
  newOwner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_CancelHandoffRequestInput = {
  handoffId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_CancelTask_RequestInput = {
  statusReason?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_ClaimTask_RequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_CompleteSla_RequestInput = {
  /** NOW() used if blank */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slaType?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_CompleteTask_RequestInput = {
  closeCode?: InputMaybe<Scalars['String']['input']>;
  completionMethod?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_ConfirmHandoffRequestInput = {
  handoffId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_Count_RequestInput = {
  searchFilters?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV1Services_CreateBulkTasks_RequestInput = {
  /**
   * If allow duplicates is true, then tasks with all the same attributes will be allowed to be created multiple times.
   * If allow duplicates is false, then it'll throw an error if there are any duplicate tasks based on the attributes.
   */
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Array<OdProtosCaseyV1Services_CreateBulkTasks_TaskInput>>;
};

export type OdProtosCaseyV1Services_CreateBulkTasks_TaskInput = {
  /** Event type to listen for auto closing from topic "tasks.closing_events" */
  closingEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * To create a dependency on another task within the same bulk request. Value is the other task's task_type.
   * Cannot have circular dependency (will result in error).
   */
  dependsOn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description of the task. Will be used to display in the UI. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the task. Will be used to display in the UI. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Owner of the task. This is optional and can be assigned later. */
  owner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  /** Permissions for the task. Will be used to determine who can view and complete the task based on branch and role. */
  permissions?: InputMaybe<OdProtosCaseyV1Data_PermissionsInput>;
  /** Optional, used to determine who is responsible for the task. Ex: acq_tc, resale_cc, etc. */
  responsibilityRole?: InputMaybe<Scalars['String']['input']>;
  /** Due date for the task. */
  slas?: InputMaybe<Array<OdProtosCaseyV1Data_SlaInput>>;
  /** Optional, used to snooze the task until a certain time. It's used only at frontend side. No internal logic is attached to it. */
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * There can be multiple sources attached to a task. Ex: listing, offer, etc.
   * Will be used to enrich the task later and also to identify the tasks by transaction, customer etc.
   */
  sources?: InputMaybe<Array<OdProtosCaseyV1Data_SourceInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Any additional data that needs to be attached to the task. */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  /**
   * Identifier for the type of task. This is just an arbitrary string and is owned by the task producer.
   * Will be handy to have custom CTAs for different tasks or have custom filters to find tasks for specfic teams etc.
   */
  taskType?: InputMaybe<Scalars['String']['input']>;
  /** Optional, used to determine who can see the task. Ex: acq_tc, resale_cc, etc. */
  visibilityRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional, controls when the task becomes visible in search/list operations. */
  visibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional, used to trace back the corresponding Web task if available */
  webTaskId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCaseyV1Services_CreateHandoffRequestInput = {
  assigneeToken?: InputMaybe<Scalars['String']['input']>;
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_CreateOrUpdateWebTask_RequestInput = {
  tasks?: InputMaybe<Array<OdProtosCaseyV1Services_CreateOrUpdateWebTask_TaskInput>>;
};

export type OdProtosCaseyV1Services_CreateOrUpdateWebTask_TaskInput = {
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  closeCode?: InputMaybe<Scalars['String']['input']>;
  closingEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completionMethod?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  permissions?: InputMaybe<OdProtosCaseyV1Data_PermissionsInput>;
  responsibilityRole?: InputMaybe<Scalars['String']['input']>;
  slas?: InputMaybe<Array<OdProtosCaseyV1Data_SlaInput>>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  sources?: InputMaybe<Array<OdProtosCaseyV1Data_SourceInput>>;
  status?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  visibilityRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional, used to trace back the corresponding Web task if available */
  webTaskId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCaseyV1Services_Create_RequestInput = {
  /** If allow duplicates is true tasks with all the same attributes may be created multiple times */
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** we'll ignore your task.id tho. */
  task?: InputMaybe<OdProtosCaseyV1Data_TaskInput>;
};

export type OdProtosCaseyV1Services_Deescalate_RequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_Escalate_RequestInput = {
  /** A snapshot of the task input and output. */
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_FindTask_RequestInput = {
  searchFilters?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV1Services_GetTaskByHandoff_RequestInput = {
  handoffId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_GetTask_RequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_ListTasksByIds_RequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCaseyV1Services_ObserveWorkflowTask_RequestInput = {
  runId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_RelatedObjectInput = {
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_SearchAndAssign_RequestInput = {
  /** new owner id to be assigned to the tasks */
  newOwner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filters to find tasks to assign/re-assign. There must be at least one filter set.
   * If the owner filter is set, the new_owner will be updated only if the current owner matches.
   */
  searchFilters?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFiltersInput>;
};

export type OdProtosCaseyV1Services_SearchAndStart_RequestInput = {
  searchFilters?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFiltersInput>>;
  startWorkRequest?: InputMaybe<OdProtosCaseyV1Data_StartWorkRequestInput>;
};

export type OdProtosCaseyV1Services_SearchOrgTasks_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFiltersInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosCaseyV1Services_SearchTasks_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosCaseyV1Services_Search_RequestInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV1Services_SetSla_RequestInput = {
  newDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  slaType?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_SetStatus_RequestInput = {
  /** set this if you are going to set the task to CLOSED. */
  closeCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * set this if you want to set a new status
   * conditional on the current status matching
   */
  expectedCurrentStatus?: InputMaybe<OdProtosCaseyV1Services_SetStatus_Request_ExpectedCurrentStatusInput>;
  newStatus?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
  newStatusReason?: InputMaybe<Scalars['String']['input']>;
  /** A snapshot of the task input and output. */
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_SetStatus_Request_ExpectedCurrentStatusInput = {
  status?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
};

export type OdProtosCaseyV1Services_Snooze_RequestInput = {
  /** unsnoozed if blank */
  newSnoozedUntil?: InputMaybe<OdProtosCaseyV1Services_Task_TimeInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_StartWork_RequestInput = {
  startWorkRequest?: InputMaybe<OdProtosCaseyV1Data_StartWorkRequestInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_Task_TimeInput = {
  time?: InputMaybe<OdProtosCaseyV1Services_Task_Time_TimeOneofInput>;
};

export type OdProtosCaseyV1Services_Task_Time_TimeOneofInput = {
  exactTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCaseyV1Services_UnclaimTask_RequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_UpdateRelatedObjectReference_RequestInput = {
  fromObjectId?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<OdProtosCaseyV1Services_UpdateRelatedObjectReference_Request_SearchByOneofInput>;
  toObjectId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_UpdateRelatedObjectReference_Request_SearchByOneofInput = {
  relatedObject?: InputMaybe<OdProtosCaseyV1Services_RelatedObjectInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_UpdateTaskDescriptionAndSla_RequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  newDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  slaType?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_UpdateTaskTiming_RequestInput = {
  checkInAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  clearConfirmedAt?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStop?: InputMaybe<Scalars['DateTime']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCaseyV1Services_UpdateWebTaskDependency_RequestInput = {
  taskDependencies?: InputMaybe<Array<OdProtosCaseyV1Services_UpdateWebTaskDependency_TaskDependencyInput>>;
};

export type OdProtosCaseyV1Services_UpdateWebTaskDependency_TaskDependencyInput = {
  parentWebTaskId?: InputMaybe<Scalars['Float']['input']>;
  webTaskId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosCaseyV1Services_WatchTasks_EventType {
  EVENT_TYPE_CREATED = 'EVENT_TYPE_CREATED',
  EVENT_TYPE_UNSPECIFIED = 'EVENT_TYPE_UNSPECIFIED',
  EVENT_TYPE_UPDATED = 'EVENT_TYPE_UPDATED'
}

export type OdProtosCaseyV1Services_WatchTasks_RequestInput = {
  events?: InputMaybe<Array<OdProtosCaseyV1Services_WatchTasks_EventType>>;
  filters?: InputMaybe<OdProtosCaseyV1Services_WatchTasks_TaskFiltersInput>;
};

export type OdProtosCaseyV1Services_WatchTasks_TaskFiltersInput = {
  owner?: InputMaybe<OdProtosCaseyV1Services_WatchTasks_TaskFilters_OwnerFilter>;
  statuses?: InputMaybe<Array<OdProtosCaseyV1Data_Task_Status>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OdProtosCaseyV1Services_WatchTasks_TaskFilters_OwnerFilter {
  OWNER_FILTER_ME = 'OWNER_FILTER_ME',
  OWNER_FILTER_UNASSIGNED = 'OWNER_FILTER_UNASSIGNED',
  OWNER_FILTER_UNSPECIFIED = 'OWNER_FILTER_UNSPECIFIED'
}

export type OdProtosCommanderServices_GetOpenUserTasks_RequestInput = {
  /** Id of the process instance */
  processInstanceId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommanderServices_SubmitWorkflowData_RequestInput = {
  /**
   * Data submitted via the form
   * TODO: Explore support for nested objects and forms which has array of data.
   */
  formData?: InputMaybe<Array<OdProtosCommanderServices_SubmitWorkflowData_Request_FormDataEntryInput>>;
  /** Id of the process instance */
  processInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the associated user task */
  userTaskId?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosCommanderServices_SubmitWorkflowData_Request_FormDataEntryInput` represents the `form_data` map in `od_protos.commander.services.SubmitWorkflowData.Request`. */
export type OdProtosCommanderServices_SubmitWorkflowData_Request_FormDataEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosCommonAssumptions_Unit {
  BPS = 'BPS',
  BPS_DIVIDED_BY_ONE_HUNDRED = 'BPS_DIVIDED_BY_ONE_HUNDRED',
  BPS_DIVIDED_BY_TEN_THOUSAND = 'BPS_DIVIDED_BY_TEN_THOUSAND',
  BPS_DIVIDED_BY_TEN_THOUSAND_PER_DIP = 'BPS_DIVIDED_BY_TEN_THOUSAND_PER_DIP',
  CENTS = 'CENTS',
  CENTS_PER_DIP = 'CENTS_PER_DIP',
  CENTS_PER_DOM = 'CENTS_PER_DOM',
  CENTS_PER_HOME_PER_SQUARE_FOOT_PER_DIP = 'CENTS_PER_HOME_PER_SQUARE_FOOT_PER_DIP',
  DAYS = 'DAYS',
  DOLLARS = 'DOLLARS',
  UNSET = 'UNSET'
}

/** Next ID: 5 */
export type OdProtosCommonBuyer_AttributionInput = {
  lastReferrer?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommonBuyer_TimeslotInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCommonData_AddressInput = {
  apn?: InputMaybe<Scalars['String']['input']>;
  /**
   * Geo grouping determined by the US census
   * Bigger than a block, smaller than a census tract
   */
  blockGroupId?: InputMaybe<Scalars['String']['input']>;
  blockId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Almost always empty. Some folks like to name everything
   * Designates a specific building within an address
   * Almost all addresses consist of a single building
   */
  building?: InputMaybe<Scalars['String']['input']>;
  censusTractId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosCommonState_State>;
  street1?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  /** The internal OD address token (Unique ID) */
  token?: InputMaybe<Scalars['String']['input']>;
  /** A unit designates part of a building */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosCommonData_DwellingType {
  APARTMENT = 'APARTMENT',
  CONDO = 'CONDO',
  LOFT = 'LOFT',
  MISCELLANEOUS = 'MISCELLANEOUS',
  OTHER = 'OTHER',
  PATIO = 'PATIO',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
  TOWNHOUSE = 'TOWNHOUSE',
  VACANT = 'VACANT'
}

export enum OdProtosCommonData_PoolType {
  BOTH_PRIVATE_COMMUNITY = 'BOTH_PRIVATE_COMMUNITY',
  COMMUNITY = 'COMMUNITY',
  NONE = 'NONE',
  PRIVATE = 'PRIVATE'
}

/** Health checks shouldn't require inputs, since clients are often naive (e.g. k8s readiness/liveness, pingdom) */
export type OdProtosCommonHealthServices_HealthRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The names must be the uppercase versions of the market identifiers in web.
 * Update region.proto if any market is added/removed from here.
 */
export enum OdProtosCommonMarket_Market {
  ALABAMA_OTHER = 'ALABAMA_OTHER',
  ALASKA_OTHER = 'ALASKA_OTHER',
  ALBUQUERQUE_NM = 'ALBUQUERQUE_NM',
  ARIZONA_OTHER = 'ARIZONA_OTHER',
  ARKANSAS_OTHER = 'ARKANSAS_OTHER',
  /** @deprecated No longer supported */
  ASHEVILLE_NC = 'ASHEVILLE_NC',
  ATLANTA = 'ATLANTA',
  AUSTIN = 'AUSTIN',
  /** @deprecated No longer supported */
  BAKERSFIELD_CA = 'BAKERSFIELD_CA',
  BALTIMORE_MD = 'BALTIMORE_MD',
  BIRMINGHAM_AL = 'BIRMINGHAM_AL',
  BOISE = 'BOISE',
  BOSTON_MA = 'BOSTON_MA',
  CALIFORNIA_OTHER = 'CALIFORNIA_OTHER',
  CENTRAL_CALIFORNIA_CA = 'CENTRAL_CALIFORNIA_CA',
  CHARLESTON_SC = 'CHARLESTON_SC',
  CHARLOTTE = 'CHARLOTTE',
  CHATTANOOGA = 'CHATTANOOGA',
  CHICAGO_IL = 'CHICAGO_IL',
  CINCINNATI_OH = 'CINCINNATI_OH',
  /** @deprecated No longer supported */
  CINCINNATI_OK = 'CINCINNATI_OK',
  /** @deprecated No longer supported */
  CLARKSVILLE_KY_TN = 'CLARKSVILLE_KY_TN',
  CLEVELAND_OH = 'CLEVELAND_OH',
  COLORADO_OTHER = 'COLORADO_OTHER',
  COLORADO_SPRINGS_CO = 'COLORADO_SPRINGS_CO',
  COLUMBIA_SC = 'COLUMBIA_SC',
  COLUMBUS_OH = 'COLUMBUS_OH',
  CONNECTICUT_OTHER = 'CONNECTICUT_OTHER',
  CORPUS_CHRISTI_TX = 'CORPUS_CHRISTI_TX',
  DALLAS = 'DALLAS',
  DELAWARE_OTHER = 'DELAWARE_OTHER',
  DENVER = 'DENVER',
  DETROIT_MI = 'DETROIT_MI',
  EAST_TEXAS = 'EAST_TEXAS',
  EL_PASO = 'EL_PASO',
  FLORIDA_PANHANDLE = 'FLORIDA_PANHANDLE',
  /**
   * renamed to NORTHERN_COLORADO
   * @deprecated No longer supported
   */
  FORT_COLLINS_CO = 'FORT_COLLINS_CO',
  GEORGIA_OTHER = 'GEORGIA_OTHER',
  GREENSBORO_NC = 'GREENSBORO_NC',
  GREENVILLE_SC = 'GREENVILLE_SC',
  HAWAII_OTHER = 'HAWAII_OTHER',
  HOUSTON = 'HOUSTON',
  /** @deprecated No longer supported */
  HUNTSVILLE_AL = 'HUNTSVILLE_AL',
  IDAHO_OTHER = 'IDAHO_OTHER',
  ILLINOIS_OTHER = 'ILLINOIS_OTHER',
  INDIANAPOLIS_IN = 'INDIANAPOLIS_IN',
  INDIANA_OTHER = 'INDIANA_OTHER',
  IOWA_OTHER = 'IOWA_OTHER',
  JACKSONVILLE = 'JACKSONVILLE',
  /** @deprecated No longer supported */
  JOHNSON_CITY_TN = 'JOHNSON_CITY_TN',
  KANSAS_CITY = 'KANSAS_CITY',
  KANSAS_OTHER = 'KANSAS_OTHER',
  KENTUCKY_OTHER = 'KENTUCKY_OTHER',
  KILLEEN_TX = 'KILLEEN_TX',
  KNOXVILLE_TN = 'KNOXVILLE_TN',
  LAS_VEGAS = 'LAS_VEGAS',
  LITTLE_ROCK_AR = 'LITTLE_ROCK_AR',
  LOS_ANGELES = 'LOS_ANGELES',
  LOUISIANA_OTHER = 'LOUISIANA_OTHER',
  LOUISVILLE_IN_KY = 'LOUISVILLE_IN_KY',
  MAINE_OTHER = 'MAINE_OTHER',
  MARYLAND_OTHER = 'MARYLAND_OTHER',
  MASSACHUSETTS_OTHER = 'MASSACHUSETTS_OTHER',
  /** Open Exchange only */
  MEMPHIS_TN = 'MEMPHIS_TN',
  MIAMI_FL = 'MIAMI_FL',
  MICHIGAN_OTHER = 'MICHIGAN_OTHER',
  MILWAUKEE_WAUKESHA_WI = 'MILWAUKEE_WAUKESHA_WI',
  MINNEAPOLIS = 'MINNEAPOLIS',
  MINNESOTA_OTHER = 'MINNESOTA_OTHER',
  MISSISSIPPI_OTHER = 'MISSISSIPPI_OTHER',
  MISSOURI_OTHER = 'MISSOURI_OTHER',
  MONTANA_OTHER = 'MONTANA_OTHER',
  NASHVILLE = 'NASHVILLE',
  NEBRASKA_OTHER = 'NEBRASKA_OTHER',
  NEVADA_OTHER = 'NEVADA_OTHER',
  NEW_HAMPSHIRE_OTHER = 'NEW_HAMPSHIRE_OTHER',
  NEW_MEXICO_OTHER = 'NEW_MEXICO_OTHER',
  NEW_ORLEANS_LA = 'NEW_ORLEANS_LA',
  NEW_YORK_NEW_JERSEY = 'NEW_YORK_NEW_JERSEY',
  NEW_YORK_OTHER = 'NEW_YORK_OTHER',
  NORTHERN_COLORADO = 'NORTHERN_COLORADO',
  NORTH_CAROLINA_OTHER = 'NORTH_CAROLINA_OTHER',
  NORTH_DAKOTA_OTHER = 'NORTH_DAKOTA_OTHER',
  OHIO_OTHER = 'OHIO_OTHER',
  OKLAHOMA_CITY_OK = 'OKLAHOMA_CITY_OK',
  OKLAHOMA_OTHER = 'OKLAHOMA_OTHER',
  OMAHA_NE = 'OMAHA_NE',
  OREGON_OTHER = 'OREGON_OTHER',
  ORLANDO = 'ORLANDO',
  /** @deprecated No longer supported */
  PALM_BAY_FL = 'PALM_BAY_FL',
  PENNSYLVANIA_OTHER = 'PENNSYLVANIA_OTHER',
  PHILADELPHIA_PA = 'PHILADELPHIA_PA',
  PHOENIX = 'PHOENIX',
  PITTSBURGH_PA = 'PITTSBURGH_PA',
  PORTLAND = 'PORTLAND',
  PRESCOTT_AZ = 'PRESCOTT_AZ',
  /** @deprecated No longer supported */
  PROVIDENCE_RI = 'PROVIDENCE_RI',
  PUERTO_RICO_OTHER = 'PUERTO_RICO_OTHER',
  RALEIGH = 'RALEIGH',
  RENO_NV = 'RENO_NV',
  RICHMOND_VA = 'RICHMOND_VA',
  RIVERSIDE = 'RIVERSIDE',
  SACRAMENTO = 'SACRAMENTO',
  SALT_LAKE_CITY = 'SALT_LAKE_CITY',
  SAN_ANTONIO = 'SAN_ANTONIO',
  SAN_DIEGO_CA = 'SAN_DIEGO_CA',
  /** @deprecated No longer supported */
  SAVANNAH_GA = 'SAVANNAH_GA',
  SEATTLE_WA = 'SEATTLE_WA',
  SF_BAY_AREA = 'SF_BAY_AREA',
  SOUTHWEST_FL = 'SOUTHWEST_FL',
  SOUTH_CAROLINA_OTHER = 'SOUTH_CAROLINA_OTHER',
  SOUTH_DAKOTA_OTHER = 'SOUTH_DAKOTA_OTHER',
  SOUTH_TEXAS = 'SOUTH_TEXAS',
  /** @deprecated No longer supported */
  SPRINGFIELD_MO = 'SPRINGFIELD_MO',
  ST_LOUIS = 'ST_LOUIS',
  TAMPA = 'TAMPA',
  TENNESSEE_OTHER = 'TENNESSEE_OTHER',
  TUCSON = 'TUCSON',
  TULSA_OK = 'TULSA_OK',
  UNKNOWN = 'UNKNOWN',
  UTAH_OTHER = 'UTAH_OTHER',
  VERMONT_OTHER = 'VERMONT_OTHER',
  VIRGINIA_BEACH_VA = 'VIRGINIA_BEACH_VA',
  VIRGINIA_OTHER = 'VIRGINIA_OTHER',
  WASHINGTON_DC = 'WASHINGTON_DC',
  WASHINGTON_OTHER = 'WASHINGTON_OTHER',
  WESTERN_MD = 'WESTERN_MD',
  WESTERN_NY = 'WESTERN_NY',
  WEST_TEXAS = 'WEST_TEXAS',
  WEST_VIRGINIA_OTHER = 'WEST_VIRGINIA_OTHER',
  /** @deprecated No longer supported */
  WICHITA_KS = 'WICHITA_KS',
  WISCONSIN_OTHER = 'WISCONSIN_OTHER',
  WYOMING_OTHER = 'WYOMING_OTHER'
}

export enum OdProtosCommonMarket_Region_Central {
  ARKANSAS_OTHER = 'ARKANSAS_OTHER',
  AUSTIN = 'AUSTIN',
  CHICAGO_IL = 'CHICAGO_IL',
  CORPUS_CHRISTI_TX = 'CORPUS_CHRISTI_TX',
  DALLAS = 'DALLAS',
  EAST_TEXAS = 'EAST_TEXAS',
  EL_PASO = 'EL_PASO',
  HOUSTON = 'HOUSTON',
  INDIANA_OTHER = 'INDIANA_OTHER',
  IOWA_OTHER = 'IOWA_OTHER',
  KANSAS_CITY = 'KANSAS_CITY',
  KANSAS_OTHER = 'KANSAS_OTHER',
  KENTUCKY_OTHER = 'KENTUCKY_OTHER',
  KILLEEN_TX = 'KILLEEN_TX',
  LITTLE_ROCK_AR = 'LITTLE_ROCK_AR',
  LOUISIANA_OTHER = 'LOUISIANA_OTHER',
  MICHIGAN_OTHER = 'MICHIGAN_OTHER',
  MILWAUKEE_WAUKESHA_WI = 'MILWAUKEE_WAUKESHA_WI',
  MINNESOTA_OTHER = 'MINNESOTA_OTHER',
  MISSISSIPPI_OTHER = 'MISSISSIPPI_OTHER',
  MISSOURI_OTHER = 'MISSOURI_OTHER',
  NEBRASKA_OTHER = 'NEBRASKA_OTHER',
  NEW_ORLEANS_LA = 'NEW_ORLEANS_LA',
  NORTH_DAKOTA_OTHER = 'NORTH_DAKOTA_OTHER',
  OKLAHOMA_CITY_OK = 'OKLAHOMA_CITY_OK',
  OKLAHOMA_OTHER = 'OKLAHOMA_OTHER',
  OMAHA_NE = 'OMAHA_NE',
  SAN_ANTONIO = 'SAN_ANTONIO',
  SOUTH_DAKOTA_OTHER = 'SOUTH_DAKOTA_OTHER',
  SOUTH_TEXAS = 'SOUTH_TEXAS',
  SPRINGFIELD_MO = 'SPRINGFIELD_MO',
  ST_LOUIS = 'ST_LOUIS',
  TULSA_OK = 'TULSA_OK',
  WEST_TEXAS = 'WEST_TEXAS',
  WICHITA_KS = 'WICHITA_KS',
  WISCONSIN_OTHER = 'WISCONSIN_OTHER'
}

export enum OdProtosCommonMarket_Region_East {
  ALABAMA_OTHER = 'ALABAMA_OTHER',
  ASHEVILLE_NC = 'ASHEVILLE_NC',
  ATLANTA = 'ATLANTA',
  BALTIMORE_MD = 'BALTIMORE_MD',
  BIRMINGHAM_AL = 'BIRMINGHAM_AL',
  BOSTON_MA = 'BOSTON_MA',
  CHARLESTON_SC = 'CHARLESTON_SC',
  CHARLOTTE = 'CHARLOTTE',
  CHATTANOOGA = 'CHATTANOOGA',
  CINCINNATI_OH = 'CINCINNATI_OH',
  CLARKSVILLE_KY_TN = 'CLARKSVILLE_KY_TN',
  CLEVELAND_OH = 'CLEVELAND_OH',
  COLUMBIA_SC = 'COLUMBIA_SC',
  COLUMBUS_OH = 'COLUMBUS_OH',
  CONNECTICUT_OTHER = 'CONNECTICUT_OTHER',
  DELAWARE_OTHER = 'DELAWARE_OTHER',
  DETROIT_MI = 'DETROIT_MI',
  FLORIDA_PANHANDLE = 'FLORIDA_PANHANDLE',
  GEORGIA_OTHER = 'GEORGIA_OTHER',
  GREENSBORO_NC = 'GREENSBORO_NC',
  GREENVILLE_SC = 'GREENVILLE_SC',
  HUNTSVILLE_AL = 'HUNTSVILLE_AL',
  ILLINOIS_OTHER = 'ILLINOIS_OTHER',
  INDIANAPOLIS_IN = 'INDIANAPOLIS_IN',
  JACKSONVILLE = 'JACKSONVILLE',
  JOHNSON_CITY_TN = 'JOHNSON_CITY_TN',
  KNOXVILLE_TN = 'KNOXVILLE_TN',
  LOUISVILLE_IN_KY = 'LOUISVILLE_IN_KY',
  MAINE_OTHER = 'MAINE_OTHER',
  MARYLAND_OTHER = 'MARYLAND_OTHER',
  MASSACHUSETTS_OTHER = 'MASSACHUSETTS_OTHER',
  MEMPHIS_TN = 'MEMPHIS_TN',
  MIAMI_FL = 'MIAMI_FL',
  MINNEAPOLIS = 'MINNEAPOLIS',
  NASHVILLE = 'NASHVILLE',
  NEW_HAMPSHIRE_OTHER = 'NEW_HAMPSHIRE_OTHER',
  NEW_YORK_NEW_JERSEY = 'NEW_YORK_NEW_JERSEY',
  NEW_YORK_OTHER = 'NEW_YORK_OTHER',
  NORTH_CAROLINA_OTHER = 'NORTH_CAROLINA_OTHER',
  OHIO_OTHER = 'OHIO_OTHER',
  ORLANDO = 'ORLANDO',
  PALM_BAY_FL = 'PALM_BAY_FL',
  PENNSYLVANIA_OTHER = 'PENNSYLVANIA_OTHER',
  PHILADELPHIA_PA = 'PHILADELPHIA_PA',
  PITTSBURGH_PA = 'PITTSBURGH_PA',
  PROVIDENCE_RI = 'PROVIDENCE_RI',
  PUERTO_RICO_OTHER = 'PUERTO_RICO_OTHER',
  RALEIGH = 'RALEIGH',
  RICHMOND_VA = 'RICHMOND_VA',
  SOUTHWEST_FL = 'SOUTHWEST_FL',
  SOUTH_CAROLINA_OTHER = 'SOUTH_CAROLINA_OTHER',
  TAMPA = 'TAMPA',
  TENNESSEE_OTHER = 'TENNESSEE_OTHER',
  VERMONT_OTHER = 'VERMONT_OTHER',
  VIRGINIA_BEACH_VA = 'VIRGINIA_BEACH_VA',
  VIRGINIA_OTHER = 'VIRGINIA_OTHER',
  WASHINGTON_DC = 'WASHINGTON_DC',
  WESTERN_MD = 'WESTERN_MD',
  WESTERN_NY = 'WESTERN_NY',
  WEST_VIRGINIA_OTHER = 'WEST_VIRGINIA_OTHER'
}

export enum OdProtosCommonMarket_Region_West {
  ALASKA_OTHER = 'ALASKA_OTHER',
  ALBUQUERQUE_NM = 'ALBUQUERQUE_NM',
  ARIZONA_OTHER = 'ARIZONA_OTHER',
  BAKERSFIELD_CA = 'BAKERSFIELD_CA',
  BOISE = 'BOISE',
  CALIFORNIA_OTHER = 'CALIFORNIA_OTHER',
  CENTRAL_CALIFORNIA_CA = 'CENTRAL_CALIFORNIA_CA',
  COLORADO_OTHER = 'COLORADO_OTHER',
  COLORADO_SPRINGS_CO = 'COLORADO_SPRINGS_CO',
  DENVER = 'DENVER',
  HAWAII_OTHER = 'HAWAII_OTHER',
  IDAHO_OTHER = 'IDAHO_OTHER',
  LAS_VEGAS = 'LAS_VEGAS',
  LOS_ANGELES = 'LOS_ANGELES',
  MONTANA_OTHER = 'MONTANA_OTHER',
  NEVADA_OTHER = 'NEVADA_OTHER',
  NEW_MEXICO_OTHER = 'NEW_MEXICO_OTHER',
  NORTHERN_COLORADO = 'NORTHERN_COLORADO',
  OREGON_OTHER = 'OREGON_OTHER',
  PHOENIX = 'PHOENIX',
  PORTLAND = 'PORTLAND',
  PRESCOTT_AZ = 'PRESCOTT_AZ',
  RENO_NV = 'RENO_NV',
  RIVERSIDE = 'RIVERSIDE',
  SACRAMENTO = 'SACRAMENTO',
  SALT_LAKE_CITY = 'SALT_LAKE_CITY',
  SAN_DIEGO_CA = 'SAN_DIEGO_CA',
  SEATTLE_WA = 'SEATTLE_WA',
  SF_BAY_AREA = 'SF_BAY_AREA',
  TUCSON = 'TUCSON',
  UTAH_OTHER = 'UTAH_OTHER',
  WASHINGTON_OTHER = 'WASHINGTON_OTHER',
  WYOMING_OTHER = 'WYOMING_OTHER'
}

/**
 * Enumeration of Multiple Listing Services.
 * Comment format: Region Coverage - OD Markets
 */
export enum OdProtosCommonMls_Mls {
  /** Aiken Association of REALTORS */
  AARMLS = 'AARMLS',
  /** Austin - AUS (Austin, TX) */
  ABORMLS = 'ABORMLS',
  /** Aspen Glenwood MLS */
  AGMLS = 'AGMLS',
  /** Alaska Multiple Listing Service */
  AKMLS = 'AKMLS',
  /** Altitude MLS */
  ALTITUDEMLS = 'ALTITUDEMLS',
  /** Amarillo Association of REALTORS */
  AMARILLOMLS = 'AMARILLOMLS',
  /** APEX MLS (Greater Louisville Association of REALTORS) */
  APEXMLS = 'APEXMLS',
  /** ArkansasONE MLS */
  ARKONEMLS = 'ARKONEMLS',
  /** Arizona Regional - PHX (Phoenix, AZ) */
  ARMLS = 'ARMLS',
  /** Bagnell Dam Association of REALTORS */
  BAGNELLMLS = 'BAGNELLMLS',
  /** Baldwin REALTORS */
  BALDWINMLS = 'BALDWINMLS',
  /** San Francisco, Northern Counties */
  BAREIS = 'BAREIS',
  /** Brooklyn Board of REALTORS */
  BBORMLS = 'BBORMLS',
  /** BryanCollege Station Regional Multiple Listing Service */
  BCSMLS = 'BCSMLS',
  /** Miami FL */
  BEACHESMLS = 'BEACHESMLS',
  /** Beaumont Board of REALTORS */
  BEBORMLS = 'BEBORMLS',
  /** Berkshire County Board of REALTORS */
  BERKMLS = 'BERKMLS',
  /** Black Hills Association of REALTORS */
  BHARLMLS = 'BHARLMLS',
  /** Big Sky Country MLS (Gallatin Association of REALTORS) */
  BIGSKYMLS = 'BIGSKYMLS',
  /** Billings Multiple Listing Service */
  BILLINGSMLS = 'BILLINGSMLS',
  /** San Francisco, East/South Bay */
  BRIDGEMLS = 'BRIDGEMLS',
  /** Washington DC, Arlington VA */
  BRIGHTMLS = 'BRIGHTMLS',
  /** Charlottesville Area Association of REALTORS */
  CAARMLS = 'CAARMLS',
  /** California - LAX (Los Angeles, CA) */
  CARETS = 'CARETS',
  /** Cooperative Arkansas REALTORS MLS */
  CARMLS = 'CARMLS',
  /** Capital Area Technology & REALTOR Services (Tallahassee Board of REALTORS) */
  CATARS = 'CATARS',
  /** Corpus Christi TX */
  CBMLS = 'CBMLS',
  /** Columbia Board of REALTORS */
  CBOR = 'CBOR',
  /** Coastal Carolinas Association of REALTORS */
  CCAR = 'CCAR',
  /** Cape Cod & Islands Association of REALTORS */
  CCIARMLS = 'CCIARMLS',
  /** Columbus, OH */
  CCOR = 'CCOR',
  /** Coeur d'Alene Multiple Listing Service */
  CDAMLS = 'CDAMLS',
  /** California Desert Association of REALTORS */
  CDARMLS = 'CDARMLS',
  /** Central Jersey - ? (NJ/NY) */
  CENTRALJERSEYMLS = 'CENTRALJERSEYMLS',
  /** Central Georgia MLS */
  CGMLS = 'CGMLS',
  /** Cheyenne Board of REALTORS */
  CHEYENNEMLS = 'CHEYENNEMLS',
  /** Charleston, SC */
  CHSMLS = 'CHSMLS',
  /** Cincinnati, OH */
  CINCYMLS = 'CINCYMLS',
  /** CLASSIC MLS (Athens Area Association of REALTORS) */
  CLASSICMLS = 'CLASSICMLS',
  /** ? - CLT (Charlotte, SC) */
  CMLS = 'CMLS',
  /** Columbia SC */
  CONSOLIDATEDMLS = 'CONSOLIDATEDMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_ARMLS = 'CONSTELLATION_ARMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_BEACHESMLS = 'CONSTELLATION_BEACHESMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_BRIGHTMLS = 'CONSTELLATION_BRIGHTMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_CMLS = 'CONSTELLATION_CMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_CRMLS = 'CONSTELLATION_CRMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_FGCMLS = 'CONSTELLATION_FGCMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_FMLS = 'CONSTELLATION_FMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_GAMLS = 'CONSTELLATION_GAMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_HARMLS = 'CONSTELLATION_HARMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_MFRMLS = 'CONSTELLATION_MFRMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_MI_REAL_SOURCE = 'CONSTELLATION_MI_REAL_SOURCE',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_MLSOK = 'CONSTELLATION_MLSOK',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_MREDMLS = 'CONSTELLATION_MREDMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_NORTHSTAR = 'CONSTELLATION_NORTHSTAR',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_ONEKEY = 'CONSTELLATION_ONEKEY',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_REALCOMP = 'CONSTELLATION_REALCOMP',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_REALTRACS = 'CONSTELLATION_REALTRACS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_RECOLORADO = 'CONSTELLATION_RECOLORADO',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_SDMLS = 'CONSTELLATION_SDMLS',
  /**
   * Constellation MLS
   * @deprecated No longer supported
   */
  CONSTELLATION_SEF = 'CONSTELLATION_SEF',
  /** Contra Costa Association of REALTORS */
  CONTRACOSTAMLS = 'CONTRACOSTAMLS',
  /** Central Panhandle Association of REALTORS */
  CPARMLS = 'CPARMLS',
  /** Cedar Rapids Area Association of REALTORS */
  CRAAR = 'CRAAR',
  /** Colorado Real Estate Network (CREN) */
  CREN = 'CREN',
  /** California Regional - LAX (Los Angeles, CA), RIV (Riverside, CA) */
  CRMLS = 'CRMLS',
  /** Kileen TX */
  CTXMLS = 'CTXMLS',
  /** Richmond, VA */
  CVRMLS = 'CVRMLS',
  /** Central Wisconsin Multiple Listing Service */
  CWMLS = 'CWMLS',
  /** Central West Tennessee Association of REALTORS */
  CWTARMLS = 'CWTARMLS',
  /** Dayton REALTORS */
  DAYTONMLS = 'DAYTONMLS',
  /** Daytona Beach Area Association of REALTORS */
  DBAARMLS = 'DBAARMLS',
  /** Des Moines Area Association of REALTORS */
  DMAARMLS = 'DMAARMLS',
  /** Emerald Coast Association of REALTORS */
  ECAR = 'ECAR',
  /** Elko County Association of REALTORS */
  ELKOMLS = 'ELKOMLS',
  /** FargoMoorhead Area Association of REALTORS */
  FMARMLS = 'FMARMLS',
  /** ? - ATL (Atlanta, GA) */
  FMLS = 'FMLS',
  /** Fresno, CA */
  FRESNOMLS = 'FRESNOMLS',
  /** Birmingham, AL */
  GALMLS = 'GALMLS',
  /** Georgia MLS - ATL (Atlanta, GA) */
  GAMLS = 'GAMLS',
  /** Greater Antelope Valley Association of REALTORS */
  GAVARMLS = 'GAVARMLS',
  /** Greater Baton Rouge Association of REALTORS */
  GBRAR = 'GBRAR',
  /** Chattanooga TN */
  GCAR = 'GCAR',
  /** Gulf Coast MLS (Mobile Area Association of REALTORS) */
  GCMLS = 'GCMLS',
  /** Bakersfield CA */
  GEMLS = 'GEMLS',
  /** Greater El Paso Association of REALTORS */
  GEPARMLS = 'GEPARMLS',
  /** Grand Forks Area Association of REALTORS */
  GFAARMLS = 'GFAARMLS',
  /** Greater Fairbanks Board of REALTORS */
  GFBORMLS = 'GFBORMLS',
  /** Golden Isles Association of REALTORS */
  GIARMLS = 'GIARMLS',
  /** Grand Island Board of REALTORS */
  GIBORMLS = 'GIBORMLS',
  /** Grand Junction Area REALTOR Association */
  GJARMLS = 'GJARMLS',
  /** Louisville, KY */
  GLARMLS = 'GLARMLS',
  /** Global MLS */
  GLOBALMLS = 'GLOBALMLS',
  /** Greater Las Vegas - LAS (Las Vegas, NV) */
  GLVAR = 'GLVAR',
  /** Greater Lehigh Valley REALTORS */
  GLVRMLS = 'GLVRMLS',
  /** Greater McAllen Association of REALTORS */
  GMAR = 'GMAR',
  /** REALTORS of Greater MidNebraska */
  GMNRBMLS = 'GMNRBMLS',
  /** Greater Northwoods MLS */
  GNMLS = 'GNMLS',
  /** Great Plains Regional MLS */
  GPRMLS = 'GPRMLS',
  /** Greenville + Anderson SC */
  GREENVILLEMLS = 'GREENVILLEMLS',
  /** Greenwich Association of REALTORS */
  GREENWICHMLS = 'GREENWICHMLS',
  /** Greater Lansing Association of REALTORS */
  GRLARMLS = 'GRLARMLS',
  /** Great North MLS */
  GRNMLS = 'GRNMLS',
  /** Central New York Information Services (Greater Syracuse Association of REALTORS) */
  GSARMLS = 'GSARMLS',
  /** Greater Scranton Board of REALTORS */
  GSBOR = 'GSBOR',
  /** Great Smoky Mountains Association of REALTORS */
  GSMARMLS = 'GSMARMLS',
  /** Garden State MLS (NJ/NY) */
  GSMLS = 'GSMLS',
  /** Gulf South Real Estate Information Network */
  GSREIN = 'GSREIN',
  /** Greater Tyler Association of REALTORS */
  GTAR = 'GTAR',
  /** Houston - HOU (Houston, TX) */
  HARMLS = 'HARMLS',
  /** Hattiesburg Area Association of REALTORS */
  HATARMLS = 'HATARMLS',
  /** Huntington Board of REALTORS */
  HBORMLS = 'HBORMLS',
  /** High Country Association of REALTORS */
  HCAR = 'HCAR',
  /** Hudson County MLS (Liberty Board of REALTORS) */
  HCMLS = 'HCMLS',
  /** HiCentral MLS (Honolulu Board of REALTORS) */
  HICENTRALMLS = 'HICENTRALMLS',
  /** Highland Lakes Association of REALTORS */
  HILAORMLS = 'HILAORMLS',
  /** Hive MLS */
  HIVEMLS = 'HIVEMLS',
  /** Kansas City */
  HMLMLS = 'HMLMLS',
  /** Kansas City, HMLMLS was the original Kansas market and is no longer being ingested. It's left in for backwards compatibility */
  HMLS = 'HMLS',
  /** Hudson Valley Catskills Region Multiple List Service (Ulster County Board of REALTORS) */
  HVMLS = 'HVMLS',
  /** Iowa City Area Association of REALTORS */
  ICAAR = 'ICAAR',
  /** Iron County Board of REALTORS */
  ICBOR = 'ICBOR',
  /**
   * Chicago, IL
   * @deprecated No longer supported
   */
  ILMLSNI = 'ILMLSNI',
  /** Imagine MLS (Bluegrass REALTORS) */
  IMAGINEMLS = 'IMAGINEMLS',
  /** Boise ID */
  IMLS = 'IMLS',
  /** Fort Collins CO */
  IRES = 'IRES',
  /** IRES MLS */
  IRESMLS = 'IRESMLS',
  /** Indiana Regional MLS */
  IRMLS = 'IRMLS',
  /** Knoxville + Morristown TN */
  KAAR = 'KAAR',
  /** Kanawha Valley Board of REALTORS */
  KVBARMLS = 'KVBARMLS',
  /** Longview Area Association of REALTORS */
  LAARMLS = 'LAARMLS',
  /** Lynchburg Association of REALTORS */
  LARMLS = 'LARMLS',
  /** Luzerne County Association of REALTORS */
  LCARMLS = 'LCARMLS',
  /** Lake Havasu Association of REALTORS */
  LHARMLS = 'LHARMLS',
  /** Lake of the Ozarks Board of REALTORS */
  LOBRMLS = 'LOBRMLS',
  /** Longleaf Pine REALTORS */
  LPRMLS = 'LPRMLS',
  /** Lowcountry Regional MLS (BeaufortJasper County REALTORS) */
  LRMLS = 'LRMLS',
  /** Lake Superior Area REALTORS */
  LSARMLS = 'LSARMLS',
  /** Lubbock Association of REALTORS */
  LUBBOCKMLS = 'LUBBOCKMLS',
  /** Memphis - ? (Memphis, TN) */
  MAARMLS = 'MAARMLS',
  /** Maine Listings */
  MAINEMLS = 'MAINEMLS',
  /** St Louis MO */
  MARIS = 'MARIS',
  /** Maui MLS (REALTORS Association of Maui) */
  MAUIMLS = 'MAUIMLS',
  /** Sacramento Metro - SAC (Sacramento, CA) */
  METROLIST = 'METROLIST',
  /** Metro MLS */
  METROMLS = 'METROMLS',
  /** Mid Florida - ORL (Orlando, FL), TPA (Tampa, FL) */
  MFRMLS = 'MFRMLS',
  /** Miami FL */
  MIAMIRE = 'MIAMIRE',
  /** Indianapolis, IN */
  MIBOR = 'MIBOR',
  /** MiRealSource */
  MIREAL = 'MIREAL',
  /** California - LAX (Los Angeles, CA) */
  MLSCLAW = 'MLSCLAW',
  /** Hawaii Information Service (MLS Hawaii) */
  MLSHAWAII = 'MLSHAWAII',
  /** San Francisco, South Bay */
  MLSLISTINGS = 'MLSLISTINGS',
  /** Cleveland, OH */
  MLSNOW = 'MLSNOW',
  /** Oklahoma City OK */
  MLSOK = 'MLSOK',
  /** Boston, MA */
  MLSPIN = 'MLSPIN',
  /** Southern Arizona - TUS (Tucson, AZ) */
  MLSSAZ = 'MLSSAZ',
  /** MLS Technology */
  MLSTECHNOLOGY = 'MLSTECHNOLOGY',
  /** MLS United */
  MLSU = 'MLSU',
  /** Montgomery Area Association of REALTORS */
  MOARMLS = 'MOARMLS',
  /** MOREMLS (Monmouth Ocean Regional REALTORS) */
  MOREMLS = 'MOREMLS',
  /** Mount Rushmore Area Association of REALTORS */
  MRAAR = 'MRAAR',
  /** Chicago, IL */
  MREDMLS = 'MREDMLS',
  /** Montana Regional MLS */
  MRMLS = 'MRMLS',
  /** National */
  MYSTATE = 'MYSTATE',
  /** NoCoast MLS */
  NCMLS = 'NCMLS',
  /** North Central West Virginia REIN */
  NCWVREIN = 'NCWVREIN',
  /** Northeast Arkansas Board of REALTORS */
  NEABOR = 'NEABOR',
  /** Northeast Florida - JAX (Jacksonville, FL) */
  NEFMLS = 'NEFMLS',
  /** Northeast Georgia Board of REALTORS */
  NEGBORMLS = 'NEGBORMLS',
  /** Northeast Iowa Regional Board of REALTORS */
  NEIRBOR = 'NEIRBOR',
  /** Northeast Mississippi Board of REALTORS */
  NEMISMLS = 'NEMISMLS',
  /** Northeast Oklahoma Board of Realtors (Tulsa) */
  NEOBRMLS = 'NEOBRMLS',
  /** Northeast Oklahoma Board of REALTORS */
  NEOKMLS = 'NEOKMLS',
  /** Northeast REALTORS of Louisiana */
  NERLMLS = 'NERLMLS',
  /** Northern Great Lakes REALTORS MLS */
  NGLRMLS = 'NGLRMLS',
  /** Northwest Indiana REALTORS Association */
  NIRAMLS = 'NIRAMLS',
  /** New Jersey MLS (NJ/NY) */
  NJMLS = 'NJMLS',
  /** Northern Kentucky */
  NKARMLS = 'NKARMLS',
  /** New Mexico MLS */
  NMMLS = 'NMMLS',
  /** Reno NV */
  NNRMLS = 'NNRMLS',
  /** Tulsa, OK */
  NORES = 'NORES',
  /** Northwest Ohio Real Estate Information Service (NORIS) */
  NORIS = 'NORIS',
  /** Minnesota and Western Wisconsin - MSP (Minneapolis, MN) */
  NORTHSTAR = 'NORTHSTAR',
  /** North Texas - DFW (Dallas Ft Worth, TX) */
  NTREIS = 'NTREIS',
  /** NorthWest Illinois Alliance of REALTORS */
  NWILARMLS = 'NWILARMLS',
  /** Seattle, WA */
  NWMLS = 'NWMLS',
  /** Northwestern Wisconsin Multiple Listing Service */
  NWWMLS = 'NWWMLS',
  /** NY State MLS */
  NYSTATEMLS = 'NYSTATEMLS',
  /** Odessa Board of REALTORS */
  ODESSAMLS = 'ODESSAMLS',
  /** Oregon Data Share */
  ODSHARE = 'ODSHARE',
  /** Ozark Gateway Association of REALTORS */
  OGARMLS = 'OGARMLS',
  /** Hudson Valley, Long Island (NJ/NY) */
  ONEKEY = 'ONEKEY',
  /** Deprecated - MLS name is ONEKEY, see below */
  ONEKEYMLS = 'ONEKEYMLS',
  /** Prescott AZ */
  PAAR = 'PAAR',
  /** Permian Basin Board of REALTORS */
  PBBORMLS = 'PBBORMLS',
  /** Park City Board of REALTORS */
  PCBOR = 'PCBOR',
  /** Pensacola Association of REALTORS */
  PENSACOLAMLS = 'PENSACOLAMLS',
  /** Pocono Mountains Association of REALTORS */
  PMARMLS = 'PMARMLS',
  /** Colorado Springs, CO */
  PPMLS = 'PPMLS',
  /** PrimeMLS */
  PRIMEMLS = 'PRIMEMLS',
  /** Pacific Regional MLS */
  PRMLS = 'PRMLS',
  /** Pueblo Association of REALTORS */
  PUEBLOMLS = 'PUEBLOMLS',
  /** REALTOR Association of Acadiana */
  RAAMLS = 'RAAMLS',
  /** REALTORS Association of Citrus County */
  RACITRUS = 'RACITRUS',
  /** REALTORS Association of Indian River County */
  RAIRC = 'RAIRC',
  /** REALTORS Association of Northeast Wisconsin */
  RANWMLS = 'RANWMLS',
  /** REALTOR Association of Southern Minnesota */
  RASMMLS = 'RASMMLS',
  /** River Counties Association of REALTORS */
  RCARMLS = 'RCARMLS',
  /** Detroit, MI */
  REALCOMP = 'REALCOMP',
  /** Mid-South - NAS (Nashville, TN) */
  REALTRACS = 'REALTRACS',
  /** Real Estate Board of New York (REBNY) */
  REBNY = 'REBNY',
  /** Colorado - DEN (Denver, CO) */
  RECOLORADO = 'RECOLORADO',
  /** Real Estate Information Network (REIN) */
  REIN = 'REIN',
  /** Real Estate Information Services (REALTOR Association of Southern Kentucky) */
  REISKMLS = 'REISKMLS',
  /** REsides */
  RESIDES = 'RESIDES',
  /** REALTORS of Greater Augusta */
  RGAMLS = 'RGAMLS',
  /** Rio Grande Valley Multiple Listing Service (Harlingen Board of REALTORS) */
  RGVMLS = 'RGVMLS',
  /** ? - PDX (Portland, OR) */
  RMLS = 'RMLS',
  /** RMLS Alliance */
  RMLSA = 'RMLSA',
  /** ROAM MLS */
  ROAMMLS = 'ROAMMLS',
  /** Roanoke Valley Association of REALTORS */
  RVARMLS = 'RVARMLS',
  /** San Antonio - SAT (San Antonio, TX) */
  SABORMLS = 'SABORMLS',
  /** Santa Fe Association of REALTORS */
  SAFARMLS = 'SAFARMLS',
  /** South Central Kansas MLS */
  SCKMLS = 'SCKMLS',
  /** South Central Wisconsin Multiple Listing Service */
  SCWMLS = 'SCWMLS',
  /** San Diego - ? (San Diego, CA) */
  SDMLS = 'SDMLS',
  /** Southeast Alaska MLS */
  SEAKMLS = 'SEAKMLS',
  /** San Francisco, Peninsula */
  SFAR = 'SFAR',
  /** Staten Island Multiple Listing Service */
  SIMLS = 'SIMLS',
  /** REALTOR Association of the Sioux Empire */
  SIOUXMLS = 'SIOUXMLS',
  /** Louisville (Indiana side) */
  SIRAMLS = 'SIRAMLS',
  /** South Jersey Shore Regional MLS */
  SJSMLS = 'SJSMLS',
  /** SmartMLS */
  SMARTMLS = 'SMARTMLS',
  /** Savannah MultiList Corporation */
  SMLMLS = 'SMLMLS',
  /** Strategic MLS Alliance (Cullman Shoals Area) */
  SMLSA = 'SMLSA',
  /** Snake River Regional MLS */
  SNAKERMLS = 'SNAKERMLS',
  /** Southern Missouri Regional MLS */
  SOMOMLS = 'SOMOMLS',
  /** Space Coast MLS (Space Coast Association of REALTORS) */
  SPACECOASTMLS = 'SPACECOASTMLS',
  /** Greenville + Anderson SC */
  SPTBGMLS = 'SPTBGMLS',
  /** Spokane Association of REALTORS */
  SRMLS = 'SRMLS',
  /** StateWide MLS */
  STATEWIDEMLS = 'STATEWIDEMLS',
  /** Sunflower Association of REALTORS */
  SUNARMLS = 'SUNARMLS',
  /** southwest and Naples FL */
  SWFLA = 'SWFLA',
  /** Albuquerque, NM */
  SWMLS = 'SWMLS',
  /** Southwest Virginia Association of REALTORS */
  SWVARMLS = 'SWVARMLS',
  /** Teton Board of REALTORS */
  TETONMLS = 'TETONMLS',
  /** Triangle Area of North Carolina - RDU (Raleigh, NC) */
  TMLS = 'TMLS',
  /** TennesseeVirginia Regional MLS */
  TNVARMLS = 'TNVARMLS',
  /** Greensboro + Winston NC */
  TRIADMLS = 'TRIADMLS',
  /** Upper Cumberland Association of REALTORS */
  UCARMLS = 'UCARMLS',
  UNKNOWN = 'UNKNOWN',
  /** Upstate New York Real Estate Information Services (UNYREIS) */
  UNYREIS = 'UNYREIS',
  /** Utah - SLC (Salt Lake City, UT) */
  UTAHRE = 'UTAHRE',
  /** ValleyMLScom */
  VALLEYMLS = 'VALLEYMLS',
  /** West Alabama Multiple Listing Service */
  WAMLS = 'WAMLS',
  /** Western Arizona REALTOR Data Exchange (WARDEX) */
  WARDEX = 'WARDEX',
  /** Washington County Board of REALTORS */
  WCBORMLS = 'WCBORMLS',
  /** Wisconsin Real Estate Exchange */
  WIREX = 'WIREX',
  /** Western Kentucky Regional MLS */
  WKRMLS = 'WKRMLS',
  /** White Mountain Association of REALTORS */
  WMARMLS = 'WMARMLS',
  /** Western New York Real Estate Information Services (WNYREIS) */
  WNYREIS = 'WNYREIS',
  /** West Penn MultiList */
  WPML = 'WPML',
  /** Western Regional Information Systems & Technology (WRIST) */
  WRIST = 'WRIST',
  /** Western River Valley Board of REALTORS */
  WRVBORMLS = 'WRVBORMLS',
  /** Western Upstate Multiple Listing Service */
  WUMLS = 'WUMLS',
  /** Willamette Valley MLS */
  WVMLS = 'WVMLS',
  /** Water Wonderland Board of REALTORS */
  WWBOR = 'WWBOR',
  /** Wyoming MLS */
  WYMLS = 'WYMLS'
}

export enum OdProtosCommonOptions_Format {
  JSON = 'JSON',
  PROTO = 'PROTO'
}

/**
 * OffsetPaginationRequest
 *
 * More lightweight than the PaginationRequest
 * it only allows forward pagination
 */
export type OdProtosCommonPagination_OffsetPaginationRequestInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Pagination request.
 *
 * To enable forward pagination, two arguments are required.
 * * first takes a non‐negative integer.
 * * after takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges after the after cursor, and returning at
 * most first edges.
 *
 * To enable backward pagination, two arguments are required.
 * * last takes a non‐negative integer.
 * * before takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges before the before cursor, and returning at
 * most last edges.
 */
export type OdProtosCommonPagination_PaginationRequestInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
};

/** Tribool is a boolean (Yes/No) with a third state (Maybe). */
export enum OdProtosCommonPagination_Tribool {
  MAYBE = 'MAYBE',
  NO = 'NO',
  YES = 'YES'
}

/** Next ID: 9 */
export enum OdProtosCommonSell_ListWithOpendoorRefreshStatus {
  /** @deprecated No longer supported */
  FAIL_ACTIVE_OFFER_ON_ADDRESS_LWOD = 'FAIL_ACTIVE_OFFER_ON_ADDRESS_LWOD',
  /** @deprecated No longer supported */
  FAIL_LEAD_NOT_FOUND_LWOD = 'FAIL_LEAD_NOT_FOUND_LWOD',
  /** @deprecated No longer supported */
  FAIL_LWOD_ERR_QUALIFY_LEAD = 'FAIL_LWOD_ERR_QUALIFY_LEAD',
  /** @deprecated No longer supported */
  FAIL_MERCH_MISSING_PRODUCT_LWOD = 'FAIL_MERCH_MISSING_PRODUCT_LWOD',
  /** @deprecated No longer supported */
  FAIL_REFRESH_REQUESTED_TOO_SOON_LWOD = 'FAIL_REFRESH_REQUESTED_TOO_SOON_LWOD',
  /** @deprecated No longer supported */
  NOT_ELIGIBLE_ALREADY_QUALIFIED = 'NOT_ELIGIBLE_ALREADY_QUALIFIED',
  /** @deprecated No longer supported */
  NOT_ELIGIBLE_FOR_REFRESH = 'NOT_ELIGIBLE_FOR_REFRESH',
  /** @deprecated No longer supported */
  REFRESH_SUCCESS = 'REFRESH_SUCCESS',
  /** @deprecated No longer supported */
  UNKNOWN_REFRESH_STATUS = 'UNKNOWN_REFRESH_STATUS'
}

/** Next ID: 35 */
export enum OdProtosCommonSell_OfferRequest_Source {
  AGENT_LED_OFFERS_REACTIVATE = 'AGENT_LED_OFFERS_REACTIVATE',
  AGENT_LED_OFFER_AUTO_REFRESH = 'AGENT_LED_OFFER_AUTO_REFRESH',
  AGENT_LED_OFFER_DROPOUT = 'AGENT_LED_OFFER_DROPOUT',
  /** AUTOMATED_AGENT_REENGAGEMENT_OFFER is used for agent refreshes triggered via the daily DAG */
  AUTOMATED_AGENT_REENGAGEMENT_OFFER = 'AUTOMATED_AGENT_REENGAGEMENT_OFFER',
  /** AUTOMATED_MSRE_REFRESH_OFFER is used for auto offer refreshes for MSRE leads daily */
  AUTOMATED_MSRE_REFRESH_OFFER = 'AUTOMATED_MSRE_REFRESH_OFFER',
  AUTOMATED_REENGAGEMENT_OFFER = 'AUTOMATED_REENGAGEMENT_OFFER',
  /** EMAIL_PROSPECTING is used for offer requests on leads from the EMAIL_PROSPECTING channel */
  EMAIL_PROSPECTING = 'EMAIL_PROSPECTING',
  /** @deprecated No longer supported */
  EXCLUSIVE_OFFERS = 'EXCLUSIVE_OFFERS',
  /** FLYWHEEL is used for offer requests on leads from the FLYWHEEL channel */
  FLYWHEEL = 'FLYWHEEL',
  /** HOMEPAGE_RETURN_EXPERIENCE is used for offer refreshes that are triggered from the homepage */
  HOMEPAGE_RETURN_EXPERIENCE = 'HOMEPAGE_RETURN_EXPERIENCE',
  /** HOME_RESERVE is used for offers requests on leads from the HOME_RESERVE channel */
  HOME_RESERVE = 'HOME_RESERVE',
  /** HSA_FO_REFRESH_OUTREACH is used for final offer refresh experiment outreach after seller schedules with HSA */
  HSA_FO_REFRESH_OUTREACH = 'HSA_FO_REFRESH_OUTREACH',
  INCOMPLETE_INITIAL_LEAD_FLOW = 'INCOMPLETE_INITIAL_LEAD_FLOW',
  INITIAL_LEAD_FLOW = 'INITIAL_LEAD_FLOW',
  MOBILE_APP = 'MOBILE_APP',
  OFFER_REENGAGEMENT_CAMPAIGN = 'OFFER_REENGAGEMENT_CAMPAIGN',
  OFFER_REVIEW = 'OFFER_REVIEW',
  /** OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */
  OUTBOUND_OFFERS_LISTED = 'OUTBOUND_OFFERS_LISTED',
  /** OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that should auto-start underwriting and skip assessments */
  OUTBOUND_OFFERS_UNDERWRITTEN = 'OUTBOUND_OFFERS_UNDERWRITTEN',
  REFRESH_ADMIN = 'REFRESH_ADMIN',
  /** REFRESH_ASSESSMENT_COMPLETED is used when a customer completes a virtual assessment but their offer has expired */
  REFRESH_ASSESSMENT_COMPLETED = 'REFRESH_ASSESSMENT_COMPLETED',
  REFRESH_BROKERAGE_OFFER_DASHBOARD = 'REFRESH_BROKERAGE_OFFER_DASHBOARD',
  REFRESH_CORRECTED_SQ_FT_DATA = 'REFRESH_CORRECTED_SQ_FT_DATA',
  /** REFRESH_FROM_ENG is used for backfilling any refresh properties that expierenced a break in flow due to an error */
  REFRESH_FROM_ENG = 'REFRESH_FROM_ENG',
  /** REFRESH_HOME_DETAILS is used for offer refreshes from the offer dashboard home details page */
  REFRESH_HOME_DETAILS = 'REFRESH_HOME_DETAILS',
  REFRESH_OFFER_DASHBOARD = 'REFRESH_OFFER_DASHBOARD',
  /** REFRESH_PARTNER_CTA is used for offer requests that come from Opendoor partners */
  REFRESH_PARTNER_CTA = 'REFRESH_PARTNER_CTA',
  /** REFRESH_PARTNER_REFERRAL is used for offers refreshed from the partnerships referral dashboard */
  REFRESH_PARTNER_REFERRAL = 'REFRESH_PARTNER_REFERRAL',
  REFRESH_PREVIOUSLY_DENIED = 'REFRESH_PREVIOUSLY_DENIED',
  REFRESH_REENGAGEMENT_EMAILS = 'REFRESH_REENGAGEMENT_EMAILS',
  REFRESH_SELLER_FEEDBACK = 'REFRESH_SELLER_FEEDBACK',
  REIT_BULK_REQUEST = 'REIT_BULK_REQUEST',
  /**
   * Restore offer because of an LWOD Listing agreement being signed
   * @deprecated No longer supported
   */
  RESTORE_LWOD_LISTING_AGREEMENT_SIGNED = 'RESTORE_LWOD_LISTING_AGREEMENT_SIGNED',
  /** RETURN_TO_HUB_AUTO_REFRESH is used for offer refreshes automatically made when users return to the Hub */
  RETURN_TO_HUB_AUTO_REFRESH = 'RETURN_TO_HUB_AUTO_REFRESH',
  UNKNOWN_OFFER_SOURCE = 'UNKNOWN_OFFER_SOURCE'
}

export enum OdProtosCommonSell_OpendoorWalkReason {
  OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION = 'OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION',
  OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK = 'OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK',
  OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM = 'OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM',
  OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY = 'OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY',
  OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE = 'OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE',
  OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE = 'OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE',
  OPENDOOR_WALK_REASON_SEE_UNDERWRITING = 'OPENDOOR_WALK_REASON_SEE_UNDERWRITING',
  OPENDOOR_WALK_REASON_UNKNOWN = 'OPENDOOR_WALK_REASON_UNKNOWN'
}

/** Next ID: 17 */
export enum OdProtosCommonSell_SellDirectOfferRefreshStatus {
  FAIL_ACTIVE_OFFER_ON_ADDRESS = 'FAIL_ACTIVE_OFFER_ON_ADDRESS',
  FAIL_ACTIVE_OFFER_REQUEST_ON_ADDRESS = 'FAIL_ACTIVE_OFFER_REQUEST_ON_ADDRESS',
  FAIL_EXISTING_OFFER_NOT_FOUND = 'FAIL_EXISTING_OFFER_NOT_FOUND',
  FAIL_HOME_IS_NOW_LISTED = 'FAIL_HOME_IS_NOW_LISTED',
  FAIL_INSPECTION_IN_PROGRESS = 'FAIL_INSPECTION_IN_PROGRESS',
  FAIL_LEAD_NOT_FOUND_SELL_DIRECT = 'FAIL_LEAD_NOT_FOUND_SELL_DIRECT',
  FAIL_LEAD_NOT_QUALIFIED = 'FAIL_LEAD_NOT_QUALIFIED',
  FAIL_LISTING_DETAILS_NOT_FOUND = 'FAIL_LISTING_DETAILS_NOT_FOUND',
  FAIL_LWC_REFRESH_PERMISSION_DENIED = 'FAIL_LWC_REFRESH_PERMISSION_DENIED',
  FAIL_MERCH_DENIED_LEAD = 'FAIL_MERCH_DENIED_LEAD',
  FAIL_OFFER_ALREADY_REFRESHED = 'FAIL_OFFER_ALREADY_REFRESHED',
  FAIL_OFFER_NOT_EXPIRED = 'FAIL_OFFER_NOT_EXPIRED',
  FAIL_OFFER_STATE_NOT_REFRESHABLE = 'FAIL_OFFER_STATE_NOT_REFRESHABLE',
  FAIL_REFRESH_REQUESTED_TOO_SOON = 'FAIL_REFRESH_REQUESTED_TOO_SOON',
  FAIL_UPCOMING_CALENDLY_MEETING = 'FAIL_UPCOMING_CALENDLY_MEETING',
  SUCCESS = 'SUCCESS',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosCommonSell_SellerWalkReason {
  SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME = 'SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME',
  SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED = 'SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED',
  SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER = 'SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER',
  SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION = 'SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION',
  SELLER_WALK_REASON_HOME_IS_LISTED = 'SELLER_WALK_REASON_HOME_IS_LISTED',
  SELLER_WALK_REASON_LEGAL_ISSUES = 'SELLER_WALK_REASON_LEGAL_ISSUES',
  SELLER_WALK_REASON_NET_CASH = 'SELLER_WALK_REASON_NET_CASH',
  SELLER_WALK_REASON_NOT_SELLING = 'SELLER_WALK_REASON_NOT_SELLING',
  SELLER_WALK_REASON_OTHER_REASON = 'SELLER_WALK_REASON_OTHER_REASON',
  SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK = 'SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK',
  SELLER_WALK_REASON_UNKNOWN = 'SELLER_WALK_REASON_UNKNOWN'
}

export enum OdProtosCommonSell_WalkInitiator {
  WALK_INITIATOR_OPENDOOR = 'WALK_INITIATOR_OPENDOOR',
  WALK_INITIATOR_SELLER = 'WALK_INITIATOR_SELLER',
  WALK_INITIATOR_UNKNOWN = 'WALK_INITIATOR_UNKNOWN'
}

export enum OdProtosCommonState_RecordingState_State {
  /** Arizona State */
  AZ = 'AZ',
  /** California State */
  CA = 'CA',
  /** Idaho State */
  ID = 'ID',
  /** Nevada State */
  NV = 'NV',
  /** Oregon State */
  OR = 'OR',
  UNKNOWN = 'UNKNOWN',
  /** Utah State */
  UT = 'UT'
}

/** Next ID: 66 */
export enum OdProtosCommonState_State {
  /** Armed Forces Americas */
  AA = 'AA',
  /** Armed Forces Europe */
  AE = 'AE',
  /** Alaska State */
  AK = 'AK',
  /** Alabama State */
  AL = 'AL',
  /** Armed Forces Pacific */
  AP = 'AP',
  /** Arkansas State */
  AR = 'AR',
  /** American Samoa */
  AS = 'AS',
  /** Arizona State */
  AZ = 'AZ',
  /** California State */
  CA = 'CA',
  /** Colorado State */
  CO = 'CO',
  /** Connecticut State */
  CT = 'CT',
  /** District of Columbia Federal district */
  DC = 'DC',
  /** Delaware State */
  DE = 'DE',
  /** Florida State */
  FL = 'FL',
  /** Georgia State */
  GA = 'GA',
  /** Guam */
  GU = 'GU',
  /** Hawaii State */
  HI = 'HI',
  /** Iowa State */
  IA = 'IA',
  /** Idaho State */
  ID = 'ID',
  /** Illinois State */
  IL = 'IL',
  /** Indiana State */
  IN = 'IN',
  /** Kansas State */
  KS = 'KS',
  /** Kentucky State (Commonwealth) */
  KY = 'KY',
  /** Louisiana State */
  LA = 'LA',
  /** Massachusetts State (Commonwealth) */
  MA = 'MA',
  /** Maryland State */
  MD = 'MD',
  /** Maine State */
  ME = 'ME',
  /** Michigan State */
  MI = 'MI',
  /** Minnesota State */
  MN = 'MN',
  /** Missouri State */
  MO = 'MO',
  /** Northern Mariana Islands (Commonwealth) */
  MP = 'MP',
  /** Mississippi State */
  MS = 'MS',
  /** Montana State */
  MT = 'MT',
  /** North Carolina */
  NC = 'NC',
  /** North Dakota State */
  ND = 'ND',
  /** Nebraska State */
  NE = 'NE',
  /** New Hampshire State */
  NH = 'NH',
  /** New Jersey State */
  NJ = 'NJ',
  /** New Mexico State */
  NM = 'NM',
  /** Nevada State */
  NV = 'NV',
  /** New York State */
  NY = 'NY',
  /** Ohio State */
  OH = 'OH',
  /** Oklahoma State */
  OK = 'OK',
  /** Oregon State */
  OR = 'OR',
  /** Pennsylvania State (Commonwealth) */
  PA = 'PA',
  /** Puerto Rico (Commonwealth) */
  PR = 'PR',
  /** Rhode Island State */
  RI = 'RI',
  /** South Carolina State */
  SC = 'SC',
  /** South Dakota State */
  SD = 'SD',
  /** Tennessee State */
  TN = 'TN',
  /** Texas State */
  TX = 'TX',
  UNKNOWN = 'UNKNOWN',
  /** Utah State */
  UT = 'UT',
  /** Virginia State (Commonwealth) */
  VA = 'VA',
  /** Virgin Islands */
  VI = 'VI',
  /** Vermont State */
  VT = 'VT',
  /** Washington State */
  WA = 'WA',
  /** Wisconsin	State */
  WI = 'WI',
  /** West Virginia State */
  WV = 'WV',
  /** Wyoming	State */
  WY = 'WY'
}

/**
 * Commonly used time zones. For a comprehensive list see:
 * https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 *
 * Next ID: 7
 */
export enum OdProtosCommonTimezone_TimeZone {
  /** America/Chicago aka Central time. */
  AMERICA_CHICAGO = 'AMERICA_CHICAGO',
  /** America/Denver aka Mountain time. */
  AMERICA_DENVER = 'AMERICA_DENVER',
  /** America/Los_Angeles aka Pacific time */
  AMERICA_LOS_ANGELES = 'AMERICA_LOS_ANGELES',
  /** America/New_York aka Eastern time. */
  AMERICA_NEW_YORK = 'AMERICA_NEW_YORK',
  /**
   * America/Phoenix. Observed in most parts of Arizona, this time zone is
   * Mountain time without DST.
   */
  AMERICA_PHOENIX = 'AMERICA_PHOENIX',
  UNKNOWN = 'UNKNOWN',
  /** Coordinated Universal Time */
  UTC = 'UTC'
}

export enum OdProtosCommon_Area_Unit {
  SQUARE_INCH = 'SQUARE_INCH',
  SQUARE_METER = 'SQUARE_METER',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosCommon_DateInput = {
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year/month where the day is not significant.
   */
  day?: InputMaybe<Scalars['Float']['input']>;
  /** Month of year. Must be from 1 to 12. */
  month?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosCommon_DayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  UNKNOWN = 'UNKNOWN',
  WEDNESDAY = 'WEDNESDAY'
}

/** An amount of time. */
export type OdProtosCommon_DurationInput = {
  unit?: InputMaybe<OdProtosCommon_Duration_Unit>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosCommon_Duration_Unit {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  SECOND = 'SECOND',
  UNKWOWN = 'UNKWOWN',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

/** Next ID: 2 */
export type OdProtosCommon_EmailAddressInput = {
  /** Full e-mail address */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommon_FloatRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Represents a mailing address
 * NextID: 7
 */
export type OdProtosCommon_MailingAddressInput = {
  /** City, Suburb, etc */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Street number, Street name and direction */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Unit/Apartment number, etc */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** State code (e.g. AZ) */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Zip/Postal code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 3 */
export enum OdProtosCommon_MeasurementUnit {
  EACH = 'EACH',
  LINEAR_FT = 'LINEAR_FT',
  SQ_FT = 'SQ_FT'
}

/** Next ID: 3 */
export type OdProtosCommon_MoneyInput = {
  /** defaults to USD */
  currencyCode?: InputMaybe<OdProtosCommon_Money_AlphabeticCurrencyCode>;
  /** value in lowest unit, e.g. this would be cents in USD */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCommon_MoneyRangeInput = {
  max?: InputMaybe<OdProtosCommon_MoneyInput>;
  min?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/**
 * defaults to USD;
 * sourced on 2017-04-27 from https://www.iso.org/iso-4217-currency-codes.html
 */
export enum OdProtosCommon_Money_AlphabeticCurrencyCode {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ANG = 'ANG',
  AOA = 'AOA',
  ARS = 'ARS',
  AUD = 'AUD',
  AWG = 'AWG',
  AZN = 'AZN',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BOV = 'BOV',
  BRL = 'BRL',
  BSD = 'BSD',
  BTN = 'BTN',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHE = 'CHE',
  CHF = 'CHF',
  CHW = 'CHW',
  CLF = 'CLF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  COU = 'COU',
  CRC = 'CRC',
  CUC = 'CUC',
  CUP = 'CUP',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  FJD = 'FJD',
  FKP = 'FKP',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNF = 'GNF',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KPW = 'KPW',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRO = 'MRO',
  MUR = 'MUR',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MXV = 'MXV',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SLL = 'SLL',
  SOS = 'SOS',
  SRD = 'SRD',
  SSP = 'SSP',
  STD = 'STD',
  SVC = 'SVC',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJS = 'TJS',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  USN = 'USN',
  UYI = 'UYI',
  UYU = 'UYU',
  UZS = 'UZS',
  VEF = 'VEF',
  VND = 'VND',
  VUV = 'VUV',
  WST = 'WST',
  XAF = 'XAF',
  XAG = 'XAG',
  XAU = 'XAU',
  XBA = 'XBA',
  XBB = 'XBB',
  XBC = 'XBC',
  XBD = 'XBD',
  XCD = 'XCD',
  XDR = 'XDR',
  XOF = 'XOF',
  XPD = 'XPD',
  XPF = 'XPF',
  XPT = 'XPT',
  XSU = 'XSU',
  XTS = 'XTS',
  XUA = 'XUA',
  XXX = 'XXX',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMW = 'ZMW',
  ZWL = 'ZWL'
}

/** Next ID: 3 */
export type OdProtosCommon_NameInput = {
  /** Last name */
  familyName?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  givenName?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosCommon_PhoneNumberInput = {
  /** Fully qualified phone number */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Client-provided generated uuid for tracing the request. */
export type OdProtosCommon_RequestIdInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Registered client identifier */
export type OdProtosCommon_RequestorIdInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosCommon_SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type OdProtosCommon_TimeInput = {
  /** Hours of a time, where 0 is midnight, 12 is noon, and 13 is 1pm. */
  hours?: InputMaybe<Scalars['Float']['input']>;
  /** Minutes of a time. */
  minutes?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCommon_UInt32RangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCommunicationData_AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * unknown: an invalid state, indicating a system error
 * completed: call was handled successfully
 * canceled: call ended before completion (e.g. customer hangup, system error)
 * in_progress: call is ongoing
 * queued: the call has been queued, but has not started yet. this generally applies to outbound calls
 */
export enum OdProtosCommunicationData_CallStatus {
  CALL_STATUS_UNKNOWN = 'CALL_STATUS_UNKNOWN',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  QUEUED = 'QUEUED'
}

/**
 * Provides context around outgoing SMS messages. These are stored in Opencomm and used for analytics purposes.
 * To be included in mutation APIs (sends)
 */
export type OdProtosCommunicationData_CommunicationContextInput = {
  /** UUID of communication this message is replying to, if available */
  inReplyToUuid?: InputMaybe<Scalars['String']['input']>;
  isAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<OdProtosCommunicationData_Locale>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<OdProtosCommunicationData_CommunicationTag>>;
  zendeskTicketUuid?: InputMaybe<Scalars['String']['input']>;
};

/** see https://opendoor.atlassian.net/wiki/spaces/CO/pages/2053898320/Telephony+Strategy+Phone+numbers+categories */
export enum OdProtosCommunicationData_CommunicationDirection {
  DIRECTION_UNKNOWN = 'DIRECTION_UNKNOWN',
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

/** next field index: 17 */
export enum OdProtosCommunicationData_CommunicationTag {
  BUY_DIRECT_CONTRACT_EXECUTED = 'BUY_DIRECT_CONTRACT_EXECUTED',
  BUY_DIRECT_CONTRACT_SENT = 'BUY_DIRECT_CONTRACT_SENT',
  BUY_DIRECT_ESCROW_DEPOSIT = 'BUY_DIRECT_ESCROW_DEPOSIT',
  BUY_DIRECT_ESCROW_DEPOSIT_REMINDER = 'BUY_DIRECT_ESCROW_DEPOSIT_REMINDER',
  BUY_DIRECT_ESCROW_MONEY_RECEIVED = 'BUY_DIRECT_ESCROW_MONEY_RECEIVED',
  BUY_DIRECT_OFFER_RECEIVED = 'BUY_DIRECT_OFFER_RECEIVED',
  BUY_DIRECT_OFFER_WITHDRAWN = 'BUY_DIRECT_OFFER_WITHDRAWN',
  BUY_DIRECT_POST_CLOSE = 'BUY_DIRECT_POST_CLOSE',
  /** Buy Direct lifecycle milestones */
  BUY_DIRECT_TOUR_BOOKED = 'BUY_DIRECT_TOUR_BOOKED',
  BUY_DIRECT_TOUR_CANCELLED = 'BUY_DIRECT_TOUR_CANCELLED',
  BUY_DIRECT_TOUR_COMPLETE = 'BUY_DIRECT_TOUR_COMPLETE',
  BUY_DIRECT_TOUR_REMINDER = 'BUY_DIRECT_TOUR_REMINDER',
  COMMUNICATION_TAG_UNSPECIFIED = 'COMMUNICATION_TAG_UNSPECIFIED',
  EP_TO_SUPPORT_CALL_TRANSFER = 'EP_TO_SUPPORT_CALL_TRANSFER',
  FINAL_OFFER_CALL = 'FINAL_OFFER_CALL',
  OFFER_REVIEW_CALL = 'OFFER_REVIEW_CALL',
  SPREAD_REDUCTION_CALL = 'SPREAD_REDUCTION_CALL'
}

export enum OdProtosCommunicationData_ContactNotMadeReason {
  CONTACT_NOT_MADE_REASON_BUSY = 'CONTACT_NOT_MADE_REASON_BUSY',
  CONTACT_NOT_MADE_REASON_FAILED = 'CONTACT_NOT_MADE_REASON_FAILED',
  CONTACT_NOT_MADE_REASON_NO_ANSWER = 'CONTACT_NOT_MADE_REASON_NO_ANSWER',
  CONTACT_NOT_MADE_REASON_UNSPECIFIED = 'CONTACT_NOT_MADE_REASON_UNSPECIFIED',
  CONTACT_NOT_MADE_REASON_VOICEMAIL = 'CONTACT_NOT_MADE_REASON_VOICEMAIL'
}

export enum OdProtosCommunicationData_DevicePlatform {
  DEVICE_PLATFORM_ANDROID = 'DEVICE_PLATFORM_ANDROID',
  DEVICE_PLATFORM_IOS = 'DEVICE_PLATFORM_IOS',
  DEVICE_PLATFORM_UNSPECIFIED = 'DEVICE_PLATFORM_UNSPECIFIED'
}

export enum OdProtosCommunicationData_DeviceRegistrationState {
  DEVICE_REGISTRATION_STATE_ACTIVE = 'DEVICE_REGISTRATION_STATE_ACTIVE',
  DEVICE_REGISTRATION_STATE_PENDING = 'DEVICE_REGISTRATION_STATE_PENDING',
  DEVICE_REGISTRATION_STATE_PENDING_DEACTIVATION = 'DEVICE_REGISTRATION_STATE_PENDING_DEACTIVATION',
  DEVICE_REGISTRATION_STATE_UNSPECIFIED = 'DEVICE_REGISTRATION_STATE_UNSPECIFIED'
}

export enum OdProtosCommunicationData_EmailStatusEventType {
  BOUNCED = 'BOUNCED',
  CLICKED = 'CLICKED',
  EMAIL_STATUS_EVENT_TYPE_UNKNOWN = 'EMAIL_STATUS_EVENT_TYPE_UNKNOWN',
  MARKED_SPAM = 'MARKED_SPAM',
  OPENED = 'OPENED'
}

export enum OdProtosCommunicationData_Locale {
  LOCALE_EN = 'LOCALE_EN',
  LOCALE_ES = 'LOCALE_ES',
  LOCALE_UNSPECIFIED = 'LOCALE_UNSPECIFIED'
}

/**
 * see https://opendoor.atlassian.net/wiki/spaces/CO/pages/2053898320/Telephony+Strategy+Phone+numbers+categories
 * next enum value: 15
 */
export enum OdProtosCommunicationData_PhoneNumberCategory {
  /** Access related */
  ACCESS = 'ACCESS',
  AI_AGENT = 'AI_AGENT',
  /** Buyer experience communications */
  BUYER_EXPERIENCE = 'BUYER_EXPERIENCE',
  /** Buy Direct buyer communications */
  BUY_DIRECT = 'BUY_DIRECT',
  CHATBOT = 'CHATBOT',
  /** Direct line to a specific person via Twilio Flex */
  DIRECT = 'DIRECT',
  /** Direct line to a specific person via Mobile Phone */
  DIRECT_MOBILE = 'DIRECT_MOBILE',
  EXPERIMENTAL = 'EXPERIMENTAL',
  INFRASTRUCTURE = 'INFRASTRUCTURE',
  /**
   * Quarantine is no longer a category but a flag on a phone number
   * @deprecated No longer supported
   */
  QUARANTINE = 'QUARANTINE',
  /**
   * Deprecated
   * Phone numbers pooled to anonymize the correspondents
   * https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2402222221/Agent+Relay+WIP
   * @deprecated No longer supported
   */
  RELAY_POOL = 'RELAY_POOL',
  /** general support */
  SUPPORT = 'SUPPORT',
  TESTING = 'TESTING',
  UNKNOWN = 'UNKNOWN',
  /**
   * Visitor workflow
   * @deprecated No longer supported
   */
  VISITOR = 'VISITOR'
}

export type OdProtosCommunicationData_PhoneNumberSpecificationInput = {
  category?: InputMaybe<OdProtosCommunicationData_PhoneNumberCategory>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Push notification states */
export enum OdProtosCommunicationData_PushNotificationState {
  PUSH_NOTIFICATION_STATE_ACCEPTED = 'PUSH_NOTIFICATION_STATE_ACCEPTED',
  PUSH_NOTIFICATION_STATE_FAILED = 'PUSH_NOTIFICATION_STATE_FAILED',
  PUSH_NOTIFICATION_STATE_SENT = 'PUSH_NOTIFICATION_STATE_SENT',
  PUSH_NOTIFICATION_STATE_UNSPECIFIED = 'PUSH_NOTIFICATION_STATE_UNSPECIFIED'
}

export type OdProtosCommunicationData_SendEmailOptionsInput = {
  /**
   * when non-zero, opencomm will prevent sending the same email (same recipients, same email content) within
   * the specified time window, in seconds
   */
  dedupeWindowSeconds?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Transactional emails are one-time notifications such as password resets and purchase confirmations
   * They maintain separate unsubscribe lists from things like marketing emails
   */
  transactional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCommunicationData_SendSmsOptionsInput = {
  /**
   * Opencomm will prevent sending the same SMS (same recipient, same content) within the specified time window, in seconds
   * By default, opencomm will dedupe within an hour window - set this value to override this behavior.
   * Set it to 0 to disable dedupe
   */
  dedupeWindowSeconds?: InputMaybe<Scalars['Float']['input']>;
  shortenUrl?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosCommunicationData_SmsStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SENT = 'SENT'
}

export enum OdProtosCommunicationData_TranscriptRole {
  TRANSCRIPT_ROLE_AGENT = 'TRANSCRIPT_ROLE_AGENT',
  TRANSCRIPT_ROLE_CUSTOMER = 'TRANSCRIPT_ROLE_CUSTOMER',
  TRANSCRIPT_ROLE_UNSPECIFIED = 'TRANSCRIPT_ROLE_UNSPECIFIED'
}

export enum OdProtosCommunicationData_TranscriptionStatus {
  TRANSCRIPTION_COMPLETED = 'TRANSCRIPTION_COMPLETED',
  TRANSCRIPTION_FAILED = 'TRANSCRIPTION_FAILED',
  TRANSCRIPTION_PROCESSING = 'TRANSCRIPTION_PROCESSING',
  TRANSCRIPTION_STATUS_UNSPECIFIED = 'TRANSCRIPTION_STATUS_UNSPECIFIED'
}

/** Call analysis enums and messages */
export enum OdProtosCommunicationData_UserSentiment {
  USER_SENTIMENT_NEGATIVE = 'USER_SENTIMENT_NEGATIVE',
  USER_SENTIMENT_NEUTRAL = 'USER_SENTIMENT_NEUTRAL',
  USER_SENTIMENT_POSITIVE = 'USER_SENTIMENT_POSITIVE',
  USER_SENTIMENT_UNSPECIFIED = 'USER_SENTIMENT_UNSPECIFIED'
}

/**
 * unspecified: an invalid state, indicating some error
 * processing: voicemail is processing
 * completed: voicemail is processed and ready for use
 * canceled: voicemail experienced some error, no longer available
 */
export enum OdProtosCommunicationData_VoicemailStatus {
  VOICEMAIL_CANCELED = 'VOICEMAIL_CANCELED',
  VOICEMAIL_COMPLETED = 'VOICEMAIL_COMPLETED',
  VOICEMAIL_PROCESSING = 'VOICEMAIL_PROCESSING',
  VOICEMAIL_STATUS_UNSPECIFIED = 'VOICEMAIL_STATUS_UNSPECIFIED'
}

export type OdProtosCommunicationServices_ApplyCategoryConfigurationRequestInput = {
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  numbersToUpdate?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_BlockIncomingPhoneNumberRequestInput = {
  incomingPhoneNumber?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_BuyAccessPhoneNumberRequestInput = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Opencomm will determine it by category */
  messagingServiceSid?: InputMaybe<Scalars['String']['input']>;
  phoneAreaCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_BuyPhoneNumberForUserRequestInput = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  phoneAreaCode?: InputMaybe<Scalars['String']['input']>;
  useMobilePhone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCommunicationServices_BuySupportPhoneNumberRequestInput = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Opencomm will determine it by category */
  messagingServiceSid?: InputMaybe<Scalars['String']['input']>;
  phoneAreaCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_CreateProviderCallRequestInput = {
  /** Call configuration specific to the use case */
  callConfig?: InputMaybe<OdProtosCommunicationServices_CreateProviderCallRequest_CallConfigOneofInput>;
  communicationContext?: InputMaybe<OdProtosCommunicationData_CommunicationContextInput>;
  /** Phone number to call from (should be an Opendoor-owned AI_AGENT type number) */
  fromPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Provider-specific configuration (required - selects provider) */
  providerConfig?: InputMaybe<OdProtosCommunicationServices_CreateProviderCallRequest_ProviderConfigOneofInput>;
  /** Phone number to call to (e.g. customer phone number) */
  toPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_CreateProviderCallRequest_CallConfigOneofInput = {
  offerReview?: InputMaybe<OdProtosCommunicationServices_OfferReviewCallConfigInput>;
  scheduleAssessment?: InputMaybe<OdProtosCommunicationServices_ScheduleAssessmentCallConfigInput>;
};

export type OdProtosCommunicationServices_CreateProviderCallRequest_ProviderConfigOneofInput = {
  retellAi?: InputMaybe<OdProtosCommunicationServices_RetellAiProviderConfigInput>;
};

export type OdProtosCommunicationServices_GenerateHubSpotTwilioTokenRequestInput = {
  humanEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetCallAnalysesByPhoneCallIdsRequestInput = {
  phoneCallIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_GetCommDataForCommIdsRequestInput = {
  communicationids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_GetDeviceRegistrationsByUserEmailRequestInput = {
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetEmailsForCustomerRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetHubSpotContactPhoneRequestInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetHubSpotEngagementRequestInput = {
  engagementId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetOpendoorPhoneNumberByNumberRequestInput = {
  number?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
};

export type OdProtosCommunicationServices_GetOpendoorPhoneNumbersForUserRequestInput = {
  ownerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetPhoneCallsByIdsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_GetPhoneCallsForCustomerRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetPhoneCallsRequestInput = {
  identifier?: InputMaybe<OdProtosCommunicationServices_GetPhoneCallsRequest_IdentifierOneofInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetPhoneCallsRequest_IdentifierOneofInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetSmsMessageRequestInput = {
  smsId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetSmsMessagesForCustomerRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetSmsMessagesForPhoneNumberRequestInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetSmsSummaryForCustomerRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetStructuredTranscriptsByCommunicationIdsRequestInput = {
  communicationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequestInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Use to fetch all records in a given date range, use it without the identifier */
  fetchAll?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneofInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_CommunicationIdsInput = {
  communicationId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_CustomerIdsInput = {
  customerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneofInput = {
  communicationIds?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_CommunicationIdsInput>;
  customerIds?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_CustomerIdsInput>;
  offerIds?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_OfferIdsInput>;
  operatorIds?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_OperatorIdsInput>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_OfferIdsInput = {
  offerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_OperatorIdsInput = {
  operatorId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_GetVoicemailRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_GetVoicemailsRequestInput = {
  identifier?: InputMaybe<OdProtosCommunicationServices_GetVoicemailsRequest_IdentifierOneofInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetVoicemailsRequest_IdentifierOneofInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_HubSpotCallEngagementPropertiesInput = {
  hsActivityType?: InputMaybe<Scalars['String']['input']>;
  hsCallBody?: InputMaybe<Scalars['String']['input']>;
  hsCallDirection?: InputMaybe<Scalars['String']['input']>;
  hsCallDisposition?: InputMaybe<Scalars['String']['input']>;
  hsCallDuration?: InputMaybe<Scalars['String']['input']>;
  hsCallFromNumber?: InputMaybe<Scalars['String']['input']>;
  hsCallRecordingUrl?: InputMaybe<Scalars['String']['input']>;
  hsCallSource?: InputMaybe<Scalars['String']['input']>;
  hsCallStatus?: InputMaybe<Scalars['String']['input']>;
  hsCallToNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_InitiatePhoneCallRequestInput = {
  communicationContext?: InputMaybe<OdProtosCommunicationData_CommunicationContextInput>;
  /**
   * Phone number of Opendoor user initiating the call
   * This MUST be a "DIRECT" number for which the caller is the owner of the number
   */
  fromPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Recipient (customer, vendor, ...) phone number */
  toPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_OfferReviewCallConfigInput = {
  customerName?: InputMaybe<Scalars['String']['input']>;
  insights?: InputMaybe<Array<OdProtosCommunicationServices_OfferReviewCallConfig_InsightsEntryInput>>;
  propertyAddress?: InputMaybe<OdProtosCommunicationData_AddressInput>;
};

/** `OdProtosCommunicationServices_OfferReviewCallConfig_InsightsEntryInput` represents the `insights` map in `od_protos.communication.services.OfferReviewCallConfig`. */
export type OdProtosCommunicationServices_OfferReviewCallConfig_InsightsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_RecordHubSpotCallEndedRequestInput = {
  callSid?: InputMaybe<Scalars['String']['input']>;
  callStatus?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Float']['input']>;
  recordingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_RecordHubSpotCallStartedRequestInput = {
  callSid?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  fromNumber?: InputMaybe<Scalars['String']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  humanEmail?: InputMaybe<Scalars['String']['input']>;
  toNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_RecordIncomingEmailRequestInput = {
  attachments?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  toBccAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  toCcAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_RecordOutgoingEmailRequestInput = {
  attachments?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  toBccAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  toCcAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosCommunicationServices_RegisterDeviceRequestInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<OdProtosCommunicationData_DevicePlatform>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_ReleasePhoneNumberRequestInput = {
  number?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
};

export type OdProtosCommunicationServices_RetellAiProviderConfigInput = {
  /** Optional agent configuration (e.g. for A/B testing) */
  overrideAgentId?: InputMaybe<Scalars['String']['input']>;
  overrideAgentVersion?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_ScheduleAssessmentCallConfigInput = {
  /**
   * Available time slots in format "YYYY-MM-DD morning" or "YYYY-MM-DD afternoon"
   * Example: ["2024-01-15 morning", "2024-01-15 afternoon", "2024-01-16 morning"]
   * Sorted chronologically with mornings before afternoons on the same day
   */
  availableTimeSlots?: InputMaybe<Array<Scalars['String']['input']>>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  propertyAddress?: InputMaybe<OdProtosCommunicationData_AddressInput>;
};

export type OdProtosCommunicationServices_SendEmailRequestInput = {
  additionalHeaders?: InputMaybe<Array<OdProtosCommunicationServices_SendEmailRequest_AdditionalHeadersEntryInput>>;
  /**
   * optional - map of asset ids to attachment file names
   * if not provided, the "Name" of the asset will be used
   */
  attachmentAliases?: InputMaybe<Array<OdProtosCommunicationServices_SendEmailRequest_AttachmentAliasesEntryInput>>;
  attachments?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
  /**
   * from_address and any email recipients can be formatted either as email and name, e.g. "Support <support@opendoor.com>",
   * or just the email address, e.g. support@opendoor.com
   */
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<OdProtosCommunicationData_SendEmailOptionsInput>;
  /**
   * optional - if not provided, this will be inferred from the request context and then the from_address
   * if not inferrable, this will default to communication service token
   */
  senderId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  toBccAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  toCcAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** `OdProtosCommunicationServices_SendEmailRequest_AdditionalHeadersEntryInput` represents the `additional_headers` map in `od_protos.communication.services.SendEmailRequest`. */
export type OdProtosCommunicationServices_SendEmailRequest_AdditionalHeadersEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosCommunicationServices_SendEmailRequest_AttachmentAliasesEntryInput` represents the `attachment_aliases` map in `od_protos.communication.services.SendEmailRequest`. */
export type OdProtosCommunicationServices_SendEmailRequest_AttachmentAliasesEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_SendPushNotificationRequestInput = {
  campaignId?: InputMaybe<Scalars['Float']['input']>;
  dataFields?: InputMaybe<Array<OdProtosCommunicationServices_SendPushNotificationRequest_DataFieldsEntryInput>>;
  userEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** `OdProtosCommunicationServices_SendPushNotificationRequest_DataFieldsEntryInput` represents the `data_fields` map in `od_protos.communication.services.SendPushNotificationRequest`. */
export type OdProtosCommunicationServices_SendPushNotificationRequest_DataFieldsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** To */
export type OdProtosCommunicationServices_SendSmsRequestInput = {
  /** Sms attachments */
  assets?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  communicationContext?: InputMaybe<OdProtosCommunicationData_CommunicationContextInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  /**
   * If the from_phone_number or phone specification is not provided the service will throw an error
   * Optional: to_phone_number will be used if provided
   */
  fromPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED: message service SID to use (pool of messaging numbers) */
  messagingServiceSid?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<OdProtosCommunicationData_SendSmsOptionsInput>;
  /** Optional: the type of phone number to use (category and optionally market) */
  phoneNumberSpecification?: InputMaybe<OdProtosCommunicationData_PhoneNumberSpecificationInput>;
  /** human token of the sender, if not specified the user in the request context will be used if available */
  senderId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: if to_phone_number is not provided, phone numbers from the customer will be tried
   * if to_phone_number is provided but fails, phone numbers from the customer will be tried
   */
  toCustomerId?: InputMaybe<Scalars['String']['input']>;
  /**
   * At least one of to_phone_number or to_customer_id must be provided
   * Optional: to_phone_number will be used if provided
   */
  toPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_TrackIterableEventRequestInput = {
  communicationContext?: InputMaybe<OdProtosCommunicationData_CommunicationContextInput>;
  dataFields?: InputMaybe<GoogleProtobuf_StructInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_TrackPushOpenRequestInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  /** For iterable campaigns we dont have a backend record so we need to identify message_id + campaign_id */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /** For backend driven notifications we use push_notification_id */
  pushNotificationId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_UnblockIncomingPhoneNumberRequestInput = {
  incomingPhoneNumber?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
};

export type OdProtosCommunicationServices_UnregisterDeviceRequestInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCommunicationServices_UpdateHubSpotEngagementRequestInput = {
  engagementId?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<OdProtosCommunicationServices_HubSpotCallEngagementPropertiesInput>;
};

/**
 * Direction describes whether the communication is initiated by the Contact (OUTBOUND),
 * or initiated by another party to the Contact (INBOUND).
 *
 * Next ID: 3
 */
export enum OdProtosCustardV1Data_ContactEvent_CommunicationEvent_Direction {
  INBOUND = 'INBOUND',
  INVALID = 'INVALID',
  OUTBOUND = 'OUTBOUND'
}

/**
 * Classifications for the type of phone number of the Contact.
 *
 * Next ID: 4
 */
export enum OdProtosCustardV1Data_Phone_PhoneType {
  HOME = 'HOME',
  MOBILE = 'MOBILE',
  OTHER = 'OTHER',
  WORK = 'WORK'
}

/** Don't use this. See below. */
export enum OdProtosCustardV1Data_TrustLevel {
  /** @deprecated No longer supported */
  BLACKLISTED = 'BLACKLISTED',
  /** @deprecated No longer supported */
  GRAYLISTED = 'GRAYLISTED',
  /** @deprecated No longer supported */
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN',
  /** @deprecated No longer supported */
  WHITELISTED = 'WHITELISTED'
}

/**
 * [To Be] DEPRECATED: Use OdProtosCustardV1Services_CustomerRequests_Get
 *
 * Next ID: 2
 */
export type OdProtosCustardV1Services_ContactRequests_GetInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * [To Be] DEPRECATED: Use OdProtosCustardV1Services_CustomerRequests_Update
 * for update agent status. Other roles cannot be set.
 *
 * Next ID: 3
 */
export type OdProtosCustardV1Services_ContactRequests_MarkRoleInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  roleToMark?: InputMaybe<OdProtosCustardV1Services_ContactRequests_Role>;
};

/**
 * The different roles that a Contact can be marked as.
 *
 * Next ID: 3
 */
export enum OdProtosCustardV1Services_ContactRequests_Role {
  AGENT = 'AGENT',
  CUSTOMER = 'CUSTOMER',
  VENDOR = 'VENDOR'
}

/**
 * [To Be] DEPRECATED: Use OdProtosCustardV1Services_CustomerRequests_Update
 * for update agent status. Other roles cannot be set.
 *
 * Next ID: 3
 */
export type OdProtosCustardV1Services_ContactRequests_UnmarkRoleInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  roleToUnmark?: InputMaybe<OdProtosCustardV1Services_ContactRequests_Role>;
};

/** The status of a mortgage lead's pre-qualification or pre-approval */
export enum OdProtosCustomerFinancingServiceData_ApplicationStatus {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  SUBMITTED = 'SUBMITTED',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

/** Employment status for mortgage application */
export enum OdProtosCustomerFinancingServiceData_EmploymentStatus {
  EMPLOYED = 'EMPLOYED',
  OTHER = 'OTHER',
  RETIRED = 'RETIRED',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  UNEMPLOYED = 'UNEMPLOYED',
  UNKNOWN_EMPLOYMENT_STATUS = 'UNKNOWN_EMPLOYMENT_STATUS'
}

/** The type of property for mortgage application */
export enum OdProtosCustomerFinancingServiceData_PropertyType {
  INVESTMENT_PROPERTY = 'INVESTMENT_PROPERTY',
  PRIMARY_RESIDENCE = 'PRIMARY_RESIDENCE',
  SECONDARY_RESIDENCE = 'SECONDARY_RESIDENCE',
  UNKNOWN_PROPERTY_TYPE = 'UNKNOWN_PROPERTY_TYPE'
}

/** Next ID: 6 */
export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateAgentMortgageLeadInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  addressToken?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  leadType?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next ID: 2 */
export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateCustomerMortgageLeadInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 17 */
export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateMortgageLeadInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  currentAddress?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<OdProtosCustomerFinancingServiceData_EmploymentStatus>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  householdIncomeMax?: InputMaybe<Scalars['Float']['input']>;
  householdIncomeMin?: InputMaybe<Scalars['Float']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<OdProtosCustomerFinancingServiceData_PropertyType>;
  targetDownPayment?: InputMaybe<Scalars['Float']['input']>;
  targetLocation?: InputMaybe<Scalars['String']['input']>;
  targetMoveDate?: InputMaybe<Scalars['String']['input']>;
  targetPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_GetCurrentMortgageInterestRatesInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_GetLatestMortgageLeadByCurrentUserInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 2 */
export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_GetLatestMortgageLeadByCustomerIdInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCustomerTosV1Services_Requests_GetTosStatusInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCustomerTosV1Services_Requests_TosAcceptedInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosCustomerV1Data_Actor {
  ACTOR_TYPE_UNSPECIFIED = 'ACTOR_TYPE_UNSPECIFIED',
  AUTOMATED = 'AUTOMATED',
  CUSTOMER = 'CUSTOMER',
  OPERATOR = 'OPERATOR'
}

/**
 * Customer represents a customer's basic information
 *
 *
 * Next ID: 12
 */
export type OdProtosCustomerV1Data_CustomerInput = {
  ccpaSaleOfDataOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAgent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * List of emails that this Customer has.
   * Primary email will not be included in this list.
   */
  otherEmails?: InputMaybe<Array<OdProtosCustomerV1Data_EmailInput>>;
  /**
   * List of phones that this Customer has.
   * Primary phone will not be included in this list.
   */
  otherPhoneNumbers?: InputMaybe<Array<OdProtosCustomerV1Data_PhoneInput>>;
  primaryEmail?: InputMaybe<OdProtosCustomerV1Data_EmailInput>;
  primaryPhoneNumber?: InputMaybe<OdProtosCustomerV1Data_PhoneInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Email represents an email address of a customer and its corresponding
 * metadata with respect to that customer.
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Data_EmailInput = {
  /**
   * The e-mail address of this email object. This is also the primary identifier
   * of the email under the context of a specific customer.
   */
  address?: InputMaybe<OdProtosCommon_EmailAddressInput>;
};

export enum OdProtosCustomerV1Data_FeedType {
  FEED_TYPE_UNSPECIFIED = 'FEED_TYPE_UNSPECIFIED',
  MARKETING = 'MARKETING',
  TRANSACTIONAL = 'TRANSACTIONAL'
}

export enum OdProtosCustomerV1Data_Medium {
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  MEDIUM_UNSPECIFIED = 'MEDIUM_UNSPECIFIED',
  SMS = 'SMS'
}

/**
 * Phone represents a phone number of a customer and its corresponding
 * metadata with respect to that customer.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Data_PhoneInput = {
  /**
   * The phone number of this phone object. This is also the primary identifier
   * of the phone under the context of a specific customer.
   */
  number?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
  /**
   * The type of phone number for the Contact.
   * e.g. home phone, mobile phone...
   */
  type?: InputMaybe<OdProtosCustomerV1Data_Phone_PhoneType>;
};

/**
 * Classifications for the type of phone number of the Contact.
 *
 * Next ID: 4
 */
export enum OdProtosCustomerV1Data_Phone_PhoneType {
  HOME = 'HOME',
  MOBILE = 'MOBILE',
  OTHER = 'OTHER',
  WORK = 'WORK'
}

/**
 * PreferenceSource identifies what triggered a communication preference or subscription change.
 * Used for audit trail and compliance purposes.
 * Note: initial values are SMS-focused; additional sources for email and call
 * can be added as those flows require preference tracking.
 */
export enum OdProtosCustomerV1Data_PreferenceSource {
  /** Change originated from Cake (customer dashboard / account settings) */
  PREFERENCE_SOURCE_CAKE = 'PREFERENCE_SOURCE_CAKE',
  /** Change originated from the Iterable UI (e.g. an operator toggling a subscription directly in Iterable) */
  PREFERENCE_SOURCE_ITERABLE_UI = 'PREFERENCE_SOURCE_ITERABLE_UI',
  /** START keyword received on the marketing SMS phone number */
  PREFERENCE_SOURCE_MARKETING_START_COMMAND = 'PREFERENCE_SOURCE_MARKETING_START_COMMAND',
  /** STOP keyword received on the marketing SMS phone number */
  PREFERENCE_SOURCE_MARKETING_STOP_COMMAND = 'PREFERENCE_SOURCE_MARKETING_STOP_COMMAND',
  /** Change made by an operator via internal tooling (e.g. Tessellation) */
  PREFERENCE_SOURCE_OPERATOR = 'PREFERENCE_SOURCE_OPERATOR',
  /** Change originated from Reception (seller onboarding flow) */
  PREFERENCE_SOURCE_RECEPTION = 'PREFERENCE_SOURCE_RECEPTION',
  /** Change originated from a Salesforce sync */
  PREFERENCE_SOURCE_SALESFORCE = 'PREFERENCE_SOURCE_SALESFORCE',
  /** START keyword received on the transactional SMS phone number */
  PREFERENCE_SOURCE_TRANSACTIONAL_START_COMMAND = 'PREFERENCE_SOURCE_TRANSACTIONAL_START_COMMAND',
  /** STOP keyword received on the transactional SMS phone number */
  PREFERENCE_SOURCE_TRANSACTIONAL_STOP_COMMAND = 'PREFERENCE_SOURCE_TRANSACTIONAL_STOP_COMMAND',
  PREFERENCE_SOURCE_UNSPECIFIED = 'PREFERENCE_SOURCE_UNSPECIFIED'
}

export enum OdProtosCustomerV1Data_SubscriptionStatus {
  /** This is when OD cannot resubscribe the customer (e.g. when the customer sends a STOP message) */
  FORCE_UNSUBSCRIBED = 'FORCE_UNSUBSCRIBED',
  SUBSCRIBED = 'SUBSCRIBED',
  SUBSCRIPTION_STATUS_UNSPECIFIED = 'SUBSCRIPTION_STATUS_UNSPECIFIED',
  UNSUBSCRIBED = 'UNSUBSCRIBED'
}

/**
 * Create a new Customer
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_CreateInput = {
  newCustomer?: InputMaybe<OdProtosCustomerV1Data_CustomerInput>;
};

/** Get current sessions's customer */
export type OdProtosCustomerV1Services_CustomerRequests_GetCurrentCustomerInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Get Customer by a customer UUID
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_GetInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Get the list of Customers by a list of customer UUIDs
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_GetListInput = {
  /** Limiting to a max of 100 customers */
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Merge two existing customers that are duplicates.
 * Merges the info of the customer specified by merging_customer_uuid into the customer specified by keeping_customer_uuid.
 *
 * Next ID: 4
 */
export type OdProtosCustomerV1Services_CustomerRequests_MergeInput = {
  /** When dry_run is set to true, a preview merge result will be returned without actually performing the merge operation */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** uuid specifies the keeping customer */
  keepingCustomerUuid?: InputMaybe<Scalars['String']['input']>;
  /** uuid specifies the merging customer that will be deleted after the merge operation */
  mergingCustomerUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Search for Customer(s) by specified filters
 *
 * When searching by email, and is_primary is not specified, returned customers are sorted in
 * the order of primary email matched, then non-primary email matched.
 * When searching by phone, returned customers are not sorted.
 *
 * Next ID: 6
 */
export type OdProtosCustomerV1Services_CustomerRequests_SearchInput = {
  customerSearchParams?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Search_CustomerSearchParamsOneofInput>;
  /** limit cannot exceed 100. If limit is 0 then it will be set to the default of 100. */
  limit?: InputMaybe<Scalars['Float']['input']>;
  onlyAgents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosCustomerV1Services_CustomerRequests_Search_CustomerSearchParamsOneofInput = {
  emailParams?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Search_EmailSearchParamsInput>;
  multiParams?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Search_MultiSearchParamsInput>;
  phoneParams?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Search_PhoneSearchParamsInput>;
};

/**
 * Email params to search for customers
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Search_EmailSearchParamsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Params to search for a customer using multiple ways.
 * Will return customers in the order of:
 * 1. Primary email
 * 2. Email
 * 3. Phone number
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Search_MultiSearchParamsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Phone params to search for customers
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_Search_PhoneSearchParamsInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Set Customer's primary phone number by either creating a new or updating an existing phone record
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_SetPrimaryPhoneNumberInput = {
  number?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateCurrent will update an authenticated Customer's basic information.
 *
 * This endpoint will allow unauthenticated updating of customer information for "potential customers"
 * See implementation for definition of "potential customer"
 *
 * To use this endpoint without authentication information, provide customer_uuid of the customer to be updated
 * customer_uuid must match the authenticated customer if authentication information is present
 *
 *
 * Next ID: 6
 */
export type OdProtosCustomerV1Services_CustomerRequests_UpdateCurrentInput = {
  /**
   * UUID of the customer to be updated. This parameter MUST match the authenticated customer
   * if authentication information is present
   */
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAgent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<OdProtosCustomerV1Services_CustomerRequests_Update_Params_PhoneInput>>;
};

/**
 * Update will update a Customer's basic information.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_UpdateInput = {
  /** params specifies a customer's parameters to update. */
  params?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput>;
  /** uuid specifies the customer's UUID. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Params specifies different parameters to update a Customer on.
 *
 * At least one parameter must be specified.
 *
 * Next ID: 6
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput = {
  emails?: InputMaybe<Array<OdProtosCustomerV1Services_CustomerRequests_Update_Params_EmailInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAgent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<OdProtosCustomerV1Services_CustomerRequests_Update_Params_PhoneInput>>;
};

/**
 * Email specifies the email to update/delete/create.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_EmailInput = {
  new?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_NewInput>;
  old?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_OldInput>;
};

/**
 * New specifies the new email to update to.
 *
 * If nil is passed in, the customer's old email will be deleted.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_NewInput = {
  /**
   * The e-mail address of this email object. This is also the primary identifier
   * of the email under the context of a specific customer.
   */
  address?: InputMaybe<Scalars['String']['input']>;
  /**
   * make_primary specifies whether or not to set the new email as primary. If a customer has
   * a different email set as primary, it will replace that primary with this new one.
   *
   * Setting make_primary to false will NOT unset an existing primary.
   */
  makePrimary?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Old specifies the old email to update.
 *
 * If nil is passed in for the old email,
 * then a new email will be created based on
 * the new emails parameters.
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_OldInput = {
  /**
   * The e-mail address of this email object. This is also the primary identifier
   * of the email under the context of a specific customer.
   */
  address?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Phone specifies the phone to update/delete/create.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_PhoneInput = {
  new?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_NewInput>;
  old?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_OldInput>;
};

/**
 * New specifies the new phone to update to.
 *
 * If nil is passed in, the customer's old phone will be deleted.
 *
 * Next ID: 4
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_NewInput = {
  /**
   * make_primary specifies whether or not to set the new phone as primary. If a customer has
   * a different phone set as primary, it will replace that primary with this new one.
   *
   * Setting make_primary to false will NOT unset an existing primary.
   */
  makePrimary?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosCustomerV1Data_Phone_PhoneType>;
};

/**
 * Old specifies the old phone to update.
 *
 * The phone number and the phone type must match the customer's old phone
 * record exactly in order to find the right phone to update.
 *
 * If nil is passed in for the old phone,
 * then a new phone number will be created based on
 * the new phone parameters.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_OldInput = {
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosCustomerV1Data_Phone_PhoneType>;
};

export type OdProtosCustomerV1Services_GetCommPreferenceRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCustomerV1Services_GetSubscriptionsForFeedRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  feedName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosCustomerV1Services_SubscribeToFeedRequestInput = {
  /** Consent tracking for audit/compliance */
  consentLanguage?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  feedName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The mediums to subscribe to. This is a repeated field to allow for multiple mediums to be subscribed to at once.
   * If a medium is not available for the feed, the endpoint will error out without subscribing to any mediums.
   * If a medium is already subscribed to, it will be ignored.
   * The list will be deduped.
   */
  mediumsToSubscribe?: InputMaybe<Array<OdProtosCustomerV1Data_Medium>>;
  preferenceSource?: InputMaybe<OdProtosCustomerV1Data_PreferenceSource>;
};

export type OdProtosCustomerV1Services_TriggerBackfillJobRequestInput = {
  jobName?: InputMaybe<OdProtosCustomerV1Services_TriggerBackfillJobRequest_AvailableJobs>;
};

export enum OdProtosCustomerV1Services_TriggerBackfillJobRequest_AvailableJobs {
  BACKFILL_COMM_PREFERENCES = 'BACKFILL_COMM_PREFERENCES',
  BACKFILL_DEFAULT_SUBSCRIPTIONS = 'BACKFILL_DEFAULT_SUBSCRIPTIONS',
  BACKFILL_UNSUBSCRIPTIONS = 'BACKFILL_UNSUBSCRIPTIONS',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type OdProtosCustomerV1Services_UnsubscribeFromFeedRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  feedName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The mediums to unsubscribe from. This is a repeated field to allow for multiple mediums to be unsubscribed from at once.
   * If a medium is not available for the feed, the endpoint will error out without unsubscribing from any mediums.
   * If a medium is not subscribed to, it will be ignored.
   * The list will be deduped.
   */
  mediumsToUnsubscribe?: InputMaybe<Array<OdProtosCustomerV1Data_Medium>>;
  preferenceSource?: InputMaybe<OdProtosCustomerV1Data_PreferenceSource>;
};

export type OdProtosCustomerV1Services_UpsertCommPreferenceRequestInput = {
  /** If call_opt_out is not set, it will not be updated */
  callOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  consentLanguage?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  /** If email_opt_out is not set, it will not be updated */
  emailOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  marketingSmsOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifies what triggered this preference change. */
  preferenceSource?: InputMaybe<OdProtosCustomerV1Data_PreferenceSource>;
  /** If sms_opt_out is not set, it will not be updated */
  smsOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  transactionalSmsOptOut?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosDeadletterData_Status {
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  SKIPPED = 'SKIPPED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosDeadletterServices_AttemptProcessRequestInput = {
  messageId?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosDeadletterServices_AttemptProcessResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosDeadletterServices_ListDeadLettersRequestInput = {
  messageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<OdProtosDeadletterData_Status>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosDeadletterServices_ListDeadLettersResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Parameters for creating an organization
 * Next ID: 8
 */
export type OdProtosDirectoryData_Organization_CreateInput = {
  /** If provided, the organization will be associated with the provided address */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** The primary email for contacting the organization **REQUIRED** */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The fax number, if any */
  fax?: InputMaybe<Scalars['String']['input']>;
  /**
   * The legal name of the organization if different from the name.
   * If not set, the name will be used
   */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** The name of the organization. This must be unique. **REQUIRED** */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If provided, this organization will be made a child organization of the parent */
  parentOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  /** If provided, the corresponding user will be used as the primary organization contact */
  primaryContactToken?: InputMaybe<Scalars['String']['input']>;
  /** The primary phone number for contacting the organization */
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Update parameters for an organization
 * Next ID: 9
 */
export type OdProtosDirectoryData_Organization_UpdateInput = {
  /** Change the address uuid of the organization. i.e. The office moved */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** Change the primary email address associated with the organization */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Change the fax number associated with the organization */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** Change the legal name of the organization. */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Change the primary name of the organization. This must be unique wihtin the system */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Change the primary contact of the org */
  primaryContactToken?: InputMaybe<Scalars['String']['input']>;
  /** Change the primary phone number associated with the organization */
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  /** The uuid of the organization to update */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Parameters to change the password for a user
 * Next ID: 4
 */
export type OdProtosDirectoryData_User_ChangePasswordInput = {
  identifier?: InputMaybe<OdProtosDirectoryData_User_ChangePassword_IdentifierOneofInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  /** indicate if the password was randomly generated */
  randomlyGenerated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosDirectoryData_User_ChangePassword_IdentifierOneofInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Required parameters to create a user
 * Next ID: 8
 */
export type OdProtosDirectoryData_User_CreateInput = {
  /** The current primary email for the user. **REQUIRED** */
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** The password to use for the user. **REQUIRED** */
  password?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  publicEmail?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Available parameters to update a user
 * Next ID: 6
 */
export type OdProtosDirectoryData_User_UpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Parameters to validate a password for a user
 * Next ID: 3
 */
export type OdProtosDirectoryData_User_ValidatePasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDirectoryServices_BasicUuidRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDirectoryServices_GetOrganizationById_RequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Work with member roles.
 * Used to add/delete roles from a member
 * Next ID: 4
 */
export type OdProtosDirectoryServices_MemberRequests_EditMemberRolesInput = {
  organizationUuid?: InputMaybe<Scalars['String']['input']>;
  /** The roles to operate on. */
  roleIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Lists must be filtered by at least one dimension
 * Next ID: 3
 */
export type OdProtosDirectoryServices_MemberRequests_ListInput = {
  /** Specify the type of token to use to filter the list */
  identifierType?: InputMaybe<OdProtosDirectoryServices_MemberRequests_List_TokenType>;
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The type of filtering to use */
export enum OdProtosDirectoryServices_MemberRequests_List_TokenType {
  /** Filter using the tokens as member tokens */
  MEMBER = 'MEMBER',
  /** Filter using the tokens as organization tokens */
  ORGANIZATION = 'ORGANIZATION',
  /** Filter using the tokens as role identifiers */
  ROLE = 'ROLE',
  /** Filter using the tokens as user tokens */
  USER = 'USER'
}

/** Request an index view of organizations */
export type OdProtosDirectoryServices_OrganizationRequests_IndexInput = {
  /** Filter by organization emails */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pagination parameters for the request */
  pagination?: InputMaybe<OdProtosDirectoryServices_PaginationRequestInput>;
  /** A query that will try to match against names and emails of the organization */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization tokens */
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * When requesting results from a paginating endpoint
 * Specify the cursor to start pagination from. Leave this blank if pagination is just starting
 */
export type OdProtosDirectoryServices_PaginationRequestInput = {
  /** Max Count of records to return in the results */
  count?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<OdProtosDirectoryServices_SortDirection>;
  /**
   * The cursor to start the page at.
   * Leave this blank to start at the start of the pagination stream
   */
  startCursor?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosDirectoryServices_SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type OdProtosDirectoryServices_UserRequests_GetInput = {
  identifier?: InputMaybe<OdProtosDirectoryServices_UserRequests_Get_IdentifierOneofInput>;
};

export type OdProtosDirectoryServices_UserRequests_Get_IdentifierOneofInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Request a paginated stream of users */
export type OdProtosDirectoryServices_UserRequests_IndexInput = {
  /** Filter by emails. Applies if set */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specify pagination */
  pagination?: InputMaybe<OdProtosDirectoryServices_PaginationRequestInput>;
  /** Search for users that match the query in name, email or primary phone number */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by tokens. Applies if set */
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosDiscloseData_DataEntryFieldInput = {
  dataSourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldType?: InputMaybe<OdProtosDiscloseData_DataEntryFieldType>;
  groundingType?: InputMaybe<OdProtosDiscloseData_GroundingType>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeInDynamicForm?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  llmInstructions?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  responseOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  validations?: InputMaybe<Array<OdProtosDiscloseData_DataEntryValidationInput>>;
};

export type OdProtosDiscloseData_DataEntryFieldSuggestionReviewInput = {
  decision?: InputMaybe<OdProtosDiscloseData_DataEntrySuggestionDecision>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosDiscloseData_DataEntryFieldType {
  DATA_ENTRY_FIELD_TYPE_DROPDOWN = 'DATA_ENTRY_FIELD_TYPE_DROPDOWN',
  DATA_ENTRY_FIELD_TYPE_MULTI_LINE_TEXT = 'DATA_ENTRY_FIELD_TYPE_MULTI_LINE_TEXT',
  DATA_ENTRY_FIELD_TYPE_MULTI_SELECT = 'DATA_ENTRY_FIELD_TYPE_MULTI_SELECT',
  DATA_ENTRY_FIELD_TYPE_RADIO_GROUP = 'DATA_ENTRY_FIELD_TYPE_RADIO_GROUP',
  DATA_ENTRY_FIELD_TYPE_SINGLE_LINE_TEXT = 'DATA_ENTRY_FIELD_TYPE_SINGLE_LINE_TEXT',
  DATA_ENTRY_FIELD_TYPE_UNSPECIFIED = 'DATA_ENTRY_FIELD_TYPE_UNSPECIFIED'
}

export type OdProtosDiscloseData_DataEntryFieldValueInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseData_DataEntrySchemaInput = {
  sections?: InputMaybe<Array<OdProtosDiscloseData_DataEntrySectionInput>>;
};

export type OdProtosDiscloseData_DataEntrySectionInput = {
  fields?: InputMaybe<Array<OdProtosDiscloseData_DataEntryFieldInput>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  llmInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosDiscloseData_DataEntrySuggestionDecision {
  DATA_ENTRY_SUGGESTION_DECISION_ACCEPTED = 'DATA_ENTRY_SUGGESTION_DECISION_ACCEPTED',
  DATA_ENTRY_SUGGESTION_DECISION_REJECTED = 'DATA_ENTRY_SUGGESTION_DECISION_REJECTED'
}

export type OdProtosDiscloseData_DataEntryValidationInput = {
  rule?: InputMaybe<OdProtosDiscloseData_DataEntryValidation_RuleOneofInput>;
};

export type OdProtosDiscloseData_DataEntryValidation_RuleOneofInput = {
  doesNotContainSubstringRule?: InputMaybe<Scalars['String']['input']>;
  maxNumericalValueRule?: InputMaybe<Scalars['Float']['input']>;
  maxStringLengthRule?: InputMaybe<Scalars['Float']['input']>;
  minNumericalValueRule?: InputMaybe<Scalars['Float']['input']>;
  minStringLengthRule?: InputMaybe<Scalars['Float']['input']>;
  validFloatRule?: InputMaybe<Scalars['Float']['input']>;
  validIntegerRule?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosDiscloseData_GroundingType {
  GROUNDING_TYPE_GOOGLE_MAPS = 'GROUNDING_TYPE_GOOGLE_MAPS',
  GROUNDING_TYPE_GOOGLE_SEARCH = 'GROUNDING_TYPE_GOOGLE_SEARCH',
  GROUNDING_TYPE_NONE = 'GROUNDING_TYPE_NONE'
}

/**
 * InaccuracyCategory is an enum for the different types of inaccuracy categories
 * Ids are used
 */
export enum OdProtosDiscloseData_InaccuracyCategory {
  INACCURACY_CATEGORY_IRRELEVANTDATA = 'INACCURACY_CATEGORY_IRRELEVANTDATA',
  INACCURACY_CATEGORY_UNKNOWN = 'INACCURACY_CATEGORY_UNKNOWN',
  INACCURACY_CATEGORY_WRONGDATA = 'INACCURACY_CATEGORY_WRONGDATA'
}

/** Source is an enum for the different types of sources to aggregate disclosure data */
export enum OdProtosDiscloseData_Source {
  SOURCE_ADMIN = 'SOURCE_ADMIN',
  SOURCE_ADMIN_ACTIVITY_TAB = 'SOURCE_ADMIN_ACTIVITY_TAB',
  SOURCE_ADMIN_CLOSING_TAB = 'SOURCE_ADMIN_CLOSING_TAB',
  SOURCE_ADMIN_INVENTORY_TAB = 'SOURCE_ADMIN_INVENTORY_TAB',
  SOURCE_ADMIN_LISTING_TAB = 'SOURCE_ADMIN_LISTING_TAB',
  SOURCE_ADMIN_RBR_TAB = 'SOURCE_ADMIN_RBR_TAB',
  SOURCE_ADMIN_RENOVATION_TAB = 'SOURCE_ADMIN_RENOVATION_TAB',
  SOURCE_D1W = 'SOURCE_D1W',
  SOURCE_EXTERIOR_ASSESSMENT = 'SOURCE_EXTERIOR_ASSESSMENT',
  SOURCE_FEMA_WEBSITE = 'SOURCE_FEMA_WEBSITE',
  SOURCE_GOOGLE_MAPS = 'SOURCE_GOOGLE_MAPS',
  SOURCE_NOTES = 'SOURCE_NOTES',
  SOURCE_QC_VISIT = 'SOURCE_QC_VISIT',
  SOURCE_SELLER_INPUTS = 'SOURCE_SELLER_INPUTS',
  SOURCE_SEPTIC_SOT_IN_DISCO = 'SOURCE_SEPTIC_SOT_IN_DISCO',
  SOURCE_UNKNOWN = 'SOURCE_UNKNOWN',
  SOURCE_VIRTUAL_ASSESSMENT = 'SOURCE_VIRTUAL_ASSESSMENT',
  SOURCE_WORK_ORDERS = 'SOURCE_WORK_ORDERS'
}

export type OdProtosDiscloseData_TemplateAnnotationInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** X coordinate on page (in PDF units) */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Y coordinate on page (in PDF units) */
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseData_TemplateDefaultsInput = {
  checkboxFontSize?: InputMaybe<Scalars['Float']['input']>;
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  minFontSize?: InputMaybe<Scalars['Float']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  verticalTextAlignment?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseData_TemplateFieldInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  enumValues?: InputMaybe<Array<Scalars['String']['input']>>;
  expression?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<OdProtosDiscloseData_TemplateField_ReferenceOneofInput>;
  requiresReview?: InputMaybe<Scalars['Boolean']['input']>;
  skipReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosDiscloseData_TemplateField_CheckBoxInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosDiscloseData_TemplateField_FieldGroupReferenceInput = {
  fields?: InputMaybe<Array<OdProtosDiscloseData_TemplateField_FieldGroupReference_FieldGroupReferenceFieldInput>>;
};

export type OdProtosDiscloseData_TemplateField_FieldGroupReference_FieldGroupReferenceFieldInput = {
  reference?: InputMaybe<OdProtosDiscloseData_TemplateField_FieldReferenceInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseData_TemplateField_FieldReferenceInput = {
  fieldType?: InputMaybe<OdProtosDiscloseData_TemplateField_FieldReference_FieldTypeOneofInput>;
  height?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseData_TemplateField_FieldReference_FieldTypeOneofInput = {
  checkBox?: InputMaybe<OdProtosDiscloseData_TemplateField_CheckBoxInput>;
  image?: InputMaybe<OdProtosDiscloseData_TemplateField_ImageInput>;
  textField?: InputMaybe<OdProtosDiscloseData_TemplateField_TextFieldInput>;
};

export type OdProtosDiscloseData_TemplateField_ImageInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseData_TemplateField_ReferenceOneofInput = {
  fieldGroupReference?: InputMaybe<OdProtosDiscloseData_TemplateField_FieldGroupReferenceInput>;
  fieldReference?: InputMaybe<OdProtosDiscloseData_TemplateField_FieldReferenceInput>;
};

export type OdProtosDiscloseData_TemplateField_TextFieldInput = {
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  minFontSize?: InputMaybe<Scalars['Float']['input']>;
  multiline?: InputMaybe<Scalars['Boolean']['input']>;
  multilineLines?: InputMaybe<Scalars['Float']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  verticalTextAlignment?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseData_TemplateSchemaInput = {
  annotations?: InputMaybe<Array<OdProtosDiscloseData_TemplateAnnotationInput>>;
  defaults?: InputMaybe<OdProtosDiscloseData_TemplateDefaultsInput>;
  fields?: InputMaybe<Array<OdProtosDiscloseData_TemplateFieldInput>>;
};

export type OdProtosDiscloseData_UpdateReportRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  rubric?: InputMaybe<OdProtosRubricV2Data_RubricInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_AnalyzeListingPhotosRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_AnalyzeWorkOrdersRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_CancelSuggestionWorkflowRequestInput = {
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_CreateDataEntryTemplateRequestInput = {
  market?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_CreateDisclosureRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** the disclosure_uuid get's generated in disclose and then request is made to rubric */
  disclosureUuid?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/** Seller Disclosure Feedback */
export type OdProtosDiscloseServices_CreateSellerDisclosureFeedbackRequestInput = {
  accurateSourceIds?: InputMaybe<Array<OdProtosDiscloseData_Source>>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  inaccuracyCategoryId?: InputMaybe<OdProtosDiscloseData_InaccuracyCategory>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  /** Source that is being marked as inaccurate */
  sourceId?: InputMaybe<OdProtosDiscloseData_Source>;
};

export type OdProtosDiscloseServices_CreateTemplateRequestInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  marketIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_DeleteSellerDisclosureFeedbackRequestInput = {
  deleteReason?: InputMaybe<Scalars['String']['input']>;
  feedbackId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseServices_DisclosureFormFieldInput = {
  fieldId?: InputMaybe<Scalars['String']['input']>;
  overrideComment?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<OdProtosDiscloseServices_EvaluationSource>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_EvaluateDisclosureFormRequestInput = {
  fieldIds?: InputMaybe<Array<Scalars['String']['input']>>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  testing?: InputMaybe<OdProtosDiscloseData_TemplateFieldInput>;
};

export enum OdProtosDiscloseServices_EvaluationSource {
  EVALUATION_SOURCE_DEFAULT = 'EVALUATION_SOURCE_DEFAULT',
  EVALUATION_SOURCE_EXPRESSION = 'EVALUATION_SOURCE_EXPRESSION',
  EVALUATION_SOURCE_LLM = 'EVALUATION_SOURCE_LLM',
  EVALUATION_SOURCE_LLM_AUTO_APPROVE = 'EVALUATION_SOURCE_LLM_AUTO_APPROVE',
  EVALUATION_SOURCE_UNSPECIFIED = 'EVALUATION_SOURCE_UNSPECIFIED'
}

export type OdProtosDiscloseServices_GenerateDataEntrySuggestionsRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GenerateDisclosurePrefillRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  forceRefresh?: InputMaybe<OdProtosDiscloseServices_GenerateDisclosurePrefillRequest_ForceRefreshInput>;
  retry?: InputMaybe<Scalars['Boolean']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GenerateDisclosurePrefillRequest_ForceRefreshInput = {
  photoAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  prefill?: InputMaybe<Scalars['Boolean']['input']>;
  workOrderAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosDiscloseServices_GenerateDisclosurePrefillResponse_Status {
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export type OdProtosDiscloseServices_GenerateListingDescriptionRequestInput = {
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  addressLine?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  includePhotoAnalysisFeatures?: InputMaybe<Scalars['Boolean']['input']>;
  listingDescriptionAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosDiscloseServices_GetAirtableTemplatesByMarketRequestInput = {
  marketName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetDataEntrySuggestionsRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  forceRefresh?: InputMaybe<OdProtosDiscloseServices_GetDataEntrySuggestionsRequest_ForceRefreshInput>;
  retry?: InputMaybe<Scalars['Boolean']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetDataEntrySuggestionsRequest_ForceRefreshInput = {
  photoAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  suggestions?: InputMaybe<Scalars['Boolean']['input']>;
  workOrderAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosDiscloseServices_GetDataEntrySuggestionsResponse_Status {
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export type OdProtosDiscloseServices_GetDataEntryTemplateByMarketRequestInput = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetDataEntryTemplateRequestInput = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetDisclosureRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetDisclosureSubmissionRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetFieldFeedbackDetailsRequestInput = {
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OdProtosDiscloseServices_StatsFilterInput>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseServices_GetLatestVersionSubmissionSummariesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosDiscloseServices_GetPhotoAnalysisResultRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetQuestionsSchemaRequestInput = {
  market?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Note: Not implementing pagintation for now
 * We don't expect to have a lot of feedbacks(max few hundreds) and size of feedbacks is small
 */
export type OdProtosDiscloseServices_GetSellerDisclosureFeedbacksRequestInput = {
  feedbackIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetSellerDisclosureTaskRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosDiscloseServices_GetSignedUrlRequestInput = {
  keyForS3?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetSuggestionStatusRequestInput = {
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetTemplateFieldStatsRequestInput = {
  filter?: InputMaybe<OdProtosDiscloseServices_StatsFilterInput>;
};

export type OdProtosDiscloseServices_GetTemplateRequestInput = {
  /** If true, returns the latest draft version; if false, returns the published version */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetVersionSubmissionStatsRequestInput = {
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_GetWorkOrderAnalysisResultRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_IdentifierInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_ListDisclosureSubmissionsRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_ListTemplateVersionsRequestInput = {
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** PDF Template Management */
export type OdProtosDiscloseServices_ListTemplatesRequestInput = {
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_PreviewDisclosureFormDocumentInput = {
  fields?: InputMaybe<Array<OdProtosDiscloseServices_DisclosureFormFieldInput>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_PreviewDisclosureFormRequestInput = {
  appendedAssetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  documents?: InputMaybe<Array<OdProtosDiscloseServices_PreviewDisclosureFormDocumentInput>>;
  fields?: InputMaybe<Array<OdProtosDiscloseServices_DisclosureFormFieldInput>>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_PublishDataEntryTemplateVersionRequestInput = {
  templateId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseServices_PublishTemplateVersionRequestInput = {
  templateId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseServices_StatsFilterInput = {
  flipTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  timeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  timeTo?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
  versionMode?: InputMaybe<OdProtosDiscloseServices_VersionMode>;
};

export type OdProtosDiscloseServices_SubmitDataEntryRequestInput = {
  fields?: InputMaybe<Array<OdProtosDiscloseData_DataEntryFieldValueInput>>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  suggestionReviews?: InputMaybe<Array<OdProtosDiscloseData_DataEntryFieldSuggestionReviewInput>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseServices_SubmitDisclosureFormDocumentInput = {
  disclosurePrefillId?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<OdProtosDiscloseServices_DisclosureFormFieldInput>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseServices_SubmitDisclosureFormRequestInput = {
  appendedAssetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  disclosurePrefillId?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<OdProtosDiscloseServices_SubmitDisclosureFormDocumentInput>>;
  fields?: InputMaybe<Array<OdProtosDiscloseServices_DisclosureFormFieldInput>>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  templateVersion?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDiscloseServices_SuggestFieldImprovementRequestInput = {
  fieldId?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_UpdateDataEntryTemplateSchemaRequestInput = {
  schema?: InputMaybe<OdProtosDiscloseData_DataEntrySchemaInput>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_UpdateSellerDisclosureFeedbackRequestInput = {
  accurateSourceIds?: InputMaybe<Array<OdProtosDiscloseData_Source>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  feedbackId?: InputMaybe<Scalars['Float']['input']>;
  inaccuracyCategoryId?: InputMaybe<OdProtosDiscloseData_InaccuracyCategory>;
};

export type OdProtosDiscloseServices_UpdateTemplateRequestInput = {
  filenamePattern?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  marketIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<OdProtosDiscloseData_TemplateSchemaInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDiscloseServices_UploadDisclosuresFormRequestInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  pdfFile?: InputMaybe<Scalars['String']['input']>;
};

/** Template Field Stats — Refine Mode */
export enum OdProtosDiscloseServices_VersionMode {
  VERSION_MODE_CUMULATIVE = 'VERSION_MODE_CUMULATIVE',
  VERSION_MODE_EXACT = 'VERSION_MODE_EXACT'
}

export enum OdProtosDistilleryData_JobResult_ValidationStatus {
  /**
   * Results for availability of a mandatory field with non-empty value.
   * 0 and 1 are mutually exclusive.
   *
   * for label "Available"
   */
  AVAILABLE = 'AVAILABLE',
  /**
   * No validations configured for the field.
   *
   * for label "Captured"
   */
  DEFAULT = 'DEFAULT',
  /**
   * Confidence level of the field extraction is low.
   *
   * to grey out the labels
   */
  LOW_CONFIDENCE = 'LOW_CONFIDENCE',
  /** for label "Missing" */
  MISSING = 'MISSING',
  /**
   * Field is not expected in this document.
   *
   * for label "Unexpected"
   */
  UNEXPECTED_FIELD = 'UNEXPECTED_FIELD',
  /**
   * Validation process encountered problems. Value is not verified.
   *
   * provide a label for this?
   */
  UNKNOWN = 'UNKNOWN',
  /** for label "Mismatch" */
  VALUE_MISMATCH = 'VALUE_MISMATCH',
  /**
   * Result for the correctness of the value of a field.
   * 3 and 4 are mutually exclusive.
   *
   * for label "Verified"
   */
  VALUE_VERIFIED = 'VALUE_VERIFIED',
  /**
   * Result for the correctness of the data type of a field.
   * If this is not available, the field either has correct data type or
   * data type validation is not configured for the field
   *
   * for label "Not <data type label>"
   */
  WRONG_DATA_TYPE = 'WRONG_DATA_TYPE'
}

export enum OdProtosDistilleryData_RunFeedback_Type {
  INCORRECT_VALUE = 'INCORRECT_VALUE',
  MISSING_VALUE = 'MISSING_VALUE',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosDistilleryData_WorkflowJob_Status {
  ENQUEUED = 'ENQUEUED',
  SUBMITTED = 'SUBMITTED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosDistilleryData_WorkflowRun_Status {
  ENQUEUED = 'ENQUEUED',
  EXTRACTED = 'EXTRACTED',
  FAILED = 'FAILED',
  TRANSFORMED = 'TRANSFORMED',
  UNKNOWN = 'UNKNOWN',
  VALIDATED = 'VALIDATED'
}

export enum OdProtosDistilleryData_Workflow_DocumentSource {
  DMS = 'DMS',
  FINPLAT = 'FINPLAT',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosDistilleryData_Workflow_Vendor {
  EXTENDAPP = 'EXTENDAPP',
  UNKNOWN_VENDOR = 'UNKNOWN_VENDOR'
}

export type OdProtosDistilleryServices_DistilleryRequests_CreateWorkflowInput = {
  documentSource?: InputMaybe<OdProtosDistilleryData_Workflow_DocumentSource>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  documentableType?: InputMaybe<OdProtosDocumentManagementData_Documentable_Type>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  sourceChannel?: InputMaybe<OdProtosDocumentManagementData_Document_SourceChannel>;
  state?: InputMaybe<OdProtosCommonState_State>;
  vendor?: InputMaybe<OdProtosDistilleryData_Workflow_Vendor>;
  vendorWorkflowId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_FeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  expectedValue?: InputMaybe<Scalars['String']['input']>;
  extractedValue?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosDistilleryData_RunFeedback_Type>;
};

export type OdProtosDistilleryServices_DistilleryRequests_GetResultsInput = {
  by?: InputMaybe<OdProtosDistilleryServices_DistilleryRequests_GetResults_ByOneofInput>;
};

export type OdProtosDistilleryServices_DistilleryRequests_GetResults_ByOneofInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_GetRunFeedbacksInput = {
  workflowRunId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_PauseWorkflowInput = {
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_ResumeWorkflowInput = {
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitJobInput = {
  params?: InputMaybe<OdProtosDistilleryServices_DistilleryRequests_SubmitJob_ParamsOneofInput>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitJob_DmsInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitJob_DocumentUrlInput = {
  documentName?: InputMaybe<Scalars['String']['input']>;
  documentSource?: InputMaybe<OdProtosDistilleryData_Workflow_DocumentSource>;
  /** URL of the document with public access for at least 15 minutes */
  url?: InputMaybe<Scalars['String']['input']>;
  workflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitJob_ParamsOneofInput = {
  dms?: InputMaybe<OdProtosDistilleryServices_DistilleryRequests_SubmitJob_DmsInput>;
  documentUrl?: InputMaybe<OdProtosDistilleryServices_DistilleryRequests_SubmitJob_DocumentUrlInput>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitRunFeedbacksInput = {
  feedbacks?: InputMaybe<Array<OdProtosDistilleryServices_DistilleryRequests_FeedbackInput>>;
  workflowRunId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDistilleryServices_Transformation_RequestInput = {
  workflowRunId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDistilleryServices_Validation_RequestInput = {
  workflowRunId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosDocumentManagementData_DocumentSource_Type {
  CUSTARD_CUSTOMER = 'CUSTARD_CUSTOMER',
  HUMAN = 'HUMAN',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  MESSAGE_THREAD = 'MESSAGE_THREAD',
  ORGANIZATION = 'ORGANIZATION',
  TASKS_HELLO_SIGN_TASK = 'TASKS_HELLO_SIGN_TASK',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosDocumentManagementData_DocumentStorageInput = {
  /**
   * Document storage ID. It could be a document s3 key in the case of web, or a
   * cabinet uuid.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Where the document file is stored. */
  type?: InputMaybe<OdProtosDocumentManagementData_DocumentStorage_Type>;
};

export enum OdProtosDocumentManagementData_DocumentStorage_Type {
  CABINET = 'CABINET',
  UNKNOWN = 'UNKNOWN',
  WEB = 'WEB'
}

export enum OdProtosDocumentManagementData_DocumentTemplate_TransactionType {
  ACQUISITION = 'ACQUISITION',
  RESALE = 'RESALE',
  UNKNOWN_TRANSACTION = 'UNKNOWN_TRANSACTION'
}

export enum OdProtosDocumentManagementData_DocumentTypeConfig_TransactionType {
  ACQUISITION = 'ACQUISITION',
  RESALE = 'RESALE',
  UNKNOWN_TRANSACTION = 'UNKNOWN_TRANSACTION'
}

export enum OdProtosDocumentManagementData_DocumentTypeNote_TransactionType {
  ACQUISITION = 'ACQUISITION',
  RESALE = 'RESALE',
  UNKNOWN_TRANSACTION = 'UNKNOWN_TRANSACTION'
}

export enum OdProtosDocumentManagementData_Document_SourceChannel {
  /** @deprecated No longer supported */
  BWOD_CHANNEL = 'BWOD_CHANNEL',
  CLOSING_DASHBOARD_CHANNEL = 'CLOSING_DASHBOARD_CHANNEL',
  HELLO_SIGN_TASK_CHANNEL = 'HELLO_SIGN_TASK_CHANNEL',
  NOMAD_CHANNEL = 'NOMAD_CHANNEL',
  OFFER_PORTAL_CHANNEL = 'OFFER_PORTAL_CHANNEL',
  RESALE_CLOSING_DASHBOARD_CHANNEL = 'RESALE_CLOSING_DASHBOARD_CHANNEL',
  SETTLER_CHANNEL = 'SETTLER_CHANNEL',
  TOOLING_HUB_CHANNEL = 'TOOLING_HUB_CHANNEL',
  UNKNOWN_CHANNEL = 'UNKNOWN_CHANNEL'
}

/** Next ID: 184 */
export enum OdProtosDocumentManagementData_Document_Type {
  ABAD = 'ABAD',
  ACQ_AGENT_REFERRAL_FORM = 'ACQ_AGENT_REFERRAL_FORM',
  ACQ_DEED = 'ACQ_DEED',
  ACQ_EMR = 'ACQ_EMR',
  ACQ_FINAL_SETTLEMENT_STATEMENT = 'ACQ_FINAL_SETTLEMENT_STATEMENT',
  ACQ_HOA_DEMAND = 'ACQ_HOA_DEMAND',
  ACQ_HOA_GOVERNING_DOCS = 'ACQ_HOA_GOVERNING_DOCS',
  ACQ_HOA_RECEIPT = 'ACQ_HOA_RECEIPT',
  ACQ_LAND_SURVEY = 'ACQ_LAND_SURVEY',
  ACQ_NATURAL_HAZARD_DISCLOSURE = 'ACQ_NATURAL_HAZARD_DISCLOSURE',
  ACQ_OUTBOUND_ADDENDUM = 'ACQ_OUTBOUND_ADDENDUM',
  ACQ_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT = 'ACQ_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT',
  ACQ_TAX_CERTIFICATE = 'ACQ_TAX_CERTIFICATE',
  ACQ_TITLE_COMMITMENT = 'ACQ_TITLE_COMMITMENT',
  ACQ_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT = 'ACQ_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT',
  ADDENDUM = 'ADDENDUM',
  AGENT_REFERRAL_W9 = 'AGENT_REFERRAL_W9',
  AMENDMENT = 'AMENDMENT',
  APPRAISAL_REPORT = 'APPRAISAL_REPORT',
  ASSESSMENT_REPORT = 'ASSESSMENT_REPORT',
  AVID_BUYER = 'AVID_BUYER',
  AVID_SELLER = 'AVID_SELLER',
  BINDING_COUNTER_OFFER = 'BINDING_COUNTER_OFFER',
  BINSR = 'BINSR',
  BRN_CREDIT_ADDENDUM = 'BRN_CREDIT_ADDENDUM',
  BRN_RESPONSE = 'BRN_RESPONSE',
  BROKER_PRICE_OPINION = 'BROKER_PRICE_OPINION',
  BUYER_CLOSING_DOCS = 'BUYER_CLOSING_DOCS',
  CANCEL_BINSR = 'CANCEL_BINSR',
  CASH_AGREEMENT = 'CASH_AGREEMENT',
  CASH_PLUS_AGREEMENT = 'CASH_PLUS_AGREEMENT',
  CCR = 'CCR',
  CHANGE_CLOSE_OF_ESCROW_ADDENDUM = 'CHANGE_CLOSE_OF_ESCROW_ADDENDUM',
  CHECKLIST_HOA_SOU = 'CHECKLIST_HOA_SOU',
  CIC_RECEIPT = 'CIC_RECEIPT',
  CLOSING_STATEMENT_FOR_APPROVAL = 'CLOSING_STATEMENT_FOR_APPROVAL',
  CLUE = 'CLUE',
  COMBINED = 'COMBINED',
  COMBINED_FILE = 'COMBINED_FILE',
  COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM = 'COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM',
  COMMISSION_INSTRUCTIONS = 'COMMISSION_INSTRUCTIONS',
  CONFIRMATION_OF_NO_HOA = 'CONFIRMATION_OF_NO_HOA',
  CONTINGENCY = 'CONTINGENCY',
  CONTINGENCY_REMOVAL = 'CONTINGENCY_REMOVAL',
  COUNTER = 'COUNTER',
  DEED = 'DEED',
  EOI = 'EOI',
  FINALIZE_BINSR = 'FINALIZE_BINSR',
  FINAL_OFFER_PDF = 'FINAL_OFFER_PDF',
  FINAL_REPAIR_ASK = 'FINAL_REPAIR_ASK',
  FINAL_SETTLEMENT_STATEMENT = 'FINAL_SETTLEMENT_STATEMENT',
  FIRPTA = 'FIRPTA',
  HOA = 'HOA',
  HOA_ADDENDUM = 'HOA_ADDENDUM',
  HOA_BUYER_APPROVAL = 'HOA_BUYER_APPROVAL',
  HOA_CCRS = 'HOA_CCRS',
  HOA_CCR_AMENDMENT = 'HOA_CCR_AMENDMENT',
  HOA_DEMAND = 'HOA_DEMAND',
  HOA_DEMAND_SUB = 'HOA_DEMAND_SUB',
  HOA_ESTOPPEL_LETTER_UPDATED = 'HOA_ESTOPPEL_LETTER_UPDATED',
  HOA_PACKAGE = 'HOA_PACKAGE',
  HOA_STATUS_LETTER = 'HOA_STATUS_LETTER',
  HOA_VIOLATION_RESOLUTION = 'HOA_VIOLATION_RESOLUTION',
  HOME_CONDITION_BRANDED = 'HOME_CONDITION_BRANDED',
  HOME_CONDITION_UNBRANDED = 'HOME_CONDITION_UNBRANDED',
  HOME_WARRANTY_INVOICE = 'HOME_WARRANTY_INVOICE',
  INITIAL_BINSR_REQUEST = 'INITIAL_BINSR_REQUEST',
  INITIAL_REPAIR_ASK = 'INITIAL_REPAIR_ASK',
  INSPECTION_REPORT_ELECTRICAL = 'INSPECTION_REPORT_ELECTRICAL',
  INSPECTION_REPORT_FOUNDATION = 'INSPECTION_REPORT_FOUNDATION',
  INSPECTION_REPORT_GENERAL = 'INSPECTION_REPORT_GENERAL',
  INSPECTION_REPORT_HVAC = 'INSPECTION_REPORT_HVAC',
  INSPECTION_REPORT_OTHER = 'INSPECTION_REPORT_OTHER',
  INSPECTION_REPORT_PLUMBING = 'INSPECTION_REPORT_PLUMBING',
  INSPECTION_REPORT_POOL = 'INSPECTION_REPORT_POOL',
  INSPECTION_REPORT_ROOF = 'INSPECTION_REPORT_ROOF',
  INSPECTION_REPORT_SHERLOCK = 'INSPECTION_REPORT_SHERLOCK',
  INSPECTION_REPORT_TERMITE = 'INSPECTION_REPORT_TERMITE',
  INSURANCE_CLAIM = 'INSURANCE_CLAIM',
  INVOICE = 'INVOICE',
  LAND_SURVEY = 'LAND_SURVEY',
  LATE_CHECKOUT_ADDENDUM = 'LATE_CHECKOUT_ADDENDUM',
  LBP_ADDENDUM = 'LBP_ADDENDUM',
  LEASED_FIXTURES = 'LEASED_FIXTURES',
  LIEN_SEARCH = 'LIEN_SEARCH',
  LIGHTWEIGHT_PURCHASE_AGREEMENT = 'LIGHTWEIGHT_PURCHASE_AGREEMENT',
  LISTING_DISCLOSURE = 'LISTING_DISCLOSURE',
  LISTING_PACKET = 'LISTING_PACKET',
  LOSS_HISTORY_REPORT = 'LOSS_HISTORY_REPORT',
  /** @deprecated No longer supported */
  LWOD_OFFER_REVIEW = 'LWOD_OFFER_REVIEW',
  MARKET_CONDITIONS_ADVISORY = 'MARKET_CONDITIONS_ADVISORY',
  MEASUREMENT_REPORT = 'MEASUREMENT_REPORT',
  MINERAL_OIL_GAS = 'MINERAL_OIL_GAS',
  MISC = 'MISC',
  NAME_CHANGE = 'NAME_CHANGE',
  NON_BINDING_COUNTER_OFFER = 'NON_BINDING_COUNTER_OFFER',
  NON_REQUIRED_DOCS = 'NON_REQUIRED_DOCS',
  OD_ADDENDUM = 'OD_ADDENDUM',
  OD_GUARANTEE = 'OD_GUARANTEE',
  OD_SERVICES_ADDENDUM = 'OD_SERVICES_ADDENDUM',
  OUTBOUND_PURCHASE_AGREEMENT = 'OUTBOUND_PURCHASE_AGREEMENT',
  OWNERS_POLICY = 'OWNERS_POLICY',
  O_AND_E_RECEIPT = 'O_AND_E_RECEIPT',
  PREPARED_DEED = 'PREPARED_DEED',
  PREQUAL = 'PREQUAL',
  PROOF_OF_FUNDS = 'PROOF_OF_FUNDS',
  PROPERTY_DISCLOSURE = 'PROPERTY_DISCLOSURE',
  PROPOSED_AMENDMENT = 'PROPOSED_AMENDMENT',
  PTL = 'PTL',
  PURCHASE_AGREEMENT = 'PURCHASE_AGREEMENT',
  PURCHASE_AGREEMENT_TERMINATION = 'PURCHASE_AGREEMENT_TERMINATION',
  REALTOR_DISCLOSURE = 'REALTOR_DISCLOSURE',
  REIT_RESALE_PURCHASE_CONTRACT = 'REIT_RESALE_PURCHASE_CONTRACT',
  REJECTED_SETTLEMENT_STATEMENT = 'REJECTED_SETTLEMENT_STATEMENT',
  RENOVATION_PROPOSAL = 'RENOVATION_PROPOSAL',
  REPAIR_ADDENDUM = 'REPAIR_ADDENDUM',
  RESALE_ADDENDUM = 'RESALE_ADDENDUM',
  RESALE_EMR = 'RESALE_EMR',
  RESALE_FINAL_SETTLEMENT_STATEMENT = 'RESALE_FINAL_SETTLEMENT_STATEMENT',
  RESALE_SIGNED_SELLER_CLOSING_DOCS = 'RESALE_SIGNED_SELLER_CLOSING_DOCS',
  RS_ADDENDUM = 'RS_ADDENDUM',
  RS_ADDENDUM_CONTINGENCY = 'RS_ADDENDUM_CONTINGENCY',
  RS_ADDENDUM_HOA = 'RS_ADDENDUM_HOA',
  RS_ADDENDUM_LBP = 'RS_ADDENDUM_LBP',
  RS_ADDENDUM_MINERAL_OIL_GAS = 'RS_ADDENDUM_MINERAL_OIL_GAS',
  RS_ADDENDUM_TPF = 'RS_ADDENDUM_TPF',
  RS_AGENT_REFERRAL_FORM = 'RS_AGENT_REFERRAL_FORM',
  RS_AMENDMENT = 'RS_AMENDMENT',
  RS_BRN_CREDIT_ADDENDUM = 'RS_BRN_CREDIT_ADDENDUM',
  RS_BRN_FINAL = 'RS_BRN_FINAL',
  RS_BRN_FINAL_CREDIT_ADDENDUM = 'RS_BRN_FINAL_CREDIT_ADDENDUM',
  RS_BRN_INITIAL = 'RS_BRN_INITIAL',
  RS_BUYER_CLOSING_DOCS = 'RS_BUYER_CLOSING_DOCS',
  RS_BUYER_INSPECTION_FOUNDATION = 'RS_BUYER_INSPECTION_FOUNDATION',
  RS_BUYER_INSPECTION_GENERAL = 'RS_BUYER_INSPECTION_GENERAL',
  RS_BUYER_INSPECTION_HVAC = 'RS_BUYER_INSPECTION_HVAC',
  RS_BUYER_INSPECTION_OTHER = 'RS_BUYER_INSPECTION_OTHER',
  RS_BUYER_INSPECTION_ROOF = 'RS_BUYER_INSPECTION_ROOF',
  RS_BUYER_INSPECTION_TERMITE = 'RS_BUYER_INSPECTION_TERMITE',
  RS_CANCEL_DOCUMENT = 'RS_CANCEL_DOCUMENT',
  RS_CIC_RECEIPT = 'RS_CIC_RECEIPT',
  RS_COUNTER = 'RS_COUNTER',
  RS_CURE_NOTICE = 'RS_CURE_NOTICE',
  RS_DEED = 'RS_DEED',
  RS_FHA_LOAN_AMENDATORY = 'RS_FHA_LOAN_AMENDATORY',
  RS_FINAL_SETTLEMENT_STATEMENT = 'RS_FINAL_SETTLEMENT_STATEMENT',
  RS_HOA_DEMAND = 'RS_HOA_DEMAND',
  RS_HOA_DOCS = 'RS_HOA_DOCS',
  RS_HOA_RECEIPT = 'RS_HOA_RECEIPT',
  RS_HOME_WARRANTY_INVOICE = 'RS_HOME_WARRANTY_INVOICE',
  RS_LAND_SURVEY = 'RS_LAND_SURVEY',
  RS_LOAN_STATUS_UPDATE = 'RS_LOAN_STATUS_UPDATE',
  RS_NATURAL_HAZARD_DISCLOSURE = 'RS_NATURAL_HAZARD_DISCLOSURE',
  RS_PRE_CLOSE_WALKTHROUGH = 'RS_PRE_CLOSE_WALKTHROUGH',
  RS_REALTOR_DISCLOSURE_AGENCY = 'RS_REALTOR_DISCLOSURE_AGENCY',
  RS_RECEIPT_EM = 'RS_RECEIPT_EM',
  RS_RECEIPT_OTHER = 'RS_RECEIPT_OTHER',
  RS_SELLER_SIGNED_CLOSING_DOCS = 'RS_SELLER_SIGNED_CLOSING_DOCS',
  RS_SURVEY = 'RS_SURVEY',
  RS_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT = 'RS_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT',
  RS_TAX_CERTIFICATE = 'RS_TAX_CERTIFICATE',
  RS_TITLE_COMMITMENT = 'RS_TITLE_COMMITMENT',
  RS_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT = 'RS_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT',
  RS_USER_MISC = 'RS_USER_MISC',
  RS_VA_LOAN_AMENDATORY = 'RS_VA_LOAN_AMENDATORY',
  RS_W9 = 'RS_W9',
  SELLER_DISCLOSURES = 'SELLER_DISCLOSURES',
  SEPTIC_PERMIT = 'SEPTIC_PERMIT',
  SHERLOCK_ASSESSMENT_REPORT = 'SHERLOCK_ASSESSMENT_REPORT',
  SOLAR_INFORMATION = 'SOLAR_INFORMATION',
  SOLAR_MISC = 'SOLAR_MISC',
  SOLAR_PAYOFF = 'SOLAR_PAYOFF',
  SOLAR_TRANSFER_AGREEMENT = 'SOLAR_TRANSFER_AGREEMENT',
  SPDS = 'SPDS',
  STATE_OR_COUNTY_DISCLOSURES = 'STATE_OR_COUNTY_DISCLOSURES',
  SWU_ESTIMATED_NET_SHEET_PDF = 'SWU_ESTIMATED_NET_SHEET_PDF',
  TAX_CERTIFICATE = 'TAX_CERTIFICATE',
  /** @deprecated No longer supported */
  THIRD_PARTY_ADDENDUM = 'THIRD_PARTY_ADDENDUM',
  TITLE_COMMITMENT = 'TITLE_COMMITMENT',
  TITLE_COMPANY_CHANGE = 'TITLE_COMPANY_CHANGE',
  TITLE_DISCLOSURE = 'TITLE_DISCLOSURE',
  TRUTH_IN_SALE_OF_HOUSING_INSPECTION = 'TRUTH_IN_SALE_OF_HOUSING_INSPECTION',
  UCC_TERMINATION = 'UCC_TERMINATION',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT'
}

export type OdProtosDocumentManagementData_DocumentableInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosDocumentManagementData_Documentable_Type>;
};

export enum OdProtosDocumentManagementData_Documentable_Type {
  BRN = 'BRN',
  BROKERAGE_OFFER = 'BROKERAGE_OFFER',
  FLIP = 'FLIP',
  HOME_CONDITION_REPORT = 'HOME_CONDITION_REPORT',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  INVOICE = 'INVOICE',
  LISTING = 'LISTING',
  LISTING_OFFER = 'LISTING_OFFER',
  MAINTENANCE_SCHEDULE = 'MAINTENANCE_SCHEDULE',
  OFFER = 'OFFER',
  UNKNOWN = 'UNKNOWN',
  WORK_ORDER = 'WORK_ORDER',
  WORK_ORDER_ITEM = 'WORK_ORDER_ITEM'
}

export type OdProtosDocumentManagementServices_DocumentRequests_CreateTemplateInput = {
  region?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTemplate_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_DeleteInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_DeleteTemplateDefinitionsInput = {
  templateDefinitionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_GetDocumentTypeConfigInput = {
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTypeConfig_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_GetDocumentTypeNoteInput = {
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTypeNote_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_GetInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_GetTemplateInput = {
  region?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTemplate_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_ListDocumentTypesInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_ListInput = {
  documentType?: InputMaybe<OdProtosDocumentManagementData_Document_Type>;
  params?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneofInput>;
};

/**
 * finds documents for listing offer and all related
 * listing offers up to and including this one
 */
export type OdProtosDocumentManagementServices_DocumentRequests_List_AllListingOfferDocumentsInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_List_CurrentLeadDocumentsInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_List_DocumentableInput = {
  documentable?: InputMaybe<OdProtosDocumentManagementData_DocumentableInput>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_List_IdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneofInput = {
  currentLead?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_CurrentLeadDocumentsInput>;
  documentable?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_DocumentableInput>;
  ids?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_IdsInput>;
  listingOffer?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_AllListingOfferDocumentsInput>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_ReviewInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewStatus>;
  type?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_Review_LogActivityInput = {
  activityNote?: InputMaybe<Scalars['String']['input']>;
  activityType?: InputMaybe<Scalars['String']['input']>;
  eventTime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  reviewType?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewType>;
};

export enum OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export enum OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewType {
  DUE_DILIGENCE = 'DUE_DILIGENCE',
  TRANSACTION_COORDINATOR = 'TRANSACTION_COORDINATOR',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosDocumentManagementServices_DocumentRequests_UpdateInput = {
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** use document_type_id */
  type?: InputMaybe<OdProtosDocumentManagementData_Document_Type>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UploadInput = {
  params?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Upload_ParamsOneofInput>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_Upload_DocumentInput = {
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  documentable?: InputMaybe<OdProtosDocumentManagementData_DocumentableInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  sourceChannel?: InputMaybe<OdProtosDocumentManagementData_Document_SourceChannel>;
  storage?: InputMaybe<OdProtosDocumentManagementData_DocumentStorageInput>;
  /** use document_type_id */
  type?: InputMaybe<OdProtosDocumentManagementData_Document_Type>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_Upload_ParamsOneofInput = {
  document?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Upload_DocumentInput>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertDocumentTypeConfigInput = {
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  reviewFields?: InputMaybe<Array<OdProtosDocumentManagementServices_DocumentRequests_UpsertDocumentTypeConfig_ReviewFieldInput>>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTypeConfig_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertDocumentTypeConfig_ReviewFieldInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertDocumentTypeNoteInput = {
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTypeNote_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertTemplateDefinitionsInput = {
  templateDefinitions?: InputMaybe<Array<OdProtosDocumentManagementServices_DocumentRequests_UpsertTemplateDefinitions_TemplateDefinitionInput>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertTemplateDefinitions_TemplateDefinitionInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceContractSlaInDays?: InputMaybe<Scalars['Float']['input']>;
  dueDiligenceDocUploadSlaInDays?: InputMaybe<Scalars['Float']['input']>;
  dueDiligenceSlaInDays?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  requiresBuyerSignature?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDueDiligence?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEpsSignature?: InputMaybe<Scalars['Boolean']['input']>;
  requiresNotarization?: InputMaybe<Scalars['Boolean']['input']>;
  requiresReview?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSellerSignature?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  tcContractSlaInDays?: InputMaybe<Scalars['Float']['input']>;
  tcDocUploadSlaInDays?: InputMaybe<Scalars['Float']['input']>;
  tcSlaInDays?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDocumentManagementServices_SyncWebDocReviewsToDms_DocumentReviewInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  docId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reviewerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  webReviewId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDocumentManagementServices_SyncWebDocReviewsToDms_RequestInput = {
  bulkUpsert?: InputMaybe<Scalars['Boolean']['input']>;
  documentReviews?: InputMaybe<Array<OdProtosDocumentManagementServices_SyncWebDocReviewsToDms_DocumentReviewInput>>;
};

export type OdProtosDocumentManagementServices_SyncWebDocsToDms_DocumentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedById?: InputMaybe<Scalars['String']['input']>;
  detectiveUuid?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<OdProtosDocumentManagementData_Document_Type>;
  documentableId?: InputMaybe<Scalars['String']['input']>;
  documentableType?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalSource?: InputMaybe<Scalars['String']['input']>;
  homeworkId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  s3ContentId?: InputMaybe<Scalars['String']['input']>;
  signedOn?: InputMaybe<Scalars['DateTime']['input']>;
  sourceChannel?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  visibilityMask?: InputMaybe<Scalars['String']['input']>;
  webDocId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosDocumentManagementServices_SyncWebDocsToDms_RequestInput = {
  bulkUpsert?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Array<OdProtosDocumentManagementServices_SyncWebDocsToDms_DocumentInput>>;
};

export enum OdProtosElementsData_SyncType_Type {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UNKNOWN = 'UNKNOWN',
  UPDATE = 'UPDATE'
}

/**
 * A utility context is a wrapper for general information required to manage any
 * utility.
 *
 * It can includes things like proof of ownership and home access information.
 *
 * NEXT ID: 35
 */
export type OdProtosElementsData_UtilityContextInput = {
  acqTitleContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Acquisition Title Organization contact details */
  acqTitleContactName?: InputMaybe<Scalars['String']['input']>;
  acqTitleContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Url to the Acquisition warranty deed */
  acqWarrantyDeed?: InputMaybe<Scalars['String']['input']>;
  /** Date the flip was acquired */
  acquisitionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Acquisition Title Organization name */
  acquisitionOrganizationName?: InputMaybe<Scalars['String']['input']>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** Number of bathrooms in the Home. */
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Number of bedrooms in the Home. */
  bedrooms?: InputMaybe<Scalars['Float']['input']>;
  closeOfEscrowDate?: InputMaybe<Scalars['DateTime']['input']>;
  communityGateCode?: InputMaybe<Scalars['String']['input']>;
  /** Context creation timestamp */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  cxEmail?: InputMaybe<Scalars['String']['input']>;
  /** Display Category represents Acq/Resale channels */
  displayCategory?: InputMaybe<Scalars['String']['input']>;
  escrowNumber?: InputMaybe<Scalars['String']['input']>;
  /** Url to the settlement doc */
  finalSettlementDoc?: InputMaybe<Scalars['String']['input']>;
  /** Emails used for blocked escalation paths */
  hqlEmail?: InputMaybe<Scalars['String']['input']>;
  /**
   * Uniqueness is enforced.
   * Flip token should follow the convention of 'flip:[TOKEN_HERE]'
   */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Last successful sync with an external tasking system */
  lastSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lateCheckoutDate?: InputMaybe<Scalars['DateTime']['input']>;
  lockboxCode?: InputMaybe<Scalars['String']['input']>;
  /** Long form standard market name e.g. phoenix */
  market?: InputMaybe<Scalars['String']['input']>;
  /** The meter number or a url to its picture */
  meterNumber?: InputMaybe<Scalars['String']['input']>;
  /** All Utility Photo urls */
  photoUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Url to the Resale settlement doc */
  resaleFinalSettlementDoc?: InputMaybe<Scalars['String']['input']>;
  resaleTitleContactEmail?: InputMaybe<Scalars['String']['input']>;
  resaleTitleContactName?: InputMaybe<Scalars['String']['input']>;
  resaleTitleContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Resale Title Organization and contact details */
  resaleTitleOrganizationName?: InputMaybe<Scalars['String']['input']>;
  /** Url to the Resale warranty deed */
  resaleWarrantyDeed?: InputMaybe<Scalars['String']['input']>;
  /** Special Flags like the lead type, offer type, if reserved home, etc. */
  specialFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Total square footage of all livable area of the Home. */
  squareFootage?: InputMaybe<Scalars['Float']['input']>;
  /** Context update timestamp */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A utility task contains instructions and state information for a utility
 * on/off/change task.
 *
 * E.g.
 * TURN_ON ELECTRIC due to ACQ_COE on 9/1
 * SCHEDULED for 9/3
 * Task completed 8/1
 *
 * Next ID: 24
 */
export type OdProtosElementsData_UtilityTaskInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * An identifier to track tasks which were generated in the same batch
   * (for billing purposes)
   */
  batchUuid?: InputMaybe<Scalars['String']['input']>;
  /** Additional context for why the task is blocked */
  blockedReason?: InputMaybe<Scalars['String']['input']>;
  /** Task completion timestamp */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The vendor who serviced this utility type */
  contactedBy?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference to a utility context.
   * Flip token should follow the convention of 'flip:[TOKEN_HERE]'
   */
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Task creation timestamp */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Task deletion timestamp */
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date we want the activity to be scheduled */
  desiredActivityDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** To indicate if utility provider has been contacted for this task */
  isProviderContacted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the task has a sync_scheduled_date, but is already synced immediately */
  isScheduledSyncCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last successful sync with an external tasking system */
  lastSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** Utility provider, e.g. PG&E */
  provider?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<OdProtosElementsData_UtilityTask_Reason>;
  /** Date that the activity was actually scheduled */
  scheduledActivityDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<OdProtosElementsData_UtilityTask_TaskState>;
  /** Date we want the activity to be synced */
  syncScheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  taskAction?: InputMaybe<OdProtosElementsData_UtilityTask_TaskAction>;
  /** Task update timestamp */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  utilityType?: InputMaybe<OdProtosElementsData_UtilityTask_UtilityType>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** Whether the property has Sewer or Septic */
  wasteWaterType?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 8 */
export enum OdProtosElementsData_UtilityTask_Reason {
  ACQ_COE = 'ACQ_COE',
  ACQ_COE_CHANGE = 'ACQ_COE_CHANGE',
  EXPIRED = 'EXPIRED',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  RESALE_COE = 'RESALE_COE',
  RESALE_COE_CHANGE = 'RESALE_COE_CHANGE',
  UNKNOWN_REASON = 'UNKNOWN_REASON',
  WITHDRAWN = 'WITHDRAWN'
}

/** Next ID: 6 */
export enum OdProtosElementsData_UtilityTask_TaskAction {
  HANDLE_WITHDRAWAL = 'HANDLE_WITHDRAWAL',
  MODIFY_OFF = 'MODIFY_OFF',
  MODIFY_ON = 'MODIFY_ON',
  TURN_OFF = 'TURN_OFF',
  TURN_ON = 'TURN_ON',
  UNKNOWN_ACTION = 'UNKNOWN_ACTION'
}

/** Next ID: 9 */
export enum OdProtosElementsData_UtilityTask_TaskState {
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  CLAIMED = 'CLAIMED',
  COMPLETED = 'COMPLETED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  PENDING_CX = 'PENDING_CX',
  RE_OPENED = 'RE_OPENED',
  UNCLAIMED = 'UNCLAIMED',
  /**
   * UKNOWN_STATE is the default task state but should not be used in normal
   * circumstances.
   */
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/**
 * UtilityType is an enum that represents the possible types of utilities
 * or services that can be set up within a home.
 *
 * Next ID: 6
 */
export enum OdProtosElementsData_UtilityTask_UtilityType {
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  SEWAGE = 'SEWAGE',
  TRASH = 'TRASH',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  WATER = 'WATER'
}

/**
 * Elements uses the context of existing tasks to apply a command.
 * A command can result in generating a new task or updating an existing task.
 *
 * NEXT ID: 9
 */
export type OdProtosElementsServices_CommandInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference to a utility context.
   * Flip token should follow the convention of 'flip:[TOKEN_HERE]'
   */
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Date we want the activity to be scheduled. */
  desiredActivityDate?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<OdProtosElementsData_UtilityTask_Reason>;
  taskAction?: InputMaybe<OdProtosElementsData_UtilityTask_TaskAction>;
  utilityType?: InputMaybe<OdProtosElementsData_UtilityTask_UtilityType>;
};

export type OdProtosElementsServices_ElementsDebugRequest_SyncServiceAccountsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosElementsServices_ElementsDebugRequest_SyncTasksInput = {
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** This flag can be set to only resync unsynced tasks. */
  onlyUnsynced?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosElementsServices_ElementsRequest_CreateTaskInput = {
  task?: InputMaybe<OdProtosElementsData_UtilityTaskInput>;
};

export type OdProtosElementsServices_ElementsRequest_DeleteTaskInput = {
  taskUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Flip token identifier should follow the convention of 'flip:[TOKEN_HERE]' */
export type OdProtosElementsServices_ElementsRequest_GetContextInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosElementsServices_ElementsRequest_GetTaskInput = {
  taskUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosElementsServices_ElementsRequest_GetUtilityContextAndTasksInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosElementsServices_ElementsRequest_MutateTaskInput = {
  taskMutate?: InputMaybe<OdProtosElementsServices_TaskMutateInput>;
};

export type OdProtosElementsServices_ElementsRequest_PushCommandsAndContextInput = {
  commands?: InputMaybe<Array<OdProtosElementsServices_CommandInput>>;
  context?: InputMaybe<OdProtosElementsData_UtilityContextInput>;
};

export type OdProtosElementsServices_ElementsRequest_SaveContextInput = {
  context?: InputMaybe<OdProtosElementsData_UtilityContextInput>;
};

export type OdProtosElementsServices_ElementsRequest_UpdateLastContextSyncInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosElementsServices_ElementsRequest_UpdateLastTaskSyncInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosElementsServices_PublishToHomeDataStoreRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosElementsServices_SyncWattbuyWebNotesRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/** NEXT ID: 11 */
export type OdProtosElementsServices_TaskMutateInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Task completion timestamp */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The vendor who serviced this utility type */
  contactedBy?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if utility provider has been contacted for this task */
  isProviderContacted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** Mutable fields */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Date that the activity was actually scheduled. */
  scheduledActivityDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<OdProtosElementsData_UtilityTask_TaskState>;
  /** Task identifier */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** Whether the property has Sewer or Septic */
  wasteWaterType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosElementsServices_TestCcpaAccessRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 8 */
export type OdProtosFenceData_RegionDetailInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** From Directory */
  createdByToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** From Directory */
  editPermOrganizationUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Should only be populated with a Polygon or MultiPolygon GeoJSON object.
   * [To be implemented] - Will be usable after Polyfence rollout.
   */
  geojsonGeom?: InputMaybe<Scalars['String']['input']>;
  /** [To be deprecated] Optional - Will no longer be used for actual logic after Polyfence rollout. Please use geojson_geom instead. */
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<OdProtosCommonState_State>;
};

/** Next ID: 6 */
export type OdProtosFenceData_RegionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional - may be empty if with_detail not set in request */
  details?: InputMaybe<OdProtosFenceData_RegionDetailInput>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  tagIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 3 */
export type OdProtosFenceServices_AddTagsToRegionRequestInput = {
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  tagIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Parameters for BulkGetIntersectingRegions RPC
 * Next ID: 5
 *
 * Required. The response will include all regions that intersect with this one
 * A region always intersects itself, but it may be excluded from the results
 * if it is not tagged correctly
 */
export type OdProtosFenceServices_BulkGetIntersectingRegionsRequestInput = {
  /** Fence Region identifier. */
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter the regions to return only those with ALL of these tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include the details field */
  withDetail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 5 */
export type OdProtosFenceServices_BulkGetRegionsFromAddressRequestInput = {
  addresses?: InputMaybe<Array<OdProtosFenceServices_BulkGetRegionsFromAddressRequest_AddressInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  withDetail?: InputMaybe<Scalars['Boolean']['input']>;
  withGeom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosFenceServices_BulkGetRegionsFromAddressRequest_AddressInput = {
  address?: InputMaybe<OdProtosFenceServices_BulkGetRegionsFromAddressRequest_Address_AddressOneofInput>;
};

export type OdProtosFenceServices_BulkGetRegionsFromAddressRequest_Address_AddressOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  casaAddress?: InputMaybe<OdProtosCasaData_AddressInput>;
};

/** Next ID: 9 */
export type OdProtosFenceServices_CreateRegionRequestInput = {
  /** From Directory */
  createdByToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional - human readable description of region */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional - Should only be populated with a Polygon or MultiPolygon GeoJSON object.
   * Will be usable after Polyfence rollout.
   */
  geojsonGeom?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Optional - empty array is valid (means everyone can edit) */
  organizationUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * [To be deprecated] Optional - Can be used with geojson_geom="" to request polygon generation.
   * This code path is for backwards compatibility and is strongly discouraged after Polyfence rollout.
   */
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional */
  state?: InputMaybe<OdProtosCommonState_State>;
  /** Optional - empty array is valid */
  tagsIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 5 */
export type OdProtosFenceServices_CreateTagRequestInput = {
  /** From Directory */
  createdByToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  noOverlap?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Parameters for GetIntersectingRegions RPC
 * Next ID: 5
 *
 * Required. The response will include all regions that intersect with this one
 * A region always intersects itself, but it may be excluded from the results
 * if it is not tagged correctly
 */
export type OdProtosFenceServices_GetIntersectingRegionsRequestInput = {
  /** Fence Region identifier. */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter the regions to return only those with ALL of these tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include the details field */
  withDetail?: InputMaybe<Scalars['Boolean']['input']>;
  withGeom?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetRegionHistoryRequestInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetRegionRequestInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosFenceServices_GetRegionsFromAddressRequestInput = {
  address?: InputMaybe<OdProtosFenceServices_GetRegionsFromAddressRequest_AddressOneofInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  withDetail?: InputMaybe<Scalars['Boolean']['input']>;
  withGeom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosFenceServices_GetRegionsFromAddressRequest_AddressOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  casaAddress?: InputMaybe<OdProtosCasaData_AddressInput>;
};

/** Next ID: 3 */
export type OdProtosFenceServices_GetRegionsFromPostalCodesRequestInput = {
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 4 */
export type OdProtosFenceServices_GetRegionsFromTagsRequestInput = {
  /** Optional - will return all regions if empty */
  tagIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  withDetail?: InputMaybe<Scalars['Boolean']['input']>;
  withGeom?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetRegionsRequestInput = {
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetTagRequestInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetTagsRequestInput = {
  /** Optional - return all tags if unset */
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 4 */
export type OdProtosFenceServices_UpdateRegionRequestInput = {
  region?: InputMaybe<OdProtosFenceData_RegionInput>;
  /**
   * Required: identifier, details.created_by_token
   * Won't update (set internally): version, created_at, details.archived_at
   */
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

export type OdProtosFinanceData_AccountBalanceInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_AccountInput = {
  balance?: InputMaybe<Scalars['Float']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  contributesToBorrowingBase?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  syncTime?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_AccountsInput = {
  accounts?: InputMaybe<Array<OdProtosFinanceData_Accounts_AccountsEntryInput>>;
};

/** `OdProtosFinanceData_Accounts_AccountsEntryInput` represents the `accounts` map in `od_protos.finance.data.Accounts`. */
export type OdProtosFinanceData_Accounts_AccountsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosFinanceData_AccountInput>;
};

/** Acquisition // */
export type OdProtosFinanceData_AcquisitionInput = {
  actualCoeDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedInitialCapEx?: InputMaybe<Scalars['Float']['input']>;
  grossPurchasePrice?: InputMaybe<Scalars['Float']['input']>;
  netPrice?: InputMaybe<Scalars['Float']['input']>;
  scheduledCoeDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosFinanceData_BorrowingBaseInput = {
  concentrationLimits?: InputMaybe<Array<OdProtosFinanceData_ConcentrationLimitInput>>;
  state?: InputMaybe<OdProtosFinanceData_BorrowingBaseStateInput>;
};

export type OdProtosFinanceData_BorrowingBaseSnapshotInput = {
  borrowingBaseAmount?: InputMaybe<Scalars['Float']['input']>;
  borrowingBaseAsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  breachState?: InputMaybe<Scalars['String']['input']>;
  cash?: InputMaybe<Scalars['Float']['input']>;
  collateralization?: InputMaybe<Scalars['Float']['input']>;
  concentrationLimitId?: InputMaybe<Scalars['String']['input']>;
  facilityTransactions?: InputMaybe<Array<OdProtosFinanceData_TransactionInput>>;
  isInBreach?: InputMaybe<Scalars['Boolean']['input']>;
  loanAmount?: InputMaybe<Scalars['Float']['input']>;
  results?: InputMaybe<Array<OdProtosFinanceData_ConcentrationLimitResultInput>>;
};

export type OdProtosFinanceData_BorrowingBaseStateInput = {
  breachState?: InputMaybe<Scalars['String']['input']>;
  initialSnapshot?: InputMaybe<OdProtosFinanceData_BorrowingBaseSnapshotInput>;
  isInBreach?: InputMaybe<Scalars['Boolean']['input']>;
  latestSnapshot?: InputMaybe<OdProtosFinanceData_BorrowingBaseSnapshotInput>;
  maxSnapshot?: InputMaybe<OdProtosFinanceData_BorrowingBaseSnapshotInput>;
};

export type OdProtosFinanceData_ConcentrationLimitInput = {
  distinctTransactionBucketRule?: InputMaybe<OdProtosFinanceData_DistinctTransactionBucketInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  postProcessor?: InputMaybe<OdProtosFinanceData_PostProcessorInput>;
  transactionBucketRules?: InputMaybe<Array<OdProtosFinanceData_TransactionBucketRuleInput>>;
};

export type OdProtosFinanceData_ConcentrationLimitResultInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  concentrationLimitId?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<Array<OdProtosFinanceData_TransactionBucketResultInput>>;
};

export type OdProtosFinanceData_DistinctThresholdsInput = {
  default?: InputMaybe<Scalars['Float']['input']>;
  overrides?: InputMaybe<Array<OdProtosFinanceData_OverrideThresholdInput>>;
};

export type OdProtosFinanceData_DistinctTransactionBucketInput = {
  distinctThresholds?: InputMaybe<OdProtosFinanceData_DistinctThresholdsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  partitionField?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_EmailTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientGroupName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_FacilityInput = {
  accounts?: InputMaybe<OdProtosFinanceData_AccountsInput>;
  borrowingBase?: InputMaybe<OdProtosFinanceData_BorrowingBaseInput>;
  fundedTransactions?: InputMaybe<OdProtosFinanceData_FundedTransactionsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  loanTerms?: InputMaybe<OdProtosFinanceData_LoanTermsInput>;
  marketConfig?: InputMaybe<OdProtosFinanceData_MarketsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owningEntity?: InputMaybe<Scalars['String']['input']>;
  rateSchedule?: InputMaybe<OdProtosFinanceData_RateScheduleInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Financing // */
export type OdProtosFinanceData_FinancingInput = {
  facilityAllocations?: InputMaybe<Array<OdProtosFinanceData_Financing_FacilityAllocationsEntryInput>>;
};

/** `OdProtosFinanceData_Financing_FacilityAllocationsEntryInput` represents the `facility_allocations` map in `od_protos.finance.data.Financing`. */
export type OdProtosFinanceData_Financing_FacilityAllocationsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosFinanceData_FundedTransactionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_FundedTransactionsInput = {
  transactions?: InputMaybe<Array<OdProtosFinanceData_FundedTransactions_TransactionsEntryInput>>;
};

/** `OdProtosFinanceData_FundedTransactions_TransactionsEntryInput` represents the `transactions` map in `od_protos.finance.data.FundedTransactions`. */
export type OdProtosFinanceData_FundedTransactions_TransactionsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosFinanceData_FundedTransactionInput>;
};

export type OdProtosFinanceData_LoanTermsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosFinanceData_MarketInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  msa?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_MarketsInput = {
  markets?: InputMaybe<Array<OdProtosFinanceData_Markets_MarketsEntryInput>>;
};

/** `OdProtosFinanceData_Markets_MarketsEntryInput` represents the `markets` map in `od_protos.finance.data.Markets`. */
export type OdProtosFinanceData_Markets_MarketsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosFinanceData_MarketInput>;
};

export type OdProtosFinanceData_OverrideThresholdInput = {
  threshold?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_PostProcessorInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_PropertyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceData_PropertyDetailInput = {
  address?: InputMaybe<OdProtosFinanceData_PropertyAddressInput>;
  numBathrooms?: InputMaybe<Scalars['Float']['input']>;
  numBedrooms?: InputMaybe<Scalars['Float']['input']>;
  propertyType?: InputMaybe<OdProtosFinanceData_PropertyDetail_PropertyType>;
  type?: InputMaybe<Scalars['String']['input']>;
  yearBuilt?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosFinanceData_PropertyDetail_PropertyType {
  CONDO = 'CONDO',
  MULTI_FAMILY = 'MULTI_FAMILY',
  PROPERTY_TYPE_UNSPECIFIED = 'PROPERTY_TYPE_UNSPECIFIED',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
  TOWNHOUSE_OTHER = 'TOWNHOUSE_OTHER'
}

/** Property // */
export type OdProtosFinanceData_PropertyInput = {
  detail?: InputMaybe<OdProtosFinanceData_PropertyDetailInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  syncTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosFinanceData_RateInput = {
  end?: InputMaybe<Scalars['Float']['input']>;
  loanToCost?: InputMaybe<Scalars['Float']['input']>;
  loanToValue?: InputMaybe<Scalars['Float']['input']>;
  rateId?: InputMaybe<Scalars['String']['input']>;
  resale?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosFinanceData_RateScheduleInput = {
  rateSchedule?: InputMaybe<Array<OdProtosFinanceData_RateInput>>;
};

/** Resale // */
export type OdProtosFinanceData_ResaleInput = {
  actualCoeDate?: InputMaybe<Scalars['DateTime']['input']>;
  concentrationProceeds?: InputMaybe<OdProtosFinanceData_ResaleProceedsInput>;
  escrowProceeds?: InputMaybe<OdProtosFinanceData_ResaleProceedsInput>;
  scheduledCoeDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosFinanceData_ResaleProceedsInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  money?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosFinanceData_TransactionBucketResultInput = {
  bbAmount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxLoanAmount?: InputMaybe<Scalars['Float']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalValue?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosFinanceData_TransactionBucketRuleInput = {
  conditionExpression?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

/** Transaction // */
export type OdProtosFinanceData_TransactionInput = {
  acquisition?: InputMaybe<OdProtosFinanceData_AcquisitionInput>;
  financing?: InputMaybe<OdProtosFinanceData_FinancingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<OdProtosFinanceData_PropertyInput>;
  resale?: InputMaybe<OdProtosFinanceData_ResaleInput>;
};

export type OdProtosFinanceServices_AuthorizeOauthRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** BatchCreateOrUpdateTransactions // */
export type OdProtosFinanceServices_BatchCreateOrUpdateTransactionsRequestInput = {
  transactions?: InputMaybe<Array<OdProtosFinanceData_TransactionInput>>;
};

/** BatchDeleteTransactionFinancing // */
export type OdProtosFinanceServices_BatchDeleteTransactionFinancingRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** BatchDeleteTransactions - NOT IMPLEMENTED // */
export type OdProtosFinanceServices_BatchDeleteTransactionsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** CreateConcentrationLimit // */
export type OdProtosFinanceServices_CreateConcentrationLimitRequestInput = {
  concentrationLimit?: InputMaybe<OdProtosFinanceData_ConcentrationLimitInput>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceServices_CreateEmailTemplateRequestInput = {
  template?: InputMaybe<OdProtosFinanceData_EmailTemplateInput>;
};

/** CreateFacility // */
export type OdProtosFinanceServices_CreateFacilityAccountRequestInput = {
  account?: InputMaybe<OdProtosFinanceData_AccountInput>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

/** CreateFacility // */
export type OdProtosFinanceServices_CreateFacilityRequestInput = {
  facility?: InputMaybe<OdProtosFinanceData_FacilityInput>;
};

/** DeleteConcentrationLimit// */
export type OdProtosFinanceServices_DeleteConcentrationLimitRequestInput = {
  concentrationLimitId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

/** DeleteFacility // */
export type OdProtosFinanceServices_DeleteFacilityAccountRequestInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

/** DeleteFacilityMarkets // */
export type OdProtosFinanceServices_DeleteFacilityMarketsRequestInput = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetFacility // */
export type OdProtosFinanceServices_GetFacilityRequestInput = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

/** GetTransaction // */
export type OdProtosFinanceServices_GetTransactionRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Email Templates // */
export type OdProtosFinanceServices_ListEmailTemplatesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ListFacilities // */
export type OdProtosFinanceServices_ListFacilitiesRequestInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

/** ListFundedTransactions // */
export type OdProtosFinanceServices_ListFundedTransactionsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** SetAccountBalances // */
export type OdProtosFinanceServices_SetFacilityAccountBalancesRequestInput = {
  accountBalances?: InputMaybe<Array<OdProtosFinanceData_AccountBalanceInput>>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFinanceServices_SyncFacilityMarketsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** UpdateConcentrationLimit // */
export type OdProtosFinanceServices_UpdateConcentrationLimitRequestInput = {
  concentrationLimit?: InputMaybe<OdProtosFinanceData_ConcentrationLimitInput>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateFacility // */
export type OdProtosFinanceServices_UpdateFacilityAccountRequestInput = {
  account?: InputMaybe<OdProtosFinanceData_AccountInput>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateFacility // */
export type OdProtosFinanceServices_UpdateFacilityRequestInput = {
  facility?: InputMaybe<OdProtosFinanceData_FacilityInput>;
};

/** UpsertFacilityMarkets // */
export type OdProtosFinanceServices_UpsertFacilityMarketsRequestInput = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  markets?: InputMaybe<Array<OdProtosFinanceData_MarketInput>>;
};

export enum OdProtosFulfillmentData_MilestoneStatus {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN'
}

export type OdProtosFulfillmentServices_CreateClosingValidationByReasonInput = {
  fulfillmentId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFulfillmentServices_CreateClosingValidationByValidationInput = {
  deedDocumentId?: InputMaybe<Scalars['String']['input']>;
  deedRecordingDate?: InputMaybe<Scalars['DateTime']['input']>;
  disbursementDate?: InputMaybe<Scalars['DateTime']['input']>;
  finalSettlementStatementDocumentId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosFulfillmentServices_CreateClosingValidationRequestInput = {
  by?: InputMaybe<OdProtosFulfillmentServices_CreateClosingValidationRequest_ByOneofInput>;
};

export type OdProtosFulfillmentServices_CreateClosingValidationRequest_ByOneofInput = {
  skipvalidation?: InputMaybe<OdProtosFulfillmentServices_CreateClosingValidationByReasonInput>;
  validate?: InputMaybe<OdProtosFulfillmentServices_CreateClosingValidationByValidationInput>;
};

export type OdProtosFulfillmentServices_GetClosingValidationById_RequestInput = {
  by?: InputMaybe<OdProtosFulfillmentServices_GetClosingValidationById_Request_ByOneofInput>;
};

export type OdProtosFulfillmentServices_GetClosingValidationById_Request_ByOneofInput = {
  closingValidationId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFulfillmentServices_GetFulfillmentById_RequestInput = {
  by?: InputMaybe<OdProtosFulfillmentServices_GetFulfillmentById_Request_ByOneofInput>;
};

export type OdProtosFulfillmentServices_GetFulfillmentById_Request_ByOneofInput = {
  fulfillmentId?: InputMaybe<Scalars['String']['input']>;
  listingOfferUuid?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosFulfillmentServices_GetFulfillmentRequestInput = {
  fulfillmentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFulfillmentServices_GetFulfillmentWebStateRequestInput = {
  fulfillmentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFulfillmentServices_GetFulfillmentsSummaryForOperatorsRequestInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  operatorTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosFulfillmentServices_GetTotalActiveVolumeForOperatorsRequestInput = {
  activeVolumeFilters?: InputMaybe<Array<OdProtosOperatorServices_ActiveVolumeFilterInput>>;
};

export type OdProtosFulfillmentServices_ReassignFulfillmentsRequestInput = {
  fulfillmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  operatorTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosFulfillmentServices_RefreshFulfillmentRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosFulfillmentServices_SearchFulfillmentRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosFulfillmentServices_UpdateFulfillmentRequestInput = {
  fulfillmentId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentStatus?: InputMaybe<Scalars['String']['input']>;
  fulfillmentStatusReason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosGatekeeperServices_GetPermissionsForUserRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosGatekeeperServices_GetRequiredRolesForAllServicesEndpointsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosGatekeeperServices_GetRequiredRolesForEndpointRequestInput = {
  /** Next ID: 3 */
  endpointName?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosGatekeeperServices_GetRequiredRolesForPermissionsRequestInput = {
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosGatekeeperServices_GetRequiredRolesForServiceEndpointsRequestInput = {
  /** Next ID: 2 */
  serviceName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosGatekeeperServices_GetServicePermissionsForRolesRequestInput = {
  serviceName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosGatekeeperServices_GetWebPermissionsForRolesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 39 */
export type OdProtosGeoDataStoreData_CoreLogicBuildingPermitInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  addressUnitNumber?: InputMaybe<Scalars['String']['input']>;
  addressUnitType?: InputMaybe<Scalars['String']['input']>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  apn?: InputMaybe<Scalars['String']['input']>;
  buildingPermitNumber?: InputMaybe<Scalars['String']['input']>;
  contractorBusinessName?: InputMaybe<Scalars['String']['input']>;
  contractorCity?: InputMaybe<Scalars['String']['input']>;
  contractorPostalCode?: InputMaybe<Scalars['String']['input']>;
  contractorState?: InputMaybe<Scalars['String']['input']>;
  contractorType?: InputMaybe<Scalars['Int']['input']>;
  contractorUrl?: InputMaybe<Scalars['String']['input']>;
  countyLandUseDescription?: InputMaybe<Scalars['String']['input']>;
  fipsCode?: InputMaybe<Scalars['String']['input']>;
  homeownerName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  landUseCode?: InputMaybe<Scalars['Int']['input']>;
  mostRecentStatusAttained?: InputMaybe<Scalars['String']['input']>;
  permitDescription?: InputMaybe<Scalars['String']['input']>;
  permitEffectiveDate?: InputMaybe<OdProtosCommon_DateInput>;
  permitExpirationDate?: InputMaybe<OdProtosCommon_DateInput>;
  permitFilingFeesCents?: InputMaybe<Scalars['Float']['input']>;
  permitJobValueCents?: InputMaybe<Scalars['Float']['input']>;
  permitNumberOfUnits?: InputMaybe<Scalars['Float']['input']>;
  permitProjectType1?: InputMaybe<Scalars['String']['input']>;
  permitProjectType2?: InputMaybe<Scalars['String']['input']>;
  permitProjectType3?: InputMaybe<Scalars['String']['input']>;
  permitSquareFeet?: InputMaybe<Scalars['Float']['input']>;
  permitStatus?: InputMaybe<Scalars['String']['input']>;
  permitStories?: InputMaybe<Scalars['Float']['input']>;
  permitSubtypeOfWork?: InputMaybe<Scalars['String']['input']>;
  permitTypeOfWork?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  propertyIndicatorCode?: InputMaybe<Scalars['Int']['input']>;
  stateLandUseDescription?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosGeoDataStoreData_EducationLevel {
  EDUCATIONLEVEL_ELEMENTARY = 'EDUCATIONLEVEL_ELEMENTARY',
  EDUCATIONLEVEL_HIGH = 'EDUCATIONLEVEL_HIGH',
  EDUCATIONLEVEL_MIDDLE = 'EDUCATIONLEVEL_MIDDLE',
  EDUCATIONLEVEL_UNKNOWN = 'EDUCATIONLEVEL_UNKNOWN'
}

/**
 * NOT FOR READ USAGE.
 * This is a proto DAS writing Precisely data to GDS ONLY.
 *
 * Next ID:
 */
export type OdProtosGeoDataStoreData_PreciselyDistrictInput = {
  /** wkt shape of the school district boundary */
  boundary?: InputMaybe<Scalars['String']['input']>;
  /** Unique obj_id district identifier internal to precisely */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of the school district */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the school district from NCES */
  ncesDistrictId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * NOT FOR READ USAGE.
 * This is a proto DAS writing Precisely data to GDS ONLY.
 *
 * Next ID: 15
 */
export type OdProtosGeoDataStoreData_PreciselySchoolInput = {
  /** wkt shape of the school boundary */
  boundary?: InputMaybe<Scalars['String']['input']>;
  /** Unique obj_id district identifier internal to precisely */
  districtId?: InputMaybe<Scalars['String']['input']>;
  /** Level of instruction provided by school (can be multiple) */
  educationLevel?: InputMaybe<Array<OdProtosGeoDataStoreData_EducationLevel>>;
  /** The grades offered at the school e.g. "PK-5" */
  gradesOffered?: InputMaybe<Scalars['String']['input']>;
  /** The great school's overview url for this school */
  greatSchoolsUrl?: InputMaybe<Scalars['String']['input']>;
  /** Unique obj_id school identifier internal to precisely */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The lat/lon of the school */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** The name of the school */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the school district from NCES */
  ncesDistrictId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the school from NCES */
  ncesSchoolId?: InputMaybe<Scalars['String']['input']>;
  /** The great schools rating of the school, out of 10 */
  rating?: InputMaybe<Scalars['Int']['input']>;
  /** The type of school, e.g. public/private */
  schoolType?: InputMaybe<OdProtosGeoDataStoreData_PreciselySchool_SchoolType>;
  /** The school's website url */
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosGeoDataStoreData_PreciselySchool_SchoolType {
  TYPE_PRIVATE = 'TYPE_PRIVATE',
  TYPE_PUBLIC = 'TYPE_PUBLIC',
  TYPE_UNKNOWN = 'TYPE_UNKNOWN'
}

export enum OdProtosGeoDataStoreData_Zone_Type {
  CITY = 'CITY',
  COUNTY = 'COUNTY',
  MACRO_NEIGHBORHOOD = 'MACRO_NEIGHBORHOOD',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  RESIDENTIAL_BOUNDARY = 'RESIDENTIAL_BOUNDARY',
  STATE = 'STATE',
  SUBNEIGHBORHOOD = 'SUBNEIGHBORHOOD',
  UNKNOWN = 'UNKNOWN',
  ZIP_CODE = 'ZIP_CODE'
}

export type OdProtosGeoDataStoreServices_BulkGetNicheSchoolsRequestInput = {
  /** The locations to query for schools. Capped at 200 */
  locations?: InputMaybe<Array<OdProtosGeoDataStoreServices_LocationInput>>;
  /**
   * Optional. The max number of schools to return for each location (the first N nearest schools).
   * Defaults to 25 if unset
   * Capped at 250, returns CodeInvalidArgument if request's limit is > 250
   */
  perLocationLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosGeoDataStoreServices_BulkGetSchoolsRequestInput = {
  /** The locations to query for schools. Capped at 200 */
  locations?: InputMaybe<Array<OdProtosGeoDataStoreServices_LocationInput>>;
  /**
   * Optional. The max number of schools to return for each location (the first N nearest schools).
   * Defaults to 25 if unset
   * Capped at 250, returns CodeInvalidArgument if request's limit is > 250
   */
  perLocationLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosGeoDataStoreServices_BulkGetZoneHierarchyRequestInput = {
  /** The locations to fetch zone hierarchies of. Capped at 20 */
  locations?: InputMaybe<Array<OdProtosGeoDataStoreServices_LocationInput>>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

export type OdProtosGeoDataStoreServices_CheckFloodHazardRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** The zones to consider when checking flood hazard (default: A, A99, AE, AH, AO, V, VE). */
  zones?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OdProtosGeoDataStoreServices_GeoSortKey {
  SORT_KEY_DEFAULT = 'SORT_KEY_DEFAULT',
  SORT_KEY_DISTANCE_ASC = 'SORT_KEY_DISTANCE_ASC',
  SORT_KEY_NAME_ASC = 'SORT_KEY_NAME_ASC'
}

export type OdProtosGeoDataStoreServices_GetCavZonesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosGeoDataStoreServices_GetCoreLogicBuildingPermitRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosGeoDataStoreServices_GetDisplayableZonesRequestInput = {
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** Gets all zones matching requested UUIDs. */
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosGeoDataStoreServices_GetFloodZoneDetailsRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosGeoDataStoreServices_GetNicheSchoolsRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional. The number of schools to return (the first N nearest schools).
   * Defaults to 25 if unset
   * Capped at 250, returns CodeInvalidArgument if request's limit is > 250
   */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosGeoDataStoreServices_GetSchoolsRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional. The number of schools to return (the first N nearest schools).
   * Defaults to 25 if unset
   * Capped at 250, returns CodeInvalidArgument if request's limit is > 250
   */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosGeoDataStoreServices_GetZoneHierarchyRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

export type OdProtosGeoDataStoreServices_GetZonesRequestInput = {
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** Gets all zones matching requested UUIDs. */
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosGeoDataStoreServices_GetZonesVersionIdRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosGeoDataStoreServices_ListCoreLogicBuildingPermitsRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosGeoDataStoreServices_LocationInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosGeoDataStoreServices_SearchZonesByLocationRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional. The number of zones to return
   * Capped at 500, returns CodeInvalidArgument if request's limit is > 500
   * Defaults to 100 if unset
   */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional: The distance to limit the search to.
   * Only Zones within this distance (in meters) will be returned
   * Capped at 160000 (~100 miles), returns CodeInvalidArgument if request's limit is > 160000
   */
  searchDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  sortKey?: InputMaybe<OdProtosGeoDataStoreServices_GeoSortKey>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

export type OdProtosGeoDataStoreServices_SearchZonesByPolygonRequestInput = {
  /**
   * Optional. The number of zones to return
   * Capped at 500, returns CodeInvalidArgument if request's limit is > 500
   * Defaults to 100 if unset
   */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** GeoJSON polygon */
  polygon?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: The distance to limit the search to.
   * Only Zones within this distance (in meters) of the polygon border will be returned
   * Capped at 160000 (~100 miles), returns CodeInvalidArgument if request's limit is > 160000
   */
  searchDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  sortKey?: InputMaybe<OdProtosGeoDataStoreServices_GeoSortKey>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

export type OdProtosGeoDataStoreServices_SearchZonesByTextQueryRequestInput = {
  /** Optional: The latitude of the location used to order search results by nearest */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional. The number of zones to return
   * Capped at 500, returns CodeInvalidArgument if request's limit is > 500
   * Defaults to 100 if unset
   */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Optional: The longitude of the location used to order search results by nearest */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** The query string to search Zones by name with */
  queryString?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** Optional: The states to limit results to */
  states?: InputMaybe<Array<OdProtosCommonState_State>>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

/**
 * UNKNOWN/FULL_SIZE: Full shape is returned
 * EXCLUDE: Empty string is returned
 * SIMPLIFY: ST_Simplified shape is returned
 */
export enum OdProtosGeoDataStoreServices_ShapeGeoOption {
  EXCLUDE = 'EXCLUDE',
  FULL_SIZE = 'FULL_SIZE',
  SIMPLIFY = 'SIMPLIFY',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosGeoDataStoreServices_StoreCavZoneRequestInput = {
  /** Optional supporting evidence */
  evidence?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Polygon ring as lat/lng pairs (must have >= 3 points) */
  polygon?: InputMaybe<Array<OdProtosGeoDataStoreServices_LocationInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** One of: Low, Medium, High, Critical */
  severity?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['String']['input']>;
  /** One of: ESCALATE, BEWARE, GUIDANCE */
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosGeoDataStoreServices_WriteCoreLogicBuildingPermitsRequestInput = {
  permits?: InputMaybe<Array<OdProtosGeoDataStoreData_CoreLogicBuildingPermitInput>>;
};

export type OdProtosGeoDataStoreServices_WritePreciselyDistrictRequestInput = {
  district?: InputMaybe<OdProtosGeoDataStoreData_PreciselyDistrictInput>;
};

export type OdProtosGeoDataStoreServices_WritePreciselySchoolRequestInput = {
  school?: InputMaybe<OdProtosGeoDataStoreData_PreciselySchoolInput>;
};

/**
 * PodCount contains pod counts before and during test run.
 *
 * Next ID: 4
 */
export type OdProtosHedgehogData_PodCountInput = {
  preTestPodCount?: InputMaybe<Scalars['Int']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  testPodCount?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Names of tests in hedgehog service
 * Next ID: 4
 */
export enum OdProtosHedgehogData_TestName {
  HUB_VIEW_VOLUME_TEST = 'HUB_VIEW_VOLUME_TEST',
  OFFER_CREATION_LOAD_TEST = 'OFFER_CREATION_LOAD_TEST',
  SELLER_INPUTS_LOAD_TEST = 'SELLER_INPUTS_LOAD_TEST',
  UNKNOWN = 'UNKNOWN'
}

/**
 * states of tests in hedgehog service
 * Next ID: 5
 */
export enum OdProtosHedgehogData_Test_TestState {
  ABORTED = 'ABORTED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 1 */
export type OdProtosHedgehogServices_AbortAllRunningTestsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 2 */
export type OdProtosHedgehogServices_AbortTestRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 1 */
export type OdProtosHedgehogServices_GetAllRunningTestsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 1 */
export type OdProtosHedgehogServices_GetTestsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 10 */
export type OdProtosHedgehogServices_RunTestRequestInput = {
  podCounts?: InputMaybe<Array<OdProtosHedgehogData_PodCountInput>>;
  script?: InputMaybe<Scalars['String']['input']>;
  testDataset?: InputMaybe<OdProtosHedgehogServices_RunTestRequest_TestDatasetOneofInput>;
  testDescription?: InputMaybe<Scalars['String']['input']>;
  testName?: InputMaybe<OdProtosHedgehogServices_RunTestRequest_TestNameOneofInput>;
};

export type OdProtosHedgehogServices_RunTestRequest_TestDatasetOneofInput = {
  datasetFileContents?: InputMaybe<Scalars['String']['input']>;
  sqlQuery?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHedgehogServices_RunTestRequest_TestNameOneofInput = {
  /** adhoc test name */
  adhocTestName?: InputMaybe<Scalars['String']['input']>;
  /** saved test name */
  savedTestName?: InputMaybe<OdProtosHedgehogData_TestName>;
};

export type OdProtosHelloritoData_MergeFieldInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosHelloritoData_Signature_Status {
  BOUNCED = 'BOUNCED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  SENT = 'SENT',
  SIGNED = 'SIGNED'
}

export type OdProtosHelloritoServices_RecipientsInput = {
  ccs?: InputMaybe<Array<OdProtosHelloritoServices_Recipients_CcInput>>;
  signers?: InputMaybe<Array<OdProtosHelloritoServices_Recipients_SignerInput>>;
};

export type OdProtosHelloritoServices_Recipients_CcInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHelloritoServices_Recipients_SignerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Embedded signers will sign in an OD application.
   * Client is responsible for notifying signer, authenticating and authorizing them,
   * and presenting the contract using GetSignerView.
   */
  isEmbedded?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHelloritoServices_Request_CreateDraftInput = {
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<OdProtosHelloritoServices_RecipientsInput>;
  signingNotificationSubjectText?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHelloritoServices_Request_CreateInput = {
  mergeFields?: InputMaybe<Array<OdProtosHelloritoData_MergeFieldInput>>;
  recipients?: InputMaybe<OdProtosHelloritoServices_RecipientsInput>;
  signingNotificationSubjectText?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHelloritoServices_Request_GetInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHelloritoServices_Request_GetSenderViewInput = {
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** where the sender will be sent to after completion */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHelloritoServices_Request_GetSignerViewInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  /** where the signer will be sent to after completion */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  signerEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHelloritoServices_Request_GetVersionsInput = {
  contractVersionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next index: 10 */
export type OdProtosHodorData_HoaContactInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosHodorData_HoaContact_HoaContactType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosHodorData_HoaContact_HoaContactType {
  ATTORNEY = 'ATTORNEY',
  MANAGING_AGENCY = 'MANAGING_AGENCY',
  OWNERS_ASSOCIATION = 'OWNERS_ASSOCIATION',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosHodorData_HoaFeeInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequency?: InputMaybe<OdProtosHodorData_HoaFee_FeeFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OdProtosHodorData_HoaFee_HoaFeeType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosHodorData_HoaFee_FeeFrequency {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY',
  ONEOFF = 'ONEOFF',
  QUARTERLY = 'QUARTERLY',
  SEMIANNUALLY = 'SEMIANNUALLY',
  UNKNOWN = 'UNKNOWN'
}

/** Type of association fee. */
export enum OdProtosHodorData_HoaFee_HoaFeeType {
  AMENTITY_FEE = 'AMENTITY_FEE',
  BUILDING_MAINTAINENCE_FEE = 'BUILDING_MAINTAINENCE_FEE',
  COMMUNITY_MASTER_HOME_OWNER_FEE = 'COMMUNITY_MASTER_HOME_OWNER_FEE',
  DISCLOSURE = 'DISCLOSURE',
  FEE_CAPITAL_IMPROVEMENTS_FEE = 'FEE_CAPITAL_IMPROVEMENTS_FEE',
  HOMEOWNERS_ASSOCIATION = 'HOMEOWNERS_ASSOCIATION',
  HOME_OWNER_ASSESSMENTS_FEE = 'HOME_OWNER_ASSESSMENTS_FEE',
  HOME_OWNER_TRANSFER_FEE = 'HOME_OWNER_TRANSFER_FEE',
  IMPROVEMENT = 'IMPROVEMENT',
  INITIATION = 'INITIATION',
  MASTER_ASSOCIATION_SPECIAL_ASSESSMENT = 'MASTER_ASSOCIATION_SPECIAL_ASSESSMENT',
  MASTER_ASSOCIATION_TRANSFER = 'MASTER_ASSOCIATION_TRANSFER',
  MELLO_ROOS_COMMUNITY_FACILITIES_DISTRICT_FEE = 'MELLO_ROOS_COMMUNITY_FACILITIES_DISTRICT_FEE',
  MOVE_IN = 'MOVE_IN',
  NEW_ACCOUNT = 'NEW_ACCOUNT',
  OTHER_FEE = 'OTHER_FEE',
  POA_FEE = 'POA_FEE',
  PREPAID = 'PREPAID',
  RECREATION_FEE = 'RECREATION_FEE',
  RESERVE = 'RESERVE',
  RESORT_FEE = 'RESORT_FEE',
  SIDLID_COMMUNITY_FACILITIES_DISTRICT_FEE = 'SIDLID_COMMUNITY_FACILITIES_DISTRICT_FEE',
  SPECIAL_ASSESSMENT = 'SPECIAL_ASSESSMENT',
  SPECIAL_ASSESSMENT_UNDER_CONSIDERATION = 'SPECIAL_ASSESSMENT_UNDER_CONSIDERATION',
  TENNIS_FEE = 'TENNIS_FEE',
  TRANSFER = 'TRANSFER',
  TRANSFER_COMMON_ASSETS = 'TRANSFER_COMMON_ASSETS',
  UNKNOWN_HOA_FEE_TYPE = 'UNKNOWN_HOA_FEE_TYPE'
}

export type OdProtosHodorData_HoaRestrictionsInput = {
  ageRestriction?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  gateCommunityType?: InputMaybe<Scalars['String']['input']>;
  hasAgeRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeasingRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  hasOccupancyRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  hoaCoversExteriorsAndRoofs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  institutionPurchaseLimit?: InputMaybe<Scalars['Float']['input']>;
  institutionsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isAssociationMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isSignageAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  utilitiesPaidByHoa?: InputMaybe<Scalars['Boolean']['input']>;
};

/** HOA Types */
export enum OdProtosHodorData_HomeownersAssociation_HoaType {
  CONDO_OWNER_ASSOCIATION = 'CONDO_OWNER_ASSOCIATION',
  HOME_OWNER_ASSOCIATION = 'HOME_OWNER_ASSOCIATION',
  LEGAL_AGENCY = 'LEGAL_AGENCY',
  MANAGEMENT_AGENCY = 'MANAGEMENT_AGENCY',
  MASTER_ASSOCIATION = 'MASTER_ASSOCIATION',
  PLANNED_UNIT_DEVELOPMENT = 'PLANNED_UNIT_DEVELOPMENT',
  SUB_HOME_OWNER_ASSOCIATION = 'SUB_HOME_OWNER_ASSOCIATION',
  UNKNOWN_HOA_TYPE = 'UNKNOWN_HOA_TYPE'
}

export type OdProtosHodorServices_AddPropertyToHoa_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHodorServices_CreateHoa_RequestInput = {
  billingAddressUuid?: InputMaybe<Scalars['String']['input']>;
  mailingAddressUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<OdProtosHodorData_HoaRestrictionsInput>;
  type?: InputMaybe<OdProtosHodorData_HomeownersAssociation_HoaType>;
};

export type OdProtosHodorServices_GetHoaInfo_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHodorServices_GetHoasForProperty_RequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHodorServices_RemovePropertyFromHoa_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHodorServices_UpdateHoaContacts_RequestInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  contactRemovals?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUpserts?: InputMaybe<Array<OdProtosHodorData_HoaContactInput>>;
  hoaId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHodorServices_UpdateHoaFees_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']['input']>;
  propertySpecificFeeRemovals?: InputMaybe<Array<Scalars['String']['input']>>;
  propertySpecificFeeUpserts?: InputMaybe<Array<OdProtosHodorData_HoaFeeInput>>;
  standardFeeRemovals?: InputMaybe<Array<Scalars['String']['input']>>;
  standardFeeUpserts?: InputMaybe<Array<OdProtosHodorData_HoaFeeInput>>;
};

export type OdProtosHodorServices_UpdateHoaIsArchived_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHodorServices_UpdateHoaProperty_RequestInput = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  guardContact?: InputMaybe<Scalars['String']['input']>;
  hoaId?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHodorServices_UpdateHoaRestrictions_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<OdProtosHodorData_HoaRestrictionsInput>;
};

export type OdProtosHodorServices_UpdateHoa_RequestInput = {
  billingAddressUuid?: InputMaybe<Scalars['String']['input']>;
  hoaId?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  mailingAddressUuid?: InputMaybe<Scalars['String']['input']>;
  managementAgencyUuid?: InputMaybe<Scalars['String']['input']>;
  masterAssociationUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosHodorData_HomeownersAssociation_HoaType>;
};

export type OdProtosHodorServices_ValidateHoa_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHodorServices_ValidatePropertyHasNoHoa_RequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Records service and user ID (human token rather than username or email which can change).
 * Particularly useful for finding patterns in home detail edits or tracking provenance
 */
export type OdProtosHomeDataStore_ActorInput = {
  systemId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_BatchGetHomeDetailRequestInput = {
  /** List of home detail IDs that would be queried over. */
  homeDetailIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeDataStore_BatchRemovePrimaryAddressForHomeDetailRequestInput = {
  homeDetailIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeDataStore_BatchResolveHomeDetailsRequestInput = {
  resolveHomeDetailsRequests?: InputMaybe<Array<OdProtosHomeDataStore_ResolveHomeDetailsRequestInput>>;
};

export type OdProtosHomeDataStore_BatchResolveProvidedHomeDetailsRequestInput = {
  /** provided_home_detail_requests is a list of homes and their details. Used to bulk resolve multiple homes in a single request */
  providedHomeDetailRequests?: InputMaybe<Array<OdProtosHomeDataStore_ResolveProvidedHomeDetailsRequestInput>>;
};

export type OdProtosHomeDataStore_BatchUnresolvedHomeDetailsRequestInput = {
  unresolvedHomeDetailsRequests?: InputMaybe<Array<OdProtosHomeDataStore_UnresolvedHomeDetailsRequestInput>>;
};

export type OdProtosHomeDataStore_BatchWriteHomeDetailsRequestInput = {
  /**
   * DEPRECATED. Actor information should be included in the home detail created_by field.
   * While teams are migrating, HDS will write this data into the home detail field.
   * Do not populate both actor and home_detail.created_by for any home detail being passed in.
   */
  actor?: InputMaybe<OdProtosHomeDataStore_ActorInput>;
  homeDetails?: InputMaybe<Array<OdProtosHomeDataStore_BatchWriteHomeDetailsRequest_HomeDetailWriteRequestInput>>;
};

export type OdProtosHomeDataStore_BatchWriteHomeDetailsRequest_HomeDetailWriteRequestInput = {
  homeDetail?: InputMaybe<OdProtosHomeDataStore_HomeDetailInput>;
};

export type OdProtosHomeDataStore_GetAllHomeDetailsBySourceRequestInput = {
  /** The maximum number of results to return. If not specified, defaults to 100. */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum timestamp which we want to return home details for this home. Defaults to now. */
  ltTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Source of the home details we want to get. See `home_detail.proto` for explanation. */
  source?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Source>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_GetAllHomeDetailsRequestInput = {
  /** Address token of the home to get all details from. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Timestamp as of which we want to resolve home details for this home. E.g. if we want to get the state of a home
   * in a particular date (without using any newer data) we should set this field.
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeDataStore_GetHomeDetailRequestInput = {
  /**
   * Home Detail ID of a specific Home Detail. This would perform no resolution
   * and would return an immutable detail that was written before.
   */
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * HomeDetail represents a view of a Home attributes. These details could come from one source (e.g. MLS) or be the
 * result of merging with multiple sources.
 *
 * A HomeDetail is uniquely identified by the (source, source_name, source_id, instance_updated_timestamp) tuple.
 *
 * Next ID: 214
 */
export type OdProtosHomeDataStore_HomeDetailInput = {
  /**
   * Square footage of all livable area above ground. Specifically this does not include any square footage from
   * finished basement.
   */
  aboveGradeSqFt?: InputMaybe<Scalars['Float']['input']>;
  additions?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_AdditionInput>>;
  /** Address UUID contains the casa identifier assigned to a specific home. */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** Assessor's parcel number. Unique number assigned by each county Tax Assessor office. */
  apn?: InputMaybe<Scalars['String']['input']>;
  architecturalStyle?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_ArchitecturalStyle>>;
  attractors?: InputMaybe<OdProtosHomeDataStore_HomeDetail_AttractorsInput>;
  backYard?: InputMaybe<OdProtosHomeDataStore_HomeDetail_YardFeaturesInput>;
  /** no_yard, needs_work, partially_landscaped, fully_landscaped */
  backYardCondition?: InputMaybe<Scalars['String']['input']>;
  /** Slope direction relative to the home. */
  backYardSlopeDirection?: InputMaybe<Scalars['String']['input']>;
  /**
   * back yard slope severity
   * slight_slope, substantial_slope, severe_slope, none
   */
  backYardSlopeType?: InputMaybe<Scalars['String']['input']>;
  basementFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_BasementFeaturesInput>;
  /** Square footage of finished basement area. */
  basementFinishedSqFt?: InputMaybe<Scalars['Float']['input']>;
  /** Total square footage of the basement. It includes both finished and unfinished area square footage. */
  basementSqFt?: InputMaybe<Scalars['Float']['input']>;
  /** Square footage of basement that is not considered as livable. */
  basementUnfinishedSqFt?: InputMaybe<Scalars['Float']['input']>;
  /** needs_work, typical_use, great_condition */
  bathroomCondition?: InputMaybe<Scalars['String']['input']>;
  /** repeated for each bathroom */
  bathroomFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_BathroomFeaturesInput>>;
  /** Number of full bathrooms within the home (i.e. a bathroom with toilet, sink and shower/bathtub)/ */
  bathroomsFull?: InputMaybe<Scalars['Float']['input']>;
  /** Number of bathrooms that do not contain a shower or bathtub. These are bathrooms with only a toilet and a sink. */
  bathroomsHalf?: InputMaybe<Scalars['Float']['input']>;
  /** Number of bedrooms present in the Home. */
  bedrooms?: InputMaybe<Scalars['Float']['input']>;
  /** city/urban block in which the property is located if applicable */
  block?: InputMaybe<Scalars['String']['input']>;
  /** Name of the builder of this home. */
  builderName?: InputMaybe<Scalars['String']['input']>;
  /** Number of carport spaces in this home. */
  carportSpaces?: InputMaybe<Scalars['Float']['input']>;
  condition?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ConditionInput>;
  /** Construction materials for a given home */
  constructionMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
  cookingRange?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  coolingFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_CoolingFeature>>;
  /**
   * Records system ID and user ID (human token) for creator of home detail.
   * Particularly useful for finding patterns in home detail edits or tracking provenance.
   */
  createdBy?: InputMaybe<OdProtosHomeDataStore_ActorInput>;
  detractors?: InputMaybe<OdProtosHomeDataStore_HomeDetail_DetractorsInput>;
  diningAreas?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_DiningArea>>;
  dishwasher?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  /**
   * driveway slope direction, relative to the home.
   * no_slope, downhill_slope, uphill_slope
   */
  drivewaySlopeDirection?: InputMaybe<Scalars['String']['input']>;
  /**
   * driveway slope severity
   * slight_slope, substantial_slope, severe_slope, none
   */
  drivewaySlopeType?: InputMaybe<Scalars['String']['input']>;
  /** Dwelling style of a home. (single_story, split-level) */
  dwellingStyle?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dwelling type contains the type of a home. Common values are: single_family, apartment, vacant, multi_family,
   * townhouse, etc. These values should come from DwellingTypeValues.
   */
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  /** Field to provide justification and context on internal Opendoor edits */
  editedFieldFeedback?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_EditedFieldFeedbackInput>>;
  electricUtilityProviders?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_UtilityProviderInput>>;
  /** aluminum, copper, unknown, other */
  electricalWireMaterial?: InputMaybe<Array<Scalars['String']['input']>>;
  /** How you get into the home, either private entrance or some variation of shared. */
  entryType?: InputMaybe<Scalars['String']['input']>;
  /** needs_work, average, like_new */
  exteriorFacadeCondition?: InputMaybe<Scalars['String']['input']>;
  /** Number of stories of this home. */
  exteriorStories?: InputMaybe<Scalars['Float']['input']>;
  facade?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FacadeInput>;
  fenceFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FenceFeature>>;
  fireplaceFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FireplaceFeaturesInput>;
  /** list of flooring materials used for a given home. */
  flooringMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
  /** basement, slab, pier_and_beam */
  foundationType?: InputMaybe<Scalars['String']['input']>;
  frontYard?: InputMaybe<OdProtosHomeDataStore_HomeDetail_YardFeaturesInput>;
  /** no_yard, needs_work, partially_landscaped, fully_landscaped */
  frontYardCondition?: InputMaybe<Scalars['String']['input']>;
  /** Number of parking spots in the home. */
  garageSpaces?: InputMaybe<Scalars['Float']['input']>;
  garbageDisposal?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  gasUtilityProviders?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_UtilityProviderInput>>;
  /** Whether the home has a room addition. */
  hasAddition?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether the home has air conditioning */
  hasAirConditioning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home has asbestos in the walls. */
  hasAsbestosSiding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the yard has a retaining wall */
  hasBackYardRetainingWall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the house has a basement */
  hasBasement?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this home has a community/shared pool */
  hasCommunityPool?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether home has access to a community/shared spa */
  hasCommunitySpa?: InputMaybe<Scalars['Boolean']['input']>;
  hasCrawlspace?: InputMaybe<Scalars['Boolean']['input']>;
  /** A room that could be used as a den/office/library */
  hasDen?: InputMaybe<Scalars['Boolean']['input']>;
  hasExteriorBalcony?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home has fire damage, now or in the past. */
  hasFireDamage?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether the home has a fireplace */
  hasFireplace?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home has a garage converted into a room. */
  hasGarageConversion?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether or not the gated community has a guard or not.
   * 2/1/2021 - We are going to start buying homes that are in a guarded gated community this week.
   */
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the lot has been contaminated in the past (e.g., gas tank leak). */
  hasHistoryOfChemicalContamination?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether horse features exist for a home */
  hasHorses?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncomeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home has known foundation issues. */
  hasKnownFoundationIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hasLakeView?: InputMaybe<Scalars['Boolean']['input']>;
  hasMountainView?: InputMaybe<Scalars['Boolean']['input']>;
  hasNewRoof?: InputMaybe<Scalars['Boolean']['input']>;
  hasNewWindows?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether the home has a nice backyard */
  hasNiceBackyard?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether the home has a nice curb appeal */
  hasNiceCurbAppeal?: InputMaybe<Scalars['Boolean']['input']>;
  hasOceanView?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenFloorPlan?: InputMaybe<Scalars['Boolean']['input']>;
  hasPlantationShutters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this home has a private pool or not. */
  hasPrivatePool?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether home has a private spa */
  hasPrivateSpa?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether its a resort style home */
  hasResortStyle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home has a septic tank. */
  hasSeptic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home has or is in a sinkhole (cracked bedrock, source of foundation issues). */
  hasSinkhole?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home has solar panels. */
  hasSolarPanels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether master bedroom is separated from rest of house */
  hasSplitMasterBedroom?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether the home has upgrades */
  hasUpgrades?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the house has a vaulted/raised ceiling */
  hasVaultedCeiling?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalkInCloset?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home has/pumps its water from a well. */
  hasWellWater?: InputMaybe<Scalars['Boolean']['input']>;
  heatingFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_HeatingFeature>>;
  /**
   * First HOA associated with this home.
   *
   * Deprecated: Use field `hoas` instead.
   */
  hoa?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HoaInput>;
  /** HOAs associated with this home. */
  hoas?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_HoaInput>>;
  /** Unique identifier of this HomeDetail. It should be filled by Home Data Store. */
  homeDetailId: Scalars['ID']['input'];
  hvacSystems?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_HvacSystemInput>>;
  /**
   * Estimated name of subdivision based on location
   * Deprecated: Use dwellings geo_details table instead
   */
  imputedSubdivision?: InputMaybe<Scalars['String']['input']>;
  /**
   * When we have multiple instances of the source, Instance_Updated_Timestamp contains when each instance becomes valid.
   * E.g MLS - instance_updated_timestamp may not be populated because there's only 1 listing. Default value will be set.
   * E.g Tax accessor - instance_updated_timestamp would be the tax year when the update became valid. (i.e TAX_YEAR_ASSESSED)
   * Moving forward this will be used to uniquely identify a home detail along with source information.
   * The timestamp resolution order for sorting would be instance_updated_timestamp > source_timestamp > timestamp
   */
  instanceUpdatedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** needs_work, typical_use, great_condition */
  interiorPaintCondition?: InputMaybe<Scalars['String']['input']>;
  /** Number of interior stories of this home (differs from exterior_stories e.g. for mid/highrises & basements). */
  interiorStories?: InputMaybe<Scalars['Float']['input']>;
  /** Must be null unless has_addition is true */
  isAdditionPermitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home is in an elderly community. */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the carport attached to the home? */
  isCarportAttached?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the Garage attached to the home? */
  isGarageAttached?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home is in a gated community. */
  isGatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home is zoned for horses or other livestock. */
  isZonedForLivestock?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Primary appliance material (main kitchen)
   * stainless_steel, black, white, mixed
   */
  kitchenApplianceType?: InputMaybe<Scalars['String']['input']>;
  /** needs_work, typical_use, great_condition */
  kitchenCondition?: InputMaybe<Scalars['String']['input']>;
  /** granite_slab, granite_tile, other_tile, corian, formica, quartz */
  kitchenCountertop?: InputMaybe<Scalars['String']['input']>;
  kitchenFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_KitchenFeaturesInput>;
  /** never, less_than_5_years_ago, 5_to_10_years_ago, more_than_10_years_ago */
  kitchenRemodel?: InputMaybe<Scalars['String']['input']>;
  /** landscaping attributes of a home. Intended to replace repeated string field landscaping_features */
  landscaping?: InputMaybe<OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput>;
  /** Landscaping features for a given home */
  landscapingFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Date when renovation was completed. */
  lastRenovatedDate?: InputMaybe<OdProtosCommon_DateInput>;
  laundryFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_LaundryFeaturesInput>;
  lotFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_LotFeaturesInput>;
  /** the individual lot number of the property as used in the Lot and Block survey system */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Square footage of the lot where the home sits. */
  lotSqFt?: InputMaybe<Scalars['Float']['input']>;
  masterBathroomFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_BathroomFeature>>;
  /** never, less_than_5_years_ago, 5_to_10_years_ago, more_than_10_years_ago */
  masterBathroomRemodel?: InputMaybe<Scalars['String']['input']>;
  /** entry_level, first_floor, second_floor, third_floor, basement */
  masterBedroomFloor?: InputMaybe<Scalars['String']['input']>;
  microwave?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  nearCommunityPark?: InputMaybe<Scalars['Boolean']['input']>;
  nearGolfCourse?: InputMaybe<Scalars['Boolean']['input']>;
  nearestHighwayPrimary?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestHighwaySecondary?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestHighwayTertiary?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestMotorway?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestMotorwayLink?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestTrunk?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestTrunkLink?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  /** # of fireplaces in the home */
  numFireplaces?: InputMaybe<Scalars['Float']['input']>;
  /** Rooms that do not require additional features. Simply designates existence of a room. */
  otherRooms?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_OtherRoom>>;
  outdoorSpaces?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_OutdoorSpaceInput>>;
  /** ownership type, e.g. fee_simple, leasehold, condominium, timeshare, coop */
  ownership?: InputMaybe<Scalars['String']['input']>;
  /** all_neutral, no_neutral, mix_mostly_neutral, mix_mostly_not_neutral */
  paintNeutral?: InputMaybe<Scalars['String']['input']>;
  parkingFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_ParkingFeature>>;
  /** Name of the buildable plan this home represents e.g. Hawthorne */
  planName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Number of available specs(lots) for this new construction plan
   * NOTE: New construction "homes" actually represent plans for a home.
   */
  planSpecCount?: InputMaybe<Scalars['Float']['input']>;
  poolFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Flooring that covers the majority of the house */
  primaryFlooring?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringInput>;
  /** Primary Owner of this home as of timestamp. */
  primaryOwner?: InputMaybe<Scalars['String']['input']>;
  /** Primary Owner type of this home. Common values are np, unknown, company, individual */
  primaryOwnerType?: InputMaybe<Scalars['String']['input']>;
  refrigerator?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  roof?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoofInput>;
  /** Roof materials of a home. */
  roofMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Map from room name to flooring */
  roomFloorings?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput>>;
  roomfeatureCarport?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureDeck?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureDen?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  /**
   * Top-level room field to be applied to rooms with specific and agreed upon locations.
   * There should be no ambiguity for a room location: e.g. master bedroom vs bedroom1, bedroom2
   * These fields are populated during Opendoor walkthroughs
   */
  roomfeatureDiningRoom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureEntry?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureFamilyRoom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureGarage?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureKitchen?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureLaundry?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureLivingRoom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureLoft?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureMasterBathroom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureMasterBedroom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureMasterCloset?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureOffice?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeaturePorch?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureUnfinishedBasement?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  /**
   * Deprecated, use top-level fields for available rooms (e.g. family_room)
   * Remaining ambiguous rooms can continue to be listed here
   * Ex. bedroom (non-master), bathroom (non-master), hallway, closet, storage
   */
  rooms?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_RoomInput>>;
  /** Name of elementary school district this address is in */
  schoolDistrictElementary?: InputMaybe<Scalars['String']['input']>;
  /** Name of high school district this address is in */
  schoolDistrictHigh?: InputMaybe<Scalars['String']['input']>;
  /** Name of individual elementary school this address attends */
  schoolElementary?: InputMaybe<Scalars['String']['input']>;
  /** Name of individual high school this address attends */
  schoolHigh?: InputMaybe<Scalars['String']['input']>;
  /** Name of individual middle / jr. high school this address attends */
  schoolMiddle?: InputMaybe<Scalars['String']['input']>;
  /** Flooring that covers other parts of the house */
  secondaryFlooring?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringInput>;
  /**
   * Whether this home has a private pool or not.
   * Secondary Owner of this home as of timestamp.
   */
  secondaryOwner?: InputMaybe<Scalars['String']['input']>;
  /** Secondary Owner type of this home. Common values are np, unknown, company, individual */
  secondaryOwnerType?: InputMaybe<Scalars['String']['input']>;
  /** cast_iron, pvc, vinyl_abs, unknown, other */
  sewerPipeMaterial?: InputMaybe<Array<Scalars['String']['input']>>;
  /** public, private, septic */
  sewerType?: InputMaybe<Scalars['String']['input']>;
  sewerUtilityProviders?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_UtilityProviderInput>>;
  /** Must be null unless has_solar_panels is true; options are leased, owned */
  solarPanelsOwnership?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Source>;
  /**
   * Source ID refers to the ID associated to this Home Detail in the Source data source. This is very
   * useful for debugging purposes and together with address_id, timestamp, source and souce_name can uniquely
   * identify a HomeDetail.
   */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /**
   * A more fine-grain description of the source. Not required to be set, but it is used for primary key of this home
   * detail. A common use case is the name of the MLS from where this detail came from, e.g. "armls".
   */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** Arbitrary source specific detail. There are no guarantees that this will be filled and should be used for experimental data that could be moved to the main proto. */
  sourceSpecificDetail?: InputMaybe<GoogleProtobuf_AnyInput>;
  /**
   * Source_Timestamp contains when a home detail has become valid from the source.
   * E.g MLS - source_timestamp is when the listing was listed (list_date)
   * E.g Tax accessor - source_timestamp maybe not filled in but if it was it'd be when the data was published to county tax (i.e. ASSR_LAST_UPDATED)
   */
  sourceTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Spa features for a home. */
  spaFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  standaloneOven?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  standaloneStovetop?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  /** general, exterior, none */
  stormShelterType?: InputMaybe<Scalars['String']['input']>;
  /** Name of subdivision. */
  subdivision?: InputMaybe<Scalars['String']['input']>;
  /** ID of subdivision, unique for a given builder */
  subdivisionId?: InputMaybe<Scalars['String']['input']>;
  /** Number of available new construction plans in subdivision */
  subdivisionPlanCount?: InputMaybe<Scalars['Float']['input']>;
  /** cpvc, pvc, polybutylene, copper, galvanized, pex, unknown, other */
  supplyPipeMaterial?: InputMaybe<Array<Scalars['String']['input']>>;
  /** the legal description for the property provided on the title commitment and included in tax records */
  taxLegalDescription?: InputMaybe<Scalars['String']['input']>;
  /** calendar year for property tax */
  taxYear?: InputMaybe<Scalars['Float']['input']>;
  /** annual property tax amount */
  taxes?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Timestamp contains when a home detail has been updated. This is a required field.
   * E.g MLS - timestamp is when the listing was updated (mod_timestamp)
   * E.g Tax accessor - timestamp is when the data was updated (i.e PUBLICATION_DATE)
   */
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Square footage of all livable area including finished basement sqft. */
  totalLivingSqFt?: InputMaybe<Scalars['Float']['input']>;
  /** Number of units in multi_family homes */
  units?: InputMaybe<Scalars['Float']['input']>;
  /** Field if providers cannot be split into categories (limitation of data sources like MLS) */
  utilityProviders?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of water heaters installed at the home */
  waterHeaters?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_WaterHeaterInput>>;
  waterUtilityProviders?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_UtilityProviderInput>>;
  yards?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_YardInput>>;
  /** Year at which this home got built. */
  yearBuilt?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosHomeDataStore_HomeDetailWriteRequestInput = {
  /**
   * DEPRECATED. Actor information should be included in the home detail created_by field.
   * While teams are migrating, we will write this data into the home detail field.
   * Do not populate both actor and home_detail.created_by
   */
  actor?: InputMaybe<OdProtosHomeDataStore_ActorInput>;
  /** The home detail to be written. Address UUID, source information, and timestamp are required. */
  homeDetail?: InputMaybe<OdProtosHomeDataStore_HomeDetailInput>;
  /**
   * Require the home detail in the request to have a newer or equal timestamp to the existing home detail.
   * If there is no existing home detail for this source, or the existing home detail is older, write successfully.
   */
  validateGteTimestamp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_AdditionInput = {
  /** Does the addition have hvac */
  additionHvac?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Addition_AdditionHvac>;
  /** the sqft of the addition */
  additionSqFt?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Type of addition.  possible values: attic_conversion, garage_conversion,
   * master_suite_addition, screen_porch, sun_room, other
   */
  additionType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Build quality of the addition relative to the original structure.
   * Possible values: inferior_to_original_structure, same_as_original_structure,
   * superior_to_original_structure.
   */
  buildQuality?: InputMaybe<Scalars['String']['input']>;
  /**
   * True if the addition is permitted, false if it is known to be un-permitted,
   * null if unknown.
   */
  isPermitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the addition is up to code, false if it not up to code. */
  isUpToCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_Addition_AdditionHvac {
  FULL_HVAC = 'FULL_HVAC',
  HEATED_ONLY = 'HEATED_ONLY',
  HVAC_OTHER = 'HVAC_OTHER',
  HVAC_UNKNOWN = 'HVAC_UNKNOWN',
  NO_HEATING_OR_COOLING = 'NO_HEATING_OR_COOLING'
}

export type OdProtosHomeDataStore_HomeDetail_ApplianceInput = {
  /** needs_work, typical_use, great_condition */
  condition?: InputMaybe<Scalars['String']['input']>;
  /** gas, electric */
  energyType?: InputMaybe<Scalars['String']['input']>;
  /** Designates the existence of the appliance. nil value == unknown. */
  hasAppliance?: InputMaybe<Scalars['Boolean']['input']>;
  /** stainless_steel, black, white */
  materialType?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_ArchitecturalStyle {
  ARCH_STYLE_A_FRAME = 'ARCH_STYLE_A_FRAME',
  ARCH_STYLE_CAPE_COD = 'ARCH_STYLE_CAPE_COD',
  ARCH_STYLE_COLONIAL = 'ARCH_STYLE_COLONIAL',
  ARCH_STYLE_CONTEMPORARY = 'ARCH_STYLE_CONTEMPORARY',
  ARCH_STYLE_MEDITERRANEAN = 'ARCH_STYLE_MEDITERRANEAN',
  ARCH_STYLE_RANCH = 'ARCH_STYLE_RANCH',
  ARCH_STYLE_SPLIT_LEVEL = 'ARCH_STYLE_SPLIT_LEVEL',
  ARCH_STYLE_UNKNOWN = 'ARCH_STYLE_UNKNOWN'
}

/**
 * Attractors for a home. Oftentimes these are attributes of the home's surroundings that make it more attractive to buyers.
 * Float values should be between 0 and 1
 * 0 means the home does not have the attribute (e.g. it's not near a golf course at all)
 * 1 means the home is strongly correlated with the attribute (e.g. it's right on the golf course)
 * values between 0 and 1 represent the strength of the correlation (e.g. 0.5 if the home is somewhat near a golf course)
 */
export type OdProtosHomeDataStore_HomeDetail_AttractorsInput = {
  coveredPatio?: InputMaybe<Scalars['Float']['input']>;
  coveredPorch?: InputMaybe<Scalars['Float']['input']>;
  culDeSac?: InputMaybe<Scalars['Float']['input']>;
  golfLot?: InputMaybe<Scalars['Float']['input']>;
  lakeLot?: InputMaybe<Scalars['Float']['input']>;
  otherAttractors?: InputMaybe<Scalars['Float']['input']>;
  otherAttractorsReason?: InputMaybe<Scalars['String']['input']>;
  parkGreenLot?: InputMaybe<Scalars['Float']['input']>;
  views?: InputMaybe<Scalars['Float']['input']>;
  yardLandscaping?: InputMaybe<Scalars['Float']['input']>;
};

/** Basement features of a home. Common values are: finished, unfinished, crawl_space, egress, partially_finished etc */
export type OdProtosHomeDataStore_HomeDetail_BasementFeaturesInput = {
  /** is it a daylight basement */
  daylight?: InputMaybe<Scalars['Boolean']['input']>;
  /** 10/24: Trying to avoid using repeated strings in general, extend this struct instead moving forward. */
  feature?: InputMaybe<Array<Scalars['String']['input']>>;
  /** basement finish status */
  finishStatus?: InputMaybe<OdProtosHomeDataStore_HomeDetail_BasementFinishStatus>;
  /** whether the basement has HVAC */
  hasHvac?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_BasementFinishStatus {
  FINISH_STATUS_FINISHED = 'FINISH_STATUS_FINISHED',
  FINISH_STATUS_PARTIALLY_FINISHED = 'FINISH_STATUS_PARTIALLY_FINISHED',
  FINISH_STATUS_UNFINISHED = 'FINISH_STATUS_UNFINISHED',
  FINISH_STATUS_UNKNOWN = 'FINISH_STATUS_UNKNOWN'
}

export enum OdProtosHomeDataStore_HomeDetail_BathroomFeature {
  BATHROOM_3_4_SHOWER_ONLY = 'BATHROOM_3_4_SHOWER_ONLY',
  BATHROOM_3_4_TUB_ONLY = 'BATHROOM_3_4_TUB_ONLY',
  BATHROOM_BIDET = 'BATHROOM_BIDET',
  BATHROOM_DOUBLE_SINK = 'BATHROOM_DOUBLE_SINK',
  BATHROOM_DUAL_BATHROOMS = 'BATHROOM_DUAL_BATHROOMS',
  BATHROOM_FULL_BATH = 'BATHROOM_FULL_BATH',
  BATHROOM_GRANITE_COUNTERTOPS = 'BATHROOM_GRANITE_COUNTERTOPS',
  BATHROOM_HALF = 'BATHROOM_HALF',
  BATHROOM_JETTED_TUB = 'BATHROOM_JETTED_TUB',
  BATHROOM_NONE = 'BATHROOM_NONE',
  BATHROOM_NO_MAIN_BATHROOM = 'BATHROOM_NO_MAIN_BATHROOM',
  BATHROOM_OTHER = 'BATHROOM_OTHER',
  BATHROOM_PRIVATE_TOILET = 'BATHROOM_PRIVATE_TOILET',
  BATHROOM_SAUNA = 'BATHROOM_SAUNA',
  BATHROOM_SEPARATE_SHOWER_TUB = 'BATHROOM_SEPARATE_SHOWER_TUB',
  BATHROOM_SHOWER_TUB_COMBO = 'BATHROOM_SHOWER_TUB_COMBO',
  BATHROOM_SKYLIGHTS = 'BATHROOM_SKYLIGHTS',
  BATHROOM_SOAKING_TUB = 'BATHROOM_SOAKING_TUB',
  BATHROOM_UNKNOWN = 'BATHROOM_UNKNOWN',
  BATHROOM_WALK_IN_CLOSETS = 'BATHROOM_WALK_IN_CLOSETS'
}

export type OdProtosHomeDataStore_HomeDetail_BathroomFeaturesInput = {
  /** full_bath, three_quarter_bath, half_bath, quarter_bath */
  bathroomType?: InputMaybe<Scalars['String']['input']>;
  doubleSink?: InputMaybe<Scalars['Boolean']['input']>;
  graniteCountertops?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated as never filled, please use master_bathroom_features instead */
  isMasterBathroom?: InputMaybe<Scalars['Boolean']['input']>;
  separateShowerTub?: InputMaybe<Scalars['Boolean']['input']>;
  tileSurround?: InputMaybe<Scalars['Boolean']['input']>;
  updatedTileFloors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_ConditionInput = {
  /** no_yard, needs_work, partially_landscaped, fully_landscaped */
  backYardCondition?: InputMaybe<Scalars['String']['input']>;
  bathroom?: InputMaybe<Scalars['Float']['input']>;
  /** needs_work, typical_use, great_condition */
  bathroomCondition?: InputMaybe<Scalars['String']['input']>;
  exterior?: InputMaybe<Scalars['Float']['input']>;
  /** needs_work, average, like_new */
  exteriorFacadeCondition?: InputMaybe<Scalars['String']['input']>;
  /** flag to describe if home needs fixes/repairs */
  fixUpNeedsRepair?: InputMaybe<Scalars['Boolean']['input']>;
  /** no_yard, needs_work, partially_landscaped, fully_landscaped */
  frontYardCondition?: InputMaybe<Scalars['String']['input']>;
  interior?: InputMaybe<Scalars['Float']['input']>;
  /** needs_work, typical_use, great_condition */
  interiorPaintCondition?: InputMaybe<Scalars['String']['input']>;
  kitchen?: InputMaybe<Scalars['Float']['input']>;
  /** needs_work, typical_use, great_condition */
  kitchenCondition?: InputMaybe<Scalars['String']['input']>;
  /** Condition scores are a float between 0 and 1, where 0 is an unlivable disaster and 1 is brand new. */
  property?: InputMaybe<Scalars['Float']['input']>;
};

/** Next Room Id: 20 */
export enum OdProtosHomeDataStore_HomeDetail_CoolingFeature {
  COOLING_AIR_CONDITION = 'COOLING_AIR_CONDITION',
  COOLING_ATTIC_FAN = 'COOLING_ATTIC_FAN',
  COOLING_CENTRAL = 'COOLING_CENTRAL',
  COOLING_CENTRAL_ELECTRIC = 'COOLING_CENTRAL_ELECTRIC',
  COOLING_CENTRAL_GAS = 'COOLING_CENTRAL_GAS',
  COOLING_DUAL = 'COOLING_DUAL',
  COOLING_ELECTRIC = 'COOLING_ELECTRIC',
  COOLING_ENERGY_STAR = 'COOLING_ENERGY_STAR',
  COOLING_EVAPORATIVE_COOLER = 'COOLING_EVAPORATIVE_COOLER',
  COOLING_FAN = 'COOLING_FAN',
  COOLING_GAS = 'COOLING_GAS',
  COOLING_GEOTHERMAL = 'COOLING_GEOTHERMAL',
  COOLING_HEAT_PUMP = 'COOLING_HEAT_PUMP',
  COOLING_HIGH_EFFICIENCY = 'COOLING_HIGH_EFFICIENCY',
  COOLING_MINI_SPLIT = 'COOLING_MINI_SPLIT',
  COOLING_MUTLI_UNITS = 'COOLING_MUTLI_UNITS',
  COOLING_NONE = 'COOLING_NONE',
  COOLING_OTHER = 'COOLING_OTHER',
  COOLING_PROGRAMMABLE_THERMOSTAT = 'COOLING_PROGRAMMABLE_THERMOSTAT',
  COOLING_REFRIGERATION = 'COOLING_REFRIGERATION',
  COOLING_UNKNOWN = 'COOLING_UNKNOWN',
  COOLING_WALL_UNIT = 'COOLING_WALL_UNIT',
  COOLING_WHOLE_HOUSE_FAN = 'COOLING_WHOLE_HOUSE_FAN',
  COOLING_WINDOW_UNIT = 'COOLING_WINDOW_UNIT',
  COOLING_ZONED = 'COOLING_ZONED'
}

/**
 * Detractors for a home. Oftentimes these are attributes of the home's surroundings that make it less attractive to buyers.
 * Float values should be between 0 and 1
 * 0 means the home does not have the attribute (e.g. it's not near a a busy road at all)
 * 1 means the home is strongly correlated with the attribute (e.g. it's right on a busy road)
 * values between 0 and 1 represent the strength of the correlation (e.g. 0.5 if the home is somewhat near a busy road)
 */
export type OdProtosHomeDataStore_HomeDetail_DetractorsInput = {
  busyRoadArterialConnector?: InputMaybe<Scalars['Float']['input']>;
  busyRoadFreewayHighway?: InputMaybe<Scalars['Float']['input']>;
  busyRoadMainWithSubdivision?: InputMaybe<Scalars['Float']['input']>;
  neighborsCommercial?: InputMaybe<Scalars['Float']['input']>;
  neighborsIndustrial?: InputMaybe<Scalars['Float']['input']>;
  neighborsMultiFamily?: InputMaybe<Scalars['Float']['input']>;
  neighborsSchool?: InputMaybe<Scalars['Float']['input']>;
  otherDetractors?: InputMaybe<Scalars['Float']['input']>;
  otherDetractorsReason?: InputMaybe<Scalars['String']['input']>;
  powerHighVoltageTower?: InputMaybe<Scalars['Float']['input']>;
  powerHighVoltageWire?: InputMaybe<Scalars['Float']['input']>;
  powerLowVoltagePowerline?: InputMaybe<Scalars['Float']['input']>;
  powerSubstation?: InputMaybe<Scalars['Float']['input']>;
  railroad?: InputMaybe<Scalars['Float']['input']>;
  slopedBackyard?: InputMaybe<Scalars['Float']['input']>;
  slopedDriveway?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_DiningArea {
  DINING_BREAKFAST_AREA = 'DINING_BREAKFAST_AREA',
  DINING_BREAKFAST_BAR = 'DINING_BREAKFAST_BAR',
  DINING_EAT_IN_KITCHEN = 'DINING_EAT_IN_KITCHEN',
  DINING_FAMILY_COMBO = 'DINING_FAMILY_COMBO',
  DINING_FORMAL = 'DINING_FORMAL',
  DINING_FRONT_ROOM = 'DINING_FRONT_ROOM',
  DINING_KITCHEN_COMBO = 'DINING_KITCHEN_COMBO',
  DINING_LIVING_COMBO = 'DINING_LIVING_COMBO',
  DINING_L_SHAPED = 'DINING_L_SHAPED',
  DINING_NONE = 'DINING_NONE',
  DINING_OTHER = 'DINING_OTHER',
  DINING_UNKNOWN = 'DINING_UNKNOWN'
}

export enum OdProtosHomeDataStore_HomeDetail_DwellingTypeValues {
  APARTMENT = 'APARTMENT',
  CHURCH = 'CHURCH',
  COMMERCIAL = 'COMMERCIAL',
  COOP = 'COOP',
  FARM = 'FARM',
  HALF_DUPLEX = 'HALF_DUPLEX',
  HOTEL = 'HOTEL',
  INDUSTRIAL = 'INDUSTRIAL',
  MANUFACTURED = 'MANUFACTURED',
  MIXED = 'MIXED',
  MOBILE_HOME = 'MOBILE_HOME',
  MULTI_FAMILY = 'MULTI_FAMILY',
  OFFICE = 'OFFICE',
  OTHER = 'OTHER',
  RETAIL = 'RETAIL',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
  SPECIAL_PURPOSE = 'SPECIAL_PURPOSE',
  TENANCY_IN_COMMON = 'TENANCY_IN_COMMON',
  TOWNHOUSE = 'TOWNHOUSE',
  UNKNOWN_DWELLING_TYPE = 'UNKNOWN_DWELLING_TYPE',
  VACANT = 'VACANT',
  WAREHOUSE = 'WAREHOUSE'
}

export type OdProtosHomeDataStore_HomeDetail_EditedFieldFeedbackInput = {
  /** structured sources, e.g. "mls", "floor_plan", "tax_data" */
  dataSource?: InputMaybe<Scalars['String']['input']>;
  /** free form notes and justification for an edit */
  editContext?: InputMaybe<Scalars['String']['input']>;
  /** structured reason codes for editing, e.g. "previous_edit_incorrect", "new_source_available" */
  editReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** home detail field that was edited */
  fieldKey?: InputMaybe<Scalars['String']['input']>;
};

/** Facade / siding */
export type OdProtosHomeDataStore_HomeDetail_FacadeInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  /** brick, composite, stucco, vinyl, wood, other */
  material?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Fence structures and materials */
export enum OdProtosHomeDataStore_HomeDetail_FenceFeature {
  FENCE_ALUMINUM = 'FENCE_ALUMINUM',
  FENCE_BACK_YARD = 'FENCE_BACK_YARD',
  FENCE_BARBED_WIRE = 'FENCE_BARBED_WIRE',
  FENCE_BLOCK = 'FENCE_BLOCK',
  FENCE_BRICK = 'FENCE_BRICK',
  FENCE_CHAIN_LINK = 'FENCE_CHAIN_LINK',
  FENCE_CROSS_FENCED = 'FENCE_CROSS_FENCED',
  FENCE_FRONT_YARD = 'FENCE_FRONT_YARD',
  FENCE_FULLY_FENCED = 'FENCE_FULLY_FENCED',
  FENCE_METAL = 'FENCE_METAL',
  FENCE_NONE = 'FENCE_NONE',
  FENCE_OTHER = 'FENCE_OTHER',
  FENCE_PARTIAL = 'FENCE_PARTIAL',
  FENCE_PRIVACY = 'FENCE_PRIVACY',
  FENCE_STONE = 'FENCE_STONE',
  FENCE_UNKNOWN = 'FENCE_UNKNOWN',
  FENCE_VINYL = 'FENCE_VINYL',
  FENCE_WIRE = 'FENCE_WIRE',
  FENCE_WOOD = 'FENCE_WOOD',
  FENCE_WROUGHT_IRON = 'FENCE_WROUGHT_IRON'
}

export type OdProtosHomeDataStore_HomeDetail_FenceInput = {
  fenceMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OdProtosHomeDataStore_HomeDetail_FireplaceFeature {
  FIREPLACE_BRICK = 'FIREPLACE_BRICK',
  FIREPLACE_DECORATIVE = 'FIREPLACE_DECORATIVE',
  FIREPLACE_ELECTRIC = 'FIREPLACE_ELECTRIC',
  FIREPLACE_FIREPIT = 'FIREPLACE_FIREPIT',
  FIREPLACE_FREE_STANDING = 'FIREPLACE_FREE_STANDING',
  FIREPLACE_GAS = 'FIREPLACE_GAS',
  FIREPLACE_GAS_LOG = 'FIREPLACE_GAS_LOG',
  FIREPLACE_GAS_STARTER = 'FIREPLACE_GAS_STARTER',
  FIREPLACE_INSERT = 'FIREPLACE_INSERT',
  FIREPLACE_NONE = 'FIREPLACE_NONE',
  FIREPLACE_OTHER = 'FIREPLACE_OTHER',
  FIREPLACE_PELLET_STOVE = 'FIREPLACE_PELLET_STOVE',
  FIREPLACE_TWO_WAY = 'FIREPLACE_TWO_WAY',
  FIREPLACE_UNKNOWN = 'FIREPLACE_UNKNOWN',
  FIREPLACE_WOOD = 'FIREPLACE_WOOD',
  FIREPLACE_WOOD_BURNING_STOVE = 'FIREPLACE_WOOD_BURNING_STOVE'
}

export type OdProtosHomeDataStore_HomeDetail_FireplaceFeaturesInput = {
  features?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FireplaceFeature>>;
  locations?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_Location>>;
};

export type OdProtosHomeDataStore_HomeDetail_FireplaceInput = {
  /** gas, electric, wood_burning */
  fireplaceType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_FlooringInput = {
  /** heavily_worn, typical_use, great_condition */
  condition?: InputMaybe<Scalars['String']['input']>;
  flooringMaterial?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringMaterial>;
  lengthFeet?: InputMaybe<Scalars['Float']['input']>;
  /** tile, laminate, hardwood, carpet, other */
  material?: InputMaybe<Scalars['String']['input']>;
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  widthFeet?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_FlooringMaterial {
  FLOORING_BAMBOO = 'FLOORING_BAMBOO',
  FLOORING_BRICK = 'FLOORING_BRICK',
  FLOORING_CARPET = 'FLOORING_CARPET',
  FLOORING_CONCRETE = 'FLOORING_CONCRETE',
  FLOORING_CORK = 'FLOORING_CORK',
  FLOORING_ENGINEERED_HARDWOOD = 'FLOORING_ENGINEERED_HARDWOOD',
  FLOORING_ENGINEERED_WOOD = 'FLOORING_ENGINEERED_WOOD',
  FLOORING_GRANITE = 'FLOORING_GRANITE',
  FLOORING_HARDWOOD = 'FLOORING_HARDWOOD',
  FLOORING_LAMINATE = 'FLOORING_LAMINATE',
  FLOORING_LINOLEUM = 'FLOORING_LINOLEUM',
  FLOORING_LUXURY_VINYL_PLANK = 'FLOORING_LUXURY_VINYL_PLANK',
  FLOORING_MARBLE = 'FLOORING_MARBLE',
  FLOORING_OTHER = 'FLOORING_OTHER',
  FLOORING_PAINTED = 'FLOORING_PAINTED',
  FLOORING_PARQUET = 'FLOORING_PARQUET',
  FLOORING_PAVERS = 'FLOORING_PAVERS',
  FLOORING_SALTILLO_TILE = 'FLOORING_SALTILLO_TILE',
  FLOORING_SLATE = 'FLOORING_SLATE',
  FLOORING_STAMPED = 'FLOORING_STAMPED',
  FLOORING_STONE = 'FLOORING_STONE',
  FLOORING_TERRAZZO = 'FLOORING_TERRAZZO',
  FLOORING_TILE = 'FLOORING_TILE',
  FLOORING_TRAVERTINE = 'FLOORING_TRAVERTINE',
  FLOORING_UNKNOWN = 'FLOORING_UNKNOWN',
  FLOORING_VINYL = 'FLOORING_VINYL',
  FLOORING_WOOD = 'FLOORING_WOOD'
}

/** Next Room Id: 20 */
export enum OdProtosHomeDataStore_HomeDetail_HeatingFeature {
  HEATING_BASEBOARD = 'HEATING_BASEBOARD',
  HEATING_BOILER = 'HEATING_BOILER',
  HEATING_CEILING = 'HEATING_CEILING',
  HEATING_CENTRAL = 'HEATING_CENTRAL',
  HEATING_ELECTRIC = 'HEATING_ELECTRIC',
  HEATING_FIREPLACE = 'HEATING_FIREPLACE',
  HEATING_FLOOR_FURNACE = 'HEATING_FLOOR_FURNACE',
  HEATING_GAS = 'HEATING_GAS',
  HEATING_GEOTHERMAL = 'HEATING_GEOTHERMAL',
  HEATING_HEAT_PUMP = 'HEATING_HEAT_PUMP',
  HEATING_HIGH_EFFICIENCY = 'HEATING_HIGH_EFFICIENCY',
  HEATING_HOT_WATER = 'HEATING_HOT_WATER',
  HEATING_MINI_SPLIT = 'HEATING_MINI_SPLIT',
  HEATING_NONE = 'HEATING_NONE',
  HEATING_OIL = 'HEATING_OIL',
  HEATING_OTHER = 'HEATING_OTHER',
  HEATING_PROPANE = 'HEATING_PROPANE',
  HEATING_RADIANT = 'HEATING_RADIANT',
  HEATING_SOLAR = 'HEATING_SOLAR',
  HEATING_STEAM = 'HEATING_STEAM',
  HEATING_UNKNOWN = 'HEATING_UNKNOWN',
  HEATING_WALL_FURNACE = 'HEATING_WALL_FURNACE',
  HEATING_WALL_UNIT = 'HEATING_WALL_UNIT',
  HEATING_WOOD = 'HEATING_WOOD',
  HEATING_ZONED = 'HEATING_ZONED'
}

/** Home Owner's Association data. */
export type OdProtosHomeDataStore_HomeDetail_HoaInput = {
  /** Managing agency name. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_Hoa_ContactInput>>;
  /** Fee to be paid to the HOA. Usually a recurring fee as specified by fee_frequency. */
  fee?: InputMaybe<OdProtosCommon_MoneyInput>;
  feeFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Optional maximum HOA fee. */
  feeMaximum?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Optional minimum HOA fee. */
  feeMinimum?: InputMaybe<OdProtosCommon_MoneyInput>;
  feeType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Hoa_HoaFeeType>;
  /** Whether the HOA has leasing restrictions. */
  hasLeasingRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  hoaType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Hoa_HoaType>;
  /** What is included with the HOA fees. */
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Law firm name. */
  lawFirmName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the HOA. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rules of the HOA. */
  rules?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_Hoa_ContactInput = {
  address?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Hoa_Contact_AddressInput>;
  businessPhone?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
  email?: InputMaybe<OdProtosCommon_EmailAddressInput>;
  mobilePhone?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Hoa_Contact_Type>;
};

export type OdProtosHomeDataStore_HomeDetail_Hoa_Contact_AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_Hoa_Contact_Type {
  ATTORNEY = 'ATTORNEY',
  MANAGING_AGENCY = 'MANAGING_AGENCY',
  OWNERS_ASSOCIATION = 'OWNERS_ASSOCIATION',
  UNKNOWN = 'UNKNOWN'
}

/** Type of association fee. */
export enum OdProtosHomeDataStore_HomeDetail_Hoa_HoaFeeType {
  AMENTITY_FEE = 'AMENTITY_FEE',
  BUILDING_MAINTAINENCE_FEE = 'BUILDING_MAINTAINENCE_FEE',
  COMMUNITY_MASTER_HOME_OWNER_FEE = 'COMMUNITY_MASTER_HOME_OWNER_FEE',
  FEE_CAPITAL_IMPROVEMENTS_FEE = 'FEE_CAPITAL_IMPROVEMENTS_FEE',
  HOME_OWNER_ASSESSMENTS_FEE = 'HOME_OWNER_ASSESSMENTS_FEE',
  HOME_OWNER_TRANSFER_FEE = 'HOME_OWNER_TRANSFER_FEE',
  MELLO_ROOS_COMMUNITY_FACILITIES_DISTRICT_FEE = 'MELLO_ROOS_COMMUNITY_FACILITIES_DISTRICT_FEE',
  POA_FEE = 'POA_FEE',
  RECREATION_FEE = 'RECREATION_FEE',
  RESORT_FEE = 'RESORT_FEE',
  TENNIS_FEE = 'TENNIS_FEE',
  UNKNOWN_HOA_FEE_TYPE = 'UNKNOWN_HOA_FEE_TYPE'
}

/** Owners association type. */
export enum OdProtosHomeDataStore_HomeDetail_Hoa_HoaType {
  CONDO_OWNER_ASSOCIATION = 'CONDO_OWNER_ASSOCIATION',
  HOME_OWNER_ASSOCIATION = 'HOME_OWNER_ASSOCIATION',
  LEGAL_AGENCY = 'LEGAL_AGENCY',
  MANAGEMENT_AGENCY = 'MANAGEMENT_AGENCY',
  PLANNED_UNIT_DEVELOPMENT = 'PLANNED_UNIT_DEVELOPMENT',
  UNKNOWN_HOA_TYPE = 'UNKNOWN_HOA_TYPE'
}

export type OdProtosHomeDataStore_HomeDetail_HvacInput = {
  hvacLocation?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HvacLocation>;
  hvacUnitType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HvacUnitType>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  yearManufactured?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_HvacLocation {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR',
  UNKNOWN_LOCATION = 'UNKNOWN_LOCATION'
}

export type OdProtosHomeDataStore_HomeDetail_HvacSystemInput = {
  energyType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacEnergyType>;
  /** List of HVACs installed at the home */
  hvacs?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_HvacInput>>;
  systemType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacSystemType>;
};

export enum OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacEnergyType {
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  UNKNOWN_ENERGY_TYPE = 'UNKNOWN_ENERGY_TYPE'
}

export enum OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacSystemType {
  PACKAGED = 'PACKAGED',
  SPLIT = 'SPLIT',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

export enum OdProtosHomeDataStore_HomeDetail_HvacUnitType {
  AIR_HANDLING_UNIT = 'AIR_HANDLING_UNIT',
  CONDENSER = 'CONDENSER',
  FURNACE = 'FURNACE',
  HEAT_PUMP = 'HEAT_PUMP',
  UNKNOWN_UNIT_TYPE = 'UNKNOWN_UNIT_TYPE'
}

/** An inclusive range of integer values. */
export type OdProtosHomeDataStore_HomeDetail_IntegerRangeInput = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_KitchenFeaturesInput = {
  galley?: InputMaybe<Scalars['Boolean']['input']>;
  hasBuiltInMicrowave?: InputMaybe<Scalars['Boolean']['input']>;
  hasButlerPantry?: InputMaybe<Scalars['Boolean']['input']>;
  hasCablePrewire?: InputMaybe<Scalars['Boolean']['input']>;
  hasCeilingFan?: InputMaybe<Scalars['Boolean']['input']>;
  hasCookingIsland?: InputMaybe<Scalars['Boolean']['input']>;
  hasDoubleOven?: InputMaybe<Scalars['Boolean']['input']>;
  hasExhaustFanOrHood?: InputMaybe<Scalars['Boolean']['input']>;
  hasFoodPrepIsland?: InputMaybe<Scalars['Boolean']['input']>;
  hasMultipleOvens?: InputMaybe<Scalars['Boolean']['input']>;
  hasPantry?: InputMaybe<Scalars['Boolean']['input']>;
  hasPlumbedGas?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecessedLighting?: InputMaybe<Scalars['Boolean']['input']>;
  hasSkylight?: InputMaybe<Scalars['Boolean']['input']>;
  hasVentMechanism?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalkInPantry?: InputMaybe<Scalars['Boolean']['input']>;
  hasWallOven?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterLineToFridge?: InputMaybe<Scalars['Boolean']['input']>;
  hasWetBar?: InputMaybe<Scalars['Boolean']['input']>;
  kitchenIsland?: InputMaybe<Scalars['Boolean']['input']>;
  kitchenette?: InputMaybe<Scalars['Boolean']['input']>;
  newCabinets?: InputMaybe<Scalars['Boolean']['input']>;
  noAppliances?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Scalars['Boolean']['input']>;
  openFloorPlan?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  tileBacksplash?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput = {
  decorativeLighting?: InputMaybe<Scalars['Boolean']['input']>;
  dirt?: InputMaybe<Scalars['Boolean']['input']>;
  fountain?: InputMaybe<Scalars['Boolean']['input']>;
  fruitTrees?: InputMaybe<Scalars['Boolean']['input']>;
  garden?: InputMaybe<Scalars['Boolean']['input']>;
  grass?: InputMaybe<Scalars['Boolean']['input']>;
  gravelStone?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesertYard?: InputMaybe<Scalars['Boolean']['input']>;
  lowMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  matureLandscaping?: InputMaybe<Scalars['Boolean']['input']>;
  noLandscaping?: InputMaybe<Scalars['Boolean']['input']>;
  shrubs?: InputMaybe<Scalars['Boolean']['input']>;
  sprinklerSystem?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticGrass?: InputMaybe<Scalars['Boolean']['input']>;
  trees?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_LaundryFeature {
  LAUNDRY_COMMUNITY_LAUNDRY = 'LAUNDRY_COMMUNITY_LAUNDRY',
  LAUNDRY_DRYER_HOOKUP = 'LAUNDRY_DRYER_HOOKUP',
  LAUNDRY_DRYER_INCLUDED = 'LAUNDRY_DRYER_INCLUDED',
  LAUNDRY_NONE = 'LAUNDRY_NONE',
  LAUNDRY_OTHER = 'LAUNDRY_OTHER',
  LAUNDRY_UNKNOWN = 'LAUNDRY_UNKNOWN',
  LAUNDRY_WASHER_HOOKUP = 'LAUNDRY_WASHER_HOOKUP',
  LAUNDRY_WASHER_INCLUDED = 'LAUNDRY_WASHER_INCLUDED'
}

export type OdProtosHomeDataStore_HomeDetail_LaundryFeaturesInput = {
  features?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_LaundryFeature>>;
  location?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Location>;
};

export enum OdProtosHomeDataStore_HomeDetail_Location {
  LOCATION_BASEMENT = 'LOCATION_BASEMENT',
  LOCATION_DEN = 'LOCATION_DEN',
  LOCATION_DINING_ROOM = 'LOCATION_DINING_ROOM',
  LOCATION_EXTERIOR = 'LOCATION_EXTERIOR',
  LOCATION_FAMILY_ROOM = 'LOCATION_FAMILY_ROOM',
  LOCATION_GARAGE = 'LOCATION_GARAGE',
  LOCATION_GREAT_ROOM = 'LOCATION_GREAT_ROOM',
  LOCATION_INTERIOR = 'LOCATION_INTERIOR',
  LOCATION_KITCHEN = 'LOCATION_KITCHEN',
  LOCATION_LAUNDRY_ROOM = 'LOCATION_LAUNDRY_ROOM',
  LOCATION_LIVING_ROOM = 'LOCATION_LIVING_ROOM',
  LOCATION_MASTER_BEDROOM = 'LOCATION_MASTER_BEDROOM',
  LOCATION_UNKNOWN = 'LOCATION_UNKNOWN',
  LOCATION_UPSTAIRS = 'LOCATION_UPSTAIRS'
}

/** Next LotFeature ID: 13; */
export type OdProtosHomeDataStore_HomeDetail_LotFeaturesInput = {
  isCleared?: InputMaybe<Scalars['Boolean']['input']>;
  /** A lot abutting 2 intersecting streets where the interior angle of intersection does not exceed 135 degrees */
  isCornerLot?: InputMaybe<Scalars['Boolean']['input']>;
  /** A lot on the end of a minor street with only one outlet and terminating in a vehicular turnaround */
  isCulDeSac?: InputMaybe<Scalars['Boolean']['input']>;
  isFlagLot?: InputMaybe<Scalars['Boolean']['input']>;
  isGreenbelt?: InputMaybe<Scalars['Boolean']['input']>;
  isInteriorLot?: InputMaybe<Scalars['Boolean']['input']>;
  isIrregularLot?: InputMaybe<Scalars['Boolean']['input']>;
  isLandscaped?: InputMaybe<Scalars['Boolean']['input']>;
  onGolfCourse?: InputMaybe<Scalars['Boolean']['input']>;
  onWaterfront?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length of the plot outer boundaries */
  perimeterFeet?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_OtherRoom {
  OTHER_ROOM_DEN_OFFICE = 'OTHER_ROOM_DEN_OFFICE',
  OTHER_ROOM_EXERCISE_ROOM = 'OTHER_ROOM_EXERCISE_ROOM',
  OTHER_ROOM_FAMILY_ROOM = 'OTHER_ROOM_FAMILY_ROOM',
  OTHER_ROOM_FORMAL_DINING_ROOM = 'OTHER_ROOM_FORMAL_DINING_ROOM',
  OTHER_ROOM_FORMAL_LIVING_ROOM_SEPARATE = 'OTHER_ROOM_FORMAL_LIVING_ROOM_SEPARATE',
  OTHER_ROOM_FOYER = 'OTHER_ROOM_FOYER',
  OTHER_ROOM_GAME_ROOM = 'OTHER_ROOM_GAME_ROOM',
  OTHER_ROOM_GREAT_ROOM = 'OTHER_ROOM_GREAT_ROOM',
  OTHER_ROOM_INTERIOR_LAUNDRY = 'OTHER_ROOM_INTERIOR_LAUNDRY',
  OTHER_ROOM_LAUNDRY_UTILITY_ROOM = 'OTHER_ROOM_LAUNDRY_UTILITY_ROOM',
  OTHER_ROOM_LIBRARY = 'OTHER_ROOM_LIBRARY',
  OTHER_ROOM_LOFT = 'OTHER_ROOM_LOFT',
  OTHER_ROOM_MEDIA_ROOM = 'OTHER_ROOM_MEDIA_ROOM',
  OTHER_ROOM_NONE = 'OTHER_ROOM_NONE',
  OTHER_ROOM_OTHER = 'OTHER_ROOM_OTHER',
  OTHER_ROOM_SCREENED_PORCH = 'OTHER_ROOM_SCREENED_PORCH',
  OTHER_ROOM_SEP_GUEST_QUARTERS = 'OTHER_ROOM_SEP_GUEST_QUARTERS',
  OTHER_ROOM_STORAGE = 'OTHER_ROOM_STORAGE',
  OTHER_ROOM_SUN_ROOM = 'OTHER_ROOM_SUN_ROOM',
  OTHER_ROOM_UNKNOWN = 'OTHER_ROOM_UNKNOWN',
  OTHER_ROOM_WINE_CELLAR = 'OTHER_ROOM_WINE_CELLAR',
  OTHER_ROOM_WORKSHOP = 'OTHER_ROOM_WORKSHOP'
}

export type OdProtosHomeDataStore_HomeDetail_OutdoorSpaceInput = {
  /** True if the cover was built with a proper permit.  Nil if no cover exists. */
  isCoverPermitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the patio has a cover. */
  isCovered?: InputMaybe<Scalars['Boolean']['input']>;
  /** front, back, side */
  location?: InputMaybe<Scalars['String']['input']>;
  /** patio, deck, porch, outdoor_kitchen, dock, other */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Next Room Id: 45 */
export enum OdProtosHomeDataStore_HomeDetail_ParkingFeature {
  PARKING_ALLEY_ACCESS = 'PARKING_ALLEY_ACCESS',
  PARKING_ASSIGNED = 'PARKING_ASSIGNED',
  PARKING_ATTACHED_GARAGE = 'PARKING_ATTACHED_GARAGE',
  PARKING_ATTACHED_GARAGE_CABINETS = 'PARKING_ATTACHED_GARAGE_CABINETS',
  PARKING_CARPORT = 'PARKING_CARPORT',
  PARKING_CARPORT_ATTACHED = 'PARKING_CARPORT_ATTACHED',
  PARKING_CARPORT_DETACHED = 'PARKING_CARPORT_DETACHED',
  PARKING_CIRCULAR_DRIVEWAY = 'PARKING_CIRCULAR_DRIVEWAY',
  PARKING_COMMON = 'PARKING_COMMON',
  PARKING_COMMUNITY = 'PARKING_COMMUNITY',
  PARKING_CONVERTED_GARAGE = 'PARKING_CONVERTED_GARAGE',
  PARKING_COVERED = 'PARKING_COVERED',
  PARKING_DETACHED_GARAGE = 'PARKING_DETACHED_GARAGE',
  PARKING_DIRECT_GARAGE_ACCESS = 'PARKING_DIRECT_GARAGE_ACCESS',
  PARKING_DRIVEWAY = 'PARKING_DRIVEWAY',
  PARKING_ELECTRIC_CAR_CHARGING = 'PARKING_ELECTRIC_CAR_CHARGING',
  PARKING_EXTENDED_LENGTH_GARAGE = 'PARKING_EXTENDED_LENGTH_GARAGE',
  PARKING_FEE = 'PARKING_FEE',
  PARKING_FRONT_ENTRY = 'PARKING_FRONT_ENTRY',
  PARKING_GARAGE = 'PARKING_GARAGE',
  PARKING_GARAGE_DOOR_OPENER = 'PARKING_GARAGE_DOOR_OPENER',
  PARKING_GATED = 'PARKING_GATED',
  PARKING_GOLF_CART = 'PARKING_GOLF_CART',
  PARKING_HEATED_GARAGE = 'PARKING_HEATED_GARAGE',
  PARKING_NONE = 'PARKING_NONE',
  PARKING_OFFSITE = 'PARKING_OFFSITE',
  PARKING_OFF_STREET = 'PARKING_OFF_STREET',
  PARKING_OVERSIZED = 'PARKING_OVERSIZED',
  PARKING_PAVED_DRIVEWAY = 'PARKING_PAVED_DRIVEWAY',
  PARKING_PERMIT = 'PARKING_PERMIT',
  PARKING_PULL_THROUGH = 'PARKING_PULL_THROUGH',
  PARKING_REAR_ENTRY = 'PARKING_REAR_ENTRY',
  PARKING_RV = 'PARKING_RV',
  PARKING_RV_GARAGE = 'PARKING_RV_GARAGE',
  PARKING_SHARED_DRIVEWAY = 'PARKING_SHARED_DRIVEWAY',
  PARKING_SIDE_ENTRY = 'PARKING_SIDE_ENTRY',
  PARKING_STORAGE = 'PARKING_STORAGE',
  PARKING_STREET = 'PARKING_STREET',
  PARKING_TANDEM = 'PARKING_TANDEM',
  PARKING_TEMP_CONTROLLED = 'PARKING_TEMP_CONTROLLED',
  PARKING_UNASSIGNED = 'PARKING_UNASSIGNED',
  PARKING_UNKNOWN = 'PARKING_UNKNOWN',
  PARKING_UNPAVED_DRIVEWAY = 'PARKING_UNPAVED_DRIVEWAY',
  PARKING_VALET = 'PARKING_VALET',
  PARKING_WORKSHOP = 'PARKING_WORKSHOP'
}

/** Road represents segments of both Road and Links (onRamps) */
export type OdProtosHomeDataStore_HomeDetail_RoadInput = {
  adjacent?: InputMaybe<Scalars['Boolean']['input']>;
  distanceM?: InputMaybe<Scalars['Float']['input']>;
  /** name of the road, or some other signifier */
  label?: InputMaybe<Scalars['String']['input']>;
  /** well-known text representation of the road */
  roadWkt?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_RoofInput = {
  /**
   * An estimation of the years we can expect the roof to require replacement,
   * represented as the range of years (e.g 2022 - 2024).
   */
  estimatedLifeExpiration?: InputMaybe<OdProtosHomeDataStore_HomeDetail_IntegerRangeInput>;
  hasEvidenceOfHailDamage?: InputMaybe<Scalars['Boolean']['input']>;
  hasEvidenceOfLeakFromInterior?: InputMaybe<Scalars['Boolean']['input']>;
  isRoofMaintainedByHoa?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * asphalt_shingles, metal_shingles, wood_shingles, flat_rolled,
   * membrane_roofing, metal, shake, slate, tile, other, unknown
   */
  roofMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
  yearBuilt?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput = {
  fireplaceFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FireplaceFeature>>;
  /** flooring material for whole room */
  flooringMaterial?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringMaterial>;
  /** Basement = floor -1, ground floor = floor 1. 0 should never be used. */
  interiorStory?: InputMaybe<Scalars['Float']['input']>;
  lengthFeet?: InputMaybe<Scalars['Float']['input']>;
  /** flooring material breakdown with included size */
  roomFloorings?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FlooringInput>>;
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  widthFeet?: InputMaybe<Scalars['Float']['input']>;
};

/** `OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput` represents the `room_floorings` map in `od_protos.home_data_store.HomeDetail`. */
export type OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringInput>;
};

/**
 * Deprecated, use top-level fields for available rooms.
 * Remaining ambiguous rooms can continue to be listed here
 * Ex. bedroom (non-master), bathroom (non-master), hallway, closet, storage
 * Next Room Id: 11
 */
export type OdProtosHomeDataStore_HomeDetail_RoomInput = {
  fireplaces?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FireplaceInput>>;
  /** heavily_worn, typical_use, great_condition */
  flooringCondition?: InputMaybe<Scalars['String']['input']>;
  /** tile, laminate, hardwood, carpet, other */
  flooringMaterial?: InputMaybe<Scalars['String']['input']>;
  lengthFeet?: InputMaybe<Scalars['Float']['input']>;
  roomFloorings?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FlooringInput>>;
  /** currently only used for bathrooms, e.g. half_bath, full_bath */
  roomSubType?: InputMaybe<Scalars['String']['input']>;
  /** bedroom, bathroom, living, kitchen, etc. */
  roomType?: InputMaybe<Scalars['String']['input']>;
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  /** first_floor, second_floor, third_floor, basement, sub_basement, other */
  story?: InputMaybe<Scalars['String']['input']>;
  widthFeet?: InputMaybe<Scalars['Float']['input']>;
};

/** Slope direction relative to the home. */
export enum OdProtosHomeDataStore_HomeDetail_SlopeDirection {
  SLOPEDIR_DOWNHILL = 'SLOPEDIR_DOWNHILL',
  SLOPEDIR_NONE = 'SLOPEDIR_NONE',
  SLOPEDIR_UNKNOWN = 'SLOPEDIR_UNKNOWN',
  SLOPEDIR_UPHILL = 'SLOPEDIR_UPHILL'
}

export enum OdProtosHomeDataStore_HomeDetail_SlopeType {
  SLOPETYPE_NONE = 'SLOPETYPE_NONE',
  SLOPETYPE_SLIGHT = 'SLOPETYPE_SLIGHT',
  SLOPETYPE_SUBSTANTIAL = 'SLOPETYPE_SUBSTANTIAL',
  SLOPETYPE_UNKNOWN = 'SLOPETYPE_UNKNOWN'
}

/**
 * Source encodes where does this data comes from. This is needed so that we can have resolution strategies that
 * depend on where data came from. Source is a coarse grained category of where the data came from. E.g. all MLS
 * data is grouped into the MLS source.
 *
 * If you plan to start writing to Home Data Store, please add yourself here and request a review from #data-infra.
 * Next Source ID: 30
 */
export enum OdProtosHomeDataStore_HomeDetail_Source {
  /** Operator entered overrides through admin. Done by Opendoor employees. */
  SOURCE_ADMIN_OVERRIDES = 'SOURCE_ADMIN_OVERRIDES',
  /** Sherlock assessments performed by Opendoor employees. This is written from web. */
  SOURCE_ASSESSMENT = 'SOURCE_ASSESSMENT',
  /** Derived data that combines ATTOM parcels details and census features */
  SOURCE_ATTOM_AND_CENSUS_MTRAC = 'SOURCE_ATTOM_AND_CENSUS_MTRAC',
  /** Data provided from Attom HOA data */
  SOURCE_ATTOM_HOA_DATA = 'SOURCE_ATTOM_HOA_DATA',
  /** Derived data from ATTOM parcel dimensions */
  SOURCE_ATTOM_PARCELS = 'SOURCE_ATTOM_PARCELS',
  /**
   * Parcel boundaries given to us by BSI, usually used to infer lot square footage. More documentation can be
   * found at https://github.com/opendoor-labs/dwellings/tree/master/docs/bsi and
   * https://www.boundarysolutions.com/.
   */
  SOURCE_BSI_PARCEL = 'SOURCE_BSI_PARCEL',
  /**
   * Derived from the tax data provided by Corelogic. Corelogic provides tax data similar to RealtyTrac
   * but the data is expected to be more accurate
   */
  SOURCE_CORELOGIC_TAX_DATA = 'SOURCE_CORELOGIC_TAX_DATA',
  /** Assessments and other field visits performed by Opendoor employees using Scout. */
  SOURCE_FIELD_OPERATOR = 'SOURCE_FIELD_OPERATOR',
  /**
   * Figure Eight provides human tagged data about our homes. We use figure eight to determine kitchen countertops
   * among other things on homes in the markets we care about.
   * https://www.figure-eight.com/.
   */
  SOURCE_FIGURE_EIGHT = 'SOURCE_FIGURE_EIGHT',
  /** Data provided from a floor plan scan */
  SOURCE_FLOOR_PLAN = 'SOURCE_FLOOR_PLAN',
  /** Homebuilder is any home builder corporation building brand new homes. For example: Lennar, Pulte. */
  SOURCE_HOMEBUILDER = 'SOURCE_HOMEBUILDER',
  /** Data that is imputed from comps in the same postal code */
  SOURCE_IMPUTED = 'SOURCE_IMPUTED',
  /** Lakehouse arbitrated data */
  SOURCE_LAKEHOUSE_ARBITRATED = 'SOURCE_LAKEHOUSE_ARBITRATED',
  /** Derived data from the Listing Remarks */
  SOURCE_LISTING_REMARKS = 'SOURCE_LISTING_REMARKS',
  /**
   * Parcel boundaries given by Maponics. Similar to BSI Parcel data.
   * https://www.pitneybowes.com/us/data/boundary-data/neighborhood-boundaries.html
   */
  SOURCE_MAPONICS_PARCEL = 'SOURCE_MAPONICS_PARCEL',
  /** Opendoor employees review discrepancies between seller answers and assessment data to identify correct values. */
  SOURCE_MISSTATEMENT_RESOLUTION = 'SOURCE_MISSTATEMENT_RESOLUTION',
  /**
   * Multiple Listing Service. This contains data ingested by the Data Engineering team by connecting to different
   * MLS data feeds across different markets. This data is associated to when a home is in the market.
   */
  SOURCE_MLS = 'SOURCE_MLS',
  /**
   * Maricopa County Assessor documents. Similar data as Realty Trac but of higher quality in the Phoenix area.
   * https://github.com/opendoor-labs/dwellings/tree/master/docs/monsoon.
   */
  SOURCE_MONSOON = 'SOURCE_MONSOON',
  /**
   * Edits made by the ODA (Opendoor Direct Access – institutional buyers) ops team
   * during diligence in response to institutional bids.
   */
  SOURCE_ODA_TOOLING = 'SOURCE_ODA_TOOLING',
  /**
   * Bulk labeling from internal users that use custom tools to label batches of homes at a time
   * At the time of adding this new source, this process is used to label guard gated communities, sink holes, entry types,
   * and similar features that might impact a home's eligibility in our buy box
   */
  SOURCE_OPENDOOR_BULK_LABELING = 'SOURCE_OPENDOOR_BULK_LABELING',
  /**
   * Opendoor edits made by internal tools and employees. Highest priority resolution. The tool used to make the
   * edit should be written as `source_name`.
   * Note: It will be necessary to create a separate "source" for other "Opendoor edits" in the future,
   * i.e. for Opendoor contract teams where the edits are lower priority.
   */
  SOURCE_OPENDOOR_INTERNAL_EDIT = 'SOURCE_OPENDOOR_INTERNAL_EDIT',
  /** Data validated by an Opendoor employee */
  SOURCE_OPENDOOR_INTERNAL_VALIDATION = 'SOURCE_OPENDOOR_INTERNAL_VALIDATION',
  /** GIS Values derived by Opendoor from Data provided by OpenStreetMap */
  SOURCE_OSM = 'SOURCE_OSM',
  /** Data from photo labelling vendors via the service "dataingest" (i.e. HiveAI, RestB ...) */
  SOURCE_PHOTO_LABELS = 'SOURCE_PHOTO_LABELS',
  /** Condition scores from prelisting photos */
  SOURCE_PRELISTING = 'SOURCE_PRELISTING',
  /** PropCo (core OD flipping business) home details for resale listings. */
  SOURCE_PROPCO_LISTING = 'SOURCE_PROPCO_LISTING',
  /**
   * Realty Trac provides tax assessor records to us for the whole country. Documentation about this data source
   * can be found at https://github.com/opendoor-labs/dwellings/tree/master/docs/realty_trac.
   */
  SOURCE_REALTY_TRAC = 'SOURCE_REALTY_TRAC',
  /**
   * A resolved source means that HDS resolved this home details by possibly merging multiple sources. It should
   * only be set by Home Data Store.
   */
  SOURCE_RESOLVED = 'SOURCE_RESOLVED',
  /**
   * Assessor documents manually scraped by the pricing team to get higher accuracy in some counties where
   * Realty Trac data quality is lacking.
   */
  SOURCE_SCRAPED_COUNTY_TAX_ASSESSOR = 'SOURCE_SCRAPED_COUNTY_TAX_ASSESSOR',
  /** Seller Inputs is that entered by a customer through our seller flow when requesting an offer. */
  SOURCE_SELLER_INPUTS = 'SOURCE_SELLER_INPUTS',
  /** Sherlock assessments performed by Opendoor employees. */
  SOURCE_SHERLOCK = 'SOURCE_SHERLOCK',
  /**
   * Information from RepairScopes in Sherlock assessments performed by Opendoor employees.
   * This information may be transient. Consumers should verify that these values have not changed during renovation.
   */
  SOURCE_SHERLOCK_REPAIR_SCOPES = 'SOURCE_SHERLOCK_REPAIR_SCOPES',
  /**
   * Default value, whenever we do not know the source of the data. HDS would not accept anything that has an
   * unspecified source.
   */
  SOURCE_UNKNOWN = 'SOURCE_UNKNOWN',
  /** Edits made through the Valuation Tool (Pricing) when pricing associates make offers to a customer. */
  SOURCE_VAL_TOOL = 'SOURCE_VAL_TOOL',
  /** Virtual assessments performed by Opendoor employees */
  SOURCE_VIRTUAL_ASSESSMENT = 'SOURCE_VIRTUAL_ASSESSMENT',
  /** Opendoor edits done through https://wally.apps.opendoor.com/. This could come from anyone within Opendoor. */
  SOURCE_WOLLIZ = 'SOURCE_WOLLIZ'
}

export type OdProtosHomeDataStore_HomeDetail_UtilityProviderInput = {
  providerName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_HomeDetail_WaterHeaterInput = {
  /**
   * An (inclusive) estimated range of the capacity of the water heater.
   * If an exact value is known, start and end will be equal.
   */
  capacityGallons?: InputMaybe<OdProtosHomeDataStore_HomeDetail_IntegerRangeInput>;
  energyType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_WaterHeater_WaterHeaterEnergyType>;
  /** List of water heater features. */
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Year when the water heater was installed. */
  yearInstalled?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosHomeDataStore_HomeDetail_WaterHeater_WaterHeaterEnergyType {
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  UNKNOWN_ENERGY_TYPE = 'UNKNOWN_ENERGY_TYPE'
}

export type OdProtosHomeDataStore_HomeDetail_YardFeaturesInput = {
  fenceCompletionStatus?: InputMaybe<OdProtosHomeDataStore_HomeDetail_YardFeatures_FenceCompletionStatus>;
  fenceFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FenceFeature>>;
  /** Designates existence. False indicates the home has no yard in the specified position. */
  hasYard?: InputMaybe<Scalars['Boolean']['input']>;
  landscaping?: InputMaybe<OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput>;
  /** Slope direction relative to the home. */
  slopeDirection?: InputMaybe<OdProtosHomeDataStore_HomeDetail_SlopeDirection>;
  /** slope severity */
  slopeType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_SlopeType>;
};

export enum OdProtosHomeDataStore_HomeDetail_YardFeatures_FenceCompletionStatus {
  FULL = 'FULL',
  NO_FENCE = 'NO_FENCE',
  PARTIAL = 'PARTIAL',
  UNSPECIFIED_STATUS = 'UNSPECIFIED_STATUS'
}

/**
 * Deprecated, use yard features instead
 * Next Yard ID: 7;
 */
export type OdProtosHomeDataStore_HomeDetail_YardInput = {
  /** needs_work, typical_use, great_condition */
  condition?: InputMaybe<Scalars['String']['input']>;
  fence?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FenceInput>;
  /**
   * Designates existence. false value indicatest that the home
   * has no yard in the specified position.
   */
  hasYard?: InputMaybe<Scalars['Boolean']['input']>;
  /** front, back */
  position?: InputMaybe<Scalars['String']['input']>;
  /**
   * Slope direction relative to the home.
   * no_slope, downhill_slope, uphill_slope
   */
  slopeDirection?: InputMaybe<Scalars['String']['input']>;
  /** slight_slope, substantial_slope, severe_slope, none */
  slopeType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_ListResolverLabelsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Seller inputs that do not exist on HomeDetail
 * Next ID: 15
 */
export type OdProtosHomeDataStore_PartnershipAdditionalHomeDetailsInput = {
  /** Can be unfinished, partially_finished, or finished */
  basementFinishing?: InputMaybe<Scalars['String']['input']>;
  floodHistoryTriage?: InputMaybe<OdProtosSellReceptionData_Answers_FloodHistoryTriageInput>;
  hasFireDamage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the house has leased solar panels AND the owner does not want to buy out the lease */
  hasLeasedSolarPanelsAndRejectBuyOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether seller's estimate of the home's value is out of buybox */
  hasPriceEstimateTriage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Freetext additional information */
  otherInformation?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosHomeDataStore_PreferredHomeDetailsUsage {
  /** Default behavior. Preferred home details are preferred above all else. */
  PREFERRED_HOME_DETAILS_USAGE_DEFAULT = 'PREFERRED_HOME_DETAILS_USAGE_DEFAULT',
  /**
   * Preferred home details will replace all other home details for the same source,
   * but the resolution strategy will still be applied, and could rank other home
   * details from other sources above the preferred home details.
   */
  PREFERRED_HOME_DETAILS_USAGE_REPLACE_ALL_FROM_SOURCE = 'PREFERRED_HOME_DETAILS_USAGE_REPLACE_ALL_FROM_SOURCE'
}

export type OdProtosHomeDataStore_RemovePrimaryAddressForHomeDetailRequestInput = {
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_ResolveHomeDetailsRequestInput = {
  /** Address from casa */
  address?: InputMaybe<OdProtosCasaData_AddressInput>;
  /** Address ID of the home we want to get details from. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Customer preassigned id for accessing the api. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Timestamp as of which we want to resolve home details for this home. E.g. if we want to get the state of a home
   * in a particular date (without using any newer data) we should set this field.
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * List of home detail IDs with a higher preference that any others. Beginning of the list has higher preference than
   * the end. This should be used sparingly and it is meant for use-cases in which we want to apply overrides for
   * single requests.
   */
  preferredHomeDetailIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Specify how the preferred_home_detail_ids should be used. The default is to use them
   * above all else, but we can also use them to replace all home details from a specific source.
   */
  preferredHomeDetailsUsage?: InputMaybe<OdProtosHomeDataStore_PreferredHomeDetailsUsage>;
  /** Specific resolution strategy desired. Default will be used if not given. */
  resolveStrategyLabel?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_ResolveProvidedHomeDetailsRequestInput = {
  /** Address from casa. */
  address?: InputMaybe<OdProtosCasaData_AddressInput>;
  /** List of HomeDetails to be used for resolution. */
  providedHomeDetails?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetailInput>>;
  /** Specific resolution strategy desired. Default will be used if not given. */
  resolveStrategyLabel?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_SetPrimaryAddressForHomeDetailRequestInput = {
  /** The home detail ID we want to update. */
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  /** New address UUID for the home detail. */
  primaryAddressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeDataStore_UnresolvedHomeDetailsRequestInput = {
  /** Address token of the home to get unresolved home details from. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Timestamp as of which we want to resolve home details for this home. E.g. if we want to get the state of a home
   * in a particular date (without using any newer data) we should set this field.
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosHomeInspectorData_DecisionEngineStatus {
  DECISION_ENGINE_STATUS_APPROVED = 'DECISION_ENGINE_STATUS_APPROVED',
  DECISION_ENGINE_STATUS_PENDING = 'DECISION_ENGINE_STATUS_PENDING',
  DECISION_ENGINE_STATUS_PROPAGATED = 'DECISION_ENGINE_STATUS_PROPAGATED',
  DECISION_ENGINE_STATUS_REJECTED = 'DECISION_ENGINE_STATUS_REJECTED',
  DECISION_ENGINE_STATUS_UNSPECIFIED = 'DECISION_ENGINE_STATUS_UNSPECIFIED',
  DECISION_ENGINE_STATUS_VALIDATED = 'DECISION_ENGINE_STATUS_VALIDATED'
}

export enum OdProtosHomeInspectorData_RepairScopeSuggestion_Category {
  CATEGORY_COSMETIC = 'CATEGORY_COSMETIC',
  CATEGORY_FUNCTIONAL = 'CATEGORY_FUNCTIONAL',
  CATEGORY_PERSONALIZATION = 'CATEGORY_PERSONALIZATION',
  CATEGORY_SAFETY = 'CATEGORY_SAFETY',
  CATEGORY_STRUCTURAL = 'CATEGORY_STRUCTURAL',
  CATEGORY_UNSPECIFIED = 'CATEGORY_UNSPECIFIED'
}

export enum OdProtosHomeInspectorData_RepairScopeSuggestion_ReviewStatus {
  REVIEW_STATUS_ACCEPTED = 'REVIEW_STATUS_ACCEPTED',
  REVIEW_STATUS_PENDING = 'REVIEW_STATUS_PENDING',
  REVIEW_STATUS_REVIEWED = 'REVIEW_STATUS_REVIEWED',
  REVIEW_STATUS_SKIPPED = 'REVIEW_STATUS_SKIPPED',
  REVIEW_STATUS_UNSPECIFIED = 'REVIEW_STATUS_UNSPECIFIED'
}

export enum OdProtosHomeInspectorData_RepairScopeSuggestion_Severity {
  SEVERITY_MAJOR = 'SEVERITY_MAJOR',
  SEVERITY_MINOR = 'SEVERITY_MINOR',
  SEVERITY_NON_ISSUE = 'SEVERITY_NON_ISSUE',
  SEVERITY_NOT_APPLICABLE = 'SEVERITY_NOT_APPLICABLE',
  SEVERITY_UNSPECIFIED = 'SEVERITY_UNSPECIFIED'
}

export type OdProtosHomeInspectorData_RepairStandardsActionInput = {
  prefillSelection?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsAction_PrefillSelectionInput>;
  result?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsAction_Result>;
};

export type OdProtosHomeInspectorData_RepairStandardsAction_PrefillSelectionInput = {
  prefillId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosHomeInspectorData_RepairStandardsAction_Result {
  RESULT_CREATE = 'RESULT_CREATE',
  RESULT_ESTIMATE_ONLY = 'RESULT_ESTIMATE_ONLY',
  RESULT_IGNORE = 'RESULT_IGNORE'
}

export type OdProtosHomeInspectorData_RepairStandardsRuleInput = {
  action?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsActionInput>;
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  criteria?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  marketActions?: InputMaybe<Array<OdProtosHomeInspectorData_RepairStandardsRule_MarketActionsEntryInput>>;
  mustNot?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosHomeInspectorData_RepairStandardsRule_MarketActionsEntryInput` represents the `market_actions` map in `od_protos.home_inspector.data.RepairStandardsRule`. */
export type OdProtosHomeInspectorData_RepairStandardsRule_MarketActionsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsActionInput>;
};

export type OdProtosHomeInspectorData_RepairStandardsRulesetInput = {
  rules?: InputMaybe<Array<OdProtosHomeInspectorData_RepairStandardsRuleInput>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_AcceptRepairScopeSuggestionRequestInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  repairScope?: InputMaybe<OdProtosAbraV0Services_CreateRepairScopeRequestInput>;
  repairScopeSuggestionId?: InputMaybe<Scalars['String']['input']>;
  severityDowngrade?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Decision Engine messages */
export type OdProtosHomeInspectorServices_ApproveDecisionEngineRunRequestInput = {
  decisionEngineRunId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_AssessmentTaskCompletedRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_ClearResultsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_ConditionScopingTaskCompletedRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_ConditionScopingTaskCreatedRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_CreateDecisionEngineRunsRequestInput = {
  repairScopeSuggestionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeInspectorServices_CreateFeatureQuestionRequestInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  featureName?: InputMaybe<Scalars['String']['input']>;
  homeArea?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_CreatePromptConfigurationRequestInput = {
  jobType?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  topK?: InputMaybe<Scalars['Float']['input']>;
  topP?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosHomeInspectorServices_CreateRepairStandardsSnapshotRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeInspectorServices_DevCreateHomeInspectionDiligenceScopingTaskRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_DevCreateNewConditionScopingTaskRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  areas?: InputMaybe<Array<Scalars['String']['input']>>;
  disabledStandards?: InputMaybe<Scalars['Boolean']['input']>;
  faster?: InputMaybe<Scalars['Boolean']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeInspectorServices_DryRunLlmRequestRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  json?: InputMaybe<Scalars['Boolean']['input']>;
  llmRequestId?: InputMaybe<Scalars['String']['input']>;
  promptConfigurationId?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_EnqueueHeroShotsRequestInput = {
  conditionScopingTaskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_EstimateAreaRequestInput = {
  conditionScopingTaskId?: InputMaybe<Scalars['String']['input']>;
  /** When true, skips area validation guardrails that check if livable area is within 10% of property area */
  skipAreaGuardrails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeInspectorServices_GenerateHeroShotsRequestInput = {
  /** optional list of specific areas */
  areas?: InputMaybe<Array<Scalars['String']['input']>>;
  assessmentTaskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_GenerateWebSocketTokenRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_GetConditionScopingQuestionnaireRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_GetRepairScopeSuggestionRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_HomeInspectionDiligenceScopingTaskCreatedRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_InspectionEstimateAreaRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  assessmentReportId?: InputMaybe<Scalars['String']['input']>;
  conditionScopingTaskId?: InputMaybe<Scalars['String']['input']>;
  skipAreaGuardrails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeInspectorServices_ListDecisionEngineGroundTruthRunsRequestInput = {
  repairStandardsDefectId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_ListDecisionEngineRunsRequestInput = {
  repairScopeSuggestionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeInspectorServices_ListHeroShotsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_ListRepairScopeSuggestionsByIdsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeInspectorServices_ListRepairScopeSuggestionsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  repairStandardsDefectId?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<OdProtosHomeInspectorData_RepairScopeSuggestion_ReviewStatus>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_ListRepairStandardsDefectsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeInspectorServices_ProcessConditionScopingQuestionnaireRequestInput = {
  conditionScopingTaskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_PropagateConditionScopingQuestionnaireRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_PropagateRepairScopesRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  conditionScopingTaskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_RejectDecisionEngineRunRequestInput = {
  decisionEngineRunId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequestInput = {
  duplicateRepairScopeId?: InputMaybe<Scalars['String']['input']>;
  incorrectPrefillFeedback?: InputMaybe<OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_IncorrectPrefillFeedbackInput>;
  incorrectPriceFeedback?: InputMaybe<OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_IncorrectPriceFeedbackInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rejectReason?: InputMaybe<OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_RejectReason>;
  repairScopeSuggestionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_IncorrectPrefillFeedbackInput = {
  defectId?: InputMaybe<Scalars['String']['input']>;
  prefillId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_IncorrectPriceFeedbackInput = {
  laborCost?: InputMaybe<OdProtosAbraV0Data_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosAbraV0Data_MaterialCostInput>;
};

export enum OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_RejectReason {
  REJECT_REASON_APPROVED = 'REJECT_REASON_APPROVED',
  REJECT_REASON_DUPLICATE = 'REJECT_REASON_DUPLICATE',
  REJECT_REASON_INCORRECT_PREFILL = 'REJECT_REASON_INCORRECT_PREFILL',
  REJECT_REASON_INCORRECT_PRICE = 'REJECT_REASON_INCORRECT_PRICE',
  REJECT_REASON_ISSUE_NOT_PRESENT = 'REJECT_REASON_ISSUE_NOT_PRESENT',
  REJECT_REASON_NEGLIGIBLE = 'REJECT_REASON_NEGLIGIBLE',
  REJECT_REASON_NOT_APPLICABLE_TO_MARKET = 'REJECT_REASON_NOT_APPLICABLE_TO_MARKET',
  REJECT_REASON_NOT_DEFECT = 'REJECT_REASON_NOT_DEFECT',
  REJECT_REASON_UNSPECIFIED = 'REJECT_REASON_UNSPECIFIED'
}

export type OdProtosHomeInspectorServices_TestRepairScopesEstimateRequestInput = {
  repairScopeSuggestionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeInspectorServices_TestRepairStandardsRulesetRequestInput = {
  repairScopeSuggestionId?: InputMaybe<Scalars['String']['input']>;
  ruleset?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsRulesetInput>;
};

/**
 * Config keyed by Market.
 * PBDB Key: market
 */
export type OdProtosHomeOperationsConfig_MarketConfigInput = {
  /**
   * Change orders above this dollar amount require approval from an area
   * construction manager
   */
  acmEscalationThresholdInDollars?: InputMaybe<Scalars['Float']['input']>;
  /** Area construction manager Slack group */
  acmSlackGroup?: InputMaybe<Scalars['String']['input']>;
  /** Slack channel for change order esclations */
  changeOrderEscalationSlackChannel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Change orders above this dollar amount require approval from a general
   * manager
   */
  gmEscalationThresholdInDollars?: InputMaybe<Scalars['Float']['input']>;
  /** General manager Slack group */
  gmSlackGroup?: InputMaybe<Scalars['String']['input']>;
  /** Home operations coordinator Slack group */
  hocSlackGroup?: InputMaybe<Scalars['String']['input']>;
  /**
   * Used to qualify a home for low risk home treatment. The age of the home in years
   * must be this or less.
   */
  lowRiskHomeTreatmentHomeAgeInYears?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Used to qualify a home for low risk home treatment. The immediate or assessment
   * scope in dollars must be this amount or less.
   */
  lowRiskHomeTreatmentImmediateScopeInDollars?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Change orders above this dollar amount require approval from an area
   * construction manager (Renovation projects only)
   */
  renoAcmEscalationThresholdInDollars?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Change orders above this dollar amount require approval from a general
   * manager (Renovation projects only)
   */
  renoGmEscalationThresholdInDollars?: InputMaybe<Scalars['Float']['input']>;
  /** Slack channel for unassigned line items */
  unassignedLineItemsSlackChannel?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosHomeworkData_AlertThresholdEntity {
  LINE_ITEM = 'LINE_ITEM',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosHomeworkData_ChangeOrder_State {
  DRAFT = 'DRAFT',
  FINALIZED = 'FINALIZED',
  INVALID = 'INVALID',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW'
}

export type OdProtosHomeworkData_LineItemFilterInput = {
  column?: InputMaybe<OdProtosHomeworkData_LineItemFilter_Column>;
  isNegated?: InputMaybe<Scalars['Boolean']['input']>;
  operand?: InputMaybe<OdProtosHomeworkData_LineItemFilter_OperandInput>;
  operator?: InputMaybe<OdProtosHomeworkData_LineItemFilter_Operator>;
};

export type OdProtosHomeworkData_LineItemFilterSetInput = {
  /** filters are AND'd with each other */
  filters?: InputMaybe<Array<OdProtosHomeworkData_LineItemFilterInput>>;
};

export enum OdProtosHomeworkData_LineItemFilter_Column {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  INVALID_COLUMN = 'INVALID_COLUMN',
  PROJECT_ID = 'PROJECT_ID',
  WORK_ORDER_ID = 'WORK_ORDER_ID'
}

export type OdProtosHomeworkData_LineItemFilter_OperandInput = {
  value?: InputMaybe<OdProtosHomeworkData_LineItemFilter_Operand_ValueOneofInput>;
};

export type OdProtosHomeworkData_LineItemFilter_Operand_StringListInput = {
  strings?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeworkData_LineItemFilter_Operand_ValueOneofInput = {
  stringValue?: InputMaybe<Scalars['String']['input']>;
  stringValueList?: InputMaybe<OdProtosHomeworkData_LineItemFilter_Operand_StringListInput>;
};

export enum OdProtosHomeworkData_LineItemFilter_Operator {
  EQUAL_TO = 'EQUAL_TO',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  IN = 'IN',
  INVALID_OPERATOR = 'INVALID_OPERATOR',
  IS_NULL = 'IS_NULL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO'
}

export type OdProtosHomeworkData_LineItemOrderingInput = {
  column?: InputMaybe<OdProtosHomeworkData_LineItemOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosHomeworkData_LineItemOrdering_Column {
  CREATED_AT = 'CREATED_AT',
  INVALID = 'INVALID'
}

export type OdProtosHomeworkData_LineItemScope_LaborCostInput = {
  totalCents?: InputMaybe<Scalars['Float']['input']>;
  totalMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosHomeworkData_LineItemScope_MaterialCostInput = {
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitCents?: InputMaybe<Scalars['Float']['input']>;
  unitLabel?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosHomeworkData_LineItem_AccountCategory {
  BINSR = 'BINSR',
  RENOVATIONS = 'RENOVATIONS',
  REPAIRS = 'REPAIRS'
}

export enum OdProtosHomeworkData_LineItem_State {
  DRAFT = 'DRAFT',
  INVALID = 'INVALID',
  REWORK_REQUESTED = 'REWORK_REQUESTED',
  SCOPE_ACCEPTED = 'SCOPE_ACCEPTED',
  SCOPE_REJECTED = 'SCOPE_REJECTED',
  WORK_CANCELED = 'WORK_CANCELED',
  WORK_COMPLETED = 'WORK_COMPLETED',
  WORK_INVALIDATED = 'WORK_INVALIDATED',
  WORK_VALIDATED = 'WORK_VALIDATED'
}

export enum OdProtosHomeworkData_MessageThreadStatus {
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED',
  WAITING_ON_OPENDOOR_RESPONSE = 'WAITING_ON_OPENDOOR_RESPONSE',
  WAITING_ON_THIRD_PARTY_RESPONSE = 'WAITING_ON_THIRD_PARTY_RESPONSE'
}

export type OdProtosHomeworkData_ProjectFilterInput = {
  column?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Column>;
  isNegated?: InputMaybe<Scalars['Boolean']['input']>;
  operand?: InputMaybe<OdProtosHomeworkData_ProjectFilter_OperandInput>;
  operator?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Operator>;
};

export type OdProtosHomeworkData_ProjectFilterSetInput = {
  /** These filters are AND'd together */
  filters?: InputMaybe<Array<OdProtosHomeworkData_ProjectFilterInput>>;
};

export enum OdProtosHomeworkData_ProjectFilter_Column {
  ADDRESS_ID = 'ADDRESS_ID',
  FLIP_TOKEN = 'FLIP_TOKEN',
  ID = 'ID',
  KIND = 'KIND',
  MARKET = 'MARKET',
  SCHEDULED_START_AT = 'SCHEDULED_START_AT',
  STATE = 'STATE'
}

export type OdProtosHomeworkData_ProjectFilter_OperandInput = {
  value?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Operand_ValueOneofInput>;
};

export type OdProtosHomeworkData_ProjectFilter_Operand_MarketListInput = {
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosHomeworkData_ProjectFilter_Operand_StringListInput = {
  strings?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeworkData_ProjectFilter_Operand_ValueOneofInput = {
  kindValue?: InputMaybe<OdProtosHomeworkData_ProjectKind>;
  marketValue?: InputMaybe<OdProtosCommonMarket_Market>;
  marketValueList?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Operand_MarketListInput>;
  stateValue?: InputMaybe<OdProtosHomeworkData_Project_State>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  stringValueList?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Operand_StringListInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosHomeworkData_ProjectFilter_Operator {
  EQUAL_TO = 'EQUAL_TO',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  IN = 'IN',
  IS_NULL = 'IS_NULL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO'
}

export enum OdProtosHomeworkData_ProjectKind {
  BRN = 'BRN',
  LISTED = 'LISTED',
  NONE = 'NONE',
  /** When adding new values, also modify the db enum type. */
  REIT_RENOVATION = 'REIT_RENOVATION',
  RENOVATION = 'RENOVATION'
}

export type OdProtosHomeworkData_ProjectOrderingInput = {
  column?: InputMaybe<OdProtosHomeworkData_ProjectOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosHomeworkData_ProjectOrdering_Column {
  CREATED_AT = 'CREATED_AT',
  SCHEDULED_START_ON = 'SCHEDULED_START_ON',
  SCHEDULED_STOP_ON = 'SCHEDULED_STOP_ON'
}

export enum OdProtosHomeworkData_Project_State {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  INVALID = 'INVALID',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type OdProtosHomeworkData_WorkOrderFilterInput = {
  column?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Column>;
  isNegated?: InputMaybe<Scalars['Boolean']['input']>;
  operand?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_OperandInput>;
  operator?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operator>;
};

export type OdProtosHomeworkData_WorkOrderFilterSetInput = {
  /** filters are AND'd with each other */
  filters?: InputMaybe<Array<OdProtosHomeworkData_WorkOrderFilterInput>>;
};

export enum OdProtosHomeworkData_WorkOrderFilter_Column {
  ADDRESS_ID = 'ADDRESS_ID',
  ASSIGNED_TO_BRANCH_ID = 'ASSIGNED_TO_BRANCH_ID',
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  KIND = 'KIND',
  MANAGER_ID = 'MANAGER_ID',
  MARKET = 'MARKET',
  STATE = 'STATE',
  VENDOR_COMPLETED_AT = 'VENDOR_COMPLETED_AT'
}

export type OdProtosHomeworkData_WorkOrderFilter_OperandInput = {
  value?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneofInput>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_KindListInput = {
  kinds?: InputMaybe<Array<OdProtosHomeworkData_WorkOrder_Kind>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_MarketListInput = {
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_StateListInput = {
  states?: InputMaybe<Array<OdProtosHomeworkData_WorkOrder_State>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_StringListInput = {
  strings?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneofInput = {
  kindValueList?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_KindListInput>;
  marketValue?: InputMaybe<OdProtosCommonMarket_Market>;
  marketValueList?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_MarketListInput>;
  stateValue?: InputMaybe<OdProtosHomeworkData_WorkOrder_State>;
  stateValueList?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_StateListInput>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  stringValueList?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_StringListInput>;
  timestampValue?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosHomeworkData_WorkOrderFilter_Operator {
  EQUAL_TO = 'EQUAL_TO',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  IN = 'IN',
  IS_NULL = 'IS_NULL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO'
}

export enum OdProtosHomeworkData_WorkOrderForTradePartnerIndex_ProgressState {
  INVOICABLE = 'INVOICABLE',
  INVOICE_APPROVED = 'INVOICE_APPROVED',
  INVOICE_SUBMITTED = 'INVOICE_SUBMITTED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW',
  NONE = 'NONE',
  READY_TO_START = 'READY_TO_START',
  REWORK_NEEDED = 'REWORK_NEEDED',
  WAITING_FOR_ALLOWED_START = 'WAITING_FOR_ALLOWED_START',
  WAITING_FOR_QUALITY_CONTROL = 'WAITING_FOR_QUALITY_CONTROL'
}

export type OdProtosHomeworkData_WorkOrderOrderingInput = {
  column?: InputMaybe<OdProtosHomeworkData_WorkOrderOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosHomeworkData_WorkOrderOrdering_Column {
  CREATED_AT = 'CREATED_AT'
}

export enum OdProtosHomeworkData_WorkOrder_Kind {
  FEEDBACK = 'FEEDBACK',
  HOA_VIOLATION = 'HOA_VIOLATION',
  /**
   * Deprecated values
   * @deprecated No longer supported
   */
  HOLDING = 'HOLDING',
  INCIDENT = 'INCIDENT',
  INSURED = 'INSURED',
  LENDER_REQUIRED = 'LENDER_REQUIRED',
  LISTED = 'LISTED',
  /** @deprecated No longer supported */
  LITE = 'LITE',
  /** @deprecated No longer supported */
  LWOD = 'LWOD',
  /** @deprecated No longer supported */
  MAINTENANCE = 'MAINTENANCE',
  /** @deprecated No longer supported */
  MARKETPLACE = 'MARKETPLACE',
  OTHER = 'OTHER',
  /** @deprecated No longer supported */
  PRELIMINARY = 'PRELIMINARY',
  REIT_RENOVATION = 'REIT_RENOVATION',
  RENOVATION = 'RENOVATION',
  RESALE = 'RESALE',
  REWORK = 'REWORK',
  SOLD = 'SOLD',
  /** @deprecated No longer supported */
  TEST = 'TEST'
}

/** When updating the Work Order State enum, also add it to the work_order_state enum in the db */
export enum OdProtosHomeworkData_WorkOrder_State {
  DRAFT = 'DRAFT',
  /**
   * This state means that the construction manager has finished
   * creating the work order and moved it from the DRAFT state
   */
  FINALIZED = 'FINALIZED',
  INVALID = 'INVALID',
  REWORK_REQUESTED = 'REWORK_REQUESTED',
  SCOPE_ACCEPTED = 'SCOPE_ACCEPTED',
  SCOPE_REJECTED = 'SCOPE_REJECTED',
  WORK_CANCELED = 'WORK_CANCELED',
  WORK_COMMENCED = 'WORK_COMMENCED',
  WORK_COMPLETED = 'WORK_COMPLETED',
  WORK_INVALIDATED = 'WORK_INVALIDATED',
  WORK_VALIDATED = 'WORK_VALIDATED'
}

export type OdProtosHomeworkServices_AcceptWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_AccountingBucketListInput = {
  accountingBuckets?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeworkServices_AssignOnSiteWorkerRequestInput = {
  assignedOnSiteWorkerId?: InputMaybe<Scalars['String']['input']>;
  lineItemId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_AsyncUploadPhotosRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  photoType?: InputMaybe<OdProtosHomeworkServices_AsyncUploadPhotosRequest_PhotoType>;
};

export enum OdProtosHomeworkServices_AsyncUploadPhotosRequest_PhotoType {
  LINE_ITEM_AFTER_PHOTOS = 'LINE_ITEM_AFTER_PHOTOS',
  LINE_ITEM_BEFORE_PHOTOS = 'LINE_ITEM_BEFORE_PHOTOS',
  UNSET = 'UNSET'
}

export type OdProtosHomeworkServices_BrnRepairItemTokenRequestInput = {
  brnRepairItemToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_ChangeAddressRequestInput = {
  newAddressId?: InputMaybe<Scalars['String']['input']>;
  oldAddressId?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OdProtosHomeworkServices_ClassificationActionEnum {
  CLASSIFICATION_ACTION_UNSPECIFIED = 'CLASSIFICATION_ACTION_UNSPECIFIED',
  HPM_CONSULTATION = 'HPM_CONSULTATION',
  HPM_VISIT = 'HPM_VISIT',
  HPM_VISIT_SCHEDULED = 'HPM_VISIT_SCHEDULED',
  INCIDENT = 'INCIDENT',
  LWO = 'LWO',
  LWO_SCHEDULED = 'LWO_SCHEDULED',
  MAINTENANCE_VISIT = 'MAINTENANCE_VISIT',
  NO_ACTION = 'NO_ACTION',
  RESOLVED = 'RESOLVED',
  UTILITIES = 'UTILITIES'
}

export type OdProtosHomeworkServices_CommenceWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CompleteLineItemRequestInput = {
  lineItemId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CompleteReworkRequestInput = {
  reworkId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CreateChangeOrderRequestInput = {
  /** The associated project [required] */
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CreateLineItemRequestInput = {
  /**
   * Computed field, setting this field will only set account if it cannot be
   * computed
   */
  account?: InputMaybe<Scalars['String']['input']>;
  areaId?: InputMaybe<Scalars['String']['input']>;
  associatedWith?: InputMaybe<OdProtosHomeworkServices_CreateLineItemRequest_AssociatedWithOneofInput>;
  brnRepairItemToken?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated */
  changeOrderId?: InputMaybe<Scalars['String']['input']>;
  defectId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  prefillId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Computed field, setting this field will only set account if it cannot be
   * computed
   */
  repairIssue?: InputMaybe<Scalars['String']['input']>;
  repairScopeToken?: InputMaybe<Scalars['String']['input']>;
  requirementId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CreateLineItemRequest_AssociatedWithOneofInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CreateLineItemScopeRequestInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally associate this scope with a change order */
  changeOrderId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  lineItemId?: InputMaybe<Scalars['String']['input']>;
  /** Construction manager fields */
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  skipExternalNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vendor fields */
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeworkServices_CreateProjectRequestInput = {
  /** Must be a casa address id */
  addressId?: InputMaybe<Scalars['String']['input']>;
  budgetAmountCents?: InputMaybe<Scalars['Float']['input']>;
  /** It is an error to create a project with a NONE project kind */
  kind?: InputMaybe<OdProtosHomeworkData_ProjectKind>;
  managedByBranchId?: InputMaybe<Scalars['String']['input']>;
  managerContactUserToken?: InputMaybe<Scalars['String']['input']>;
  ownedBy?: InputMaybe<OdProtosHomeworkServices_CreateProjectRequest_OwnedByOneofInput>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosHomeworkServices_CreateProjectRequest_OwnedByOneofInput = {
  /** An branch of an organization owns it */
  branchId?: InputMaybe<Scalars['String']['input']>;
  /** One person owns it */
  humanId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Create a new project scope request. Homework enforces the rule that
 * signatures may only be supplied by the user they corrispond to. This is
 * pulled from the user token in the context of the request.
 */
export type OdProtosHomeworkServices_CreateProjectScopeRequestInput = {
  /** The budget in this scope */
  budgetAmountCents?: InputMaybe<Scalars['Float']['input']>;
  /** The construction manager who accepted this project scope */
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The owner of the home who accepted this project scope */
  ownerAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The project that this scope is attached to */
  projectId?: InputMaybe<Scalars['String']['input']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosHomeworkServices_CreateReworkRequestInput = {
  lineItemId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CreateTriageActionDecisionRequestInput = {
  action?: InputMaybe<OdProtosHomeworkServices_ClassificationActionEnum>;
  items?: InputMaybe<GoogleProtobuf_StructInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CreateTriageIntakeDecisionRequestInput = {
  issues?: InputMaybe<Array<OdProtosHomeworkServices_TriageIssueInput>>;
  priority?: InputMaybe<OdProtosHomeworkServices_TriagePriorityEnum>;
  reason?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CreateWorkOrderRequestInput = {
  accountingBuckets?: InputMaybe<Array<Scalars['String']['input']>>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  assignedToBranchId?: InputMaybe<Scalars['String']['input']>;
  budgetAmountCents?: InputMaybe<Scalars['Float']['input']>;
  includeInHcr?: InputMaybe<Scalars['Boolean']['input']>;
  /** Metadata */
  kind?: InputMaybe<OdProtosHomeworkData_WorkOrder_Kind>;
  managedByBranchId?: InputMaybe<Scalars['String']['input']>;
  managerContactUserToken?: InputMaybe<Scalars['String']['input']>;
  /** Use this field to mark the work order as finalized [optional] */
  managerFinalizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  messageThreadId?: InputMaybe<Scalars['String']['input']>;
  onSiteMessageThreadId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  /** deprecated */
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  vendorManagerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_CreateWorkOrderScopeRequestInput = {
  budgetAmountCents?: InputMaybe<Scalars['Float']['input']>;
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_EnrollReitRenovationRequestInput = {
  address?: InputMaybe<OdProtosCasaServices_CasaRequest_FindByFieldsInput>;
  /** Notes to be added to the visit created during enrollment. */
  dayOneWalkVisitNotes?: InputMaybe<Scalars['String']['input']>;
  initialBudgetCents?: InputMaybe<Scalars['Float']['input']>;
  lockboxCode?: InputMaybe<Scalars['String']['input']>;
  reitOrgId?: InputMaybe<Scalars['String']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  /**
   * Square footage of all livable area including finished basement sqft.
   * If REITs give us the square footage we should use the data they give us.
   */
  totalLivingSqFt?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosHomeworkServices_FinalizeAndAcceptWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_FinalizeWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_ForceDeleteWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_ForceUpdateLineItemScopeRequestInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_GetAlertThresholdRequestInput = {
  entity?: InputMaybe<OdProtosHomeworkData_AlertThresholdEntity>;
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosHomeworkServices_GetLatestTriageActionDecisionRequestInput = {
  lookup?: InputMaybe<OdProtosHomeworkServices_GetLatestTriageActionDecisionRequest_LookupOneofInput>;
};

export type OdProtosHomeworkServices_GetLatestTriageActionDecisionRequest_LookupOneofInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_GetLatestTriageIntakeDecisionRequestInput = {
  lookup?: InputMaybe<OdProtosHomeworkServices_GetLatestTriageIntakeDecisionRequest_LookupOneofInput>;
};

export type OdProtosHomeworkServices_GetLatestTriageIntakeDecisionRequest_LookupOneofInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_GetWorkOrderByReferenceNumberRequestInput = {
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_GetWorkOrderMessageThreadsRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeworkServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_LineItemAccountCategoryValueInput = {
  value?: InputMaybe<OdProtosHomeworkData_LineItem_AccountCategory>;
};

export type OdProtosHomeworkServices_ManagerApproveLineItemScopeRequestInput = {
  lineItemScopeId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_ManagerRejectLineItemScopeRequestInput = {
  lineItemScopeId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_MaybeFinalizeChangeOrdersRequestInput = {
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosHomeworkServices_PostToWorkOrderMessageThreadRequestInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  newStatus?: InputMaybe<OdProtosHomeworkData_MessageThreadStatus>;
  /** if false will use the regular message thread. */
  useOnsiteMessageThread?: InputMaybe<Scalars['Boolean']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_ProposeLineItemCancellationRequestInput = {
  /** The time of the cancellation [required] */
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The id of the line item to cancel [required] */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The time the manager accepted [optional] */
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The reason for the cancellation [required] */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The time the vendor accepted [optional] */
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeworkServices_ProposeLineItemRequestInput = {
  /**
   * Computed field, setting this field will only set account if it cannot be
   * computed
   */
  account?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<OdProtosHomeworkData_LineItem_AccountCategory>;
  areaId?: InputMaybe<Scalars['String']['input']>;
  associatedWith?: InputMaybe<OdProtosHomeworkServices_ProposeLineItemRequest_AssociatedWithOneofInput>;
  defectId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  noBeforePhotoReason?: InputMaybe<Scalars['String']['input']>;
  prefillId?: InputMaybe<Scalars['String']['input']>;
  prefillPriceMismatchComment?: InputMaybe<Scalars['String']['input']>;
  prefillPriceMismatchReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Computed field, setting this field will only set account if it cannot be
   * computed
   */
  repairIssue?: InputMaybe<Scalars['String']['input']>;
  repairScopeToken?: InputMaybe<Scalars['String']['input']>;
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_ProposeLineItemRequest_AssociatedWithOneofInput = {
  associatedWithProjectId?: InputMaybe<Scalars['String']['input']>;
  associatedWithWorkOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_ProposeLineItemScopeRequestInput = {
  /** Use ProposeLineItemCancellation instead */
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  lineItemId?: InputMaybe<Scalars['String']['input']>;
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeworkServices_ProposeWorkOrderScopeRequestInput = {
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_ReassignWorkOrderRequestInput = {
  assignedToBranchId?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_RejectWorkOrderRequestInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_SearchLineItemsRequestInput = {
  /** filter_sets are OR'd with each other */
  filterSets?: InputMaybe<Array<OdProtosHomeworkData_LineItemFilterSetInput>>;
  orderings?: InputMaybe<Array<OdProtosHomeworkData_LineItemOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosHomeworkServices_SearchProjectsRequestInput = {
  /**
   * filter_sets are OR'd together (each one consists of a bunch of AND'd
   * filters, so the search can be pretty expressive).
   */
  filterSets?: InputMaybe<Array<OdProtosHomeworkData_ProjectFilterSetInput>>;
  orderings?: InputMaybe<Array<OdProtosHomeworkData_ProjectOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosHomeworkServices_SearchWorkOrdersByStatesRequestInput = {
  /** Optional, no age limit if empty */
  earliestCreationTime?: InputMaybe<Scalars['DateTime']['input']>;
  excludedStates?: InputMaybe<Array<OdProtosHomeworkData_WorkOrder_State>>;
  /** If true only expanded_work_orders are returned */
  expandWorkOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** State filter, use one or the other */
  includedStates?: InputMaybe<Array<OdProtosHomeworkData_WorkOrder_State>>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosHomeworkServices_SearchWorkOrdersRequestInput = {
  /** assigned_field_user_ids are AND'd to all provided filters */
  assignedFieldUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true only expanded_work_orders are returned */
  expandWorkOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter_sets are OR'd with each other */
  filterSets?: InputMaybe<Array<OdProtosHomeworkData_WorkOrderFilterSetInput>>;
  /** manager_ids AND'd to all provided filters */
  managerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderings?: InputMaybe<Array<OdProtosHomeworkData_WorkOrderOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  /** unclaimed AND'd to all provided filters */
  unclaimedWorkOrders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeworkServices_SignatureRequestInput = {
  decision?: InputMaybe<OdProtosHomeworkServices_SignatureRequest_DecisionOneofInput>;
};

export type OdProtosHomeworkServices_SignatureRequest_DecisionOneofInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeworkServices_StartTriageProcessRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosHomeworkServices_StartTriageProcessRequest_SourceOneofInput>;
};

export type OdProtosHomeworkServices_StartTriageProcessRequest_SourceOneofInput = {
  incidentReportId?: InputMaybe<Scalars['String']['input']>;
  listingFeedbackId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  noteId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_SubmitChangeOrderRequestInput = {
  changeOrderId?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeworkServices_TriageIssueInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosHomeworkServices_TriagePriorityEnum {
  HIGH = 'HIGH',
  NORMAL = 'NORMAL',
  TRIAGE_PRIORITY_UNSPECIFIED = 'TRIAGE_PRIORITY_UNSPECIFIED',
  URGENT = 'URGENT'
}

export type OdProtosHomeworkServices_UnassignLineItemsCancelWorkOrderRequestInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_UncompleteLineItemRequestInput = {
  lineItemId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_UncompleteReworkRequestInput = {
  reworkId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_UnenrollReitRenovationRequestInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_UpdateChangeOrderRequestInput = {
  /**
   * When the change order was finalized
   * an error will be returned if the change order
   * has already been finalized [optional]
   * Only a construction manager can finalize a change order
   */
  finalizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The change order's id [required] */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * When the change order was submitted
   * an error will be returned if the change order
   * has already been submitted [optional]
   * Only a construction manager can submit a change order
   */
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeworkServices_UpdateLineItemRequestInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  accountCategory?: InputMaybe<OdProtosHomeworkServices_LineItemAccountCategoryValueInput>;
  areaId?: InputMaybe<Scalars['String']['input']>;
  /** Vendor can update these fields */
  assignedOnSiteWorkerId?: InputMaybe<Scalars['String']['input']>;
  associatedWith?: InputMaybe<OdProtosHomeworkServices_UpdateLineItemRequest_AssociatedWithOneofInput>;
  /** Deprecated */
  changeOrderId?: InputMaybe<Scalars['String']['input']>;
  costToken?: InputMaybe<Scalars['String']['input']>;
  defectId?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invalidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  noBeforePhotoReason?: InputMaybe<Scalars['String']['input']>;
  prefillId?: InputMaybe<Scalars['String']['input']>;
  prefillPriceMismatchComment?: InputMaybe<Scalars['String']['input']>;
  prefillPriceMismatchReason?: InputMaybe<Scalars['String']['input']>;
  repairIssue?: InputMaybe<Scalars['String']['input']>;
  repairScopeToken?: InputMaybe<Scalars['String']['input']>;
  requirementId?: InputMaybe<Scalars['String']['input']>;
  unsetAssociatedWith?: InputMaybe<Scalars['Boolean']['input']>;
  unsetBrnRepairItemToken?: InputMaybe<Scalars['Boolean']['input']>;
  unsetInvalidatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  unsetValidatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  unsetVendorCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Construction manager can update these fields */
  validatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vendorCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeworkServices_UpdateLineItemRequest_AssociatedWithOneofInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_UpdateLineItemScopeRequestInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally associate this scope with a change order */
  changeOrderId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  /** Construction manager fields */
  managerSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Vendor fields
   * We will allow the construction manager to set this field
   * temporarily
   */
  vendorSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
};

export type OdProtosHomeworkServices_UpdateProjectRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  budgetAmountCents?: InputMaybe<Scalars['Float']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** If kind = NONE (the default), no update is made */
  kind?: InputMaybe<OdProtosHomeworkData_ProjectKind>;
  lastMarkedSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  managedByBranchId?: InputMaybe<Scalars['String']['input']>;
  managerContactUserToken?: InputMaybe<Scalars['String']['input']>;
  ownedBy?: InputMaybe<OdProtosHomeworkServices_UpdateProjectRequest_OwnedByOneofInput>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  unsetCancelledAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosHomeworkServices_UpdateProjectRequest_OwnedByOneofInput = {
  /** An branch of an organization owns it */
  branchId?: InputMaybe<Scalars['String']['input']>;
  /** One person owns it */
  humanId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_UpdateProjectScopeRequestInput = {
  /** The budget in this scope */
  budgetAmountCents?: InputMaybe<Scalars['Float']['input']>;
  /** The id of the project scope to update */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The manager who accepted/rejected this project scope on behalf of Opendoor */
  managerSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
  /** The owner of the home who accepted/rejected this project scope */
  ownerSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosHomeworkServices_UpdateReworkRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  invalidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  unsetInvalidatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  unsetValidatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  unsetVendorCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Construction manager can update these fields */
  validatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Vendor can update these fields */
  vendorCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosHomeworkServices_UpdateVendorManagerRequestInput = {
  unsetVendorManagerId?: InputMaybe<Scalars['Boolean']['input']>;
  vendorManagerId?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_UpdateWorkOrderRequestInput = {
  accountingBuckets?: InputMaybe<OdProtosHomeworkServices_AccountingBucketListInput>;
  accountingClosedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Construction manager can update these fields */
  addressId?: InputMaybe<Scalars['String']['input']>;
  assignedToBranchId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeInHcr?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<OdProtosHomeworkServices_WorkOrderKindValueInput>;
  /** only construction manager can update this field */
  managerContactUserToken?: InputMaybe<Scalars['String']['input']>;
  managerFinalizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  messageThreadId?: InputMaybe<Scalars['String']['input']>;
  onSiteMessageThreadId?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  unsetManagerFinalizedAt?: InputMaybe<Scalars['Boolean']['input']>;
  unsetManagerId?: InputMaybe<Scalars['Boolean']['input']>;
  /** TODO: allow editing of project_id? */
  unsetVendorCommencedAt?: InputMaybe<Scalars['Boolean']['input']>;
  unsetVendorManagerId?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vendor can update these fields */
  vendorCommencedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vendorManagerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosHomeworkServices_UpdateWorkOrderScopeRequestInput = {
  budgetAmountCents?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Construction manager fields */
  managerSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  /** Vendor fields */
  vendorSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
};

export type OdProtosHomeworkServices_WorkOrderKindValueInput = {
  value?: InputMaybe<OdProtosHomeworkData_WorkOrder_Kind>;
};

/** Only value aggregations are supported for now */
export type OdProtosIndextriousData_AggregationInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * By default, the terms aggregation returns the top 1000 terms with the most documents.
   * Use the size parameter to return more terms, up to the search.max_buckets limit (65536).
   */
  size?: InputMaybe<Scalars['Float']['input']>;
  subAggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  topHits?: InputMaybe<OdProtosIndextriousData_Aggregation_TopHitsInput>;
};

export type OdProtosIndextriousData_Aggregation_TopHitsInput = {
  size?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export enum OdProtosIndextriousData_CashPlusStatus {
  CASH_PLUS_STATUS_FALSE = 'CASH_PLUS_STATUS_FALSE',
  CASH_PLUS_STATUS_NOT_APPLICABLE = 'CASH_PLUS_STATUS_NOT_APPLICABLE',
  CASH_PLUS_STATUS_TRUE = 'CASH_PLUS_STATUS_TRUE',
  CASH_PLUS_STATUS_UNKNOWN = 'CASH_PLUS_STATUS_UNKNOWN'
}

export type OdProtosIndextriousData_FilterInput = {
  value?: InputMaybe<OdProtosIndextriousData_Filter_ValueOneofInput>;
};

export type OdProtosIndextriousData_Filter_AndFilterInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /** Name of the filter. Useful for front end to identify the filter when it needs to be reset. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosIndextriousData_Filter_FieldExistsInput = {
  value?: InputMaybe<OdProtosIndextriousData_Filter_FieldExists_ValueOneofInput>;
};

export type OdProtosIndextriousData_Filter_FieldExists_ValueOneofInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  nestedField?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosIndextriousData_Filter_FieldNotExistsInput = {
  value?: InputMaybe<OdProtosIndextriousData_Filter_FieldNotExists_ValueOneofInput>;
};

export type OdProtosIndextriousData_Filter_FieldNotExists_ValueOneofInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  nestedField?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosIndextriousData_Filter_MultiFieldInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  operand?: InputMaybe<OdProtosIndextriousData_Filter_OperandInput>;
  operator?: InputMaybe<OdProtosIndextriousData_Filter_Operator>;
};

/**
 * NotFilter is a special case of AndFilter with only one filter.
 * It is used to negate the filter.
 */
export type OdProtosIndextriousData_Filter_NotFilterInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /** Name of the filter. Useful for front end to identify the filter when it needs to be reset. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosIndextriousData_Filter_OperandInput = {
  value?: InputMaybe<OdProtosIndextriousData_Filter_Operand_ValueOneofInput>;
};

export type OdProtosIndextriousData_Filter_Operand_ArrayValueInput = {
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosIndextriousData_Filter_Operand_GeoBoundingBoxValueInput = {
  bottomRight?: InputMaybe<OdProtosIndextriousData_GeoPointInput>;
  topLeft?: InputMaybe<OdProtosIndextriousData_GeoPointInput>;
};

export type OdProtosIndextriousData_Filter_Operand_GeoDistanceValueInput = {
  distance?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<OdProtosIndextriousData_GeoPointInput>;
};

export type OdProtosIndextriousData_Filter_Operand_GeoPolygonValueInput = {
  vertices?: InputMaybe<Array<OdProtosIndextriousData_GeoPointInput>>;
};

export type OdProtosIndextriousData_Filter_Operand_RangeValueInput = {
  gte?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  /** time_zone parameter is an UTC offset used to convert date values to UTC */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosIndextriousData_Filter_Operand_ValueOneofInput = {
  arrayValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_ArrayValueInput>;
  geoBoundingBoxValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_GeoBoundingBoxValueInput>;
  geoDistanceValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_GeoDistanceValueInput>;
  geoPolygonValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_GeoPolygonValueInput>;
  rangeValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_RangeValueInput>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosIndextriousData_Filter_Operator {
  EQUALS = 'EQUALS',
  /** GEO_BOUNDING_BOX is used to find documents with geo-points within a bounding box. */
  GEO_BOUNDING_BOX = 'GEO_BOUNDING_BOX',
  /** GEO_DISTANCE is used to find documents with geo-points within a certain distance of a central point. */
  GEO_DISTANCE = 'GEO_DISTANCE',
  /** GEO_POLYGON is used to find documents with geo-points within a polygon. */
  GEO_POLYGON = 'GEO_POLYGON',
  IN = 'IN',
  LIKE = 'LIKE',
  NOT_EQUALS = 'NOT_EQUALS',
  /**
   * PHRASE_PREFIX is used to match the beginning of a phrase. It also enforce the order of the words in the phrase.
   * For example, the phrase prefix query for "quick brown" will match documents with "quick brown fox" but not "brown fox quick".
   */
  PHRASE_PREFIX = 'PHRASE_PREFIX',
  /**
   * PREFIX is used to match the beginning of a text. It does not enforce the order of the words in the text.
   * For example, the prefix query for "quick brown" will match documents with "quick brown fox" and "brown fox quick".
   */
  PREFIX = 'PREFIX',
  RANGE = 'RANGE'
}

export type OdProtosIndextriousData_Filter_OrFilterInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /** Name of the filter. Useful for front end to identify the filter when it needs to be reset. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosIndextriousData_Filter_SingleFieldInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  operand?: InputMaybe<OdProtosIndextriousData_Filter_OperandInput>;
  operator?: InputMaybe<OdProtosIndextriousData_Filter_Operator>;
};

export type OdProtosIndextriousData_Filter_ValueOneofInput = {
  /**
   * To nest multiple 'and' filters within an 'or' filter
   * Note: By default all the *root* level filters are 'and' filters
   */
  and?: InputMaybe<OdProtosIndextriousData_Filter_AndFilterInput>;
  exists?: InputMaybe<OdProtosIndextriousData_Filter_FieldExistsInput>;
  multi?: InputMaybe<OdProtosIndextriousData_Filter_MultiFieldInput>;
  not?: InputMaybe<OdProtosIndextriousData_Filter_NotFilterInput>;
  notExists?: InputMaybe<OdProtosIndextriousData_Filter_FieldNotExistsInput>;
  or?: InputMaybe<OdProtosIndextriousData_Filter_OrFilterInput>;
  single?: InputMaybe<OdProtosIndextriousData_Filter_SingleFieldInput>;
};

export type OdProtosIndextriousData_GeoPointInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosIndextriousData_Index {
  ADDRESS = 'ADDRESS',
  BUYER_PROPERTY = 'BUYER_PROPERTY',
  CUSTOMER = 'CUSTOMER',
  /**
   * This field is deprecated. Use the 'document-reviews' index present as a child of the 'fulfillment' index instead.
   * @deprecated No longer supported
   */
  DOCUMENT = 'DOCUMENT',
  FULFILLMENT = 'FULFILLMENT',
  HODOR = 'HODOR',
  HUMAN = 'HUMAN',
  LISTING = 'LISTING',
  LISTING_OFFER = 'LISTING_OFFER',
  LWCLISTING = 'LWCLISTING',
  NOTE = 'NOTE',
  OPERATOR = 'OPERATOR',
  ORGANIZATION = 'ORGANIZATION',
  PROPERTY = 'PROPERTY',
  RENOVATION = 'RENOVATION',
  SELLER_LEAD = 'SELLER_LEAD',
  SELL_DIRECT_OFFER = 'SELL_DIRECT_OFFER',
  SHOWING = 'SHOWING',
  TASK = 'TASK',
  TICKET = 'TICKET',
  TOUR_REQUEST = 'TOUR_REQUEST',
  TRADE_PARTNER_WORK_ORDER = 'TRADE_PARTNER_WORK_ORDER'
}

export type OdProtosIndextriousData_IndexRequestInput = {
  /** ID of the doc to index */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Index name of the doc to index */
  index?: InputMaybe<OdProtosIndextriousData_Index>;
  /** Set only if the index needs to be done synchronously. Should not be required for the most scenarios. */
  sync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosIndextriousData_KnnQueryInput = {
  /** The vector field path (e.g., "tour_feedbacks.embedding") */
  field?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum number of results to return. When min_score is also set, k acts
   * as an upper bound on the radial search results.
   */
  k?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Minimum similarity score threshold using OpenSearch radial search. Valid
   * range is [0, 1] for the cosinesimil space type with the Lucene engine
   * (score = (1 + cosine_similarity) / 2). A value of 0.5 corresponds to
   * orthogonal vectors, 1.0 to identical vectors, and 0.0 to diametrically
   * opposed vectors. For example, 0.85 corresponds to ~70% cosine similarity.
   * When set, this replaces k in the KNN clause (they are mutually exclusive in
   * OpenSearch). If both k and min_score are provided, radial search is used and
   * results are truncated to k.
   *
   * Note: in hybrid mode (text_query + text_field set), min_score only gates
   * the KNN sub-clause. Documents matching only the BM25 text component may
   * still appear regardless of their vector similarity. min_score does not act
   * as a global quality threshold in hybrid queries.
   */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Boost factor for the BM25 text match relative to KNN score. Defaults to
   * 2.0 if not set. Higher values weight text matches more heavily.
   */
  textBoost?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional: text field to match against for hybrid BM25 + KNN scoring.
   * When set alongside text_query, results are ranked by combined BM25 text
   * relevance and KNN vector similarity (e.g., "listing_description").
   */
  textField?: InputMaybe<Scalars['String']['input']>;
  /**
   * The raw text query for BM25 matching (e.g., the user's search input).
   * Both text_field and text_query must be set to enable hybrid search.
   */
  textQuery?: InputMaybe<Scalars['String']['input']>;
  /** The query vector to search with */
  vector?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** Listing data entry states */
export enum OdProtosIndextriousData_ListingDataEntryState {
  LISTING_DATA_ENTRY_COMPLETE = 'LISTING_DATA_ENTRY_COMPLETE',
  LISTING_DATA_ENTRY_ESCALATED = 'LISTING_DATA_ENTRY_ESCALATED',
  LISTING_DATA_ENTRY_INCOMPLETE = 'LISTING_DATA_ENTRY_INCOMPLETE'
}

/** listing photos state */
export enum OdProtosIndextriousData_ListingPhotosState {
  LISTING_PHOTOS_COMPLETED = 'LISTING_PHOTOS_COMPLETED',
  LISTING_PHOTOS_DELAYED = 'LISTING_PHOTOS_DELAYED',
  LISTING_PHOTOS_PENDING = 'LISTING_PHOTOS_PENDING',
  LISTING_PHOTOS_SCHEDULED = 'LISTING_PHOTOS_SCHEDULED',
  LISTING_PHOTOS_UNKNOWN = 'LISTING_PHOTOS_UNKNOWN'
}

/** listing price state */
export enum OdProtosIndextriousData_ListingPriceState {
  LISTING_PRICE_DELAYED = 'LISTING_PRICE_DELAYED',
  LISTING_PRICE_PENDING = 'LISTING_PRICE_PENDING',
  LISTING_PRICE_RECEIVED = 'LISTING_PRICE_RECEIVED',
  LISTING_PRICE_UNKNOWN = 'LISTING_PRICE_UNKNOWN'
}

/** Listing Task states */
export enum OdProtosIndextriousData_ListingTaskState {
  TASK_CREATED = 'TASK_CREATED',
  TASK_SCHEDULED = 'TASK_SCHEDULED',
  TASK_SENT = 'TASK_SENT',
  TASK_UNKNOWN = 'TASK_UNKNOWN'
}

export type OdProtosIndextriousData_MigrateIndexRequestInput = {
  /**
   * If set to true, will auto promote the index after migration.
   * NOTE: if schema only is set to true, auto promotion won't happen.
   * It is done to reduce chances of any accidental index drops
   */
  autoPromote?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<OdProtosIndextriousData_Index>;
  /**
   * If set to true, will skip existing docs and migrate the scehma only.
   * Otherwise will migrate the schema and index existing docs with new schema.
   */
  schemaOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosIndextriousData_MilestoneStatus {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN'
}

export enum OdProtosIndextriousData_MlsTaskStatus {
  COMPLETED_TASK_STATUS = 'COMPLETED_TASK_STATUS',
  COMPLETED_WITH_ERROR_TASK_STATUS = 'COMPLETED_WITH_ERROR_TASK_STATUS',
  CONFIRMED_COMPLETED_TASK_STATUS = 'CONFIRMED_COMPLETED_TASK_STATUS',
  DISCREPANCY_DETECTED_TASK_STATUS = 'DISCREPANCY_DETECTED_TASK_STATUS',
  FATAL_TASK_STATUS = 'FATAL_TASK_STATUS',
  MANUALLY_RESOLVED_TASK_STATUS = 'MANUALLY_RESOLVED_TASK_STATUS',
  PENDING_TASK_STATUS = 'PENDING_TASK_STATUS',
  UNKNOWN_TASK_STATUS = 'UNKNOWN_TASK_STATUS',
  UNSUPPORTED_TASK_STATUS = 'UNSUPPORTED_TASK_STATUS'
}

export type OdProtosIndextriousData_PageParamsInput = {
  /** 0 indexed page number */
  number?: InputMaybe<Scalars['Float']['input']>;
  /** Number of items per page */
  size?: InputMaybe<Scalars['Float']['input']>;
};

/** photo approval states */
export enum OdProtosIndextriousData_PhotoReviewState {
  PHOTO_REVIEW_ACCEPTED = 'PHOTO_REVIEW_ACCEPTED',
  PHOTO_REVIEW_DELAYED = 'PHOTO_REVIEW_DELAYED',
  PHOTO_REVIEW_INCOMPLETE = 'PHOTO_REVIEW_INCOMPLETE',
  PHOTO_REVIEW_REJECTED = 'PHOTO_REVIEW_REJECTED'
}

export type OdProtosIndextriousData_PromoteIndexRequestInput = {
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

export type OdProtosIndextriousData_RankingFunctionInput = {
  /** Boost mode is used to define how the computed score is combined with the score of the original query. Defaults to multiply. */
  boostMode?: InputMaybe<OdProtosIndextriousData_RankingFunction_BoostMode>;
  functions?: InputMaybe<Array<OdProtosIndextriousData_RankingFunction_FunctionInput>>;
  /** Score mode is used to aggregate the score of the functions. Defaults to multiply. */
  scoreMode?: InputMaybe<OdProtosIndextriousData_RankingFunction_Function_ScoreMode>;
};

export enum OdProtosIndextriousData_RankingFunction_BoostMode {
  AVG = 'AVG',
  MAX = 'MAX',
  MIN = 'MIN',
  /** default */
  MULTIPLY = 'MULTIPLY',
  /** only function score is used, the query score is ignored */
  REPLACE = 'REPLACE',
  SUM = 'SUM'
}

export type OdProtosIndextriousData_RankingFunction_FunctionInput = {
  filter?: InputMaybe<OdProtosIndextriousData_FilterInput>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosIndextriousData_RankingFunction_Function_ScoreMode {
  AVG = 'AVG',
  /** the first function that has a matching filter is applied */
  FIRST = 'FIRST',
  MAX = 'MAX',
  MIN = 'MIN',
  /** default */
  MULTIPLY = 'MULTIPLY',
  SUM = 'SUM'
}

export type OdProtosIndextriousData_ReIndexRequestInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /** Index name to re-index docs */
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

/** setup visit State */
export enum OdProtosIndextriousData_SetupVisitState {
  SETUP_VISIT_COMPLETED = 'SETUP_VISIT_COMPLETED',
  SETUP_VISIT_PENDING = 'SETUP_VISIT_PENDING',
  SETUP_VISIT_SCHEDULED = 'SETUP_VISIT_SCHEDULED',
  SETUP_VISIT_UNKNOWN = 'SETUP_VISIT_UNKNOWN'
}

export enum OdProtosIndextriousData_Sla_SlaType {
  RESOLUTION = 'RESOLUTION'
}

export type OdProtosIndextriousData_SortByInput = {
  /** Needs to be set only for descending orders as default ordering is ascending */
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the order of items that are missing the above field. By default the order is LAST. */
  missing?: InputMaybe<OdProtosIndextriousData_SortBy_Missing>;
};

export enum OdProtosIndextriousData_SortBy_Missing {
  FIRST = 'FIRST',
  LAST = 'LAST'
}

export type OdProtosIndextriousServices_BackfillIndexRequestInput = {
  ids?: InputMaybe<OdProtosIndextriousServices_BackfillIndexRequest_IdsOneofInput>;
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

export type OdProtosIndextriousServices_BackfillIndexRequest_IdsAsStringListInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosIndextriousServices_BackfillIndexRequest_IdsOneofInput = {
  idsFromFile?: InputMaybe<Scalars['String']['input']>;
  stringIds?: InputMaybe<OdProtosIndextriousServices_BackfillIndexRequest_IdsAsStringListInput>;
};

export type OdProtosIndextriousServices_DeleteIndexRequestInput = {
  index?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosIndextriousServices_FulfillmentSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_GetIndexSchemaRequestInput = {
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

export type OdProtosIndextriousServices_HodorSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_ListAliasesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosIndextriousServices_ListIndexesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosIndextriousServices_OperatorSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_PruneIndexRequestInput = {
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

export type OdProtosIndextriousServices_RenovationSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SearchAddressesRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SearchIdsRequestInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  indexes?: InputMaybe<Array<OdProtosIndextriousData_Index>>;
};

export type OdProtosIndextriousServices_SearchIndicesRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /**
   * Controls whether KNN vector fields (embeddings) are returned in the
   * response. Presence-aware so the server can tell an explicit opt-out from
   * a legacy client that predates this field:
   *   - unset: server-side default applies (currently: include, for backward
   *     compatibility during rollout; a follow-up change will flip this to
   *     strip-by-default once every caller that needs embeddings has been
   *     migrated to set include_embeddings=true).
   *   - true:  embeddings are returned. Set this when the caller actually
   *     needs the raw vectors (e.g. to compute a centroid or preference
   *     vector client-side).
   *   - false: embeddings are stripped from _source. KNN search itself does
   *     not require them -- the vector index is consulted server-side
   *     regardless.
   */
  includeEmbeddings?: InputMaybe<Scalars['Boolean']['input']>;
  indexes?: InputMaybe<Array<OdProtosIndextriousData_Index>>;
  /**
   * Optional KNN vector search query. When provided, results are ranked by
   * vector similarity. Existing filters act as a pre-filter.
   */
  knn?: InputMaybe<OdProtosIndextriousData_KnnQueryInput>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SearchTradePartnerWorkOrderRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SellDirectOfferSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SwitchAliasRequestInput = {
  /** alias name to switch index for */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** new index name to alias */
  index?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosIndextriousServices_TaskSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_TicketSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

/**
 * UserIdentifier represents the identifier that the insight service uses
 * to determine the user.
 * Next ID: 3
 */
export type OdProtosInsightData_UserIdentifierInput = {
  userIdentifier?: InputMaybe<OdProtosInsightData_UserIdentifier_UserIdentifierOneofInput>;
};

export type OdProtosInsightData_UserIdentifier_UserIdentifierOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosInsightServices_InsightRequests_CheckUserAudiencesInput = {
  audiences?: InputMaybe<Array<Scalars['String']['input']>>;
  user?: InputMaybe<OdProtosInsightData_UserIdentifierInput>;
};

/** Next ID: 4 */
export type OdProtosInsightServices_InsightRequests_ListAudienceMemberIDsInput = {
  audience?: InputMaybe<Scalars['String']['input']>;
  /**
   * cursor should be null when getting the first page of results and it should contain
   * the returned cursor on subsequent requests.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** limit cannot be greater than 1000. If limit is 0 then it will be set to the default of 100. */
  limit?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Identifier represents the identifier that the insight service uses
 * to determine what entity to select
 * Next ID: 4
 */
export type OdProtosInsightV2Data_IdentifierInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_Identifier_IdentifierOneofInput>;
};

export type OdProtosInsightV2Data_Identifier_CustomerInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_Identifier_Customer_IdentifierOneofInput>;
};

export type OdProtosInsightV2Data_Identifier_Customer_IdentifierOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInsightV2Data_Identifier_IdentifierOneofInput = {
  customerIdentifier?: InputMaybe<OdProtosInsightV2Data_Identifier_CustomerInput>;
  leadIdentifier?: InputMaybe<OdProtosInsightV2Data_Identifier_LeadInput>;
  propertyIdentifier?: InputMaybe<OdProtosInsightV2Data_Identifier_PropertyInput>;
};

export type OdProtosInsightV2Data_Identifier_LeadInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_Identifier_Lead_IdentifierOneofInput>;
};

export type OdProtosInsightV2Data_Identifier_Lead_IdentifierOneofInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInsightV2Data_Identifier_PropertyInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_Identifier_Property_IdentifierOneofInput>;
};

export type OdProtosInsightV2Data_Identifier_Property_IdentifierOneofInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosInsightV2Services_GetMapValueForKeyRequestInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_IdentifierInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  traitName?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosInsightV2Services_GetTraitForIdentifierRequestInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_IdentifierInput>;
  traitName?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosInsightV2Services_GetTraitsForIdentifierRequestInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_IdentifierInput>;
  traitNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 3 */
export type OdProtosInsightV2Services_ResetTraitForIdentifierRequestInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_IdentifierInput>;
  /** A nil trait_name will reset all traits */
  traitName?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosInstitutionsData_Activity_Type {
  BID_UPLOAD = 'BID_UPLOAD',
  BULK_DOWNLOAD = 'BULK_DOWNLOAD',
  MLS_DOWNLOAD = 'MLS_DOWNLOAD',
  TAPE_DOWNLOAD = 'TAPE_DOWNLOAD',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

export enum OdProtosInstitutionsData_Alert_AlertType {
  GUARDRAIL = 'GUARDRAIL',
  UNKNOWN_ALERT_TYPE = 'UNKNOWN_ALERT_TYPE'
}

export enum OdProtosInstitutionsData_AuctionType {
  AGENT_SOURCED = 'AGENT_SOURCED',
  /** @deprecated No longer supported */
  BWODA = 'BWODA',
  DIRECT_SELLER = 'DIRECT_SELLER',
  HOME_BUILDER = 'HOME_BUILDER',
  LISTED = 'LISTED',
  /** @deprecated No longer supported */
  OD_EXCLUSIVES = 'OD_EXCLUSIVES',
  OD_SOURCED = 'OD_SOURCED',
  /** @deprecated No longer supported */
  OUT_OF_BUYBOX = 'OUT_OF_BUYBOX',
  OX_LISTING = 'OX_LISTING',
  PRE_LIST = 'PRE_LIST',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  /** @deprecated No longer supported */
  WALK = 'WALK'
}

export enum OdProtosInstitutionsData_BidAction {
  BUYER_ACCEPTS = 'BUYER_ACCEPTS',
  BUYER_ACCEPTS_UPDATE = 'BUYER_ACCEPTS_UPDATE',
  BUYER_ADDITIONAL_DETAILS_UPDATE = 'BUYER_ADDITIONAL_DETAILS_UPDATE',
  BUYER_COUNTERS = 'BUYER_COUNTERS',
  BUYER_COUNTERS_HIGHEST_AND_BEST = 'BUYER_COUNTERS_HIGHEST_AND_BEST',
  BUYER_SIGNS = 'BUYER_SIGNS',
  BUYER_WITHDRAWS = 'BUYER_WITHDRAWS',
  OD_ACCEPTS = 'OD_ACCEPTS',
  OD_REJECTS = 'OD_REJECTS',
  OD_SENDS_CONTRACT = 'OD_SENDS_CONTRACT',
  PROCESS_INVENTORY_BID = 'PROCESS_INVENTORY_BID',
  PROCESS_OBS_BID = 'PROCESS_OBS_BID',
  RECHECK_ELIGIBILITY = 'RECHECK_ELIGIBILITY',
  REINSTATE_BID = 'REINSTATE_BID',
  SELLER_ACCEPTS_INVENTORY_BID = 'SELLER_ACCEPTS_INVENTORY_BID',
  SELLER_ACCEPTS_INVENTORY_COUNTER = 'SELLER_ACCEPTS_INVENTORY_COUNTER',
  SELLER_ACCEPTS_INVENTORY_HIGHEST_AND_BEST = 'SELLER_ACCEPTS_INVENTORY_HIGHEST_AND_BEST',
  SELLER_ACCEPTS_OBS_BID = 'SELLER_ACCEPTS_OBS_BID',
  SELLER_ACCEPTS_OBS_COUNTER = 'SELLER_ACCEPTS_OBS_COUNTER',
  SELLER_ACCEPTS_OBS_HIGHEST_AND_BEST = 'SELLER_ACCEPTS_OBS_HIGHEST_AND_BEST',
  SELLER_ACCEPTS_UPDATED_OFFER = 'SELLER_ACCEPTS_UPDATED_OFFER',
  SELLER_COUNTERS = 'SELLER_COUNTERS',
  /** @deprecated No longer supported */
  SELLER_COUNTERS_COUNTER = 'SELLER_COUNTERS_COUNTER',
  SELLER_COUNTERS_HIGHEST_AND_BEST = 'SELLER_COUNTERS_HIGHEST_AND_BEST',
  SELLER_REJECTS = 'SELLER_REJECTS',
  SELLER_REJECTS_COUNTER = 'SELLER_REJECTS_COUNTER',
  SELLER_REJECTS_HIGHEST_AND_BEST = 'SELLER_REJECTS_HIGHEST_AND_BEST',
  SELLER_SENDS_ADDITIONAL_DETAILS = 'SELLER_SENDS_ADDITIONAL_DETAILS',
  SELLER_SENDS_CONTRACT = 'SELLER_SENDS_CONTRACT',
  SELLER_SIGNS = 'SELLER_SIGNS',
  SEND_PROPERTY_FLAGS = 'SEND_PROPERTY_FLAGS',
  TERMINATE_CONTRACT = 'TERMINATE_CONTRACT',
  UNKNOWN_ACTION = 'UNKNOWN_ACTION'
}

/**
 * The initial bid state is product specific:
 * (*) Resale - AWAITING_SELLER_OFFER_EVALUATION
 * (*) BwODA - AWAITING_OD_TO_SEND_CONTRACT
 * (*) OBS - AWAITING_OD_OFFER_EVALUATION
 */
export enum OdProtosInstitutionsData_BidState {
  /** @deprecated No longer supported */
  AWAITING_ADDITIONAL_DETAILS_FROM_SELLER = 'AWAITING_ADDITIONAL_DETAILS_FROM_SELLER',
  /** @deprecated No longer supported */
  AWAITING_BUYER_ADDITIONAL_HOME_DETAIL_EVALUATION = 'AWAITING_BUYER_ADDITIONAL_HOME_DETAIL_EVALUATION',
  AWAITING_BUYER_COUNTER_EVALUATION = 'AWAITING_BUYER_COUNTER_EVALUATION',
  AWAITING_BUYER_HIGHEST_AND_BEST_EVALUATION = 'AWAITING_BUYER_HIGHEST_AND_BEST_EVALUATION',
  /** @deprecated No longer supported */
  AWAITING_BUYER_OFFER_EVALUATION = 'AWAITING_BUYER_OFFER_EVALUATION',
  /** @deprecated No longer supported */
  AWAITING_BUYER_REJECTION_EVALUATION = 'AWAITING_BUYER_REJECTION_EVALUATION',
  AWAITING_BUYER_SIGNATURE = 'AWAITING_BUYER_SIGNATURE',
  AWAITING_OD_OFFER_EVALUATION = 'AWAITING_OD_OFFER_EVALUATION',
  /** @deprecated No longer supported */
  AWAITING_OD_TO_SEND_CONTRACT = 'AWAITING_OD_TO_SEND_CONTRACT',
  AWAITING_SELLER_COUNTER_EVALUATION = 'AWAITING_SELLER_COUNTER_EVALUATION',
  AWAITING_SELLER_HIGHEST_AND_BEST_EVALUATION = 'AWAITING_SELLER_HIGHEST_AND_BEST_EVALUATION',
  AWAITING_SELLER_OFFER_EVALUATION = 'AWAITING_SELLER_OFFER_EVALUATION',
  AWAITING_SELLER_SIGNATURE = 'AWAITING_SELLER_SIGNATURE',
  /** @deprecated No longer supported */
  AWAITING_SELLER_TO_SEND_CONTRACT = 'AWAITING_SELLER_TO_SEND_CONTRACT',
  /** @deprecated No longer supported */
  AWAITING_SELLER_UPDATED_OFFER_EVALUATION = 'AWAITING_SELLER_UPDATED_OFFER_EVALUATION',
  /** @deprecated No longer supported */
  BID_RECEIVED = 'BID_RECEIVED',
  BUYER_WITHDRAWN = 'BUYER_WITHDRAWN',
  CLEAR_TO_CLOSE = 'CLEAR_TO_CLOSE',
  CLOSED = 'CLOSED',
  /** @deprecated No longer supported */
  COUNTERED = 'COUNTERED',
  /** @deprecated No longer supported */
  COUNTERED_HIGHEST_AND_BEST = 'COUNTERED_HIGHEST_AND_BEST',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  /** @deprecated No longer supported */
  LOST = 'LOST',
  OD_REJECTED = 'OD_REJECTED',
  /**
   * The following bid states are deprecated and are not actively used anymore.
   * @deprecated No longer supported
   */
  PENDING = 'PENDING',
  PENDING_CLOSE = 'PENDING_CLOSE',
  SELLER_REJECTED = 'SELLER_REJECTED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE',
  /** @deprecated No longer supported */
  WON = 'WON'
}

/** commission structure will differ from normal bwoda procedure if there is a referral */
export enum OdProtosInstitutionsData_Bid_ReferralSourcedBy {
  BUYER = 'BUYER',
  OPENDOOR = 'OPENDOOR',
  UNKNOWN_REFERRAL_TYPE = 'UNKNOWN_REFERRAL_TYPE'
}

export type OdProtosInstitutionsData_Bid_SubmissionInfoInput = {
  escrowCompanyOrganizationId?: InputMaybe<Scalars['String']['input']>;
  referralSourcedBy?: InputMaybe<OdProtosInstitutionsData_Bid_ReferralSourcedBy>;
  titleCompanyOrganizationId?: InputMaybe<Scalars['String']['input']>;
};

/** go live dates for products */
export type OdProtosInstitutionsData_BrokerageRegion_LaunchDatesInput = {
  bwoda?: InputMaybe<OdProtosCommon_DateInput>;
  listed?: InputMaybe<OdProtosCommon_DateInput>;
  prelist?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsData_BrokerageRegion_PreferencesInput = {
  /** e.g. Austin, TX */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** composite of city and state e.g. austin_tx */
  identifier?: InputMaybe<Scalars['String']['input']>;
  launchDates?: InputMaybe<OdProtosInstitutionsData_BrokerageRegion_LaunchDatesInput>;
  listingMlsList?: InputMaybe<Array<OdProtosInstitutionsData_MlsInput>>;
  /** managed by backend for now, TODO: update mls_list to be modified by UI */
  mlsList?: InputMaybe<Array<OdProtosCommonMls_Mls>>;
};

export type OdProtosInstitutionsData_Buybox_CriteriaInput = {
  allowPrivatePools?: InputMaybe<Scalars['Boolean']['input']>;
  bathrooms?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_FloatRangeInput>;
  bedrooms?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_IntRangeInput>;
  dwellingTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  estimatedCurrentYieldPct?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_FloatRangeInput>;
  guidancePrice?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_IntRangeInput>;
  minYearBuilt?: InputMaybe<Scalars['Int']['input']>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sqFt?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_IntRangeInput>;
};

export type OdProtosInstitutionsData_Buybox_Criteria_FloatRangeInput = {
  gte?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

/** use wrappers when a field is nullable */
export type OdProtosInstitutionsData_Buybox_Criteria_IntRangeInput = {
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The date preference manages a specific RelativeDate (for CH) or date field
 * for a bid.
 */
export type OdProtosInstitutionsData_DatePreferenceInput = {
  dayType?: InputMaybe<OdProtosInstitutionsData_DatePreference_DayType>;
  /** Date preference is this many days from an anchor. */
  days?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosInstitutionsData_DatePreference_DayType {
  /** Mon-Fri excluding national holidays. */
  BUSINESS = 'BUSINESS',
  CALENDAR = 'CALENDAR',
  /**
   * Same as calendar days but if the end date is not a business day, go to
   * the next business day
   */
  CALENDAR_ENDING_ON_BUSINESS = 'CALENDAR_ENDING_ON_BUSINESS',
  DAY_TYPE_UNKNOWN = 'DAY_TYPE_UNKNOWN'
}

export type OdProtosInstitutionsData_DateRangeInput = {
  gte?: InputMaybe<OdProtosCommon_DateInput>;
  lt?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsData_DecisionInput = {
  analystAction?: InputMaybe<Scalars['String']['input']>;
  analystActionDescriptions?: InputMaybe<Scalars['String']['input']>;
  analystActionReasons?: InputMaybe<Scalars['String']['input']>;
  analystSignedOff?: InputMaybe<Scalars['Boolean']['input']>;
  analystSuggestedCloseOfEscrow?: InputMaybe<Scalars['DateTime']['input']>;
  analystSuggestedCounterAmountCents?: InputMaybe<Scalars['Float']['input']>;
  analystSuggestedCounterCommissionPct?: InputMaybe<Scalars['Float']['input']>;
  analystSuggestedDdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  analystSuggestedEarnestMoneyDepositCents?: InputMaybe<Scalars['Float']['input']>;
  analystSuggestedExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  analystSuggestedRejectionCode?: InputMaybe<Scalars['String']['input']>;
  analystSuggestedRejectionDescription?: InputMaybe<Scalars['String']['input']>;
  decisionableType?: InputMaybe<Scalars['String']['input']>;
  decisionableUuid?: InputMaybe<Scalars['String']['input']>;
  imsResponse?: InputMaybe<Scalars['String']['input']>;
  isBackup?: InputMaybe<Scalars['Boolean']['input']>;
  offerDecision?: InputMaybe<Scalars['String']['input']>;
  offerDecisionDescriptions?: InputMaybe<Scalars['String']['input']>;
  offerDecisionReasons?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export enum OdProtosInstitutionsData_Event_Type {
  BID_ASSIGNEE_UPDATED = 'BID_ASSIGNEE_UPDATED',
  BID_CREATED = 'BID_CREATED',
  BID_STATE_UPDATED = 'BID_STATE_UPDATED',
  BID_TAG_CREATED = 'BID_TAG_CREATED',
  BID_TAG_DELETED = 'BID_TAG_DELETED',
  BID_UPDATED = 'BID_UPDATED',
  BROKER_COMMENTS_UPDATED = 'BROKER_COMMENTS_UPDATED',
  DOCUMENT_CREATED = 'DOCUMENT_CREATED',
  DOCUMENT_EXECUTED = 'DOCUMENT_EXECUTED',
  DOCUMENT_REVIEWS_CREATED = 'DOCUMENT_REVIEWS_CREATED',
  DOCUMENT_REVIEWS_UPDATED = 'DOCUMENT_REVIEWS_UPDATED',
  DOCUMENT_SIGNED = 'DOCUMENT_SIGNED',
  DOCUMENT_STATUS_UPDATED = 'DOCUMENT_STATUS_UPDATED',
  DOCUMENT_UPDATED = 'DOCUMENT_UPDATED',
  DOCUMENT_VERSION_CREATED = 'DOCUMENT_VERSION_CREATED',
  DOCUMENT_VERSION_UPDATED = 'DOCUMENT_VERSION_UPDATED',
  INSPECTION_STATE_UPDATED = 'INSPECTION_STATE_UPDATED',
  PARTICIPANT_CREATED = 'PARTICIPANT_CREATED',
  PARTICIPANT_UPDATED = 'PARTICIPANT_UPDATED',
  SIGNATURE_REQUEST_CREATED = 'SIGNATURE_REQUEST_CREATED',
  SIGNATURE_REQUEST_UPDATED = 'SIGNATURE_REQUEST_UPDATED',
  TERM_DATE_UPDATED = 'TERM_DATE_UPDATED',
  TERM_UPDATED = 'TERM_UPDATED',
  TRANSACTION_CREATED = 'TRANSACTION_CREATED',
  TRANSACTION_UPDATED = 'TRANSACTION_UPDATED',
  UNKNOWN_EVENT_TYPE = 'UNKNOWN_EVENT_TYPE'
}

/** Next ID: 7 */
export enum OdProtosInstitutionsData_ExternalPermission {
  API_DOCUMENTATION_READ = 'API_DOCUMENTATION_READ',
  BUYBOX_READ = 'BUYBOX_READ',
  BUYBOX_WRITE = 'BUYBOX_WRITE',
  MLS_READ = 'MLS_READ',
  RENT_ESTIMATE_READ = 'RENT_ESTIMATE_READ',
  SETTINGS_READ = 'SETTINGS_READ',
  SETTINGS_WRITE = 'SETTINGS_WRITE',
  UNKNOWN_EXTERNAL_PERMISSION = 'UNKNOWN_EXTERNAL_PERMISSION'
}

export type OdProtosInstitutionsData_HomebuilderLeadInput = {
  addedAt?: InputMaybe<OdProtosCommon_DateInput>;
  availableAt?: InputMaybe<OdProtosCommon_DateInput>;
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  bedrooms?: InputMaybe<Scalars['Float']['input']>;
  builderName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  constructionStatus?: InputMaybe<Scalars['String']['input']>;
  currentPriceUsd?: InputMaybe<Scalars['Int']['input']>;
  garageSpaces?: InputMaybe<Scalars['Float']['input']>;
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeptic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSolarPanels?: InputMaybe<Scalars['Boolean']['input']>;
  hoaMonthlyFeesCents?: InputMaybe<Scalars['Int']['input']>;
  interiorSqFt?: InputMaybe<Scalars['Float']['input']>;
  lot?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalPriceUsd?: InputMaybe<Scalars['Float']['input']>;
  plElevation?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  subdivisionProject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<OdProtosCommon_DateInput>;
  yearBuilt?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 7 */
export enum OdProtosInstitutionsData_InspectionState {
  AWAITING_INSPECTION = 'AWAITING_INSPECTION',
  /** for when a reit has marked their inspection complete */
  AWAITING_INSPECTION_COMPLETION = 'AWAITING_INSPECTION_COMPLETION',
  /** for when a reit has completed the inspection but we are waiting for them to either counter or release contingencies */
  AWAITING_INSPECTION_RESULTS = 'AWAITING_INSPECTION_RESULTS',
  AWAITING_INSPECTION_SCHEDULED = 'AWAITING_INSPECTION_SCHEDULED',
  INSPECTION_CONTINGENCY_RELEASED = 'INSPECTION_CONTINGENCY_RELEASED',
  /**
   * we are using AWAITING_INSPECTION instead
   * @deprecated No longer supported
   */
  INSPECTION_SCHEDULED = 'INSPECTION_SCHEDULED',
  POST_INSPECTION_NEGOTIATION = 'POST_INSPECTION_NEGOTIATION',
  UNKNOWN_INSPECTION_STATE = 'UNKNOWN_INSPECTION_STATE'
}

/** Next ID: 18 */
export enum OdProtosInstitutionsData_InternalPermission {
  ADMIN = 'ADMIN',
  ADVANCED_UI_FEATURES = 'ADVANCED_UI_FEATURES',
  AGENT_OPERATOR_READ = 'AGENT_OPERATOR_READ',
  AGENT_OPERATOR_WRITE = 'AGENT_OPERATOR_WRITE',
  ELIGIBLE_PRODUCTS_READ = 'ELIGIBLE_PRODUCTS_READ',
  ELIGIBLE_PRODUCTS_WRITE = 'ELIGIBLE_PRODUCTS_WRITE',
  KEY_TERMS_READ = 'KEY_TERMS_READ',
  KEY_TERMS_WRITE = 'KEY_TERMS_WRITE',
  MANUAL_BID_UPLOAD_READ = 'MANUAL_BID_UPLOAD_READ',
  MANUAL_BID_UPLOAD_WRITE = 'MANUAL_BID_UPLOAD_WRITE',
  PARTICIPANTS_READ = 'PARTICIPANTS_READ',
  PARTICIPANTS_WRITE = 'PARTICIPANTS_WRITE',
  PIPELINE_READ = 'PIPELINE_READ',
  PIPELINE_WRITE = 'PIPELINE_WRITE',
  RESALE_READ = 'RESALE_READ',
  RESALE_WRITE = 'RESALE_WRITE',
  TASK_CONFIG_READ = 'TASK_CONFIG_READ',
  TASK_CONFIG_WRITE = 'TASK_CONFIG_WRITE',
  TASK_READ = 'TASK_READ',
  TASK_WRITE = 'TASK_WRITE',
  UNKNOWN_INTERNAL_PERMISSION = 'UNKNOWN_INTERNAL_PERMISSION'
}

export enum OdProtosInstitutionsData_LeadEvent_LeadEventType {
  /** A Lead record is deleted */
  DELETE = 'DELETE',
  /** A Lead record is created */
  INSERT = 'INSERT',
  /** A Lead record is updated */
  UPDATE = 'UPDATE'
}

export enum OdProtosInstitutionsData_LeadType {
  LEAD_TYPE_AGENT_SOURCED = 'LEAD_TYPE_AGENT_SOURCED',
  /** @deprecated No longer supported */
  LEAD_TYPE_BWODA = 'LEAD_TYPE_BWODA',
  LEAD_TYPE_DIRECT_SELLER = 'LEAD_TYPE_DIRECT_SELLER',
  LEAD_TYPE_HOME_BUILDER = 'LEAD_TYPE_HOME_BUILDER',
  LEAD_TYPE_LISTED = 'LEAD_TYPE_LISTED',
  LEAD_TYPE_ODLS_MANUAL = 'LEAD_TYPE_ODLS_MANUAL',
  /** @deprecated No longer supported */
  LEAD_TYPE_OD_EXCLUSIVES = 'LEAD_TYPE_OD_EXCLUSIVES',
  LEAD_TYPE_OD_SOURCED = 'LEAD_TYPE_OD_SOURCED',
  /** @deprecated No longer supported */
  LEAD_TYPE_OUT_OF_BUYBOX = 'LEAD_TYPE_OUT_OF_BUYBOX',
  LEAD_TYPE_PRELIST = 'LEAD_TYPE_PRELIST',
  LEAD_TYPE_UNSPECIFIED = 'LEAD_TYPE_UNSPECIFIED',
  /** @deprecated No longer supported */
  LEAD_TYPE_WALK = 'LEAD_TYPE_WALK'
}

export type OdProtosInstitutionsData_Lead_HomeDetails_HoaInput = {
  fee?: InputMaybe<OdProtosCommon_MoneyInput>;
  feeFrequency?: InputMaybe<Scalars['String']['input']>;
  hasLeasingRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosInstitutionsData_Lead_LeadState {
  /**
   * Lead is actively receiving offers.
   * Terminal: No
   */
  ACTIVE = 'ACTIVE',
  /**
   * A sale has gone through and is now closed.
   * Terminal: Yes.
   */
  CLOSED = 'CLOSED',
  /** Terminal: No. */
  COMING_SOON = 'COMING_SOON',
  /**
   * Lead has expired and is no longer current.
   * Terminal: Yes
   */
  EXPIRED = 'EXPIRED',
  /**
   * Lead is not necessarily on MLS, typically associated with Exclusives.
   * Terminal: No
   */
  PRIVATELY_LISTED = 'PRIVATELY_LISTED',
  /** Terminal: No. */
  SALE_PENDING = 'SALE_PENDING',
  /** Terminal: No. */
  TEMP_OFF_MARKET = 'TEMP_OFF_MARKET',
  UNSPECIFIED_STATE = 'UNSPECIFIED_STATE',
  /**
   * Lead is not actively receiving offers.
   * Terminal: Yes
   */
  WITHDRAWN = 'WITHDRAWN'
}

export type OdProtosInstitutionsData_Lead_ListingAgentInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  mlsId?: InputMaybe<Scalars['String']['input']>;
  mlsName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_Lead_NewBuildInfoInput = {
  builderName?: InputMaybe<Scalars['String']['input']>;
  constructionStatus?: InputMaybe<Scalars['String']['input']>;
  isNewBuild?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Scalars['String']['input']>;
  plElevation?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  subdivisionProject?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_Lead_SellerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_MarketSettingsInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
};

/** These map to member roles in https://admin.opendoor.com/admin/organizations/23960 */
export enum OdProtosInstitutionsData_MemberRole {
  /** Role for BPO LSS. */
  BPO_LSS = 'BPO_LSS',
  /** Role for the Broker. */
  BROKER = 'BROKER',
  /** Role for the Transaction Coordinator. */
  CUSTOMER_EXPERIENCE_PARTNER = 'CUSTOMER_EXPERIENCE_PARTNER',
  LICENSED_HOME_ADVISOR = 'LICENSED_HOME_ADVISOR',
  /** Role for the Listing Coordinator. */
  LISTING_COORDINATOR = 'LISTING_COORDINATOR',
  OBS_MANAGER = 'OBS_MANAGER',
  /** Role for the Portfolio Manager. */
  PORTFOLIO_MANAGER = 'PORTFOLIO_MANAGER',
  /** Role for the Pricing Analyst. */
  PRICING_ANALYST = 'PRICING_ANALYST',
  /** Role for the Pricing Lead. */
  PRICING_LEAD = 'PRICING_LEAD',
  /** Temporary role that acts similar to CEP and handles inspection scheduling. */
  TRANSACTION_SUPPORT_SPECIALIST = 'TRANSACTION_SUPPORT_SPECIALIST',
  UNKNOWN_MEMBER_ROLE = 'UNKNOWN_MEMBER_ROLE'
}

export type OdProtosInstitutionsData_MlsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_MonetaryPreferenceInput = {
  preference?: InputMaybe<OdProtosInstitutionsData_MonetaryPreference_PreferenceOneofInput>;
};

export type OdProtosInstitutionsData_MonetaryPreference_PreferenceOneofInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** 0-100 */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsData_NegotiationInput = {
  amountCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  bidUuid?: InputMaybe<Scalars['String']['input']>;
  commissionPct?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated fields */
  deadline?: InputMaybe<OdProtosCommon_DateInput>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  decision?: InputMaybe<OdProtosInstitutionsData_DecisionInput>;
  isBuyerRequested?: InputMaybe<Scalars['Boolean']['input']>;
  listingOfferId?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * We need to wrap the oneof inside Permission
 * because protobuf does not support repeated oneof
 */
export type OdProtosInstitutionsData_PermissionsInput = {
  externalPermissions?: InputMaybe<Array<OdProtosInstitutionsData_ExternalPermission>>;
  internalPermissions?: InputMaybe<Array<OdProtosInstitutionsData_InternalPermission>>;
};

/**
 * Reit settings are preferences for specific (or default) reit, brokerage_region, and
 * product type combinations. The final preferences applied to a bid are
 * computed based on the override levels.
 *
 * Override levels:
 *   (0) default reit + default brokerage region
 *   (1) default reit + specific brokerage region
 *   (2) default reit + specific brokerage region + specific product type
 *   (3) specific reit + default brokerage region
 *   (4) specific reit + specific brokerage region
 *   (5) specific reit + specific brokerage region + specific product type
 *
 * Next id: 11
 */
export type OdProtosInstitutionsData_ReitSettingsInput = {
  brokerageRegionId?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  preferences?: InputMaybe<OdProtosInstitutionsData_ReitSettings_PreferencesInput>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
  state?: InputMaybe<OdProtosCommonState_State>;
};

/** Next id: 52 */
export type OdProtosInstitutionsData_ReitSettings_PreferencesInput = {
  appraisalContingencyDeadline?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  /** The number of days before a previously bid on lead is re-shown in feeds. */
  bidLifetimeDays?: InputMaybe<Scalars['Float']['input']>;
  brokerContact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  /** Contact information for the default broker and brokerage participants */
  brokerageContact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  brokerageVendorId?: InputMaybe<Scalars['String']['input']>;
  /** These participant preferences are human token only (for v1). */
  buyerAgent?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  /** Contact information for the default buyer agent participant */
  buyerAgentContact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  buyerCloser?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  buyerCredit?: InputMaybe<OdProtosCommon_MoneyInput>;
  buyerInspector?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  buyerPrincipal?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  buyerReferralCommission?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  buyerSignatory?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  buyerUnderwriter?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  /** Vendor branch ids used in transactions, editable through participants page for now */
  bwodaAgentVendorId?: InputMaybe<Scalars['String']['input']>;
  closeOfEscrow?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  /**
   * The conveyances preference is added "as-is" to the transaction terms for
   * a bid.
   */
  conveyances?: InputMaybe<OdProtosInstitutionsReithouseData_ConveyancesInput>;
  /**
   * These freeform preferences are not stored on the bid or transaction,
   * instead are used as reference settings (similar to guardrail preferences).
   */
  customPreferences?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_CustomPreferenceInput>>;
  /** This is deprecated. Use inspection_contingency_deadline. */
  dueDiligence?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  earnestDeposit?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_EarnestDepositInput>;
  earnestDepositDue?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  escrowCompanies?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput>>;
  escrowCompany?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput>;
  escrowContact?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  /**
   * @TODO Need to remove escrow_contacts and escrow_companies once we removed the escrow_companies
   * @TODO implementation in Institutions.
   * Note: Do not need to migrate escrow_companies data as it has the same data with the escrow_company
   */
  escrowContacts?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>>;
  /** Operators will manually configure the escrows on the reit settings page. */
  escrowOrganizationUsers?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationUserContactInput>>;
  financingType?: InputMaybe<OdProtosInstitutionsReithouseData_FinancingTypeInput>;
  inspectionContingencyDeadline?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  minimumInspectionContingencyDeadlineToCoe?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  /**
   * These "guardrail preferences" are not stored on the bid or transaction,
   * instead they are used to produce "guardrail alerts" on the detail view.
   */
  minimumInspectionDateToInspectionContingencyDeadline?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  obsAgentVendorId?: InputMaybe<Scalars['String']['input']>;
  /** default commission percentages */
  odaCommission?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  odaOperatorBranchId?: InputMaybe<Scalars['String']['input']>;
  offerExpiration?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  opendoorReferralCommission?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  optionMoney?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_OptionMoneyInput>;
  oxFee?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  oxListingCommission?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  propertyFlags?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlagsInput>;
  resolutionPeriodDeadline?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  sellerCredit?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  /** This is deprecated. Use inspection_contingency_deadline. */
  terminationOptionPeriod?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  titleCompanies?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput>>;
  titleCompany?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput>;
  transactionCoordinator?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  /**
   * Overrides preferences (at the current level) for any bid on a property
   * that meets the year built condition (i.e. year_built >= 2019).
   */
  yearBuiltOverride?: InputMaybe<OdProtosInstitutionsData_YearBuiltOverrideInput>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_CustomPreferenceInput = {
  applicableBidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_EarnestDepositInput = {
  nonrefundableAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  refundableAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_OptionMoneyInput = {
  buyerAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  opendoorAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationUserContactInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlagsInput = {
  hoaRestrictions?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HoaRestrictionsInput>;
  homeCondition?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HomeConditionInput>;
  homeFeatures?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HomeFeaturesInput>;
  locationFeatures?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_LocationFeaturesInput>;
  other?: InputMaybe<Scalars['String']['input']>;
  parkingRequirements?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_ParkingRequirementsInput>;
  tenantOccupancy?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_TenantOccupancyInput>;
  titlePreference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HoaRestrictionsInput = {
  capacityThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  hoaRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  leaseRequirement?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HomeConditionInput = {
  extensiveLandscapeRepair?: InputMaybe<Scalars['Boolean']['input']>;
  foundationIssues?: InputMaybe<Scalars['Boolean']['input']>;
  waterIntrusionDamage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HomeFeaturesInput = {
  oilTank?: InputMaybe<Scalars['Boolean']['input']>;
  polybutylenePlumbing?: InputMaybe<Scalars['Boolean']['input']>;
  septic?: InputMaybe<Scalars['Boolean']['input']>;
  sharedDriveway?: InputMaybe<Scalars['Boolean']['input']>;
  slopedLots?: InputMaybe<Scalars['Boolean']['input']>;
  solarPanels?: InputMaybe<Scalars['Boolean']['input']>;
  wellWater?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_LocationFeaturesInput = {
  busyStreet?: InputMaybe<Scalars['Boolean']['input']>;
  commercialZone?: InputMaybe<Scalars['Boolean']['input']>;
  floodZone?: InputMaybe<Scalars['Boolean']['input']>;
  highCrimeZoneRating?: InputMaybe<Scalars['Boolean']['input']>;
  highVoltageWiresPoles?: InputMaybe<Scalars['Boolean']['input']>;
  lowSchoolZoneRating?: InputMaybe<Scalars['Boolean']['input']>;
  openWater?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_ParkingRequirementsInput = {
  attachedGarage?: InputMaybe<Scalars['Boolean']['input']>;
  carport?: InputMaybe<Scalars['Boolean']['input']>;
  coveredParking?: InputMaybe<Scalars['Boolean']['input']>;
  detachedGarage?: InputMaybe<Scalars['Boolean']['input']>;
  pavedDriveway?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_TenantOccupancyInput = {
  occupancyInMonths?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_SellableInfoInput = {
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  /** TODO: migrate onto this field from type, then switch type to be Sellable.Type */
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
  sourceType?: InputMaybe<OdProtosRealtyCommon_Source_Type>;
  /**
   * For prelist and inventory, token is the flip token.
   * For direct_seller, out of buybox, and walk, token is the lead token.
   * For bwoda, mls, token (id), and source_type come from the ODLS sell request's source.
   */
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosInstitutionsData_AuctionType>;
};

export enum OdProtosInstitutionsData_Sellable_Type {
  AGENT_SOURCED = 'AGENT_SOURCED',
  /** @deprecated No longer supported */
  BWODA = 'BWODA',
  DIRECT_SELLER = 'DIRECT_SELLER',
  HOME_BUILDER = 'HOME_BUILDER',
  LISTED = 'LISTED',
  /** @deprecated No longer supported */
  OD_EXCLUSIVES = 'OD_EXCLUSIVES',
  OD_SOURCED = 'OD_SOURCED',
  /** @deprecated No longer supported */
  OUT_OF_BUYBOX = 'OUT_OF_BUYBOX',
  OX_LISTING = 'OX_LISTING',
  PRE_LIST = 'PRE_LIST',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  /** @deprecated No longer supported */
  WALK = 'WALK'
}

export type OdProtosInstitutionsData_TimestampRangeInput = {
  /** Include results that have been greater than or equal to */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include results that have been less than */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosInstitutionsData_UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<OdProtosInstitutionsData_PermissionsInput>;
  productionApiToken?: InputMaybe<Scalars['String']['input']>;
  readmeUrl?: InputMaybe<Scalars['String']['input']>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
  slackId?: InputMaybe<Scalars['String']['input']>;
  stagingApiToken?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsData_YearBuiltOverrideInput = {
  gte?: InputMaybe<Scalars['Float']['input']>;
  preferences?: InputMaybe<OdProtosInstitutionsData_ReitSettings_PreferencesInput>;
};

export enum OdProtosInstitutionsExternal_BidStatus {
  AWAITING_SIGNATURE = 'AWAITING_SIGNATURE',
  CLEAR_TO_CLOSE = 'CLEAR_TO_CLOSE',
  CLOSED = 'CLOSED',
  INSPECTION_PERIOD = 'INSPECTION_PERIOD',
  IN_NEGOTIATION = 'IN_NEGOTIATION',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  NEW_OFFER = 'NEW_OFFER',
  PENDING_CLOSE = 'PENDING_CLOSE',
  REJECTED = 'REJECTED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_BID_STATUS = 'UNKNOWN_BID_STATUS'
}

/** Tells us when to show this guardrail preference tooltip */
export enum OdProtosInstitutionsExternal_GuardrailPreference_Type {
  INSPECTION_CONTINGENCY = 'INSPECTION_CONTINGENCY',
  INSPECTION_SCHEDULE = 'INSPECTION_SCHEDULE',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosInstitutionsExternal_NextAction_Type {
  /** deprecated */
  CONFIRM_INSPECTION = 'CONFIRM_INSPECTION',
  CONFIRM_INSPECTION_STATUS = 'CONFIRM_INSPECTION_STATUS',
  EVALUATE_DATE_COUNTER = 'EVALUATE_DATE_COUNTER',
  EVALUATE_PRICE_COUNTER = 'EVALUATE_PRICE_COUNTER',
  /** deprecated */
  EVALUATE_TERMS = 'EVALUATE_TERMS',
  EVALUATE_TERM_COUNTER = 'EVALUATE_TERM_COUNTER',
  /** deprecated */
  PROPOSE_INSPECTION = 'PROPOSE_INSPECTION',
  /** deprecated */
  PROPOSE_POST_INSPECTION = 'PROPOSE_POST_INSPECTION',
  PROPOSE_POST_INSPECTION_NEGOTIATION = 'PROPOSE_POST_INSPECTION_NEGOTIATION',
  /** deprecated */
  RELEASE_INSPECTION_CONTINGENCY = 'RELEASE_INSPECTION_CONTINGENCY',
  SCHEDULE_INSPECTION = 'SCHEDULE_INSPECTION',
  SIGN_DOCUMENTS = 'SIGN_DOCUMENTS',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  /** deprecated */
  UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS'
}

export enum OdProtosInstitutionsExternal_NextAction_Urgency {
  HIGH = 'HIGH',
  LOW = 'LOW',
  UNKNOWN_URGENCY = 'UNKNOWN_URGENCY'
}

/** Requirement for a document. */
export type OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirementInput = {
  /** Required document class. Implicit: The document must be uploaded. */
  documentDescriptorClass?: InputMaybe<OdProtosRealtyDocumentsData_DocumentDescriptor_Class>;
  transitionRequirements?: InputMaybe<Array<OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirementInput>>;
};

/** Rules for how the document transitions states/is archived */
export type OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirementInput = {
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Requires an approved review */
  reviewedByBroker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Both parties must have signed before transition */
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  /** When to check for a required document. */
  when?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirement_WhenOneofInput>;
};

export type OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirement_WhenOneofInput = {
  /** Before a transaction is archived. */
  beforeArchive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Before a transaction transitions to a state. */
  beforeTransitionToState?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_State>;
};

export enum OdProtosInstitutionsReithouseDataBrokerage_DocumentReview_RejectionReason {
  INCORRECT_INFORMATION = 'INCORRECT_INFORMATION',
  INFORMATION_NOT_MATCHING = 'INFORMATION_NOT_MATCHING',
  MISSING_ADDENDA_AMENDMENT_AFFIDAVIT = 'MISSING_ADDENDA_AMENDMENT_AFFIDAVIT',
  MISSING_BOX_CHECK = 'MISSING_BOX_CHECK',
  MISSING_BROKER_AGENT_INFORMATION = 'MISSING_BROKER_AGENT_INFORMATION',
  MISSING_CLOSING_DATE = 'MISSING_CLOSING_DATE',
  MISSING_COMMISSION_AMOUNT_NOTATION = 'MISSING_COMMISSION_AMOUNT_NOTATION',
  MISSING_DATE = 'MISSING_DATE',
  MISSING_DISCLOSURE = 'MISSING_DISCLOSURE',
  MISSING_DOCUMENT = 'MISSING_DOCUMENT',
  MISSING_DUE_DILIGENCE_INSPECTION_PERIOD = 'MISSING_DUE_DILIGENCE_INSPECTION_PERIOD',
  MISSING_ESCROW_GROUP = 'MISSING_ESCROW_GROUP',
  MISSING_INITIALS = 'MISSING_INITIALS',
  MISSING_LIST_PURCHASE_PRICE = 'MISSING_LIST_PURCHASE_PRICE',
  MISSING_PAGE = 'MISSING_PAGE',
  MISSING_PROPERTY_ADDRESS = 'MISSING_PROPERTY_ADDRESS',
  MISSING_PROPERTY_APN_ID_LEGAL_DESCRIPTION = 'MISSING_PROPERTY_APN_ID_LEGAL_DESCRIPTION',
  MISSING_PRO_RATA_SHARE_INFO = 'MISSING_PRO_RATA_SHARE_INFO',
  MISSING_REFERRAL_AMOUNT_NOTATION = 'MISSING_REFERRAL_AMOUNT_NOTATION',
  MISSING_SIGNATURE = 'MISSING_SIGNATURE',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN'
}

/** Result of document review. */
export enum OdProtosInstitutionsReithouseDataBrokerage_DocumentReview_Result {
  APPROVED = 'APPROVED',
  NONE = 'NONE',
  REJECTED = 'REJECTED'
}

export enum OdProtosInstitutionsReithouseDataBrokerage_DocumentViolation_Type {
  MISSING_TYPE = 'MISSING_TYPE',
  NOT_REVIEWED_BY_BROKER = 'NOT_REVIEWED_BY_BROKER',
  NOT_SIGNED = 'NOT_SIGNED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosInstitutionsReithouseDataBrokerage_RuleInput = {
  type?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_Rule_TypeOneofInput>;
};

export type OdProtosInstitutionsReithouseDataBrokerage_Rule_TypeOneofInput = {
  documentRequirement?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirementInput>;
};

/**
 * Brokerage-defined rule set for transactions.
 *
 * Note that transactions also have implicit rules. See Transaction documentation.
 */
export type OdProtosInstitutionsReithouseDataBrokerage_TransactionRuleSetInput = {
  /** Brokerage VendorBranch that owns these transaction requirements. */
  brokerageVendorBranchId?: InputMaybe<Scalars['String']['input']>;
  /** Rules in this rule set. */
  rules?: InputMaybe<Array<OdProtosInstitutionsReithouseDataBrokerage_RuleInput>>;
};

/** The actor doing the thing */
export type OdProtosInstitutionsReithouseDataCommon_ActorInput = {
  /** Deprecated: Use user_id instead. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Contact records information
 * about a contact. Person, organization, customer etc.
 */
export type OdProtosInstitutionsReithouseDataCommon_ContactInput = {
  address?: InputMaybe<OdProtosCommonData_AddressInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<OdProtosBrokeragesData_RealEstateLicenseInput>;
  mlsId?: InputMaybe<OdProtosBrokeragesData_MlsidInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<OdProtosInstitutionsReithouseDataCommon_PhoneNumberInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vendorBranchId?: InputMaybe<Scalars['String']['input']>;
};

/** An ID issued by an MLS. */
export type OdProtosInstitutionsReithouseDataCommon_MlsidInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
};

export type OdProtosInstitutionsReithouseDataCommon_PhoneNumberInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_PhoneNumber_Type>;
};

export enum OdProtosInstitutionsReithouseDataCommon_PhoneNumber_Type {
  FAX = 'FAX',
  HOME = 'HOME',
  MOBILE = 'MOBILE',
  OTHER = 'OTHER',
  WORK = 'WORK'
}

/** A specific version of an ID. */
export type OdProtosInstitutionsReithouseDataCommon_VersionedIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

/** Additional amount of earnest money and its due date (NC only) */
export type OdProtosInstitutionsReithouseData_AdditionalEarnestDepositInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  due?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Date an appraiser estimates the property value for the lender. */
export type OdProtosInstitutionsReithouseData_AppraisalDateInput = {
  date?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseData_AssetInput = {
  location?: InputMaybe<OdProtosInstitutionsReithouseData_Asset_LocationOneofInput>;
};

export type OdProtosInstitutionsReithouseData_Asset_LocationOneofInput = {
  cabinetAssetId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Broker commission. */
export type OdProtosInstitutionsReithouseData_BrokerCommissionInput = {
  commission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommission_CommissionOneofInput>;
};

export type OdProtosInstitutionsReithouseData_BrokerCommission_CommissionOneofInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** 0-100 */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsReithouseData_ClearinghouseSpecificInput = {
  /** hellorito template id */
  helloritoTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** List of CH terms that this document includes */
  includedChTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseTerm>>;
  /** whether document is needed in order to archive in Clearinghouse */
  isRequiredForChArchive?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of CH transaction states in which a document needs broker review. */
  needsBrokerReviewInChStates?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState>>;
  /** If set to NONE, document is not required in clearinghouse */
  requiredForChState?: InputMaybe<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState>;
  /** List of fields needed to generate this document */
  templateFields?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TemplateFieldDescriptorInput>>;
};

/**
 * these values needs to correspond to od_protos.institutions.reithouse.data.Transaction.State
 * in order for DocConfig and Reithouse to understand each other
 */
export enum OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState {
  CLOSED = 'CLOSED',
  DISCARDED = 'DISCARDED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  /** NONE indicates that no state is chosen */
  NONE = 'NONE',
  OPEN = 'OPEN',
  PRELIST = 'PRELIST',
  REJECTED = 'REJECTED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/**
 * these values needs to correspond to od_protos.institutions.reithouse.data.TermType.Type
 * in order for DocConfig and Reithouse to understand each other
 */
export enum OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseTerm {
  ADDITIONAL_EARNEST_DEPOSIT = 'ADDITIONAL_EARNEST_DEPOSIT',
  APPRAISAL_CONTINGENCY = 'APPRAISAL_CONTINGENCY',
  APPRAISAL_DATE = 'APPRAISAL_DATE',
  BUYER_BROKER_COMMISSION = 'BUYER_BROKER_COMMISSION',
  CLOSE_OF_ESCROW_DATE = 'CLOSE_OF_ESCROW_DATE',
  /** @deprecated No longer supported */
  CONTINGENCY = 'CONTINGENCY',
  CONTRACT_EXPIRATION = 'CONTRACT_EXPIRATION',
  CONVEYANCES = 'CONVEYANCES',
  EARNEST_DEPOSIT = 'EARNEST_DEPOSIT',
  EARNEST_DEPOSIT_DUE = 'EARNEST_DEPOSIT_DUE',
  FINANCING_CONTINGENCY = 'FINANCING_CONTINGENCY',
  FINANCING_TYPE = 'FINANCING_TYPE',
  FUNDING_RELATED_DELAYS = 'FUNDING_RELATED_DELAYS',
  INSPECTION_CONTINGENCY = 'INSPECTION_CONTINGENCY',
  INSPECTION_SCHEDULE = 'INSPECTION_SCHEDULE',
  LAND_SURVEY_REQUIREMENT = 'LAND_SURVEY_REQUIREMENT',
  OPENDOOR_COMMISSION = 'OPENDOOR_COMMISSION',
  OX_FEE = 'OX_FEE',
  PRICE = 'PRICE',
  RENT_BACK = 'RENT_BACK',
  REPAIR = 'REPAIR',
  RESOLUTION_PERIOD_CONTINGENCY = 'RESOLUTION_PERIOD_CONTINGENCY',
  SELLER_BROKER_COMMISSION = 'SELLER_BROKER_COMMISSION',
  SELLER_CREDIT = 'SELLER_CREDIT',
  SELLER_DISCLOSURES_DUE = 'SELLER_DISCLOSURES_DUE',
  TERMINATION_OPTION = 'TERMINATION_OPTION',
  TEXT_TERM = 'TEXT_TERM',
  TITLE_POLICY_AMENDMENT = 'TITLE_POLICY_AMENDMENT',
  TITLE_POLICY_FEE = 'TITLE_POLICY_FEE',
  VACANCY_DATE = 'VACANCY_DATE'
}

/** CloseOfEscrowDate is the date when the ownership transfers from seller to buyer. */
export type OdProtosInstitutionsReithouseData_CloseOfEscrowDateInput = {
  date?: InputMaybe<OdProtosCommon_DateInput>;
  relativeDate?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

/**
 * Concession is money given to buyer or seller for a reason.
 * Often, a seller might give the buyer concession instead of agreeing to a repair ask.
 */
export type OdProtosInstitutionsReithouseData_ConcessionInput = {
  /** Deprecated but still used for backward compatibility */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  commission?: InputMaybe<OdProtosInstitutionsReithouseData_Concession_CommissionOneofInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseData_Concession_CommissionOneofInput = {
  commissionAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** 0-100 */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Contingency. */
export type OdProtosInstitutionsReithouseData_ContingencyInput = {
  contingencyType?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_ContingencyTypeInput>;
  releasedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosInstitutionsReithouseData_Contingency_AppraisalInput = {
  /** the date by when appraisal needs to be done. anchor is contract binding date. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_ContingencyTypeInput = {
  type?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneofInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneofInput = {
  appraisal?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_AppraisalInput>;
  financing?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_FinancingInput>;
  homeSale?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_HomeSaleInput>;
  inspection?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_InspectionInput>;
  resolutionPeriod?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_ResolutionPeriodInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_FinancingInput = {
  /** the date by when mortgage financing needs to be secured. */
  financingDeadline?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_HomeSaleInput = {
  /** the date by when another linked home transaction must be completed. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_InspectionInput = {
  /** the date by when inspection needs to be done. anchor is contract binding date. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
  inspectionDeadline?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_ResolutionPeriodInput = {
  /** the date by when resolution needs to be done. anchor is inspection contingency release date. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_ContractExpirationInput = {
  date?: InputMaybe<OdProtosCommon_DateInput>;
  /** anchor is contract sent date. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_ConveyancesInput = {
  /** List of items that will convey. */
  items?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Conveyances_ItemInput>>;
};

export type OdProtosInstitutionsReithouseData_Conveyances_ItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<OdProtosInstitutionsReithouseData_Conveyances_ItemType>;
};

export enum OdProtosInstitutionsReithouseData_Conveyances_ItemType {
  DRYER = 'DRYER',
  MICROWAVE = 'MICROWAVE',
  OTHER = 'OTHER',
  REFRIGERATOR = 'REFRIGERATOR',
  STOVE_OVEN = 'STOVE_OVEN',
  UNKNOWN = 'UNKNOWN',
  WASHER = 'WASHER'
}

/**
 * Represents a document used in real estate transactions
 * These documents have a class but also may be applicable at a federal, state or vendor level
 */
export type OdProtosInstitutionsReithouseData_DocumentDescriptorInput = {
  /**
   * ------------------------
   * Other Attributes:
   * ------------------------
   * Location of a blank version of the document
   */
  asset?: InputMaybe<OdProtosInstitutionsReithouseData_AssetInput>;
  /**
   * If not empty string, this document is only applicable when this vendor branch is involved
   * in the transaction
   */
  branchId?: InputMaybe<Scalars['String']['input']>;
  /** If present, this document is only applicable for a house built after this year */
  builtAfterYear?: InputMaybe<Scalars['Float']['input']>;
  /** If present, this document is only applicable for a house built before this year */
  builtBeforeYear?: InputMaybe<Scalars['Float']['input']>;
  /** whether or not it makes sense to have multiple copies of this document per transaction */
  canHaveMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Class>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdByUserToken?: InputMaybe<Scalars['String']['input']>;
  /** Human readable version of the class field. Can be used to display in UIs */
  displayClass?: InputMaybe<Scalars['String']['input']>;
  /** If true this document is federally applicable */
  federal?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ------------------------
   * Qualifiers:
   * ------------------------
   * Next id: 22
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** If true, this document is only applicable for property with a HOA */
  isForHoa?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ------------------------
   * Contents:
   * ------------------------
   * Local market name for this document
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of parties for which a signature is required */
  requiredSignatures?: InputMaybe<OdProtosInstitutionsReithouseData_PartyListInput>;
  /** If present this document is applicable only in this state */
  state?: InputMaybe<OdProtosCommonState_State>;
  status?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Status>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedByUserToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * If not empty string, this document is only applicable when this vendor is involved
   * in the transaction
   */
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The general description of the document
 * The realty document will have many sub-types represented by the `DocumentDescriptor`
 * Next ID: 65
 */
export enum OdProtosInstitutionsReithouseData_DocumentDescriptor_Class {
  ABAD = 'ABAD',
  ADDENDUM = 'ADDENDUM',
  /** @deprecated No longer supported */
  AGENCY_AGREEMENT = 'AGENCY_AGREEMENT',
  AGENCY_DISCLOSURE = 'AGENCY_DISCLOSURE',
  AGREEMENT = 'AGREEMENT',
  AMENDMENT = 'AMENDMENT',
  APPRAISAL_REPORT = 'APPRAISAL_REPORT',
  ASSIGNMENT = 'ASSIGNMENT',
  BILL_OF_SALE = 'BILL_OF_SALE',
  BUYER_PURCHASE_ADDENDUM = 'BUYER_PURCHASE_ADDENDUM',
  CERTIFICATE_OF_OCCUPANCY = 'CERTIFICATE_OF_OCCUPANCY',
  CLOSING_DOCUMENTS = 'CLOSING_DOCUMENTS',
  COMISSION_INSTRUCTIONS = 'COMISSION_INSTRUCTIONS',
  COMPENSATION_AGREEMENT = 'COMPENSATION_AGREEMENT',
  CONCIERGE_AGREEMENT = 'CONCIERGE_AGREEMENT',
  CONCIERGE_INVOICE = 'CONCIERGE_INVOICE',
  COUNTER_OFFER = 'COUNTER_OFFER',
  DEED = 'DEED',
  DISCLOSURE = 'DISCLOSURE',
  EARNEST_MONEY_DEPOSIT_RECEIPT = 'EARNEST_MONEY_DEPOSIT_RECEIPT',
  EARNEST_MONEY_RELEASE_FORM = 'EARNEST_MONEY_RELEASE_FORM',
  /** @deprecated No longer supported */
  EXCLUSIVE_RIGHT_TO_SELL = 'EXCLUSIVE_RIGHT_TO_SELL',
  FINAL_REPAIR_ASK = 'FINAL_REPAIR_ASK',
  FINAL_SETTLEMENT_STATEMENT = 'FINAL_SETTLEMENT_STATEMENT',
  FINAL_WALKTHROUGH_VERIFICATION = 'FINAL_WALKTHROUGH_VERIFICATION',
  FIRPTA = 'FIRPTA',
  HOA_ADDENDUM = 'HOA_ADDENDUM',
  HOA_DEMAND = 'HOA_DEMAND',
  HOA_GOVERNING_DOCUMENTS = 'HOA_GOVERNING_DOCUMENTS',
  HOA_QUESTIONNAIRE = 'HOA_QUESTIONNAIRE',
  HOA_VIOLATION_RESOLUTION = 'HOA_VIOLATION_RESOLUTION',
  HOME_BUILDER_WARRANTY = 'HOME_BUILDER_WARRANTY',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  LAND_SURVEY = 'LAND_SURVEY',
  LCO_ADDENDUM = 'LCO_ADDENDUM',
  LEAD_BASED_PAINT_DISCLOSURE = 'LEAD_BASED_PAINT_DISCLOSURE',
  LIEN_SEARCH = 'LIEN_SEARCH',
  LISTING_AGREEMENT = 'LISTING_AGREEMENT',
  LOAN_PAYOFF = 'LOAN_PAYOFF',
  LOSS_HISTORY_REPORT = 'LOSS_HISTORY_REPORT',
  MARKET_CONDITIONS_ADVISORY = 'MARKET_CONDITIONS_ADVISORY',
  MISCELLANEOUS = 'MISCELLANEOUS',
  MLS_INPUT_FORM = 'MLS_INPUT_FORM',
  MLS_PRINTOUT = 'MLS_PRINTOUT',
  MUD_DOCUMENT = 'MUD_DOCUMENT',
  OPTION_FEE = 'OPTION_FEE',
  OPTION_MONEY_VERIFICATION = 'OPTION_MONEY_VERIFICATION',
  OWNERS_POLICY = 'OWNERS_POLICY',
  PHOTO = 'PHOTO',
  POWER_OF_ATTORNEY_AGREEMENT = 'POWER_OF_ATTORNEY_AGREEMENT',
  PRE_QUALIFICATION = 'PRE_QUALIFICATION',
  PRE_TERMINATION = 'PRE_TERMINATION',
  PURCHASE_AGREEMENT = 'PURCHASE_AGREEMENT',
  RECEIPT = 'RECEIPT',
  REFERRAL_AGREEMENT = 'REFERRAL_AGREEMENT',
  REFERRAL_W9 = 'REFERRAL_W9',
  REPAIR_CREDIT_ADDENDUM = 'REPAIR_CREDIT_ADDENDUM',
  SELLER_PROPERTY_DISCLOSURE_STATEMENT = 'SELLER_PROPERTY_DISCLOSURE_STATEMENT',
  T47 = 'T47',
  TAX_CERTIFICATE = 'TAX_CERTIFICATE',
  TERMINATION = 'TERMINATION',
  TITLE_COMMITMENT = 'TITLE_COMMITMENT',
  TRANSFER_ADDENDUM = 'TRANSFER_ADDENDUM',
  UNKNOWN = 'UNKNOWN',
  WIRE_INSTRUCTIONS = 'WIRE_INSTRUCTIONS'
}

/**
 * these values needs to correspond to od_protos.institutions.reithouse.data.Transaction.State
 * in order for DocConfig and Reithouse to understand each other
 */
export enum OdProtosInstitutionsReithouseData_DocumentDescriptor_ClearinghouseState {
  CLOSED = 'CLOSED',
  DISCARDED = 'DISCARDED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  /** NONE indicates that no state is chosen */
  NONE = 'NONE',
  OPEN = 'OPEN',
  PRELIST = 'PRELIST',
  REJECTED = 'REJECTED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosInstitutionsReithouseData_DocumentDescriptor_Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum OdProtosInstitutionsReithouseData_DocumentError_Type {
  MISSING_TYPE = 'MISSING_TYPE',
  NOT_REVIEWED_BY_BROKER = 'NOT_REVIEWED_BY_BROKER',
  NOT_SIGNED = 'NOT_SIGNED'
}

/** Common signature requirement */
export enum OdProtosInstitutionsReithouseData_Document_SignatureRequirement {
  /** No signature required (so even if it's missing, it's not an exception to the rules and no action required) */
  NOT_REQUIRED = 'NOT_REQUIRED',
  /** Signature required */
  REQUIRED = 'REQUIRED',
  /** Unknown */
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosInstitutionsReithouseData_Document_Version_Status {
  ACCEPTED = 'ACCEPTED',
  PROCESSED = 'PROCESSED',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED'
}

/** Earnest deposit delivery period */
export type OdProtosInstitutionsReithouseData_EarnestDepositDueInput = {
  /** anchor is contract binding date. */
  dueDate?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

/** Earnest money deposit. */
export type OdProtosInstitutionsReithouseData_EarnestDepositInput = {
  /** total Earnest Money Deposit amount */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * non-refundable Earnest Money Deposit amount. This field is optional.
   * total EMD amount = non-refundable EMD amount + refundable EMD amount
   */
  nonRefundableAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Link to outside resource */
export type OdProtosInstitutionsReithouseData_ExternalLinkInput = {
  /** External id associated with the link */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Name of link */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Link address */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseData_FeeSplitInput = {
  buyer?: InputMaybe<OdProtosInstitutionsReithouseData_FeeSplit_SplitInput>;
  seller?: InputMaybe<OdProtosInstitutionsReithouseData_FeeSplit_SplitInput>;
};

export type OdProtosInstitutionsReithouseData_FeeSplit_SplitInput = {
  split?: InputMaybe<OdProtosInstitutionsReithouseData_FeeSplit_Split_SplitOneofInput>;
};

export type OdProtosInstitutionsReithouseData_FeeSplit_Split_SplitOneofInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsReithouseData_FinancingTypeInput = {
  /** If other, this is the description of the financing type. */
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosInstitutionsReithouseData_FinancingType_Type>;
};

/** Type of financing. */
export enum OdProtosInstitutionsReithouseData_FinancingType_Type {
  CASH = 'CASH',
  CONVENTIONAL = 'CONVENTIONAL',
  FHA = 'FHA',
  HARD_MONEY = 'HARD_MONEY',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
  VA = 'VA'
}

/** Whether funding related delays is allowed */
export type OdProtosInstitutionsReithouseData_FundingRelatedDelaysInput = {
  isAllowed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsReithouseData_GroupSpecificInput = {
  documentDescriptorId?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<OdProtosInstitutionsReithouseData_GroupSpecific_DomainOneofInput>;
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
};

export type OdProtosInstitutionsReithouseData_GroupSpecific_DomainOneofInput = {
  clearinghouseSpecific?: InputMaybe<OdProtosInstitutionsReithouseData_ClearinghouseSpecificInput>;
};

export type OdProtosInstitutionsReithouseData_InspectionScheduleInput = {
  inspectionDate?: InputMaybe<OdProtosCommon_DateInput>;
  inspectionEndTime?: InputMaybe<OdProtosCommon_TimeInput>;
  inspectionStartTime?: InputMaybe<OdProtosCommon_TimeInput>;
};

/** Whether land survey is required and surrounding terms (TX only) */
export type OdProtosInstitutionsReithouseData_LandSurveyRequirementInput = {
  /** if required, this is when the survey is due. anchor is contract binding date. */
  dueDate?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
  /** if required, the land survey is due within this period after signing contract */
  dueWithinPeriod?: InputMaybe<OdProtosCommon_DurationInput>;
  isSurveyRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** if required, this party pays for the land survey */
  payer?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseData_OverrideFieldInput = {
  /**
   * name of the template field
   * must be one of data.Document user_overrideable_template_fields
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * value to use for this field
   * type must correspond with data.Document user_overrideable_template_fields
   */
  value?: InputMaybe<OdProtosInstitutionsReithouseData_OverrideField_ValueOneofInput>;
};

export type OdProtosInstitutionsReithouseData_OverrideField_ValueOneofInput = {
  boolVal?: InputMaybe<Scalars['Boolean']['input']>;
  stringVal?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosInstitutionsReithouseData_ParticipantError_Type {
  EXPECTED_EXACTLY_ONE = 'EXPECTED_EXACTLY_ONE',
  MISSING = 'MISSING',
  MISSING_FIELD = 'MISSING_FIELD'
}

/** Next ID: 19 */
export enum OdProtosInstitutionsReithouseData_Participant_Role {
  AGENT = 'AGENT',
  BROKER = 'BROKER',
  BROKERAGE = 'BROKERAGE',
  COAGENT = 'COAGENT',
  COVERING_COAGENT = 'COVERING_COAGENT',
  ESCROW_COMPANY = 'ESCROW_COMPANY',
  ESCROW_CONTACT = 'ESCROW_CONTACT',
  /** Roles specifically designated for OX Listing Transactions. */
  LISTING_COORDINATOR = 'LISTING_COORDINATOR',
  MORTGAGE_CONTACT = 'MORTGAGE_CONTACT',
  OBSERVER = 'OBSERVER',
  PRINCIPAL = 'PRINCIPAL',
  PRINCIPAL_CLOSER = 'PRINCIPAL_CLOSER',
  PRINCIPAL_SIGNATORY = 'PRINCIPAL_SIGNATORY',
  TITLE_COMPANY = 'TITLE_COMPANY',
  TITLE_CONTACT = 'TITLE_CONTACT',
  TRANSACTION_COORDINATOR = 'TRANSACTION_COORDINATOR',
  /**
   * Temporary role needed by Homebase team. Unclear if there is future application
   * or if Homebase will even need to use it in the future.
   */
  TRANSACTION_SUPPORT_SPECIALIST = 'TRANSACTION_SUPPORT_SPECIALIST',
  UNDERWRITER = 'UNDERWRITER',
  UNKNOWN_ROLE = 'UNKNOWN_ROLE'
}

/**
 * A party in a real estate transaction. There is a BUYER and SELLER party.
 * There is also a NONE party, which is used to represent participants in neither party.
 */
export enum OdProtosInstitutionsReithouseData_Party {
  BUYER = 'BUYER',
  NONE = 'NONE',
  SELLER = 'SELLER'
}

/** List of parties */
export type OdProtosInstitutionsReithouseData_PartyListInput = {
  parties?: InputMaybe<Array<OdProtosInstitutionsReithouseData_PartyList_Party>>;
};

export enum OdProtosInstitutionsReithouseData_PartyList_Party {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

/** Price is the amount the buyer will pay the seller for ownership of the property. */
export type OdProtosInstitutionsReithouseData_PriceInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInstitutionsReithouseData_RelativeDateInput = {
  /**
   * the type of anchor determines how anchor_date is computed
   * this is dependent on term type
   */
  anchor?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDate_AnchorType>;
  /** if the concrete anchor date is available, this is the value. null otherwise */
  anchorDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** if the concrete date is able to be calculated, this is the value. null otherwise */
  date?: InputMaybe<OdProtosCommon_DateInput>;
  dayType?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDate_DayType>;
  /** date value is this many days from anchor */
  deltaDays?: InputMaybe<Scalars['Float']['input']>;
  /** if this is set, computed value is this instead of anchor + delta */
  overrideDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export enum OdProtosInstitutionsReithouseData_RelativeDate_AnchorType {
  CONTRACT_EXECUTE = 'CONTRACT_EXECUTE',
  CONTRACT_OFFER_SEND = 'CONTRACT_OFFER_SEND',
  INSPECTION_CONTINGENCY_RELEASE = 'INSPECTION_CONTINGENCY_RELEASE',
  NOW = 'NOW'
}

export enum OdProtosInstitutionsReithouseData_RelativeDate_DayType {
  /** Mon-Fri excluding national holidays */
  BUSINESS = 'BUSINESS',
  CALENDAR = 'CALENDAR',
  /** Same as calendar days but if the end date is not a business day, go to the next business day */
  CALENDAR_ENDING_ON_BUSINESS = 'CALENDAR_ENDING_ON_BUSINESS'
}

/** Terms on how seller need to rent back the property after closing. OD term is Late Checkout. */
export type OdProtosInstitutionsReithouseData_RentBackInput = {
  /** Total amount paid for rent back. */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  date?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Repair ask from buyer to fix something. */
export type OdProtosInstitutionsReithouseData_RepairInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  ask?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseData_SellerCreditInput = {
  credit?: InputMaybe<OdProtosInstitutionsReithouseData_SellerCredit_CreditOneofInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseData_SellerCredit_CreditOneofInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** When seller must send disclosures by (TX only) */
export type OdProtosInstitutionsReithouseData_SellerDisclosuresDueInput = {
  /** anchor is contract binding date. */
  dueDate?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export enum OdProtosInstitutionsReithouseData_SignatureRequest_Status {
  /** could not deliver to signer */
  BOUNCED = 'BOUNCED',
  /** signer refused to sign */
  DECLINED = 'DECLINED',
  /** given a signing order, not this signer's turn yet */
  PENDING_SEND = 'PENDING_SEND',
  /** out for signature */
  SENT = 'SENT',
  /** successfully signed */
  SIGNED = 'SIGNED'
}

/** Represents a field used in a document template */
export type OdProtosInstitutionsReithouseData_TemplateFieldDescriptorInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosInstitutionsReithouseData_TemplateFieldDescriptor_Type>;
};

/** a template field can either be a boolean or a string */
export enum OdProtosInstitutionsReithouseData_TemplateFieldDescriptor_Type {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING'
}

export enum OdProtosInstitutionsReithouseData_TermError_Type {
  EXPIRED = 'EXPIRED',
  MISSING = 'MISSING',
  NOT_AGREED_UPON = 'NOT_AGREED_UPON',
  NO_DURATION_FOR_RELATIVE_DATE = 'NO_DURATION_FOR_RELATIVE_DATE'
}

/** Wrapper to share TermType code */
export type OdProtosInstitutionsReithouseData_TermTypeInput = {
  type?: InputMaybe<OdProtosInstitutionsReithouseData_TermType_TypeOneofInput>;
};

/**
 * Used to identify a term type without the data
 * New types should be added to both at the same time!
 */
export enum OdProtosInstitutionsReithouseData_TermType_Type {
  ADDITIONAL_EARNEST_DEPOSIT = 'ADDITIONAL_EARNEST_DEPOSIT',
  APPRAISAL_CONTINGENCY = 'APPRAISAL_CONTINGENCY',
  APPRAISAL_DATE = 'APPRAISAL_DATE',
  BUYER_BROKER_COMMISSION = 'BUYER_BROKER_COMMISSION',
  CLOSE_OF_ESCROW_DATE = 'CLOSE_OF_ESCROW_DATE',
  /** @deprecated No longer supported */
  CONTINGENCY = 'CONTINGENCY',
  CONTRACT_EXPIRATION = 'CONTRACT_EXPIRATION',
  CONVEYANCES = 'CONVEYANCES',
  EARNEST_DEPOSIT = 'EARNEST_DEPOSIT',
  EARNEST_DEPOSIT_DUE = 'EARNEST_DEPOSIT_DUE',
  FINANCING_CONTINGENCY = 'FINANCING_CONTINGENCY',
  FUNDING_RELATED_DELAYS = 'FUNDING_RELATED_DELAYS',
  HOME_SALE_CONTINGENCY = 'HOME_SALE_CONTINGENCY',
  INSPECTION_CONTINGENCY = 'INSPECTION_CONTINGENCY',
  INSPECTION_SCHEDULE = 'INSPECTION_SCHEDULE',
  LAND_SURVEY_REQUIREMENT = 'LAND_SURVEY_REQUIREMENT',
  OPENDOOR_COMMISSION = 'OPENDOOR_COMMISSION',
  OX_FEE = 'OX_FEE',
  PRICE = 'PRICE',
  REIMBURSEMENT = 'REIMBURSEMENT',
  RENT_BACK = 'RENT_BACK',
  REPAIR = 'REPAIR',
  RESOLUTION_PERIOD_CONTINGENCY = 'RESOLUTION_PERIOD_CONTINGENCY',
  SELLER_BROKER_COMMISSION = 'SELLER_BROKER_COMMISSION',
  SELLER_CREDIT = 'SELLER_CREDIT',
  SELLER_DISCLOSURES_DUE = 'SELLER_DISCLOSURES_DUE',
  TERMINATION_OPTION = 'TERMINATION_OPTION',
  TEXT_TERM = 'TEXT_TERM',
  TITLE_POLICY_AMENDMENT = 'TITLE_POLICY_AMENDMENT',
  TITLE_POLICY_FEE = 'TITLE_POLICY_FEE',
  VACANCY_DATE = 'VACANCY_DATE'
}

export type OdProtosInstitutionsReithouseData_TermType_TypeOneofInput = {
  additionalEarnestDeposit?: InputMaybe<OdProtosInstitutionsReithouseData_AdditionalEarnestDepositInput>;
  appraisalDate?: InputMaybe<OdProtosInstitutionsReithouseData_AppraisalDateInput>;
  brokerCommission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  buyerBrokerCommission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  closeOfEscrowDate?: InputMaybe<OdProtosInstitutionsReithouseData_CloseOfEscrowDateInput>;
  concession?: InputMaybe<OdProtosInstitutionsReithouseData_ConcessionInput>;
  contingency?: InputMaybe<OdProtosInstitutionsReithouseData_ContingencyInput>;
  contractExpiration?: InputMaybe<OdProtosInstitutionsReithouseData_ContractExpirationInput>;
  conveyances?: InputMaybe<OdProtosInstitutionsReithouseData_ConveyancesInput>;
  earnestDeposit?: InputMaybe<OdProtosInstitutionsReithouseData_EarnestDepositInput>;
  earnestDepositDue?: InputMaybe<OdProtosInstitutionsReithouseData_EarnestDepositDueInput>;
  fundingRelatedDelays?: InputMaybe<OdProtosInstitutionsReithouseData_FundingRelatedDelaysInput>;
  inspectionSchedule?: InputMaybe<OdProtosInstitutionsReithouseData_InspectionScheduleInput>;
  landSurveyRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_LandSurveyRequirementInput>;
  opendoorCommission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  oxFee?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  price?: InputMaybe<OdProtosInstitutionsReithouseData_PriceInput>;
  reimbursement?: InputMaybe<OdProtosInstitutionsReithouseData_SellerCreditInput>;
  rentBack?: InputMaybe<OdProtosInstitutionsReithouseData_RentBackInput>;
  repair?: InputMaybe<OdProtosInstitutionsReithouseData_RepairInput>;
  sellerBrokerCommission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  sellerCredit?: InputMaybe<OdProtosInstitutionsReithouseData_SellerCreditInput>;
  sellerDisclosuresDue?: InputMaybe<OdProtosInstitutionsReithouseData_SellerDisclosuresDueInput>;
  terminationOption?: InputMaybe<OdProtosInstitutionsReithouseData_TerminationOptionInput>;
  textTerm?: InputMaybe<OdProtosInstitutionsReithouseData_TextTermInput>;
  titlePolicyAmendment?: InputMaybe<OdProtosInstitutionsReithouseData_TitlePolicyAmendmentInput>;
  titlePolicyFee?: InputMaybe<OdProtosInstitutionsReithouseData_FeeSplitInput>;
  vacancyDate?: InputMaybe<OdProtosInstitutionsReithouseData_VacancyDateInput>;
};

export enum OdProtosInstitutionsReithouseData_Term_Status {
  ACCEPTED = 'ACCEPTED',
  PROPOSED = 'PROPOSED',
  RATIFIED = 'RATIFIED',
  REJECTED = 'REJECTED',
  REMOVED = 'REMOVED'
}

/**
 * Termination Option allows the buyer to pay an option fee so that
 * they can cancel the contract for any reason within the option period
 * (TX only)
 */
export type OdProtosInstitutionsReithouseData_TerminationOptionInput = {
  feeAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** if true, fee amount is credited back to buyer at closing */
  isCreditableTowardsClosing?: InputMaybe<Scalars['Boolean']['input']>;
  optionPeriod?: InputMaybe<OdProtosCommon_DurationInput>;
};

/** TextTerm represents a manually entered term */
export type OdProtosInstitutionsReithouseData_TextTermInput = {
  body?: InputMaybe<Scalars['String']['input']>;
};

/** Whether title policy will be amended from the standard version (TX only) */
export type OdProtosInstitutionsReithouseData_TitlePolicyAmendmentInput = {
  /** if yes, this party pays for the amendment */
  payer?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  willBeAmended?: InputMaybe<Scalars['Boolean']['input']>;
};

/** State of the transaction. */
export enum OdProtosInstitutionsReithouseData_Transaction_State {
  CLOSED = 'CLOSED',
  DISCARDED = 'DISCARDED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  OPEN = 'OPEN',
  PRELIST = 'PRELIST',
  REJECTED = 'REJECTED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/** Transaction type. */
export enum OdProtosInstitutionsReithouseData_Transaction_Type {
  AGENT_SOURCED = 'AGENT_SOURCED',
  /** @deprecated No longer supported */
  BWODA = 'BWODA',
  DIRECT_SELLER = 'DIRECT_SELLER',
  HOME_BUILDER = 'HOME_BUILDER',
  /** @deprecated No longer supported */
  OD_EXCLUSIVES = 'OD_EXCLUSIVES',
  OD_SOURCED = 'OD_SOURCED',
  /** @deprecated No longer supported */
  OUT_OF_BUYBOX = 'OUT_OF_BUYBOX',
  OX_LISTING = 'OX_LISTING',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  /** @deprecated No longer supported */
  WALK = 'WALK'
}

/** Date when property should be vacant. */
export type OdProtosInstitutionsReithouseData_VacancyDateInput = {
  date?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseServices_AcceptTermRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseServices_AddParticipantRequestInput = {
  contact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  observerType?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  role?: InputMaybe<OdProtosInstitutionsReithouseData_Participant_Role>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_ArchiveTransactionRequestInput = {
  /**
   * If this flag is set to true, response will contain violations, if any,
   * but will not actually archive even if there are no violations
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether or not you want to ignore the transaction's rules
   * when trying to transition state
   */
  overrideRules?: InputMaybe<Scalars['Boolean']['input']>;
  /** What party you're archiving on behalf of (seller or buyer) */
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  /** Transaction to update. */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_CounterTermRequestInput = {
  counteredTermId?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<OdProtosInstitutionsReithouseServices_CreateTermParamsInput>;
};

export type OdProtosInstitutionsReithouseServices_CreateDocumentDescriptorRequestInput = {
  /** id and created/updated by fields are ignored and set by the server */
  documentDescriptor?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptorInput>;
};

/** next: 8 */
export type OdProtosInstitutionsReithouseServices_CreateDocumentRequestInput = {
  /** A number to uniquely identify an amendment in a transaction */
  amendmentNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Signature requirement for buyer */
  buyerSignatureRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_Document_SignatureRequirement>;
  /** Document descriptor id that describes this document. */
  documentDescriptorId?: InputMaybe<Scalars['String']['input']>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Signature requirement for seller */
  sellerSignatureRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_Document_SignatureRequirement>;
  /** Transaction this document is part of. */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_CreateDocumentVersionRequestInput = {
  buyerSigned?: InputMaybe<Scalars['Boolean']['input']>;
  cabinetAssetId?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Date when document version was executed. */
  fullySignedDate?: InputMaybe<OdProtosCommon_DateInput>;
  sellerSigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsReithouseServices_CreateGroupSpecificRequestInput = {
  groupSpecific?: InputMaybe<OdProtosInstitutionsReithouseData_GroupSpecificInput>;
};

export type OdProtosInstitutionsReithouseServices_CreateHelloSignDraftRequestInput = {
  cabinetAssetId?: InputMaybe<Scalars['String']['input']>;
  /** document to create a draft for */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /**
   * if true, ReitHouse will handling the signing process rather than HelloSign
   * backend might also ignore this in the some hardcoded cases
   */
  embeddedSign?: InputMaybe<Scalars['Boolean']['input']>;
  signers?: InputMaybe<Array<OdProtosInstitutionsReithouseServices_CreateHelloSignDraftRequest_SignerInput>>;
};

export type OdProtosInstitutionsReithouseServices_CreateHelloSignDraftRequest_SignerInput = {
  /**
   * smaller numbers sign first. if multiple signers have the same number,
   * they are notified at the same time and there is no enforced signing order
   */
  order?: InputMaybe<Scalars['Float']['input']>;
  /** participant who will be asked to sign */
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_CreateTermParamsInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<OdProtosCommon_DateInput>;
  includedInDocumentId?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  /** Type details at code/protobuf/institutions/reithouse/data/term.proto */
  termType?: InputMaybe<OdProtosInstitutionsReithouseData_TermTypeInput>;
};

export type OdProtosInstitutionsReithouseServices_CreateTermRequestInput = {
  params?: InputMaybe<OdProtosInstitutionsReithouseServices_CreateTermParamsInput>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** Next id: 23 */
export type OdProtosInstitutionsReithouseServices_CreateTransactionRequestInput = {
  /** Access instructions for the property. */
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Address of the home being transacted. */
  addressId?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  /** Buyer party specific data. */
  buyerParty?: InputMaybe<OdProtosInstitutionsReithouseServices_CreateTransactionRequest_PartySpecificInput>;
  /**
   * Date that the certificate of occupancy will be received.
   * Should only be used when is_new_build == True
   */
  certificateOfOccupancyDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Date of close of escrow of the transaction. */
  closeOfEscrowDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Links to related transaction pages */
  externalLinks?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ExternalLinkInput>>;
  /** Home details of the home being transacted. */
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  /** Set when the property is a new build. */
  isNewBuild?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Set when the transaction is a OX Listing transaction.
   *
   * The OX_Listing transaction type is used instead in transaction creation.
   */
  isOxListing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set when the property is vacant. */
  isVacant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set when the transaction is created from a lead. */
  leadId?: InputMaybe<Scalars['String']['input']>;
  /** Related MLS listings. */
  mlsIds?: InputMaybe<Array<OdProtosInstitutionsReithouseDataCommon_MlsidInput>>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Related ODLS SellRequest. */
  odlsSellRequestId?: InputMaybe<Scalars['String']['input']>;
  /** Related ODLS SellResponse. */
  odlsSellResponseId?: InputMaybe<Scalars['String']['input']>;
  /** Participants to add to the transaction upon creation. */
  participants?: InputMaybe<Array<OdProtosInstitutionsReithouseServices_ParticipantParamsInput>>;
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
  /** Purchase price of the home being transacted. */
  purchasePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** DEPRECATED. All transactions are in Institutions now. */
  rerouteToInstitutions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Seller party specific data. */
  sellerParty?: InputMaybe<OdProtosInstitutionsReithouseServices_CreateTransactionRequest_PartySpecificInput>;
  /** Business type of transaction. Required when creating a transaction. Replaced with product_type. */
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

/** Data specific to a party of the transaction. */
export type OdProtosInstitutionsReithouseServices_CreateTransactionRequest_PartySpecificInput = {
  /** Agent Team that owns this transaction. */
  agentVendorBranchId?: InputMaybe<Scalars['String']['input']>;
  /** Brokerage that owns this transaction. */
  brokerageVendorBranchId?: InputMaybe<Scalars['String']['input']>;
  /** Escrow Org for party */
  escrowOrgId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Brokerage's rule sets to use for this transaction.
   * If set, Documents will automatically be created based on the rule sets.
   */
  ruleSetId?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_VersionedIdInput>;
  /** Title Org for party */
  titleOrgId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_DeleteDocumentRequestInput = {
  /** Document to delete. */
  documentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_GenerateDocumentPacketRequestInput = {
  /** document to generate a version for */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** if true, will return errors if any, but will not actually generate or send the contract */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * if true, ReitHouse will handle the signing process rather than HelloSign.
   * backend might also ignore this in the some hardcoded cases
   */
  embeddedSign?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * if true, only generate document but DO NOT send to signers
   * this is only temporarily needed while we transition all signing to embedded signing and split up generate and send.
   * Steps to remove this:
   * 1. Change CH code to ignore this flag and always only generate without send
   * 2. Change Pact (or other client code) to not pass in this option in when making request
   * 3. Remove this from the proto
   */
  generateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Explicitly define values to fill into these fields.
   * Anything in this list will override the value that
   * Reithouse would have used for this field otherwise
   *
   * name must be one of data.Document user_overrideable_template_fields
   */
  overrideFields?: InputMaybe<Array<OdProtosInstitutionsReithouseData_OverrideFieldInput>>;
  /**
   * Can be used when there are multiple principal participants of a single party
   * The preselected participants will be the only ones in their party that will be asked to sign
   */
  preselectedParticipantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsReithouseServices_GetDocumentStatusesRequestInput = {
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsReithouseServices_GetGroupSpecificDocumentDescriptorsRequestInput = {
  ids?: InputMaybe<Array<OdProtosInstitutionsReithouseServices_GetGroupSpecificDocumentDescriptorsRequest_GroupSpecificDocumentDescriptorIdInput>>;
};

export type OdProtosInstitutionsReithouseServices_GetGroupSpecificDocumentDescriptorsRequest_GroupSpecificDocumentDescriptorIdInput = {
  documentDescriptorId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
};

export type OdProtosInstitutionsReithouseServices_GetTransactionStatusesRequestInput = {
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsReithouseServices_GroupSpecificSearchRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsReithouseServices_GroupSpecificSearchRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_GroupSpecificSearchRequest_FiltersInput = {
  filterByProductTypes?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Transaction_Type>>;
  filterByState?: InputMaybe<Array<OdProtosCommonState_State>>;
  filterByVendorId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsReithouseServices_HelloSignSignatureUrlRequestInput = {
  helloSignSignatureId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_IdentifierInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_IdentifierListInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsReithouseServices_ParticipantParamsInput = {
  contact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  observerType?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  role?: InputMaybe<OdProtosInstitutionsReithouseData_Participant_Role>;
};

export type OdProtosInstitutionsReithouseServices_RejectTermRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseServices_ReleaseContingencyTermRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_RemoveParticipantRequestInput = {
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_RemoveTermRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseServices_RequestDocumentRequestInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  role?: InputMaybe<OdProtosInstitutionsReithouseData_Participant_Role>;
};

export type OdProtosInstitutionsReithouseServices_ReviewDocumentRequestInput = {
  brokerageVendorBranchId?: InputMaybe<Scalars['String']['input']>;
  documentVersionId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  rejectionReasons?: InputMaybe<Array<OdProtosInstitutionsReithouseDataBrokerage_DocumentReview_RejectionReason>>;
  result?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_DocumentReview_Result>;
};

export type OdProtosInstitutionsReithouseServices_ReviseTermParamsInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<OdProtosCommon_DateInput>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  /** Type details at code/protobuf/institutions/reithouse/data/term.proto */
  termType?: InputMaybe<OdProtosInstitutionsReithouseData_TermTypeInput>;
};

export type OdProtosInstitutionsReithouseServices_ReviseTermRequestInput = {
  expiresAt?: InputMaybe<OdProtosCommon_DateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<OdProtosInstitutionsReithouseServices_ReviseTermParamsInput>;
};

export type OdProtosInstitutionsReithouseServices_ScheduleFinalWalkthroughRequestInput = {
  /** Date of final walkthrough. */
  finalWalkthroughDate?: InputMaybe<OdProtosCommon_DateInput>;
  finalWalkthroughEndTime?: InputMaybe<OdProtosCommon_TimeInput>;
  /** Time of final walkthrough. */
  finalWalkthroughStartTime?: InputMaybe<OdProtosCommon_TimeInput>;
  /** Transaction to schedule final walkthrough. */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_SearchTransactionsRequestInput = {
  actor?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ActorInput>;
  filters?: InputMaybe<OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_FiltersInput>;
  orderBy?: InputMaybe<Array<OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_OrderByOption>>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_FiltersInput = {
  /** Filter for transactions needs broker review after a date. */
  afterBrokerReviewDueAt?: InputMaybe<OdProtosCommon_DateInput>;
  /** Filter for transactions after a close of escrow date. */
  afterCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
  archivedState?: InputMaybe<OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_Filters_ArchivedState>;
  /** Filter for transactions needs broker review before a date. */
  beforeBrokerReviewDueAt?: InputMaybe<OdProtosCommon_DateInput>;
  /** Filter for transactions before a close of escrow date. */
  beforeCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
  documentReviewState?: InputMaybe<OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_Filters_DocumentReviewState>;
  /** Filter for transactions across a variety of fields (ids, address ..). */
  fuzzyQuery?: InputMaybe<Scalars['String']['input']>;
  /** Filter for transactions by ID */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter for transactions has less than maximum number of overdue documents. */
  maxOverdueDocuments?: InputMaybe<Scalars['Int']['input']>;
  /** Filter for transactions has less than maximum number of documents rejected by brokers. */
  maxRejectedDocuments?: InputMaybe<Scalars['Int']['input']>;
  /** Filter for transactions has more than minimum number of overdue documents. */
  minOverdueDocuments?: InputMaybe<Scalars['Int']['input']>;
  /** Filter for transactions has more than minimum number of documents rejected by brokers. */
  minRejectedDocuments?: InputMaybe<Scalars['Int']['input']>;
  productTypes?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Transaction_Type>>;
  /** Filter for transactions by the state of the property. */
  propertyStates?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Transaction_State>>;
  /** Filter for transactions by title company. */
  titleName?: InputMaybe<Scalars['String']['input']>;
  /** Filter for transactions by transaction types. Replace with product_types. */
  transactionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter for transactions by geographic US state. */
  usStates?: InputMaybe<Array<OdProtosCommonState_State>>;
};

/** Filter for archived transactions */
export enum OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_Filters_ArchivedState {
  ALL_ARCHIVED_AND_UNARCHIVED = 'ALL_ARCHIVED_AND_UNARCHIVED',
  ONLY_ARCHIVED = 'ONLY_ARCHIVED',
  ONLY_UNARCHIVED = 'ONLY_UNARCHIVED'
}

/** Filter for transactions that have documents that need review. */
export enum OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_Filters_DocumentReviewState {
  ALL = 'ALL',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  REVIEWED = 'REVIEWED'
}

export enum OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_OrderByOption {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  /** COE: Close of Escrow date */
  COE_ASC = 'COE_ASC',
  /** COE: Close of Escrow date */
  COE_DESC = 'COE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  /** number of overdue documents */
  OVERDUE_DOCUMENTS_ASC = 'OVERDUE_DOCUMENTS_ASC',
  /** number of overdue documents */
  OVERDUE_DOCUMENTS_DESC = 'OVERDUE_DOCUMENTS_DESC',
  /** number of rejected document by brokers */
  REJECTED_DOCUMENTS_ASC = 'REJECTED_DOCUMENTS_ASC',
  /** number of rejected document by brokers */
  REJECTED_DOCUMENTS_DESC = 'REJECTED_DOCUMENTS_DESC',
  /** earliest broker review due by date */
  REVIEW_DUE_ASC = 'REVIEW_DUE_ASC',
  /** earliest broker review due by date */
  REVIEW_DUE_DESC = 'REVIEW_DUE_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC'
}

export type OdProtosInstitutionsReithouseServices_SetTermDocumentIdRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  includedInDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_TransactionDocumentDescriptorsRequestInput = {
  /**
   * Filters document type included in the list if set
   * If not set, all document types are returned
   */
  includeClasses?: InputMaybe<Array<OdProtosInstitutionsReithouseData_DocumentDescriptor_Class>>;
  /**
   * Filters document status included in the list if set
   * If not set, only active document types are returned
   */
  includeStatuses?: InputMaybe<Array<OdProtosInstitutionsReithouseData_DocumentDescriptor_Status>>;
  transactionInfo?: InputMaybe<OdProtosInstitutionsReithouseServices_TransactionLookupInfoInput>;
};

/** Transaction messages */
export type OdProtosInstitutionsReithouseServices_TransactionIdInput = {
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Describe the transaction
 * The more information provided the better results can be given
 */
export type OdProtosInstitutionsReithouseServices_TransactionLookupInfoInput = {
  /** The address where the transaction is happening. (REQUIRED) */
  addressId?: InputMaybe<Scalars['String']['input']>;
  branchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The home detail id as provided by home data store */
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  /** If provided, only transactions with the given product_type are returned */
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
  /**
   * vendor_ids:
   *  The brokerage vendors involved
   *
   *  branch_ids:
   *  The vendor branches (used to represent different work flows) involved
   *
   *  Document descriptors that have vendor set to null apply to all vendors.
   *  Similarly, descriptors that have branch set to null apply to all branches.
   *  If the vendor is set but the branch is null, then the descriptor apply to
   *  all branches in that vendor.
   *
   *  Because of the above, it is recommended to always supply the vendor if the
   *  branch is supplied. This way, we can return descriptors that apply to:
   *
   *  * all vendors
   *  * all branches in the specified vendor(s)
   *  * the specified branch(es)
   *
   *  Only supplying the branch qualifier will result in missing the second subset
   *  of applicable document descriptors.
   */
  vendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The year the home was built
   * year_built in home_detail supersedes this if available
   */
  yearBuilt?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsReithouseServices_TransitionTransactionRequestInput = {
  /**
   * If this flag is set to true, response will contain violations, if any,
   * but will not actually transition state even if there are no violations
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether or not you want to ignore the transaction's rules
   * when trying to transition state
   */
  overrideRules?: InputMaybe<Scalars['Boolean']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Transaction to update. */
  transactionId?: InputMaybe<Scalars['String']['input']>;
  /** State to transition to. */
  transitionToState?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_State>;
};

export type OdProtosInstitutionsReithouseServices_UnarchiveTransactionRequestInput = {
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  /** Transaction to update. */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsReithouseServices_UnreleaseContingencyTermRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Copied non-deprecated fields from data.DocumentDescriptor
 * This endpoint expects all fields to be set on request
 * and will clear any unset fields. It does NOT perform partial updates.
 */
export type OdProtosInstitutionsReithouseServices_UpdateDocumentDescriptorRequestInput = {
  asset?: InputMaybe<OdProtosInstitutionsReithouseData_AssetInput>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  builtAfterYear?: InputMaybe<Scalars['Float']['input']>;
  /** qualifiers */
  builtBeforeYear?: InputMaybe<Scalars['Float']['input']>;
  canHaveMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Class>;
  displayClass?: InputMaybe<Scalars['String']['input']>;
  federal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Next id: 20 */
  id?: InputMaybe<Scalars['String']['input']>;
  isForHoa?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredSignatures?: InputMaybe<OdProtosInstitutionsReithouseData_PartyListInput>;
  state?: InputMaybe<OdProtosCommonState_State>;
  status?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Status>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

/** next: 10 */
export type OdProtosInstitutionsReithouseServices_UpdateDocumentRequestInput = {
  /** DocumentVersion to set as the active version. */
  activeDocumentVersionId?: InputMaybe<Scalars['String']['input']>;
  /** A number to uniquely identify an amendment in a transaction */
  amendmentNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Signature requirement for buyer */
  buyerSignatureRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_Document_SignatureRequirement>;
  /** DocumentVersion to set as the active version. */
  currentDocumentVersionId?: InputMaybe<Scalars['String']['input']>;
  /** Class that describes this document. */
  documentDescriptorClass?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Class>;
  /** Updated document descriptor id that describes this document. */
  documentDescriptorId?: InputMaybe<Scalars['String']['input']>;
  /** Document to update. */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Signature requirement for seller */
  sellerSignatureRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_Document_SignatureRequirement>;
};

export type OdProtosInstitutionsReithouseServices_UpdateDocumentVersionRequestInput = {
  buyerSigned?: InputMaybe<Scalars['Boolean']['input']>;
  cabinetAssetId?: InputMaybe<Scalars['String']['input']>;
  /** Date when document version was executed. */
  fullySignedDate?: InputMaybe<OdProtosCommon_DateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  sellerSigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequestInput = {
  /** required */
  documentDescriptorId?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_DomainOneofInput>;
  /** required */
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_DomainOneofInput = {
  updateClearinghouseSpecific?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecificInput>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecificInput = {
  helloritoTemplateId?: InputMaybe<Scalars['String']['input']>;
  includedChTerms?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateIncludedChTermsInput>;
  isRequiredForChArchive?: InputMaybe<Scalars['Boolean']['input']>;
  needsBrokerReviewInChStates?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateNeedsBrokerReviewInChStatesInput>;
  /** for comments about what each field is, see data.ClearinghouseSpecific */
  requiredForChState?: InputMaybe<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState>;
  templateFields?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateTemplateFieldsInput>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateIncludedChTermsInput = {
  includedChTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseTerm>>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateNeedsBrokerReviewInChStatesInput = {
  needsBrokerReviewInChStates?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState>>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateTemplateFieldsInput = {
  templateFields?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TemplateFieldDescriptorInput>>;
};

export type OdProtosInstitutionsReithouseServices_UpdateParticipantRequestInput = {
  contact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  observerType?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  role?: InputMaybe<OdProtosInstitutionsReithouseData_Participant_Role>;
};

export type OdProtosInstitutionsReithouseServices_UpdateTransactionReasonRequestInput = {
  /** if a value for this field is not supplied, request will use the notes of prior transaction event */
  notes?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  reason?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** Next: 24 */
export type OdProtosInstitutionsReithouseServices_UpdateTransactionRequestInput = {
  /** Access instructions for the property. */
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Related MLS listings to add. */
  addMlsIds?: InputMaybe<Array<OdProtosInstitutionsReithouseDataCommon_MlsidInput>>;
  /** Address of the home being transacted. */
  addressId?: InputMaybe<Scalars['String']['input']>;
  /** Binding date */
  bindingDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Buyer party specific data. */
  buyerParty?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateTransactionRequest_PartySpecificInput>;
  /** Date that the certificate of occupancy will be received. */
  certificateOfOccupancyDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Date of close of escrow of the transaction. */
  closeOfEscrowDate?: InputMaybe<OdProtosCommon_DateInput>;
  discoveryNotes?: InputMaybe<Scalars['String']['input']>;
  /** Links to related transaction pages */
  externalLinks?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ExternalLinkInput>>;
  highestAndBestDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Highest and best offer deadline. */
  highestAndBestDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  highestAndBestTime?: InputMaybe<OdProtosCommon_TimeInput>;
  /** Home details of the home being transacted. */
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  /** Transaction to update. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Set when the transaction is for a multioffer listing */
  isMultioffer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set when the property is a new build. */
  isNewBuild?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set when the property is vacant. */
  isVacant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Related ODLS SellRequest. */
  odlsSellRequestId?: InputMaybe<Scalars['String']['input']>;
  /** Related ODLS SellResponse. */
  odlsSellResponseId?: InputMaybe<Scalars['String']['input']>;
  /** Purchase price of the home being transacted. */
  purchasePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Related MLS listings to remove. */
  removeMlsIds?: InputMaybe<Array<OdProtosInstitutionsReithouseDataCommon_MlsidInput>>;
  sellerInterested?: InputMaybe<Scalars['Boolean']['input']>;
  /** Seller party specific data. */
  sellerParty?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateTransactionRequest_PartySpecificInput>;
};

/** Data specific to a party of the transaction. */
export type OdProtosInstitutionsReithouseServices_UpdateTransactionRequest_PartySpecificInput = {
  /** Agent Team that owns this transaction. */
  agentVendorBranchId?: InputMaybe<Scalars['String']['input']>;
  /** Brokerage that owns this transaction. */
  brokerageVendorBranchId?: InputMaybe<Scalars['String']['input']>;
  /** Escrow Org for party */
  escrowOrgId?: InputMaybe<Scalars['String']['input']>;
  /** Rule set to use for this transaction. */
  ruleSetId?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_VersionedIdInput>;
  /** Title Org for party */
  titleOrgId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_AddAgentOperatorEligibilityRequestInput = {
  agentOperatorId?: InputMaybe<Scalars['Float']['input']>;
  allMarkets?: InputMaybe<Scalars['Boolean']['input']>;
  allReits?: InputMaybe<Scalars['Boolean']['input']>;
  allSellableTypes?: InputMaybe<Scalars['Boolean']['input']>;
  brokerageRegionId?: InputMaybe<Scalars['Float']['input']>;
  /** this field is only set for LCEP agent operators */
  coverageOnly?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
  roles?: InputMaybe<Array<OdProtosInstitutionsData_MemberRole>>;
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
};

export type OdProtosInstitutionsServices_BidElasticsearchRequestInput = {
  aggs?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_AggsInput>;
  filter?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_FilterInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  sort?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_SortInput>;
};

/**
 * Placeholder for interacting with *aggs* from the Elasticsearch Search API.
 * https://www.elastic.co/guide/en/elasticsearch/reference/current/search-aggregations.html
 */
export type OdProtosInstitutionsServices_BidElasticsearchRequest_AggsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_BidElasticsearchRequest_FilterInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** if no bid states are passed it, we default to only live bid states */
  bidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  buyerIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  inspectionStates?: InputMaybe<Array<OdProtosInstitutionsData_InspectionState>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
};

export type OdProtosInstitutionsServices_BidElasticsearchRequest_SortInput = {
  sortField?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_Sort_Field>;
  sortOrder?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_Sort_Order>;
};

export enum OdProtosInstitutionsServices_BidElasticsearchRequest_Sort_Field {
  ADDRESS = 'ADDRESS',
  BID_PRICE = 'BID_PRICE',
  CEP = 'CEP',
  EMD_DUE_DATE = 'EMD_DUE_DATE',
  FIELD_UNKNOWN = 'FIELD_UNKNOWN',
  INSPECTION_CONTINGENCY_DATE = 'INSPECTION_CONTINGENCY_DATE',
  INSPECTION_SCHEDULED_AT_DATE = 'INSPECTION_SCHEDULED_AT_DATE',
  LISTING_STATUS = 'LISTING_STATUS',
  OFFER_DATE = 'OFFER_DATE',
  OFFER_RECEIVED_AT = 'OFFER_RECEIVED_AT',
  PRIMARY_AGENT = 'PRIMARY_AGENT'
}

export enum OdProtosInstitutionsServices_BidElasticsearchRequest_Sort_Order {
  ASC = 'ASC',
  DESC = 'DESC',
  ORDER_UNKNOWN = 'ORDER_UNKNOWN'
}

export type OdProtosInstitutionsServices_BidOmniSearchRequestInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Next id: 7 */
export type OdProtosInstitutionsServices_BidSearchRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_BidSearchRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosInstitutionsServices_BidSearchRequest_FiltersInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyEndedAuctions?: InputMaybe<Scalars['Boolean']['input']>;
  /** if referral_source is not specified, search all referral options */
  referralSourcedBys?: InputMaybe<Array<OdProtosInstitutionsData_Bid_ReferralSourcedBy>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_AuctionType>>;
  /** if no bid states are passed in, we default to only live bid states */
  states?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
};

export type OdProtosInstitutionsServices_BulkGetSellableRequestInput = {
  sellableIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsServices_BulkUpdateTaskConfigsRequestInput = {
  reitMarketsToAdd?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ReitMarketInput>>;
  reitMarketsToRemove?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ReitMarketInput>>;
  taskConfigIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosInstitutionsServices_CopyAndUpdateTaskConfigRequestInput = {
  /** Updates for the new task config. */
  name?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_PreferencesInput>;
  preferencesFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  /**
   * Source task config id. The specific *reit_markets* that are "copied" to the
   * new task config are removed from the source task config's all_conditions and
   * added to its none_conditions.
   */
  sourceTaskConfigId?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Specific reit market selections for the new task config. For v1 these must
   * be a subset of reit markets in the source task config.
   */
  specificReitMarkets?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ReitMarketInput>>;
};

export type OdProtosInstitutionsServices_CreateAdminBidRequestInput = {
  bidAmountUsd?: InputMaybe<Scalars['Float']['input']>;
  buyerId?: InputMaybe<Scalars['Float']['input']>;
  commisionPct?: InputMaybe<Scalars['Float']['input']>;
  /** The OX_Listing product type is used instead in bid creation. */
  isOxListing?: InputMaybe<Scalars['Boolean']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  maxBidAmountUsd?: InputMaybe<Scalars['Float']['input']>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
  sellableId?: InputMaybe<Scalars['String']['input']>;
  submissionInfo?: InputMaybe<OdProtosInstitutionsData_Bid_SubmissionInfoInput>;
  transactionType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
};

export type OdProtosInstitutionsServices_CreateAgentOperatorRequestInput = {
  /** this field is only set for LCEP - left null for other agent operators */
  dailyCapacityLimit?: InputMaybe<Scalars['Int']['input']>;
  dailyListingCapacityLimit?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  humanToken?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<OdProtosInstitutionsData_MemberRole>>;
  totalCapacityLimit?: InputMaybe<Scalars['Float']['input']>;
  totalListingCapacityLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosInstitutionsServices_CreateBrokerageRegionRequestInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  preferences?: InputMaybe<OdProtosInstitutionsData_BrokerageRegion_PreferencesInput>;
  state?: InputMaybe<OdProtosCommonState_State>;
};

export type OdProtosInstitutionsServices_CreateLeadFromSellRequestRequestInput = {
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_CreateLeadRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  assessmentLink?: InputMaybe<Scalars['String']['input']>;
  availableAt?: InputMaybe<OdProtosCommon_DateInput>;
  brokerageId?: InputMaybe<Scalars['String']['input']>;
  brokerageName?: InputMaybe<Scalars['String']['input']>;
  /** replaced by flat_cents and percentage fields */
  buyerCommission?: InputMaybe<Scalars['Float']['input']>;
  buyerCommissionFlatCents?: InputMaybe<Scalars['Int']['input']>;
  /** will be removed once we fully replace it with rate_bips in BE */
  buyerCommissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  buyerCommissionRateBips?: InputMaybe<Scalars['Int']['input']>;
  closingTimeline?: InputMaybe<Scalars['Int']['input']>;
  endsAt?: InputMaybe<OdProtosCommon_DateInput>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  isNewBuild?: InputMaybe<Scalars['Boolean']['input']>;
  leadType?: InputMaybe<OdProtosInstitutionsData_LeadType>;
  listPriceUsd?: InputMaybe<Scalars['Int']['input']>;
  listingAgents?: InputMaybe<Array<OdProtosInstitutionsData_Lead_ListingAgentInput>>;
  newBuildInfo?: InputMaybe<OdProtosInstitutionsData_Lead_NewBuildInfoInput>;
  photoLink?: InputMaybe<Scalars['String']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  publicNotes?: InputMaybe<Scalars['String']['input']>;
  sellers?: InputMaybe<Array<OdProtosInstitutionsData_Lead_SellerInput>>;
  state?: InputMaybe<OdProtosInstitutionsData_Lead_LeadState>;
};

export type OdProtosInstitutionsServices_CreateNegotiationRequestInput = {
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
  negotiation?: InputMaybe<OdProtosInstitutionsData_NegotiationInput>;
};

export type OdProtosInstitutionsServices_CreateReitRequestInput = {
  /** Optional */
  buyerIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  human?: InputMaybe<OdProtosInstitutionsServices_CreateReitRequest_HumanInput>;
  isBroker?: InputMaybe<Scalars['Boolean']['input']>;
  reit?: InputMaybe<OdProtosInstitutionsServices_CreateReitRequest_OrganizationInput>;
};

export type OdProtosInstitutionsServices_CreateReitRequest_HumanInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_CreateReitRequest_OrganizationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_CreateTagRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_CreateTaskConfigRequestInput = {
  caseyTaskType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_PreferencesInput>;
};

export type OdProtosInstitutionsServices_DeleteAgentOperatorEligibilityRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_DeleteAgentOperatorRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_DeleteTaskConfigRequestInput = {
  taskConfigId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_ExternalRequest_DownloadBidsViewRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_FiltersInput>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsSummaryRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsSummaryRequest_FiltersInput>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsSummaryRequest_FiltersInput = {
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_FiltersInput>;
  offsetPaginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sort?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_SortInput>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_FiltersInput = {
  bidStatuses?: InputMaybe<Array<OdProtosInstitutionsExternal_BidStatus>>;
  bidTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  bindingDate?: InputMaybe<OdProtosInstitutionsData_DateRangeInput>;
  closeOfEscrow?: InputMaybe<OdProtosInstitutionsData_DateRangeInput>;
  inspectionContingencyDeadline?: InputMaybe<OdProtosInstitutionsData_DateRangeInput>;
  inspectionDate?: InputMaybe<OdProtosInstitutionsData_DateRangeInput>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  mlses?: InputMaybe<Array<OdProtosCommonMls_Mls>>;
  nextActions?: InputMaybe<Array<OdProtosInstitutionsExternal_NextAction_Type>>;
  nextMilestones?: InputMaybe<Array<Scalars['String']['input']>>;
  reitIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
  submittedByHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_SortInput = {
  direction?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_Sort_Direction>;
  field?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_Sort_Field>;
};

export enum OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_Sort_Direction {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_Sort_Field {
  ADDRESS = 'ADDRESS',
  MARKET = 'MARKET',
  NEXT_ACTIONS = 'NEXT_ACTIONS',
  NEXT_MILESTONE = 'NEXT_MILESTONE',
  PRODUCT_TYPE = 'PRODUCT_TYPE',
  STATUS = 'STATUS',
  UPDATED_AT = 'UPDATED_AT'
}

export type OdProtosInstitutionsServices_FindAddressRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosCommonState_State>;
  street?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_FindOrCreateAddressRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosCommonState_State>;
  street?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetActivitiesRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_GetActivitiesRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosInstitutionsServices_GetActivitiesRequest_FiltersInput = {
  activityTypes?: InputMaybe<Array<OdProtosInstitutionsData_Activity_Type>>;
  allUsers?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<OdProtosInstitutionsData_TimestampRangeInput>;
};

export type OdProtosInstitutionsServices_GetAgentOperatorAssignmentForListingRequestInput = {
  brokerageRegionId?: InputMaybe<Scalars['Float']['input']>;
  excludedHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<OdProtosInstitutionsData_MemberRole>;
};

export type OdProtosInstitutionsServices_GetAlertsForBidRequestInput = {
  alertType?: InputMaybe<OdProtosInstitutionsData_Alert_AlertType>;
  bidUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetAllAgentOperatorsRequestInput = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_GetAllBrokerageRegionsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_GetAllTagsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_GetAuctionsWithBidsRequestInput = {
  flipTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** Next id: 7 */
export type OdProtosInstitutionsServices_GetAuctionsWithLiveBidsRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  auctionTypes?: InputMaybe<Array<OdProtosInstitutionsData_AuctionType>>;
  /** if no bid states are passed it, we default to only live bid states */
  bidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  onlyEndedAuctions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_GetBidAssigneesRequestInput = {
  bidIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsServices_GetBidEventsRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_GetBidEventsRequest_FiltersInput>;
};

export type OdProtosInstitutionsServices_GetBidEventsRequest_FiltersInput = {
  bidToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional */
  types?: InputMaybe<Array<OdProtosInstitutionsData_Event_Type>>;
};

export type OdProtosInstitutionsServices_GetBidRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetBidsForSellableRequestInput = {
  auctionType?: InputMaybe<OdProtosInstitutionsData_AuctionType>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetBidsRequestInput = {
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsServices_GetBrokerageRegionsRequestInput = {
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsServices_GetCurrentUserRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_GetDownloadableLeadsRequestInput = {
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_GetLatestAuctionDetailsRequestInput = {
  auctionType?: InputMaybe<OdProtosInstitutionsData_AuctionType>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetLatestLeadUpdatedAtByMlsNameRequestInput = {
  mlsName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetLeadBySellRequestIdRequestInput = {
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetLeadDetailRequestInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetLeadHistoryRequestInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetLeadsRequestInput = {
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsServices_GetMarketSettingsForReitRequestInput = {
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_GetNotificationsRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_GetNotificationsRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosInstitutionsServices_GetNotificationsRequest_FiltersInput = {
  activityTypes?: InputMaybe<Array<OdProtosInstitutionsData_Activity_Type>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_GetOdaResolvedHomeDetailRequestInput = {
  /** Address Id of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetPermissionsForCurrentUserRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequestInput = {
  filter?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_FilterInput>;
  offsetPaginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  sort?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_SortInput>;
};

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequest_FilterInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** if no bid states are passed it, we default to only live bid states */
  bidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  bidTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerReitIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  includeCoveringTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionStates?: InputMaybe<Array<OdProtosInstitutionsData_InspectionState>>;
  leadTypes?: InputMaybe<Array<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Filter_LeadType>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  nextTaskDue?: InputMaybe<Scalars['DateTime']['input']>;
  oxListingsFilter?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Filter_OxListingsFilter>;
  referralSourcedBys?: InputMaybe<Array<OdProtosInstitutionsData_Bid_ReferralSourcedBy>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
  tagIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Filter_LeadType {
  IS_VACANT = 'IS_VACANT',
  NEW_BUILD = 'NEW_BUILD',
  REFERRAL_LISTING = 'REFERRAL_LISTING'
}

export enum OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Filter_OxListingsFilter {
  EXCLUDE_OX_LISTINGS = 'EXCLUDE_OX_LISTINGS',
  INCLUDE_ALL = 'INCLUDE_ALL',
  OX_LISTINGS_ONLY = 'OX_LISTINGS_ONLY',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequest_SortInput = {
  direction?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Sort_Direction>;
  field?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Sort_Field>;
};

export enum OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Sort_Direction {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Sort_Field {
  ADDRESS = 'ADDRESS',
  BID_STATE = 'BID_STATE',
  CLOSING_TEAM = 'CLOSING_TEAM',
  COE = 'COE',
  CURRENT_OFFER_AMOUNT = 'CURRENT_OFFER_AMOUNT',
  CURRENT_OFFER_PERCENT_OF_LIST = 'CURRENT_OFFER_PERCENT_OF_LIST',
  DD_END_DATE = 'DD_END_DATE',
  DOM = 'DOM',
  FWT_DATE = 'FWT_DATE',
  HB_DEADLINE = 'HB_DEADLINE',
  INSPECTION_DATE = 'INSPECTION_DATE',
  IN_CONTRACT_AT = 'IN_CONTRACT_AT',
  LCEP = 'LCEP',
  LISTING_STATUS = 'LISTING_STATUS',
  MAX_OFFER_AMOUNT = 'MAX_OFFER_AMOUNT',
  NEXT_TASK_DUE = 'NEXT_TASK_DUE',
  OFFER_EXPIRATION_DATE = 'OFFER_EXPIRATION_DATE',
  OFFER_RECEIVED_AT = 'OFFER_RECEIVED_AT',
  RENT_BACK_DATE = 'RENT_BACK_DATE',
  RESOLUTION_PERIOD = 'RESOLUTION_PERIOD',
  TASK_COUNT = 'TASK_COUNT',
  UPDATED_AT = 'UPDATED_AT'
}

export type OdProtosInstitutionsServices_GetPreferencesForBidRequestInput = {
  bidUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetReitForHumanRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetReitRequestInput = {
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_GetReitSettingsRequestInput = {
  brokerageRegionId?: InputMaybe<Scalars['Float']['input']>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
};

export type OdProtosInstitutionsServices_GetReitsByIdRequestInput = {
  reitIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosInstitutionsServices_GetReitsRequestInput = {
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetRetradeDetailsRequestInput = {
  listingOfferId?: InputMaybe<Scalars['Float']['input']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_GetSellableRequestInput = {
  identifier?: InputMaybe<OdProtosInstitutionsServices_GetSellableRequest_IdentifierOneofInput>;
};

export type OdProtosInstitutionsServices_GetSellableRequest_IdentifierOneofInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  sellableInfo?: InputMaybe<OdProtosInstitutionsData_SellableInfoInput>;
};

export type OdProtosInstitutionsServices_GetSellableTypeEligibilitiesRequestInput = {
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_GetTaskConfigsByIdsRequestInput = {
  /**
   * Historically, tasks in Casey are have a different id in their sources.
   * TODO: Clean this up. Backfill TaskConfig.id in Casey? Deprecate Casey?
   */
  caseySourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taskConfigIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosInstitutionsServices_GetTaskConfigsRequestInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
};

export type OdProtosInstitutionsServices_LeadsOmniSearchRequestInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_MarkNotificationsAsReadRequestInput = {
  notificationIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosInstitutionsServices_PerformBidActionRequestInput = {
  bidAction?: InputMaybe<OdProtosInstitutionsData_BidAction>;
  bidUuid?: InputMaybe<Scalars['String']['input']>;
  /** Any additional data in performing an action as json (i.e. negotiation information) */
  data?: InputMaybe<Scalars['String']['input']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_ProcessLeadsRequestInput = {
  homebuilderLeads?: InputMaybe<Array<OdProtosInstitutionsData_HomebuilderLeadInput>>;
};

export type OdProtosInstitutionsServices_RemoveAgentOperatorEligibilityRoleRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<OdProtosInstitutionsData_MemberRole>;
};

export type OdProtosInstitutionsServices_RemoveAgentOperatorRoleRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<OdProtosInstitutionsData_MemberRole>;
};

export type OdProtosInstitutionsServices_SearchUsersRequestInput = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_SellableSearchRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_SellableSearchRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosInstitutionsServices_SellableSearchRequest_FiltersInput = {
  /**
   * if AuctionType is MlsListings and only a market is specified
   * we merge to prefer an MLS over another based on the historically more reliable mls
   */
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  /** specifying an MLS will result in only leads from that MLS returning */
  mls?: InputMaybe<Array<OdProtosCommonMls_Mls>>;
  sourceCreatedAt?: InputMaybe<OdProtosInstitutionsData_TimestampRangeInput>;
  states?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  types?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
};

export type OdProtosInstitutionsServices_SendRemoveNomadTaskSlackMessageRequestInput = {
  bidToken?: InputMaybe<Scalars['String']['input']>;
  caseyTaskId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_SetBrokerageRegionPreferencesRequestInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<OdProtosInstitutionsData_BrokerageRegion_PreferencesInput>;
  preferencesFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

/** Performs a full update of criteria - all desired fields must be specified */
export type OdProtosInstitutionsServices_SetBuyboxRequestInput = {
  criteria?: InputMaybe<OdProtosInstitutionsData_Buybox_CriteriaInput>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_SetReitSettingsRequestInput = {
  /**
   * Valid field mask items are all top level ReitSettingsPreferences.  An empty mask means that all fields will be updated.
   * This fieldmask option was removed as it was not compiling once the fieldmask plugin was acutally in use
   * It may be because it is a nested fieldmask ?
   * [(common.options.fieldmask) = "reit_settings.preferences"];
   */
  preferencesFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  /** The id in ReitSettings takes precedence over the other search criteria. */
  reitSettings?: InputMaybe<OdProtosInstitutionsData_ReitSettingsInput>;
};

export type OdProtosInstitutionsServices_UpdateAgentOperatorRequestInput = {
  coverageDates?: InputMaybe<Array<OdProtosCommon_DateInput>>;
  /** these two fields are only set for LCEP - left null for other agent operators */
  dailyCapacityLimit?: InputMaybe<Scalars['Int']['input']>;
  dailyListingCapacityLimit?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  roles?: InputMaybe<Array<OdProtosInstitutionsData_MemberRole>>;
  totalCapacityLimit?: InputMaybe<Scalars['Int']['input']>;
  totalListingCapacityLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosInstitutionsServices_UpdateAuctionDetailsRequestInput = {
  auctionUuid?: InputMaybe<Scalars['String']['input']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
  odaReviewer?: InputMaybe<OdProtosInstitutionsData_UserInput>;
};

export type OdProtosInstitutionsServices_UpdateBidBrokerageRequestInput = {
  bidUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_UpdateBidRequestInput = {
  amountCents?: InputMaybe<Scalars['Float']['input']>;
  bidUuid?: InputMaybe<Scalars['String']['input']>;
  commissionPct?: InputMaybe<Scalars['Float']['input']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosInstitutionsData_BidState>;
  /** Optional tags to set on the Bid. If not set, the tags will not be updated. */
  tags?: InputMaybe<OdProtosInstitutionsServices_UpdateBidRequest_TagsInput>;
  updateArgs?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<OdProtosInstitutionsData_UserInput>;
};

export type OdProtosInstitutionsServices_UpdateBidRequest_TagsInput = {
  ids?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosInstitutionsServices_UpdateDecisionRequestInput = {
  decision?: InputMaybe<OdProtosInstitutionsData_DecisionInput>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_UpdateLeadAddressRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_UpdateLeadListingRequestInput = {
  assessmentLink?: InputMaybe<Scalars['String']['input']>;
  availableAt?: InputMaybe<OdProtosCommon_DateInput>;
  brokerageId?: InputMaybe<Scalars['String']['input']>;
  brokerageName?: InputMaybe<Scalars['String']['input']>;
  /** replaced by flat_cents and percentage fields */
  buyerCommission?: InputMaybe<Scalars['Float']['input']>;
  buyerCommissionFlatCents?: InputMaybe<Scalars['Int']['input']>;
  /** will be removed once we fully replace it with rate_bips in BE */
  buyerCommissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  buyerCommissionRateBips?: InputMaybe<Scalars['Int']['input']>;
  closingTimeline?: InputMaybe<Scalars['Int']['input']>;
  currentListPriceUsd?: InputMaybe<Scalars['Int']['input']>;
  endedAt?: InputMaybe<OdProtosCommon_DateInput>;
  endsAt?: InputMaybe<OdProtosCommon_DateInput>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  isNewBuild?: InputMaybe<Scalars['Boolean']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  listingAgents?: InputMaybe<Array<OdProtosInstitutionsData_Lead_ListingAgentInput>>;
  newBuildInfo?: InputMaybe<OdProtosInstitutionsData_Lead_NewBuildInfoInput>;
  originalListPriceUsd?: InputMaybe<Scalars['Int']['input']>;
  photoLink?: InputMaybe<Scalars['String']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  publicNotes?: InputMaybe<Scalars['String']['input']>;
  sellers?: InputMaybe<Array<OdProtosInstitutionsData_Lead_SellerInput>>;
  state?: InputMaybe<OdProtosInstitutionsData_Lead_LeadState>;
};

export type OdProtosInstitutionsServices_UpdateLeadNewBuildInfoRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  newBuildInfo?: InputMaybe<OdProtosInstitutionsData_Lead_NewBuildInfoInput>;
};

export type OdProtosInstitutionsServices_UpdateLeadPropertyRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  apn?: InputMaybe<Scalars['String']['input']>;
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  carportSpaces?: InputMaybe<Scalars['Int']['input']>;
  exteriorStories?: InputMaybe<Scalars['Int']['input']>;
  garageSpaces?: InputMaybe<Scalars['Int']['input']>;
  hasPrivatePool?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeptic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSolarPanels?: InputMaybe<Scalars['Boolean']['input']>;
  hoas?: InputMaybe<Array<OdProtosInstitutionsData_Lead_HomeDetails_HoaInput>>;
  interiorSqFt?: InputMaybe<Scalars['Int']['input']>;
  interiorStories?: InputMaybe<Scalars['Int']['input']>;
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  lotSqFt?: InputMaybe<Scalars['Int']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  sewerType?: InputMaybe<Scalars['String']['input']>;
  solarPanelsOwnership?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosInstitutionsServices_UpdateMarketSettingsForReitRequestInput = {
  marketSettingsToUpdate?: InputMaybe<Array<OdProtosInstitutionsData_MarketSettingsInput>>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_UpdateReitRequestInput = {
  reit?: InputMaybe<OdProtosInstitutionsServices_UpdateReitRequest_ReitInput>;
  reitFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_UpdateReitRequest_ReitInput = {
  apiBidSubmissionDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  bidLifetimeDays?: InputMaybe<Scalars['Float']['input']>;
  buyerReitIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  isBroker?: InputMaybe<Scalars['Boolean']['input']>;
  mlsReadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rentEstimateReadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInstitutionsServices_UpdateTagRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsServices_UpdateTaskConfigRequestInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_PreferencesInput>;
  preferencesFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  taskConfigId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInstitutionsServices_UpdateTaskRequestInput = {
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']['input']>;
  taskUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsTasksServices_CreateTaskRequestInput = {
  assigneeHumanToken?: InputMaybe<Scalars['String']['input']>;
  bidToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueBy?: InputMaybe<Scalars['DateTime']['input']>;
  /** required: name, description, task type */
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OdProtosInstitutionsTasks_Task_Status>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taskConfigId?: InputMaybe<Scalars['Int']['input']>;
  taskType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInstitutionsTasksServices_GetTasksRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosInstitutionsTasksServices_SearchTasksRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsTasksServices_SearchTasksRequest_FiltersInput>;
};

export type OdProtosInstitutionsTasksServices_SearchTasksRequest_FiltersInput = {
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** TODO add pagination */
  bidTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<OdProtosInstitutionsTasks_Task_Status>>;
};

export type OdProtosInstitutionsTasksServices_UpdateTaskRequestInput = {
  assigneeHumanToken?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueBy?: InputMaybe<Scalars['DateTime']['input']>;
  /** all fields are optional, and will be updated if set */
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OdProtosInstitutionsTasks_Task_Status>;
  tags?: InputMaybe<OdProtosInstitutionsTasksServices_UpdateTaskRequest_TagsInput>;
};

export type OdProtosInstitutionsTasksServices_UpdateTaskRequest_TagsInput = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The Conditions specify parameters that control when bid tasks should exist. */
export type OdProtosInstitutionsTasks_ConditionsInput = {
  acceptedTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TermType_Type>>;
  bidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  boolFilters?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_BoolFilterInput>>;
  customClasses?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_CustomClass>>;
  dateFilters?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_DateFilterInput>>;
  documentsNotMeetingSigningRequirements?: InputMaybe<OdProtosInstitutionsTasks_Conditions_DocumentsInput>;
  documentsWithBrokerApprovalComment?: InputMaybe<OdProtosInstitutionsTasks_Conditions_DocumentsInput>;
  documentsWithBrokerRejection?: InputMaybe<OdProtosInstitutionsTasks_Conditions_DocumentsInput>;
  inspectionStates?: InputMaybe<Array<OdProtosInstitutionsData_InspectionState>>;
  intFilters?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_IntFilterInput>>;
  partyTurnTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Party>>;
  /** This condition is met when all specified fields are present (non-null). */
  presentFields?: InputMaybe<Array<OdProtosInstitutionsTasks_FieldInput>>;
  proposedTerms?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ProposedTermInput>>;
  ratifiedTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TermType_Type>>;
  referralSourcedBys?: InputMaybe<Array<OdProtosInstitutionsData_Bid_ReferralSourcedBy>>;
  reitMarkets?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ReitMarketInput>>;
  rejectedTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TermType_Type>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
  sourceTypes?: InputMaybe<Array<OdProtosRealtyCommon_Source_Type>>;
  states?: InputMaybe<Array<OdProtosCommonState_State>>;
  timestampFilters?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_TimestampFilterInput>>;
};

/** BollFilter is a boolean field compared against a value for equality. */
export type OdProtosInstitutionsTasks_Conditions_BoolFilterInput = {
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_Bool>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosInstitutionsTasks_Conditions_CustomClass {
  /** Guardrail terms set in reit preferences are not followed */
  GUARDRAIL_TERM_MIN_DAY_VIOLATION = 'GUARDRAIL_TERM_MIN_DAY_VIOLATION',
  /** The seller agent contact email in PACT is not specified. */
  SELLER_AGENT_CONTACT_EMAIL_MISSING = 'SELLER_AGENT_CONTACT_EMAIL_MISSING',
  UNKNOWN_CUSTOM_CLASS = 'UNKNOWN_CUSTOM_CLASS'
}

/**
 * DateFilter is an adjusted date compared against the current date.
 *
 * Examples:
 * (1) The equivalent filter for:
 *     (a) "within 1 day of the inspection scheduled date" or
 *     (b) "*start condition* 1 day before inspection schedule date" or
 *     (c) "inspection schedule date is in 1 day" is:
 *     CURRENT_DATE_ON_OR_AFTER Date.INSPECTION_SCHEDULED - 1 day
 * (2) The filter for "on or after binding date" is:
 *     CURRENT_DATE_ON_OR_AFTER Date.BINDING
 */
export type OdProtosInstitutionsTasks_Conditions_DateFilterInput = {
  dayType?: InputMaybe<OdProtosInstitutionsTasks_DayType>;
  deltaDays?: InputMaybe<Scalars['Float']['input']>;
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_Date>;
  operator?: InputMaybe<OdProtosInstitutionsTasks_Conditions_DateFilter_Operator>;
};

export enum OdProtosInstitutionsTasks_Conditions_DateFilter_Operator {
  CURRENT_DATE_ON_OR_AFTER = 'CURRENT_DATE_ON_OR_AFTER',
  CURRENT_DATE_ON_OR_BEFORE = 'CURRENT_DATE_ON_OR_BEFORE',
  UNKNOWN_OPERATOR = 'UNKNOWN_OPERATOR'
}

/**
 * Each document version that matches a Documents condition will create its
 * own separate task.
 *
 * Additionally, each document review that matches the condition will also
 * create its own separate task.
 */
export type OdProtosInstitutionsTasks_Conditions_DocumentsInput = {
  /** When the list is empty the criteria is applied to all valid values. */
  documentDescriptorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** IntFilter is an int field compared against a value. */
export type OdProtosInstitutionsTasks_Conditions_IntFilterInput = {
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_Int>;
  operator?: InputMaybe<OdProtosInstitutionsTasks_Conditions_IntFilter_Operator>;
  /** RHS value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosInstitutionsTasks_Conditions_IntFilter_Operator {
  EQUAL_TO = 'EQUAL_TO',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  UNKNOWN_OPERATOR = 'UNKNOWN_OPERATOR'
}

export type OdProtosInstitutionsTasks_Conditions_ProposedTermInput = {
  /** When NONE this condition will match either party. */
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  termType?: InputMaybe<OdProtosInstitutionsReithouseData_TermType_Type>;
};

/** These conditions are built in the UI using a kind of step-by-step wizard. */
export type OdProtosInstitutionsTasks_Conditions_ReitMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /**
   * A reit and market combination specifying an inclusion or
   * for this task config.
   *
   * When null/unknown unspecified the criteria is applied to all valid
   * values. At least one parameter must be specified.
   */
  reitId?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * TimestampFilter is an adjusted timestamp field compared against the current
 * timestamp.
 *
 * Examples:
 * (1) The equivalent filters for:
 *     (a) "within 4 hours of the highest and best deadline" or
 *     (b) "*start condition* 4 hours before highest and best deadline" or:
 *     (c) "highest and best deadline is in 4 hours" is:
 *     Timestamp.HIGHEST_AND_BEST_DEADLINE - 4 hours is AFTER_NOW_TIMESTAMP
 * (2) The filter for "1 day after bid state entered at" is:
 *     CURRENT_TIMESTAMP_AFTER Timestamp.BID_STATE_ENTERED_AT + 1
 * (3) The filter for "before auction ended at" is:
 *     CURRENT_TIMESTAMP_BEFORE Timestamp.AUCTION_ENDED_AT
 */
export type OdProtosInstitutionsTasks_Conditions_TimestampFilterInput = {
  dayType?: InputMaybe<OdProtosInstitutionsTasks_DayType>;
  /** Duration is added to the field anchor for deadline computation. */
  deltaDuration?: InputMaybe<GoogleProtobuf_DurationInput>;
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_Timestamp>;
  operator?: InputMaybe<OdProtosInstitutionsTasks_Conditions_TimestampFilter_Operator>;
};

export enum OdProtosInstitutionsTasks_Conditions_TimestampFilter_Operator {
  CURRENT_TIMESTAMP_AFTER = 'CURRENT_TIMESTAMP_AFTER',
  CURRENT_TIMESTAMP_BEFORE = 'CURRENT_TIMESTAMP_BEFORE',
  UNKNOWN_OPERATOR = 'UNKNOWN_OPERATOR'
}

export enum OdProtosInstitutionsTasks_DayType {
  /** Mon-Fri excluding national holidays. */
  BUSINESS = 'BUSINESS',
  CALENDAR = 'CALENDAR',
  DAY_TYPE_UNKNOWN = 'DAY_TYPE_UNKNOWN'
}

export type OdProtosInstitutionsTasks_FieldInput = {
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_FieldOneofInput>;
};

export enum OdProtosInstitutionsTasks_Field_Bool {
  IS_NEW_BUILD = 'IS_NEW_BUILD',
  IS_VACANT = 'IS_VACANT',
  UNKNOWN_BOOL_FIELD = 'UNKNOWN_BOOL_FIELD'
}

export enum OdProtosInstitutionsTasks_Field_Date {
  BINDING = 'BINDING',
  CERTIFICATE_OF_OCCUPANCY = 'CERTIFICATE_OF_OCCUPANCY',
  CLOSE_OF_ESCROW = 'CLOSE_OF_ESCROW',
  CONTINGENCY_DEADLINE = 'CONTINGENCY_DEADLINE',
  EARNEST_MONEY_DUE_DATE = 'EARNEST_MONEY_DUE_DATE',
  INSPECTION_SCHEDULED = 'INSPECTION_SCHEDULED',
  RENT_BACK_DATE = 'RENT_BACK_DATE',
  TIMESTAMP_AUCTION_ENDED_AT = 'TIMESTAMP_AUCTION_ENDED_AT',
  /** The fields below are duplicated from Timestamp but with date logic for ops. */
  TIMESTAMP_BID_STATE_ENTERED_AT = 'TIMESTAMP_BID_STATE_ENTERED_AT',
  TIMESTAMP_HIGHEST_AND_BEST_DEADLINE = 'TIMESTAMP_HIGHEST_AND_BEST_DEADLINE',
  TIMESTAMP_TASK_ACTIVATED_AT = 'TIMESTAMP_TASK_ACTIVATED_AT',
  UNKNOWN_DATE_FIELD = 'UNKNOWN_DATE_FIELD',
  VACANCY_DATE = 'VACANCY_DATE'
}

export type OdProtosInstitutionsTasks_Field_FieldOneofInput = {
  bool?: InputMaybe<OdProtosInstitutionsTasks_Field_Bool>;
  date?: InputMaybe<OdProtosInstitutionsTasks_Field_Date>;
  int?: InputMaybe<OdProtosInstitutionsTasks_Field_Int>;
  string?: InputMaybe<OdProtosInstitutionsTasks_Field_String>;
  timestamp?: InputMaybe<OdProtosInstitutionsTasks_Field_Timestamp>;
};

export enum OdProtosInstitutionsTasks_Field_Int {
  HOA_FEE = 'HOA_FEE',
  UNKNOWN_INT_FIELD = 'UNKNOWN_INT_FIELD',
  YEAR_BUILT = 'YEAR_BUILT'
}

export enum OdProtosInstitutionsTasks_Field_String {
  ACCESS_INSTRUCTIONS = 'ACCESS_INSTRUCTIONS',
  UNKNOWN_STRING_FIELD = 'UNKNOWN_STRING_FIELD'
}

export enum OdProtosInstitutionsTasks_Field_Timestamp {
  AUCTION_ENDED_AT = 'AUCTION_ENDED_AT',
  BID_STATE_ENTERED_AT = 'BID_STATE_ENTERED_AT',
  HIGHEST_AND_BEST_DEADLINE = 'HIGHEST_AND_BEST_DEADLINE',
  TASK_ACTIVATED_AT = 'TASK_ACTIVATED_AT',
  UNKNOWN_TIMESTAMP_FIELD = 'UNKNOWN_TIMESTAMP_FIELD'
}

export type OdProtosInstitutionsTasks_TaskConfig_DeadlineInput = {
  anchor?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_Deadline_AnchorOneofInput>;
  dayType?: InputMaybe<OdProtosInstitutionsTasks_DayType>;
  /** Duration is added to the field anchor for deadline computation. */
  deltaDuration?: InputMaybe<GoogleProtobuf_DurationInput>;
  /** Overrides the time portion of this deadline using the property's timezone. */
  overrideTime?: InputMaybe<OdProtosCommon_TimeInput>;
};

export type OdProtosInstitutionsTasks_TaskConfig_Deadline_AnchorOneofInput = {
  anchorDate?: InputMaybe<OdProtosInstitutionsTasks_Field_Date>;
  anchorTimestamp?: InputMaybe<OdProtosInstitutionsTasks_Field_Timestamp>;
  customClass?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_Deadline_CustomClass>;
};

export enum OdProtosInstitutionsTasks_TaskConfig_Deadline_CustomClass {
  UNKNOWN_CUSTOM_CLASS = 'UNKNOWN_CUSTOM_CLASS'
}

export type OdProtosInstitutionsTasks_TaskConfig_PreferencesInput = {
  /** The conditions that, when met, will open (or reopen) a bid task. */
  allConditions?: InputMaybe<OdProtosInstitutionsTasks_ConditionsInput>;
  /** SLA parameters for this config. */
  deadline?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_DeadlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Controls whether a bid task should be reopened when the conditions are subsequently met again */
  isOneTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** The task is assigned to a bid assignee human with the provided member role. */
  memberRole?: InputMaybe<OdProtosInstitutionsData_MemberRole>;
  noneConditions?: InputMaybe<OdProtosInstitutionsTasks_ConditionsInput>;
  /** Optional priority of the task. Historically we use 0, 1, 2 or 3' */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Human readable (and maintained) tags for the task config and its spawned
   * tasks for display in frontends. These are immutable in spawned tasks.
   */
  tags?: InputMaybe<Array<OdProtosInstitutionsTasks_TaskConfig_Preferences_TagInput>>;
};

export type OdProtosInstitutionsTasks_TaskConfig_Preferences_TagInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosInstitutionsTasks_TaskConfig_State {
  /** This task config fully applied and is live for new and existing bids. */
  ACTIVE = 'ACTIVE',
  /** This task config is being applied by a backend migration. */
  APPLYING = 'APPLYING',
  /**
   * This task config is no longer in use and all migrations have been
   * performed. If needed, it can be removed from the db at this point.
   */
  DELETED = 'DELETED',
  /** This task config is new or modified. */
  PENDING = 'PENDING',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosInstitutionsTasks_Task_Status {
  STATUS_CLOSED = 'STATUS_CLOSED',
  STATUS_OPEN = 'STATUS_OPEN',
  STATUS_UNSPECIFIED = 'STATUS_UNSPECIFIED'
}

export type OdProtosInventoryPrototypeData_BuyerOfferDetailsInput = {
  /** Next ID: 13 */
  financingType?: InputMaybe<OdProtosInventoryPrototypeData_BuyerOfferDetails_FinancingType>;
  isEscalated?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalOffer?: InputMaybe<Scalars['Boolean']['input']>;
  messageThreadUuid?: InputMaybe<Scalars['String']['input']>;
  netProceedsCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerAmountCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerId?: InputMaybe<Scalars['Float']['input']>;
  offerValidFrom?: InputMaybe<OdProtosCommon_DateInput>;
  offerValidUntil?: InputMaybe<OdProtosCommon_DateInput>;
  state?: InputMaybe<OdProtosInventoryPrototypeData_BuyerOfferDetails_Lifecycle>;
  targetNetProceedsCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  totalConcessionsCents?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 8 */
export enum OdProtosInventoryPrototypeData_BuyerOfferDetails_FinancingType {
  CASH = 'CASH',
  CONVENTIONAL = 'CONVENTIONAL',
  FHA = 'FHA',
  FINANCING_REQUIRED = 'FINANCING_REQUIRED',
  TXVA = 'TXVA',
  UNKNOWN = 'UNKNOWN',
  USDA = 'USDA',
  VA = 'VA'
}

/** Next ID: 5 */
export enum OdProtosInventoryPrototypeData_BuyerOfferDetails_Lifecycle {
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  OPEN = 'OPEN',
  REJECTED = 'REJECTED',
  WITHDRAWN = 'WITHDRAWN'
}

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ChangeAddressTokenDetailsInput = {
  newAddressUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 14 */
export enum OdProtosInventoryPrototypeData_EventType {
  /** When the listing's address token changes. */
  EVENT_ADDRESS_TOKEN_CHANGED = 'EVENT_ADDRESS_TOKEN_CHANGED',
  EVENT_BUYER_OFFER_ENTERED = 'EVENT_BUYER_OFFER_ENTERED',
  EVENT_HOME_OUT_OF_INVENTORY = 'EVENT_HOME_OUT_OF_INVENTORY',
  /** When the listing should be ingested into IMS. */
  EVENT_HOME_READY_FOR_UNDERWRITING = 'EVENT_HOME_READY_FOR_UNDERWRITING',
  /** @deprecated No longer supported */
  EVENT_LISTING_PHOTOS_UPLOADED = 'EVENT_LISTING_PHOTOS_UPLOADED',
  /** When the listing state is flipped back from canceled. */
  EVENT_LISTING_REINSTATED = 'EVENT_LISTING_REINSTATED',
  /** When a list price ensembled valuation is canceled. */
  EVENT_LIST_PRICE_ENSEMBLED_VALUATION_CANCELED = 'EVENT_LIST_PRICE_ENSEMBLED_VALUATION_CANCELED',
  /** When a list price ensembled valuation is completed. */
  EVENT_LIST_PRICE_ENSEMBLED_VALUATION_COMPLETED = 'EVENT_LIST_PRICE_ENSEMBLED_VALUATION_COMPLETED',
  /** When a list price ensembled valuation is escalated. */
  EVENT_LIST_PRICE_ENSEMBLED_VALUATION_ESCALATED = 'EVENT_LIST_PRICE_ENSEMBLED_VALUATION_ESCALATED',
  /** When the list price valuation is completed. */
  EVENT_LIST_PRICE_VALUATION_COMPLETED = 'EVENT_LIST_PRICE_VALUATION_COMPLETED',
  /** When a list price valuation task is requested. */
  EVENT_LIST_PRICE_VALUATION_REQUESTED = 'EVENT_LIST_PRICE_VALUATION_REQUESTED',
  EVENT_MANUAL_TRIGGER = 'EVENT_MANUAL_TRIGGER',
  /** When the listing's portfolio changes. */
  EVENT_ORGANIZATION_CHANGED = 'EVENT_ORGANIZATION_CHANGED',
  EVENT_SNAPSHOT = 'EVENT_SNAPSHOT'
}

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListPriceEnsembledValuationCompletedDetailsInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListPriceEnsembledValuationEscalatedDetailsInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListPriceValuationCompletedDetailsInput = {
  valuationId?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListPriceValuationRequestedDetailsInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListingPhotosUploadedDetailsInput = {
  dwellingType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosInventoryPrototypeNetProceeds_BuyerOfferNetProceedsRequestInput = {
  brnCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  brokerCommission?: InputMaybe<OdProtosCommon_MoneyInput>;
  concession?: InputMaybe<OdProtosCommon_MoneyInput>;
  daysPendToClose?: InputMaybe<Scalars['Float']['input']>;
  /** For indifference price there are still days left till pend */
  daysToPend?: InputMaybe<Scalars['Float']['input']>;
  /** Used for fetching data from financials service (e.g. financing costs). */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /** Next ID: 17 */
  headlinePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  homeWarranty?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** UUID of the listing that the offer belongs to. */
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  netReferralCommission?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerId?: InputMaybe<Scalars['Float']['input']>;
  /** Cost if Opendoor pays the title insurance. */
  titleCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Amount gained if the buyer uses OD title JV. */
  titleCredit?: InputMaybe<OdProtosCommon_MoneyInput>;
  unitHoldingCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** If BwOD agent is used */
  usingBwodAgent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the buyer offer has Opendoor Home Loan attached. */
  usingOdHomeLoan?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosInventoryPrototypeNetProceeds_PreListNetProceedsRequestInput = {
  acquisitionCloseDate?: InputMaybe<Scalars['DateTime']['input']>;
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Next ID: 7 */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  offer?: InputMaybe<OdProtosInventoryPrototypeNetProceeds_PreListOfferInput>;
  uwAfterRenovationValuationCents?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInventoryPrototypeNetProceeds_PreListOfferInput = {
  brnCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  brokerCommission?: InputMaybe<OdProtosCommon_MoneyInput>;
  concession?: InputMaybe<OdProtosCommon_MoneyInput>;
  daysPendToClose?: InputMaybe<Scalars['Float']['input']>;
  /** Next ID: 13 */
  headlinePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  homeWarranty?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** UUID of the listing that the offer belongs to. */
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  netReferralCommission?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerDate?: InputMaybe<Scalars['DateTime']['input']>;
  offerId?: InputMaybe<Scalars['Float']['input']>;
  /** Cost if Opendoor pays the title insurance. */
  titleCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Amount gained if the buyer uses OD title JV. */
  titleCredit?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInventoryPrototypeServices_GetAgentFeedbacksRequestInput = {
  /**
   * Using oneof here in case we want to allow looking up by other identifiers
   * like address token in the future.
   */
  identifier?: InputMaybe<OdProtosInventoryPrototypeServices_GetAgentFeedbacksRequest_IdentifierOneofInput>;
};

export type OdProtosInventoryPrototypeServices_GetAgentFeedbacksRequest_IdentifierOneofInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosInventoryPrototypeServices_InventoryManagementRequest_ConsiderBuyerOfferInput = {
  buyOfferDetails?: InputMaybe<OdProtosInventoryPrototypeData_BuyerOfferDetailsInput>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  listing?: InputMaybe<OdProtosProjectionsDataFlip_ListingInput>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 13 */
export type OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  eventDetails?: InputMaybe<OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneofInput>;
  eventType?: InputMaybe<OdProtosInventoryPrototypeData_EventType>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  organizationToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * DEPRECATED
   * TODO(jiatu): Remove when we do not communicate with web_listing_id anymore.
   */
  webListingId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneofInput = {
  buyOfferDetails?: InputMaybe<OdProtosInventoryPrototypeData_BuyerOfferDetailsInput>;
  changeAddressTokenDetails?: InputMaybe<OdProtosInventoryPrototypeData_ChangeAddressTokenDetailsInput>;
  listPriceEnsembledValuationCompletedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListPriceEnsembledValuationCompletedDetailsInput>;
  listPriceEnsembledValuationEscalatedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListPriceEnsembledValuationEscalatedDetailsInput>;
  listPriceValuationCompletedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListPriceValuationCompletedDetailsInput>;
  listPriceValuationRequestedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListPriceValuationRequestedDetailsInput>;
  listingPhotosUploadedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListingPhotosUploadedDetailsInput>;
};

/**
 * FlipInfo has all required property data from Web needed by Invoicer.
 * Invoicer currently does not make REST calls back to Web.
 * Next ID: 4
 */
export type OdProtosInvoicerData_FlipInfoInput = {
  /** Human readable address for the home */
  addressHumanReadable?: InputMaybe<Scalars['String']['input']>;
  /** Current flip state for the flip token */
  flipState?: InputMaybe<Scalars['String']['input']>;
  /** Flip token for the property */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /** Market identifier for the home */
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Set if an organization other than Opendoor owns the home. */
  owningOrganizationId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  /** In relation to what service is this invoice. */
  serviceType?: InputMaybe<OdProtosInvoicerData_ServiceType>;
};

/**
 * Invoice describes an account receivable to vendor provider.
 * Next ID: 10
 */
export type OdProtosInvoicerData_InvoiceInput = {
  /** Free form map of custom invoice fields */
  customFields?: InputMaybe<Array<OdProtosInvoicerData_Invoice_CustomFieldsEntryInput>>;
  /** Invoice id within web */
  invoiceId?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Invoice token within web
   * For work orders this is the work order reference number
   */
  invoiceToken?: InputMaybe<Scalars['String']['input']>;
  /** Type of the invoice */
  invoiceType?: InputMaybe<OdProtosInvoicerData_InvoiceType>;
  /** Line items of the invoice */
  items?: InputMaybe<Array<OdProtosInvoicerData_InvoiceItemInput>>;
  /** Organization token within web */
  organizationToken?: InputMaybe<Scalars['String']['input']>;
  /** The purchase order number for the invoice */
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  /** The email of the requester to send the JE prep to */
  requesterEmail?: InputMaybe<Scalars['String']['input']>;
  /** Submission date of the invoice */
  submittedDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Vendor provided invoice number unique to the vendor branch */
  vendorInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * InvoiceItem models an invoice line item
 * Next ID: 6
 */
export type OdProtosInvoicerData_InvoiceItemInput = {
  /** Account name pertaining to the invoice line item */
  account?: InputMaybe<Scalars['String']['input']>;
  /** Date prescribed to the invoice line item */
  costIncurredDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Free form map of custom invoice item fields */
  customFields?: InputMaybe<Array<OdProtosInvoicerData_InvoiceItem_CustomFieldsEntryInput>>;
  /** Memo of the invoice line item */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Property information pertaining to the invoice line item */
  flipInfo?: InputMaybe<OdProtosInvoicerData_FlipInfoInput>;
  /** Quantity pertaining to the invoice line item */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Cost in cents */
  unitCostCents?: InputMaybe<Scalars['Float']['input']>;
};

/** `OdProtosInvoicerData_InvoiceItem_CustomFieldsEntryInput` represents the `custom_fields` map in `od_protos.invoicer.data.InvoiceItem`. */
export type OdProtosInvoicerData_InvoiceItem_CustomFieldsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * InvoiceType represents the category of an invoice.
 * Next ID: 2
 */
export enum OdProtosInvoicerData_InvoiceType {
  MAINTENANCE = 'MAINTENANCE',
  WORK_ORDER = 'WORK_ORDER'
}

/** `OdProtosInvoicerData_Invoice_CustomFieldsEntryInput` represents the `custom_fields` map in `od_protos.invoicer.data.Invoice`. */
export type OdProtosInvoicerData_Invoice_CustomFieldsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosInvoicerData_ServiceType {
  /** Renovation on a REIT owned home. */
  REIT_RENO = 'REIT_RENO',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosInvoicerServices_GenerateNetsuiteJeRequestInput = {
  /**
   * The input invoices for the JE request,
   * currently supports both maintenance and work order invoices
   */
  inputInvoices?: InputMaybe<Array<OdProtosInvoicerData_InvoiceInput>>;
};

export type OdProtosInvoicerServices_NotifyNoInvoicesForJeRequestInput = {
  /** Type of the invoice */
  invoiceType?: InputMaybe<OdProtosInvoicerData_InvoiceType>;
  /** The email of the requester to send the notification to */
  requesterEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AgentConnectCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_EventOneofInput>;
};

/** Triggered whenever a customer is shown a denial page other than a partner referral */
export type OdProtosJourneyDataCategories_AgentConnectCategory_DeniedEventInput = {
  denialReason?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AgentConnectCategory_EventOneofInput = {
  /** agent_connect_denied_event */
  deniedEvent?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_DeniedEventInput>;
  /** agent_connect_handoff_event */
  handoffEvent?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_HandoffEventInput>;
  /** agent_connect_view_event */
  viewEvent?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_ViewEventInput>;
};

/** Triggered whenever a customer completes a handoff to a referral partner */
export type OdProtosJourneyDataCategories_AgentConnectCategory_HandoffEventInput = {
  buyerIntent?: InputMaybe<Scalars['Boolean']['input']>;
  odEstimatedSalePriceCents?: InputMaybe<Scalars['Int']['input']>;
  partner?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_Partner>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
  sellerIntent?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_SellerIntent>;
};

export enum OdProtosJourneyDataCategories_AgentConnectCategory_Partner {
  CLEVER = 'CLEVER',
  JMG = 'JMG',
  MSRE = 'MSRE',
  PARN = 'PARN',
  REDFIN = 'REDFIN',
  UNKNOWN_PARTNER = 'UNKNOWN_PARTNER'
}

export enum OdProtosJourneyDataCategories_AgentConnectCategory_SellerIntent {
  CASH = 'CASH',
  CASH_PLUS = 'CASH_PLUS',
  LIST = 'LIST',
  UNKNOWN = 'UNKNOWN'
}

/** Triggered whenever a Partner page is shown to refer in Agent Connect */
export type OdProtosJourneyDataCategories_AgentConnectCategory_ViewEventInput = {
  buyerIntent?: InputMaybe<Scalars['Boolean']['input']>;
  odEstimatedSalePriceCents?: InputMaybe<Scalars['Int']['input']>;
  partner?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_Partner>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AloCategoryInput = {
  /** Next ID: 4 */
  event?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_EventOneofInput>;
};

export enum OdProtosJourneyDataCategories_AloCategory_AloExperienceSlug {
  ALO_POST_HANDOFF_V1 = 'ALO_POST_HANDOFF_V1',
  UNKNOWN_SLUG = 'UNKNOWN_SLUG'
}

/** Next ID: 10 */
export type OdProtosJourneyDataCategories_AloCategory_AloEligibilityDetailsInput = {
  isAfterLaunchDate?: InputMaybe<Scalars['Boolean']['input']>;
  isEligibleMarket?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isNotPreviouslyDeniedRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  isNotReit?: InputMaybe<Scalars['Boolean']['input']>;
  isNotRestrictedPartnershipLead?: InputMaybe<Scalars['Boolean']['input']>;
  isNotVolumeRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  isNotWorkingWithAgent?: InputMaybe<Scalars['Boolean']['input']>;
  isValidOfferRequestSource?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 4 */
export type OdProtosJourneyDataCategories_AloCategory_AloHandoffPageViewEventInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  leadUuid?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 10 */
export type OdProtosJourneyDataCategories_AloCategory_AloHandoffSubmitEventInput = {
  addressReadable?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  leadUuid?: InputMaybe<Scalars['String']['input']>;
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AloCategory_AloPageViewEventInput = {
  experienceSlug?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloExperienceSlug>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  leadUuid?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 10 */
export type OdProtosJourneyDataCategories_AloCategory_AloQualificationEventInput = {
  aloEligibilityDetails?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloEligibilityDetailsInput>;
  eligibilityDetails?: InputMaybe<Array<OdProtosJourneyDataCategories_AloCategory_AloQualificationEvent_EligibilityDetailsEntryInput>>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  leadUuid?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  offerRequestSource?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_QualificationDecision>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosJourneyDataCategories_AloCategory_AloQualificationEvent_EligibilityDetailsEntryInput` represents the `eligibility_details` map in `od_protos.journey.data.categories.AloCategory.AloQualificationEvent`. */
export type OdProtosJourneyDataCategories_AloCategory_AloQualificationEvent_EligibilityDetailsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosJourneyDataCategories_AloCategory_EventOneofInput = {
  /** alo_handoff_page_view_event */
  handoffPageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloHandoffPageViewEventInput>;
  /** alo_handoff_submit_event */
  handoffSubmitEvent?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloHandoffSubmitEventInput>;
  /** alo_page_view_event */
  pageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloPageViewEventInput>;
  /** alo_qualification_event */
  qualificationEvent?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloQualificationEventInput>;
};

export enum OdProtosJourneyDataCategories_AloCategory_QualificationDecision {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosJourneyDataCategories_AssessmentCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFirstPhotoTakenInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFirstQuestionAnsweredInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFlowCompletedEventInput = {
  assessmentType?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentType>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFlowStartEventInput = {
  assessmentType?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentType>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentRequestedEventInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentScheduleStartEventInput = {
  assessmentType?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentType>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentSpaceCompletedInput = {
  allAreasCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  spaceTypeName?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_AssessmentCategory_AssessmentType {
  HA = 'HA',
  ORVA = 'ORVA',
  SSVA = 'SSVA',
  UNKNOWN_ASSESSMENT_TYPE = 'UNKNOWN_ASSESSMENT_TYPE',
  VIRTUAL_INSPECTION = 'VIRTUAL_INSPECTION'
}

export type OdProtosJourneyDataCategories_AssessmentCategory_EventOneofInput = {
  firstPhotoTaken?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFirstPhotoTakenInput>;
  firstQuestionAnswered?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFirstQuestionAnsweredInput>;
  flowCompleted?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFlowCompletedEventInput>;
  flowStart?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFlowStartEventInput>;
  /** assessment_requested_event */
  requested?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentRequestedEventInput>;
  scheduleStart?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentScheduleStartEventInput>;
  spaceCompleted?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentSpaceCompletedInput>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_EventOneofInput>;
};

export enum OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod {
  APPLE = 'APPLE',
  EMAIL_PASSWORD = 'EMAIL_PASSWORD',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  LITE = 'LITE',
  METHOD_UNSPECIFIED = 'METHOD_UNSPECIFIED',
  SESSION_ALREADY_EXISTS = 'SESSION_ALREADY_EXISTS'
}

export enum OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource {
  KEY_APP = 'KEY_APP',
  SOURCE_UNSPECIFIED = 'SOURCE_UNSPECIFIED'
}

export type OdProtosJourneyDataCategories_AuthenticationCategory_ClientRegistrationEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_EventOneofInput = {
  /** authentication_client_registration_event */
  clientRegistration?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_ClientRegistrationEventInput>;
  /** authentication_login_event */
  login?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_LoginEventInput>;
  /** authentication_login_failure_event */
  loginFailure?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_LoginFailureEventInput>;
  /** authentication_registration_event */
  registration?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_RegistrationEventInput>;
  /** authentication_registration_failure_event */
  registrationFailure?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_RegistrationFailureEventInput>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_LoginEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  authSource?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_LoginFailureEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  authSource?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_RegistrationEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  authSource?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_RegistrationFailureEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  authSource?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource>;
};

export type OdProtosJourneyDataCategories_ChatCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_ChatCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_ChatCategory_EventOneofInput = {
  interaction?: InputMaybe<OdProtosJourneyDataCategories_ChatCategory_InteractionEventInput>;
};

export type OdProtosJourneyDataCategories_ChatCategory_InteractionEventInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  interactionId?: InputMaybe<Scalars['String']['input']>;
  interactionType?: InputMaybe<OdProtosJourneyDataCategories_ChatCategory_InteractionEvent_InteractionType>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  rawUserInput?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosJourneyDataCategories_ChatCategory_InteractionEvent_Source>;
};

/** Next ID: 2 */
export enum OdProtosJourneyDataCategories_ChatCategory_InteractionEvent_InteractionType {
  SMS = 'SMS',
  UNKNOWN_INTERACTION_TYPE = 'UNKNOWN_INTERACTION_TYPE'
}

/** Next ID: 4 */
export enum OdProtosJourneyDataCategories_ChatCategory_InteractionEvent_Source {
  CHAT_UI = 'CHAT_UI',
  CUSTOMER_INITIATED = 'CUSTOMER_INITIATED',
  OPENDOOR_INITIATED = 'OPENDOOR_INITIATED',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE'
}

/** Next ID: 3 */
export type OdProtosJourneyDataCategories_CommunicationCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_CommunicationCategory_EventOneofInput = {
  smsReceived?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategory_SmsReceivedEventInput>;
  smsSent?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategory_SmsSentEventInput>;
  subscriptionUpdated?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEventInput>;
};

/** when a customer receives an sms from opendoor */
export type OdProtosJourneyDataCategories_CommunicationCategory_SmsReceivedEventInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  messageSid?: InputMaybe<Scalars['String']['input']>;
  toPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** when a customer sends an sms to opendoor */
export type OdProtosJourneyDataCategories_CommunicationCategory_SmsSentEventInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  messageSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCategory?: InputMaybe<Scalars['String']['input']>;
  toPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * when a customer changes their feed-level subscriptions
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEventInput = {
  actor?: InputMaybe<OdProtosCustomerV1Data_Actor>;
  /** Consent audit fields — populated when change originates from a customer-facing UI */
  consentLanguage?: InputMaybe<Scalars['String']['input']>;
  preferenceSource?: InputMaybe<OdProtosCustomerV1Data_PreferenceSource>;
  /**
   * map of feed name to whether the customer is subscribed to that feed
   * format: medium.feed_name -> is_subscribed
   */
  subscriptions?: InputMaybe<Array<OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntryInput>>;
};

/** `OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntryInput` represents the `subscriptions` map in `od_protos.journey.data.categories.CommunicationCategory.SubscriptionUpdatedEvent`. */
export type OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_AssignmentEventInput = {
  experimentName?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_EventOneofInput = {
  /** experimentation_assignment_event */
  assignment?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_AssignmentEventInput>;
  /** experimentation_impression_event */
  impression?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_ImpressionEventInput>;
  /** experimentation_lead_assignment_event */
  leadAssignment?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_LeadAssignmentEventInput>;
  /** experimentation_lead_impression_event */
  leadImpression?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_LeadImpressionEventInput>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_ImpressionEventInput = {
  experimentName?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_LeadAssignmentEventInput = {
  experimentName?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_LeadImpressionEventInput = {
  experimentName?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_HomeGuideCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_HomeGuideCategory_EventOneofInput = {
  qualification?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_QualificationEventInput>;
  valuation?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_ValuationEventInput>;
};

export type OdProtosJourneyDataCategories_HomeGuideCategory_QualificationEventInput = {
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_QualificationEvent_QualificationDecision>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_HomeGuideCategory_QualificationEvent_QualificationDecision {
  PRODUCT_DENIED = 'PRODUCT_DENIED',
  PRODUCT_QUALIFIED = 'PRODUCT_QUALIFIED',
  PRODUCT_UNDENIED = 'PRODUCT_UNDENIED',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 6 */
export type OdProtosJourneyDataCategories_HomeGuideCategory_ValuationEventInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  compsAddressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_ValuationEvent_ValuationSource>;
  valuationCents?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 3 */
export enum OdProtosJourneyDataCategories_HomeGuideCategory_ValuationEvent_ValuationSource {
  BALLPARK = 'BALLPARK',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE',
  VALUATION_API = 'VALUATION_API'
}

export type OdProtosJourneyDataCategories_LanguageCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_LanguageCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_LanguageCategory_EventOneofInput = {
  selectEvent?: InputMaybe<OdProtosJourneyDataCategories_LanguageCategory_SelectEventInput>;
};

export enum OdProtosJourneyDataCategories_LanguageCategory_Language {
  ENGLISH = 'ENGLISH',
  LANGUAGE_UNSPECIFIED = 'LANGUAGE_UNSPECIFIED',
  SPANISH = 'SPANISH'
}

export type OdProtosJourneyDataCategories_LanguageCategory_SelectEventInput = {
  language?: InputMaybe<OdProtosJourneyDataCategories_LanguageCategory_Language>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_DetailPageViewEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneofInput = {
  detailPageView?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_DetailPageViewEventInput>;
  offerStart?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_OfferStartEventInput>;
  reaction?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_ReactionEventInput>;
  rentalScamBannerLearnMore?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_RentalScamBannerLearnMoreEventInput>;
  rentalScamBannerView?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_RentalScamBannerViewEventInput>;
  share?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_ShareEventInput>;
  similarHomesClick?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_SimilarHomesClickEventInput>;
  tourBookingStart?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_TourBookingStartEventInput>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_OfferStartEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_ReactionEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_ReactionEventReaction>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_MarketplacePropertyCategory_ReactionEventReaction {
  REACTION_ADD_DISLIKE = 'REACTION_ADD_DISLIKE',
  REACTION_ADD_LIKE = 'REACTION_ADD_LIKE',
  REACTION_REMOVE_DISLIKE = 'REACTION_REMOVE_DISLIKE',
  REACTION_REMOVE_LIKE = 'REACTION_REMOVE_LIKE',
  REACTION_UNSPECIFIED = 'REACTION_UNSPECIFIED'
}

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_RentalScamBannerLearnMoreEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_RentalScamBannerViewEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_ShareEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_SimilarHomesClickEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  clickedAddressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_TourBookingStartEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
};

/**
 * ============================================
 * Enums
 * ============================================
 */
export type OdProtosJourneyDataCategories_MortgageCategoryInput = {
  /** Next ID: 35 */
  event?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_EventOneofInput>;
};

/**
 * Fired when backend returns application decision
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_MortgageCategory_ApplicationDecisionEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  decisionType?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_DecisionType>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  timeToDecisionMs?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Fired when user lands on the application for the first time
 * Next ID: 4
 */
export type OdProtosJourneyDataCategories_MortgageCategory_ApplicationStartEventInput = {
  /** borrower_uuid is the customer/applicant identifier */
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  entrySource?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_EntrySource>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Fired when user clicks submit on Review step
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_MortgageCategory_ApplicationSubmitEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  integrationsUsed?: InputMaybe<Array<OdProtosJourneyDataCategories_MortgageCategory_IntegrationType>>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  totalDurationMs?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_DecisionType {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  UNKNOWN_DECISION = 'UNKNOWN_DECISION'
}

/**
 * Fired when user signs disclosures
 * Next ID: 3
 */
export type OdProtosJourneyDataCategories_MortgageCategory_DisclosuresSignedEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Fired when user selects or changes down payment percentage
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_MortgageCategory_DownPaymentSelectionEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  downPaymentPercent?: InputMaybe<Scalars['Float']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_EntrySource {
  DIRECT = 'DIRECT',
  MARKETING = 'MARKETING',
  PARTNER = 'PARTNER',
  REFERRAL = 'REFERRAL',
  UNKNOWN_ENTRY_SOURCE = 'UNKNOWN_ENTRY_SOURCE'
}

export type OdProtosJourneyDataCategories_MortgageCategory_EventOneofInput = {
  applicationDecision?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ApplicationDecisionEventInput>;
  /** Application Funnel */
  applicationStart?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ApplicationStartEventInput>;
  applicationSubmit?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ApplicationSubmitEventInput>;
  disclosuresSigned?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_DisclosuresSignedEventInput>;
  downPaymentSelection?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_DownPaymentSelectionEventInput>;
  integrationResult?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_IntegrationResultEventInput>;
  /** Verification & Integrations */
  integrationStart?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_IntegrationStartEventInput>;
  lowerReferral?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_LowerReferralEventInput>;
  outOfPocketMaxSelection?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_OutOfPocketMaxSelectionEventInput>;
  prequalDecision?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalDecisionEventInput>;
  /** Prequal Funnel */
  prequalStart?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalStartEventInput>;
  prequalStepComplete?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalStepCompleteEventInput>;
  prequalStepView?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalStepViewEventInput>;
  prequalSubmit?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalSubmitEventInput>;
  prequalValidationError?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalValidationErrorEventInput>;
  productPricingSeeDetails?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ProductPricingSeeDetailsEventInput>;
  productPricingSelect?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ProductPricingSelectEventInput>;
  /** Product Pricing & Rate Lock */
  productPricingStart?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ProductPricingStartEventInput>;
  rateLockComplete?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_RateLockCompleteEventInput>;
  rateLockStart?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_RateLockStartEventInput>;
  stepComplete?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_StepCompleteEventInput>;
  stepView?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_StepViewEventInput>;
  /** User Behavior */
  validationError?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ValidationErrorEventInput>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_FailureReason {
  EMPLOYER_NOT_FOUND = 'EMPLOYER_NOT_FOUND',
  ERROR = 'ERROR',
  INSTITUTION_ERROR = 'INSTITUTION_ERROR',
  TIMEOUT = 'TIMEOUT',
  UNKNOWN_FAILURE = 'UNKNOWN_FAILURE',
  USER_CANCELLED = 'USER_CANCELLED',
  VERIFICATION_FAILED = 'VERIFICATION_FAILED'
}

export enum OdProtosJourneyDataCategories_MortgageCategory_IntegrationResult {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
  UNKNOWN_RESULT = 'UNKNOWN_RESULT'
}

/**
 * Fired when an integration completes (success, failure, or cancellation)
 * Next ID: 7
 */
export type OdProtosJourneyDataCategories_MortgageCategory_IntegrationResultEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  failureReason?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_FailureReason>;
  integrationType?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_IntegrationType>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_IntegrationResult>;
};

/**
 * Fired when an integration modal opens (Plaid Link, Truv, etc.)
 * Next ID: 4
 */
export type OdProtosJourneyDataCategories_MortgageCategory_IntegrationStartEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_IntegrationType>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_IntegrationType {
  PLAID_LINK = 'PLAID_LINK',
  TRUV = 'TRUV',
  UNKNOWN_INTEGRATION = 'UNKNOWN_INTEGRATION'
}

/**
 * Fired when user is referred to Lower.com (checkout flow disqualification path)
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_MortgageCategory_LowerReferralEventInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  prequalApplicationId?: InputMaybe<Scalars['String']['input']>;
  referralReason?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalDecisionType>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Fired when user sets or changes their out-of-pocket maximum
 * Next ID: 4
 */
export type OdProtosJourneyDataCategories_MortgageCategory_OutOfPocketMaxSelectionEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  outOfPocketMaxCents?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_PrequalChannel {
  BUYER_CHECKOUT = 'BUYER_CHECKOUT',
  LISTING_PARTNER_LINK = 'LISTING_PARTNER_LINK',
  UNKNOWN_CHANNEL = 'UNKNOWN_CHANNEL'
}

/**
 * Fired when backend returns the prequal decision
 * Next ID: 7
 */
export type OdProtosJourneyDataCategories_MortgageCategory_PrequalDecisionEventInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  decisionType?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalDecisionType>;
  maxLoanAmountCents?: InputMaybe<Scalars['Float']['input']>;
  prequalApplicationId?: InputMaybe<Scalars['String']['input']>;
  ratePercent?: InputMaybe<Scalars['String']['input']>;
  timeToDecisionMs?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_PrequalDecisionType {
  PREQUAL_APPROVED = 'PREQUAL_APPROVED',
  PREQUAL_DECLINED = 'PREQUAL_DECLINED',
  PREQUAL_DISQUALIFIED = 'PREQUAL_DISQUALIFIED',
  PREQUAL_TIMED_OUT = 'PREQUAL_TIMED_OUT',
  PREQUAL_UNKNOWN_DECISION = 'PREQUAL_UNKNOWN_DECISION'
}

/**
 * Fired when user starts the prequal flow (title screen shown or landing page loaded)
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_MortgageCategory_PrequalStartEventInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  prequalApplicationId?: InputMaybe<Scalars['String']['input']>;
  prequalChannel?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalChannel>;
  prequalLinkId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Fired when user successfully advances past a prequal step
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_MortgageCategory_PrequalStepCompleteEventInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  prequalApplicationId?: InputMaybe<Scalars['String']['input']>;
  stepKey?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalStepKey>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_PrequalStepKey {
  PREQUAL_ANNUAL_INCOME = 'PREQUAL_ANNUAL_INCOME',
  PREQUAL_CLOSING_DATE = 'PREQUAL_CLOSING_DATE',
  PREQUAL_CO_BORROWER = 'PREQUAL_CO_BORROWER',
  PREQUAL_CREDIT_SCORE = 'PREQUAL_CREDIT_SCORE',
  PREQUAL_CURRENT_ADDRESS = 'PREQUAL_CURRENT_ADDRESS',
  PREQUAL_DOWN_PAYMENT = 'PREQUAL_DOWN_PAYMENT',
  PREQUAL_EMPLOYMENT_STATUS = 'PREQUAL_EMPLOYMENT_STATUS',
  PREQUAL_HOME_USAGE = 'PREQUAL_HOME_USAGE',
  PREQUAL_LOCATION = 'PREQUAL_LOCATION',
  PREQUAL_MONTHLY_DEBT = 'PREQUAL_MONTHLY_DEBT',
  PREQUAL_PHONE_NUMBER = 'PREQUAL_PHONE_NUMBER',
  PREQUAL_PURCHASE_PRICE = 'PREQUAL_PURCHASE_PRICE',
  PREQUAL_PURCHASE_TIMELINE = 'PREQUAL_PURCHASE_TIMELINE',
  PREQUAL_UNKNOWN_STEP = 'PREQUAL_UNKNOWN_STEP'
}

/**
 * Fired when user navigates to a prequal question step
 * Next ID: 6
 */
export type OdProtosJourneyDataCategories_MortgageCategory_PrequalStepViewEventInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  isFirstView?: InputMaybe<Scalars['Boolean']['input']>;
  isReturnVisit?: InputMaybe<Scalars['Boolean']['input']>;
  prequalApplicationId?: InputMaybe<Scalars['String']['input']>;
  stepKey?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalStepKey>;
};

/**
 * Fired when user submits the completed prequal form
 * Next ID: 6
 */
export type OdProtosJourneyDataCategories_MortgageCategory_PrequalSubmitEventInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  prequalApplicationId?: InputMaybe<Scalars['String']['input']>;
  prequalChannel?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalChannel>;
  stepsCompleted?: InputMaybe<Scalars['Float']['input']>;
  totalDurationMs?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Fired when form validation fails on a prequal step
 * Next ID: 6
 */
export type OdProtosJourneyDataCategories_MortgageCategory_PrequalValidationErrorEventInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ValidationErrorType>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  prequalApplicationId?: InputMaybe<Scalars['String']['input']>;
  stepKey?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_PrequalStepKey>;
};

/**
 * Fired when user clicks "View details" on a rate option
 * Next ID: 4
 */
export type OdProtosJourneyDataCategories_MortgageCategory_ProductPricingSeeDetailsEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  ratePercent?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Fired when user selects a rate option
 * Next ID: 6
 */
export type OdProtosJourneyDataCategories_MortgageCategory_ProductPricingSelectEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  lockPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  monthlyPaymentCents?: InputMaybe<Scalars['Float']['input']>;
  ratePercent?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Fired when user enters the product pricing flow (after selecting down payment)
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_MortgageCategory_ProductPricingStartEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  downPaymentPercent?: InputMaybe<Scalars['Float']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  optionsCount?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Fired when rate lock is successfully completed
 * Next ID: 7
 */
export type OdProtosJourneyDataCategories_MortgageCategory_RateLockCompleteEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  cashToCloseCents?: InputMaybe<Scalars['Float']['input']>;
  downPaymentPercent?: InputMaybe<Scalars['Float']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  monthlyPaymentCents?: InputMaybe<Scalars['Float']['input']>;
  ratePercent?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Fired when user initiates rate lock (clicks "Lock my rate")
 * Next ID: 5
 */
export type OdProtosJourneyDataCategories_MortgageCategory_RateLockStartEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  lockPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  ratePercent?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Fired when user successfully advances to the next step
 * Next ID: 7
 */
export type OdProtosJourneyDataCategories_MortgageCategory_StepCompleteEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  integrationSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  integrationType?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_IntegrationType>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  stepKey?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_StepKey>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_StepKey {
  ABOUT_YOU = 'ABOUT_YOU',
  ASSETS = 'ASSETS',
  DECLARATIONS = 'DECLARATIONS',
  EMPLOYMENT_INCOME = 'EMPLOYMENT_INCOME',
  REAL_ESTATE = 'REAL_ESTATE',
  REVIEW_SUBMIT = 'REVIEW_SUBMIT',
  UNKNOWN_STEP = 'UNKNOWN_STEP',
  VERIFICATION = 'VERIFICATION'
}

/**
 * Fired when user navigates to a step (including returns)
 * Next ID: 6
 */
export type OdProtosJourneyDataCategories_MortgageCategory_StepViewEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  isFirstView?: InputMaybe<Scalars['Boolean']['input']>;
  isReturnVisit?: InputMaybe<Scalars['Boolean']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  stepKey?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_StepKey>;
};

/**
 * Fired when form validation fails
 * Next ID: 6
 */
export type OdProtosJourneyDataCategories_MortgageCategory_ValidationErrorEventInput = {
  borrowerUuid?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_ValidationErrorType>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  loanUuid?: InputMaybe<Scalars['String']['input']>;
  stepKey?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategory_StepKey>;
};

export enum OdProtosJourneyDataCategories_MortgageCategory_ValidationErrorType {
  CUSTOM = 'CUSTOM',
  FORMAT = 'FORMAT',
  RANGE = 'RANGE',
  REQUIRED = 'REQUIRED',
  UNKNOWN_ERROR_TYPE = 'UNKNOWN_ERROR_TYPE'
}

export type OdProtosJourneyDataCategories_PlatformCategoryInput = {
  /** Next ID: 37 */
  event?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AccordionClickEventInput = {
  /** Name of the individual accordion in the accordion list */
  accordionName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AccordionViewEventInput = {
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AppBackgroundedEventInput = {
  /** App build number (e.g., "456") */
  build?: InputMaybe<Scalars['String']['input']>;
  /** App version (e.g., "1.2.3") */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AppDownloadLinkEventInput = {
  devicePlatform?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_DevicePlatform>;
  linkMethod?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_LinkMethod>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AppForegroundedEventInput = {
  /** App build number (e.g., "456") */
  build?: InputMaybe<Scalars['String']['input']>;
  /** Whether app transitioned from background (always true for this event) */
  fromBackground?: InputMaybe<Scalars['Boolean']['input']>;
  /** App version (e.g., "1.2.3") */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** App lifecycle events for mobile apps */
export type OdProtosJourneyDataCategories_PlatformCategory_AppLaunchedEventInput = {
  /** App build number (e.g., "456") */
  build?: InputMaybe<Scalars['String']['input']>;
  /** Whether app transitioned from background to foreground (vs cold start) */
  fromBackground?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bundle ID of referring application if launched from another app */
  referringApplication?: InputMaybe<Scalars['String']['input']>;
  /** Deep link URL if app was launched via URL */
  url?: InputMaybe<Scalars['String']['input']>;
  /** App version (e.g., "1.2.3") */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_BoxViewEventInput = {
  /**
   * Canonical identifier of the box
   * Convention: {app_name}-{box_name}
   * box_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_ButtonClickEventInput = {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_ButtonViewEventInput = {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CardViewEventInput = {
  /**
   * Canonical identifier of the card
   * Convention: {app_name}-{card_name}
   * card_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CheckboxClickEventInput = {
  /** Name of the individual checkbox in the checkbox group */
  optionName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CheckboxViewEventInput = {
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CustomerOneTimeExperienceEventInput = {
  experienceName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CustomerUnsubscribeEventInput = {
  feedName?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_PlatformCategory_DevicePlatform {
  ANDROID = 'ANDROID',
  DEVICE_PLATFORM_UNSPECIFIED = 'DEVICE_PLATFORM_UNSPECIFIED',
  IOS = 'IOS'
}

export type OdProtosJourneyDataCategories_PlatformCategory_EventOneofInput = {
  accordionClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AccordionClickEventInput>;
  accordionViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AccordionViewEventInput>;
  appBackgroundedEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AppBackgroundedEventInput>;
  appDownloadLinkEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AppDownloadLinkEventInput>;
  appForegroundedEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AppForegroundedEventInput>;
  appLaunchedEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AppLaunchedEventInput>;
  boxViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_BoxViewEventInput>;
  buttonClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_ButtonClickEventInput>;
  buttonViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_ButtonViewEventInput>;
  cardViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CardViewEventInput>;
  checkboxClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CheckboxClickEventInput>;
  checkboxViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CheckboxViewEventInput>;
  customerOneTimeExperienceEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CustomerOneTimeExperienceEventInput>;
  customerUnsubscribeEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CustomerUnsubscribeEventInput>;
  formFieldCompleteEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormFieldCompleteEventInput>;
  formFieldFocusEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormFieldFocusEventInput>;
  formFieldValidationErrorEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormFieldValidationErrorEventInput>;
  formSubmitAttemptEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormSubmitAttemptEventInput>;
  formViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormViewEventInput>;
  imageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_ImageViewEventInput>;
  initialPageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_InitialPageViewEventInput>;
  inputFocusEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_InputFocusEventInput>;
  inputViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_InputViewEventInput>;
  leadOneTimeExperienceEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_LeadOneTimeExperienceEventInput>;
  linkClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_LinkClickEventInput>;
  linkViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_LinkViewEventInput>;
  pageLoadedEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_PageLoadedEventInput>;
  pageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_PageViewEventInput>;
  radioClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_RadioClickEventInput>;
  radioViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_RadioViewEventInput>;
  screenViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_ScreenViewEventInput>;
  sessionEndEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_SessionEndEventInput>;
  sessionStartEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_SessionStartEventInput>;
  textViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_TextViewEventInput>;
};

/** Context all form related events share */
export type OdProtosJourneyDataCategories_PlatformCategory_FormContextInput = {
  /** Canonical identifier of the form */
  formId?: InputMaybe<Scalars['String']['input']>;
  /** Session UUID for the unique session the customer interacted with the form */
  formSessionUuid?: InputMaybe<Scalars['String']['input']>;
  /** Version of the form */
  formVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Fired once per field per analytics session when the field transitions to a valid state. */
export type OdProtosJourneyDataCategories_PlatformCategory_FormFieldCompleteEventInput = {
  fieldContext?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormFieldContextInput>;
  formContext?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormContextInput>;
  /** Number of errors that occurred before the field transitioned to a valid state */
  invalidErrorCountBeforeSuccess?: InputMaybe<Scalars['Float']['input']>;
  /** Unset when the start time could not be established. */
  timeToCompleteMs?: InputMaybe<Scalars['Int']['input']>;
};

/** Context all field related events share */
export type OdProtosJourneyDataCategories_PlatformCategory_FormFieldContextInput = {
  /** Name of the field group that the field belongs to */
  fieldGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the field */
  fieldId?: InputMaybe<Scalars['String']['input']>;
  /** Type of the field */
  fieldType?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormFieldType>;
};

/** Fired once per field per analytics session on first focus / interaction. */
export type OdProtosJourneyDataCategories_PlatformCategory_FormFieldFocusEventInput = {
  fieldContext?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormFieldContextInput>;
  formContext?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormContextInput>;
};

export enum OdProtosJourneyDataCategories_PlatformCategory_FormFieldType {
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
  DROPDOWN = 'DROPDOWN',
  NUMBER = 'NUMBER',
  TEXT_INPUT = 'TEXT_INPUT',
  TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED'
}

/** Fired each time a validation error is surfaced for a field. */
export type OdProtosJourneyDataCategories_PlatformCategory_FormFieldValidationErrorEventInput = {
  /** Type of error that occurred during the field interaction */
  errorType?: InputMaybe<Scalars['String']['input']>;
  fieldContext?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormFieldContextInput>;
  formContext?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormContextInput>;
};

/** Fired each time the user attempts to submit the form (valid or invalid). */
export type OdProtosJourneyDataCategories_PlatformCategory_FormSubmitAttemptEventInput = {
  /** What attempt number this is in the session */
  attemptNumber?: InputMaybe<Scalars['Float']['input']>;
  /** Number of fields that were completed */
  completedFieldCount?: InputMaybe<Scalars['Float']['input']>;
  formContext?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormContextInput>;
  /** List of fields that were invalid */
  invalidFieldIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the form validation was successful */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Identifies which variant of the form was submitted. Forms with conditional
   * logic (e.g., a yes/no question revealing additional fields) have multiple
   * distinct field configurations. This value identifies which configuration
   * the user encountered at submission time.
   */
  pathVariant?: InputMaybe<Scalars['String']['input']>;
  /** Total time taken to submit the form */
  totalTimeMs?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of validation errors that have occurred in this session */
  totalValidationErrorCount?: InputMaybe<Scalars['Float']['input']>;
  /** Number of fields that were visible */
  visibleFieldCount?: InputMaybe<Scalars['Float']['input']>;
};

/** Fired once when the user first sees the form */
export type OdProtosJourneyDataCategories_PlatformCategory_FormViewEventInput = {
  formContext?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_FormContextInput>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_ImageViewEventInput = {
  /**
   * Canonical identifier of the image
   * Convention: {app_name}-{image_name}
   * image_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

/** temporary initial page_view event */
export type OdProtosJourneyDataCategories_PlatformCategory_InitialPageViewEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_InputFocusEventInput = {
  /**
   * Canonical identifier of the input
   * Convention: {app_name}-{input_name}
   * input_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_InputViewEventInput = {
  /**
   * Canonical identifier of the input
   * Convention: {app_name}-{input_name}
   * input_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_LeadOneTimeExperienceEventInput = {
  experienceName?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_LinkClickEventInput = {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_PlatformCategory_LinkMethod {
  CLICK = 'CLICK',
  LINK_METHOD_UNSPECIFIED = 'LINK_METHOD_UNSPECIFIED',
  QR_SCAN = 'QR_SCAN'
}

export type OdProtosJourneyDataCategories_PlatformCategory_LinkViewEventInput = {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

/** Used for measuring page performance, e.g. load time. */
export type OdProtosJourneyDataCategories_PlatformCategory_PageLoadedEventInput = {
  loadTimeMs?: InputMaybe<Scalars['Int']['input']>;
  routerPath?: InputMaybe<Scalars['String']['input']>;
};

/**
 * website_source field contains the page's url, etc.
 * No other event-specific data needed for now.
 */
export type OdProtosJourneyDataCategories_PlatformCategory_PageViewEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_RadioClickEventInput = {
  /** Name of the individual radio in the radio group */
  optionName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_RadioViewEventInput = {
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * mobile_source field contains the screen's focusRouteName, etc.
 * No other event-specfic data needed for now.
 */
export type OdProtosJourneyDataCategories_PlatformCategory_ScreenViewEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_SessionEndEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_SessionStartEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_TextViewEventInput = {
  /**
   * Canonical identifier of the text
   * Convention: {app_name}-{text_name}
   * text_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_ContactUsEventInput = {
  target?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneofInput = {
  contactUsEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_ContactUsEventInput>;
  generalErrorEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_GeneralErrorEventInput>;
  idVerificationEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationEventInput>;
  idVerificationSubmissionEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationSubmissionEventInput>;
  locationPermissionEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_LocationPermissionEventInput>;
  propertyStatusEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_PropertyStatusEventInput>;
  unlockAttemptEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_UnlockAttemptEventInput>;
  viewEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_ViewEventInput>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_GeneralErrorEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationActions {
  ALLOW_CAMERA = 'ALLOW_CAMERA',
  DISALLOW_CAMERA = 'DISALLOW_CAMERA',
  SCAN_BACK = 'SCAN_BACK',
  SCAN_FRONT = 'SCAN_FRONT',
  UNKNOWN_IDV_ACTION = 'UNKNOWN_IDV_ACTION'
}

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationEventInput = {
  action?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationActions>;
};

export enum OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationFailureFlavor {
  EXPIRED_ID = 'EXPIRED_ID',
  MITEK_ERROR = 'MITEK_ERROR',
  OD_SERVERSIDE_ERROR = 'OD_SERVERSIDE_ERROR',
  UNDERAGE_ID = 'UNDERAGE_ID',
  UNKNOWN_IDV_FAILURE = 'UNKNOWN_IDV_FAILURE'
}

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationSubmissionEventInput = {
  failureReason?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationFailureFlavor>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosJourneyDataCategories_RetailWebUnlockCategory_ListingValidationFailureFlavor {
  AFTER_HOURS_TOURING = 'AFTER_HOURS_TOURING',
  HOME_SOLD = 'HOME_SOLD',
  HOME_UNDER_CONTRACT = 'HOME_UNDER_CONTRACT',
  PPM = 'PPM',
  TEMPORARILY_OFF_MARKET = 'TEMPORARILY_OFF_MARKET',
  TRADITIONAL_LISTING = 'TRADITIONAL_LISTING',
  UNKNOWN_LISTING_FAILURE = 'UNKNOWN_LISTING_FAILURE'
}

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_LocationPermissionEventInput = {
  locationPermission?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_PropertyStatusEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  tourUnavailableReason?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_ListingValidationFailureFlavor>;
};

export enum OdProtosJourneyDataCategories_RetailWebUnlockCategory_StepType {
  GENERAL_ERROR = 'GENERAL_ERROR',
  ID_VERIFICATION_STEPS = 'ID_VERIFICATION_STEPS',
  ONBOARDING_STEPS = 'ONBOARDING_STEPS',
  PROPERTY_CONFIRMATION_STEPS = 'PROPERTY_CONFIRMATION_STEPS',
  UNKNOWN_STEP = 'UNKNOWN_STEP',
  UNLOCK_HOME_STEPS = 'UNLOCK_HOME_STEPS'
}

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_UnlockAttemptEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_UnlockFailureFlavor>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosJourneyDataCategories_RetailWebUnlockCategory_UnlockFailureFlavor {
  CODE_UNLOCK = 'CODE_UNLOCK',
  FAILED_UNLOCK = 'FAILED_UNLOCK',
  NEED_MORE_INFO = 'NEED_MORE_INFO',
  UNKNOWN_UNLOCK_FAILURE = 'UNKNOWN_UNLOCK_FAILURE'
}

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_ViewEventInput = {
  /** address_id is not set in start of the flow, so we allow it to be null */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** listing_id is not set in start of the flow, so we allow it to be null */
  listingId?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
  stepType?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_StepType>;
};

export type OdProtosJourneyDataCategories_SellCategoryInput = {
  /** Next ID: 16 */
  event?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_EventOneofInput>;
};

/** Next ID: 13 */
export type OdProtosJourneyDataCategories_SellCategory_AddressEntryEventInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  receptionChannel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields match IAddressInputAddress
   * https://github.com/opendoor-labs/code/blob/c393c8d0061e9a8ce32c63621d3ec1ded9fa55ca/js/packages/cinderblocks/src/growth/AddressInput/AddressInput.tsx#L19
   */
  street1?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 11 */
export type OdProtosJourneyDataCategories_SellCategory_AddressEntryV2EventInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  sourcePage?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosJourneyDataCategories_SellCategory_ApiOfferRequestEventInput = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 7 */
export type OdProtosJourneyDataCategories_SellCategory_ApiReferralHandoverEventInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Track the s3w intent for each lead at FO */
export type OdProtosJourneyDataCategories_SellCategory_CustomerProductIntentAtFinalOfferInput = {
  intent?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ProductIntentType>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Track the s3w intent for each lead after FO */
export type OdProtosJourneyDataCategories_SellCategory_CustomerProductIntentPostFinalOfferInput = {
  intent?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ProductIntentType>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellCategory_EventOneofInput = {
  /**
   * Growth team-owned events
   *
   * sell_address_entry_event
   */
  addressEntry?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_AddressEntryEventInput>;
  /** sell_address_entry_v2_event */
  addressEntryV2?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_AddressEntryV2EventInput>;
  /** sell_api_offer_request_event */
  apiOfferRequest?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ApiOfferRequestEventInput>;
  /** sell_api_referral_handover_event */
  apiReferralHandover?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ApiReferralHandoverEventInput>;
  customerProductIntentAtFinalOffer?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_CustomerProductIntentAtFinalOfferInput>;
  customerProductIntentPostFinalOffer?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_CustomerProductIntentPostFinalOfferInput>;
  /** sell_experience_viewed_event */
  experienceViewed?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ExperienceViewedEventInput>;
  /** sell_final_offer_comps_data_displayed_event */
  finalOfferCompsDataDisplayed?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_FinalOfferCompsDataDisplayedEventInput>;
  /** sell_onboarding_start_event */
  onboardingStart?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_OnboardingStartEventInput>;
  /** sell_product_closed_event */
  productClosed?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ProductClosedEventInput>;
  /** sell_signed_contract_event */
  signedContract?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_SignedContractEventInput>;
  /** sell_similar_home_comparison_click_event */
  similarHomeComparisonClick?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_SimilarHomeComparisonClickEventInput>;
  /** sell_similar_home_comparison_view_event */
  similarHomeComparisonView?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_SimilarHomeComparisonViewEventInput>;
  /** Seller team-owned events */
  ssvaTaskComplete?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_SsvaTaskCompleteEventInput>;
};

/** Triggered when a seller views a sell experience page */
export type OdProtosJourneyDataCategories_SellCategory_ExperienceViewedEventInput = {
  /** Optional: specific page design slug for tracking */
  experienceSlug?: InputMaybe<Scalars['String']['input']>;
  experienceType?: InputMaybe<OdProtosSellSellerData_SellerExperience>;
  isFirstOffer?: InputMaybe<Scalars['Boolean']['input']>;
  offerState?: InputMaybe<OdProtosSellSellerData_Offer_State>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * sell_final_offer_comps_data_displayed_event
 * Triggered when the final-offer page resolves the comps and market data shown to the seller.
 */
export type OdProtosJourneyDataCategories_SellCategory_FinalOfferCompsDataDisplayedEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  comparableRecentSalesAtOrAboveAskingCount?: InputMaybe<Scalars['Int']['input']>;
  comparableRecentSalesAvgSalePriceCents?: InputMaybe<Scalars['Float']['input']>;
  conditionEstimateYearBuilt?: InputMaybe<Scalars['Int']['input']>;
  hasComps?: InputMaybe<Scalars['Boolean']['input']>;
  localInventoryActiveListings?: InputMaybe<Scalars['Int']['input']>;
  localInventoryHomesOnMarket?: InputMaybe<Scalars['Int']['input']>;
  localInventoryHomesOnMarketMomPct?: InputMaybe<Scalars['Float']['input']>;
  localInventoryHomesSold?: InputMaybe<Scalars['Int']['input']>;
  localInventoryMedianSalePriceCents?: InputMaybe<Scalars['Float']['input']>;
  marketSnapshotDaysOnMarket?: InputMaybe<Scalars['Int']['input']>;
  marketSnapshotDelistingRatePct?: InputMaybe<Scalars['Float']['input']>;
  marketSnapshotNumDelistings?: InputMaybe<Scalars['Int']['input']>;
  marketSnapshotSaleToListDeltaPct?: InputMaybe<Scalars['Float']['input']>;
  marketSummaryAvgDaysOnMarket?: InputMaybe<Scalars['Int']['input']>;
  marketSummaryAvgDifferenceCents?: InputMaybe<Scalars['Float']['input']>;
  marketSummaryNetProceedsMaxCents?: InputMaybe<Scalars['Float']['input']>;
  marketSummaryNetProceedsMinCents?: InputMaybe<Scalars['Float']['input']>;
  marketSummarySalePriceMaxCents?: InputMaybe<Scalars['Float']['input']>;
  marketSummarySalePriceMinCents?: InputMaybe<Scalars['Float']['input']>;
  marketSummarySoldCount?: InputMaybe<Scalars['Int']['input']>;
  neighborhoodConditionBetterCount?: InputMaybe<Scalars['Int']['input']>;
  neighborhoodConditionSimilarCount?: InputMaybe<Scalars['Int']['input']>;
  neighborhoodConditionWorseCount?: InputMaybe<Scalars['Int']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  swuPricingUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 11 */
export type OdProtosJourneyDataCategories_SellCategory_OnboardingStartEventInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  receptionChannel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Triggered when a product transaction closes
 * Next ID: 4
 */
export type OdProtosJourneyDataCategories_SellCategory_ProductClosedEventInput = {
  /** Nullable: not present for LWC */
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_SellCategory_ProductIntentType {
  LIST = 'LIST',
  /** @deprecated No longer supported */
  MARKETPLACE = 'MARKETPLACE',
  SELL_DIRECT = 'SELL_DIRECT',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

export type OdProtosJourneyDataCategories_SellCategory_SsvaTaskCompleteEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  ssvaTaskName?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_SsvaTaskType>;
};

export enum OdProtosJourneyDataCategories_SellCategory_SsvaTaskType {
  QUESTIONNAIRE_TASK = 'QUESTIONNAIRE_TASK',
  SELLER_DISCLOSURE_DOCUMENT_TASK = 'SELLER_DISCLOSURE_DOCUMENT_TASK',
  UNKNOWN_SSVA_TASK_TYPE = 'UNKNOWN_SSVA_TASK_TYPE',
  UPLOAD_BACKYARD_RECORDING_TASK = 'UPLOAD_BACKYARD_RECORDING_TASK',
  UPLOAD_FRONTYARD_RECORDING_TASK = 'UPLOAD_FRONTYARD_RECORDING_TASK',
  UPLOAD_INTERIOR_RECORDING_TASK = 'UPLOAD_INTERIOR_RECORDING_TASK',
  UPLOAD_WHOLE_HOME_RECORDING_TASK = 'UPLOAD_WHOLE_HOME_RECORDING_TASK'
}

/**
 * Triggered when a seller signs a contract (PA for Cash/Cash Plus, Listing Agreement for LWC)
 * Next ID: 4
 */
export type OdProtosJourneyDataCategories_SellCategory_SignedContractEventInput = {
  /** Nullable: not present for LWC */
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellCategory_SimilarHomeComparisonClickEventInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  similarHomeAddressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellCategory_SimilarHomeComparisonViewEventInput = {
  agentCommissionCents?: InputMaybe<Scalars['Float']['input']>;
  closingCostsCents?: InputMaybe<Scalars['Float']['input']>;
  distanceMiles?: InputMaybe<Scalars['Float']['input']>;
  netProceedsCents?: InputMaybe<Scalars['Float']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  ownershipCostsCents?: InputMaybe<Scalars['Float']['input']>;
  prepCostCents?: InputMaybe<Scalars['Float']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  similarHomeAddressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_EventOneofInput>;
};

/** Fired client-side when the seller completes the questionnaire and qualifies for Opendoor Direct. */
export type OdProtosJourneyDataCategories_SellDirectCategory_ClientQualificationCompletedEventInput = {
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_EventOneofInput = {
  /** sell_direct_client_qualification_completed_event */
  clientQualificationCompleted?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_ClientQualificationCompletedEventInput>;
  finalOfferCreated?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_FinalOfferCreatedEventInput>;
  offerCreated?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_OfferCreatedEventInput>;
  offerFallthrough?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_OfferFallthroughEventInput>;
  offerView?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_OfferViewEventInput>;
  /** sell_direct_qualification_event */
  qualification?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_QualificationEventInput>;
  signComplete?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_SignCompleteEventInput>;
  signQuestionsSubmit?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_SignQuestionsSubmitEventInput>;
  signStart?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_SignStartEventInput>;
};

export enum OdProtosJourneyDataCategories_SellDirectCategory_FallthroughType {
  EXPIRATION = 'EXPIRATION',
  OD_WALK = 'OD_WALK',
  SELLER_WALK = 'SELLER_WALK',
  UNKNOWN_FALLTHROUGH_TYPE = 'UNKNOWN_FALLTHROUGH_TYPE'
}

export type OdProtosJourneyDataCategories_SellDirectCategory_FinalOfferCreatedEventInput = {
  finalizedFeePct?: InputMaybe<Scalars['Float']['input']>;
  headlinePrice?: InputMaybe<Scalars['Float']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  ovmExpectedError?: InputMaybe<Scalars['Float']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  underwritingId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_OfferCreatedEventInput = {
  headlineFeePct?: InputMaybe<Scalars['Float']['input']>;
  headlineOffer?: InputMaybe<Scalars['Float']['input']>;
  internalFeePct?: InputMaybe<Scalars['Float']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerCreationSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerIsRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  offerRefreshIndex?: InputMaybe<Scalars['Int']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  opendoorInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  ovmExpectedError?: InputMaybe<Scalars['Float']['input']>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_OfferFallthroughEventInput = {
  fallthroughType?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_FallthroughType>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_OfferViewEventInput = {
  isFirstOffer?: InputMaybe<Scalars['Boolean']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  /** This is populated with a UUID, not a numeric ID as the name suggests */
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerState?: InputMaybe<OdProtosSellSellerData_Offer_State>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * sell_direct_qualification_event
 * Triggered whenever qualification for the Sell Direct product changes
 */
export type OdProtosJourneyDataCategories_SellDirectCategory_QualificationEventInput = {
  denialReason?: InputMaybe<Scalars['String']['input']>;
  qualificationChannel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_QualificationEvent_QualificationDecision>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_SellDirectCategory_QualificationEvent_QualificationDecision {
  PRODUCT_DENIED = 'PRODUCT_DENIED',
  PRODUCT_QUALIFIED = 'PRODUCT_QUALIFIED',
  PRODUCT_UNDENIED = 'PRODUCT_UNDENIED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosJourneyDataCategories_SellDirectCategory_SignCompleteEventInput = {
  headlinePrice?: InputMaybe<Scalars['Float']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_SignQuestionsSubmitEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_SignStartEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellEaCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellEaCategory_CompleteEventInput = {
  eaType?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_EaType>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_SellEaCategory_EaType {
  EXTERIOR_ASSESSMENT = 'EXTERIOR_ASSESSMENT',
  EXTERIOR_VIRTUAL_ASSESSMENT = 'EXTERIOR_VIRTUAL_ASSESSMENT',
  /** exterior + interior of home */
  HOME_ASSESSMENT = 'HOME_ASSESSMENT',
  UNKNOWN_EA_TYPE = 'UNKNOWN_EA_TYPE'
}

export type OdProtosJourneyDataCategories_SellEaCategory_EventOneofInput = {
  complete?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_CompleteEventInput>;
  schedule?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_ScheduleEventInput>;
};

export type OdProtosJourneyDataCategories_SellEaCategory_ScheduleEventInput = {
  eaType?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_EaType>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneofInput = {
  canceled?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallCanceledEventInput>;
  proposed?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallProposedEventInput>;
  rescheduled?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallRescheduledEventInput>;
  scheduleReminder?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEventInput>;
  scheduled?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallScheduledEventInput>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallCanceledEventInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallProposedEventInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallRescheduledEventInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEventInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallScheduledEventInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellListCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellListCategory_AgreementSignCompleteEventInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellListCategory_EventOneofInput = {
  /**
   * Field 3 (intent_update) was removed - IntentUpdateEvent is no longer published
   *
   * sell_list_agreement_sign_complete_event
   */
  agreementSignComplete?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_AgreementSignCompleteEventInput>;
  /** sell_list_offer_view_event */
  offerView?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_OfferViewEventInput>;
  /** sell_list_qualification_event */
  qualification?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_QualificationEventInput>;
};

/** Triggered when an LwC-enrolled lead views the offer dashboard */
export type OdProtosJourneyDataCategories_SellListCategory_OfferViewEventInput = {
  isFirstOffer?: InputMaybe<Scalars['Boolean']['input']>;
  listingRangeMax?: InputMaybe<OdProtosCommon_MoneyInput>;
  listingRangeMin?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  recommendedProduct?: InputMaybe<Scalars['String']['input']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
  /** This is populated with a UUID, not a numeric ID as the name suggests */
  sellDirectOfferId?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Triggered when a Sell Direct lead's LwC qualification status changes */
export type OdProtosJourneyDataCategories_SellListCategory_QualificationEventInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_QualificationEvent_QualificationDecision>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_SellListCategory_QualificationEvent_QualificationDecision {
  PRODUCT_DENIED = 'PRODUCT_DENIED',
  PRODUCT_QUALIFIED = 'PRODUCT_QUALIFIED',
  PRODUCT_UNDENIED = 'PRODUCT_UNDENIED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosJourneyDataCategories_SellOrvaCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellOrvaCategory_CancelEventInput = {
  cancellationReason?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_OrvaCancellationReason>;
  cancellationSource?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellOrvaCategory_EventOneofInput = {
  cancel?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_CancelEventInput>;
  reschedule?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_RescheduleEventInput>;
  schedule?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_ScheduleEventInput>;
};

export enum OdProtosJourneyDataCategories_SellOrvaCategory_OrvaCancellationReason {
  CANCELLATION_REASON_UNKNOWN = 'CANCELLATION_REASON_UNKNOWN',
  CEP_CANNOT_MAKE_IT = 'CEP_CANNOT_MAKE_IT',
  CUSTOMER_CANNOT_MAKE_IT = 'CUSTOMER_CANNOT_MAKE_IT'
}

export type OdProtosJourneyDataCategories_SellOrvaCategory_RescheduleEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellOrvaCategory_ScheduleEventInput = {
  agentScheduled?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneofInput = {
  canceled?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewCanceledEventInput>;
  completed?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewCompletedEventInput>;
  rescheduled?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewRescheduledEventInput>;
  scheduled?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewScheduledEventInput>;
};

export enum OdProtosJourneyDataCategories_SellOfferReviewCategory_OrOutcome {
  AGENT_CUSTOMER_HANDED_OFF_TO_AEP = 'AGENT_CUSTOMER_HANDED_OFF_TO_AEP',
  CALL_NOT_COMPLETE_RESCHEDULE_OR = 'CALL_NOT_COMPLETE_RESCHEDULE_OR',
  CALL_NOT_COMPLETE_SENT_SSVA = 'CALL_NOT_COMPLETE_SENT_SSVA',
  CAN_COMPLETE_OR = 'CAN_COMPLETE_OR',
  DID_NOT_CONVERT = 'DID_NOT_CONVERT',
  NO_SHOW = 'NO_SHOW',
  OPENDOOR_CANNOT_PURCHASE_OOBB = 'OPENDOOR_CANNOT_PURCHASE_OOBB',
  UNKNOWN_OR_OUTCOME = 'UNKNOWN_OR_OUTCOME'
}

export enum OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType {
  OR = 'OR',
  ORVA = 'ORVA',
  UNKNOWN_OR_TYPE = 'UNKNOWN_OR_TYPE'
}

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewCanceledEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  orType?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewCompletedEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  orType?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType>;
  origin?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_Origin>;
  outcome?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrOutcome>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewRescheduledEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  orType?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewScheduledEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  orType?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_SellOfferReviewCategory_Origin {
  CUSTOMER_OUTREACH = 'CUSTOMER_OUTREACH',
  CUSTOMER_SCHEDULED = 'CUSTOMER_SCHEDULED',
  PROACTIVE_OUTREACH = 'PROACTIVE_OUTREACH',
  UNKNOWN_ORIGIN = 'UNKNOWN_ORIGIN'
}

export type OdProtosJourneyDataCategories_SellOnboardingCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellOnboardingCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellOnboardingCategory_EventOneofInput = {
  /** sell_onboarding_questions_submit_event */
  questionsSubmit?: InputMaybe<OdProtosJourneyDataCategories_SellOnboardingCategory_QuestionsSubmitEventInput>;
};

export type OdProtosJourneyDataCategories_SellOnboardingCategory_QuestionsSubmitEventInput = {
  answers?: InputMaybe<OdProtosSellReceptionData_AnswersInput>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellVaCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_CompleteEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  vaType?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_VaType>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_EventOneofInput = {
  complete?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_CompleteEventInput>;
  flowStart?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_FlowStartEventInput>;
  occupancy?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_OccupancyEventInput>;
  start?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_StartEventInput>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_FlowStartEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  /** This is populated with a UUID, not a numeric ID as the name suggests */
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_OccupancyEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  occupancy?: InputMaybe<OdProtosWebData_OccupancyAtVa>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_StartEventInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  /** This is populated with a UUID, not a numeric ID as the name suggests */
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  vaType?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_VaType>;
};

export enum OdProtosJourneyDataCategories_SellVaCategory_VaType {
  ORVA = 'ORVA',
  SSVA = 'SSVA',
  UNKNOWN_VA_TYPE = 'UNKNOWN_VA_TYPE'
}

export type OdProtosJourneyDataCategories_SellWithUpsideCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_EstimatedSalesPriceChangeEventInput = {
  changeCents?: InputMaybe<Scalars['Float']['input']>;
  newEstimatedSalesPriceCents?: InputMaybe<Scalars['Float']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  oldEstimatedSalesPriceCents?: InputMaybe<Scalars['Float']['input']>;
  opendoorEstimatedSalesPriceCents?: InputMaybe<Scalars['Float']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneofInput = {
  estimatedSalesPriceChange?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_EstimatedSalesPriceChangeEventInput>;
  pricingOptionsLoaded?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_PricingOptionsLoadedEventInput>;
  /** sell_with_upside_qualification_event */
  qualification?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_QualificationEventInput>;
  upfrontCashChange?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_UpfrontCashChangeEventInput>;
};

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_PricingOptionsLoadedEventInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  pricingUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  recommendedPricingUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_QualificationEventInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_QualificationEvent_QualificationDecision>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataCategories_SellWithUpsideCategory_QualificationEvent_QualificationDecision {
  PRODUCT_DENIED = 'PRODUCT_DENIED',
  PRODUCT_QUALIFIED = 'PRODUCT_QUALIFIED',
  PRODUCT_UNDENIED = 'PRODUCT_UNDENIED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_UpfrontCashChangeEventInput = {
  changeCents?: InputMaybe<Scalars['Float']['input']>;
  newUpfrontCashCents?: InputMaybe<Scalars['Float']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  oldUpfrontCashCents?: InputMaybe<Scalars['Float']['input']>;
  pricingUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyDataOptions_CdpOptions_FieldPlacement {
  /** Extra context is used to provide additional metadata. Should only be used in Sources. */
  EXTRA_CONTEXT = 'EXTRA_CONTEXT',
  /** PROP is the default and it is used for properties describing the event. */
  PROP = 'PROP',
  /** Standardized fields have their name and placement hard-coded and do not rely on reflection. */
  STANDARDIZED = 'STANDARDIZED',
  /** Trait's describe the customer and are relevant beyond a single event (e.g. name, email). */
  TRAIT = 'TRAIT'
}

export enum OdProtosJourneyDataOptions_CdpOptions_MessageOptions_Format {
  /** JSON_OBJECT nests the message's content using the JSON field names. Maps cannot be used within nested objects. */
  JSON_OBJECT = 'JSON_OBJECT',
  NOT_SPECIFIED = 'NOT_SPECIFIED'
}

/**
 * Context for Ad Clicks
 * Next ID: 4
 */
export type OdProtosJourneyData_AdClickContextInput = {
  /** facbook ad click */
  fbclid?: InputMaybe<Scalars['String']['input']>;
  /** google ad click */
  gclid?: InputMaybe<Scalars['String']['input']>;
  /** tiktok ad click */
  ttclid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Context for Ad analytics
 * Next ID: 8
 */
export type OdProtosJourneyData_AnalyticsContextInput = {
  /** Facebook _fbp cookie */
  fbBrowserId?: InputMaybe<Scalars['String']['input']>;
  /** Facebook _fbc cookie */
  fbClickId?: InputMaybe<Scalars['String']['input']>;
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  /** Google Analytics session ID */
  gaSessionId?: InputMaybe<Scalars['String']['input']>;
  /** Nextdoor ndclid cookie */
  nextdoorClickId?: InputMaybe<Scalars['String']['input']>;
  /** Reddit _rdt_uuid cookie */
  redditBrowserId?: InputMaybe<Scalars['String']['input']>;
  /** TikTok _ttp cookie */
  tiktokBrowserId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosJourneyData_BackendSourceInput = {
  clientIp?: InputMaybe<Scalars['String']['input']>;
  /**
   * client's user_agent and IP if the event originates from FE and routed by a BE service
   * should be nil if the event originates from BE
   */
  clientUserAgent?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosJourneyData_BackfillSourceInput = {
  eventOrigin?: InputMaybe<OdProtosJourneyData_BackfillSource_EventOrigin>;
};

export enum OdProtosJourneyData_BackfillSource_EventOrigin {
  SNOWFLAKE = 'SNOWFLAKE',
  UNSPECIFIED = 'UNSPECIFIED'
}

/**
 * Context for tracking parameter fields
 * Next ID: 13
 */
export type OdProtosJourneyData_CampaignContextInput = {
  utmAdgid?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmCat?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmCta?: InputMaybe<Scalars['String']['input']>;
  utmExternalid?: InputMaybe<Scalars['String']['input']>;
  utmGeo?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmNtwk?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmSubsite?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Context for customer related fields
 * Next ID: 6
 */
export type OdProtosJourneyData_CustomerContextInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 15 */
export type OdProtosJourneyData_EdgeSourceInput = {
  /** where the event is coming from (mostly useful for debugging page view events) */
  eventOrigin?: InputMaybe<OdProtosJourneyData_EdgeSource_EventOrigin>;
  /** request.url.host */
  host?: InputMaybe<Scalars['String']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Array<Scalars['String']['input']>>;
  market?: InputMaybe<Scalars['String']['input']>;
  /** request.url.pathname */
  pathname?: InputMaybe<Scalars['String']['input']>;
  /** the url.pathname passed to the underlying internal service */
  proxyPath?: InputMaybe<Scalars['String']['input']>;
  /** the url.searchParams passed to the underlying internal service */
  proxyQueryMap?: InputMaybe<Array<OdProtosJourneyData_EdgeSource_ProxyQueryMapEntryInput>>;
  /** request.url.search ({ 'x': '5', 'y': '3', 'z': 'a,b' }) */
  queryMap?: InputMaybe<Array<OdProtosJourneyData_EdgeSource_QueryMapEntryInput>>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  secPurpose?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyData_EdgeSource_EventOrigin {
  SERVER = 'SERVER'
}

/** `OdProtosJourneyData_EdgeSource_ProxyQueryMapEntryInput` represents the `proxy_query_map` map in `od_protos.journey.data.EdgeSource`. */
export type OdProtosJourneyData_EdgeSource_ProxyQueryMapEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosJourneyData_EdgeSource_QueryMapEntryInput` represents the `query_map` map in `od_protos.journey.data.EdgeSource`. */
export type OdProtosJourneyData_EdgeSource_QueryMapEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 39 */
export type OdProtosJourneyData_EventWrapperInput = {
  analyticsContext?: InputMaybe<OdProtosJourneyData_AnalyticsContextInput>;
  /** Must have at least one of these identifiers set */
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  campaignContext?: InputMaybe<OdProtosJourneyData_CampaignContextInput>;
  /** product or capability */
  category?: InputMaybe<OdProtosJourneyData_EventWrapper_CategoryOneofInput>;
  /**
   * Optional client-generated event id for tracking cases
   * that need shared client and server event IDs.
   */
  clientEventId?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosJourneyData_EventWrapper_SourceOneofInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosJourneyData_EventWrapper_CategoryOneofInput = {
  agentConnect?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategoryInput>;
  alo?: InputMaybe<OdProtosJourneyDataCategories_AloCategoryInput>;
  assessment?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategoryInput>;
  authentication?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategoryInput>;
  chat?: InputMaybe<OdProtosJourneyDataCategories_ChatCategoryInput>;
  communication?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategoryInput>;
  experimentation?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategoryInput>;
  homeGuide?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategoryInput>;
  language?: InputMaybe<OdProtosJourneyDataCategories_LanguageCategoryInput>;
  marketplaceProperty?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategoryInput>;
  mortgage?: InputMaybe<OdProtosJourneyDataCategories_MortgageCategoryInput>;
  platform?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategoryInput>;
  retailWebUnlock?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategoryInput>;
  sell?: InputMaybe<OdProtosJourneyDataCategories_SellCategoryInput>;
  sellDirect?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategoryInput>;
  sellEa?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategoryInput>;
  sellFinalOfferCall?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategoryInput>;
  sellList?: InputMaybe<OdProtosJourneyDataCategories_SellListCategoryInput>;
  sellOfferReview?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategoryInput>;
  sellOnboarding?: InputMaybe<OdProtosJourneyDataCategories_SellOnboardingCategoryInput>;
  sellOrva?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategoryInput>;
  sellVa?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategoryInput>;
  sellWithUpside?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategoryInput>;
};

export type OdProtosJourneyData_EventWrapper_SourceOneofInput = {
  backendSource?: InputMaybe<OdProtosJourneyData_BackendSourceInput>;
  backfillSource?: InputMaybe<OdProtosJourneyData_BackfillSourceInput>;
  edgeSource?: InputMaybe<OdProtosJourneyData_EdgeSourceInput>;
  mobileSource?: InputMaybe<OdProtosJourneyData_MobileSourceInput>;
  websiteSource?: InputMaybe<OdProtosJourneyData_WebsiteSourceInput>;
};

/**
 * Context for Exclusive Offers
 * Next ID: 8
 */
export type OdProtosJourneyData_ExclusiveOffersContextInput = {
  allPhotoCount?: InputMaybe<Scalars['Int']['input']>;
  internalPhotoCount?: InputMaybe<Scalars['Int']['input']>;
  mlsPhotoCount?: InputMaybe<Scalars['Int']['input']>;
  offerBlurPricing?: InputMaybe<Scalars['Boolean']['input']>;
  offerRangeMax?: InputMaybe<Scalars['Float']['input']>;
  offerRangeMin?: InputMaybe<Scalars['Float']['input']>;
  potentialBuyerCount?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosJourneyData_FailedEventsQueryParamsInput = {
  eventNameParams?: InputMaybe<OdProtosJourneyData_FailedEventsQueryParams_EventNameQueryParamsInput>;
  idParams?: InputMaybe<OdProtosJourneyData_FailedEventsQueryParams_IdQueryParamsInput>;
  timestampParams?: InputMaybe<OdProtosJourneyData_FailedEventsQueryParams_TimestampQueryParamsInput>;
};

export type OdProtosJourneyData_FailedEventsQueryParams_EventNameQueryParamsInput = {
  eventName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyData_FailedEventsQueryParams_IdQueryParamsInput = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosJourneyData_FailedEventsQueryParams_TimestampQueryParamsInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosJourneyData_InternalEventWrapper_Destination {
  ALL = 'ALL',
  AMPLITUDE = 'AMPLITUDE',
  SEGMENT_IDENTIFY = 'SEGMENT_IDENTIFY',
  SEGMENT_TRACK = 'SEGMENT_TRACK',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Context for lead fields
 * Next ID: 4
 */
export type OdProtosJourneyData_LeadContextInput = {
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadMarket?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 22 */
export type OdProtosJourneyData_MobileSourceInput = {
  adTrackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  advertisingId?: InputMaybe<Scalars['String']['input']>;
  appBuild?: InputMaybe<Scalars['String']['input']>;
  /** App info */
  appName?: InputMaybe<Scalars['String']['input']>;
  appNamespace?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** Network info */
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** Device info */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceManufacturer?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  /** where the event is coming from (mostly useful for debugging page view events) */
  eventOrigin?: InputMaybe<OdProtosJourneyData_MobileSource_EventOrigin>;
  /** Route info */
  focusRouteName?: InputMaybe<Scalars['String']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  notificationPermissionStatus?: InputMaybe<Scalars['String']['input']>;
  /** OS info */
  osName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * Screen info
   * using context.screen.XXX to keep consistency with WebsiteSource's convention
   */
  screenDensity?: InputMaybe<Scalars['Int']['input']>;
  /** In pixels */
  screenHeight?: InputMaybe<Scalars['Int']['input']>;
  /** In pixels */
  screenWidth?: InputMaybe<Scalars['Int']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyData_MobileSource_EventOrigin {
  APP = 'APP'
}

/**
 * Context for Sell Direct
 * Next ID: 7
 */
export type OdProtosJourneyData_SellDirectContextInput = {
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  offerDenialReason?: InputMaybe<Scalars['String']['input']>;
  offerHeadlinePrice?: InputMaybe<Scalars['Float']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerRequestSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
  offerState?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosJourneyData_SellDirectConversionEventInput = {
  conversionEvent?: InputMaybe<OdProtosWebDataSellDirect_SellDirectEventType>;
};

/** Next ID: 49 */
export type OdProtosJourneyData_UserEventInput = {
  adClickContext?: InputMaybe<OdProtosJourneyData_AdClickContextInput>;
  analyticsContext?: InputMaybe<OdProtosJourneyData_AnalyticsContextInput>;
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  campaignContext?: InputMaybe<OdProtosJourneyData_CampaignContextInput>;
  customerContext?: InputMaybe<OdProtosJourneyData_CustomerContextInput>;
  /**
   * Next ID: same as Next ID of parent message
   * NOTE: Please keep events ordered by index in each group
   */
  event?: InputMaybe<OdProtosJourneyData_UserEvent_EventOneofInput>;
  exclusiveOffersContext?: InputMaybe<OdProtosJourneyData_ExclusiveOffersContextInput>;
  humanId?: InputMaybe<Scalars['String']['input']>;
  leadContext?: InputMaybe<OdProtosJourneyData_LeadContextInput>;
  sellDirectContext?: InputMaybe<OdProtosJourneyData_SellDirectContextInput>;
  /** Next ID: same as Next ID of parent message */
  source?: InputMaybe<OdProtosJourneyData_UserEvent_SourceOneofInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyData_UserEvent_EventOneofInput = {
  /** conversion events */
  sellDirectConversionEvent?: InputMaybe<OdProtosJourneyData_SellDirectConversionEventInput>;
};

export type OdProtosJourneyData_UserEvent_SourceOneofInput = {
  backendSource?: InputMaybe<OdProtosJourneyData_BackendSourceInput>;
  mobileSource?: InputMaybe<OdProtosJourneyData_MobileSourceInput>;
  websiteSource?: InputMaybe<OdProtosJourneyData_WebsiteSourceInput>;
};

/** Next ID: 14 */
export type OdProtosJourneyData_WebsiteSourceInput = {
  /** where the event is coming from (mostly useful for debugging page view events) */
  eventOrigin?: InputMaybe<OdProtosJourneyData_WebsiteSource_EventOrigin>;
  /** request.url.host */
  host?: InputMaybe<Scalars['String']['input']>;
  /** ip is overwritten on HTTP requests with a website source. */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** this will be overwritten on HTTP requests */
  isWebview?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<Scalars['String']['input']>>;
  /** request.url.pathname */
  pathname?: InputMaybe<Scalars['String']['input']>;
  /** the url.pathname passed to the underlying internal service */
  proxyPath?: InputMaybe<Scalars['String']['input']>;
  /** the url.searchParams passed to the underlying internal service */
  proxyQueryMap?: InputMaybe<Array<OdProtosJourneyData_WebsiteSource_ProxyQueryMapEntryInput>>;
  /** request.url.search ({ 'x': '5', 'y': '3', 'z': 'a,b' }) */
  queryMap?: InputMaybe<Array<OdProtosJourneyData_WebsiteSource_QueryMapEntryInput>>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  screen?: InputMaybe<OdProtosJourneyData_WebsiteSource_ScreenInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosJourneyData_WebsiteSource_EventOrigin {
  CLIENT = 'CLIENT',
  SERVER = 'SERVER',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** `OdProtosJourneyData_WebsiteSource_ProxyQueryMapEntryInput` represents the `proxy_query_map` map in `od_protos.journey.data.WebsiteSource`. */
export type OdProtosJourneyData_WebsiteSource_ProxyQueryMapEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosJourneyData_WebsiteSource_QueryMapEntryInput` represents the `query_map` map in `od_protos.journey.data.WebsiteSource`. */
export type OdProtosJourneyData_WebsiteSource_QueryMapEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyData_WebsiteSource_ScreenInput = {
  density?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosJourneyServices_ApproveStagedEventsRequestInput = {
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosJourneyServices_ModifyFailedEventsRequestInput = {
  modifier?: InputMaybe<Scalars['String']['input']>;
  queryParams?: InputMaybe<OdProtosJourneyData_FailedEventsQueryParamsInput>;
};

export type OdProtosJourneyServices_SendEventRequestInput = {
  event?: InputMaybe<OdProtosJourneyData_EventWrapperInput>;
};

export type OdProtosJourneyServices_SendUserEventRequestInput = {
  userEvent?: InputMaybe<OdProtosJourneyData_UserEventInput>;
};

export enum OdProtosJourneyTesting_EnumTest {
  ENUMTEST_NONE = 'ENUMTEST_NONE',
  ENUMTEST_ONE = 'ENUMTEST_ONE',
  ENUMTEST_TWO = 'ENUMTEST_TWO'
}

/** The different types of inputs a MarketDataEntry Question can support */
export enum OdProtosListerineData_InputType {
  DROPDOWN = 'DROPDOWN',
  INPUT_TYPE_UNKNOWN = 'INPUT_TYPE_UNKNOWN',
  MULTI_LINE_TEXT = 'MULTI_LINE_TEXT',
  MULTI_SELECT = 'MULTI_SELECT',
  RADIO_GROUP = 'RADIO_GROUP',
  SINGLE_LINE_TEXT = 'SINGLE_LINE_TEXT'
}

/** Listing data entry states */
export enum OdProtosListerineData_ListingDataEntryState {
  LISTING_DATA_ENTRY_COMPLETE = 'LISTING_DATA_ENTRY_COMPLETE',
  LISTING_DATA_ENTRY_ESCALATED = 'LISTING_DATA_ENTRY_ESCALATED',
  LISTING_DATA_ENTRY_INCOMPLETE = 'LISTING_DATA_ENTRY_INCOMPLETE'
}

/** listing fields state */
export enum OdProtosListerineData_ListingFieldsState {
  LISTING_FIELDS_COMPLETED = 'LISTING_FIELDS_COMPLETED',
  LISTING_FIELDS_PENDING = 'LISTING_FIELDS_PENDING',
  LISTING_FIELDS_UNKNOWN = 'LISTING_FIELDS_UNKNOWN'
}

export enum OdProtosListerineData_ListingPhotosRoute {
  PHOTO_BRACKETING = 'PHOTO_BRACKETING',
  PHOTO_VENDOR = 'PHOTO_VENDOR'
}

/** listing photos state */
export enum OdProtosListerineData_ListingPhotosState {
  LISTING_PHOTOS_COMPLETED = 'LISTING_PHOTOS_COMPLETED',
  LISTING_PHOTOS_DELAYED = 'LISTING_PHOTOS_DELAYED',
  LISTING_PHOTOS_PENDING = 'LISTING_PHOTOS_PENDING',
  LISTING_PHOTOS_SCHEDULED = 'LISTING_PHOTOS_SCHEDULED',
  LISTING_PHOTOS_UNKNOWN = 'LISTING_PHOTOS_UNKNOWN'
}

/** listing price state */
export enum OdProtosListerineData_ListingPriceState {
  LISTING_PRICE_DELAYED = 'LISTING_PRICE_DELAYED',
  LISTING_PRICE_PENDING = 'LISTING_PRICE_PENDING',
  LISTING_PRICE_RECEIVED = 'LISTING_PRICE_RECEIVED',
  LISTING_PRICE_UNKNOWN = 'LISTING_PRICE_UNKNOWN'
}

export enum OdProtosListerineData_ListingTaskStatus {
  TASK_CREATED = 'TASK_CREATED',
  TASK_SCHEDULED = 'TASK_SCHEDULED',
  TASK_SENT = 'TASK_SENT',
  TASK_UNKNOWN = 'TASK_UNKNOWN'
}

/** Market data entry states */
export enum OdProtosListerineData_MarketDataEntryState {
  MARKET_DATA_ENTRY_COMPLETE = 'MARKET_DATA_ENTRY_COMPLETE',
  MARKET_DATA_ENTRY_ESCALATED = 'MARKET_DATA_ENTRY_ESCALATED',
  MARKET_DATA_ENTRY_INCOMPLETE = 'MARKET_DATA_ENTRY_INCOMPLETE'
}

/** photo approval states */
export enum OdProtosListerineData_PhotoReviewState {
  PHOTO_REVIEW_ACCEPTED = 'PHOTO_REVIEW_ACCEPTED',
  PHOTO_REVIEW_DELAYED = 'PHOTO_REVIEW_DELAYED',
  PHOTO_REVIEW_INCOMPLETE = 'PHOTO_REVIEW_INCOMPLETE',
  PHOTO_REVIEW_REJECTED = 'PHOTO_REVIEW_REJECTED'
}

/** renovation state */
export enum OdProtosListerineData_RenoState {
  RENO_STATE_COMPLETED = 'RENO_STATE_COMPLETED',
  RENO_STATE_PENDING = 'RENO_STATE_PENDING',
  RENO_STATE_UNKNOWN = 'RENO_STATE_UNKNOWN'
}

/** setup visit State */
export enum OdProtosListerineData_SetupVisitState {
  SETUP_VISIT_COMPLETED = 'SETUP_VISIT_COMPLETED',
  SETUP_VISIT_PENDING = 'SETUP_VISIT_PENDING',
  SETUP_VISIT_SCHEDULED = 'SETUP_VISIT_SCHEDULED',
  SETUP_VISIT_UNKNOWN = 'SETUP_VISIT_UNKNOWN'
}

export type OdProtosListerineServices_AddOpenHouseInfoForActiveListingsRequestInput = {
  listingUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  market?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListerineServices_ChangeAddressRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  newAddressId?: InputMaybe<Scalars['String']['input']>;
  oldAddressId?: InputMaybe<Scalars['String']['input']>;
};

/** request to create listing task */
export type OdProtosListerineServices_CreateListingTaskRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  externalListing?: InputMaybe<Scalars['Boolean']['input']>;
  flipId?: InputMaybe<Scalars['String']['input']>;
  flipState?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  listingDataEntryMarketSuffix?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<OdProtosScroogeData_Allocation_Source_SourceType>;
};

/** empty request for get all listing tasks */
export type OdProtosListerineServices_GetActiveListingTasksRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosListerineServices_GetActiveListingTasksV2RequestInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosListerineServices_GetDynamicDataEntryConfigForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
};

/** request to query listing task by web's listing_uuid or listerine's specific guid */
export type OdProtosListerineServices_GetListingTaskRequestInput = {
  /** This is listerine's ID for the listing task */
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

/** request to query multiple listing tasks by id */
export type OdProtosListerineServices_GetListingTasksRequestInput = {
  listingTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosListerineServices_GetMarketDataEntryConfigByListingTaskIdRequestInput = {
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListerineServices_GetMarketDataEntryConfigRequestInput = {
  market?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListerineServices_GetPhotoReviewRejectReasonsRequestInput = {
  /** This metadata is optional. */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListerineServices_IsRelistPossibleRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListerineServices_ManuallyResolveListingTaskRequestInput = {
  listDate?: InputMaybe<Scalars['String']['input']>;
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  mlsId?: InputMaybe<Scalars['String']['input']>;
  mlsName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListerineServices_MarkExceptionCaseyTaskCompleteRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']['input']>;
  delayReason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListerineServices_RelistOnMlsRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosListerineServices_SubmitPhotoOrderingFeedbackRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackText?: InputMaybe<Scalars['String']['input']>;
  finalOrder?: InputMaybe<Scalars['String']['input']>;
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<Scalars['String']['input']>;
  removedPhotoIds?: InputMaybe<Scalars['String']['input']>;
};

/** next id : 5 */
export type OdProtosListerineServices_ToggleFrozenRequestInput = {
  freezeReason?: InputMaybe<Scalars['String']['input']>;
  isFrozen?: InputMaybe<Scalars['Boolean']['input']>;
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListerineServices_TriggerDataEntryTasksRequestInput = {
  /** address_ids skips any checks. */
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visits?: InputMaybe<Array<OdProtosListerineServices_VisitInput>>;
};

export type OdProtosListerineServices_TriggerMlsPublishRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

/** request to update the external listing flag for the listing task under listing_uuid */
export type OdProtosListerineServices_UpdateExternalListingFlagRequestInput = {
  isExternalListing?: InputMaybe<Scalars['Boolean']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

/** request to update flip state */
export type OdProtosListerineServices_UpdateFlipStateRequestInput = {
  flipState?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

/** request to update listing photos state */
export type OdProtosListerineServices_UpdateListingPhotosStateRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosListerineData_ListingPhotosState>;
};

/** request to update listing price and listing price state */
export type OdProtosListerineServices_UpdateListingPriceStateRequestInput = {
  listingPrice?: InputMaybe<Scalars['Float']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosListerineData_ListingPriceState>;
};

export type OdProtosListerineServices_UpdateMarketDataEntryRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']['input']>;
  escalationReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * The answers to a MarketDataEntry form. Listerine expects a json blob with a mapping of
   * Question.field_name -> answer.
   */
  formData?: InputMaybe<Scalars['String']['input']>;
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosListerineData_MarketDataEntryState>;
  updatedState?: InputMaybe<OdProtosListerineData_ListingDataEntryState>;
};

/** TODO deprecate */
export type OdProtosListerineServices_UpdateMarketDataEntryStateRequestInput = {
  /**
   * The answers to a MarketDataEntry form. Listerine expects a json blob with a mapping of
   * Question.field_name -> answer.
   */
  formData?: InputMaybe<Scalars['String']['input']>;
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosListerineData_MarketDataEntryState>;
};

/**
 * Update the state of photo review for a particular listing task. from_web should only be set to true if the
 * approval came from web.
 */
export type OdProtosListerineServices_UpdatePhotoReviewStateRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']['input']>;
  fromWeb?: InputMaybe<Scalars['Boolean']['input']>;
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  /** This is the long form text reason for rejection */
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  /** This is one of the enumerated rejection types returned from GetPhotoReviewRejectReasons */
  rejectReasonBucket?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosListerineData_PhotoReviewState>;
};

/** request to update setup visit state */
export type OdProtosListerineServices_UpdateSetupVisitStateRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosListerineData_SetupVisitState>;
};

/** Visit and Address needed for DE task creation */
export type OdProtosListerineServices_VisitInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosListingsData_Actor {
  AGENT = 'AGENT',
  CEP = 'CEP',
  SYSTEM = 'SYSTEM',
  UNKNOWN_ACTOR = 'UNKNOWN_ACTOR'
}

export enum OdProtosListingsData_AloUnenrollmentReason {
  ALO_UNENROLLMENT_REASON_AUTOMATIC_DROPOUT = 'ALO_UNENROLLMENT_REASON_AUTOMATIC_DROPOUT',
  ALO_UNENROLLMENT_REASON_MANUAL = 'ALO_UNENROLLMENT_REASON_MANUAL',
  ALO_UNENROLLMENT_REASON_UNSPECIFIED = 'ALO_UNENROLLMENT_REASON_UNSPECIFIED'
}

export enum OdProtosListingsData_ExperiencePartnerSupportRequestType {
  SUPPORT_REQUEST_TYPE_FINAL_OFFER_DISCUSSIOON_WITH_SELLER = 'SUPPORT_REQUEST_TYPE_FINAL_OFFER_DISCUSSIOON_WITH_SELLER',
  SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION = 'SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION',
  SUPPORT_REQUEST_TYPE_REPAIR_ASKS = 'SUPPORT_REQUEST_TYPE_REPAIR_ASKS',
  SUPPORT_REQUEST_TYPE_SELLER_AGENT_INTRODUCTION = 'SUPPORT_REQUEST_TYPE_SELLER_AGENT_INTRODUCTION',
  SUPPORT_REQUEST_TYPE_SELLER_CONTACT = 'SUPPORT_REQUEST_TYPE_SELLER_CONTACT',
  UNKNOWN_SUPPORT_REQUEST_TYPE = 'UNKNOWN_SUPPORT_REQUEST_TYPE'
}

export type OdProtosListingsData_KeyTimestampPairInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosListingsData_ListingInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  agent?: InputMaybe<OdProtosListingsData_Listing_AgentInput>;
  agentCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  brokerageId?: InputMaybe<Scalars['String']['input']>;
  contractPrice?: InputMaybe<Scalars['Float']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  estimatedListPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  estimatedSalePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  grossCommission?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  listingPrice?: InputMaybe<Scalars['Float']['input']>;
  marketId?: InputMaybe<Scalars['String']['input']>;
  soldPrice?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<OdProtosListingsData_Listing_SourceInput>;
  state?: InputMaybe<OdProtosListingsData_Listing_State>;
  timestamps?: InputMaybe<Array<OdProtosListingsData_Listing_TimestampInput>>;
};

export type OdProtosListingsData_Listing_AgentInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsData_Listing_SourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosListingsData_Listing_Source_Type>;
};

export enum OdProtosListingsData_Listing_Source_Type {
  LIST_WITH_CERTAINTY = 'LIST_WITH_CERTAINTY',
  PARN = 'PARN',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosListingsData_Listing_State {
  /** @deprecated No longer supported */
  AGENT_ASSIGNMENT = 'AGENT_ASSIGNMENT',
  CANCELED = 'CANCELED',
  IN_CONTRACT = 'IN_CONTRACT',
  /** @deprecated No longer supported */
  LEAD_TERMINATED = 'LEAD_TERMINATED',
  LISTING_ACTIVE = 'LISTING_ACTIVE',
  LISTING_AGREEMENT_SIGNED = 'LISTING_AGREEMENT_SIGNED',
  /** @deprecated No longer supported */
  LISTING_TERMINATED = 'LISTING_TERMINATED',
  /** @deprecated No longer supported */
  NOT_LISTED = 'NOT_LISTED',
  /** @deprecated No longer supported */
  OWNER_LIST_DECISION = 'OWNER_LIST_DECISION',
  SOLD = 'SOLD',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosListingsData_Listing_TimestampInput = {
  state?: InputMaybe<OdProtosListingsData_Listing_State>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The LwcProductFilter is used to filter LwcProduct list results */
export type OdProtosListingsData_LwcProductFilterInput = {
  /**
   * Only LwcProducts which have a state found in the states list will
   * be returned. If no states filter is provided, all LwcProducts found
   * in an "active" states (i.e. not CREATED or DELETED) will be returned.
   */
  states?: InputMaybe<Array<OdProtosListingsData_LwcProduct_State>>;
};

/** Next ID: 31 */
export enum OdProtosListingsData_LwcProduct_State {
  CLOSED = 'CLOSED',
  CREATED = 'CREATED',
  LISTING_AGREEMENT_SIGNED = 'LISTING_AGREEMENT_SIGNED',
  /** Terminal */
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosListingsData_NoteType {
  AGENT_NOTE = 'AGENT_NOTE',
  CEP_NOTE = 'CEP_NOTE',
  LEAD_PASS_BACK_NOTE = 'LEAD_PASS_BACK_NOTE',
  UNKNOWN_NOTE = 'UNKNOWN_NOTE'
}

/** Next ID: 4 */
export enum OdProtosListingsData_ParnDidNotCloseReason {
  NO_ACCEPTABLE_OFFERS = 'NO_ACCEPTABLE_OFFERS',
  OTHER = 'OTHER',
  PLANS_CHANGED = 'PLANS_CHANGED',
  UNKNOWN_REASON_DID_NOT_CLOSE = 'UNKNOWN_REASON_DID_NOT_CLOSE'
}

/** Next ID: 5 */
export enum OdProtosListingsData_ParnDidNotConvertReason {
  NOT_INTERESTED = 'NOT_INTERESTED',
  PARN_COMPETITOR = 'PARN_COMPETITOR',
  PARN_NON_RESPONSIVE = 'PARN_NON_RESPONSIVE',
  PARN_NOT_BUYING_OR_SELLING = 'PARN_NOT_BUYING_OR_SELLING',
  UNKNOWN_REASON_DID_NOT_CONVERT = 'UNKNOWN_REASON_DID_NOT_CONVERT'
}

export type OdProtosListingsData_ParnKeyTimestampPairInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 14 */
export enum OdProtosListingsData_Parn_State {
  CREATED = 'CREATED',
  DID_NOT_CLOSE_NO_ACCEPTABLE_OFFERS = 'DID_NOT_CLOSE_NO_ACCEPTABLE_OFFERS',
  DID_NOT_CLOSE_OTHER = 'DID_NOT_CLOSE_OTHER',
  DID_NOT_CLOSE_PLANS_CHANGED = 'DID_NOT_CLOSE_PLANS_CHANGED',
  DID_NOT_CONVERT_COMPETITOR = 'DID_NOT_CONVERT_COMPETITOR',
  DID_NOT_CONVERT_NON_RESPONSIVE = 'DID_NOT_CONVERT_NON_RESPONSIVE',
  DID_NOT_CONVERT_NOT_BUYING_SELLING = 'DID_NOT_CONVERT_NOT_BUYING_SELLING',
  DID_NOT_CONVERT_NOT_INTERESTED = 'DID_NOT_CONVERT_NOT_INTERESTED',
  FIRST_CONTACT_ATTEMPTED = 'FIRST_CONTACT_ATTEMPTED',
  FIRST_CONTACT_MADE = 'FIRST_CONTACT_MADE',
  LISTING_INITIATED = 'LISTING_INITIATED',
  SELECTED_PARN = 'SELECTED_PARN',
  /** Terminal */
  SOLD = 'SOLD',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosListingsData_SelectedProduct {
  SELECTED_PRODUCT_LIST_WITH_CERTAINTY = 'SELECTED_PRODUCT_LIST_WITH_CERTAINTY',
  SELECTED_PRODUCT_OPENDOOR_DIRECT = 'SELECTED_PRODUCT_OPENDOOR_DIRECT',
  SELECTED_PRODUCT_SELL_WITH_UPSIDE = 'SELECTED_PRODUCT_SELL_WITH_UPSIDE',
  SELECTED_PRODUCT_UNKNOWN = 'SELECTED_PRODUCT_UNKNOWN'
}

export type OdProtosListingsServices_CheckEligibilityRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_CreateListingRequestInput = {
  listing?: InputMaybe<OdProtosListingsData_ListingInput>;
};

export type OdProtosListingsServices_CreateLwcProductRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  hasInitialLeadFlowOfferRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isNotPreviouslyDeniedRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  latestSellDirectOfferUuid?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['String']['input']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
  skipEligibilityCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosListingsServices_CreateParnRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_FirstContactAttemptedForParnRequestInput = {
  firstContactAttemptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  parnId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_FirstContactMadeForParnRequestInput = {
  firstContactMadeAt?: InputMaybe<Scalars['DateTime']['input']>;
  parnId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetListingBySourceRequestInput = {
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetListingDetailByAgentLeadIdRequestInput = {
  agentLeadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetListingDetailsByAgentRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
};

/** Endpoints with page-based pagination */
export type OdProtosListingsServices_GetListingDetailsByAgentV2RequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** 0-indexed page number (0 for first page) */
  pageNumber?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  /** Searches across customer name and property address */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sellingStageFilter?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetListingDetailsByBrokerageRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetListingDetailsByBrokerageV2RequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
  agentFilter?: InputMaybe<Scalars['String']['input']>;
  /** 0-indexed page number (0 for first page) */
  pageNumber?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  /** Searches across customer name and property address */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sellingStageFilter?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetListingPricingInformationRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetListingRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetLwcDetailsBySellDirectLeadRequestInput = {
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetLwcDetailsBySellerInputUuidRequestInput = {
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetLwcDetailsBySellerLeadUuidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetLwcDetailsForBrokerageRequestInput = {
  /**
   * I can see us having a brokerage_id, agent_id fields in the future
   * to enable getting LWC Details for a brokerage via different IDs
   */
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetLwcDetailsRequestInput = {
  /** If we start using this for CEPs, add new fields instead of using oneof */
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetLwcProductViewBySellDirectLeadRequestInput = {
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetLwcProductViewBySellerLeadUuidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_GetOpenExperiencePartnerSupportRequestRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosListingsData_ExperiencePartnerSupportRequestType>;
};

export type OdProtosListingsServices_GetParnDetailsRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request/Response objects for GetSellDirectDetails
 * Next ID: 3
 */
export type OdProtosListingsServices_GetSellDirectDetailsRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_InitiateListingLeadBySellerLeadTokenRequestInput = {
  /** Deprecated: ODLO experiment ended Dec 2025. This field is ignored. */
  bypassOdloExperimentCheck?: InputMaybe<Scalars['Boolean']['input']>;
  sellerLeadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_InitiateListingLeadRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_ListLwcDetailsRequestInput = {
  filter?: InputMaybe<OdProtosListingsData_LwcProductFilterInput>;
};

export type OdProtosListingsServices_ListingAgreementSignedRequestInput = {
  listingAgreementSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_MarkNotEligibleRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_ParnDidNotCloseRequestInput = {
  parnId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<OdProtosListingsData_ParnDidNotCloseReason>;
};

export type OdProtosListingsServices_ParnDidNotConvertRequestInput = {
  parnId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<OdProtosListingsData_ParnDidNotConvertReason>;
};

export type OdProtosListingsServices_ReactivateLeadRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_RequestExperiencePartnerSupportRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosListingsData_ExperiencePartnerSupportRequestType>;
};

export type OdProtosListingsServices_SelectedParnRequestInput = {
  listingAgreementSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  parnId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_SetAloQualificationRequestInput = {
  /** Reason for unenrollment (only relevant when is_qualified=false) */
  aloUnenrollmentReason?: InputMaybe<OdProtosListingsData_AloUnenrollmentReason>;
  isQualified?: InputMaybe<Scalars['Boolean']['input']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_SetAgentNoteForParnRequestInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  parnId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_SetDetailsRequestInput = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  agentCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  contractPrice?: InputMaybe<Scalars['Float']['input']>;
  estimatedListPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  estimatedSalePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  grossCommission?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  listingPrice?: InputMaybe<Scalars['Float']['input']>;
  nextState?: InputMaybe<OdProtosListingsData_Listing_State>;
  soldPrice?: InputMaybe<Scalars['Float']['input']>;
  timestampOverrides?: InputMaybe<Array<OdProtosListingsServices_SetDetailsRequest_TimestampOverrideInput>>;
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

export type OdProtosListingsServices_SetDetailsRequest_TimestampOverrideInput = {
  state?: InputMaybe<OdProtosListingsData_Listing_State>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosListingsServices_SetNoteRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosListingsData_NoteType>;
};

export type OdProtosListingsServices_SetParnTimestampsRequestInput = {
  keyTimestampPairs?: InputMaybe<Array<OdProtosListingsData_ParnKeyTimestampPairInput>>;
  parnId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosListingsServices_SetTimestampsRequestInput = {
  keyTimestampPairs?: InputMaybe<Array<OdProtosListingsData_KeyTimestampPairInput>>;
  lwcProductId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A market is a non-overlapping region that Opendoor operates in. Markets are the highest-level
 * division of Opendoor operations.
 *
 * Data in this message is intended to be very high-level and only provide config that *almost all*
 * services need. If your service has a requirement for Market-keyed config, please define a new
 * service/product-specific message and register it as a new type in PBDB.
 *
 * PBDB Key: Fence Region ID
 * Next ID: 6
 */
export type OdProtosMarketConfig_MarketInput = {
  /** Customer facing name (e.g. "Phoenix"). */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Directory ID of the organization that oversees this market. */
  orgId?: InputMaybe<Scalars['String']['input']>;
  /** Fence ID of the region covered by this market. This is also the identifier (e.g. "phoenix"). */
  regionId?: InputMaybe<Scalars['String']['input']>;
  /** Used mainly for naming market-specific things like Slack channels (e.g. "phx"). */
  shorthandIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Timezone of the market (e.g. "America/Los_Angeles") */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsAcquisition_BrnSpendRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Overrides market name for address token */
  marketName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsAcquisition_PostlistRepairSpendRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Overrides market name for address token */
  marketName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsAcquisition_PrelistRepairScopeRequestInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  basementFinishedSqFt?: InputMaybe<Scalars['Int']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrivatePool?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Required] The internal fee charged for this home */
  internalFee?: InputMaybe<Scalars['Float']['input']>;
  /** [Required] Whether the home is is_listed */
  isListed?: InputMaybe<Scalars['Boolean']['input']>;
  lotSqFt?: InputMaybe<Scalars['Int']['input']>;
  propertyConditionScore?: InputMaybe<Scalars['Float']['input']>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosMdfModelsAcquisition_RestbCalibrationScoreRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  bathroomSellerAnswer?: InputMaybe<Scalars['String']['input']>;
  exteriorSellerAnswer?: InputMaybe<Scalars['String']['input']>;
  kitchenSellerAnswer?: InputMaybe<Scalars['String']['input']>;
  livingRoomSellerAnswer?: InputMaybe<Scalars['String']['input']>;
  offerValuationUsd?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosMdfModelsAcquisition_VendigiQuintilesRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  listDate?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsResale_IndifferencePriceTargetModelRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsResale_InitialMarkupFeaturesRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsResale_ResalePricingRecommendationsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** These are the new formats that should be used going forward */
export type OdProtosMdfModelsResale_ResaleProbabilityContractModelRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsResale_ResaleTargetPriceModelRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsSpread_DaysToPendBiasRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Dwelling type, defaults to value from HDS */
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Whether the home has a hoa, defaults to value from HDS */
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home is in a age restricted community, defaults to value from HDS */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home is in a gated community, defaults to value from HDS */
  isGatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Required] Valuation of the home in USD */
  postRepairValuationUsd?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Year build, defaults to value from HDS */
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosMdfModelsSpread_ForecastedSpreadDailyChangeRequestInput = {
  /** [Required] The address token of the home. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Required] The date range end. Format expected is YYYY-MM-DD */
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  /** [Required] The date range start. Format expected is YYYY-MM-DD */
  dateStart?: InputMaybe<Scalars['String']['input']>;
  /** [Required] Valuation of the home in USD */
  valuationUsd?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosMdfModelsSpread_MultivariatePrelistValGainAdjustmentRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Dwelling type, defaults to value from HDS */
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Whether the home is in a guarded, gated community, defaults to value from HDS */
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has a hoa, defaults to value from HDS */
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has a private pool, defaults to value from HDS */
  hasPrivatePool?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home is in a age restricted community, defaults to value from HDS */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home is in a gated community, defaults to value from HDS */
  isGatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Required] Valuation of the home in USD */
  postRepairValuationUsd?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] The [1-6] RestB property condition score, defaults to denormalized value from HDS */
  propertyRestbConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Year build, defaults to value from HDS */
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

/** Protos for the post-list val gain adjustments model */
export type OdProtosMdfModelsSpread_MultivariateValGainAdjustmentRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Dwelling type, defaults to value from HDS */
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Whether the home is in a guarded, gated community, defaults to value from HDS */
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has a hoa, defaults to value from HDS */
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has a private pool, defaults to value from HDS */
  hasPrivatePool?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home is in a age restricted community, defaults to value from HDS */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home is in a gated community, defaults to value from HDS */
  isGatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Required] Valuation of the home in USD */
  postRepairValuationUsd?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] The [1-6] RestB property condition score, defaults to denormalized value from HDS */
  propertyRestbConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Year build, defaults to value from HDS */
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosMdfModelsSpread_NegativeSelectionChargeRequestInput = {
  /** [Required] The address token of the home. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Required] OVM Expected Error */
  expectedError?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosMdfModelsValuation_NationwideValuationsEnsemblerModelRequestInput = {
  /**
   * Home features
   *
   * [Optional] Above ground finished sq ft of the home
   */
  aboveGradeSqFt?: InputMaybe<Scalars['Int']['input']>;
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Basement finished sq ft of the home */
  basementFinishedSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Basement unfinished sq ft of the home */
  basementUnfinishedSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Bathrooms full */
  bathroomsFull?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Bathrooms half */
  bathroomsHalf?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Bedrooms */
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] HDS-formatted dwelling type of the home */
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Size of the home lot */
  lotSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Year home was built */
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosMdfModelsValuation_QuantariumDebiasedValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsValuation_QuantariumEnsemblerModelRequestInput = {
  /** [Optional] Above grade square footage of the home */
  aboveGradeSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Basement finished sq ft of the home */
  basementFinishedSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Basement unfinished sq ft of the home */
  basementUnfinishedSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] RestB formatted (1-6) bathroom condition score */
  bathroomConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Bathrooms full */
  bathroomsFull?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Bathrooms half */
  bathroomsHalf?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Bedrooms */
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Garport spaces */
  carportSpaces?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] HDS-formatted dwelling type of the home */
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] RestB formatted (1-6) exterior condition score */
  exteriorConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Exterior stories */
  exteriorStories?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Garage spaces */
  garageSpaces?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Whether the home has a basement */
  hasBasement?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home's basement has a daylight */
  hasBasementDaylight?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home is part of a gated community */
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home is part of a HOA */
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has a new roof */
  hasNewRoof?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has new windows */
  hasNewWindows?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has a nice backyard */
  hasNiceBackyard?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has a private pool */
  hasPrivatePool?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has solar */
  hasSolar?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Whether the home has upgrades */
  hasUpgrades?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] RestB formatted (1-6) interior condition score */
  interiorConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Whether the home is in an age restricted community */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] Kitchen appliance type */
  kitchenApplianceType?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] RestB formatted (1-6) kitchen condition score */
  kitchenConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Kitchen countertop type */
  kitchenCountertop?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Size of the home lot */
  lotSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Required] OVM Expected Error in decimal formats */
  ovmExpectedError?: InputMaybe<Scalars['Float']['input']>;
  /** [Required] OVM Valuation in USD */
  ovmValuation?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] RestB formatted (1-6) property condition score */
  propertyConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Year home was built */
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosMdfModelsValuation_QuantariumValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsValuation_RealtyTracValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMdfModelsValuation_ValuationsEnsemblerModelRequestInput = {
  /**
   * Home features
   *
   * [Optional] Above ground finished sq ft of the home
   */
  aboveGradeSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Basement finished sq ft of the home */
  basementFinishedSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Basement unfinished sq ft of the home */
  basementUnfinishedSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] RestB formatted (1-6) bathroom condition score */
  bathroomConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Bathrooms full */
  bathroomsFull?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Bathrooms half */
  bathroomsHalf?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Bedrooms */
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Garport spaces */
  carportSpaces?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] HDS-formatted dwelling type of the home */
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] RestB formatted (1-6) exterior condition score */
  exteriorConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Garage spaces */
  garageSpaces?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] RestB formatted (1-6) interior condition score */
  interiorConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Whether the home is in an age restricted community */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Optional] RestB formatted (1-6) kitchen condition score */
  kitchenConditionScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Size of the home lot */
  lotSqFt?: InputMaybe<Scalars['Int']['input']>;
  /** [Required] Ensemble methodology, must be one of ("prelim_offer", "underwriting" or "list_price") */
  methodology?: InputMaybe<Scalars['String']['input']>;
  /**
   * Valuation metadata
   *
   * [Required] OVM Expected Error in decimal formats
   */
  ovmExpectedError?: InputMaybe<Scalars['Float']['input']>;
  /** [Required] OVM Uncertainty percentile (taken directly from signals output) */
  ovmUncertaintyPercentileInDistribution?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Child valuations
   *
   * [Required] OVM Valuation in USD (not cents!)
   */
  ovmValuation?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Valuation from first PA in Ensemble, in USD (not cents!) */
  pa1Valuation?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Valuation from 2nd PA in Ensemble, in USD (not cents!) */
  pa2Valuation?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Valuation from 3rd PA in Ensemble, in USD (not cents!) */
  pa3Valuation?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Valuation from 4th PA in Ensemble, in USD (not cents!) */
  pa4Valuation?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Quantarium confidence score */
  quantariumConfidenceScore?: InputMaybe<Scalars['Float']['input']>;
  /** [Optional] Quantarium Valuation in USD (not cents!) */
  quantariumValuation?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Year home was built */
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export enum OdProtosMdfServices_ErrorCode {
  /** Field has wrong type */
  ERROR_CODE_INVALID_TYPE = 'ERROR_CODE_INVALID_TYPE',
  /** Required field missing in response */
  ERROR_CODE_MISSING_REQUIRED_FIELD = 'ERROR_CODE_MISSING_REQUIRED_FIELD',
  /** Databricks model returned error */
  ERROR_CODE_MODEL_FAILED = 'ERROR_CODE_MODEL_FAILED',
  ERROR_CODE_UNSPECIFIED = 'ERROR_CODE_UNSPECIFIED',
  /** Generic validation failure */
  ERROR_CODE_VALIDATION_FAILED = 'ERROR_CODE_VALIDATION_FAILED',
  /** Value above valid maximum */
  ERROR_CODE_VALUE_TOO_LARGE = 'ERROR_CODE_VALUE_TOO_LARGE',
  /** Value below valid minimum */
  ERROR_CODE_VALUE_TOO_SMALL = 'ERROR_CODE_VALUE_TOO_SMALL'
}

/** NEXT ID: 28 */
export type OdProtosMdfServices_ModelRequestInput = {
  modelRequest?: InputMaybe<OdProtosMdfServices_ModelRequest_ModelRequestOneofInput>;
};

export type OdProtosMdfServices_ModelRequest_ModelRequestOneofInput = {
  brnSpendRequest?: InputMaybe<OdProtosMdfModelsAcquisition_BrnSpendRequestInput>;
  daysToPendBiasRequest?: InputMaybe<OdProtosMdfModelsSpread_DaysToPendBiasRequestInput>;
  forecastedSpreadDailyChangeRequest?: InputMaybe<OdProtosMdfModelsSpread_ForecastedSpreadDailyChangeRequestInput>;
  indifferencePriceTargetModelRequest?: InputMaybe<OdProtosMdfModelsResale_IndifferencePriceTargetModelRequestInput>;
  initialMarkupFeaturesRequest?: InputMaybe<OdProtosMdfModelsResale_InitialMarkupFeaturesRequestInput>;
  multivariatePrelistValGainAdjustmentRequest?: InputMaybe<OdProtosMdfModelsSpread_MultivariatePrelistValGainAdjustmentRequestInput>;
  /** ----------- SPREAD ----------- */
  multivariateValGainAdjustmentRequest?: InputMaybe<OdProtosMdfModelsSpread_MultivariateValGainAdjustmentRequestInput>;
  nationwideValuationsEnsemblerRequest?: InputMaybe<OdProtosMdfModelsValuation_NationwideValuationsEnsemblerModelRequestInput>;
  negativeSelectionChargeRequest?: InputMaybe<OdProtosMdfModelsSpread_NegativeSelectionChargeRequestInput>;
  postlistRepairSpendRequest?: InputMaybe<OdProtosMdfModelsAcquisition_PostlistRepairSpendRequestInput>;
  /** -------- ACQUISITION --------- */
  prelistRepairScopeRequest?: InputMaybe<OdProtosMdfModelsAcquisition_PrelistRepairScopeRequestInput>;
  quantariumDebiasedValuationRequest?: InputMaybe<OdProtosMdfModelsValuation_QuantariumDebiasedValuationRequestInput>;
  /** ----------- VALUATION ----------- */
  quantariumEnsemblerModelRequest?: InputMaybe<OdProtosMdfModelsValuation_QuantariumEnsemblerModelRequestInput>;
  quantariumValuationRequest?: InputMaybe<OdProtosMdfModelsValuation_QuantariumValuationRequestInput>;
  realtytracValuationRequest?: InputMaybe<OdProtosMdfModelsValuation_RealtyTracValuationRequestInput>;
  resalePricingRecommendationsRequest?: InputMaybe<OdProtosMdfModelsResale_ResalePricingRecommendationsRequestInput>;
  /** ----------- RESALE ----------- */
  resaleProbabilityContractModelRequest?: InputMaybe<OdProtosMdfModelsResale_ResaleProbabilityContractModelRequestInput>;
  resaleTargetPriceModelRequest?: InputMaybe<OdProtosMdfModelsResale_ResaleTargetPriceModelRequestInput>;
  restbCalibrationScoreRequest?: InputMaybe<OdProtosMdfModelsAcquisition_RestbCalibrationScoreRequestInput>;
  valuationsEnsemblerRequest?: InputMaybe<OdProtosMdfModelsValuation_ValuationsEnsemblerModelRequestInput>;
  vendigiQuintilesRequest?: InputMaybe<OdProtosMdfModelsAcquisition_VendigiQuintilesRequestInput>;
};

export type OdProtosMdfServices_ScoringRequestInput = {
  modelEndpoint?: InputMaybe<Scalars['String']['input']>;
  modelRequests?: InputMaybe<Array<OdProtosMdfServices_ModelRequestInput>>;
  requestId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * AddressContext represents the location of the eligibility check. At least
 * one of the fields must be provided, but prefer to provide more if possible.
 * Latitude and longitude cannot be the only fields provided.
 * Only the address_id is directly passed to the CheckEligibility data fields
 * from the AddressContext.
 * Next ID: 6
 */
export type OdProtosMerchandisingData_AddressContextInput = {
  /**
   * Address identifier. This will be used to look up the postal code and
   * market fields if not specified.
   */
  addressId?: InputMaybe<Scalars['String']['input']>;
  /** Latitude of the address. Cannot be the only field provided. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude of the address. Cannot be the only field provided. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Active market region. Provide this field only if the address lies within
   * an *active* market.
   */
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Postal code of address. Useful as a shortcut for some services. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingData_BoolWrapperInput = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CustomerContext represents customer information to be used with CheckEligibility
 * calls
 */
export type OdProtosMerchandisingData_CustomerContextInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Set of services that Merchandising can fetch fields from.
 * Next ID: 16
 */
export enum OdProtosMerchandisingData_DataSource {
  BALLPARK = 'BALLPARK',
  CASA = 'CASA',
  /** @deprecated No longer supported */
  DWELLINGS = 'DWELLINGS',
  FENCE = 'FENCE',
  GDS = 'GDS',
  HDS = 'HDS',
  LISTING = 'LISTING',
  ODLS = 'ODLS',
  OFFER_OUTLIER = 'OFFER_OUTLIER',
  OSTIARY = 'OSTIARY',
  PARTNERSHIP = 'PARTNERSHIP',
  RECEPTION = 'RECEPTION',
  SELLER_DASHBOARD_METRICS = 'SELLER_DASHBOARD_METRICS',
  TOGGLE = 'TOGGLE',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE',
  WEB = 'WEB'
}

/**
 * DataSources represents the sources a CheckEligibility request can use to fetch data.
 * Next ID: 7
 */
export type OdProtosMerchandisingData_DataSourcesInput = {
  experimentEntityId?: InputMaybe<Scalars['String']['input']>;
  homeDataStoreId?: InputMaybe<Scalars['String']['input']>;
  /** Optional fields to limit calls to external datasources in a CheckEligibility request. */
  input?: InputMaybe<OdProtosMerchandisingData_DataSources_InputOneofInput>;
  sellerInput?: InputMaybe<OdProtosMerchandisingData_DataSources_SellerInputInput>;
};

export type OdProtosMerchandisingData_DataSources_DataSourceListInput = {
  dataSources?: InputMaybe<Array<OdProtosMerchandisingData_DataSource>>;
};

export type OdProtosMerchandisingData_DataSources_InputOneofInput = {
  /** Do not make any calls to external datasources. */
  excludeAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Call out to all datasources except those in this list. */
  excluded?: InputMaybe<OdProtosMerchandisingData_DataSources_DataSourceListInput>;
  /** Call out to only the datasources in this list. */
  included?: InputMaybe<OdProtosMerchandisingData_DataSources_DataSourceListInput>;
};

export type OdProtosMerchandisingData_DataSources_SellerInputInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosMerchandisingData_DataSources_SellerInput_Type>;
};

export enum OdProtosMerchandisingData_DataSources_SellerInput_Type {
  PARTNERSHIP = 'PARTNERSHIP',
  RECEPTION = 'RECEPTION',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

/**
 * Fields is a set of data inputs used by Merchandising to check eligibilities.
 * Rules in RuleSets can reference fields by their name and when evaluating
 * the rule expression, the value that will be used will be provided by
 * this Protobuf message in the gRPC request. If a field is left unset,
 * it will be interpreted as having a NULL value.
 *
 * Field must have one of the following types:
 * BoolWrapper
 * Int64Wrapper
 * DoubleWrapper
 * StringWrapper
 * TimestampWrapper
 * StringListWrapper
 *
 * The wrapper types exist to distinguish fields between the Unknown state and the
 * Null state. Both states represent a missing value, but the intention is different.
 * An Unknown state is where the caller, or a data source, does not know the value
 * of a field, while the Null state is where value is known to be missing.
 *
 * If Merchandising finds an Unknown value, it will attempt to fill that value in by
 * loading data from its data sources. If Merchandising finds a Null value, it will
 * not attempt to fill the value in and leave the value as null.
 *
 * Callers should prefer to use the Unknown state to allow Merchandising to fetch data,
 * however callers may want to use Null if:
 * They do not want Merchandising to call a particular data source that provides
 * the missing field.
 * They intentionally want the value of the field to be missing and not be used
 * in the evaluation of rules.
 *
 * To use a Unknown value, leave the field unset in the Fields message.
 *
 * // All fields are implicitly unknown.
 * fields := &pb.Fields{}
 * // Explicitly set field to unknown state.
 * fields.LotSqFt = nil
 *
 * To use a Null value, set the field to an empty wrapper.
 *
 * // Set field to null state.
 * fields.LotSqFt = &pb.Int64Wrapper{}
 *
 * To use a non-missing value, set the field to a populated wrapper.
 *
 * // Set field to a populated state.
 * fields.LotSqFt = &pb.Int64Wrapper{Int64: &wrappers.Int64Value{Value: 2000}}
 *
 * Next ID: 91
 */
export type OdProtosMerchandisingData_FieldsInput = {
  activeOrganicGrowth?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  activelyLookingToBuy?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  addressEntryProduct?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  addressId?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  addressUuid?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  ageRestrictedCommunity?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  agentRelation?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  asbestosSiding?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  bathrooms?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  bedrooms?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  belowMarketRateOwnership?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  brokerageUuid?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  buyWithOpendoorEnabled?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  cesspool?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  distressedSale?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  dwellingType?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  expectedError?: InputMaybe<OdProtosMerchandisingData_Float64WrapperInput>;
  expectedLgmCents?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  /**
   * Optimizely feature flag names. Flags in this list are assumed enabled; flags not in the list are assumed disabled.
   * If this field is provided, Optimizely will not be called to check on the status of the flags.
   */
  featureFlags?: InputMaybe<OdProtosMerchandisingData_StringListWrapperInput>;
  fireDamage?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  flipStatus?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  floodHistory?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  floodProximity?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  floodZone?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  floodZoneCode?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  foundationIssues?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  gatedCommunity?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  gatedCommunityHasGuard?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  hasCompAddressUuids?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  hasHistoricalMarketMetrics?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  /**
   * has_legacy_flip can be used when constricting the
   * sell direct buybox. For example, when constraining
   * valuation cents you can continue to allows addresses
   * which have a legacy flip to be considered eligible
   * despite falling outside the new buybox.
   */
  hasLegacyFlip?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  hasValuationCents?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  hoaNames?: InputMaybe<OdProtosMerchandisingData_StringListWrapperInput>;
  homeEstimateCents?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  homebuilderReferrerUserId?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  inAgentLedOffersExperience?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  inCovidWhitelist?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  internalFeePct?: InputMaybe<OdProtosMerchandisingData_Float64WrapperInput>;
  /** use internal_fee to include risk_adjustment (NSC) */
  internalFeeWithoutRiskAdjustmentPct?: InputMaybe<OdProtosMerchandisingData_Float64WrapperInput>;
  isOfferOutlier?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  isQualifiedForAlo?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  leadChannel?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  leadState?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  leasedSolarPanels?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  listPriceCents?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  livestock?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  lotSqFt?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  mlsListingStatus?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  mobileManufacturedHome?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  mostRecentZillowReferralDays?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  newConstruction?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  offerRequestCount?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  offerRequestSource?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  opendoorDirectDenialReason?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  /** partnership_type is deprecated - use referral_types instead. */
  partnershipType?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  polybutylenePiping?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  postalCode?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  potentialTradeIn?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  price?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  priceEstimateTriage?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  privatePool?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  referralIdentifiers?: InputMaybe<OdProtosMerchandisingData_StringListWrapperInput>;
  referralTypes?: InputMaybe<OdProtosMerchandisingData_StringListWrapperInput>;
  rentControlledTenantOccupied?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  riskProhibitedRegion?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  saleTimeline?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  septic?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  seriousSeller?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  sharedEntrance?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  sharedLot?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  sinkholes?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  timeshare?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  totalLivingSqFt?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  undergroundOilTank?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  uniqueOwnershipStructure?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  unpermittedAddition?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  valuationCents?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  valuationCentsForPartnerships?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  wellWater?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  workingWithAgent?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  workingWithHomeBuilder?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  yearBuilt?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingData_Float64WrapperInput = {
  float64?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingData_Int64WrapperInput = {
  int64?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosMerchandisingData_NullValue {
  NULL_VALUE = 'NULL_VALUE'
}

/** Next ID: 4 */
export enum OdProtosMerchandisingData_Result_Status {
  /** The rule's condition was not satisfied. */
  FAILED = 'FAILED',
  /** The rule's condition could not be evaluated due to missing data. */
  MISSING = 'MISSING',
  /** The rule's condition was satisfied. */
  PASSED = 'PASSED',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

/** Next ID: 3 */
export type OdProtosMerchandisingData_RuleInput = {
  exprJson?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosMerchandisingData_RuleSetVersion_State {
  /** The proposed version has been approved and is now live. */
  APPROVED = 'APPROVED',
  /** The proposed version has been closed without approval. */
  CLOSED = 'CLOSED',
  /** This version has been proposed, but is not yet live. */
  PROPOSED = 'PROPOSED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/** Next ID: 2 */
export type OdProtosMerchandisingData_StringListWrapperInput = {
  stringList?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingData_StringWrapperInput = {
  string?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosMerchandisingData_Value_Kind {
  BOOL = 'BOOL',
  FLOAT64 = 'FLOAT64',
  INT64 = 'INT64',
  NULL = 'NULL',
  STRING = 'STRING',
  STRING_LIST = 'STRING_LIST',
  TIMESTAMP = 'TIMESTAMP',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

/** Next ID: 2 */
export type OdProtosMerchandisingServices_AcceptRuleSetProposalRequestInput = {
  ruleSetProposalId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_ApproveRulesRequestInput = {
  ruleSetVersionId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_BulkCreateRuleSetsRequestInput = {
  requests?: InputMaybe<Array<OdProtosMerchandisingServices_CreateRuleSetRequestInput>>;
};

/** Next ID: 6 */
export type OdProtosMerchandisingServices_CheckEligibilityRequestInput = {
  address?: InputMaybe<OdProtosMerchandisingData_AddressContextInput>;
  customer?: InputMaybe<OdProtosMerchandisingData_CustomerContextInput>;
  dataFields?: InputMaybe<OdProtosMerchandisingData_FieldsInput>;
  dataSources?: InputMaybe<OdProtosMerchandisingData_DataSourcesInput>;
  experiences?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_CloseRuleSetProposalRequestInput = {
  ruleSetProposalId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_CloseRulesRequestInput = {
  ruleSetVersionId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosMerchandisingServices_CreateRuleSetRequestInput = {
  /**
   * Whether the rule set is active or not. If this field is not set, defaults
   * to true.
   */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** If set, the similar market's active rule set will be copied and used as the new market's inital ruleset. */
  marketToCopy?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosMerchandisingServices_DeleteRuleSetRequestInput = {
  ruleSetId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosMerchandisingServices_FindRuleSetsRequestInput = {
  experiences?: InputMaybe<Array<Scalars['String']['input']>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosMerchandisingServices_GetProposedEditsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_GetRuleSetRequestInput = {
  ruleSetId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosMerchandisingServices_ListRuleSetVersionsRequestInput = {
  input?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetVersionsRequest_InputOneofInput>;
};

export type OdProtosMerchandisingServices_ListRuleSetVersionsRequest_IdentifiersInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosMerchandisingServices_ListRuleSetVersionsRequest_InputOneofInput = {
  ruleSetId?: InputMaybe<Scalars['String']['input']>;
  ruleSetVersionIds?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetVersionsRequest_IdentifiersInput>;
};

/** Next ID: 4 */
export type OdProtosMerchandisingServices_ListRuleSetsRequestInput = {
  input?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetsRequest_InputOneofInput>;
};

export type OdProtosMerchandisingServices_ListRuleSetsRequest_IdentifiersInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosMerchandisingServices_ListRuleSetsRequest_InputOneofInput = {
  markets?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetsRequest_MarketsInput>;
  ruleSetIds?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetsRequest_IdentifiersInput>;
};

export type OdProtosMerchandisingServices_ListRuleSetsRequest_MarketsInput = {
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

/** Next ID: 3 */
export type OdProtosMerchandisingServices_ProposeRuleSetRequestInput = {
  proposedActive?: InputMaybe<Scalars['Boolean']['input']>;
  ruleSetId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosMerchandisingServices_ProposeRulesRequestInput = {
  includedRuleSetVersionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleSetId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<OdProtosMerchandisingData_RuleInput>>;
};

/** Next ID: 5 */
export type OdProtosMerchandisingServices_ScheduleBacktestRequestInput = {
  /**
   * Specify a list of particular addresses to target.
   * TODO: Support this functionality.
   */
  backtests?: InputMaybe<Array<OdProtosMerchandisingServices_ScheduleBacktestRequest_BacktestInput>>;
  experience?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  proposedrulesetversionuuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMerchandisingServices_ScheduleBacktestRequest_BacktestInput = {
  addresstoken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosMerchandisingServices_SearchRuleSetProposalsRequestInput = {
  ruleSetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<OdProtosMerchandisingServices_SearchRuleSetProposalsRequest_Status>;
};

export enum OdProtosMerchandisingServices_SearchRuleSetProposalsRequest_Status {
  APPROVED = 'APPROVED',
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

/** Next ID: 4 */
export type OdProtosMerchandisingServices_UpdateRuleSetRequestInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ruleSetId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_ValidateRulesRequestInput = {
  rules?: InputMaybe<Array<OdProtosMerchandisingData_RuleInput>>;
};

export type OdProtosMergeServices_MergeAddressRequestInput = {
  fromId?: InputMaybe<Scalars['String']['input']>;
  toId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMergeServices_MergeCustomerRequestInput = {
  fromId?: InputMaybe<Scalars['String']['input']>;
  toId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesData_AddOpenHouseInfoInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesData_CloseOfEscrowDateUpdateInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  newDate?: InputMaybe<Scalars['String']['input']>;
};

/**
 * EffectiveSyncState represents the reconciled sync state for a (listing_uuid, task_type) pair,
 * derived from the most recent task's status.
 */
export enum OdProtosMolassesData_EffectiveSyncState {
  IN_PROGRESS = 'IN_PROGRESS',
  SYNCED = 'SYNCED',
  UNKNOWN_SYNC_STATE = 'UNKNOWN_SYNC_STATE',
  UNSYNCED = 'UNSYNCED'
}

export enum OdProtosMolassesData_ErrorCategory {
  CAPTCHA_BLOCKED = 'CAPTCHA_BLOCKED',
  CREDENTIALS_INVALID = 'CREDENTIALS_INVALID',
  ELEMENT_INTERACTION = 'ELEMENT_INTERACTION',
  NETWORK_ERROR = 'NETWORK_ERROR',
  PAGE_TIMEOUT = 'PAGE_TIMEOUT',
  SCRIPT_BUG = 'SCRIPT_BUG',
  SELECTOR_NOT_FOUND = 'SELECTOR_NOT_FOUND',
  TWO_FACTOR_AUTH = 'TWO_FACTOR_AUTH',
  UNKNOWN_ERROR_CATEGORY = 'UNKNOWN_ERROR_CATEGORY'
}

export type OdProtosMolassesData_FhaEligibleUpdateInput = {
  fhaEligibleDate?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosMolassesData_Level {
  ERROR_LEVEL = 'ERROR_LEVEL',
  INFO_LEVEL = 'INFO_LEVEL',
  UNKNOWN_LEVEL = 'UNKNOWN_LEVEL',
  WARN_LEVEL = 'WARN_LEVEL'
}

export type OdProtosMolassesData_ListerineCreateListingBlobInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  fetchedData?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['String']['input']>;
  hdsId?: InputMaybe<Scalars['String']['input']>;
  hpmD1wVisit?: InputMaybe<Scalars['String']['input']>;
  hpmSetupVisit?: InputMaybe<Scalars['String']['input']>;
  isTraditionalListing?: InputMaybe<Scalars['Boolean']['input']>;
  listingTaskId?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

/** ListingStatus enumerates the different possible MLS statuses a listing can be in. */
export enum OdProtosMolassesData_ListingStatus {
  ACTIVE_LISTING_STATUS = 'ACTIVE_LISTING_STATUS',
  CANCELED_LISTING_STATUS = 'CANCELED_LISTING_STATUS',
  CLOSED_LISTING_STATUS = 'CLOSED_LISTING_STATUS',
  COMING_SOON_LISTING_STATUS = 'COMING_SOON_LISTING_STATUS',
  CONTINGENT_LISTING_STATUS = 'CONTINGENT_LISTING_STATUS',
  EXPIRED_LISTING_STATUS = 'EXPIRED_LISTING_STATUS',
  PENDING_LISTING_STATUS = 'PENDING_LISTING_STATUS',
  PUT_ON_MARKET_LISTING_STATUS = 'PUT_ON_MARKET_LISTING_STATUS',
  TEMPORARILY_OFF_MARKET_LISTING_STATUS = 'TEMPORARILY_OFF_MARKET_LISTING_STATUS',
  UNKNOWN_LISTING_STATUS = 'UNKNOWN_LISTING_STATUS',
  WITHDRAWN_LISTING_STATUS = 'WITHDRAWN_LISTING_STATUS'
}

/**
 * ListingStatusFields is an object that contains any metadata that we also want to manually specify
 * when performing a particular request (e.g. specifying an estimated COE date when updating a
 * listing status.)
 *
 * Fetching this data is by default managed by the Molasses service itself, but this object allows
 * us to manually specify/override any parameters that we want to use when performing the request.
 */
export type OdProtosMolassesData_ListingStatusFieldsInput = {
  /** TODO(evan): Fill this out as it becomes necessary. */
  optionExpirationDate?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesData_ListingStatusUpdateInput = {
  isTraditionalListing?: InputMaybe<Scalars['Boolean']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  newStatus?: InputMaybe<OdProtosMolassesData_ListingStatus>;
  overrides?: InputMaybe<OdProtosMolassesData_ListingStatusFieldsInput>;
};

export enum OdProtosMolassesData_MlsTaskStatus {
  /**
   * COMPLETED represents a task that ran to completion and has passed any post-submission
   * checks/validations verifying that it completed properly.
   */
  COMPLETED_TASK_STATUS = 'COMPLETED_TASK_STATUS',
  /**
   * COMPLETED_WITH_ERROR represents a task that has run to completion, with an error.
   * It will retry unless the max retries have been reached (then it is fatal).
   */
  COMPLETED_WITH_ERROR_TASK_STATUS = 'COMPLETED_WITH_ERROR_TASK_STATUS',
  /**
   * CONFIRMED_COMPLETED represents a task that successfully completed and its consequences were verified
   * after the task was completed
   */
  CONFIRMED_COMPLETED_TASK_STATUS = 'CONFIRMED_COMPLETED_TASK_STATUS',
  /**
   * DISCREPANCY_DETECTED_TASK_STATUS represents a task that successfully completed and its consequences (price)
   * do not match or could not be confirmed after the task was completed
   */
  DISCREPANCY_DETECTED_TASK_STATUS = 'DISCREPANCY_DETECTED_TASK_STATUS',
  /**
   * FATAL represents a task that has failed permanently, either because we reached the
   * maximum number of retries or we ran into some sort of unrecoverable error.
   */
  FATAL_TASK_STATUS = 'FATAL_TASK_STATUS',
  /** MANUALLY_RESOLVED represents a task that was manually resolved by an Operator outside of Molasses */
  MANUALLY_RESOLVED_TASK_STATUS = 'MANUALLY_RESOLVED_TASK_STATUS',
  /**
   * PENDING represents a task that has been readied for execution and may be picked up by a
   * worker, but has not yet run to completion.
   */
  PENDING_TASK_STATUS = 'PENDING_TASK_STATUS',
  UNKNOWN_TASK_STATUS = 'UNKNOWN_TASK_STATUS',
  /**
   * UNSUPPORTED represents a task update for an unsupported (mls, TaskType)
   * pair.
   */
  UNSUPPORTED_TASK_STATUS = 'UNSUPPORTED_TASK_STATUS'
}

export enum OdProtosMolassesData_MlsTaskType {
  ADD_OPEN_HOUSE_INFO_TASK_TYPE = 'ADD_OPEN_HOUSE_INFO_TASK_TYPE',
  CLOSE_OF_ESCROW_DATE_UPDATE_TASK_TYPE = 'CLOSE_OF_ESCROW_DATE_UPDATE_TASK_TYPE',
  CREATE_LISTING_TASK_TYPE = 'CREATE_LISTING_TASK_TYPE',
  FHA_ELIGIBLE_UPDATE_TASK_TYPE = 'FHA_ELIGIBLE_UPDATE_TASK_TYPE',
  LISTING_STATUS_UPDATE_TASK_TYPE = 'LISTING_STATUS_UPDATE_TASK_TYPE',
  PRICE_UPDATE_TASK_TYPE = 'PRICE_UPDATE_TASK_TYPE',
  UNKNOWN_TASK_TYPE = 'UNKNOWN_TASK_TYPE',
  UPLOAD_DISCLOSURE_DOCS_TASK_TYPE = 'UPLOAD_DISCLOSURE_DOCS_TASK_TYPE'
}

export type OdProtosMolassesData_PriceUpdateInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  newPriceCents?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosMolassesData_UploadDisclosureDocsInput = {
  /** 4: content_url */
  documentId?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_ComputeStatusesInput = {
  listingUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  /** pagination is required */
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  syncState?: InputMaybe<Array<OdProtosMolassesData_EffectiveSyncState>>;
  taskType?: InputMaybe<Array<OdProtosMolassesData_MlsTaskType>>;
};

export type OdProtosMolassesServices_MlsTaskRequest_GetInput = {
  taskUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_GetLatestListingCreateInput = {
  ignoreNotFoundErrors?: InputMaybe<Scalars['Boolean']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_ListInput = {
  /** UUIDs for all tasks to be returned. If none are specified, returns all tasks. */
  taskUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosMolassesServices_MlsTaskRequest_PresignSnapshotsInput = {
  taskUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_RerunInput = {
  taskUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_SearchInput = {
  /** Filter by error category of the most recent task run. */
  errorCategory?: InputMaybe<Array<OdProtosMolassesData_ErrorCategory>>;
  listingUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  /** pagination is required */
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  taskStatus?: InputMaybe<Array<OdProtosMolassesData_MlsTaskStatus>>;
  /**
   * It searches by the union of filters. If the individual filter is provided
   * it searches for entries that have one of the provided values.
   */
  taskType?: InputMaybe<Array<OdProtosMolassesData_MlsTaskType>>;
};

export type OdProtosMolassesServices_MlsTaskRequest_SetToManuallyResolvedInput = {
  taskUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesServices_MolassesRequest_AddOpenHouseInfoInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_AddOpenHouseInfoInput>;
};

export type OdProtosMolassesServices_MolassesRequest_CloseOfEscrowDateUpdateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_CloseOfEscrowDateUpdateInput>;
};

export type OdProtosMolassesServices_MolassesRequest_FhaEligibleUpdateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_FhaEligibleUpdateInput>;
};

export type OdProtosMolassesServices_MolassesRequest_ListMlsNamesInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosMolassesServices_MolassesRequest_ListUsernamesInput = {
  mlsName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesServices_MolassesRequest_ListingCreateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_ListerineCreateListingBlobInput>;
};

export type OdProtosMolassesServices_MolassesRequest_ListingStatusUpdateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_ListingStatusUpdateInput>;
};

export type OdProtosMolassesServices_MolassesRequest_PriceUpdateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_PriceUpdateInput>;
};

export type OdProtosMolassesServices_MolassesRequest_UpdateMlsCredentialsInput = {
  mlsName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosMolassesServices_MolassesRequest_UploadDisclosureDocsInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_UploadDisclosureDocsInput>;
};

export type OdProtosMolassesServices_SupportedRequest_IsSupportedInput = {
  checkSupported?: InputMaybe<OdProtosMolassesServices_SupportedUpdateInput>;
};

export type OdProtosMolassesServices_SupportedRequest_UpdateInput = {
  supportedRequest?: InputMaybe<OdProtosMolassesServices_SupportedUpdateInput>;
};

/** Represents a possible update to the MLS and its support */
export type OdProtosMolassesServices_SupportedUpdateInput = {
  /** Desired state of this update type, ignored for IsSupported checks */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional listing_status, only applicable for that task type */
  listingStatus?: InputMaybe<OdProtosMolassesData_ListingStatus>;
  /** MlsName of the supported update */
  mlsName?: InputMaybe<Scalars['String']['input']>;
  /** TaskType of the active request */
  taskType?: InputMaybe<OdProtosMolassesData_MlsTaskType>;
};

/** Next ID: 3 */
export type OdProtosMortgageData_CreditRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosNotesData_NoteContextInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  contextIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
};

export type OdProtosNotesData_NoteItemOrderingInput = {
  column?: InputMaybe<OdProtosNotesData_NoteItemOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosNotesData_NoteItemOrdering_Column {
  CREATED_AT = 'CREATED_AT'
}

export type OdProtosNotesData_NoteSearchFiltersInput = {
  /** ignore, if empty. If more then one, then combines with AND */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosNotesServices_CreateNote_RequestInput = {
  /** Main text of the note. */
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']['input']>;
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Type of note */
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
  /** Token of the creating user. */
  createdByToken?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosNotesServices_CreateNotes_NoteInput = {
  /** Main text of the note. */
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']['input']>;
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Type of note */
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
  /** Token of the creating user. */
  createdByToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosNotesServices_CreateNotes_RequestInput = {
  notes?: InputMaybe<Array<OdProtosNotesServices_CreateNotes_NoteInput>>;
};

export type OdProtosNotesServices_CreateOrUpdateNoteFromWebBulk_NoteInput = {
  /** Main text of the note. */
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']['input']>;
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Type of note */
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
  /** Creation timestamp of note. */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Token of the creating user. */
  createdByToken?: InputMaybe<Scalars['String']['input']>;
  /** Last modified timestamp of note. */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** uuid of the note in web */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** Note Id is an identifier for notes in web */
  webNoteId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosNotesServices_CreateOrUpdateNoteFromWebBulk_RequestInput = {
  notes?: InputMaybe<Array<OdProtosNotesServices_CreateOrUpdateNoteFromWebBulk_NoteInput>>;
};

export type OdProtosNotesServices_DeleteCustomerNoteForCcpa_RequestInput = {
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosNotesServices_DeleteNoteWeb_RequestInput = {
  webNoteId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosNotesServices_DeleteNote_RequestInput = {
  contextType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosNotesServices_GetLatestNote_RequestInput = {
  noteContexts?: InputMaybe<Array<OdProtosNotesData_NoteContextInput>>;
};

export type OdProtosNotesServices_GetNoteById_RequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosNotesServices_GetNotesSummary_NoteContextInput = {
  contextIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
};

export type OdProtosNotesServices_GetNotesSummary_RequestInput = {
  noteContexts?: InputMaybe<Array<OdProtosNotesServices_GetNotesSummary_NoteContextInput>>;
};

export type OdProtosNotesServices_MigrateWebNotes_RequestInput = {
  batchSize?: InputMaybe<Scalars['Float']['input']>;
  lastMigrationTime?: InputMaybe<Scalars['DateTime']['input']>;
  notableTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosNotesServices_NoteUpdateInput = {
  /** Using wrapper to handle optional fields */
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']['input']>;
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  contextType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosNotesServices_SearchNotes_RequestInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** If provided restrict to notes with this category */
  category?: InputMaybe<Scalars['String']['input']>;
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  contextIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Context type and identifier must be specified. */
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
  createdByTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Deprecated */
  filters?: InputMaybe<OdProtosNotesData_NoteSearchFiltersInput>;
  orderings?: InputMaybe<Array<OdProtosNotesData_NoteItemOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosNotesServices_UpdateNoteV1_RequestInput = {
  note?: InputMaybe<OdProtosNotesServices_NoteUpdateInput>;
};

export type OdProtosNotesServices_UpdateNote_RequestInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']['input']>;
  contextType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosNotesServices_UpdateNotes_RequestInput = {
  notes?: InputMaybe<Array<OdProtosNotesServices_NoteUpdateInput>>;
};

/**
 * All notes have are associated with some external context.
 * Type and identifier specify this context.
 *
 * DO NOT change existing enum names as it will break past notes!
 * DO add to this enum for a new note association! No further service changes are
 * required.
 */
export enum OdProtosNotesTypes_ContextType {
  ADDRESS = 'ADDRESS',
  BRN = 'BRN',
  BROKER_TRANSACTION_DOCUMENT_REVIEW = 'BROKER_TRANSACTION_DOCUMENT_REVIEW',
  BROKER_TRANSACTION_REVIEW = 'BROKER_TRANSACTION_REVIEW',
  BUY_OFFER = 'BUY_OFFER',
  CASEY_TASK = 'CASEY_TASK',
  CONSTRUCTION_WORK_ORDER = 'CONSTRUCTION_WORK_ORDER',
  CONTACT = 'CONTACT',
  DOCUMENT = 'DOCUMENT',
  /** @deprecated No longer supported */
  EXCLUSIVE_LISTING_INFO = 'EXCLUSIVE_LISTING_INFO',
  FULFILLMENT = 'FULFILLMENT',
  LISTING = 'LISTING',
  /** @deprecated No longer supported */
  LWOD_LEAD = 'LWOD_LEAD',
  MESSAGE_THREAD = 'MESSAGE_THREAD',
  OFFER = 'OFFER',
  /** @deprecated No longer supported */
  OPENDOOR_BACKED_OFFER = 'OPENDOOR_BACKED_OFFER',
  OPENDOOR_BACKED_ORDER = 'OPENDOOR_BACKED_ORDER',
  PRICING_QA = 'PRICING_QA',
  RENOVATION = 'RENOVATION',
  REPAIR_BUDGET_REVIEW = 'REPAIR_BUDGET_REVIEW',
  TRANSACTION = 'TRANSACTION',
  UNKNOWN = 'UNKNOWN',
  VISIT = 'VISIT',
  VISIT_ITEM = 'VISIT_ITEM',
  WEB_FLIP = 'WEB_FLIP'
}

export enum OdProtosNotificationsData_Notification_NotificationType {
  CUSTOMER_MESSAGE = 'CUSTOMER_MESSAGE',
  HOME_REASSIGNMENT = 'HOME_REASSIGNMENT',
  INVALID_TYPE = 'INVALID_TYPE',
  PROJECT_NOTE = 'PROJECT_NOTE',
  REPAIR_SCOPES_READY_FOR_REVIEW = 'REPAIR_SCOPES_READY_FOR_REVIEW',
  VISIT_ASSIGN = 'VISIT_ASSIGN',
  VISIT_CANCEL = 'VISIT_CANCEL',
  VISIT_CREATE = 'VISIT_CREATE',
  VISIT_REJECT = 'VISIT_REJECT',
  VISIT_REMINDER = 'VISIT_REMINDER',
  VISIT_SCHEDULE_CHANGE = 'VISIT_SCHEDULE_CHANGE',
  WORK_ORDER_MESSAGE = 'WORK_ORDER_MESSAGE'
}

export enum OdProtosNotificationsData_Notification_Platform {
  INVALID_PLATFORM = 'INVALID_PLATFORM',
  MAESTRO = 'MAESTRO',
  SCOUT = 'SCOUT'
}

export type OdProtosNotificationsServices_AssociatedWithInput = {
  associatedWithId?: InputMaybe<Scalars['String']['input']>;
  associatedWithType?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosNotificationsServices_BackfillNotificationRequestInput = {
  createRequest?: InputMaybe<OdProtosNotificationsServices_CreateNotificationRequestInput>;
  createdAtOverwrite?: InputMaybe<Scalars['DateTime']['input']>;
  markAsSeen?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 2 */
export type OdProtosNotificationsServices_BackfillNotificationsRequestInput = {
  backfillNotificationRequests?: InputMaybe<Array<OdProtosNotificationsServices_BackfillNotificationRequestInput>>;
};

/** Next ID: 4 */
export type OdProtosNotificationsServices_CountNotificationsRequestInput = {
  associatedWith?: InputMaybe<OdProtosNotificationsServices_AssociatedWithInput>;
  hideSeenNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  markets?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  types?: InputMaybe<Array<OdProtosNotificationsData_Notification_NotificationType>>;
};

/** Next ID: 5 */
export type OdProtosNotificationsServices_CountUnseenNotificationsForMarketsRequestInput = {
  createdAtInterval?: InputMaybe<OdProtosNotificationsServices_IntervalInput>;
  markets?: InputMaybe<Array<Scalars['String']['input']>>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
};

/** Next ID: 5 */
export type OdProtosNotificationsServices_CountUnseenNotificationsForUserRequestInput = {
  createdAtInterval?: InputMaybe<OdProtosNotificationsServices_IntervalInput>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 10 */
export type OdProtosNotificationsServices_CreateNotificationRequestInput = {
  assignedUserToken?: InputMaybe<Scalars['String']['input']>;
  associatedWith?: InputMaybe<OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneofInput>;
  market?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosNotificationsData_Notification_NotificationType>;
};

export type OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneofInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosNotificationsServices_GetNotificationsByIdRequestInput = {
  notificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 3 */
export type OdProtosNotificationsServices_GetNotificationsForWorkOrderRequestInput = {
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosNotificationsServices_IntervalInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 5 */
export type OdProtosNotificationsServices_ListNotificationsForAssociatedWithIdsRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationType?: InputMaybe<OdProtosNotificationsData_Notification_NotificationType>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  workOrderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosNotificationsServices_MarkNotificationSeenRequestInput = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosNotificationsServices_MarkNotificationUnseenRequestInput = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosNotificationsServices_SearchNotificationsRequestInput = {
  associatedWith?: InputMaybe<OdProtosNotificationsServices_AssociatedWithInput>;
  hideSeenNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  markets?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  types?: InputMaybe<Array<OdProtosNotificationsData_Notification_NotificationType>>;
};

export type OdProtosOperatorData_BrokerageLicenseFilterInput = {
  licenseStates?: InputMaybe<Array<OdProtosCommonState_State>>;
  operatorTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  validOn?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosOperatorData_BrokerageLicenseInput = {
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licenseState?: InputMaybe<OdProtosCommonState_State>;
  operatorToken?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  validTill?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Deprecated: use coverage pods */
export type OdProtosOperatorData_CoverageCircleInput = {
  /**
   * The keys and values are Operator Human token
   * the operator from the key is covered by the operator from the value
   * e.g: the map:
   * {
   *   "X" : "Y",
   *   "Y" : "Z",
   *   "Z" : "X".
   * }
   * represents the coverage circle
   * X -> Y -> Z -> X
   *
   * If X is unavailable the responsibility for their work goes to Y
   * If Y is unavailable the responsibility for their work goes to Z
   * If Z is unavailable the responsibility for their work goes to X (closing the circle)
   * The map has to represent a closed circle, the list of keys and values are the same and are unique
   * map<from_operator_token, to_operator_token>
   */
  coverageMap?: InputMaybe<Array<OdProtosOperatorData_CoverageCircle_CoverageMapEntryInput>>;
};

/** `OdProtosOperatorData_CoverageCircle_CoverageMapEntryInput` represents the `coverage_map` map in `od_protos.operator.data.CoverageCircle`. */
export type OdProtosOperatorData_CoverageCircle_CoverageMapEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosOperatorData_CoverageResponsibilityGrainType {
  RESPONSIBILITY_GRAIN_CUSTOMER = 'RESPONSIBILITY_GRAIN_CUSTOMER',
  RESPONSIBILITY_GRAIN_TRANSACTION = 'RESPONSIBILITY_GRAIN_TRANSACTION',
  RESPONSIBILITY_GRAIN_UNSPECIFIED = 'RESPONSIBILITY_GRAIN_UNSPECIFIED'
}

export type OdProtosOperatorData_FilterInput = {
  /** Filter out operators who no longer work with Opendoor */
  excludeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Get operators with given tokens, or get all operators
   * in the reporting hierarchy of given manager taoken
   */
  operatorFilter?: InputMaybe<OdProtosOperatorData_Filter_OperatorFilterOneofInput>;
};

export type OdProtosOperatorData_Filter_HumanTokensInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorData_Filter_OperatorFilterOneofInput = {
  managerToken?: InputMaybe<Scalars['String']['input']>;
  operatorTokens?: InputMaybe<OdProtosOperatorData_Filter_HumanTokensInput>;
};

export type OdProtosOperatorData_SkillFilterInput = {
  operatorTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  skillNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorData_SkillInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  operatorToken?: InputMaybe<Scalars['String']['input']>;
  skillName?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorData_TemplateConfigurationInput = {
  capacityCount?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<OdProtosOperatorData_WorkCategory>;
  id?: InputMaybe<Scalars['String']['input']>;
  marketRestrictions?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  regionRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorData_TemplateInput = {
  configurations?: InputMaybe<Array<OdProtosOperatorData_TemplateConfigurationInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorData_WorkAssignmentAttributesInput = {
  /** Location, reference to valid casa address */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Current operator token, to exclude in case of reassignments */
  currentOperatorToken?: InputMaybe<Scalars['String']['input']>;
  /** Date by which work must be done */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Real estate license needed */
  licensesRequired?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Skills / specializations needed */
  skillsRequired?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Strict due date availability */
  strictDueDateAvailibility?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of work */
  workCategory?: InputMaybe<OdProtosOperatorData_WorkCategory>;
};

export type OdProtosOperatorData_WorkAssignmentConfigInput = {
  allowOverutilization?: InputMaybe<Scalars['Boolean']['input']>;
  capacityCount?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<OdProtosOperatorData_WorkCategory>;
  humanToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  marketRestrictions?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  regionRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OdProtosOperatorData_WorkCategory {
  ACQ_TC = 'ACQ_TC',
  FVA_ALA_ASSESSMENT = 'FVA_ALA_ASSESSMENT',
  FVA_ASSESSMENT = 'FVA_ASSESSMENT',
  IVA_ASSESSMENT = 'IVA_ASSESSMENT',
  RESALE_TC = 'RESALE_TC',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosOperatorServices_ActiveVolumeFilterInput = {
  category?: InputMaybe<OdProtosOperatorData_WorkCategory>;
  configId?: InputMaybe<Scalars['String']['input']>;
  humanToken?: InputMaybe<Scalars['String']['input']>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosOperatorServices_AssignTemplateRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_CreateCoveragePodRequestInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Human tokens */
  operatorTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_DeleteBrokerageLicensesRequestInput = {
  licenseUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_DeleteCoveragePodRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_DeleteOperatorSkillsRequestInput = {
  skillUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_DeleteOperatorWorkAssignmentConfigsRequestInput = {
  workAssignmentConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_DeleteTemplatesRequestInput = {
  templateUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_GetActiveVolumeForOperatorsRequestInput = {
  activeVolumeFilters?: InputMaybe<Array<OdProtosOperatorServices_ActiveVolumeFilterInput>>;
  dueDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type OdProtosOperatorServices_GetAvailableOperatorsInTimeWindowRequestInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  operatorHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCalendarId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosOperatorServices_GetBestCandidateBulkRequestInput = {
  /** optional, only when above is true - use shared (team) calendar instead of operator's primary calendar */
  sharedCalendarId?: InputMaybe<Scalars['String']['input']>;
  /** optional - tiebreaker strategy for selecting among candidates with equal utilization */
  tiebreakerStrategy?: InputMaybe<OdProtosOperatorServices_TiebreakerStrategy>;
  /** optional - use google calendar instead of web availability details */
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of work, market restrictions, (and skills, licenses if needed) for each work unit */
  workUnits?: InputMaybe<Array<OdProtosOperatorData_WorkAssignmentAttributesInput>>;
};

export type OdProtosOperatorServices_GetBestCandidateForWorkRequestInput = {
  /** The type of work, market restrictions, (and skills, licenses if needed) */
  attributes?: InputMaybe<OdProtosOperatorData_WorkAssignmentAttributesInput>;
  /** optional, only when above is true - use shared (team) calendar instead of operator's primary calendar */
  sharedCalendarId?: InputMaybe<Scalars['String']['input']>;
  /** optional - tiebreaker strategy for selecting among candidates with equal utilization. */
  tiebreakerStrategy?: InputMaybe<OdProtosOperatorServices_TiebreakerStrategy>;
  /** optional - use google calendar instead of web availability details */
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosOperatorServices_GetBrokerageLicensesRequestInput = {
  filter?: InputMaybe<OdProtosOperatorData_BrokerageLicenseFilterInput>;
};

export type OdProtosOperatorServices_GetCandidatesForWorkRequestInput = {
  attributes?: InputMaybe<OdProtosOperatorData_WorkAssignmentAttributesInput>;
  sharedCalendarId?: InputMaybe<Scalars['String']['input']>;
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosOperatorServices_GetCoveringOperatorRequestInput = {
  operatorHumanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_GetOperatorByUserTokenRequestInput = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_GetOperatorCoverageResponsibilitiesRequestInput = {
  operatorToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_GetOperatorPreferencesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosOperatorServices_GetOperatorRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_GetOperatorSkillsRequestInput = {
  filter?: InputMaybe<OdProtosOperatorData_SkillFilterInput>;
};

export type OdProtosOperatorServices_GetOperatorUnavailabilitiesRequestInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  operatorHumanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCalendarId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosOperatorServices_GetOperatorWorkAssignmentConfigsRequestInput = {
  filter?: InputMaybe<OdProtosOperatorServices_WorkAssignmentConfigFilterInput>;
};

export type OdProtosOperatorServices_GetOperatorsCoveredByOperatorRequestInput = {
  operatorHumanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_GetOperatorsRequestInput = {
  filter?: InputMaybe<OdProtosOperatorData_FilterInput>;
};

/** Next ID: 2 */
export type OdProtosOperatorServices_GetRoleMembersRequestInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_GetTemplatesRequestInput = {
  filter?: InputMaybe<OdProtosOperatorServices_TemplateFilterInput>;
};

/** Next ID: 2 */
export type OdProtosOperatorServices_GetUserRolesRequestInput = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOperatorServices_HolidayCalendarRequestInput = {
  /** Please refrain using start time past 2022-01-01. Calendar API has holidays starting from 2022 */
  starttime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosOperatorServices_ListCoveragePodsRequestInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosOperatorServices_RefreshOperatorDataRequestInput = {
  operatorfilter?: InputMaybe<OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorFilterOneofInput>;
};

export type OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorEmailsInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorFilterOneofInput = {
  operatorEmails?: InputMaybe<OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorEmailsInput>;
  operatorTokens?: InputMaybe<OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorTokensInput>;
};

export type OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorTokensInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_SetBrokerageLicensesRequestInput = {
  licenses?: InputMaybe<Array<OdProtosOperatorData_BrokerageLicenseInput>>;
};

export type OdProtosOperatorServices_SetCoverageCirclesRequestInput = {
  /**
   * If any operator from an existing circle is modified, the full circle must be provided
   * To remove an operator from a circle, set the operator's covering operator to ""
   * E.g To go from X -> Y -> Z -> X to X -> Z -> X you must pass in the coverage circle coverage map of
   * "X": "Z"
   * "Y": ""
   * "Z: "X"
   */
  modifiedCoverageCircles?: InputMaybe<Array<OdProtosOperatorData_CoverageCircleInput>>;
};

export type OdProtosOperatorServices_SetOperatorPreferencesRequestInput = {
  preferences?: InputMaybe<GoogleProtobuf_StructInput>;
};

export type OdProtosOperatorServices_SetOperatorSkillsRequestInput = {
  skills?: InputMaybe<Array<OdProtosOperatorData_SkillInput>>;
};

export type OdProtosOperatorServices_SetOperatorWorkAssignmentConfigsRequestInput = {
  configs?: InputMaybe<Array<OdProtosOperatorData_WorkAssignmentConfigInput>>;
};

export type OdProtosOperatorServices_SetTemplatesRequestInput = {
  templates?: InputMaybe<Array<OdProtosOperatorData_TemplateInput>>;
};

export type OdProtosOperatorServices_TemplateFilterInput = {
  categories?: InputMaybe<Array<OdProtosOperatorData_WorkCategory>>;
  level?: InputMaybe<Scalars['Float']['input']>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * TiebreakerStrategy defines how the allocator resolves cases where
 * multiple operators have equal utilization.
 */
export enum OdProtosOperatorServices_TiebreakerStrategy {
  /**
   * Randomly selects among tied operators with probability proportional
   * to their capacity.
   */
  TIEBREAKER_STRATEGY_CAPACITY_WEIGHTED_RANDOM = 'TIEBREAKER_STRATEGY_CAPACITY_WEIGHTED_RANDOM',
  TIEBREAKER_STRATEGY_UNSPECIFIED = 'TIEBREAKER_STRATEGY_UNSPECIFIED'
}

export type OdProtosOperatorServices_UpdateCoveragePodRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  /** null if not updated */
  name?: InputMaybe<Scalars['String']['input']>;
  /** null if not updated */
  newOperatorTokens?: InputMaybe<OdProtosOperatorServices_UpdateCoveragePodRequest_OperatorTokensInput>;
};

/** Human tokens */
export type OdProtosOperatorServices_UpdateCoveragePodRequest_OperatorTokensInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_WorkAssignmentConfigFilterInput = {
  /** Filter out configurations of operators who no longer work with Opendoor */
  excludeDeactivatedOperatorConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Market restrictions */
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  /**
   * all configurations of operators in list, or all operators
   * in reporting hierarchy of given manager
   */
  operatorFilter?: InputMaybe<OdProtosOperatorServices_WorkAssignmentConfigFilter_OperatorFilterOneofInput>;
  /** Region restrictions - region identifiers from Fence */
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of work */
  workCategories?: InputMaybe<Array<OdProtosOperatorData_WorkCategory>>;
};

export type OdProtosOperatorServices_WorkAssignmentConfigFilter_HumanTokensInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOperatorServices_WorkAssignmentConfigFilter_OperatorFilterOneofInput = {
  humanTokens?: InputMaybe<OdProtosOperatorServices_WorkAssignmentConfigFilter_HumanTokensInput>;
  managerToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosOstiaryServices_CheckRiskProhibitedRegionRequestInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosOstiaryServices_CheckRiskProhibitedRegionResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosOutreachData_OrvaSchedulingOutcomeType {
  LEFT_VM_OR_TEXT = 'LEFT_VM_OR_TEXT',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  NOT_INTERESTED = 'NOT_INTERESTED',
  NO_ANSWER = 'NO_ANSWER',
  ORVA_COMPLETED = 'ORVA_COMPLETED',
  ORVA_SCHEDULED = 'ORVA_SCHEDULED',
  SKIPPED = 'SKIPPED',
  UNKNOWN = 'UNKNOWN',
  VERBALLY_AGREED_TO_SSVA = 'VERBALLY_AGREED_TO_SSVA'
}

export type OdProtosOutreachServices_GetNextOutreachRequestInput = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOutreachServices_GetOutcomesCountSinceRequestInput = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOutreachServices_PaginatedUserOutreachesRequestInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosOutreachServices_RecordOutreachOutcomeRequestInput = {
  outcomeType?: InputMaybe<OdProtosOutreachServices_RecordOutreachOutcomeRequest_OutcomeTypeOneofInput>;
  outreachId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOutreachServices_RecordOutreachOutcomeRequest_OutcomeTypeOneofInput = {
  orvaSchedulingOutcomeType?: InputMaybe<OdProtosOutreachData_OrvaSchedulingOutcomeType>;
};

export type OdProtosOxOxCommsData_AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosCommonState_State>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosOxOxCommsData_Communication_CommunicationType {
  PHONE_CALL = 'PHONE_CALL',
  SMS_MESSAGE = 'SMS_MESSAGE',
  UNKNOWN_COMMUNICATION_TYPE = 'UNKNOWN_COMMUNICATION_TYPE'
}

export enum OdProtosOxOxCommsData_Communication_Direction {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
  UNKNOWN_DIRECTION = 'UNKNOWN_DIRECTION'
}

export type OdProtosOxOxCommsData_ContactInput = {
  address?: InputMaybe<OdProtosOxOxCommsData_AddressInput>;
  association?: InputMaybe<OdProtosOxOxCommsData_Contact_Association>;
  company?: InputMaybe<Scalars['String']['input']>;
  emailAddresses?: InputMaybe<Array<OdProtosOxOxCommsData_EmailAddressInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gongUserId?: InputMaybe<Scalars['String']['input']>;
  /** not using a foreign key to Directory here because we are decoupling from Web */
  humanToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mlsIds?: InputMaybe<Array<OdProtosBrokeragesData_MlsidInput>>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumbers?: InputMaybe<Array<OdProtosOxOxCommsData_PhoneNumberInput>>;
  realEstateLicenses?: InputMaybe<Array<OdProtosBrokeragesData_RealEstateLicenseInput>>;
  slackId?: InputMaybe<Scalars['String']['input']>;
  voicemailGreetingRecordingId?: InputMaybe<Scalars['String']['input']>;
};

/** which party does this Contact represent? */
export enum OdProtosOxOxCommsData_Contact_Association {
  /** OX employee */
  EMPLOYEE = 'EMPLOYEE',
  /** non-OX Opendoor employee */
  OPENDOOR = 'OPENDOOR',
  /** REIT partner */
  PARTNER = 'PARTNER',
  /** any 3rd party involved in a transaction */
  THIRD_PARTY = 'THIRD_PARTY',
  UNKNOWN_ASSOCIATION = 'UNKNOWN_ASSOCIATION'
}

export type OdProtosOxOxCommsData_EmailAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  brokerageRegionIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  emailAddressType?: InputMaybe<OdProtosOxOxCommsData_EmailAddress_EmailAddressType>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosOxOxCommsData_EmailAddress_EmailAddressType {
  PERSONAL = 'PERSONAL',
  UNKNOWN_EMAIL_ADDRESS_TYPE = 'UNKNOWN_EMAIL_ADDRESS_TYPE',
  WORK = 'WORK'
}

export enum OdProtosOxOxCommsData_PhoneCall_Status {
  /** caller received a busy signal */
  BUSY = 'BUSY',
  /** call was answered and has ended normally */
  COMPLETED = 'COMPLETED',
  /** call could not be completed as dialed, most likely because the phone number was non-existent */
  FAILED = 'FAILED',
  /** call has been initiated but is not yet in progress */
  INITIATED = 'INITIATED',
  /** call was answered and is currently in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** there was no answer or the call was rejected */
  NO_ANSWER = 'NO_ANSWER',
  /** call is ready and waiting in line before dialing */
  QUEUED = 'QUEUED',
  /** call is currently ringing */
  RINGING = 'RINGING',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type OdProtosOxOxCommsData_PhoneNumberInput = {
  brokerageRegionIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** formatted in US format, e.g. (415) 555-2671 */
  formattedNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** must always be in E.164 format, e.g. +14155552671 */
  number?: InputMaybe<Scalars['String']['input']>;
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<OdProtosOxOxCommsData_PhoneNumber_PhoneNumberType>;
};

export enum OdProtosOxOxCommsData_PhoneNumber_PhoneNumberType {
  /** market number provided by Twilio */
  MARKET = 'MARKET',
  PERSONAL = 'PERSONAL',
  UNKNOWN_PHONE_NUMBER_TYPE = 'UNKNOWN_PHONE_NUMBER_TYPE',
  WORK = 'WORK'
}

export enum OdProtosOxOxCommsData_SmsMessage_Status {
  /** Twilio has received your API request to immediately send an outbound message */
  ACCEPTED = 'ACCEPTED',
  /** the message was scheduled to be sent at a later time but was canceled. */
  CANCELED = 'CANCELED',
  /** Twilio has received confirmation of outbound message delivery from the upstream carrier, and, where available, the destination handset */
  DELIVERED = 'DELIVERED',
  /** the outbound message failed to send */
  FAILED = 'FAILED',
  /** the message was created but sending is not yet in progress */
  INITIATED = 'INITIATED',
  /** the Twilio API request to send a message was successful and the message is queued to be sent out */
  QUEUED = 'QUEUED',
  /** the message was received */
  RECEIVED = 'RECEIVED',
  /** the inbound message was received by Twilio and is currently being processed */
  RECEIVING = 'RECEIVING',
  /** the message has been scheduled to be sent at a later time */
  SCHEDULED = 'SCHEDULED',
  /** Twilio is dispatching the outbound message to the nearest upstream carrier in the network */
  SENDING = 'SENDING',
  /** the nearest upstream carrier accepted the outbound message */
  SENT = 'SENT',
  /** Twilio received a delivery receipt indicating that the outbound message was not delivered */
  UNDELIVERED = 'UNDELIVERED',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type OdProtosOxOxCommsServices_CreateContactRequestInput = {
  /** authorize transfer of phone numbers/email addresses from another contact to this one */
  authorizeTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<OdProtosOxOxCommsData_ContactInput>;
};

export type OdProtosOxOxCommsServices_DeleteContactRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_GetCommunicationsForContactRequestInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OdProtosOxOxCommsServices_GetCommunicationsForContactRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosOxOxCommsServices_GetCommunicationsForContactRequest_FiltersInput = {
  /** choose SMS or phone call. If not set, all types are returned */
  communicationType?: InputMaybe<OdProtosOxOxCommsData_Communication_CommunicationType>;
  /** if set, only communications between the currently viewed contact and the participant are returned */
  participantContactId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_GetCommunicationsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOxOxCommsServices_GetContactByEmailAddressRequestInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_GetContactRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_GetContactsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** returns all contacts that have communicated with the participant */
export type OdProtosOxOxCommsServices_GetParticipantContactsRequestInput = {
  participantContactId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_GetRecordingsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosOxOxCommsServices_MakePhoneCallRequestInput = {
  /** this will be the PhoneCall id */
  id?: InputMaybe<Scalars['String']['input']>;
  recipientPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
  /** must be a display (aka market) number */
  senderPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_RecordVoicemailGreetingRequestInput = {
  /** the contact to record a new voicemail greeting for */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** this will be the id of the PhoneCall used to record the greeting */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_SearchContactsRequestInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_SendSmsMessageRequestInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** this will be the SmsMessage id */
  id?: InputMaybe<Scalars['String']['input']>;
  recipientPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
  /** must be a display (aka market) number */
  senderPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxCommsServices_UpdateContactRequestInput = {
  /** authorize transfer of phone numbers/email addresses from another contact to this one */
  authorizeTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<OdProtosOxOxCommsData_ContactInput>;
  fieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  /** merge this contact into the updated contact */
  mergeInContactId?: InputMaybe<Scalars['String']['input']>;
};

/** This will move to a common ox location in the future */
export type OdProtosOxOxUsersData_OxNameInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Permissions */
export enum OdProtosOxOxUsersData_Permissions {
  ADMIN = 'ADMIN',
  ADVANCED_UI_FEATURES = 'ADVANCED_UI_FEATURES',
  AGENT_OPERATOR_READ = 'AGENT_OPERATOR_READ',
  AGENT_OPERATOR_WRITE = 'AGENT_OPERATOR_WRITE',
  API_DOCUMENTATION_READ = 'API_DOCUMENTATION_READ',
  BUYBOX_READ = 'BUYBOX_READ',
  BUYBOX_WRITE = 'BUYBOX_WRITE',
  ELIGIBLE_PRODUCTS_READ = 'ELIGIBLE_PRODUCTS_READ',
  ELIGIBLE_PRODUCTS_WRITE = 'ELIGIBLE_PRODUCTS_WRITE',
  KEY_TERMS_READ = 'KEY_TERMS_READ',
  KEY_TERMS_WRITE = 'KEY_TERMS_WRITE',
  MANUAL_BID_UPLOAD_READ = 'MANUAL_BID_UPLOAD_READ',
  MANUAL_BID_UPLOAD_WRITE = 'MANUAL_BID_UPLOAD_WRITE',
  MLS_READ = 'MLS_READ',
  PARTICIPANTS_READ = 'PARTICIPANTS_READ',
  PARTICIPANTS_WRITE = 'PARTICIPANTS_WRITE',
  PIPELINE_READ = 'PIPELINE_READ',
  PIPELINE_WRITE = 'PIPELINE_WRITE',
  RESALE_READ = 'RESALE_READ',
  RESALE_WRITE = 'RESALE_WRITE',
  SETTINGS_READ = 'SETTINGS_READ',
  SETTINGS_WRITE = 'SETTINGS_WRITE',
  TASK_CONFIG_READ = 'TASK_CONFIG_READ',
  TASK_CONFIG_WRITE = 'TASK_CONFIG_WRITE',
  TASK_READ = 'TASK_READ',
  TASK_WRITE = 'TASK_WRITE',
  UNKNOWN_PERMISSION = 'UNKNOWN_PERMISSION'
}

export type OdProtosOxOxUsersServices_AddMemberRequestInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roleTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_AddOrganizationRoleRequestInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  roleType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxUsersServices_CreateOrganizationRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryContactEmail?: InputMaybe<Scalars['String']['input']>;
  primaryContactFirstName?: InputMaybe<Scalars['String']['input']>;
  primaryContactLastName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxUsersServices_CreateUserRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxUsersServices_GetOrganizationByIdRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxUsersServices_GetOrganizationsByEmailRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxUsersServices_GetUserByEmailRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxUsersServices_GetUserByIdRequestInput = {
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_GetUserEventsRequestInput = {
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_RemoveMemberRequestInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_RemoveOrganizationRoleRequestInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roleType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxUsersServices_UpdateMemberRolesRequestInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roleTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_UpdateOrganizationRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  updates?: InputMaybe<OdProtosOxOxUsersServices_UpdateOrganizationRequest_UpdatesInput>;
};

export type OdProtosOxOxUsersServices_UpdateOrganizationRequest_UpdatesInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryContactId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_UpdateOrganizationRoleRequestInput = {
  roleId?: InputMaybe<Scalars['String']['input']>;
  updates?: InputMaybe<OdProtosOxOxUsersServices_UpdateOrganizationRoleRequest_UpdatesInput>;
};

export type OdProtosOxOxUsersServices_UpdateOrganizationRoleRequest_UpdatesInput = {
  permissions?: InputMaybe<Array<OdProtosOxOxUsersData_Permissions>>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  roleType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosOxOxUsersServices_UpdateUserRequestInput = {
  id?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
  updates?: InputMaybe<OdProtosOxOxUsersServices_UpdateUserRequest_UpdatesInput>;
};

export type OdProtosOxOxUsersServices_UpdateUserRequest_UpdatesInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The billing type determines when final payment eligibility is reported and payouts are made
 * Next ID: 3
 */
export enum OdProtosPartnershipData_BillingType {
  /** Billed via a monthly invoicing process */
  INVOICE = 'INVOICE',
  /** Billed on as part of transaction closing process */
  PER_TRANSACTION = 'PER_TRANSACTION',
  UNKNOWN_BILLING_TYPE = 'UNKNOWN_BILLING_TYPE'
}

/** Delivery parameters for a future offer */
export type OdProtosPartnershipData_CommunicationDetailsInput = {
  /**
   * Specifies the time the offer should be delivered to the customer.
   * Specified in milliseconds of UTC time since Unix epoch.
   */
  offerDeliveryTime?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * References contact information for a customer or partner.
 * Next ID: 5
 */
export type OdProtosPartnershipData_CustomerDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * DirectoryOrg defines the fields and children orgs needed to create an org in the Directory service.
 * It also included metadata tracked by the partnership service
 *
 * Next ID: 5
 */
export type OdProtosPartnershipData_DirectoryOrgInput = {
  /** Immediate children of this organization */
  children?: InputMaybe<Array<OdProtosPartnershipData_DirectoryOrgInput>>;
  /** Required to create an org in the Directory service */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Metadata that is provided for the leaf nodes of the organization hierarchy */
  metadata?: InputMaybe<OdProtosPartnershipData_MetadataInput>;
  /** Relevant name at the given partner organization hierarchy level */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export enum OdProtosPartnershipData_DocumentType {
  INVOICE_DOCUMENT_TYPE = 'INVOICE_DOCUMENT_TYPE',
  UNKNOWN_DOCUMENT_TYPE = 'UNKNOWN_DOCUMENT_TYPE'
}

/** Next ID: 2 */
export enum OdProtosPartnershipData_InboundBuyerReferral_Source {
  PARTNER_LISTING_LINK = 'PARTNER_LISTING_LINK',
  PARTNER_PRELISTED_LINK = 'PARTNER_PRELISTED_LINK',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 2 */
export enum OdProtosPartnershipData_LoyaltyEvent_EventType {
  /** Used for an event associated with an offer close */
  OFFER_CLOSE = 'OFFER_CLOSE',
  UNKNOWN_EVENT_TYPE = 'UNKNOWN_EVENT_TYPE'
}

/** Next ID: 3 */
export enum OdProtosPartnershipData_LoyaltyEvent_Source {
  /** Used for an event associated with an acquisition offer */
  ACQUISITION_OFFER = 'ACQUISITION_OFFER',
  /** Used for an event associated with a resale offer */
  RESALE_OFFER = 'RESALE_OFFER',
  UNKNOWN_EVENT_SOURCE = 'UNKNOWN_EVENT_SOURCE'
}

/**
 * Metadata contains various additional details about a DirectoryOrg that the partnership service tracks
 *
 * Next ID: 5
 */
export type OdProtosPartnershipData_MetadataInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible sources of an offer request
 * Next ID: 4
 */
export enum OdProtosPartnershipData_Offer_Source {
  CUSTOMER = 'CUSTOMER',
  PARTNER = 'PARTNER',
  SYSTEM = 'SYSTEM',
  UNKNOWN_OFFER_SOURCE = 'UNKNOWN_OFFER_SOURCE'
}

/**
 * Specifies the current state of an outbound buyer referral tour request
 * Next ID: 6
 */
export enum OdProtosPartnershipData_OutboundBuyerReferralTourRequest_State {
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  NO_SHOW = 'NO_SHOW',
  REQUESTED = 'REQUESTED',
  SCHEDULED = 'SCHEDULED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/**
 * Specifies the current state of an outbound buyer referral
 * Next ID: 6
 */
export enum OdProtosPartnershipData_OutboundBuyerReferral_State {
  CLOSED = 'CLOSED',
  INTERESTED = 'INTERESTED',
  IN_CONTRACT = 'IN_CONTRACT',
  NOT_MOVING_FORWARD = 'NOT_MOVING_FORWARD',
  TOURING = 'TOURING',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/** Next ID: 9 */
export type OdProtosPartnershipData_PartnerBranchInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  internalOrganizationId?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  salesAssociateEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 7 */
export type OdProtosPartnershipData_PartnerBranchMemberInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  partnerBranchUuid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Seller input that is coming from an external partner.
 * Next ID: 10
 */
export type OdProtosPartnershipData_PartnerSellerInputInput = {
  /** Details about the home that are not included in protobuf/home-data-store/home_detail.proto */
  additionalHomeDetails?: InputMaybe<OdProtosHomeDataStore_PartnershipAdditionalHomeDetailsInput>;
  /** Casa address of the property */
  casaAddress?: InputMaybe<OdProtosCasaData_AddressInput>;
  /** Specifies some communication parameters */
  communicationDetails?: InputMaybe<OdProtosPartnershipData_CommunicationDetailsInput>;
  /** Details about the home */
  homeDetails?: InputMaybe<OdProtosHomeDataStore_HomeDetailInput>;
  /** Specifies details of seller */
  inputSellerDetails?: InputMaybe<OdProtosPartnershipData_SellerDetailsInput>;
  /** Identifier of the partner */
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Contact information for referring party */
  referrerDetails?: InputMaybe<OdProtosPartnershipData_CustomerDetailsInput>;
  /**
   * Contact information for seller
   * Being deprecated in favor of CustomerDetails embedded in
   * input_seller_details field.
   */
  sellerDetails?: InputMaybe<OdProtosPartnershipData_CustomerDetailsInput>;
  /** Specifies the source of the referral for this seller input */
  source?: InputMaybe<OdProtosPartnershipData_Referral_Source>;
};

/** Next ID: 10 */
export type OdProtosPartnershipData_PartnerUserInput = {
  /** Email -- Their existing email with their company */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First Name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The directory user token if one exists */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Last Name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** identifer of partner user is associated with ("" for independent user) */
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The region identifier for the market that this user operates in */
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Roles to assign to Membership */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * References the relationship between an Opendoor and the partner.
 * Next ID: 15
 */
export enum OdProtosPartnershipData_PartnershipType {
  AGENT_BROKERAGE = 'AGENT_BROKERAGE',
  AGENT_TECH_INTEGRATION = 'AGENT_TECH_INTEGRATION',
  CORPORATE_BENEFITS = 'CORPORATE_BENEFITS',
  CREDIT_AND_DEBT = 'CREDIT_AND_DEBT',
  HOME_BUILDER = 'HOME_BUILDER',
  INDEPENDENT_DEVELOPER = 'INDEPENDENT_DEVELOPER',
  LENDER = 'LENDER',
  MARKETING = 'MARKETING',
  MLS = 'MLS',
  ONLINE_REAL_ESTATE = 'ONLINE_REAL_ESTATE',
  /** used as a catch-all partnership type */
  OTHERS = 'OTHERS',
  REAL_ESTATE_AGENCY = 'REAL_ESTATE_AGENCY',
  REIT = 'REIT',
  /** used internally only for creating test partners */
  TEST_PARTNER = 'TEST_PARTNER',
  UNKNOWN = 'UNKNOWN'
}

/**
 * The payable conditions determine which conditions must be met in order for the referral to be payable to the partner.
 * Next ID: 9
 */
export enum OdProtosPartnershipData_PayableConditions {
  CHECK_FOR_ASSOCIATED_AGENT = 'CHECK_FOR_ASSOCIATED_AGENT',
  CHECK_FOR_ASSOCIATED_API_PARTNER = 'CHECK_FOR_ASSOCIATED_API_PARTNER',
  /** @deprecated No longer supported */
  CHECK_FOR_ASSOCIATED_ORE = 'CHECK_FOR_ASSOCIATED_ORE',
  CUSTOMER_MATCH = 'CUSTOMER_MATCH',
  EMAIL_MATCH = 'EMAIL_MATCH',
  HANDOVER_BEFORE_OFFER_VIEWED = 'HANDOVER_BEFORE_OFFER_VIEWED',
  REFERRAL_INITIATED_AT_HANDOVER = 'REFERRAL_INITIATED_AT_HANDOVER',
  TWO_WEEK_ELIGIBILITY_LOCK = 'TWO_WEEK_ELIGIBILITY_LOCK',
  UNKNOWN_PAYABLE_CONDITION = 'UNKNOWN_PAYABLE_CONDITION'
}

/**
 * A payable conversion event that we might pay partners for
 * Next ID: 7
 */
export enum OdProtosPartnershipData_PayableEvent {
  ACQ_CLOSED_WITH_RESALE = 'ACQ_CLOSED_WITH_RESALE',
  AGENT_ACCESS_BONUS = 'AGENT_ACCESS_BONUS',
  CLOSED_SALE = 'CLOSED_SALE',
  OFFER_VIEWED = 'OFFER_VIEWED',
  QUALIFIED_LEAD = 'QUALIFIED_LEAD',
  RESALE_CLOSED_SALE = 'RESALE_CLOSED_SALE',
  UNKNOWN_EVENT = 'UNKNOWN_EVENT'
}

/**
 * A payment agreement models a payment contract terms established with a given partner
 * Next ID: 26
 */
export type OdProtosPartnershipData_PaymentAgreementInput = {
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  activatedBy?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  billingType?: InputMaybe<OdProtosPartnershipData_BillingType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  payableConditions?: InputMaybe<Array<OdProtosPartnershipData_PayableConditions>>;
  payableEvent?: InputMaybe<OdProtosPartnershipData_PayableEvent>;
  paymentAgreementTiers?: InputMaybe<Array<OdProtosPartnershipData_PaymentAgreementTierInput>>;
  paymentType?: InputMaybe<OdProtosPartnershipData_PaymentType>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sendCommissionInstruction?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<OdProtosPartnershipData_PaymentAgreement_State>;
  termConversionWindowDays?: InputMaybe<Scalars['Float']['input']>;
  termPayOnDetachedLead?: InputMaybe<Scalars['Boolean']['input']>;
  termPreviousRequestDays?: InputMaybe<Scalars['Float']['input']>;
  termUniqueLeadType?: InputMaybe<OdProtosPartnershipData_UniqueLeadType>;
  tierType?: InputMaybe<OdProtosPartnershipData_TierType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A payment agreement tier includes the payout details for a given payment agreement
 * Next ID: 11
 */
export type OdProtosPartnershipData_PaymentAgreementTierInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPoints?: InputMaybe<Scalars['Float']['input']>;
  paymentAgreementUuid?: InputMaybe<Scalars['String']['input']>;
  paymentFlatRate?: InputMaybe<Scalars['Float']['input']>;
  paymentPercentageBasis?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  tierCondition?: InputMaybe<OdProtosPartnershipData_TierCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export enum OdProtosPartnershipData_PaymentAgreement_State {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Reason why a referral payment is or is not payable
 * Next ID: 22
 */
export enum OdProtosPartnershipData_PaymentEligibilityReason {
  AGENT_ATTRIBUTION_AFTER_FINAL_OFFER = 'AGENT_ATTRIBUTION_AFTER_FINAL_OFFER',
  ALL_CHECKS_PASSED = 'ALL_CHECKS_PASSED',
  ALREADY_PAID = 'ALREADY_PAID',
  CUSTOMER_MATCH_FAILED = 'CUSTOMER_MATCH_FAILED',
  DETACHED_LEAD = 'DETACHED_LEAD',
  ELA_TAKEBACK = 'ELA_TAKEBACK',
  EMAIL_MATCH_FAILED = 'EMAIL_MATCH_FAILED',
  INELIGIBLE_ASSOCIATED_AGENT = 'INELIGIBLE_ASSOCIATED_AGENT',
  IS_HOMEOWNER = 'IS_HOMEOWNER',
  IS_LISTED = 'IS_LISTED',
  OD_DIRECT_PYMT_INELIGIBLE_IN_SELL_WITH_UPSIDE = 'OD_DIRECT_PYMT_INELIGIBLE_IN_SELL_WITH_UPSIDE',
  OFFER_NOT_VIEWED = 'OFFER_NOT_VIEWED',
  OFFER_WITHDRAWN = 'OFFER_WITHDRAWN',
  OUTSIDE_CONVERSION_WINDOW = 'OUTSIDE_CONVERSION_WINDOW',
  OVERRIDDEN = 'OVERRIDDEN',
  PREVIOUS_OFFER_REQUEST = 'PREVIOUS_OFFER_REQUEST',
  RECENT_DELISTED_ADDRESS = 'RECENT_DELISTED_ADDRESS',
  REFERRAL_HANDOVER_NOT_BEFORE_VIEW = 'REFERRAL_HANDOVER_NOT_BEFORE_VIEW',
  REFERRAL_NOT_ACCEPTED = 'REFERRAL_NOT_ACCEPTED',
  UNENROLLED_SELL_WITH_UPSIDE = 'UNENROLLED_SELL_WITH_UPSIDE',
  UNKNOWN_REASON = 'UNKNOWN_REASON'
}

/**
 * The payment type determines how a referral payment value should be calculated
 * Next ID: 7
 */
export enum OdProtosPartnershipData_PaymentType {
  /** For SwU, we pay a flat fee and percentage of cash advance */
  COMBINED_FLAT_AND_PERCENT_OF_SWU = 'COMBINED_FLAT_AND_PERCENT_OF_SWU',
  /** Flat fee paid on a given lead's conversion event */
  FLAT = 'FLAT',
  /** In the case of closed_sale, we pay 1-1.5% of headline price */
  PERCENT_OF_HEADLINE = 'PERCENT_OF_HEADLINE',
  /** In the case of SwU offer closed, we pay on percentage of cash advance */
  PERCENT_OF_HEADLINE_OR_SWU_ADVANCE = 'PERCENT_OF_HEADLINE_OR_SWU_ADVANCE',
  /** In the case of resale closed, we pay on percentage of closed listing offer */
  PERCENT_OF_RESALE_PRICE = 'PERCENT_OF_RESALE_PRICE',
  /** Percentage of SWU projected resale sales price */
  PERCENT_OF_SWU_RESALE_PRICE = 'PERCENT_OF_SWU_RESALE_PRICE',
  UNKNOWN_PAYMENT_TYPE = 'UNKNOWN_PAYMENT_TYPE'
}

/**
 * Acceptance status of a referral invitation by the invitee
 *
 * Next ID: 3
 */
export enum OdProtosPartnershipData_ReferralInvitationAcceptanceStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING'
}

/** Next ID: 4 */
export enum OdProtosPartnershipData_ReferralPayment_Source {
  /** The default source used on records created by default process */
  DEFAULT = 'DEFAULT',
  /** Used on records created from initial backfill of payment data into partnership db */
  INITIAL_BACKFILL = 'INITIAL_BACKFILL',
  /** Used on records the are modified manually by eng or ops */
  MANUAL_OVERRIDE = 'MANUAL_OVERRIDE',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE'
}

/** Next ID: 4 */
export enum OdProtosPartnershipData_ReferralPayment_State {
  /** Used once a payable (conversion) event has occured */
  CONVERTED = 'CONVERTED',
  /** Used after referral_payment record is created, for most payable events this state is transitory */
  PROJECTED = 'PROJECTED',
  /** Transitions to reported state after a billing report is generated or a transaction closes, depending on billing type */
  REPORTED = 'REPORTED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/**
 * Attributes contains additional information regarding a referral. Intended to store
 * details and fields that might be subject to change.
 *
 * Next ID: 15
 */
export type OdProtosPartnershipData_Referral_AttributesInput = {
  /** Whether agent is attributed to referral prior to final offer */
  agentAttributedByFinalOffer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Real estate license, used for agent referrals */
  agentRealEstateLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Real estate license state, used for agent referrals */
  agentRealEstateLicenseState?: InputMaybe<Scalars['String']['input']>;
  /** Brokerage address, used for agent referrals */
  brokerageAddress?: InputMaybe<Scalars['String']['input']>;
  /** Brokerage name, used for agent referrals */
  brokerageName?: InputMaybe<Scalars['String']['input']>;
  /** Time an attempt to update the ELA action was made */
  elaActionUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  /** Time an ELA assignment was passed back to the partner */
  elaPassbackDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Token of the external listing associated with the referral */
  elaResaleFlipToken?: InputMaybe<Scalars['String']['input']>;
  /** Time an ELA assignment was taken back from the partner */
  elaTakebackDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tracks whether the referral is eligible for a agent referral payment. Not intended to track referral payments generally. */
  eligibleForAgentReferralPayment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time the offer was requested using the partner API */
  offerRequestedAt?: InputMaybe<Scalars['String']['input']>;
  /** Used to store the name of the other_builder partner when provided by the customer. */
  otherBuilderName?: InputMaybe<Scalars['String']['input']>;
  /** Tracks whether the referral has been handed over from a partner's site for the purposes of payment eligibility */
  referralHandoverOccurredAt?: InputMaybe<Scalars['String']['input']>;
  /** Used to store a sales associate email provided by a customer when the sales associate does not yet have a human record */
  unknownSalesAssociateEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of webhook sent at timestamps */
  webhooksSentAt?: InputMaybe<Array<OdProtosPartnershipData_Referral_Attributes_WebhookSentAtInput>>;
};

/** Next ID: 3 */
export type OdProtosPartnershipData_Referral_Attributes_WebhookSentAtInput = {
  eventName?: InputMaybe<Scalars['String']['input']>;
  webhookSentAt?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Exact attribution for this referral, i.e. referral type.
 *
 * Next ID: 3
 */
export enum OdProtosPartnershipData_Referral_AttributionType {
  REFERRAL = 'REFERRAL',
  /** can add other attribution types in the future like NO_ATTRIBUTION or REPRESENTATION_NO_REFERRAL */
  REPRESENTATION = 'REPRESENTATION',
  UNKNOWN_ATTRIBUTION = 'UNKNOWN_ATTRIBUTION'
}

/** Next ID: 6 */
export enum OdProtosPartnershipData_Referral_SellerRelation {
  /** The seller is a client of the referrer */
  CLIENT = 'CLIENT',
  /** The seller is a prospective client of the referrer */
  POTENTIAL_CLIENT = 'POTENTIAL_CLIENT',
  /** The seller is not represented by referrer. Is only being referred */
  REFEREE = 'REFEREE',
  /** the seller is being referred by invitation to Opendoor by the referrer. */
  REFERRAL_BY_INVITATION = 'REFERRAL_BY_INVITATION',
  /** The referring party is representing themselves */
  SELF = 'SELF',
  UNKNOWN_RELATION = 'UNKNOWN_RELATION'
}

/** Next ID: 10 */
export enum OdProtosPartnershipData_Referral_Source {
  ADMIN_OVERRIDE = 'ADMIN_OVERRIDE',
  DETACHED_LEAD = 'DETACHED_LEAD',
  PARTNER_API = 'PARTNER_API',
  REFERRAL_DASHBOARD = 'REFERRAL_DASHBOARD',
  REFERRAL_LINK = 'REFERRAL_LINK',
  SCRIPT = 'SCRIPT',
  SELLER_DISCLOSURES = 'SELLER_DISCLOSURES',
  SELLER_FLOW = 'SELLER_FLOW',
  TRACKING_KEYWORD = 'TRACKING_KEYWORD',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 4 */
export enum OdProtosPartnershipData_Report_State {
  /** The report is failed to be generated */
  FAILED = 'FAILED',
  /** The report is still in process of generating */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The report has successfully been generated and ready for download */
  READY_TO_DOWNLOAD = 'READY_TO_DOWNLOAD',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 13 */
export type OdProtosPartnershipData_ReportingSearchFiltersInput = {
  /** Search for leads with this casa address uuid */
  addressId?: InputMaybe<Scalars['String']['input']>;
  /** This will be used to build the search_after field in the next query */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The direcion of the sort oder: 'asc' or 'desc' */
  direction?: InputMaybe<OdProtosPartnershipData_ReportingSearchFilters_Direction>;
  /** Search for leads created before the end_date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The field to order the results by */
  orderBy?: InputMaybe<OdProtosPartnershipData_ReportingSearchFilters_OrderBy>;
  /** Search for leads that match any of these markets */
  regionIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search for leads with referrals that have a referrer with this user id */
  salesReferrerUserId?: InputMaybe<Scalars['String']['input']>;
  /** The text search query to fuzzy match against address, customer, and sales referrer */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Will be passed as the `size` parameter in the elastic search query */
  size?: InputMaybe<Scalars['Float']['input']>;
  /** Search for leads created after the start_date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Search for leads that match any of these lead states */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search for leads that have been updated at any time since updated_since */
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * The options for sort direction
 * Next ID: 2
 */
export enum OdProtosPartnershipData_ReportingSearchFilters_Direction {
  ASC = 'ASC',
  DESC = 'DESC'
}

/**
 * The options for ordering sorted results
 * Next ID: 6
 */
export enum OdProtosPartnershipData_ReportingSearchFilters_OrderBy {
  CUSTOMER_NAME = 'CUSTOMER_NAME',
  LEAD_CREATED = 'LEAD_CREATED',
  OFFER_SENT = 'OFFER_SENT',
  PARTNER_DISPLAY_NAME = 'PARTNER_DISPLAY_NAME',
  REGION_IDENTIFIER = 'REGION_IDENTIFIER',
  SALES_REFERRER = 'SALES_REFERRER'
}

/**
 * Seller details for a given transaction.
 * Can represent one of a number of parties defined by relation fields.
 * Next ID: 4
 */
export type OdProtosPartnershipData_SellerDetailsInput = {
  agentRelationToSeller?: InputMaybe<OdProtosPartnershipData_SellerDetails_AgentRelationToSeller>;
  customerContactDetails?: InputMaybe<OdProtosPartnershipData_CustomerDetailsInput>;
  sellerRelationToOwner?: InputMaybe<OdProtosPartnershipData_SellerDetails_SellerRelationToOwner>;
};

export enum OdProtosPartnershipData_SellerDetails_AgentRelationToSeller {
  AGENT_SELF = 'AGENT_SELF',
  CLIENT = 'CLIENT',
  POTENTIAL_CLIENT = 'POTENTIAL_CLIENT',
  REFEREE = 'REFEREE',
  UNKNOWN_AGENT_RELATION = 'UNKNOWN_AGENT_RELATION'
}

export enum OdProtosPartnershipData_SellerDetails_SellerRelationToOwner {
  AGENT = 'AGENT',
  SELLER_SELF = 'SELLER_SELF',
  UNKNOWN_SELLER_RELATION = 'UNKNOWN_SELLER_RELATION'
}

/**
 * The tier condition is the condition that be met in order for the referral to be eligible for that payment agreement tier.
 * Next ID: 7
 */
export enum OdProtosPartnershipData_TierCondition {
  AGENT_REPRESENTED = 'AGENT_REPRESENTED',
  AGENT_UNREPRESENTED = 'AGENT_UNREPRESENTED',
  ELA_ASSIGNED = 'ELA_ASSIGNED',
  ELA_UNASSIGNED = 'ELA_UNASSIGNED',
  ENROLLED_SELL_WITH_UPSIDE = 'ENROLLED_SELL_WITH_UPSIDE',
  NOT_ENROLLED_SELL_WITH_UPSIDE = 'NOT_ENROLLED_SELL_WITH_UPSIDE',
  NO_CONDITION = 'NO_CONDITION'
}

/**
 * The tier type determines the type of payment agreement tier and how to evaluate which active payment_agreement_tier to use
 * Next ID: 7
 */
export enum OdProtosPartnershipData_TierType {
  AGENT_ACCESS_TIER = 'AGENT_ACCESS_TIER',
  /** tier depends on whether the buyer is represented */
  BUYER_REPRESENTATION_TIER = 'BUYER_REPRESENTATION_TIER',
  /** tier depends on whether there is an active partner ELA attached to the referral */
  ELA_TIER = 'ELA_TIER',
  /** tier depends on which market the partner is in */
  MARKET_TIER = 'MARKET_TIER',
  NO_TIER_TYPE = 'NO_TIER_TYPE',
  /** tier depends on how many closed offers the partner has */
  OFFER_CLOSED_COUNT_TIER = 'OFFER_CLOSED_COUNT_TIER',
  /** tier depends on whether enrolled in SwU */
  SWU_TIER = 'SWU_TIER'
}

/**
 * States for underwriting
 * Next ID: 6
 */
export enum OdProtosPartnershipData_Underwriting_State {
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  ESCALATED = 'ESCALATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE',
  WALKED = 'WALKED'
}

/**
 * The unique lead type determines which duplicate payment rule is used in the eligibility process
 * Next ID: 2
 */
export enum OdProtosPartnershipData_UniqueLeadType {
  ADDRESS = 'ADDRESS',
  NONE = 'NONE'
}

/** Next ID: 2 */
export type OdProtosPartnershipServices_AcceptReferralInvitationRequestInput = {
  invitationId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ActivatePaymentAgreementRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ActivatePaymentAgreementTierRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ArchivePaymentAgreementRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_AuthenticatePartnerByTokenRequestInput = {
  /** Auth token that uniquely identifies a partner */
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_BulkCreatePartnerUsersRequestInput = {
  /** List of all partner users */
  partnerUsers?: InputMaybe<Array<OdProtosPartnershipData_PartnerUserInput>>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_BulkGetReferralsForSellerInputsRequestInput = {
  sellerInputs?: InputMaybe<Array<OdProtosPartnershipServices_GetReferralsForSellerInputRequestInput>>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_CheckProductsEligibilityRequestInput = {
  /** Casa Address ID */
  addressId?: InputMaybe<Scalars['String']['input']>;
  /** optional -- only needed if checking product eligibility for an external partner */
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Products for which to check eligibility */
  products?: InputMaybe<Array<OdProtosSellCommon_Product>>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_ClaimInboundBuyerReferralsForListingOfferRequestInput = {
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 18 */
export type OdProtosPartnershipServices_CreateOrUpdateReferralForSellerInputRequestInput = {
  /** Optional -- the attributes data on the referral */
  attributes?: InputMaybe<OdProtosPartnershipData_Referral_AttributesInput>;
  /** Mask of attributes fields to update. An empty mask means to update all fields. */
  attributesMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional -- Identifier for an external object in a partner's system */
  externalTrackingId?: InputMaybe<Scalars['String']['input']>;
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- Organization from Directory for this referral */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the partnership associated with this referral */
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Fence region identifier for the address on the seller input */
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * Seller input of the initial related referral for detached lead,
   * e.g. when a referred customer starts a new lead via the core flow.
   */
  rootSellerInputId?: InputMaybe<Scalars['String']['input']>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- Relation the seller has to the referrer */
  sellerRelation?: InputMaybe<OdProtosPartnershipData_Referral_SellerRelation>;
  /** Optional -- Source the referral came from */
  source?: InputMaybe<OdProtosPartnershipData_Referral_Source>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optional -- User email for this referral. Will be used to fetch a user from Directory. If none is found, this field
   * if ignored.
   */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- User from Directory for this referral */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreatePartnerAuthTokenRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_CreatePartnerOrgHierarchyRequestInput = {
  /** List of children for the root organization */
  orgs?: InputMaybe<Array<OdProtosPartnershipData_DirectoryOrgInput>>;
  /** Root node partner identifier */
  rootPartnerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 9 */
export type OdProtosPartnershipServices_CreatePartnerRequestInput = {
  /** Display name of the partner being created */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the partner being created */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Opendoor landing page for partner */
  landingPage?: InputMaybe<Scalars['String']['input']>;
  /** Associated organization from Directory to be updated */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the type of partnership this partner has with Opendoor */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** URL-safe string for partner */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Marketing tracking keyword associated with a partner */
  trackingKeyword?: InputMaybe<Scalars['String']['input']>;
  /** URL for the partner's webhook endpoint */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreatePartnerUserRequestInput = {
  /** The partner user to create */
  partnerUser?: InputMaybe<OdProtosPartnershipData_PartnerUserInput>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreatePaymentAgreementRequestInput = {
  paymentAgreement?: InputMaybe<OdProtosPartnershipData_PaymentAgreementInput>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreatePaymentAgreementTierRequestInput = {
  paymentAgreementTier?: InputMaybe<OdProtosPartnershipData_PaymentAgreementTierInput>;
};

/** Next ID: 14 */
export type OdProtosPartnershipServices_CreateReferralForSellerInputRequestInput = {
  /** The UUID of the address eligibility log to associate to this referral */
  addressEligibilityLogUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- address ID of the referral address */
  addressId?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- Identifier for an external object in a partner's system */
  externalTrackingId?: InputMaybe<Scalars['String']['input']>;
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- Organization from Directory for this referral */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the partnership associated with this referral */
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Fence region identifier for the address on the seller input */
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- Relation the seller has to the referrer */
  sellerRelation?: InputMaybe<OdProtosPartnershipData_Referral_SellerRelation>;
  /** Optional -- Source the referral came from */
  source?: InputMaybe<OdProtosPartnershipData_Referral_Source>;
  /** Optional -- User from Directory for this referral */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 12 */
export type OdProtosPartnershipServices_CreateReferralRequestInput = {
  /** Optional -- Identifier for an external object in a partner's system */
  externalTrackingId?: InputMaybe<Scalars['String']['input']>;
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- Organization from Directory for this referral */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the partnership associated with this referral */
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Type of the partnership this referral is coming from */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Fence region identifier for the address on the seller input */
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- Relation the seller has to the referrer */
  sellerRelation?: InputMaybe<OdProtosPartnershipData_Referral_SellerRelation>;
  /** The source this referral is created from */
  source?: InputMaybe<OdProtosPartnershipData_Referral_Source>;
  /** Optional -- User from Directory for this referral */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_CreateReferralsFromTrackingKeywordsRequestInput = {
  /** Collection of tracking keywords */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** Partner referral ID. */
  partnerReferralId?: InputMaybe<Scalars['String']['input']>;
  /** Region identifier of the referral to create */
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** ID of the seller input */
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosPartnershipServices_CreateReportRequestInput = {
  documentType?: InputMaybe<OdProtosPartnershipData_DocumentType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreateSellRequestRequestInput = {
  partnerSellerInput?: InputMaybe<OdProtosPartnershipData_PartnerSellerInputInput>;
};

/** Next ID: 7 */
export enum OdProtosPartnershipServices_CreateSellRequestResponse_SellRequestError {
  ERROR_CONTACT_INFO = 'ERROR_CONTACT_INFO',
  ERROR_HOME_ADDRESS = 'ERROR_HOME_ADDRESS',
  ERROR_HOME_DETAILS = 'ERROR_HOME_DETAILS',
  ERROR_MISSING_MARKET = 'ERROR_MISSING_MARKET',
  ERROR_MISSING_PARTNER = 'ERROR_MISSING_PARTNER',
  ERROR_NULL = 'ERROR_NULL',
  ERROR_REFERRAL = 'ERROR_REFERRAL'
}

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreateSellerInputRequestInput = {
  partnerSellerInput?: InputMaybe<OdProtosPartnershipData_PartnerSellerInputInput>;
};

/** Next ID: 7 */
export enum OdProtosPartnershipServices_CreateSellerInputResponse_SellerInputError {
  ERROR_CONTACT_INFO = 'ERROR_CONTACT_INFO',
  ERROR_HOME_ADDRESS = 'ERROR_HOME_ADDRESS',
  ERROR_HOME_DETAILS = 'ERROR_HOME_DETAILS',
  ERROR_MISSING_MARKET = 'ERROR_MISSING_MARKET',
  ERROR_MISSING_PARTNER = 'ERROR_MISSING_PARTNER',
  ERROR_NULL = 'ERROR_NULL',
  ERROR_REFERRAL = 'ERROR_REFERRAL'
}

/** Next ID: 2 */
export type OdProtosPartnershipServices_DeactivatePartnerAuthTokenRequestInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_DeclineReferralInvitationRequestInput = {
  invitationId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_DeletePartnerWebhookUrlRequestInput = {
  /** Identifier of the partner to update */
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_DeleteReferralForSellerInputRequestInput = {
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_DeleteReferralLinkRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GenerateDownloadableReportRequestInput = {
  searchFilters?: InputMaybe<OdProtosPartnershipData_ReportingSearchFiltersInput>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_GenerateReferralLinkRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosPartnershipServices_GetActivePaymentAgreementRequestInput = {
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  payableEvent?: InputMaybe<OdProtosPartnershipData_PayableEvent>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetAgentReferralPaymentsBySellerInputIdRequestInput = {
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetDownloadableReportRequestInput = {
  reportRunId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_GetEmbeddableReportsRequestInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Contains query parameters for param_market_name, which will be appended to an embeddable URL */
  marketNameQueryParameters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_GetExistingReferralsForTrackingIdRequestInput = {
  /** Tracking Identifier for partner's referral */
  externalTrackingId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the partnership associated with this referral */
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetInboundBuyerReferralsForListingOfferRequestInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_GetLeadStatusStringMappingRequestInput = {
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  leadState?: InputMaybe<OdProtosSellSellerData_ProductOffering_State>;
  offerState?: InputMaybe<OdProtosSellSellerData_Offer_State>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetLoyaltyEventRequestInput = {
  /** The id of an event external to the system, e.g. ListingOffer uuid or OpendoorDirectOffer uuid */
  foreignEventUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_GetLoyaltyPointsAndPayoutByCustomerRequestInput = {
  /** The Custard customer uuid */
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  /** The id of an event external to the system, e.g. ListingOffer uuid or OpendoorDirectOffer uuid */
  foreignEventUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetOutboundBuyerReferralRequestInput = {
  uuid: Scalars['ID']['input'];
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetOutboundBuyerReferralsRequestInput = {
  input?: InputMaybe<OdProtosPartnershipServices_GetOutboundBuyerReferralsRequest_InputOneofInput>;
};

export type OdProtosPartnershipServices_GetOutboundBuyerReferralsRequest_InputOneofInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  salesRepresentativeId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerAuthTokensRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerBranchByUserRequestInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerBranchRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerBranchesByPartnerRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerByTrackingKeywordRequestInput = {
  /** tracking keyword of the requested parter */
  trackingKeyword?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerRequestInput = {
  /** Identifier of the requested parter */
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnersByOrgIDsRequestInput = {
  /** Identifiers of the organizations */
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPaymentAgreementRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPaymentAgreementsForPartnerRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralInvitationEligibilityRequestInput = {
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralInvitationRequestInput = {
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_GetReferralLinkRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  userData?: InputMaybe<OdProtosPartnershipServices_GetReferralLinkRequest_UserDataOneofInput>;
  /** TODO: deprecate after removed from FE */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPartnershipServices_GetReferralLinkRequest_UserDataOneofInput = {
  /** If slug is passed in, the link will be returned if it exists, but a link will not be created otherwise. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** If user_email is passed in, the link will be returned if it exists, but a link will not be created otherwise. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** If user_id is passed in and a referral link does not exist, a referral link will be created. */
  userToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralPaymentRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralPaymentsByFlipTokenRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralRequestInput = {
  /** ID of the requested referral */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_GetReferralsByAddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralsByTrackingIdRequestInput = {
  /** external tracking id from partner */
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralsForReferrerRequestInput = {
  /** ID of the referrer from Directory */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_GetReferralsForSellerInputRequestInput = {
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** ID of the seller input */
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReportRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 1 */
export type OdProtosPartnershipServices_GetReportableIndexFieldsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_GetSellerLeadsRequestInput = {
  /**
   * Cursor that points to the last seller lead
   * from the previous response
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** To get leads created before the end_date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Max number of leads to return */
  limit?: InputMaybe<Scalars['Float']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** To get leads created after the start_date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetUserNotificationPreferencesRequestInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 10 */
export type OdProtosPartnershipServices_HandleReferralHandoffRequestInput = {
  agentRealEstateLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  agentRealEstateLicenseState?: InputMaybe<Scalars['String']['input']>;
  brokerageAddress?: InputMaybe<Scalars['String']['input']>;
  brokerageName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFirstName?: InputMaybe<Scalars['String']['input']>;
  customerLastName?: InputMaybe<Scalars['String']['input']>;
  customerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ListPartnersByTypesRequestInput = {
  partnershipTypes?: InputMaybe<Array<OdProtosPartnershipData_PartnershipType>>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ListPartnersRequestInput = {
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
};

/** Next ID: 5 */
export type OdProtosPartnershipServices_ListReferralLinksRequestInput = {
  /** Pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Optional market filter */
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Page size (default 20, max 100) */
  size?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_NotificationPreferenceInput = {
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_OverrideReferralPaymentRequestInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  payable?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Next ID: 11
 *
 * Params after AttributionType are unnecessary if opting to represent.
 */
export type OdProtosPartnershipServices_ReferOrRepresentCustomerRequestInput = {
  agentRealEstateLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  agentRealEstateLicenseState?: InputMaybe<Scalars['String']['input']>;
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  brokerageAddress?: InputMaybe<Scalars['String']['input']>;
  brokerageName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFirstName?: InputMaybe<Scalars['String']['input']>;
  customerLastName?: InputMaybe<Scalars['String']['input']>;
  customerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_RemovePaymentAgreementTierRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ResetReferralAttributionTypeRequestInput = {
  /** ID of the referral */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 21 */
export type OdProtosPartnershipServices_SearchSellerLeadsIndexRequestInput = {
  /** Search for leads with this casa address uuid */
  addressId?: InputMaybe<Scalars['String']['input']>;
  /** This will be used to build the search_after field in the next query */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The direcion of the sort oder: 'asc' or 'desc' */
  direction?: InputMaybe<OdProtosPartnershipServices_SearchSellerLeadsIndexRequest_Direction>;
  /** Search for leads created before the end_date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Deprecated in favor for partner_states */
  flipStates?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The field to order the results by */
  orderBy?: InputMaybe<OdProtosPartnershipServices_SearchSellerLeadsIndexRequest_OrderBy>;
  /** Search for leads that match any of these partner display names */
  partnerIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search for leads that match any of these partnership types */
  partnershipTypes?: InputMaybe<Array<OdProtosPartnershipData_PartnershipType>>;
  /** Search for leads that have a payable referral payment */
  payable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search for leads that match any of these markets */
  regionIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search for leads with these root seller input ids */
  rootSellerInputIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search for leads with referrals that have a referrer with this user id */
  salesReferrerUserId?: InputMaybe<Scalars['String']['input']>;
  /** The text search query to fuzzy match against address, customer, and sales referrer */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Search for leads with these seller input ids */
  sellerInputIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search for leads with these seller lead ids */
  sellerLeadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Will be passed as the `size` parameter in the elastic search query */
  size?: InputMaybe<Scalars['Float']['input']>;
  /** Search for leads created after the start_date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Search for leads that match any of these lead states */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search for leads that have been updated at any time since updated_since */
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * The options for sort direction
 * Next ID: 2
 */
export enum OdProtosPartnershipServices_SearchSellerLeadsIndexRequest_Direction {
  ASC = 'ASC',
  DESC = 'DESC'
}

/**
 * The options for ordering sorted results
 * Next ID: 6
 */
export enum OdProtosPartnershipServices_SearchSellerLeadsIndexRequest_OrderBy {
  CUSTOMER_NAME = 'CUSTOMER_NAME',
  LEAD_CREATED = 'LEAD_CREATED',
  OFFER_SENT = 'OFFER_SENT',
  PARTNER_DISPLAY_NAME = 'PARTNER_DISPLAY_NAME',
  REGION_IDENTIFIER = 'REGION_IDENTIFIER',
  SALES_REFERRER = 'SALES_REFERRER'
}

/** Next ID: 3 */
export type OdProtosPartnershipServices_SendLoginLiteLinkEmailForSellerInputRequestInput = {
  isRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_SendPartnershipLeadNotificationsRequestInput = {
  offerCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosPartnershipServices_SendPartnershipLeadNotificationsRequest_State>;
};

/** Next ID: 2 */
export enum OdProtosPartnershipServices_SendPartnershipLeadNotificationsRequest_State {
  OFFER_SENT = 'OFFER_SENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 4 */
export type OdProtosPartnershipServices_SetReferralLinkRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateLoyaltyEventRequestInput = {
  /** Optional: The customer uuid */
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  /** The id of an event external to the system, e.g. ListingOffer uuid or OpendoorDirectOffer uuid */
  foreignEventUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional: The number of loyalty points being earned for this event */
  points?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateOutboundBuyerReferralRequestInput = {
  salesRepresentativeId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosPartnershipData_OutboundBuyerReferral_State>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateOutboundBuyerReferralTourRequestRequestInput = {
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<OdProtosPartnershipData_OutboundBuyerReferralTourRequest_State>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdatePartnerBranchMemberByPartnerAndRegionRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_UpdatePartnerBranchMemberRequestInput = {
  partnerBranchMember?: InputMaybe<OdProtosPartnershipData_PartnerBranchMemberInput>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_UpdatePartnerBranchRequestInput = {
  partnerBranch?: InputMaybe<OdProtosPartnershipData_PartnerBranchInput>;
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

/** Next ID: 7 */
export type OdProtosPartnershipServices_UpdatePartnerRequestInput = {
  /** Optional -- updated display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the partner to update */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- updated landing page */
  landingPage?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- updated slug */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- updated tracking keyword */
  trackingKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- URL for the partner's webhook endpoint */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 17 */
export type OdProtosPartnershipServices_UpdatePaymentAgreementRequestInput = {
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  billingType?: InputMaybe<OdProtosPartnershipData_BillingType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  payableConditions?: InputMaybe<Array<OdProtosPartnershipData_PayableConditions>>;
  payableEvent?: InputMaybe<OdProtosPartnershipData_PayableEvent>;
  paymentType?: InputMaybe<OdProtosPartnershipData_PaymentType>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sendCommissionInstruction?: InputMaybe<Scalars['Boolean']['input']>;
  termConversionWindowDays?: InputMaybe<Scalars['Int']['input']>;
  termPayOnDetachedLead?: InputMaybe<Scalars['Boolean']['input']>;
  termPreviousRequestDays?: InputMaybe<Scalars['Int']['input']>;
  termUniqueLeadTypeWrapper?: InputMaybe<OdProtosPartnershipServices_UpdatePaymentAgreementRequest_TermUniqueLeadTypeWrapperInput>;
  tierTypeWrapper?: InputMaybe<OdProtosPartnershipServices_UpdatePaymentAgreementRequest_TermTierTypeWrapperInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPartnershipServices_UpdatePaymentAgreementRequest_TermTierTypeWrapperInput = {
  tierType?: InputMaybe<OdProtosPartnershipData_TierType>;
};

export type OdProtosPartnershipServices_UpdatePaymentAgreementRequest_TermUniqueLeadTypeWrapperInput = {
  termUniqueLeadType?: InputMaybe<OdProtosPartnershipData_UniqueLeadType>;
};

/** Next ID: 7 */
export type OdProtosPartnershipServices_UpdatePaymentAgreementTierRequestInput = {
  minimumPoints?: InputMaybe<Scalars['Float']['input']>;
  paymentFlatRate?: InputMaybe<Scalars['Float']['input']>;
  paymentPercentageBasis?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  tierCondition?: InputMaybe<OdProtosPartnershipData_TierCondition>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_UpdateReferralPaymentsForFlipTokenRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_UpdateReferralRequestInput = {
  /** Optional -- updated organization ID for the referral */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional -- updated user ID for the referral */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the referral to update */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateReferralSellerRelationForSellerInputRequestInput = {
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  /** The seller's relation to the referrer */
  sellerRelation?: InputMaybe<OdProtosPartnershipData_Referral_SellerRelation>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequestInput = {
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
  /** Referrer details for seller input */
  userData?: InputMaybe<OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequest_UserDataOneofInput>;
};

export type OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequest_UserDataOneofInput = {
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateSellRequestRequestInput = {
  communicationDetails?: InputMaybe<OdProtosPartnershipData_CommunicationDetailsInput>;
  referrerDetails?: InputMaybe<OdProtosPartnershipData_CustomerDetailsInput>;
  sellerInputId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_UpdateUserNotificationPreferencesRequestInput = {
  notificationPreferences?: InputMaybe<Array<OdProtosPartnershipServices_NotificationPreferenceInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ValidateEmailRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/**
 * An expression oneof.
 *
 * Expressions in PBDB are a subset of PostgreSQL 10 expressions:
 *
 * 1. Identifier: A property of an entry, either 'key', 'value', or 'last_version_created_at'.
 *                The 'value' identifier represents a PostgreSQL JSONB type that is the canonical
 *                JSON mapping of a Protocol Buffer as defined in
 *                'https://developers.google.com/protocol-buffers/docs/proto3#json'.
 *                You may access fields using PostgreSQL JSONB operators and functions such as
 *                "->>", "#>>", "jsonb_extract_path", etc.
 * 2. Value:      A value, such as a string or a number.
 * 3. Function:   A function call, the name of the PostgreSQL operator or function and the arguments
 *                to apply to it.
 *
 * *Examples*
 *
 * Let's see some examples, using some pseudo-protobuf code. Suppose we have this User message:
 *   message User {
 *     string name = 1;
 *     int32 age = 2;
 *   }
 *
 * Expressions for a user's name and age:
 *   Fn("->>", Id("value"), Val("name"))
 *   Fn("->>", Id("value"), Val("age"))
 *
 * Boolean expression for whether a user has the name "Jason":
 *   Fn("=",
 *     Fn("->>", Id("value"), Val("name")),
 *     Value("Jason")
 *   )
 *
 * Boolean expression for whether a user is at least 18 years old:
 *   Fn(">=",
 *     Fn("->>", Id("value"), Val("age")),
 *     Val(18)
 *   )
 *
 * Boolean expression that is the AND of the above.
 *   Fn("AND", [
 *     Fn("=",
 *       Fn("->>", Id("value"), Val("name")),
 *       Value("Jason")
 *     ),
 *     Fn(">=",
 *       Fn("->>", Id("value"), Val("age")),
 *       Val(18)
 *     )
 *   ])
 */
export type OdProtosPbdbData_ExprInput = {
  type?: InputMaybe<OdProtosPbdbData_Expr_TypeOneofInput>;
};

/**
 * A function expression is a function (or operator) and its arguments.
 *
 * The supported set of functions with their names and arities:
 *
 * Logical:
 *   "NOT" / 1
 * 	 "AND" / 0+
 * 	 "OR" / 0+
 *
 * Null:
 * 	 "IS NULL" / 1
 * 	 "IS NOT NULL" / 1
 *
 * Comparison:
 * 	 "=" / 2
 * 	 "!=" / 2
 * 	 "<" / 2
 * 	 ">" / 2
 * 	 "<=" / 2
 * 	 ">=" / 2
 * 	 "LIKE" / 2
 * 	 "NOT LIKE" / 2
 *
 * Array:
 * 	 "IN" / 1+
 * 	 "NOT IN" / 1+
 *
 * JSON/JSONB:
 * 	 "->" / 2
 * 	 "->>" / 2
 * 	 "#>" / 2
 * 	 "#>>" / 2
 *
 * String:
 * 	 "lower" / 1
 * 	 "upper" / 2
 *
 * Casts:
 *   "CAST AS x" / 1, where x is one of:
 *     bigint,
 *   	 boolean,
 *   	 bytea,
 *   	 date,
 *   	 double precision,
 *   	 integer,
 *   	 interval,
 *   	 json,
 *   	 jsonb,
 *   	 real,
 *   	 text,
 *   	 time,
 *   	 timetz,
 *   	 timestamp,
 *   	 timestamptz,
 */
export type OdProtosPbdbData_Expr_FunctionInput = {
  /** Arguments on the operation. */
  args?: InputMaybe<Array<OdProtosPbdbData_ExprInput>>;
  /** Name of function or operator. */
  fn?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPbdbData_Expr_TypeOneofInput = {
  function?: InputMaybe<OdProtosPbdbData_Expr_FunctionInput>;
  /** An identifier, either 'key', 'value', or 'last_version_created_at'. */
  identifier?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosPbdbData_Expr_ValueInput>;
};

/** A value expression. */
export type OdProtosPbdbData_Expr_ValueInput = {
  type?: InputMaybe<OdProtosPbdbData_Expr_Value_TypeOneofInput>;
};

export type OdProtosPbdbData_Expr_Value_TypeOneofInput = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
  bytes?: InputMaybe<Scalars['String']['input']>;
  double?: InputMaybe<Scalars['Float']['input']>;
  duration?: InputMaybe<GoogleProtobuf_DurationInput>;
  float?: InputMaybe<Scalars['Float']['input']>;
  int32?: InputMaybe<Scalars['Float']['input']>;
  int64?: InputMaybe<Scalars['Float']['input']>;
  string?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  uint32?: InputMaybe<Scalars['Float']['input']>;
  uint64?: InputMaybe<Scalars['Float']['input']>;
};

/** A sort expression is an expression and a direction. */
export type OdProtosPbdbData_SortExprInput = {
  direction?: InputMaybe<OdProtosPbdbData_SortExpr_Direction>;
  expr?: InputMaybe<OdProtosPbdbData_ExprInput>;
};

export enum OdProtosPbdbData_SortExpr_Direction {
  ASC = 'ASC',
  DESC = 'DESC'
}

/**
 * Enumeration of types of PBDB entries.
 * You should add a new identifier here when registering a new PBDB entry type.
 */
export enum OdProtosPbdbData_Type {
  /**
   * Config for a buy market.
   * * Key: market identifier
   * * Value: od_protos.buy.config.MarketConfig
   */
  BUY_MARKET_CONFIG = 'BUY_MARKET_CONFIG',
  /**
   * EXAMPLE is an example type. Please follow this format.
   * * Key: any string
   * * Value: od_protos.example.config.ExampleData
   */
  EXAMPLE = 'EXAMPLE',
  /**
   * Config for market operations.
   * * Key: market identifier
   * * Value: od_protos.home_operations.config.MarketConfig
   */
  HOME_OPERATIONS_MARKET_CONFIG = 'HOME_OPERATIONS_MARKET_CONFIG',
  /**
   * A market is a non-overlapping region that Opendoor operates in. Markets are the highest-level
   * division of Opendoor operations.
   * * Key: Fence Region ID
   * * Value: od_protos.market.config.Market
   */
  MARKET = 'MARKET',
  /**
   * Config for a Sell market.
   * * Key: Fence Region ID
   * * Value: od_protos.sell.config.MarketConfig
   */
  SELL_MARKET_CONFIG = 'SELL_MARKET_CONFIG',
  UNSET = 'UNSET'
}

export type OdProtosPbdbServices_ListRequestInput = {
  /** An expression to filter on. Must evaluate to a boolean. */
  filterExpr?: InputMaybe<OdProtosPbdbData_ExprInput>;
  /** Required. Defines the requested page of the list. */
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  /** Expressions to sort on. */
  sortExprs?: InputMaybe<Array<OdProtosPbdbData_SortExprInput>>;
  /** The type of entries to list. */
  type?: InputMaybe<OdProtosPbdbData_Type>;
};

export type OdProtosPbdbServices_NotARealCommandRequestInput = {
  brokerageTransactionRules?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_TransactionRuleSetInput>;
  buyMarketConfig?: InputMaybe<OdProtosBuyConfig_MarketConfigInput>;
  homeOperationsMarketConfig?: InputMaybe<OdProtosHomeOperationsConfig_MarketConfigInput>;
  market?: InputMaybe<OdProtosMarketConfig_MarketInput>;
  sellMarketConfig?: InputMaybe<OdProtosSellConfig_MarketConfigInput>;
};

export type OdProtosPbdbServices_ReadRequestInput = {
  /** The key of the entry to read. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The type of the entry to read. */
  type?: InputMaybe<OdProtosPbdbData_Type>;
  /**
   * Used to read a specific version of an entry.
   * * If == 0 (default), reads the latest version of an entry.
   * * If > 0, reads a specific version of an entry.
   */
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPbdbServices_WriteRequestInput = {
  /** The key of the entry to write. */
  key?: InputMaybe<Scalars['String']['input']>;
  /**
   * Used to prevent multiple clients from overwriting each other.
   * Returns FAILED_PRECONDITION if a condition wasn't satisfied.
   * * If == nil (default), unconditionally writes the entry.
   * * If == 0, conditionally writes the entry if this entry doesn't exist yet.
   * * If > 0, conditionally writes the entry if last_version_condition matches
   *   the current version.
   */
  lastVersionCondition?: InputMaybe<Scalars['Int']['input']>;
  /** The type of the entry to write. */
  type?: InputMaybe<OdProtosPbdbData_Type>;
  /** The value of the entry. The value is subject to the type's validation rules. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Describes a specific kind of edit for an Item */
export type OdProtosPictionaryBracketeerData_EditInput = {
  /**
   * This is implemented as a oneof instead of an enum to allow future edit modes to have
   * specialized parameters
   */
  spec?: InputMaybe<OdProtosPictionaryBracketeerData_Edit_SpecOneofInput>;
};

export enum OdProtosPictionaryBracketeerData_EditJob_State {
  /** Accepted but not yet submitted to 3rd party editor */
  CREATED = 'CREATED',
  /** 3rd party notified us of a problem */
  ERROR = 'ERROR',
  /** Request was created, but not accepted by 3rd party */
  FAILURE = 'FAILURE',
  /** Processing of successful job outputs is complete and all assets available in Cabinet */
  FINISHED = 'FINISHED',
  /** Request accepted by 3rd party editor */
  PENDING = 'PENDING',
  /** 3rd party notified us of job completion, but we're still processing results */
  SUCCESS = 'SUCCESS',
  UNKNOWN = 'UNKNOWN'
}

/** Basic HDR bracketing is a pre-set package of edits */
export type OdProtosPictionaryBracketeerData_Edit_BracketingInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosPictionaryBracketeerData_Edit_SpecOneofInput = {
  /** Standard HDR bracketing service */
  bracketingSpec?: InputMaybe<OdProtosPictionaryBracketeerData_Edit_BracketingInput>;
};

/** A line item in an edit job */
export type OdProtosPictionaryBracketeerData_ItemInput = {
  /** List of requested services */
  edits?: InputMaybe<Array<OdProtosPictionaryBracketeerData_EditInput>>;
  /** URLs where input images may be retrieved (must be accessible to public) */
  inputUrls?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPictionaryData_ErrorInput = {
  /** maps to go/lib/errors.Code */
  code?: InputMaybe<Scalars['Float']['input']>;
  /** Human-readable error message */
  message?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosPictionaryData_OrderingSource {
  ORDERING_SOURCE_AI = 'ORDERING_SOURCE_AI',
  ORDERING_SOURCE_BRACKET_INDEX_FALLBACK = 'ORDERING_SOURCE_BRACKET_INDEX_FALLBACK',
  ORDERING_SOURCE_UNSPECIFIED = 'ORDERING_SOURCE_UNSPECIFIED'
}

/** Optionally used to enrich drop folder events with additional data */
export type OdProtosPictionaryGdriveData_DropFolder_MetaInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** Arbitrary other data may be attached. Maximum size may be limited. */
  blob?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Uniquely identifies a drop folder and its purpose. This value serves to de-duplicate requests.
 * For example, if a drop folder is for accepting new listing photos, the namespace could be
 * "add_listing_photos" and the ID could be set to the listing_uuid of the associated listing.
 * You may also choose to use obfuscated namespaces so long as they are unique.
 */
export type OdProtosPictionaryGdriveData_DropFolder_SubjectInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPictionaryServices_AlbumConsumedReqInput = {
  albumId?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  /** if error is unset we assume the operation succeeded */
  error?: InputMaybe<OdProtosPictionaryData_ErrorInput>;
  workshopId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPictionaryServices_DeleteDropFolderReqInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPictionaryServices_DeleteWorkshopReqInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPictionaryServices_EditPhotosReqInput = {
  /**
   * Optional user-provided value which is used to compute a kafka partition key. The job ID is used
   * when not set. You would only need to set this value if you wanted to preserve event order
   * across more than one job.
   */
  eventKey?: InputMaybe<Scalars['String']['input']>;
  /** A list of edit request items */
  items?: InputMaybe<Array<OdProtosPictionaryBracketeerData_ItemInput>>;
  /** Human-readable name for this job (visible to 3P services) */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPictionaryServices_GetDropFolderReqInput = {
  identifier?: InputMaybe<OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneofInput>;
};

export type OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  dropFolderId?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_SubjectInput>;
};

export type OdProtosPictionaryServices_GetEditJobsReqInput = {
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPictionaryServices_GetOrCreateDropFolderReqInput = {
  /** If the drop folder does not exist one will be created in Google Drive with this name */
  folderName?: InputMaybe<Scalars['String']['input']>;
  /** Metadata will be updated, if given (when drop folder does not exist yet) */
  meta?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_MetaInput>;
  subject?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_SubjectInput>;
};

export type OdProtosPictionaryServices_GetWorkshopReqInput = {
  identifier?: InputMaybe<OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneofInput>;
};

export type OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  workshopId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPictionaryServices_SetDropFolderMetaReqInput = {
  identifier?: InputMaybe<OdProtosPictionaryServices_SetDropFolderMetaReq_IdentifierOneofInput>;
  meta?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_MetaInput>;
};

export type OdProtosPictionaryServices_SetDropFolderMetaReq_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_SubjectInput>;
};

export type OdProtosPictionaryServices_UploadAssetsReqInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dropFolderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPricesAcquisitionData_ContinuousNetCashExperimentTreatmentInput = {
  subsidyBps?: InputMaybe<Scalars['Float']['input']>;
  treatmentArm?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPricesAcquisitionData_FeeExperimentFlagsInput = {
  continuousNetCashExperimentTreatment?: InputMaybe<OdProtosPricesAcquisitionData_ContinuousNetCashExperimentTreatmentInput>;
};

export type OdProtosPricesAcquisitionData_FeeOverridesInput = {
  applyFeeBandExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  applyHeadlinePriceExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If set, the headline discount on the home will be set such that
   * headline fee / headline price == flat_headline_fee_percentage.
   */
  flatHeadlineFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  /** only one of flat_headline_fee_percentage and flat_headline_price_cents can be set */
  flatHeadlinePriceCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * If set, the internal fee is overridden to be that amount (before rounding).
   * This affects the resulting LGM and will bypass LGM flooring
   */
  flatInternalFeeCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  ignoreFeeFloors?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreFeeRounding?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreHeadlinePriceRounding?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether to ignore partner fee policy violations. These violations usually result in a fee
   * calculation error. A list of these violations can be found at o/homebuilder-grandfather.
   */
  ignorePartnerPolicyViolation?: InputMaybe<Scalars['Boolean']['input']>;
  minExternalFeePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosPricesCommon_OnlineRealEstatePartner {
  ORE_NONE = 'ORE_NONE',
  ORE_UNKNOWN = 'ORE_UNKNOWN',
  REDFIN = 'REDFIN'
}

/**
 * Next ID: 61
 * NOTE: WHEN UPDATING THIS ENUM YOU MUST BUMP PROTOS FOR PRICES, WEB, AND GENIE.
 * In the past, we have forgotten to bump protos for Genie, causing it to crash when it receives a partner it doesn't recognize.
 *
 * NOTE: IN PRACTICE, THIS IS USED JUST FOR HOMEBUILDER PARTNERS. Soon to be deprecated in favor of PartnerReferral type above.
 */
export enum OdProtosPricesCommon_Partner {
  AMERICAN_WEST = 'AMERICAN_WEST',
  ASHTON_WOODS = 'ASHTON_WOODS',
  BEAZER_HOMES = 'BEAZER_HOMES',
  BLOOMFIELD_HOMES = 'BLOOMFIELD_HOMES',
  BROOKFIELD_RESIDENTIAL_PROPERTIES = 'BROOKFIELD_RESIDENTIAL_PROPERTIES',
  CALATLANTIC = 'CALATLANTIC',
  CAVENDAR = 'CAVENDAR',
  CENTEX = 'CENTEX',
  CENTURY_COMMUNITIES = 'CENTURY_COMMUNITIES',
  CHAFIN = 'CHAFIN',
  CITY_VENTURES = 'CITY_VENTURES',
  CLARITY = 'CLARITY',
  DAN_RYAN = 'DAN_RYAN',
  DAVID_WEEKLEY = 'DAVID_WEEKLEY',
  DEERBROOKE = 'DEERBROOKE',
  DEL_WEBB = 'DEL_WEBB',
  DORN = 'DORN',
  DREAM_FINDERS_HOMES = 'DREAM_FINDERS_HOMES',
  DREES = 'DREES',
  DRHORTON = 'DRHORTON',
  /**
   * TODO: Remove this when web is no longer using it.
   * @deprecated No longer supported
   */
  DR_HORTON = 'DR_HORTON',
  EMPIRE_COMMUNITIES = 'EMPIRE_COMMUNITIES',
  EPCON_COMMUNITIES_FRANCHISING = 'EPCON_COMMUNITIES_FRANCHISING',
  FRONTDOOR = 'FRONTDOOR',
  GEHAN_HOMES = 'GEHAN_HOMES',
  GOODALL = 'GOODALL',
  JDRE = 'JDRE',
  JMC_HOMES = 'JMC_HOMES',
  JOHN_HOUSTON_CUSTOM_HOMES = 'JOHN_HOUSTON_CUSTOM_HOMES',
  JOHN_WIELAND_HOMES = 'JOHN_WIELAND_HOMES',
  KB_HOME = 'KB_HOME',
  LENNAR = 'LENNAR',
  LILLIAN = 'LILLIAN',
  MARACAY = 'MARACAY',
  MARONDA = 'MARONDA',
  MATTAMY = 'MATTAMY',
  MERITAGE = 'MERITAGE',
  MEYERRANCH = 'MEYERRANCH',
  MI_HOMES = 'MI_HOMES',
  NONE = 'NONE',
  OTHER_BUILDER = 'OTHER_BUILDER',
  PAHLISCH = 'PAHLISCH',
  PARDEE = 'PARDEE',
  PERRY_HOMES = 'PERRY_HOMES',
  PROVIDENCE_HOMES = 'PROVIDENCE_HOMES',
  PULTE = 'PULTE',
  RICHMOND_AMERICAN = 'RICHMOND_AMERICAN',
  RIVERSIDE = 'RIVERSIDE',
  RYAN = 'RYAN',
  SHEA_HOMES_TRILOGY = 'SHEA_HOMES_TRILOGY',
  SMITHDOUGLAS = 'SMITHDOUGLAS',
  STONE_BRIDGE = 'STONE_BRIDGE',
  TAYLOR_MORRISON = 'TAYLOR_MORRISON',
  TOLL_BROTHERS = 'TOLL_BROTHERS',
  TOUCHSTONE = 'TOUCHSTONE',
  TRENDMAKER_HOMES = 'TRENDMAKER_HOMES',
  TRIPOINTE = 'TRIPOINTE',
  TRUE_HOMES_USA = 'TRUE_HOMES_USA',
  UNKNOWN = 'UNKNOWN',
  WADE_JURNEY_HOMES = 'WADE_JURNEY_HOMES',
  WOODSIDE = 'WOODSIDE'
}

/**
 * PartnerReferral defines all the data about the referral and the associated partner that we need for pricing, mainly fees.
 *
 * Next ID: 5
 */
export type OdProtosPricesCommon_PartnerReferralInput = {
  attributionType?: InputMaybe<OdProtosPricesCommon_PartnerReferral_AttributionType>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  partnershipType?: InputMaybe<OdProtosPricesCommon_PartnerReferral_PartnershipType>;
  referralId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export enum OdProtosPricesCommon_PartnerReferral_AttributionType {
  REFERRAL = 'REFERRAL',
  REPRESENTATION = 'REPRESENTATION',
  UNKNOWN_ATTRIBUTION = 'UNKNOWN_ATTRIBUTION'
}

/** Next ID: 5 */
export enum OdProtosPricesCommon_PartnerReferral_PartnershipType {
  HOMEBUILDER = 'HOMEBUILDER',
  /** Pricing does not need to know about most partnership types. */
  OTHER = 'OTHER',
  REAL_ESTATE_AGENCY = 'REAL_ESTATE_AGENCY',
  REIT = 'REIT',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPricesDataFinancials_AcquisitionChannel {
  AGENT_ACQUISITION = 'AGENT_ACQUISITION',
  DIRECT_ACQUISITION = 'DIRECT_ACQUISITION',
  HOME_BUILDER_NON_PARTNER = 'HOME_BUILDER_NON_PARTNER',
  HOME_BUILDER_PARTNER = 'HOME_BUILDER_PARTNER',
  REIT_ACQUISITION = 'REIT_ACQUISITION',
  TRADE_IN = 'TRADE_IN',
  UNSET_ACQUISITION_CHANNEL = 'UNSET_ACQUISITION_CHANNEL'
}

/**
 * Next ID: 12
 * Deprecated IDs: 1, 6
 */
export type OdProtosPricesDataFinancials_CohortInput = {
  /** If empty, assumed to be all channels. */
  acquisitionChannels?: InputMaybe<Array<OdProtosPricesDataFinancials_AcquisitionChannel>>;
  cohortType?: InputMaybe<OdProtosPricesDataFinancials_CohortType>;
  endDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** If empty, flips from all markets will be returned. */
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  offerAutomationType?: InputMaybe<OdProtosPricesDataFinancials_OfferAutomationType>;
  /** >= lower_bound (where offer_price is positive) */
  offerPriceLowerBound?: InputMaybe<Scalars['Float']['input']>;
  /** < upper_bound (where offer_price is positive) */
  offerPriceUpperBound?: InputMaybe<Scalars['Float']['input']>;
  /** If empty, assumed to be all channels. */
  resaleChannels?: InputMaybe<Array<OdProtosPricesDataFinancials_ResaleChannel>>;
  /**
   * start_date and end_date define the cohort's date range. This date range is
   * inclusive of start_date and end_date and is defined in UTC. It includes all the flips that
   * were of type `cohort_type` during the time period.
   */
  startDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Next ID: 7 */
export enum OdProtosPricesDataFinancials_CohortType {
  ACQUISITION_COE = 'ACQUISITION_COE',
  ACQUISITION_CONTRACT = 'ACQUISITION_CONTRACT',
  ACQUISITION_CR = 'ACQUISITION_CR',
  LISTED = 'LISTED',
  RESALE_COE = 'RESALE_COE',
  RESALE_CONTRACT = 'RESALE_CONTRACT',
  UNSET_COHORT_TYPE = 'UNSET_COHORT_TYPE',
  UNSOLD = 'UNSOLD'
}

export enum OdProtosPricesDataFinancials_ContractState {
  CONTRACT_STATE_IN_CONTRACT = 'CONTRACT_STATE_IN_CONTRACT',
  CONTRACT_STATE_LISTED = 'CONTRACT_STATE_LISTED',
  CONTRACT_STATE_PRE_LISTING = 'CONTRACT_STATE_PRE_LISTING',
  CONTRACT_STATE_RESALE_CONTINGENCY_RELEASED = 'CONTRACT_STATE_RESALE_CONTINGENCY_RELEASED',
  CONTRACT_STATE_RESALE_IN_CONTRACT = 'CONTRACT_STATE_RESALE_IN_CONTRACT',
  CONTRACT_STATE_SOLD = 'CONTRACT_STATE_SOLD',
  CONTRACT_STATE_SOLD_AND_CLOSED_BY_ACCOUNTING = 'CONTRACT_STATE_SOLD_AND_CLOSED_BY_ACCOUNTING',
  CONTRACT_STATE_UW = 'CONTRACT_STATE_UW'
}

export type OdProtosPricesDataFinancials_GetFinancialsRequestInput = {
  cohort?: InputMaybe<OdProtosPricesDataFinancials_CohortInput>;
  /**
   * Note: Only one of tokens or cohort should be set. A `oneof` proto declaration can't be used
   * here because it does not support `repeated` fields.
   */
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OdProtosPricesDataFinancials_OfferAutomationType {
  ALL_OFFERS = 'ALL_OFFERS',
  AUTOMATED_OFFERS = 'AUTOMATED_OFFERS',
  VAL_LEAD_OFFERS = 'VAL_LEAD_OFFERS'
}

/** Deprecated IDs: 4 */
export enum OdProtosPricesDataFinancials_ResaleChannel {
  AGENT_RESALE = 'AGENT_RESALE',
  DIRECT_RESALE = 'DIRECT_RESALE',
  REIT = 'REIT',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN',
  UNSET_RESALE_CHANNEL = 'UNSET_RESALE_CHANNEL'
}

export enum OdProtosPricingDataPropertyEngagements_AcquisitionDataLabeling_State {
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPricingDataPropertyEngagements_AcquisitionRepairBudgetReview_State {
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_State {
  COMPLETED = 'COMPLETED',
  ESCALATED = 'ESCALATED',
  MANUAL_COMPLETED = 'MANUAL_COMPLETED',
  MANUAL_REQUESTED = 'MANUAL_REQUESTED',
  REQUESTED = 'REQUESTED',
  REUSED = 'REUSED',
  SKIPPED = 'SKIPPED',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Note: AUS does not accurately populate this state on its events. The LifecycleState
 * on PE events is more relevant
 */
export enum OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_State {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  OD_SELECT = 'OD_SELECT',
  RESOLVING_WALK = 'RESOLVING_WALK',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPricingDataPropertyEngagements_AcquisitionValuation_EventExtensions_Domain_Completed_ValuationType {
  UNKNOWN = 'UNKNOWN',
  WEB_ENSEMBLED_VALUATION = 'WEB_ENSEMBLED_VALUATION',
  WEB_SINGLE_VALUATION = 'WEB_SINGLE_VALUATION'
}

export enum OdProtosPricingDataPropertyEngagements_AcquisitionValuation_State {
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_State {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 7 */
export type OdProtosPricingData_CamundaFlowNodeInstanceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  flowNodeName?: InputMaybe<Scalars['String']['input']>;
  incident?: InputMaybe<OdProtosPricingData_CamundaIncidentInput>;
  key?: InputMaybe<Scalars['Float']['input']>;
  /** ACTIVE, COMPLETED, TERMINATED */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosPricingData_CamundaIncidentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  incidentType?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** ACTIVE, MIGRATED, RESOLVED, PENDING */
  state?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Captures data relevant to a single instance of the Camunda process
 * Next ID: 10
 */
export type OdProtosPricingData_CamundaProcessInstanceInput = {
  /** When the camunda process instance was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The flow node instances of the process instance which would represent the current state of the process instance */
  flowNodeInstances?: InputMaybe<Array<OdProtosPricingData_CamundaFlowNodeInstanceInput>>;
  /** The process instance key */
  processInstanceKey?: InputMaybe<Scalars['Float']['input']>;
  /** The process name */
  processName?: InputMaybe<Scalars['String']['input']>;
  /** The Property Engagement ID */
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  /** The process instance state */
  state?: InputMaybe<Scalars['String']['input']>;
  /** When the camunda process instance was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The variables stored in the process instance */
  variables?: InputMaybe<GoogleProtobuf_StructInput>;
  /** The Camunda model version */
  version?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosPricingData_EnsembledRepairLineItem_RepairType {
  PRELIST = 'PRELIST',
  UNKNOWN = 'UNKNOWN'
}

/** Configurations for mocking the underwriting workflow */
export type OdProtosPricingData_MockAcquisitionUnderwritingInput = {
  dataLabeling?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabelingInput>;
  defaultHumanToken?: InputMaybe<Scalars['String']['input']>;
  pricingDecision?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecisionInput>;
  repairBudgetReview?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReviewInput>;
  riskAssessment?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessmentInput>;
  valuation?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockValuationInput>;
};

/**
 * Do not add fields to this message
 * Instead, create a new PE-specific message for the scenario
 * and add the fields there.
 */
export type OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabelingInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabeling_ConfigOneofInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabeling_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecisionInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecision_ConfigOneofInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecision_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput>;
  walk?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecision_WalkInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecision_WalkInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReviewInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ConfigOneofInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput>;
  proposeWalk?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ProposeWalkInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ProposeWalkInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  primaryReason?: InputMaybe<Scalars['String']['input']>;
  resolutionOutcome?: InputMaybe<OdProtosPricingData_WalkResolutionOutcome>;
  secondaryReason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessmentInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ConfigOneofInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_HappyPathInput>;
  proposeWalk?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ProposeWalkInput>;
  skipRiskAssessment?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_SkipInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_HappyPathInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ProposeWalkInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_SkipInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockValuationInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ConfigOneofInput>;
  finalPrv?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput>;
  proposeWalk?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ProposeWalkInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ProposeWalkInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  primaryReason?: InputMaybe<Scalars['String']['input']>;
  secondaryReason?: InputMaybe<Scalars['String']['input']>;
};

/** Specifies the transaction phase when underwriting is executed */
export enum OdProtosPricingData_UnderwritingExecutionTiming {
  POST_CONTRACT = 'POST_CONTRACT',
  PRE_CONTRACT = 'PRE_CONTRACT',
  UNDERWRITING_EXECUTION_TIMING_UNSPECIFIED = 'UNDERWRITING_EXECUTION_TIMING_UNSPECIFIED'
}

/** Specifies what data context is available for underwriting */
export enum OdProtosPricingData_UnderwritingInputContext {
  ASSESSMENT = 'ASSESSMENT',
  DILIGENCE_VISIT = 'DILIGENCE_VISIT',
  UNDERWRITING_INPUT_CONTEXT_UNSPECIFIED = 'UNDERWRITING_INPUT_CONTEXT_UNSPECIFIED'
}

export enum OdProtosPricingData_UnderwritingSubEngagement {
  DATA_LABELING = 'DATA_LABELING',
  ENSEMBLED_VALUATION = 'ENSEMBLED_VALUATION',
  LGM_REVIEW = 'LGM_REVIEW',
  /** optional valuation that overrides the EV after a rejected walk proposal */
  OVERRIDE_VALUATION = 'OVERRIDE_VALUATION',
  /** part of OD Select workflow */
  POST_RENO_VALUATION = 'POST_RENO_VALUATION',
  /** part of OD Select workflow */
  PRE_RENO_VALUATION = 'PRE_RENO_VALUATION',
  PRICING_DECISION = 'PRICING_DECISION',
  REPAIR_BUDGET_REVIEW = 'REPAIR_BUDGET_REVIEW',
  RISK_ASSESSMENT = 'RISK_ASSESSMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 9 */
export type OdProtosPricingData_WalkProposalInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** The primary reason for the walk proposal */
  primaryReason?: InputMaybe<Scalars['String']['input']>;
  /** Parent PE ID for the sub-engagement that is the source of this walk proposal */
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  /** additional details about the walk proposal */
  proposalDetails?: InputMaybe<GoogleProtobuf_StructInput>;
  /** The Human token of user who proposed the walk */
  proposedByToken?: InputMaybe<Scalars['String']['input']>;
  /** The source of the proposal. These are the only valid sources for initiating a walk proposal */
  proposedFromPeType?: InputMaybe<OdProtosPricingData_UnderwritingSubEngagement>;
  /** PE ID for the sub-engagement */
  sourcePropertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  /** If the walk proposal was proposed from a valuation PE, it's ID will be set here. */
  valuationId?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 11 */
export type OdProtosPricingData_WalkResolutionInput = {
  /** If the walk proposal was accepted, the ID of the accepted walk proposal */
  acceptedWalkProposalId?: InputMaybe<Scalars['String']['input']>;
  /** direct override valuation EE proxy */
  directOverrideValuationCi50margin?: InputMaybe<Scalars['Float']['input']>;
  /** direct override valuation price */
  directOverrideValuationPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  /** instructions stemming from the decision made on the walk proposal */
  resolutionCxInstructions?: InputMaybe<Scalars['String']['input']>;
  /** notes about the decision made on the walk proposal */
  resolutionNote?: InputMaybe<Scalars['String']['input']>;
  /** the decision made on the walk proposal */
  resolutionOutcome?: InputMaybe<OdProtosPricingData_WalkResolutionOutcome>;
  /** The type of walk resolution */
  resolutionType?: InputMaybe<OdProtosPricingData_WalkResolutionType>;
  /** when the walk proposal was resolved */
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The Human token of the user who resolved the proposal */
  resolvedByToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosPricingData_WalkResolutionOutcome {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  REJECTED_WITH_DIRECT_OVERRIDE = 'REJECTED_WITH_DIRECT_OVERRIDE',
  REJECTED_WITH_VALUATION_OVERRIDE = 'REJECTED_WITH_VALUATION_OVERRIDE',
  UNKNOWN_OUTCOME = 'UNKNOWN_OUTCOME'
}

export enum OdProtosPricingData_WalkResolutionType {
  HOMES = 'HOMES',
  PRICING = 'PRICING',
  UNKNOWN_RESOLUTION_TYPE = 'UNKNOWN_RESOLUTION_TYPE'
}

export type OdProtosPricingsData_AgentCommissionInput = {
  flatRate?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * Percentage of the projected resale sales price
   * (or agent_projected_resale_sales_price if available)
   *
   * e.g., 0.06 for 6%
   */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPricingsData_AgentGuaranteedFixedCommissionInput = {
  value?: InputMaybe<OdProtosPricingsData_AgentGuaranteedFixedCommission_ValueOneofInput>;
};

export type OdProtosPricingsData_AgentGuaranteedFixedCommission_ValueOneofInput = {
  fixedAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** e.g. 0.029 for 2.9% */
  pctOfUserExpectedResale?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPricingsData_AgentProjectedSalesPriceInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** If true, will ignore modification guardrails (e.g., 110% of projected sales price) */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosPricingsData_AgentVariableCommissionInput = {
  /** e.g. 0.007 for 0.7% */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Override for target levered gross margin */
export type OdProtosPricingsData_LgmOverrideInput = {
  overrideBps?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosPricingsData_MetadataInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * metainfo is not used by the service
   * but it will be associated with created records
   * so callers may lookup in non-prod (e.g., snowflake) contexts
   *  e.g., select * from pricings where metadata:metainfo:foo = 'bar';
   */
  metainfo?: InputMaybe<GoogleProtobuf_StructInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPricingsData_ModificationInput = {
  kind?: InputMaybe<OdProtosPricingsData_Modification_KindOneofInput>;
};

export type OdProtosPricingsData_Modification_KindOneofInput = {
  agentFixedCommission?: InputMaybe<OdProtosPricingsData_AgentGuaranteedFixedCommissionInput>;
  agentProjectedSalesPrice?: InputMaybe<OdProtosPricingsData_AgentProjectedSalesPriceInput>;
  agentVariableCommission?: InputMaybe<OdProtosPricingsData_AgentVariableCommissionInput>;
  buyerAgentCommission?: InputMaybe<OdProtosPricingsData_AgentCommissionInput>;
  prelistRepairsSubsidy?: InputMaybe<OdProtosPricingsData_PrelistRepairsSubsidyInput>;
  salesPriceSubsidy?: InputMaybe<OdProtosPricingsData_SalesPriceSubsidyInput>;
  sellerAgentCommission?: InputMaybe<OdProtosPricingsData_AgentCommissionInput>;
  sellerDesiredAdvance?: InputMaybe<OdProtosPricingsData_SellerDesiredAdvanceInput>;
  /** V2: use this for the seller, agent, or user expected resale price. */
  sellerProjectedSalesPrice?: InputMaybe<OdProtosPricingsData_SellerProjectedSalesPriceInput>;
};

export type OdProtosPricingsData_MutationInput = {
  operation?: InputMaybe<OdProtosPricingsData_Mutation_OperationOneofInput>;
};

export type OdProtosPricingsData_Mutation_OperationOneofInput = {
  /**
   * Add a new instance of the given modification.
   * Some modifications may only be allowed at most once or may conflict with other modifications.
   * In such cases, the server will return an error.
   */
  add?: InputMaybe<OdProtosPricingsData_ModificationInput>;
  /**
   * Remove an existing instance of the given modification.
   * The server will return an error if the modification does not exist.
   */
  remove?: InputMaybe<OdProtosPricingsData_ModificationInput>;
  /**
   * Update an existing instance of the given modification.
   * The server will return an error if the modification does not exist or if the update is
   * not allowed.
   */
  update?: InputMaybe<OdProtosPricingsData_ModificationInput>;
  /** Update the whole unit economics linkage. */
  updateUnderwriting?: InputMaybe<OdProtosPricingsData_UpdateUnderwritingInput>;
  /**
   * Update an existing instance of the given modification, or add it if it does not exist.
   * May not be compatible with all modifications.
   * Will return an error if multiple modifications of the same type are present and cannot be uniqely identified
   */
  upsert?: InputMaybe<OdProtosPricingsData_ModificationInput>;
};

export type OdProtosPricingsData_PrelistRepairsSubsidyInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Pricing type enum to select which pricing graph/presentation to use */
export enum OdProtosPricingsData_PricingType {
  AGENT = 'AGENT',
  DEFAULT = 'DEFAULT',
  DIRECT_TO_CONSUMER = 'DIRECT_TO_CONSUMER',
  LENNAR_PILOT = 'LENNAR_PILOT',
  ONLINE_REAL_ESTATE = 'ONLINE_REAL_ESTATE',
  UNDERWRITTEN_OUTBOUNDS = 'UNDERWRITTEN_OUTBOUNDS'
}

export type OdProtosPricingsData_SalesPriceSubsidyInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** If true, will ignore modification guardrails (e.g., 20% of UW PRV) */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosPricingsData_SellerDesiredAdvanceInput = {
  desiredCashAdvance?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsData_SellerProjectedSalesPriceInput = {
  sellerProjectedSalesPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsData_UpdateUnderwritingInput = {
  underwritingId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPricingsServicesPricingsGraphql_DeriveNewPricingRequestInput = {
  /**
   * Typically, you want to derive from a 'leaf' pricing (e.g., some 'latest' pricing)
   * When `allow_non_leaf_derivation = false` (default), we return an error if the source pricing is not a leaf
   * That is, if any derivations have been made _from_ the source pricing, we return an error
   */
  allowNonLeafDerivation?: InputMaybe<Scalars['Boolean']['input']>;
  emitUpdateEvent?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  mutations?: InputMaybe<Array<OdProtosPricingsData_MutationInput>>;
  sourcePricingUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPricingsServicesPricingsGraphql_GetSellWithUpsidePricingOptionsRequestInput = {
  /** This is the base pricing that will be used to produce options */
  basePricingUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: List of products being merchandised alongside this SwU offer
   * Used to provide context about what other offers the seller is seeing
   */
  merchandisedAlongside?: InputMaybe<Array<OdProtosSellCommon_Product>>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  /** Optional: Seller estimated sales price */
  sellerEstimatedSalesPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsServicesPricingsGraphql_ListPricingsExpandedRequestInput = {
  pricingUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPricingsServicesPricingsGraphql_ListPricingsRequestInput = {
  pricingUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OdProtosPricingsServicesPricingsGraphql_PostDiligenceVisitUpdateSource {
  UPDATE_SOURCE_PRICING_REVIEW = 'UPDATE_SOURCE_PRICING_REVIEW',
  UPDATE_SOURCE_UNDERWRITING = 'UPDATE_SOURCE_UNDERWRITING',
  UPDATE_SOURCE_UNSPECIFIED = 'UPDATE_SOURCE_UNSPECIFIED'
}

export type OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  operatorDecision?: InputMaybe<OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequest_OperatorDecisionOneofInput>;
  updateSource?: InputMaybe<OdProtosPricingsServicesPricingsGraphql_PostDiligenceVisitUpdateSource>;
};

export type OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequest_OperatorDecisionOneofInput = {
  addendum?: InputMaybe<OdProtosCommon_MoneyInput>;
  proceed?: InputMaybe<GoogleProtobuf_EmptyInput>;
  withdraw?: InputMaybe<OdProtosPricingsServicesPricingsGraphql_WithdrawDecisionInput>;
};

export type OdProtosPricingsServicesPricingsGraphql_WithdrawDecisionInput = {
  reasoning?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Recalculate a sell direct pricing preserving the source pricing's Abacus
 * inputs and version, changing only the CX subsidy.
 */
export type OdProtosPricingsServicesPricings_AddCxSubsidyRequestInput = {
  /**
   * The existing py-pricings pricing UUID to grandfather from.
   * Abacus inputs and version are taken from this pricing.
   */
  sourcePricingUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * The updated CX subsidy as a positive amount representing a credit to the seller.
   * Passed explicitly to ensure parity with web's computation.
   */
  subsidySellerCx?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export enum OdProtosPricingsServicesPricings_AddCxSubsidyResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Creates a new Sell Direct pricing after post-contract underwriting completes.
 * Compares the post-UW pricing to the in-contract pricing to determine if an addendum is needed.
 */
export type OdProtosPricingsServicesPricings_CreateInContractSellDirectPricingRequestInput = {
  /**
   * The in-contract pricing UUID the seller signed.
   * Used to compare against the newly computed pricing and determine addendum need.
   */
  contractPricingUuid?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  lgmOverride?: InputMaybe<OdProtosPricingsData_LgmOverrideInput>;
  /** The offer UUID associated with this transaction. */
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<OdProtosPricingsData_PricingType>;
  /** When true, skip writing an outbox event for the addendum decision. */
  skipOutboxEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** OPTIONAL. Same semantics as GetSellDirectPricingRequest.valuation_ref. */
  valuationRef?: InputMaybe<OdProtosPricingsServicesPricings_ValuationRefInput>;
};

/** Next ID: 9 */
export type OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequestInput = {
  /** from partnership.data.Partner.identifier */
  agentReferralPartnerId?: InputMaybe<Scalars['String']['input']>;
  economics?: InputMaybe<OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_EconomicsOneofInput>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * Hack: if we need additional partner fields, begin generalizing this request.
   * e.g., call GetReferralsForSellerInputRequest and parse partners that way.
   */
  isMsre?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_EconomicsOneofInput = {
  /**
   * This is the minimum data we need to compute an lwod pricing.
   * I've created this to demonstrate what we need, but we may want to replace this with some
   * new identifier. e.g., a valuation ID + repairs ensemble ID + ... something else w/ val gain + pvals.
   * Or maybe we decide it's just the first two IDs are necessary in which case we can query for flip level val gain.
   * Maybe pvals are not necessary here. All TBD.
   */
  rawEconomics?: InputMaybe<OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_RawEconomicsInput>;
  underwritingId?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * This is the minimum data we need to compute an lwod pricing,
 * which is what we normally get from the SD offer.
 * Hopefully this will go away after we develop a better abstraction
 */
export type OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_RawEconomicsInput = {
  /** required */
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** defaults to 0 if unset */
  postValuationAdjustments?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** defaults to 0 if unset */
  prelistRepairsCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** defaults to 0 if unset */
  projectedValGain?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export enum OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosPricingsServicesPricings_CreateSellDirectPricingRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  /** aka unit_economics_id */
  underwritingId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosPricingsServicesPricings_CreateSellDirectPricingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 10 */
export type OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequestInput = {
  /**
   * When neither is set, no agent relationship is established, meaning it is an
   * Opendoor Led Offer (ODLO).
   */
  agentRelationship?: InputMaybe<OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_AgentRelationshipOneofInput>;
  /** current pricing that the customer wants to move forward with. */
  currentPricingUuid?: InputMaybe<Scalars['String']['input']>;
  economics?: InputMaybe<OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_RawEconomicsInput>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * Hack: if we need additional partner fields, begin generalizing this request.
   * e.g., call GetReferralsForSellerInputRequest and parse partners that way.
   */
  isMsre?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  newOfferPresentationExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  underwritingId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_AgentRelationshipOneofInput = {
  /**
   * Agent Acq
   * from partnership.data.Partner.identifier
   */
  agentReferralPartnerId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Agent Led Offer (ALO)
   * Temporarily may have OD brokerage set for ODLO
   * from agents.data.Brokerage.id
   */
  brokerageId?: InputMaybe<Scalars['String']['input']>;
};

/** This is the minimum data we need to compute a swu pricing. */
export type OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_RawEconomicsInput = {
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  postValuationAdjustments?: InputMaybe<OdProtosCommon_MoneyInput>;
  prelistRepairsCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  projectedHoldingCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  projectedValGain?: InputMaybe<OdProtosCommon_MoneyInput>;
  valuationExpectedError?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_ECONOMICALLY_FEASIBLE = 'NOT_ECONOMICALLY_FEASIBLE',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosPricingsServicesPricings_DeriveNewPricingRequestInput = {
  /**
   * Typically, you want to derive from a 'leaf' pricing (e.g., some 'latest' pricing)
   * When `allow_non_leaf_derivation = false` (default), we return an error if the source pricing is not a leaf
   * That is, if any derivations have been made _from_ the source pricing, we return an error
   */
  allowNonLeafDerivation?: InputMaybe<Scalars['Boolean']['input']>;
  emitUpdateEvent?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  mutations?: InputMaybe<Array<OdProtosPricingsData_MutationInput>>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  sourcePricingUuid?: InputMaybe<Scalars['String']['input']>;
  /** the user token who is requesting the new derived pricing */
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosPricingsServicesPricings_DeriveNewPricingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  /** See DeriveNewPricingRequest.allow_non_leaf_derivation for context. */
  NON_LEAF_PRICING = 'NON_LEAF_PRICING',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosPricingsServicesPricings_ExplainPricingRequestInput = {
  pricingUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosPricingsServicesPricings_ExplainPricingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosPricingsServicesPricings_GetPricingRequestInput = {
  pricingUuid?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosPricingsServicesPricings_GetPricingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Request to create sell direct pricing
 * Service fetches all required data internally using the flip_token
 */
export type OdProtosPricingsServicesPricings_GetSellDirectPricingRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mirrors Ruby's NetCash::Calculator#run! `is_final_offer_calculation` kwarg.
   * When false (preliminary offer flows, e.g. initiate_automated_offer_job),
   * py-pricings zeroes out the post-inspection cost inputs
   * (cost_scoped_prelist_repairs_cents, cost_scoped_renovations_cents,
   * subsidy_seller_cx_cents) to match Ruby's
   * NetCash::Calculator#shared_target_net_cash_and_unit_economics_inputs
   * gating. When true (underwriting / final offer flows) those costs are
   * passed through from GetAcquisitionData as-is.
   */
  isFinalOfferCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  lgmOverride?: InputMaybe<OdProtosPricingsData_LgmOverrideInput>;
  pricingType?: InputMaybe<OdProtosPricingsData_PricingType>;
  /**
   * OPTIONAL. When set, py-pricings uses this valuation directly instead of
   * calling GetLatestValuationForFlip's lifecycle-aware resolution. Used by
   * NetCash::Calculator's shadow call so py-pricings evaluates the exact
   * valuation Ruby just used.
   */
  valuationRef?: InputMaybe<OdProtosPricingsServicesPricings_ValuationRefInput>;
};

export type OdProtosPricingsServicesPricings_GetUnitEconomicsRequestInput = {
  pricingUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosPricingsServicesPricings_GetUnitEconomicsResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosPricingsServicesPricings_SubmitPostDiligenceVisitRepairScopeUpdateRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  /**
   * delta between original scope and revised scope
   *
   * In the future we might need more specificity to update economics?
   * common.Money revised_prelist_repair_estimate = 7;
   * common.Money revised_postlist_repair_estimate = 8;
   * common.Money revised_brn_estimate = 9;
   */
  scopeDifference?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export enum OdProtosPricingsServicesPricings_SubmitPostDiligenceVisitRepairScopeUpdateResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Identifies a specific valuation to use. When set on a pricing request,
 * py-pricings uses this valuation directly and skips lifecycle-aware lookup.
 * Mirrors TARGET_NET_CASH.{valuation_id, valuation_type}.
 *
 * `id` is a string so we can accommodate future non-integer identifiers
 * (e.g. UUIDs) without a proto migration. Today it carries the numeric
 * Valuation / EnsembledValuation primary key as a decimal string.
 */
export type OdProtosPricingsServicesPricings_ValuationRefInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosPricingsServicesPricings_ValuationRef_Type>;
};

export enum OdProtosPricingsServicesPricings_ValuationRef_Type {
  UNKNOWN = 'UNKNOWN',
  WEB_ENSEMBLED_VALUATION = 'WEB_ENSEMBLED_VALUATION',
  WEB_VALUATION = 'WEB_VALUATION'
}

export type OdProtosProjectionsDataFlip_ListingInput = {
  /** acquisition close date in "YYYY-MM-DD" format */
  acquisitionCloseDateIso8601?: InputMaybe<Scalars['String']['input']>;
  /** the address token of the property */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** after renovation valuation in cents */
  afterRenovationValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** current list price in cents */
  currentListPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** we need flip token to retrieve RestB score */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /** initial list price in cents */
  initialListPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** whether the home is an Opendoor home or not */
  isOpendoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** when the last price change occurred */
  lastPriceChangeDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  /** list date in "YYYY-MM-DD" format */
  listDateIso8601?: InputMaybe<Scalars['String']['input']>;
  /** list valuation in cents */
  listValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** market area of the flip */
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** list date in "YYYY-MM-DD" format */
  postListConditionDateIso8601?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosProjectionsServices_BulkProjectionPostListRequestInput = {
  listings?: InputMaybe<Array<OdProtosProjectionsDataFlip_ListingInput>>;
};

export enum OdProtosProjectionsServices_InitialMarkupLineItemSource {
  OVERLAY = 'OVERLAY',
  PCF_MODEL = 'PCF_MODEL',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE'
}

export type OdProtosProjectionsServices_InitialMarkupRecommendationRequestInput = {
  /** the address token of the property */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Flip token, for RestB pre-list fetching */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /** ILP valuation in cents */
  initialListPriceValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** market area of the flip */
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosProjectionsServices_ProjectionPostListRequestInput = {
  listing?: InputMaybe<OdProtosProjectionsDataFlip_ListingInput>;
};

export type OdProtosPropertyDataStoreServices_AddressAutocompleteRequestInput = {
  /** If true, suggestions will include properties with invalid addresses */
  allowInvalidAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  /** If specified, properties matching these listing states are excluded from suggestions */
  excludeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /**
   * If specified, results will include the full Property of the suggestion
   * To maximize performance, set this to false
   */
  fetchProperties?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Configures the level of fuzziness applied to the suggestion query
   * For strict prefix matching, use FUZZINESS_NONE
   */
  fuzziness?: InputMaybe<OdProtosPropertyDataStoreServices_Fuzziness>;
  /** If specified, only properties matching these listing states are suggested */
  includeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /** Optional. If specified, results will include matching suggestions closer to this point first */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** The max number of suggestions to return. Capped at 50. Defaults to 5. */
  limit?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyDataStoreServices_BulkRefreshPropertyRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPropertyDataStoreServices_BwodFilterInput = {
  marketIdentifiers?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export enum OdProtosPropertyDataStoreServices_Fuzziness {
  FUZZINESS_AUTO = 'FUZZINESS_AUTO',
  FUZZINESS_NONE = 'FUZZINESS_NONE',
  FUZZINESS_UNKNOWN = 'FUZZINESS_UNKNOWN'
}

export type OdProtosPropertyDataStoreServices_GetPropertiesByAddressIdRequestInput = {
  /** Maximum of 1000 ids per request enforced */
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPropertyDataStoreServices_GetPropertyByAddressIdRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyDataStoreServices_MinMaxFilterInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPropertyDataStoreServices_MinMaxFloatFilterInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPropertyDataStoreServices_PaginationRequestInput = {
  from?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 43 */
export type OdProtosPropertyDataStoreServices_PropertyFiltersInput = {
  /** Optionally filters the results to properties within some range of above grade sq footage */
  aboveGradeSqFt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Optionally filters the results to properties within some range of basement sq footage */
  basementSqFt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /**
   * Optionally filters the results to properties having some range of bathrooms
   * Note: current convention is to count half baths as 0.5; so 2 full 2 half house = 3.0 total
   */
  bathroomsTotal?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFloatFilterInput>;
  /** Optionally filters the results to properties having some range of bedrooms */
  bedrooms?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** If bwod markets are defined in filter, only properties that are currently eligible for BwOD Offers (and in those markets) are returned */
  bwodOfferable?: InputMaybe<OdProtosPropertyDataStoreServices_BwodFilterInput>;
  /** If bwod markets are defined in filter, only properties that are currently eligible for BwOD Tours (and in those markets) are returned */
  bwodTourable?: InputMaybe<OdProtosPropertyDataStoreServices_BwodFilterInput>;
  /** Optionally filters results to properties in a specific city (case-insensitive) */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Optionally filters the results to properties within some range of current list price */
  currentListPrice?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** If empty, properties of any dwelling type are returned. If specified, only those properties matching these dwelling types are returned */
  dwellingTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Any address ids specified in exclude_address_ids are filtered out of search results */
  excludeAddressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If specified, properties matching these states are excluded */
  excludeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /** Include properties that have indexed_at >= gte_indexed_at */
  gteIndexedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include properties that have listed_at >= gte_listed_at */
  gteListedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include properties that have pending_at >= gte_pending_at */
  gtePendingAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include properties that have sold_at >= gte_sold_at */
  gteSoldAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If true, only properties with photos are returned. If false, only properties without photos are returned
   * Does NOT indicate whether those photos are downloaded in Cabinet, only that they are known to exist on the sell request
   */
  hasPhotos?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only properties with pool are returned. If false, only properties with no pool are returned */
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to false to exclude all properties with a takedown request. If true, only taken-down properties are returned */
  hasTakedown?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayable?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only properties that are currently eligible to be purchased with an FHA loan are returned */
  isFhaEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only new construction properties are returned. If false, new construction properties are excluded */
  isNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally filters the results to only Opendoor-owned properties */
  isOpendoorOwned?: InputMaybe<Scalars['Boolean']['input']>;
  /** If empty, properties with any current listing state are returned. If specified, only those properties matching these states are returned */
  listingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /** Optionally filters the results to properties within some range of lot size */
  lotSqFt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Include properties that have indexed_at < lt_indexed_at */
  ltIndexedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include properties that have listed_at < lt_listed_at */
  ltListedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include properties that have been pending_at < lt_pending_at */
  ltPendingAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include properties that have sold_at < lt_sold_at */
  ltSoldAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally filters the results to properties within some range of monthly HOA dues */
  monthlyHoaDues?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /**
   * If empty, all properties, regardless of photo status are returned.
   * If specified, only those properties with photos known to already be available in Cabinet *or*
   *   those created in ODLS before (now - threshold) are returned.
   * That way, we don't indefinitely exclude Properties that will *never* have photos from search results
   * Set to -1 to return properties without cabinet photos downloaded
   */
  photoThresholdSeconds?: InputMaybe<Scalars['Float']['input']>;
  /** If true, only currently-popular (based on page views) properties are returned */
  popular?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally filters results to properties in specific postal/zip codes */
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, only properties that are available for self-touring are returned. If false, only those properties without self-touring are returned */
  selfTourAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally filters the results to properties within some range of sold price price */
  soldPrice?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Optionally filters results to properties in a specific state (2-letter code, case-insensitive) */
  state?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optionally filters the results to properties with some range of stories
   * Uses interior stories where available, otherwise falls back on exterior stories
   */
  stories?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Optionally filters the results to only properties with a matching subdivision value */
  subdivision?: InputMaybe<Scalars['String']['input']>;
  /** Optionally filters the results to properties within some range of total sq footage */
  totalLivingSqFt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Optionally filters the results to properties built within some range of years */
  yearBuilt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** If specified, only those properties within the specified GDS zones are returned */
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPropertyDataStoreServices_RefreshPropertyRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyDataStoreServices_SearchPropertiesByFieldsRequestInput = {
  filters?: InputMaybe<OdProtosPropertyDataStoreServices_PropertyFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosPropertyDataStoreServices_PaginationRequestInput>;
  sortKey?: InputMaybe<OdProtosPropertyDataStoreServices_SearchPropertiesRequest_SortKey>;
};

export type OdProtosPropertyDataStoreServices_SearchPropertiesByQueryRequestInput = {
  /** If specified, filter criteria will be applied to limit the search results */
  filters?: InputMaybe<OdProtosPropertyDataStoreServices_PropertyFiltersInput>;
  /** If specified, results will include results closer to this point first */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  paginationRequest?: InputMaybe<OdProtosPropertyDataStoreServices_PaginationRequestInput>;
  queryString?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyDataStoreServices_SearchPropertiesRequestInput = {
  /** If specified, filter criteria will be applied to limit the search results */
  filters?: InputMaybe<OdProtosPropertyDataStoreServices_PropertyFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosPropertyDataStoreServices_PaginationRequestInput>;
  /** GeoJSON shape (must be polygon or multipolygon) */
  shape?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<OdProtosPropertyDataStoreServices_SearchPropertiesRequest_SortKey>;
};

export enum OdProtosPropertyDataStoreServices_SearchPropertiesRequest_SortKey {
  SORT_KEY_CURRENT_LIST_PRICE_ASC = 'SORT_KEY_CURRENT_LIST_PRICE_ASC',
  SORT_KEY_CURRENT_LIST_PRICE_DESC = 'SORT_KEY_CURRENT_LIST_PRICE_DESC',
  SORT_KEY_DEFAULT = 'SORT_KEY_DEFAULT',
  SORT_KEY_INDEXED_AT_ASC = 'SORT_KEY_INDEXED_AT_ASC',
  SORT_KEY_INDEXED_AT_DESC = 'SORT_KEY_INDEXED_AT_DESC',
  SORT_KEY_LISTED_AT_ASC = 'SORT_KEY_LISTED_AT_ASC',
  SORT_KEY_LISTED_AT_DESC = 'SORT_KEY_LISTED_AT_DESC',
  SORT_KEY_NONE = 'SORT_KEY_NONE',
  SORT_KEY_TOTAL_LIVING_SQ_FT_ASC = 'SORT_KEY_TOTAL_LIVING_SQ_FT_ASC',
  SORT_KEY_TOTAL_LIVING_SQ_FT_DESC = 'SORT_KEY_TOTAL_LIVING_SQ_FT_DESC'
}

/**
 * ActorType describes an entity that can be associated with a given lifecycle
 * domain object (PE / PT etc).
 */
export enum OdProtosPropertyLifecycleDataActors_ActorType {
  CONTACT_CUSTOMER = 'CONTACT_CUSTOMER',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosPropertyLifecycleDataDip_DipBucketInput = {
  fromDurationDays?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['Float']['input']>;
  stageId?: InputMaybe<Scalars['String']['input']>;
  toDurationDays?: InputMaybe<Scalars['Float']['input']>;
  /** Only populated in response (for obvious reasons) */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosPropertyLifecycleDataPropertyEngagements_Assessment_State {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  SCHEDULED = 'SCHEDULED',
  UNKNOWN = 'UNKNOWN',
  WAITING_FOR_CUSTOMER = 'WAITING_FOR_CUSTOMER'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_BuyerRepairNegotiation_State {
  ACCEPTED = 'ACCEPTED',
  ADDENDUM_OUT = 'ADDENDUM_OUT',
  CANCELED = 'CANCELED',
  CREDIT_ONLY_ACCEPTED = 'CREDIT_ONLY_ACCEPTED',
  DRAFT = 'DRAFT',
  ESTIMATING = 'ESTIMATING',
  ESTIMATION_COMPLETE = 'ESTIMATION_COMPLETE',
  RENEGOTIATING = 'RENEGOTIATING',
  UNKNOWN = 'UNKNOWN',
  WORK_COMPLETED = 'WORK_COMPLETED',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS',
  ZERO_WORK_COMPLETED = 'ZERO_WORK_COMPLETED'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_BwodLead_State {
  /** @deprecated No longer supported */
  OFFERED = 'OFFERED',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_DebtFinancing_State {
  FUNDED = 'FUNDED',
  IN_PROGRESS = 'IN_PROGRESS',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_DigitalCheckout_State {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_DirectLead_State {
  CREATED = 'CREATED',
  DENIED = 'DENIED',
  PRELIM_OFFER_SENT = 'PRELIM_OFFER_SENT',
  QUALIFIED = 'QUALIFIED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_State {
  /** Terminated Success */
  CLOSED = 'CLOSED',
  /**
   * Deprecated: New offers will not enter these states
   * Old offers may be in these states
   * @deprecated No longer supported
   */
  CREATED = 'CREATED',
  /** Terminated Failure */
  CUSTOMER_WITHDRAWN = 'CUSTOMER_WITHDRAWN',
  ENTERED_CONTRACT = 'ENTERED_CONTRACT',
  /** Terminated Failure */
  EXPIRED = 'EXPIRED',
  FINAL_OFFER_SENT = 'FINAL_OFFER_SENT',
  /**
   * Will stay in FINAL_OFFER_SENT until we enter contract
   * @deprecated No longer supported
   */
  FINAL_OFFER_VIEWED = 'FINAL_OFFER_VIEWED',
  /**
   * We are in LATE_CHECKOUT when we own the home, but we don't have
   * possession yet due to late checkout
   */
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  /** Terminated Failure */
  OPENDOOR_WITHDRAWN = 'OPENDOOR_WITHDRAWN',
  /** This PE will start once the prelim offer is sent */
  PRELIM_OFFER_SENT = 'PRELIM_OFFER_SENT',
  /**
   * Replaced by ENTERED_CONTRACT
   * @deprecated No longer supported
   */
  RELEASED_CONTINGENCIES = 'RELEASED_CONTINGENCIES',
  UNKNOWN = 'UNKNOWN',
  /**
   * Replaced by CUSTOMER_WITHDRAWN and OPENDOOR_WITHDRAWN
   * @deprecated No longer supported
   */
  WITHDRAWN = 'WITHDRAWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_ExclusiveListing_State {
  /** @deprecated No longer supported */
  AWAITING_SELLER_COMMITMENT = 'AWAITING_SELLER_COMMITMENT',
  /** @deprecated No longer supported */
  EXPIRED = 'EXPIRED',
  /** @deprecated No longer supported */
  IN_CONTRACT = 'IN_CONTRACT',
  /** @deprecated No longer supported */
  LISTED = 'LISTED',
  /** @deprecated No longer supported */
  SETUP_STARTED = 'SETUP_STARTED',
  /** @deprecated No longer supported */
  SOLD = 'SOLD',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_State {
  ACTIVE = 'ACTIVE',
  ATTORNEY_REVIEW = 'ATTORNEY_REVIEW',
  CANCELED = 'CANCELED',
  CONTINGENCY_RELEASED = 'CONTINGENCY_RELEASED',
  INACTIVE = 'INACTIVE',
  IN_CONTRACT = 'IN_CONTRACT',
  SOLD = 'SOLD',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_HomeAccessMonitoring_State {
  ACCESS_AVAILABLE = 'ACCESS_AVAILABLE',
  ACCESS_MONITORING_AVAILABLE = 'ACCESS_MONITORING_AVAILABLE',
  COMPLETED = 'COMPLETED',
  MONITORING_AVAILABLE = 'MONITORING_AVAILABLE',
  REQUESTED = 'REQUESTED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_InventoryListing_State {
  ACTIVE = 'ACTIVE',
  ATTORNEY_REVIEW = 'ATTORNEY_REVIEW',
  CANCELED = 'CANCELED',
  CONTINGENCY_RELEASED = 'CONTINGENCY_RELEASED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  SOLD = 'SOLD',
  UNKNOWN = 'UNKNOWN',
  UPCOMING = 'UPCOMING'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_InventoryMaintenance_State {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_InventoryReno_State {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_State {
  ACQUIRING = 'ACQUIRING',
  NOT_ACQUIRED = 'NOT_ACQUIRED',
  ON_THE_MARKET = 'ON_THE_MARKET',
  PREP_FOR_RESALE = 'PREP_FOR_RESALE',
  RESERVED = 'RESERVED',
  SELLABLE = 'SELLABLE',
  SELLING = 'SELLING',
  /** OWNERSHIP_EXCEPTION = 9; */
  SOLD = 'SOLD',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_LenderRequiredRepairs_State {
  ADDENDUM_ACCEPTED = 'ADDENDUM_ACCEPTED',
  ADDENDUM_CREATED = 'ADDENDUM_CREATED',
  CANCELED = 'CANCELED',
  CREATED = 'CREATED',
  DRAFT = 'DRAFT',
  ESTIMATED = 'ESTIMATED',
  UNKNOWN = 'UNKNOWN',
  WORK_ORDERS_COMPLETE = 'WORK_ORDERS_COMPLETE',
  WORK_ORDERS_CREATED = 'WORK_ORDERS_CREATED'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_Metadata_MaintenanceKind {
  CLEANING = 'CLEANING',
  HVAC = 'HVAC',
  LANDSCAPING = 'LANDSCAPING',
  OTHER = 'OTHER',
  POOL = 'POOL',
  SNOW = 'SNOW',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_State {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  FINISHED = 'FINISHED',
  REQUESTED = 'REQUESTED',
  SCHEDULED = 'SCHEDULED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_State {
  /** @deprecated No longer supported */
  ACTIVE = 'ACTIVE',
  /** @deprecated No longer supported */
  AWAITING_SIGNATURE = 'AWAITING_SIGNATURE',
  /** @deprecated No longer supported */
  BUYER_WALKED = 'BUYER_WALKED',
  /** @deprecated No longer supported */
  CANCELED = 'CANCELED',
  /** @deprecated No longer supported */
  CLOSED = 'CLOSED',
  /** @deprecated No longer supported */
  CONTINGENCIES_RELEASED = 'CONTINGENCIES_RELEASED',
  /** @deprecated No longer supported */
  CONTRACT_FELL_THROUGH = 'CONTRACT_FELL_THROUGH',
  /** @deprecated No longer supported */
  IN_CONTRACT = 'IN_CONTRACT',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_State {
  /** @deprecated No longer supported */
  ACQ_WITHDRAWN = 'ACQ_WITHDRAWN',
  /** @deprecated No longer supported */
  CANCELED = 'CANCELED',
  /** @deprecated No longer supported */
  CONTINGENCIES_RELEASED = 'CONTINGENCIES_RELEASED',
  /** @deprecated No longer supported */
  IN_CONTRACT = 'IN_CONTRACT',
  /** @deprecated No longer supported */
  LISTED = 'LISTED',
  /** @deprecated No longer supported */
  PRE_RENOVATION = 'PRE_RENOVATION',
  /** @deprecated No longer supported */
  RESALE_CONTINGENCIES_RELEASED = 'RESALE_CONTINGENCIES_RELEASED',
  /** @deprecated No longer supported */
  RESALE_IN_CONTRACT = 'RESALE_IN_CONTRACT',
  /** @deprecated No longer supported */
  SOLD = 'SOLD',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_ReitReno_State {
  /** Terminal sad */
  CANCELED = 'CANCELED',
  /** Terminal happy */
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  PLANNED = 'PLANNED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_RenoPrep_State {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  REQUESTED = 'REQUESTED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_State {
  /** Terminal sad */
  CANCELED = 'CANCELED',
  /** Terminal happy */
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  PLANNED = 'PLANNED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_RenoRepairScoping_State {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  REQUESTED = 'REQUESTED',
  STARTED = 'STARTED',
  UNKNOWN = 'UNKNOWN'
}

/** Kind is analgous to listing offer channel. */
export enum OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_Metadata_Kind {
  /** Opendoor is the brokerage */
  BROKERAGE = 'BROKERAGE',
  /** Buy Direct */
  DIRECT = 'DIRECT',
  /**
   * Exclusive Listing
   * @deprecated No longer supported
   */
  EXCLUSIVE = 'EXCLUSIVE',
  /**
   * Exclusive Third Party (3P)
   * @deprecated No longer supported
   */
  EXCLUSIVE_THIRD_PARTY = 'EXCLUSIVE_THIRD_PARTY',
  /** External Listing */
  EXTERNAL = 'EXTERNAL',
  REIT = 'REIT',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_State {
  ACTIVE = 'ACTIVE',
  ATTORNEY_REVIEW = 'ATTORNEY_REVIEW',
  AWAITING_SIGNATURE = 'AWAITING_SIGNATURE',
  BACKUP = 'BACKUP',
  BUYER_WALKED = 'BUYER_WALKED',
  /** This state is terminal (sad). */
  CANCELED = 'CANCELED',
  /** This state is terminal (happy). */
  CLOSED = 'CLOSED',
  CONTINGENCIES_RELEASED = 'CONTINGENCIES_RELEASED',
  CONTRACT_FELLTHROUGH = 'CONTRACT_FELLTHROUGH',
  COUNTERED = 'COUNTERED',
  IN_CONTRACT = 'IN_CONTRACT',
  IN_NEGOTIATION = 'IN_NEGOTIATION',
  /** This state is terminal (sad). */
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_State {
  ACTIVE = 'ACTIVE',
  ATTORNEY_REVIEW = 'ATTORNEY_REVIEW',
  CANCELED = 'CANCELED',
  CONTINGENCY_RELEASED = 'CONTINGENCY_RELEASED',
  INACTIVE = 'INACTIVE',
  IN_CONTRACT = 'IN_CONTRACT',
  SOLD = 'SOLD',
  UNKNOWN = 'UNKNOWN'
}

/** The list of supported property engagement types */
export enum OdProtosPropertyLifecycleDataPropertyEngagements_Type {
  ACQUISITION_DATA_LABELING = 'ACQUISITION_DATA_LABELING',
  ACQUISITION_REPAIR_BUDGET_REVIEW = 'ACQUISITION_REPAIR_BUDGET_REVIEW',
  ACQUISITION_RISK_ASSESSMENT = 'ACQUISITION_RISK_ASSESSMENT',
  ACQUISITION_UNDERWRITING = 'ACQUISITION_UNDERWRITING',
  ACQUISITION_VALUATION = 'ACQUISITION_VALUATION',
  ASSESSSMENT = 'ASSESSSMENT',
  BUYER_REPAIR_NEGOTIATION = 'BUYER_REPAIR_NEGOTIATION',
  /** @deprecated No longer supported */
  BWOD_LEAD = 'BWOD_LEAD',
  DEBT_FINANCING = 'DEBT_FINANCING',
  DIGITAL_CHECKOUT = 'DIGITAL_CHECKOUT',
  /** @deprecated No longer supported */
  DIRECT_LEAD = 'DIRECT_LEAD',
  DIRECT_OFFER = 'DIRECT_OFFER',
  /** @deprecated No longer supported */
  EXCLUSIVE_LISTING = 'EXCLUSIVE_LISTING',
  EXTERNAL_LISTING = 'EXTERNAL_LISTING',
  HOME_ACCESS_MONITORING = 'HOME_ACCESS_MONITORING',
  INVENTORY = 'INVENTORY',
  INVENTORY_LISTING = 'INVENTORY_LISTING',
  INVENTORY_MAINTENANCE = 'INVENTORY_MAINTENANCE',
  INVENTORY_RENO = 'INVENTORY_RENO',
  LENDER_REQUIRED_REPAIRS = 'LENDER_REQUIRED_REPAIRS',
  MAINTENANCE_SCHEDULE = 'MAINTENANCE_SCHEDULE',
  /** @deprecated No longer supported */
  OBO_BUYER_OFFER = 'OBO_BUYER_OFFER',
  /** @deprecated No longer supported */
  OBO_BWOD_OFFER = 'OBO_BWOD_OFFER',
  REIT_RENO = 'REIT_RENO',
  /** @deprecated No longer supported */
  RENO_PREP = 'RENO_PREP',
  RENO_PROJECT_EXECUTION = 'RENO_PROJECT_EXECUTION',
  /** @deprecated No longer supported */
  RENO_REPAIR_SCOPING = 'RENO_REPAIR_SCOPING',
  RESALE_BUYER_OFFER = 'RESALE_BUYER_OFFER',
  RESALE_BUY_DIRECT = 'RESALE_BUY_DIRECT',
  RESALE_INVENTORY = 'RESALE_INVENTORY',
  RESALE_LISTING = 'RESALE_LISTING',
  /** register all PE types here */
  SELL_WITH_UPSIDE_PRICING = 'SELL_WITH_UPSIDE_PRICING',
  /** @deprecated No longer supported */
  THIRD_PARTY_MARKETPLACE_LISTING = 'THIRD_PARTY_MARKETPLACE_LISTING',
  UNKNOWN = 'UNKNOWN'
}

/**
 * LifecycleState describes the lifecycle state of a property engagement or
 * property task from the perspective of the property lifecycle domain.
 *
 * Domain-specific PE/PT states are tracked separately and are defined
 * on a per-PE/PT basis
 */
export enum OdProtosPropertyLifecycleData_LifecycleState {
  /**
   * The PE/PT is active. When a PE/PT is ACTIVE, its domain state is used to
   * reflect its state specific to the type of PE/PT
   */
  ACTIVE = 'ACTIVE',
  /** The PE/PT is in a paused state */
  PAUSED = 'PAUSED',
  /**
   * The PLD has requested that the implementing domain create a PE/PT,
   * however an event confirming its creation hasn't been received yet
   */
  REQUESTED = 'REQUESTED',
  /** The PE/PT has terminated with a failure */
  TERMINATED_FAILURE = 'TERMINATED_FAILURE',
  /** The PE/PT has terminated successfully */
  TERMINATED_SUCCESS = 'TERMINATED_SUCCESS',
  UNKNOWN = 'UNKNOWN'
}

/**
 * The LifecycleState enum provides is used to notify the property lifecycle
 * domain how a property engagement's lifecycle state has changed from within
 * a domain event.
 */
export enum OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_LifecycleState {
  /** The property engagement is active */
  ACTIVE = 'ACTIVE',
  /** The property engagement has terminated with a failed outcome */
  TERMINATED_FAILURE = 'TERMINATED_FAILURE',
  /** The property engagement has terminated with a successful outcome */
  TERMINATED_SUCCESS = 'TERMINATED_SUCCESS',
  /**
   * The property engagement's lifecycle state is unchanged by this
   * domain event
   */
  UNKNOWN = 'UNKNOWN'
}

/**
 * The LifecycleState enum provides is used to notify the property lifecycle
 * domain how a property engagement's lifecycle state has changed from within
 * a domain event.
 */
export enum OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_LifecycleState {
  /** The property engagement is active */
  ACTIVE = 'ACTIVE',
  /** The property engagement has terminated with a failed outcome */
  TERMINATED_FAILURE = 'TERMINATED_FAILURE',
  /** The property engagement has terminated with a successful outcome */
  TERMINATED_SUCCESS = 'TERMINATED_SUCCESS',
  /**
   * The property engagement's lifecycle state is unchanged by this
   * domain event
   */
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosPropertyLifecycleServicesDip_GetDipMetrics_FiltersInput = {
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPropertyLifecycleServicesDip_GetDipMetrics_RequestInput = {
  filters?: InputMaybe<OdProtosPropertyLifecycleServicesDip_GetDipMetrics_FiltersInput>;
};

export type OdProtosPropertyLifecycleServicesDip_GetDipProperties_FiltersInput = {
  /** List of client-defined buckets. Each has a specific associated stage ID from the server. */
  buckets?: InputMaybe<Array<OdProtosPropertyLifecycleDataDip_DipBucketInput>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPropertyLifecycleServicesDip_GetDipProperties_PaginationInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPropertyLifecycleServicesDip_GetDipProperties_RequestInput = {
  filters?: InputMaybe<OdProtosPropertyLifecycleServicesDip_GetDipProperties_FiltersInput>;
  pagination?: InputMaybe<OdProtosPropertyLifecycleServicesDip_GetDipProperties_PaginationInput>;
};

export type OdProtosPropertyLifecycleServices_ApplyBpmnMigration_RequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosPropertyLifecycleServices_DeletePropertyEngagement_RequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosPropertyLifecycleServices_DipAggregationType {
  AVERAGE = 'AVERAGE',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosPropertyLifecycleServices_EnqueueBackfill_RequestInput = {
  backfillAllFlips?: InputMaybe<Scalars['Boolean']['input']>;
  backfillAllYears?: InputMaybe<Scalars['Boolean']['input']>;
  /** if set it will run the PE metadata backfill */
  backfillPeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  backfillPeMetadataLimit?: InputMaybe<Scalars['Float']['input']>;
  backfillPeMetadataOffset?: InputMaybe<Scalars['Float']['input']>;
  /** if set will run only state mismatch data fix and COE date mismatch */
  dataFix?: InputMaybe<Scalars['Boolean']['input']>;
  /** if set will run only the incremental PE backfill */
  incremental?: InputMaybe<Scalars['Boolean']['input']>;
  /** if set will run only the inventory PE backfill */
  inventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** if set it will run the inventory listing backfill */
  inventoryListing?: InputMaybe<Scalars['Boolean']['input']>;
  /** if set it will run the inventory reno backfill */
  inventoryReno?: InputMaybe<Scalars['Boolean']['input']>;
  /** if set it will run the maintenance schedule backfill */
  maintenanceSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  tier?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPropertyLifecycleServices_GetDipMetrics_RequestInput = {
  aggregationType?: InputMaybe<OdProtosPropertyLifecycleServices_DipAggregationType>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementEventLog_RequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_RequestInput = {
  /** by is the primary filter */
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneofInput>;
  /**
   * fetch_events: if set the service will populate all events for the
   * PE's in the response
   */
  fetchEvents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Each filter is AND'd together, for example, returned PEs must be one of the PE types, one of the states given, etc. */
  filter?: InputMaybe<Array<OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_FilterInput>>;
  paginationRequest?: InputMaybe<OdProtosPropertyLifecycleServices_PaginationRequestInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneofInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementGroupIds?: InputMaybe<OdProtosPropertyLifecycleServices_PropertyEngagementGroupIDsInput>;
  propertyEngagementIds?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_PropertyEngagementIDsInput>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_FilterInput = {
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_Filter_ByOneofInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_Filter_ByOneofInput = {
  lifecycleStates?: InputMaybe<OdProtosPropertyLifecycleServices_LifecycleStatesInput>;
  /**
   * When min_completed_at is set it filters out all
   * PEs completed before that date.
   * Note that uncompleted PEs will not be filtered out.
   */
  minCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  propertyEngagementTypes?: InputMaybe<OdProtosPropertyLifecycleServices_PropertyEngagementTypesInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_PropertyEngagementIDsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagements_RequestInput = {
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_ByOneofInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_ByOneofInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementIds?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_PropertyEngagementIDsInput>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_PropertyEngagementIDsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEventLog_RequestInput = {
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEventLog_Request_ByOneofInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEventLog_Request_ByOneofInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyLifecycleServices_GetProperty_RequestInput = {
  /**
   * Property can be referenced either by the PLD property ID or
   * the address token currently mapped to the property
   */
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetProperty_Request_ByOneofInput>;
};

export type OdProtosPropertyLifecycleServices_GetProperty_Request_ByOneofInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosPropertyLifecycleServices_LifecycleStatesInput = {
  allowedLifecycleStates?: InputMaybe<Array<OdProtosPropertyLifecycleData_LifecycleState>>;
};

export type OdProtosPropertyLifecycleServices_PaginationRequestInput = {
  /**
   * after is the cursor value at which point we should start
   * leave blank to start in the beginning
   */
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosPropertyLifecycleServices_PropertyEngagementGroupIDsInput = {
  propertyEngagementGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosPropertyLifecycleServices_PropertyEngagementTypesInput = {
  types?: InputMaybe<Array<OdProtosPropertyLifecycleDataPropertyEngagements_Type>>;
};

export type OdProtosQacServices_CheckForServiceRequestInput = {
  envId?: InputMaybe<Scalars['String']['input']>;
  /** The k8s service name (in staging) of the service */
  stagingName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_CreateEnvRequestInput = {
  /** Arbitrary name, usually branch or PR */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user who created the environment */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_DeleteEnvRequestInput = {
  envId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_GetEnvRequestInput = {
  envId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_GithubSpecInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  cloneDb?: InputMaybe<Scalars['Boolean']['input']>;
  /** Typically you will just set one or the other of these, although setting both is supported. */
  imageTag?: InputMaybe<Scalars['String']['input']>;
  /** substitute for repo/path */
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  /** Used to redeploy on pushes. If set, ignore image_tag and branch. */
  prUrl?: InputMaybe<Scalars['String']['input']>;
  repo?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_GooseMockInput = {
  /** E.g., prices.acquisition.testing.TestFeeService. See goose README */
  gooseModule?: InputMaybe<Scalars['String']['input']>;
  /** The k8s service name (in staging) of the service being mocked */
  stagingName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_GooseMocksInput = {
  /** Github branch of Goose mocks (if not master). Will be deprecated once PR pipelines are setup */
  branch?: InputMaybe<Scalars['String']['input']>;
  grpc?: InputMaybe<Array<OdProtosQacServices_GooseMockInput>>;
  /** Not supported yet */
  http?: InputMaybe<Array<OdProtosQacServices_GooseMockInput>>;
  /** Goose Docker image tag. Will be deprecated once PR pipelines for building images is setup */
  imageTag?: InputMaybe<Scalars['String']['input']>;
  /** Used to redeploy on pushes. If set, ignore image_tag and branch. */
  prUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_HandlePullRequestEventRequestInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  prUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_ListEnvsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosQacServices_PostponeEnvCleanupRequestInput = {
  envId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_RedeployServicesRequestInput = {
  /** Image tag for each path returned by ServicesForPr, or in service_branches */
  imageTags?: InputMaybe<Array<OdProtosQacServices_RedeployServicesRequest_ImageTagsEntryInput>>;
  /** If given, QAC redeploys all envs with services using this PR */
  prUrl?: InputMaybe<Scalars['String']['input']>;
  /** Redeploys all envs with services running on the given branches */
  serviceBranches?: InputMaybe<Array<OdProtosQacServices_ServiceBranchInput>>;
};

/** `OdProtosQacServices_RedeployServicesRequest_ImageTagsEntryInput` represents the `image_tags` map in `od_protos.qac.services.RedeployServicesRequest`. */
export type OdProtosQacServices_RedeployServicesRequest_ImageTagsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_ServiceBranchInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  repo?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_ServiceSpecInput = {
  spec?: InputMaybe<OdProtosQacServices_ServiceSpec_SpecOneofInput>;
};

export type OdProtosQacServices_ServiceSpec_SpecOneofInput = {
  github?: InputMaybe<OdProtosQacServices_GithubSpecInput>;
  /** See py/projects/goose */
  goose?: InputMaybe<OdProtosQacServices_GooseMocksInput>;
};

export type OdProtosQacServices_ServicesForPrRequestInput = {
  prUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_SetBuildUrlRequestInput = {
  buildUrl?: InputMaybe<Scalars['String']['input']>;
  prUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosQacServices_SetServicesRequestInput = {
  envId?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<OdProtosQacServices_ServiceSpecInput>>;
};

/** The actor doing the thing */
export type OdProtosRealtyCommon_ActorInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyCommon_AgentInformationInput = {
  contact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  license?: InputMaybe<OdProtosBrokeragesData_RealEstateLicenseInput>;
  mlsId?: InputMaybe<OdProtosBrokeragesData_MlsidInput>;
  officeMlsId?: InputMaybe<Scalars['String']['input']>;
  officeName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyCommon_CoeTermInput = {
  date?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyCommon_CommissionBreakdownInput = {
  buyer?: InputMaybe<OdProtosRealtyCommon_CommissionInput>;
  seller?: InputMaybe<OdProtosRealtyCommon_CommissionInput>;
};

export type OdProtosRealtyCommon_CommissionInput = {
  type?: InputMaybe<OdProtosRealtyCommon_Commission_TypeOneofInput>;
};

export type OdProtosRealtyCommon_Commission_TypeOneofInput = {
  flatCents?: InputMaybe<Scalars['Float']['input']>;
  /** `1 bip = 1%/100` = 1/10000 */
  rateBips?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Contact records information
 * about a contact. Person, organization, customer etc.
 */
export type OdProtosRealtyCommon_ContactInput = {
  address?: InputMaybe<OdProtosCommonData_AddressInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<OdProtosBrokeragesData_RealEstateLicenseInput>;
  mlsId?: InputMaybe<OdProtosBrokeragesData_MlsidInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<OdProtosRealtyCommon_PhoneNumberInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vendorBranchId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyCommon_CreditTermInput = {
  beneficiary?: InputMaybe<Scalars['String']['input']>;
  creditCents?: InputMaybe<Scalars['Float']['input']>;
  creditReason?: InputMaybe<Scalars['String']['input']>;
  responsibleParty?: InputMaybe<OdProtosRealtyCommon_PartyType>;
};

/**
 * Any disclosures that need to be made by either party.
 * Includes leans, easements, seller disclosures, or covenants.
 */
export type OdProtosRealtyCommon_DisclosureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<OdProtosRealtyCommon_Disclosure_IdentifierOneofInput>;
  kind?: InputMaybe<OdProtosRealtyCommon_Disclosure_Kind>;
};

export type OdProtosRealtyCommon_Disclosure_IdentifierOneofInput = {
  buyOfferId?: InputMaybe<Scalars['String']['input']>;
  negotiationId?: InputMaybe<Scalars['String']['input']>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRealtyCommon_Disclosure_Kind {
  COVENANT_DISCLOSURE = 'COVENANT_DISCLOSURE',
  EASEMENT_DISCLOSURE = 'EASEMENT_DISCLOSURE',
  FINANCING_DISCLOSURE = 'FINANCING_DISCLOSURE',
  LEAN_DISCLOSURE = 'LEAN_DISCLOSURE',
  OTHER_DISCLOSURE = 'OTHER_DISCLOSURE',
  SELLER_DISCLOSURE = 'SELLER_DISCLOSURE'
}

export type OdProtosRealtyCommon_FeeTermInput = {
  beneficiary?: InputMaybe<Scalars['String']['input']>;
  feeCents?: InputMaybe<Scalars['Float']['input']>;
  responsibleParty?: InputMaybe<OdProtosRealtyCommon_PartyType>;
};

export type OdProtosRealtyCommon_FinancingTermInput = {
  type?: InputMaybe<OdProtosRealtyCommon_FinancingTerm_FinancingType>;
};

export enum OdProtosRealtyCommon_FinancingTerm_FinancingType {
  ALL_CASH = 'ALL_CASH',
  CONVENTIONAL_LOAN = 'CONVENTIONAL_LOAN',
  FHA_LOAN = 'FHA_LOAN',
  TX_VA_LOAN = 'TX_VA_LOAN',
  UNKNOWN_FINANCING = 'UNKNOWN_FINANCING',
  USDA_LOAN = 'USDA_LOAN',
  VA_LOAN = 'VA_LOAN'
}

export type OdProtosRealtyCommon_OptionPeriodTermInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRealtyCommon_OtherTermInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRealtyCommon_PartyType {
  BUYER = 'BUYER',
  SELLER = 'SELLER',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRealtyCommon_PhoneNumberInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosRealtyCommon_PhoneNumber_Type>;
};

export enum OdProtosRealtyCommon_PhoneNumber_Type {
  FAX = 'FAX',
  HOME = 'HOME',
  MOBILE = 'MOBILE',
  OTHER = 'OTHER',
  WORK = 'WORK'
}

export type OdProtosRealtyCommon_PriceTermInput = {
  priceCents?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosRealtyCommon_RepairTermInput = {
  requiredRepairDescription?: InputMaybe<Scalars['String']['input']>;
  responsibleParty?: InputMaybe<OdProtosRealtyCommon_PartyType>;
};

export type OdProtosRealtyCommon_SourceInput = {
  /** Optional. The private/system ID from the source. For example, the MLS resource ID. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Required. The public/known ID from the source. For example, the MLS number. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Used when type is `MLS`. */
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  /** Required. The type of the source information for grouping/sorting later. */
  type?: InputMaybe<OdProtosRealtyCommon_Source_Type>;
};

export enum OdProtosRealtyCommon_Source_Type {
  /** From a homebuilder. */
  HOMEBUILDER = 'HOMEBUILDER',
  /** From a listing agent and off MLS. */
  LISTING_AGENT = 'LISTING_AGENT',
  /** From an MLS. If set, please also set the mls field. */
  MLS = 'MLS',
  /** From Opendoor, when they are selling (e.g. resale). */
  PROP_CO = 'PROP_CO',
  /** From a direct seller who entered their address on the Opendoor seller flow. */
  SELLER_CO = 'SELLER_CO',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

/**
 * A contractual term that can become part of the contract if both parties agree to it.
 *
 * Terms are immutable--the details may never be modified.
 * In SellRequests and BuyOffers, terms may be freely added and deleted.
 * In Negotiations, terms may be proposed but not deleted. If a term should be removed, both
 * parties must REJECT the term.
 */
export type OdProtosRealtyCommon_TermInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proposedAt?: InputMaybe<Scalars['DateTime']['input']>;
  proposerParty?: InputMaybe<OdProtosRealtyCommon_PartyType>;
  proposerUserToken?: InputMaybe<Scalars['String']['input']>;
  termOneof?: InputMaybe<OdProtosRealtyCommon_TermOneofInput>;
};

/** Wrapper around term oneof. */
export type OdProtosRealtyCommon_TermOneofInput = {
  type?: InputMaybe<OdProtosRealtyCommon_TermOneof_TypeOneofInput>;
};

export type OdProtosRealtyCommon_TermOneof_TypeOneofInput = {
  coe?: InputMaybe<OdProtosRealtyCommon_CoeTermInput>;
  credit?: InputMaybe<OdProtosRealtyCommon_CreditTermInput>;
  fee?: InputMaybe<OdProtosRealtyCommon_FeeTermInput>;
  financing?: InputMaybe<OdProtosRealtyCommon_FinancingTermInput>;
  optionPeriod?: InputMaybe<OdProtosRealtyCommon_OptionPeriodTermInput>;
  other?: InputMaybe<OdProtosRealtyCommon_OtherTermInput>;
  price?: InputMaybe<OdProtosRealtyCommon_PriceTermInput>;
  repair?: InputMaybe<OdProtosRealtyCommon_RepairTermInput>;
};

/**
 * these values needs to correspond to od_protos.realty.clearinghouse.data.Transaction.State
 * in order for Proforma and Clearinghouse to understand each other
 */
export enum OdProtosRealtyDocumentsData_ClearinghouseSpecific_ClearinghouseState {
  CLOSED = 'CLOSED',
  DISCARDED = 'DISCARDED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  /** NONE indicates that no state is chosen */
  NONE = 'NONE',
  OPEN = 'OPEN',
  REJECTED = 'REJECTED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/**
 * these values needs to correspond to od_protos.realty.clearinghouse.data.TermType.Type
 * in order for Proforma and Clearinghouse to understand each other
 */
export enum OdProtosRealtyDocumentsData_ClearinghouseSpecific_ClearinghouseTerm {
  ADDITIONAL_EARNEST_DEPOSIT = 'ADDITIONAL_EARNEST_DEPOSIT',
  APPRAISAL_DATE = 'APPRAISAL_DATE',
  BUYER_BROKER_COMMISSION = 'BUYER_BROKER_COMMISSION',
  CLOSE_OF_ESCROW_DATE = 'CLOSE_OF_ESCROW_DATE',
  /** @deprecated No longer supported */
  CONTINGENCY = 'CONTINGENCY',
  CONTRACT_EXPIRATION = 'CONTRACT_EXPIRATION',
  EARNEST_DEPOSIT = 'EARNEST_DEPOSIT',
  EARNEST_DEPOSIT_DUE = 'EARNEST_DEPOSIT_DUE',
  FINANCING_CONTINGENCY = 'FINANCING_CONTINGENCY',
  FUNDING_RELATED_DELAYS = 'FUNDING_RELATED_DELAYS',
  INSPECTION_CONTINGENCY = 'INSPECTION_CONTINGENCY',
  LAND_SURVEY_REQUIREMENT = 'LAND_SURVEY_REQUIREMENT',
  OPENDOOR_COMMISSION = 'OPENDOOR_COMMISSION',
  PRICE = 'PRICE',
  RENT_BACK = 'RENT_BACK',
  REPAIR = 'REPAIR',
  RESOLUTION_PERIOD_CONTINGENCY = 'RESOLUTION_PERIOD_CONTINGENCY',
  SELLER_BROKER_COMMISSION = 'SELLER_BROKER_COMMISSION',
  SELLER_CREDIT = 'SELLER_CREDIT',
  SELLER_DISCLOSURES_DUE = 'SELLER_DISCLOSURES_DUE',
  TERMINATION_OPTION = 'TERMINATION_OPTION',
  TEXT_TERM = 'TEXT_TERM',
  TITLE_POLICY_AMENDMENT = 'TITLE_POLICY_AMENDMENT',
  TITLE_POLICY_FEE = 'TITLE_POLICY_FEE'
}

/**
 * The general description of the document
 * The realty document will have many sub-types represented by the `DocumentDescriptor`
 * NEXT ID: 65
 */
export enum OdProtosRealtyDocumentsData_DocumentDescriptor_Class {
  ABAD = 'ABAD',
  ADDENDUM = 'ADDENDUM',
  /** @deprecated No longer supported */
  AGENCY_AGREEMENT = 'AGENCY_AGREEMENT',
  AGENCY_DISCLOSURE = 'AGENCY_DISCLOSURE',
  AGREEMENT = 'AGREEMENT',
  AMENDMENT = 'AMENDMENT',
  APPRAISAL_REPORT = 'APPRAISAL_REPORT',
  ASSIGNMENT = 'ASSIGNMENT',
  BILL_OF_SALE = 'BILL_OF_SALE',
  BUYER_PURCHASE_ADDENDUM = 'BUYER_PURCHASE_ADDENDUM',
  CERTIFICATE_OF_OCCUPANCY = 'CERTIFICATE_OF_OCCUPANCY',
  CLOSING_DOCUMENTS = 'CLOSING_DOCUMENTS',
  COMISSION_INSTRUCTIONS = 'COMISSION_INSTRUCTIONS',
  COMPENSATION_AGREEMENT = 'COMPENSATION_AGREEMENT',
  CONCIERGE_AGREEMENT = 'CONCIERGE_AGREEMENT',
  CONCIERGE_INVOICE = 'CONCIERGE_INVOICE',
  COUNTER_OFFER = 'COUNTER_OFFER',
  DEED = 'DEED',
  DISCLOSURE = 'DISCLOSURE',
  EARNEST_MONEY_DEPOSIT_RECEIPT = 'EARNEST_MONEY_DEPOSIT_RECEIPT',
  EARNEST_MONEY_RELEASE_FORM = 'EARNEST_MONEY_RELEASE_FORM',
  /** @deprecated No longer supported */
  EXCLUSIVE_RIGHT_TO_SELL = 'EXCLUSIVE_RIGHT_TO_SELL',
  FINAL_REPAIR_ASK = 'FINAL_REPAIR_ASK',
  FINAL_SETTLEMENT_STATEMENT = 'FINAL_SETTLEMENT_STATEMENT',
  FINAL_WALKTHROUGH_VERIFICATION = 'FINAL_WALKTHROUGH_VERIFICATION',
  FIRPTA = 'FIRPTA',
  HOA_ADDENDUM = 'HOA_ADDENDUM',
  HOA_DEMAND = 'HOA_DEMAND',
  HOA_GOVERNING_DOCUMENTS = 'HOA_GOVERNING_DOCUMENTS',
  HOA_QUESTIONNAIRE = 'HOA_QUESTIONNAIRE',
  HOA_VIOLATION_RESOLUTION = 'HOA_VIOLATION_RESOLUTION',
  HOME_BUILDER_WARRANTY = 'HOME_BUILDER_WARRANTY',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  LAND_SURVEY = 'LAND_SURVEY',
  LCO_ADDENDUM = 'LCO_ADDENDUM',
  LEAD_BASED_PAINT_DISCLOSURE = 'LEAD_BASED_PAINT_DISCLOSURE',
  LIEN_SEARCH = 'LIEN_SEARCH',
  LISTING_AGREEMENT = 'LISTING_AGREEMENT',
  LOAN_PAYOFF = 'LOAN_PAYOFF',
  LOSS_HISTORY_REPORT = 'LOSS_HISTORY_REPORT',
  MARKET_CONDITIONS_ADVISORY = 'MARKET_CONDITIONS_ADVISORY',
  MISCELLANEOUS = 'MISCELLANEOUS',
  MLS_INPUT_FORM = 'MLS_INPUT_FORM',
  MLS_PRINTOUT = 'MLS_PRINTOUT',
  MUD_DOCUMENT = 'MUD_DOCUMENT',
  OPTION_FEE = 'OPTION_FEE',
  OPTION_MONEY_VERIFICATION = 'OPTION_MONEY_VERIFICATION',
  OWNERS_POLICY = 'OWNERS_POLICY',
  PHOTO = 'PHOTO',
  POWER_OF_ATTORNEY_AGREEMENT = 'POWER_OF_ATTORNEY_AGREEMENT',
  PRE_QUALIFICATION = 'PRE_QUALIFICATION',
  PRE_TERMINATION = 'PRE_TERMINATION',
  PURCHASE_AGREEMENT = 'PURCHASE_AGREEMENT',
  RECEIPT = 'RECEIPT',
  REFERRAL_AGREEMENT = 'REFERRAL_AGREEMENT',
  REFERRAL_W9 = 'REFERRAL_W9',
  REPAIR_CREDIT_ADDENDUM = 'REPAIR_CREDIT_ADDENDUM',
  SELLER_PROPERTY_DISCLOSURE_STATEMENT = 'SELLER_PROPERTY_DISCLOSURE_STATEMENT',
  T47 = 'T47',
  TAX_CERTIFICATE = 'TAX_CERTIFICATE',
  TERMINATION = 'TERMINATION',
  TITLE_COMMITMENT = 'TITLE_COMMITMENT',
  TRANSFER_ADDENDUM = 'TRANSFER_ADDENDUM',
  UNKNOWN = 'UNKNOWN',
  WIRE_INSTRUCTIONS = 'WIRE_INSTRUCTIONS'
}

/**
 * these values needs to correspond to od_protos.realty.clearinghouse.data.Transaction.State
 * in order for Proforma and Clearinghouse to understand each other
 */
export enum OdProtosRealtyDocumentsData_DocumentDescriptor_ClearinghouseState {
  CLOSED = 'CLOSED',
  DISCARDED = 'DISCARDED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  /** NONE indicates that no state is chosen */
  NONE = 'NONE',
  OPEN = 'OPEN',
  REJECTED = 'REJECTED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosRealtyDocumentsData_DocumentDescriptor_Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum OdProtosRealtyDocumentsData_PartyList_Party {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

/** a template field can either be a boolean or a string */
export enum OdProtosRealtyDocumentsData_TemplateFieldDescriptor_Type {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING'
}

/** Represents an openhouse for a home. */
export type OdProtosRealtyOdlsData_OpenHouseInput = {
  /** Whether the open house is active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  /** Create timestamp. Generated by the service. */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** End timestamp in UTC. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The ID of the open house on the external system. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
  /** Start timestamp in UTC. */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The type of open house (i.e. public vs private). */
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
  /** Update timestamp. Generated by the service. */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosRealtyOdlsData_OpenHouse_Type {
  /** The open house is scheduled for a private showing. */
  TYPE_PRIVATE = 'TYPE_PRIVATE',
  /** The open house is open to the public. */
  TYPE_PUBLIC = 'TYPE_PUBLIC',
  TYPE_UNKNOWN = 'TYPE_UNKNOWN'
}

/**
 * Blobbly data on the sell request. The core functionality of Clearinghouse
 * does not need this data, but ODLS does pass this data on to buyers.
 * Next ID: 64
 */
export type OdProtosRealtyOdlsData_SellBlobInput = {
  /**
   * The raw address fields from the sell request source. May be used for display
   * purposes when the Casa address quality is bad.
   */
  address?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_AddressInput>;
  /** List of non-photo assets. */
  assets?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_AssetInput>>;
  /** Only completed after a sale */
  buyerAgentInformation?: InputMaybe<OdProtosRealtyCommon_AgentInformationInput>;
  buyerConcessionsCents?: InputMaybe<Scalars['Float']['input']>;
  cDom?: InputMaybe<Scalars['Float']['input']>;
  /** Assume this to be in local time w.r.t. the home location */
  closedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  commissionBreakdown?: InputMaybe<OdProtosRealtyCommon_CommissionBreakdownInput>;
  /** Price fields */
  currentListPriceCents?: InputMaybe<Scalars['Float']['input']>;
  currentLowPriceCents?: InputMaybe<Scalars['Float']['input']>;
  /** Free-form text description of this sell request. */
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<Array<OdProtosRealtyCommon_DisclosureInput>>;
  /** An opaque string for contact information required for public display. */
  displayContactInformation?: InputMaybe<Scalars['String']['input']>;
  dom?: InputMaybe<Scalars['Float']['input']>;
  entryTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estimated date this sell request will be listed on the MLS. */
  estimatedMlsListDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Estimated date scheduled tour will be available. */
  estimatedScheduledTourAvailableDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Estimated date self tour will be available. */
  estimatedSelfTourAvailable?: InputMaybe<OdProtosCommon_DateInput>;
  /** TOM/BOM fields */
  expectedBomDate?: InputMaybe<OdProtosCommon_DateInput>;
  fallThroughHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this sell request is currently eligible for an FHA loan. */
  fhaLoanEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** When this sell request will be eligible for an FHA loan. */
  fhaLoanEligibleOn?: InputMaybe<OdProtosCommon_DateInput>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  /** HomeDataStore IDs pointing to immutable home detail data. */
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  /** Optional. When the seller hopes the transaction will close by. This is an estimate. */
  hopefulCloseBy?: InputMaybe<Scalars['DateTime']['input']>;
  /** Timestamps provided by the source for when various events happened. */
  listPriceChangedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Assume this to be in local time w.r.t. the home location */
  listTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  listingAgentInformation?: InputMaybe<OdProtosRealtyCommon_AgentInformationInput>;
  mlsListingInformation?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_MlsListingInformationInput>;
  modificationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optional. When the seller requires the transaction to close by. This if often used when the
   * seller has a contingent purchase agreement.
   */
  mustCloseBy?: InputMaybe<Scalars['DateTime']['input']>;
  newConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  newPhotosNeededAtBom?: InputMaybe<Scalars['Boolean']['input']>;
  occupancy?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_Occupancy>;
  /** When true, signifies that a Listing can be unlocked remotely without a code. */
  odCodelessUnlock?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Matches Web's listing.published field.
   * For context, see https://opendoor.slack.com/archives/GUS9FUQ8Y/p1583947707054400
   */
  odPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** The slug used for constructing Opendoor listing URLs. */
  odSlug?: InputMaybe<Scalars['String']['input']>;
  offerCount?: InputMaybe<Scalars['Int']['input']>;
  originalListPriceCents?: InputMaybe<Scalars['Float']['input']>;
  permissions?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_PermissionsInput>;
  /** Cabinet ID pointing to photos. */
  photoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of metadata that must align with `photo_ids`. */
  photoMetadata?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_PhotoMetadataInput>>;
  photoModificationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** See DATAS-540 */
  possibleShortSale?: InputMaybe<Scalars['Boolean']['input']>;
  privateRemarks?: InputMaybe<Scalars['String']['input']>;
  publicRemarks?: InputMaybe<Scalars['String']['input']>;
  renovationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Assume this to be in local time w.r.t. the home location */
  salePendingTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Traditional scheduled tour is available with an agent. */
  scheduledTourAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Self tour at buyer's convenience.
   * TODO: Self tour times are currently not available on this API.
   */
  selfTourAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  sellerConcessionsCents?: InputMaybe<Scalars['Float']['input']>;
  /** Data specific to the seller. Contact the seller to get the descriptor for this data. */
  sellerSpecificData?: InputMaybe<GoogleProtobuf_AnyInput>;
  showingInstructions?: InputMaybe<Array<Scalars['String']['input']>>;
  soldPriceCents?: InputMaybe<Scalars['Float']['input']>;
  specialListingConditions?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_SpecialListingConditionsInput>;
  stateChangeTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  /** Assume this to be in local time w.r.t. the home location */
  tempOffMarketTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Initial proposed terms of the transaction. */
  terms?: InputMaybe<Array<OdProtosRealtyCommon_TermInput>>;
  tomReason?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_TomReason>;
  viewCount?: InputMaybe<Scalars['Int']['input']>;
  virtualTourLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  visitCount?: InputMaybe<Scalars['Int']['input']>;
  /** Assume this to be in local time w.r.t. the home location */
  withdrawnTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  workSummary?: InputMaybe<Scalars['String']['input']>;
  zoning?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsData_SellBlob_AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsData_SellBlob_AssetInput = {
  /** The short text given to summarize the object. */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** The type of asset at the URL or HTML. */
  category?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_Asset_Category>;
  /** The full robust description of the object. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The JavaScript or other method to embed a video, image, virtual tour or other media. */
  html?: InputMaybe<Scalars['String']['input']>;
  /** The transactional timestamp automatically recorded by the system representing when the media record was last modified. */
  modificationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** The display permission for this asset. */
  permission?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_Permission>>;
  /** The URI to the media file referenced by this record. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** https://ddwiki.reso.org/display/DDW17/MediaCategory+Lookups */
export enum OdProtosRealtyOdlsData_SellBlob_Asset_Category {
  AGENT_PHOTO = 'AGENT_PHOTO',
  BRANDED_VIRTUAL_TOUR = 'BRANDED_VIRTUAL_TOUR',
  DOCUMENT = 'DOCUMENT',
  FLOOR_PLAN = 'FLOOR_PLAN',
  OFFICE_LOGO = 'OFFICE_LOGO',
  OFFICE_PHOTO = 'OFFICE_PHOTO',
  PHOTO = 'PHOTO',
  UNBRANDED_VIRTUAL_TOUR = 'UNBRANDED_VIRTUAL_TOUR',
  UNKNOWN = 'UNKNOWN',
  VIDEO = 'VIDEO'
}

export type OdProtosRealtyOdlsData_SellBlob_MlsListingInformationInput = {
  listingNumber?: InputMaybe<Scalars['String']['input']>;
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
};

export enum OdProtosRealtyOdlsData_SellBlob_Occupancy {
  OCCUPANCY_OWNER_OCCUPIED = 'OCCUPANCY_OWNER_OCCUPIED',
  OCCUPANCY_TENANT_OCCUPIED = 'OCCUPANCY_TENANT_OCCUPIED',
  OCCUPANCY_UNKNOWN = 'OCCUPANCY_UNKNOWN',
  OCCUPANCY_UNOCCUPIED = 'OCCUPANCY_UNOCCUPIED'
}

/** Display permissions. According to RESO spec there's also IDX, VOW, agent-only, office-only, and firm-only. */
export enum OdProtosRealtyOdlsData_SellBlob_Permission {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type OdProtosRealtyOdlsData_SellBlob_PermissionsInput = {
  /**
   * Permit Automated Valuation Model on this sell request
   *
   * AVM stands for “Automated Valuation Model.” It is a program that automatically analyzes
   * various data points to produce an estimate on the current value of a home or property.
   */
  allowAvm?: InputMaybe<Scalars['Boolean']['input']>;
  allowCommentsAndReviews?: InputMaybe<Scalars['Boolean']['input']>;
  allowPublishToInternet?: InputMaybe<Scalars['Boolean']['input']>;
  allowShowings?: InputMaybe<Scalars['Boolean']['input']>;
  hideDisplayAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showSinglePhotoOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRealtyOdlsData_SellBlob_PhotoMetadataInput = {
  /** The short text given to summarize the object. Commonly used as the short description displayed under a photo. */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** The full robust description of the photo. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The height of the image expressed in pixels. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /**
   * When set to true, the media record in question is the preferred photo.
   * This will typically mean the photo to be shown when only one of the photos is to be displayed.
   */
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  /** The transactional timestamp automatically recorded by the system representing when the photo was last modified. */
  modificationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** The original URL of where the photo was downloaded from. */
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  /** The display permission for this photo. */
  permission?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_Permission>>;
  /** The width of the image expressed in pixels. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosRealtyOdlsData_SellBlob_SpecialListingConditionsInput = {
  asIs?: InputMaybe<Scalars['Boolean']['input']>;
  courtApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  ownerAgent?: InputMaybe<Scalars['Boolean']['input']>;
  ownerOccupiedRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  preForeclosure?: InputMaybe<Scalars['Boolean']['input']>;
  probateSale?: InputMaybe<Scalars['Boolean']['input']>;
  reo?: InputMaybe<Scalars['Boolean']['input']>;
  shortSale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosRealtyOdlsData_SellBlob_TomReason {
  ADDITIONAL_RENOVATIONS = 'ADDITIONAL_RENOVATIONS',
  ADDITIONAL_RENOVATIONS_POST_FALLTHROUGH = 'ADDITIONAL_RENOVATIONS_POST_FALLTHROUGH',
  DAMAGE_IN_HOME = 'DAMAGE_IN_HOME',
  LEGAL_ISSUE = 'LEGAL_ISSUE',
  PESTS = 'PESTS',
  SELLER_DISCLOSURE_UPDATE = 'SELLER_DISCLOSURE_UPDATE',
  TOM_REASON_UNSPECIFIED = 'TOM_REASON_UNSPECIFIED',
  TRUST_AND_SAFETY = 'TRUST_AND_SAFETY',
  UTILITY_ISSUE = 'UTILITY_ISSUE',
  WEATHER = 'WEATHER'
}

/** Describes the distribution channels for this sell request */
export type OdProtosRealtyOdlsData_SellRequest_ChannelInput = {
  type?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneofInput>;
};

export enum OdProtosRealtyOdlsData_SellRequest_ChannelType {
  /** @deprecated No longer supported */
  EXCLUSIVES = 'EXCLUSIVES',
  INSTITUTIONAL_BUYER = 'INSTITUTIONAL_BUYER',
  PUBLIC = 'PUBLIC',
  UNKNOWN_CHANNEL_TYPE = 'UNKNOWN_CHANNEL_TYPE'
}

/** Present this sell request to partner agents */
export type OdProtosRealtyOdlsData_SellRequest_Channel_AgentRepresentationChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Present this sell request to partners with early access */
export type OdProtosRealtyOdlsData_SellRequest_Channel_EarlyAccessChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Present this sell request to buyers on the Opendoor Exclusives platform */
export type OdProtosRealtyOdlsData_SellRequest_Channel_ExclusivesChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Present this sell request to institutional buyers */
export type OdProtosRealtyOdlsData_SellRequest_Channel_InstitutionalBuyerChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Present this sell request to the public */
export type OdProtosRealtyOdlsData_SellRequest_Channel_PublicChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneofInput = {
  agentRepresentation?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_AgentRepresentationChannelInput>;
  earlyAccess?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_EarlyAccessChannelInput>;
  exclusives?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_ExclusivesChannelInput>;
  institutional?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_InstitutionalBuyerChannelInput>;
  public?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_PublicChannelInput>;
};

export enum OdProtosRealtyOdlsData_SellRequest_PropertyType {
  COMMERCIAL_LEASE = 'COMMERCIAL_LEASE',
  COMMERCIAL_SALE = 'COMMERCIAL_SALE',
  LAND_SALE = 'LAND_SALE',
  RESIDENTIAL_LEASE = 'RESIDENTIAL_LEASE',
  RESIDENTIAL_SALE = 'RESIDENTIAL_SALE',
  UNKNOWN_PROPERTY_TYPE = 'UNKNOWN_PROPERTY_TYPE'
}

/**
 * Sell request states define the actions that can be performed on the sell request.
 *
 * Terminal: Sell request cannot receive new buy offers and will not change state under normal
 *   circumstances.
 */
export enum OdProtosRealtyOdlsData_SellRequest_State {
  /**
   * The seller is actively receiving offers.
   * Terminal: No
   */
  SELL_REQUEST_ACTIVE = 'SELL_REQUEST_ACTIVE',
  /**
   * A sale has gone through and is now closed.
   * Terminal: Yes.
   */
  SELL_REQUEST_CLOSED = 'SELL_REQUEST_CLOSED',
  /**
   * The sell request is coming soon.
   * Terminal: No.
   */
  SELL_REQUEST_COMING_SOON = 'SELL_REQUEST_COMING_SOON',
  /**
   * The sell request has expired and is no longer current. This state is set automatically when
   * the sell request expires.
   * Terminal: Yes
   */
  SELL_REQUEST_EXPIRED = 'SELL_REQUEST_EXPIRED',
  /**
   * The sell request is listed privately (aka not on the MLS) (e.g. listed only on exclusives).
   * Terminal: No.
   */
  SELL_REQUEST_PRIVATELY_LISTED = 'SELL_REQUEST_PRIVATELY_LISTED',
  /**
   * A sale is pending.
   * Terminal: No.
   */
  SELL_REQUEST_SALE_PENDING = 'SELL_REQUEST_SALE_PENDING',
  /**
   * The sell request is temporarily off the market.
   * Terminal: No.
   */
  SELL_REQUEST_TEMP_OFF_MARKET = 'SELL_REQUEST_TEMP_OFF_MARKET',
  SELL_REQUEST_UNKNOWN = 'SELL_REQUEST_UNKNOWN',
  /**
   * The seller is not actively receiving offers.
   * Terminal: Yes
   */
  SELL_REQUEST_WITHDRAWN = 'SELL_REQUEST_WITHDRAWN'
}

export type OdProtosRealtyOdlsServices_BulkSellRequestGetBySourceRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  sources?: InputMaybe<Array<OdProtosRealtyCommon_SourceInput>>;
};

export type OdProtosRealtyOdlsServices_HasMlsListingsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsServices_OpenHouseSearchRequestInput = {
  /** Optional. Filter OpenHouses based on its active field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  /** Find openhouses scheduled to start after timestamp. */
  gteTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Find openhouses scheduled to start before timestamp. */
  ltTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  /** Get open houses for these sell requests. */
  sellRequestIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Return open houses by type. */
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
};

export type OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput = {
  /**
   * Include everything you want to be returned, e.g. `PUBLIC` _and_ `PRIVATE`.
   * It is directly matched against the asset permission list.
   * Defaults to `PUBLIC` only.
   */
  assetPermissions?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_Permission>>;
};

export type OdProtosRealtyOdlsServices_SellRequestGetBySourceRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
};

export type OdProtosRealtyOdlsServices_SellRequestGetCurrentListForAddressRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
};

/** Searches for sell requests that match the given filters */
export type OdProtosRealtyOdlsServices_SellRequestSearchRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  filters?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestSearchRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  sortKey?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestSearchRequest_SortKey>;
};

export type OdProtosRealtyOdlsServices_SellRequestSearchRequest_FiltersInput = {
  /** Filter by address IDs. */
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Required. Filter by channel type (only one channel type at a time is supported). */
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  /**
   * Filter results to exclude those states that appear here
   * If a state appears in both include and exclude, exclude will take precedence (i.e. it will not appear)
   */
  excludeStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /**
   * Include results that have been updated_at >= gte_updated_at
   * This is an inclusive bound
   * [updated_at_min, updated_at_max)
   */
  gteUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Filter results to those including these states
   * If a state appears in both include and exclude, exclude will take precedence (i.e. it will not appear)
   */
  includeStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /**
   * Include results that have been updated_at < lt_updated_at
   * This is an exclusive bound
   * [updated_at_min, updated_at_max)
   */
  ltUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Required. Filter by property type (only one property type at a time is supported). */
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  /** Filter results to only include items from a source */
  sources?: InputMaybe<Array<OdProtosRealtyCommon_SourceInput>>;
};

export enum OdProtosRealtyOdlsServices_SellRequestSearchRequest_SortKey {
  /** Sort by address and earliest listed first. */
  SORT_KEY_ADDRESS_LISTED_ASC = 'SORT_KEY_ADDRESS_LISTED_ASC',
  /** Sort by address and most recently listed first. */
  SORT_KEY_ADDRESS_LISTED_DESC = 'SORT_KEY_ADDRESS_LISTED_DESC',
  /**
   * Sort by earliest created at first.
   * @deprecated No longer supported
   */
  SORT_KEY_CREATED_AT_ASC = 'SORT_KEY_CREATED_AT_ASC',
  /**
   * Sort by most recently created at first.
   * @deprecated No longer supported
   */
  SORT_KEY_CREATED_AT_DESC = 'SORT_KEY_CREATED_AT_DESC',
  SORT_KEY_DEFAULT = 'SORT_KEY_DEFAULT',
  /** Sort by earliest updated at first. */
  SORT_KEY_UPDATED_AT_ASC = 'SORT_KEY_UPDATED_AT_ASC',
  /** Sort by most recently updated at first. */
  SORT_KEY_UPDATED_AT_DESC = 'SORT_KEY_UPDATED_AT_DESC'
}

export type OdProtosRealtyOdlsServices_SellerRequest_AddNewChannelInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  /**
   * New channel to add to the sell request
   * Will raise an error if already added
   */
  channel?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelInput>;
  /** ID of sell request to update. */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_BomSellRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  renovationComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_BulkSellRequestChangeEventsBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  sellRequestIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_BulkSellRequestHistoryLatestBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  lteTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  sellRequestIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_GetPreferredSellRequestByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_GetPreferredSellRequestsByAddressIDsInput = {
  /** Max 100 address IDs! */
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseCreateInput = {
  /** Whether the open house is available. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  contact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  /** End timestamp in UTC. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The stable ID from the sell request "source", used for de-duplicating open houses. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Set individual fields. */
  openHouse?: InputMaybe<OdProtosRealtyOdlsData_OpenHouseInput>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
  /** Start timestamp in UTC. */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseGetByExternalIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseGetInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseListInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  contact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  /** End timestamp in UTC. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The stable ID from the sell request "source", used for de-duplicating open houses. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Set individual fields. Does not alter any fields missing below. */
  openHouse?: InputMaybe<OdProtosRealtyOdlsData_OpenHouseInput>;
  /** Start timestamp in UTC. */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseUpdatedInput = {
  gtUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestChangeEventsBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Create a new sell request.
 * A sell request may be rejected if there is an existing sell request already in the system.
 */
export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestCreateInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  channels?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_ChannelInput>>;
  expiresAfter?: InputMaybe<Scalars['DateTime']['input']>;
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required. The organization that owns this sell request.
   * Only users in this organization may update this sell request.
   */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  primaryContact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  sellBlob?: InputMaybe<OdProtosRealtyOdlsData_SellBlobInput>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
  state?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_State>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestGetInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  gteTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** for pagination */
  limit?: InputMaybe<Scalars['Float']['input']>;
  ltTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryDeleteInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
  sellRequestTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryGetInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
  sellRequestTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryLatestBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  lteTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
};

/** Write to the Sell Request History table */
export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryWriteInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  expiresAfter?: InputMaybe<Scalars['DateTime']['input']>;
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  primaryContact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  sellBlob?: InputMaybe<OdProtosRealtyOdlsData_SellBlobInput>;
  /**
   * The sell_request_id and sell_request_timestamp will constitute the primary keys of the Sell Requests History
   * table and will therefore be used to upsert data into the table. A corresponding sell request with the given
   * sell request id must exist in order to write the history record.
   */
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
  sellRequestTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
  state?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_State>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestListInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestResolveInput = {
  /** The id of the sell request that you want to find the master of */
  id?: InputMaybe<Scalars['String']['input']>;
  /** provide a list of mls ids */
  mlsId?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_MlsListingInformationInput>;
};

/** Updates to a sell request. */
export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestUpdateInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  expiresAfter?: InputMaybe<Scalars['DateTime']['input']>;
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  /** ID of sell request to update. */
  id?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  sellBlob?: InputMaybe<OdProtosRealtyOdlsData_SellBlobInput>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
  state?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_State>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Creates or updates a sell request based on source ID. */
export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestWriteInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  expiresAfter?: InputMaybe<Scalars['DateTime']['input']>;
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  primaryContact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  sellBlob?: InputMaybe<OdProtosRealtyOdlsData_SellBlobInput>;
  sellRequestTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
  state?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_State>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_TomSellRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  expectedBomDate?: InputMaybe<OdProtosCommon_DateInput>;
  fallThroughHome?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  newPhotosNeededAtBom?: InputMaybe<Scalars['Boolean']['input']>;
  tomReason?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_TomReason>;
  workSummary?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_UpdateExpectedBomDateInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  expectedBomDate?: InputMaybe<OdProtosCommon_DateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Params for getting multiple seller inputs. */
export type OdProtosReceptionServices_BulkGetSellerInputsRequestInput = {
  options?: InputMaybe<OdProtosReceptionServices_SellerInputRequestOptionsInput>;
  /** External identifiers for the seller inputs. */
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosReceptionServices_CalendlyCalendarRequestInput = {
  fromSellerFlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** External identifier for the seller input. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Params for creating a seller input.
 * Next ID: 12
 */
export type OdProtosReceptionServices_CreateSellerInputRequestInput = {
  /**
   * Address used to create the seller input can be either a set of params provided
   * by Google Maps autocomplete / manual seller inputs, or an already verified
   * address uuid from Casa (in the case of home profiles).
   */
  address?: InputMaybe<OdProtosReceptionServices_SellerAddressInput>;
  /** Address entry tracking and other data for analytics */
  analyticsMetadata?: InputMaybe<OdProtosSellReceptionData_SellerInput_AnalyticsMetadataInput>;
  /**
   * The channel the seller came in from, used to determine the overall experience
   * the seller will go through.
   */
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  /** if true, bypass global acquisition pause due to COVID-19 */
  covid19Whitelist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Experiment entity ID to be used with Optimizely */
  experimentEntityId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether or not the user should end up on the trade-in dashboard
   * when they're finished.
   */
  isTradeInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * if this is passed in, we will check if this seller_input has finished the flow and can be redirected to Offer dash.
   * if it can, we will return the same seller_input_uuid
   */
  oldSellerInputUuid?: InputMaybe<Scalars['String']['input']>;
  /** Partner referral tracking. */
  partnerReferralId?: InputMaybe<Scalars['String']['input']>;
  /** Assign the sellerInput to the specific sellerFlow */
  sellerFlowNameOverride?: InputMaybe<Scalars['String']['input']>;
  /** Assign the sellerInput to the specific sellerFlow */
  sellerFlowUuidOverride?: InputMaybe<Scalars['String']['input']>;
  /** Cookie based tracking keywords to associate with the seller input. */
  trackingData?: InputMaybe<Array<OdProtosReceptionServices_CreateSellerInputRequest_TrackingDataInput>>;
};

/** Cookie based tracking keywords to associate with the seller input. */
export type OdProtosReceptionServices_CreateSellerInputRequest_TrackingDataInput = {
  /** Tracking keyword (e.g. p_publicprofile). */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Time of tracking (i.e. when the keyword was added to the user's cookies). */
  trackedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Params for denying a seller input. */
export type OdProtosReceptionServices_DenySellerInputRequestInput = {
  /** Denial reason to deny the seller input for. */
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  /** Product for which to deny the seller input */
  product?: InputMaybe<OdProtosSellCommon_Product>;
  /** External identifier for the seller input to deny. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Params for getting the latest seller input from customer and address. */
export type OdProtosReceptionServices_GetLatestSellerInputFromCustomerAndAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosReceptionServices_GetOfferedProductsRequestInput = {
  /**
   * Address used to create the seller input can be either a set of params provided
   * by Google Maps autocomplete / manual seller inputs, or an already verified
   * address uuid from Casa (in the case of home profiles).
   */
  address?: InputMaybe<OdProtosReceptionServices_SellerAddressInput>;
  /** The channel the seller will come through, used to determine eligibility for some products */
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  /** Products for which we are requesting a denial check */
  products?: InputMaybe<Array<OdProtosSellCommon_Product>>;
};

export type OdProtosReceptionServices_GetQualificationStatusRequestInput = {
  /** Seller input uuid */
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Params for getting a seller input. */
export type OdProtosReceptionServices_GetSellerInputRequestInput = {
  /** External identifier for the seller input. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Params for getting seller inputs by address token. */
export type OdProtosReceptionServices_GetSellerInputsFromAddressUuidRequestInput = {
  /** Address token used to find seller inputs */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** Limits the number of results to this amount */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** How much to offset the query by */
  offset?: InputMaybe<Scalars['Float']['input']>;
};

/** Params for getting seller inputs by email. */
export type OdProtosReceptionServices_GetSellerInputsFromEmailRequestInput = {
  /** Customer email used to find seller inputs */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Limits the number of results to this amount */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** How much to offset the query by */
  offset?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Params for modifying a seller address. Modification results in the address
 * needing to be verified again.
 */
export type OdProtosReceptionServices_ModifySellerAddressRequestInput = {
  /** New address params to be used. */
  address?: InputMaybe<OdProtosReceptionServices_SellerAddressInput>;
  /** Identifier for the seller input to be modified. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Params for refreshing home details */
export type OdProtosReceptionServices_RefreshHomeDetailsRequestInput = {
  /** The uuid of the seller input for which we want a refreshed set of home details */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Params for requesting a listed offer / verifying a listing. */
export type OdProtosReceptionServices_RequestListedOfferRequestInput = {
  /** Optional override for the realtor email. */
  realtorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Optional override for the realtor name. */
  realtorName?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the listed seller input. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosReceptionServices_SaveSellerInputProgressRequestInput = {
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External identifier for the seller input. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Address inputs for creating or updating a seller input. */
export type OdProtosReceptionServices_SellerAddressInput = {
  /** City of the address. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Five digit postal code. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Two letter state abbreviation. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street name and number (e.g. 123 Main St). */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Unit number if applicable (e.g. 10), otherwise empty. */
  unit?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional Casa address identifier if the address is already known. If uuid is
   * provided, other address fields are not required. If uuid is not provided,
   * other address fields are required.
   */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosReceptionServices_SellerInputRequestOptionsInput = {
  excludeAnswerPrefills?: InputMaybe<Scalars['Boolean']['input']>;
  excludeAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  excludeHomeDetails?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Params for undenying a seller input. */
export type OdProtosReceptionServices_UndenySellerInputRequestInput = {
  /** Product for which to undeny the seller input */
  product?: InputMaybe<OdProtosSellCommon_Product>;
  /** External identifier for the seller input to undeny. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Next ID: 13
 * Params for updating seller input answers.
 */
export type OdProtosReceptionServices_UpdateSellerInputRequestInput = {
  /**
   * JSON changed answers that should be updated.
   * Example: "{ \"home.bedrooms\": 3 }"
   */
  answers?: InputMaybe<Scalars['String']['input']>;
  /** Sets a new channel, commonly used for listed homes. */
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  experiments?: InputMaybe<Array<OdProtosReceptionServices_UpdateSellerInputRequest_ExperimentsEntryInput>>;
  /** If true, will always perform the external eligibility check */
  forceExternalEligibilityCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the home is listed or not */
  isListed?: InputMaybe<Scalars['Boolean']['input']>;
  isOrvaAutoscheduleShown?: InputMaybe<Scalars['Boolean']['input']>;
  /** if true, the MtM (Monitor the Market) dashboard has been visited */
  mtmVisited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last page the seller completed in the seller flow. */
  sellerFlowLastCompletedSlug?: InputMaybe<Scalars['String']['input']>;
  sellerFlowName?: InputMaybe<Scalars['String']['input']>;
  sellerFlowUuid?: InputMaybe<Scalars['String']['input']>;
  /** External identifier for the seller input. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** `OdProtosReceptionServices_UpdateSellerInputRequest_ExperimentsEntryInput` represents the `experiments` map in `od_protos.reception.services.UpdateSellerInputRequest`. */
export type OdProtosReceptionServices_UpdateSellerInputRequest_ExperimentsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Params for verifying a seller address. Verification triggers address based
 * buybox and auto denial logic.
 */
export type OdProtosReceptionServices_VerifySellerAddressRequestInput = {
  /** Identifier for the seller input to be verified. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRefurbyData_ApResolutionTaskDataInput = {
  invoiceToken?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRefurbyData_MessageThreadStatus {
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED',
  WAITING_ON_OPENDOOR_RESPONSE = 'WAITING_ON_OPENDOOR_RESPONSE',
  WAITING_ON_THIRD_PARTY_RESPONSE = 'WAITING_ON_THIRD_PARTY_RESPONSE'
}

export type OdProtosRefurbyServices_CloseApResolutionTaskRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRefurbyServices_CompleteVisitRequestInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  submitChangeOrder?: InputMaybe<Scalars['Boolean']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRefurbyServices_CreateApResolutionTaskRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  taskData?: InputMaybe<OdProtosRefurbyData_ApResolutionTaskDataInput>;
};

export type OdProtosRefurbyServices_IdRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRefurbyServices_PostToWorkOrderMessageThreadRequestInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  newStatus?: InputMaybe<OdProtosRefurbyData_MessageThreadStatus>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRenaissance_FeatureFetchBatchRequestInput = {
  /** UUID of the address of the home for which we want features for. */
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Date at which we want features to be fetched. E.g. the previous list price of a home might be different at
   * different time periods.
   */
  asofDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** Comps can be optional. */
  includeComps?: InputMaybe<Scalars['Boolean']['input']>;
  /** The market of the request, in string form */
  market?: InputMaybe<Scalars['String']['input']>;
  /** Overlay map of column_name -> value */
  overlaysDicts?: InputMaybe<Array<OdProtosRenaissance_OverlaysDictInput>>;
};

export type OdProtosRenaissance_FeatureFetchRequestInput = {
  /** UUID of the address of the home for which we want features for. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Date at which we want features to be fetched. E.g. the previous list price of a home might be different at
   * different time periods.
   */
  asofDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Comps can be optional. */
  includeComps?: InputMaybe<Scalars['Boolean']['input']>;
  /** The market of the request, in string form */
  market?: InputMaybe<Scalars['String']['input']>;
  /** Overlay map of column_name -> value */
  overlaysDict?: InputMaybe<OdProtosRenaissance_OverlaysDictInput>;
};

export type OdProtosRenaissance_OverlaysDictInput = {
  /** Overlay map of column_name -> value */
  overlaysDict?: InputMaybe<Array<OdProtosRenaissance_OverlaysDict_OverlaysDictEntryInput>>;
};

/** `OdProtosRenaissance_OverlaysDict_OverlaysDictEntryInput` represents the `overlays_dict` map in `od_protos.renaissance.OverlaysDict`. */
export type OdProtosRenaissance_OverlaysDict_OverlaysDictEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRenovationRepairScopingData_State {
  CANCELED = 'CANCELED',
  REQUESTED = 'REQUESTED',
  SCOPING_COMPLETED = 'SCOPING_COMPLETED',
  SCOPING_STARTED = 'SCOPING_STARTED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRenovationRepairScopingServices_BulkGetOrCreateRenoRepairScopingsRequestInput = {
  requests?: InputMaybe<Array<OdProtosRenovationRepairScopingServices_GetOrCreateRenoRepairScopingRequestInput>>;
};

export type OdProtosRenovationRepairScopingServices_GetOrCreateRenoRepairScopingRequestInput = {
  enrollmentId?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRenovationRepairScopingServices_GetRenoRepairScopingRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRenovationRepairScopingServices_RequestRenoRepairScopingRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRenovationRepairScopingServices_SearchRenoRepairScopingRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRentinalServices_CancelSearchRequestInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRentinalServices_EmptyRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRentinalServices_ListSearchResultsRequestInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRentinalServices_ListSearchRunsRequestInput = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AcceptedOfferType represents the type of offer that Opendoor is accepting for a given home. */
export type OdProtosResaleInventoryData_AcceptedOfferTypeInput = {
  /** The deadline for submitting offers of the given accepted offer type. */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  offerType?: InputMaybe<OdProtosResaleInventoryData_AcceptedOfferType_OfferType>;
};

export enum OdProtosResaleInventoryData_AcceptedOfferType_OfferType {
  /** Opendoor is accepting backup offers, as it currently has a committed buyer. */
  BACKUP = 'BACKUP',
  /** “Buy It Now” means thsat if the offer qualifies then it will be automatically accepted/advanced at the "Buy It Now" price. */
  BUY_IT_NOW = 'BUY_IT_NOW',
  /** Opendoor is collecting competing offers which it will examine on a deadline. */
  HIGHEST_AND_BEST = 'HIGHEST_AND_BEST',
  /** Offers to purchase the house at various prices may be submitted which will be considered by Opendoor and responded to. */
  NEGOTIABLE = 'NEGOTIABLE',
  UNKNOWN_ACCEPTED_OFFER_TYPE = 'UNKNOWN_ACCEPTED_OFFER_TYPE'
}

export type OdProtosResaleInventoryData_AcceptedOfferTypesInput = {
  acceptedOfferTypes?: InputMaybe<Array<OdProtosResaleInventoryData_AcceptedOfferTypeInput>>;
};

/** ActiveChannel represents details about a channel that is currently active for a resale. */
export type OdProtosResaleInventoryData_ActiveChannelInput = {
  channelType?: InputMaybe<OdProtosResaleInventoryData_ChannelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OdProtosResaleInventoryData_ChannelState>;
};

export type OdProtosResaleInventoryData_ActiveChannelsInput = {
  activeChannels?: InputMaybe<Array<OdProtosResaleInventoryData_ActiveChannelInput>>;
};

/** ChannelType represents the state of the channel */
export enum OdProtosResaleInventoryData_ChannelState {
  /** The channel is pending activation, but has not yet been confirmed by the channel itself. */
  ACTIVATION_PENDING = 'ACTIVATION_PENDING',
  /** The channel is confirmed to be active by the channel. */
  ACTIVE = 'ACTIVE',
  /** The channel is terminated */
  TERMINATED = 'TERMINATED',
  /**
   * The channel termination is pending, but has not yet been confirmed. Once confirmed,
   * the channel will be terminated (aka removed from active channels).
   */
  TERMINATION_PENDING = 'TERMINATION_PENDING',
  UNKNOWN_CHANNEL_STATE = 'UNKNOWN_CHANNEL_STATE'
}

/** ChannelType represents the type of channel that a home is being resold on. */
export enum OdProtosResaleInventoryData_ChannelType {
  /** @deprecated No longer supported */
  BUY_DIRECT = 'BUY_DIRECT',
  EXTERNAL_LISTING = 'EXTERNAL_LISTING',
  MLS = 'MLS',
  UNKNOWN_CHANNEL_TYPE = 'UNKNOWN_CHANNEL_TYPE'
}

export type OdProtosResaleInventoryData_ResaleInput = {
  /** The list of offer types (and deadlines) that Opendoor is currently accepting for the property being sold */
  acceptedOfferTypes?: InputMaybe<OdProtosResaleInventoryData_AcceptedOfferTypesInput>;
  /** Flag that indicates if the property has its access blocked for customers */
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of resale channels currently being managed by the Resale entity */
  activeChannels?: InputMaybe<OdProtosResaleInventoryData_ActiveChannelsInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The factor that the headline price will be adjusted by to calculate the
   * buy direect price.
   */
  buyDirectAdjustmentFactor?: InputMaybe<Scalars['Float']['input']>;
  /** Flag that indicates if the property is eligible for exclusives */
  exclusivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the field is populated, it represents the time the exclusives window expired */
  exclusivesWindowExpiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date when the property is expected to have access unblocked */
  expectedAccessUnblockedDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** The date when the property is expected to become available to purchase (aka state = sellable) */
  expectedSellableDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** The current headline (i.e. base) price that Opendoor wishes to receive when selling the property */
  headlinePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** The timestamp when the highest and best deadline is set to */
  highestAndBestDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating if the property is in a gated community */
  inGatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Flag that indicates if the property is currently exclusively listed,
   * as in it's currently listed on our gallery, but not on the MLS.
   */
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Flag that indicates if the property being sold is currently listed
   * publicly
   */
  isPubliclyListed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The market_identifier indicating which market the property is in */
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
  /** The time at which photos have been marked as ready to be published */
  photosReadyTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Flag that indicates if a door is unable to have a remote unlock setup or it is currently disabled/non-working */
  remoteUnlockDoorDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if renovation has been completed */
  renovationCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Flag indicating if the property is self-tourable
   * This will be true if the property is not in a gated community and has a remote unlockable door
   */
  selfTourable?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<OdProtosResaleInventoryData_Resale_State>;
  /** The collection of most recent times that resale entered a state */
  stateEnterTimes?: InputMaybe<Array<OdProtosResaleInventoryData_Resale_StateEnterTimeInput>>;
  /** The reason a resale entity was terminated */
  terminationReason?: InputMaybe<OdProtosResaleInventoryData_Resale_TerminationReason>;
};

export enum OdProtosResaleInventoryData_Resale_State {
  /** Opendoor has a buyer committed to purchase the property. */
  COMMITTED_BUYER = 'COMMITTED_BUYER',
  /**
   * Opendoor owns the property, has access to it, and is preparing to sell it.
   * Resale will start related sub-processes (pricing, photos, remote access setup) at appropriate times.
   */
  PREPARING = 'PREPARING',
  /**
   * The Resale lifecycle has been created, however it is in a holding state because we
   * haven't actually acquired the property yet.
   */
  PRE_INVENTORY = 'PRE_INVENTORY',
  /** The property may now be sold, and all Resale preparation has been completed. Any active channels may expose the property as for sale. */
  SELLABLE = 'SELLABLE',
  /** The Resale lifecycle has been terminated, typically because the property has been sold. */
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/** StateEnterTime tracks the time a Resale entity entered a particular state */
export type OdProtosResaleInventoryData_Resale_StateEnterTimeInput = {
  state?: InputMaybe<OdProtosResaleInventoryData_Resale_State>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

/** TerminationReason indicates the reason a Resale entity was terminated */
export enum OdProtosResaleInventoryData_Resale_TerminationReason {
  /** Home did not get acquired to be sold */
  NOT_ACQUIRED = 'NOT_ACQUIRED',
  /** Resale was canceled */
  SALE_CANCELED = 'SALE_CANCELED',
  /** Home has been sold */
  SOLD = 'SOLD',
  UNKNOWN_TERMINATION_REASON = 'UNKNOWN_TERMINATION_REASON'
}

export type OdProtosResaleInventoryServices_AddActiveChannelRequestInput = {
  channelType?: InputMaybe<OdProtosResaleInventoryData_ChannelType>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_CommitBuyerRequestInput = {
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_CreateResaleRequestInput = {
  resale?: InputMaybe<OdProtosResaleInventoryData_ResaleInput>;
};

export type OdProtosResaleInventoryServices_GetResaleRequestInput = {
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_HomeInInventoryRequestInput = {
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_PhotosReadyRequestInput = {
  photosReadyTime?: InputMaybe<Scalars['DateTime']['input']>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_RemoveActiveChannelRequestInput = {
  channelType?: InputMaybe<OdProtosResaleInventoryData_ChannelType>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_RenovationCompletedRequestInput = {
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_RevertResaleSoldRequestInput = {
  isExternalListing?: InputMaybe<Scalars['Boolean']['input']>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_SetAccessBlockedRequestInput = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  expectedAccessUnblockedDate?: InputMaybe<OdProtosCommon_DateInput>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_SetExpectedAccessUnblockedDateRequestInput = {
  expectedAccessUnblockedDate?: InputMaybe<OdProtosCommon_DateInput>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_SetExpectedSellableDateRequestInput = {
  expectedSellableDate?: InputMaybe<OdProtosCommon_DateInput>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_SetHeadlinePriceRequestInput = {
  headlinePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_SetHighestAndBestDeadlineRequestInput = {
  highestAndBestDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_SetInGatedCommunityRequestInput = {
  inGatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_SetRemoteUnlockDoorDisabledRequestInput = {
  remoteUnlockDoorDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_TerminateRequestInput = {
  reason?: InputMaybe<OdProtosResaleInventoryData_Resale_TerminationReason>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_UncommitBuyerRequestInput = {
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_UnsetHighestAndBestDeadlineRequestInput = {
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateActiveChannelRequest enable active channel details to be set for a
 * specific Resale ID and ChannelType. Based on the Resale ID/ChannelType,
 * the channel state and ID can be set.
 *
 * This endpoint was created for migration/data repair use cases
 */
export type OdProtosResaleInventoryServices_UpdateActiveChannelRequestInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  channelState?: InputMaybe<OdProtosResaleInventoryData_ChannelState>;
  channelType?: InputMaybe<OdProtosResaleInventoryData_ChannelType>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosResaleInventoryServices_UpdateBuyDirectAdjustmentFactorRequestInput = {
  buyDirectAdjustmentFactor?: InputMaybe<Scalars['Float']['input']>;
  resaleId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRiskAssessmentData_BimodalCompsRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_CommercialNeighborsRiskInput = {
  option?: InputMaybe<OdProtosRiskAssessmentData_CommercialNeighborsRisk_OptionOneofInput>;
};

export type OdProtosRiskAssessmentData_CommercialNeighborsRisk_OptionOneofInput = {
  commercial?: InputMaybe<GoogleProtobuf_EmptyInput>;
  industrial?: InputMaybe<GoogleProtobuf_EmptyInput>;
  school?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

export type OdProtosRiskAssessmentData_CrampedKitchenRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_MultiFamilyNeighborsRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_NewConstructionRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_NonConformingCurbAppealRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_OutlierCompsRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_PowerlineRiskInput = {
  option?: InputMaybe<OdProtosRiskAssessmentData_PowerlineRisk_OptionOneofInput>;
};

export type OdProtosRiskAssessmentData_PowerlineRisk_OptionOneofInput = {
  highVoltagePowerlineTower?: InputMaybe<GoogleProtobuf_EmptyInput>;
  highVoltagePowerlineWire?: InputMaybe<GoogleProtobuf_EmptyInput>;
  lowVoltagePowerlinePole?: InputMaybe<GoogleProtobuf_EmptyInput>;
  lowVoltagePowerlineWire?: InputMaybe<GoogleProtobuf_EmptyInput>;
  powerlineStation?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

/**
 * Representation of standardized camunda variables that most
 * jobworkers will have available
 */
export type OdProtosRiskAssessmentData_PropertyEngagementMetadataInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  instanceKey?: InputMaybe<Scalars['String']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  /** camunda job worker specific details */
  stepName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRiskAssessmentData_RecentDelistingRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosRiskAssessmentData_ResolutionStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN'
}

/** A Risk is a specific risk factor */
export type OdProtosRiskAssessmentData_RiskInput = {
  /** The risk factor */
  factor?: InputMaybe<OdProtosRiskAssessmentData_Risk_FactorOneofInput>;
  /** Additional risk factor notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The risk factor score */
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosRiskAssessmentData_Risk_FactorOneofInput = {
  bimodalComps?: InputMaybe<OdProtosRiskAssessmentData_BimodalCompsRiskInput>;
  commercialNeighbors?: InputMaybe<OdProtosRiskAssessmentData_CommercialNeighborsRiskInput>;
  crampedKitchen?: InputMaybe<OdProtosRiskAssessmentData_CrampedKitchenRiskInput>;
  multiFamilyNeighbors?: InputMaybe<OdProtosRiskAssessmentData_MultiFamilyNeighborsRiskInput>;
  newConstruction?: InputMaybe<OdProtosRiskAssessmentData_NewConstructionRiskInput>;
  nonConformingCurbAppeal?: InputMaybe<OdProtosRiskAssessmentData_NonConformingCurbAppealRiskInput>;
  outlierComps?: InputMaybe<OdProtosRiskAssessmentData_OutlierCompsRiskInput>;
  powerline?: InputMaybe<OdProtosRiskAssessmentData_PowerlineRiskInput>;
  recentDelisting?: InputMaybe<OdProtosRiskAssessmentData_RecentDelistingRiskInput>;
  road?: InputMaybe<OdProtosRiskAssessmentData_RoadRiskInput>;
  slopedBackyard?: InputMaybe<OdProtosRiskAssessmentData_SlopedBackyardRiskInput>;
  slopedDriveway?: InputMaybe<OdProtosRiskAssessmentData_SlopedDrivewayRiskInput>;
  smallMaster?: InputMaybe<OdProtosRiskAssessmentData_SmallMasterRiskInput>;
  sunkenSpaces?: InputMaybe<OdProtosRiskAssessmentData_SunkenSpacesRiskInput>;
  trainTrack?: InputMaybe<OdProtosRiskAssessmentData_TrainTrackRiskInput>;
  underRenovated?: InputMaybe<OdProtosRiskAssessmentData_UnderRenovatedRiskInput>;
  unsightlyNeighbor?: InputMaybe<OdProtosRiskAssessmentData_UnsightlyNeighborRiskInput>;
  unusualAdjustments?: InputMaybe<OdProtosRiskAssessmentData_UnusualAdjustmentsRiskInput>;
};

export type OdProtosRiskAssessmentData_RoadRiskInput = {
  option?: InputMaybe<OdProtosRiskAssessmentData_RoadRisk_OptionOneofInput>;
};

export type OdProtosRiskAssessmentData_RoadRisk_OptionOneofInput = {
  arterialRoad?: InputMaybe<GoogleProtobuf_EmptyInput>;
  connectorRoad?: InputMaybe<GoogleProtobuf_EmptyInput>;
  freewayHighway?: InputMaybe<GoogleProtobuf_EmptyInput>;
  mainStreetWithinSubdivision?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

export type OdProtosRiskAssessmentData_SlopedBackyardRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_SlopedDrivewayRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_SmallMasterRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_SunkenSpacesRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_TrainTrackRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_UnderRenovatedRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_UnsightlyNeighborRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosRiskAssessmentData_UnusualAdjustmentsRiskInput = {
  option?: InputMaybe<OdProtosRiskAssessmentData_UnusualAdjustmentsRisk_OptionOneofInput>;
};

export type OdProtosRiskAssessmentData_UnusualAdjustmentsRisk_OptionOneofInput = {
  golfLot?: InputMaybe<GoogleProtobuf_EmptyInput>;
  waterView?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

export enum OdProtosRiskAssessmentServices_CreateCaseyTaskForTestingErrorCode_Code {
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRiskAssessmentServices_CreateCaseyTaskForTestingRequestInput = {
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosRiskAssessmentServices_CreateRiskAssessmentErrorCode_Code {
  DUPLICATE = 'DUPLICATE',
  INCORRECT_RISK_SCORE = 'INCORRECT_RISK_SCORE',
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 18 */
export type OdProtosRiskAssessmentServices_CreateRiskAssessmentRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  createdByToken?: InputMaybe<Scalars['String']['input']>;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  risks?: InputMaybe<Array<OdProtosRiskAssessmentData_RiskInput>>;
  score?: InputMaybe<Scalars['Float']['input']>;
  shouldWalk?: InputMaybe<Scalars['Boolean']['input']>;
  skipValuationOnWalk?: InputMaybe<Scalars['Boolean']['input']>;
  walkOverrideNotes?: InputMaybe<Scalars['String']['input']>;
  walkPreventionNotes?: InputMaybe<Scalars['String']['input']>;
  walkRecOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  webValuationId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRiskAssessmentServices_GetReusableRiskAssessmentErrorCode_Code {
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRiskAssessmentServices_GetReusableRiskAssessmentRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosRiskAssessmentServices_GetRiskAssessmentErrorCode_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRiskAssessmentServices_GetRiskAssessmentRequestInput = {
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  riskAssessmentId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRiskAssessmentServices_LogSkipDecisionErrorCode_Code {
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRiskAssessmentServices_LogSkipDecisionRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Experiment name for deciding to go against general routing */
  experimentName?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  /** Did we decide to generally skip or qc */
  routingDecision?: InputMaybe<OdProtosRiskAssessmentServices_SkipDecisionRoutingCode_Code>;
  /** Did we end up skipping QC or not */
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosRiskAssessmentServices_RecordRiskAssessmentReuseErrorCode_Code {
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRiskAssessmentServices_RecordRiskAssessmentReuseRequestInput = {
  /** Fill with Risk Assessment Property Engagement ID */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  riskAssessmentUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRiskAssessmentServices_SkipDecisionRequestInput = {
  /** Fill with Risk Assessment Property Engagement ID */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementMetadata?: InputMaybe<OdProtosRiskAssessmentData_PropertyEngagementMetadataInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export enum OdProtosRiskAssessmentServices_SkipDecisionRoutingCode_Code {
  QC = 'QC',
  SKIP = 'SKIP',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosRiskAssessmentServices_StartManualRiskAssessmentErrorCode_Code {
  ALREADY_IN_PROGRESS = 'ALREADY_IN_PROGRESS',
  DEPENDENCY_FAILURE = 'DEPENDENCY_FAILURE',
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRiskAssessmentServices_StartManualRiskAssessmentRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  workflowTaskDetail?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRiskAssessmentServices_TerminatePropertyEngagementErrorCode_Code {
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRiskAssessmentServices_TerminatePropertyEngagementRequestInput = {
  /** Fill with Risk Assessment Property Engagement ID */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosRollCallData_EnrollmentFilterInput = {
  column?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_Column>;
  isNegated?: InputMaybe<Scalars['Boolean']['input']>;
  operand?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_OperandInput>;
  operator?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_Operator>;
};

export type OdProtosRollCallData_EnrollmentFilterSetInput = {
  /** filters are AND'd with each other */
  filters?: InputMaybe<Array<OdProtosRollCallData_EnrollmentFilterInput>>;
};

export enum OdProtosRollCallData_EnrollmentFilter_Column {
  ADDRESS_ID = 'ADDRESS_ID',
  ADDRESS_LABEL = 'ADDRESS_LABEL',
  /** @deprecated No longer supported */
  ADDRESS_TSV = 'ADDRESS_TSV',
  /** Active */
  CANCELLED_AT = 'CANCELLED_AT',
  DEFAULT_FIELD_USER_ID = 'DEFAULT_FIELD_USER_ID',
  MARKET_FENCE_ID = 'MARKET_FENCE_ID',
  /**
   * Deprecated :  Protobuf 3 requires the first value to be 0
   * @deprecated No longer supported
   */
  SERVICE = 'SERVICE',
  /** @deprecated No longer supported */
  VENDOR_BRANCH_ID = 'VENDOR_BRANCH_ID'
}

export type OdProtosRollCallData_EnrollmentFilter_OperandInput = {
  value?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneofInput>;
};

export type OdProtosRollCallData_EnrollmentFilter_Operand_StringListInput = {
  strings?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneofInput = {
  /** Deprecated */
  serviceValue?: InputMaybe<OdProtosRollCallData_Enrollment_Service>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  stringValueList?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_Operand_StringListInput>;
  timestampValue?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosRollCallData_EnrollmentFilter_Operator {
  EQUAL_TO = 'EQUAL_TO',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  ILIKE = 'ILIKE',
  IN = 'IN',
  IS_NULL = 'IS_NULL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  LIKE = 'LIKE',
  /** @deprecated No longer supported */
  TEXT_SEARCH = 'TEXT_SEARCH'
}

export type OdProtosRollCallData_EnrollmentOrderingInput = {
  column?: InputMaybe<OdProtosRollCallData_EnrollmentOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosRollCallData_EnrollmentOrdering_Column {
  CANCELLED_AT = 'CANCELLED_AT',
  CREATED_AT = 'CREATED_AT'
}

/** Deprecated */
export enum OdProtosRollCallData_Enrollment_Service {
  HOMEOPS_STANDARD = 'HOMEOPS_STANDARD',
  INVALID = 'INVALID',
  PROPERTY_MANAGEMENT = 'PROPERTY_MANAGEMENT'
}

export type OdProtosRollCallServices_ChangeAddressRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  newAddressId?: InputMaybe<Scalars['String']['input']>;
  oldAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRollCallServices_CreateEnrollmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  defaultFieldUserId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated */
  enrolleeOrganizationId?: InputMaybe<Scalars['String']['input']>;
  enrolleeUserId?: InputMaybe<Scalars['String']['input']>;
  marketFenceId?: InputMaybe<Scalars['String']['input']>;
  occupantEmail?: InputMaybe<Scalars['String']['input']>;
  occupantName?: InputMaybe<Scalars['String']['input']>;
  occupantPhone?: InputMaybe<Scalars['String']['input']>;
  reminderPhone?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<OdProtosRollCallData_Enrollment_Service>;
  vendorBranchId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRollCallServices_GetFieldUsersRequestInput = {
  marketFenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRollCallServices_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRollCallServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRollCallServices_SearchEnrollmentsRequestInput = {
  /** filter_sets are OR'd with each other */
  filterSets?: InputMaybe<Array<OdProtosRollCallData_EnrollmentFilterSetInput>>;
  orderings?: InputMaybe<Array<OdProtosRollCallData_EnrollmentOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosRollCallServices_UpdateEnrollmentRequestInput = {
  defaultFieldUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isOdSelectEnrollmentRequest?: InputMaybe<Scalars['Boolean']['input']>;
  occupantEmail?: InputMaybe<Scalars['String']['input']>;
  occupantName?: InputMaybe<Scalars['String']['input']>;
  occupantPhone?: InputMaybe<Scalars['String']['input']>;
  reminderPhone?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRubricData_OptionBehavior_Action {
  CREATE_ISSUE = 'CREATE_ISSUE',
  EMIT_MESSAGE = 'EMIT_MESSAGE',
  NONE = 'NONE',
  REQUIRE_COMMENT = 'REQUIRE_COMMENT',
  REQUIRE_COMMENT_AND_PHOTO = 'REQUIRE_COMMENT_AND_PHOTO',
  REQUIRE_PHOTOS = 'REQUIRE_PHOTOS'
}

export enum OdProtosRubricData_Prompt_AnswerTypeValidation {
  FLOAT = 'FLOAT',
  INT = 'INT',
  NONE = 'NONE',
  STRING = 'STRING'
}

export enum OdProtosRubricData_Prompt_Type {
  ASSET_COLLECTION = 'ASSET_COLLECTION',
  FREEFORM = 'FREEFORM',
  KNOX_IDENTIFIER = 'KNOX_IDENTIFIER',
  MULTIPLE_SELECT = 'MULTIPLE_SELECT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosRubricServices_ChangeAddressRequestInput = {
  newAddressId?: InputMaybe<Scalars['String']['input']>;
  oldAddressId?: InputMaybe<Scalars['String']['input']>;
  taskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Data_AllowedFollowUpPromptGroupInput = {
  /**
   * some prompts have followup prompts.
   * this list contains all followup prompts this
   * prompt group allows.
   */
  allowedFollowupPrompts?: InputMaybe<Array<OdProtosRubricV2Data_PromptInput>>;
  /** id identifies the prompt group. There can be multiple occasions of this id. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** key is a unique identifier */
  key?: InputMaybe<Scalars['String']['input']>;
  prompts?: InputMaybe<Array<OdProtosRubricV2Data_PromptInput>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Data_CorrelatedPromptResponseInput = {
  response?: InputMaybe<OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneofInput>;
  rubricId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneofInput = {
  audios?: InputMaybe<OdProtosRubricV2Data_UploadedAudiosInput>;
  photos?: InputMaybe<OdProtosRubricV2Data_UploadedPhotosInput>;
  selectedOptions?: InputMaybe<OdProtosRubricV2Data_SelectedOptionsInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<OdProtosRubricV2Data_UploadedVideosInput>;
};

export type OdProtosRubricV2Data_EventInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  promptCorrelationKey?: InputMaybe<Scalars['String']['input']>;
  promptGroupCorrelationKey?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Data_ExternalActionTriggerInput = {
  actionName?: InputMaybe<Scalars['String']['input']>;
  triggeringAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Data_FollowUpPromptGroupInput = {
  /**
   * if any of these answers are not selected
   * the followup prompt group will be added
   */
  expectedAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  promptGroupId?: InputMaybe<Scalars['String']['input']>;
  /** empty if the followup prompt group doesn't exist yet */
  promptGroupKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * if any of these answers are selected
   * the followup prompt group will be added
   */
  triggeringAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Data_FollowUpPromptInput = {
  /**
   * if any of these answers are not selected
   * the followup prompt will be added
   */
  expectedAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  promptId?: InputMaybe<Scalars['String']['input']>;
  /** empty if the followup prompt doesn't exist yet */
  promptKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * if any of these answers are selected
   * the followup prompt will be added
   */
  triggeringAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Data_OptionBehaviorInput = {
  action?: InputMaybe<OdProtosRubricV2Data_OptionBehavior_Action>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRubricV2Data_OptionBehavior_Action {
  NONE = 'NONE',
  REQUIRE_COMMENT = 'REQUIRE_COMMENT',
  REQUIRE_COMMENT_AND_PHOTO = 'REQUIRE_COMMENT_AND_PHOTO',
  /** Add if needed PROMPT_GROUP_ADDITION = 4; */
  REQUIRE_COMMENT_AND_VIDEO = 'REQUIRE_COMMENT_AND_VIDEO',
  REQUIRE_PHOTOS = 'REQUIRE_PHOTOS',
  REQUIRE_VIDEOS = 'REQUIRE_VIDEOS'
}

export type OdProtosRubricV2Data_OptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  optionBehavior?: InputMaybe<OdProtosRubricV2Data_OptionBehaviorInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Data_PreviousVisitDataInput = {
  comments?: InputMaybe<Array<Scalars['String']['input']>>;
  correlatedPromptResponses?: InputMaybe<Array<OdProtosRubricV2Data_CorrelatedPromptResponseInput>>;
  photoUrls?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Data_PromptBehaviorInput = {
  behavior?: InputMaybe<OdProtosRubricV2Data_PromptBehavior_BehaviorOneofInput>;
};

export type OdProtosRubricV2Data_PromptBehavior_BehaviorOneofInput = {
  externalActionTrigger?: InputMaybe<OdProtosRubricV2Data_ExternalActionTriggerInput>;
  followUpPrompt?: InputMaybe<OdProtosRubricV2Data_FollowUpPromptInput>;
  followUpPromptGroup?: InputMaybe<OdProtosRubricV2Data_FollowUpPromptGroupInput>;
  /**
   * prompt_group_addition has not been properly implemented
   * it might get deprecated
   */
  promptGroupAddition?: InputMaybe<OdProtosRubricV2Data_PromptGroupAdditionInput>;
  textValidation?: InputMaybe<OdProtosRubricV2Data_TextValidationInput>;
};

export type OdProtosRubricV2Data_PromptGroupAdditionInput = {
  condition?: InputMaybe<OdProtosRubricV2Data_PromptGroupAddition_Condition>;
  /** the prompt group needs to be part of the cloneable_prompt_groups on the rubric */
  promptGroupId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosRubricV2Data_PromptGroupAddition_Condition {
  NONE = 'NONE',
  /** Add if needed ONCE = 2; */
  ONE_PER_NUMBER = 'ONE_PER_NUMBER'
}

export type OdProtosRubricV2Data_PromptGroupInput = {
  /**
   * some prompts have followup prompt groups.
   * this list contains all followup prompt groups this
   * prompt group allows.
   */
  allowedFollowupPromptGroups?: InputMaybe<Array<OdProtosRubricV2Data_AllowedFollowUpPromptGroupInput>>;
  /**
   * some prompts have followup prompts.
   * this list contains all followup prompts this
   * prompt group allows.
   */
  allowedFollowupPrompts?: InputMaybe<Array<OdProtosRubricV2Data_PromptInput>>;
  /** correlation_key is used to correlate this prompt group with other related prompt groups in different rubrics */
  correlationKey?: InputMaybe<Scalars['String']['input']>;
  /** id identifies the prompt group. There can be multiple occasions of this id. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** key is a unique identifier */
  key?: InputMaybe<Scalars['String']['input']>;
  prompts?: InputMaybe<Array<OdProtosRubricV2Data_PromptInput>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Data_PromptInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** correlation_key is used to correlate this prompt with other related prompts in different rubrics */
  correlationKey?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** id identifies the prompt. There can be multiple occasions of this id. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** key is a unique identifier */
  key?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<OdProtosRubricV2Data_OptionInput>>;
  previousVisit?: InputMaybe<OdProtosRubricV2Data_PreviousVisitDataInput>;
  /** prompt_behaviors are executed in order if the previous succeeds */
  promptBehaviors?: InputMaybe<Array<OdProtosRubricV2Data_PromptBehaviorInput>>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  response?: InputMaybe<OdProtosRubricV2Data_Prompt_ResponseOneofInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<OdProtosRubricV2Data_Prompt_Type>;
};

export type OdProtosRubricV2Data_Prompt_ResponseOneofInput = {
  audios?: InputMaybe<OdProtosRubricV2Data_UploadedAudiosInput>;
  photos?: InputMaybe<OdProtosRubricV2Data_UploadedPhotosInput>;
  selectedOptions?: InputMaybe<OdProtosRubricV2Data_SelectedOptionsInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<OdProtosRubricV2Data_UploadedVideosInput>;
};

export enum OdProtosRubricV2Data_Prompt_Type {
  AUDIO_INPUT = 'AUDIO_INPUT',
  FREEFORM = 'FREEFORM',
  MULTIPLE_SELECT = 'MULTIPLE_SELECT',
  PHOTO_INPUT = 'PHOTO_INPUT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT_BOX = 'TEXT_BOX',
  UNKNOWN = 'UNKNOWN',
  VIDEO_INPUT = 'VIDEO_INPUT',
  YEAR_SELECT = 'YEAR_SELECT'
}

export type OdProtosRubricV2Data_RegexValidationInput = {
  /** explanation of the regex in plain english. To be shown if the regex doesn't match */
  explanation?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Data_RubricInput = {
  cloneablePromptGroups?: InputMaybe<Array<OdProtosRubricV2Data_PromptGroupInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<OdProtosRubricV2Data_EventInput>>;
  /** id identifies the rubric. There can be multiple occasions of this id. */
  id: Scalars['ID']['input'];
  /** key is a unique identifier */
  key?: InputMaybe<Scalars['String']['input']>;
  originatingReportId?: InputMaybe<Scalars['String']['input']>;
  originatingRubricId?: InputMaybe<Scalars['String']['input']>;
  promptGroups?: InputMaybe<Array<OdProtosRubricV2Data_PromptGroupInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Data_SelectedOptionsInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Data_TextValidationInput = {
  answerTypeValidation?: InputMaybe<OdProtosRubricV2Data_TextValidation_AnswerTypeValidation>;
  /** If the answer is a number we make sure it's >= lower bound */
  lowerBoundValidation?: InputMaybe<Scalars['Float']['input']>;
  regexValidation?: InputMaybe<OdProtosRubricV2Data_RegexValidationInput>;
  /** If the answer is a number we make sure it's <= upper bound */
  upperBoundValidation?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosRubricV2Data_TextValidation_AnswerTypeValidation {
  /** a number */
  FLOAT = 'FLOAT',
  /** an integer */
  INT = 'INT',
  /** no type validation */
  NONE = 'NONE',
  /** a year or "unknown" */
  YEAR = 'YEAR'
}

export type OdProtosRubricV2Data_UploadedAudiosInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Data_UploadedPhotosInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Data_UploadedVideosInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Services_AddPromptGroupsRequestInput = {
  promptGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reportId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_AnswerOptionBehaviorRequestInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  optionValue?: InputMaybe<Scalars['String']['input']>;
  promptKey?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_AnswerPromptRequestInput = {
  promptKey?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneofInput>;
};

export type OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneofInput = {
  audios?: InputMaybe<OdProtosRubricV2Data_UploadedAudiosInput>;
  photos?: InputMaybe<OdProtosRubricV2Data_UploadedPhotosInput>;
  selectedOptions?: InputMaybe<OdProtosRubricV2Data_SelectedOptionsInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<OdProtosRubricV2Data_UploadedVideosInput>;
};

export type OdProtosRubricV2Services_BackfillQuestionsAndAnswersRequestInput = {
  /** Provide either limit and offset or report ids */
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  reportIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Services_CompleteReportAndTaskRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_CreateReportForVisitRequestInput = {
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_CreateTaskWithRubricRequestInput = {
  originatingRubricId?: InputMaybe<Scalars['String']['input']>;
  taskRequest?: InputMaybe<OdProtosCaseyV0Services_Create_RequestInput>;
};

export type OdProtosRubricV2Services_CreateVisitTypeRubricAssociationRequestInput = {
  rubricId?: InputMaybe<Scalars['String']['input']>;
  visitTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_GetPromptDiscrepancyStatisticsRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Services_IdentifierInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_MockAgentFullAssessmentForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  agentHumanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_MockIpwForReportRequestInput = {
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_QuestionFilterInput = {
  /** A filter which must match against the answers for the question. */
  answerFilter?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_ExprInput>;
  /** If specified, the question must have the given dwh tag */
  questionDwhTag?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_QuestionFilter_AndInput = {
  exprs?: InputMaybe<Array<OdProtosRubricV2Services_QuestionFilter_ExprInput>>;
};

export type OdProtosRubricV2Services_QuestionFilter_AnswerPredicateInput = {
  /**
   * A list of answer values to compare against the answers in the
   * database.
   */
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Indicates if this predicate requires that the questions
   * answers are a subset or a superset of the provided answers.
   * Only matters for multi-select.
   */
  setOp?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_SetRelation>;
};

/**
 * We wrap the predicate in a oneof so we can gracefully extend the interface with
 * boolean combinators if needed in the future.
 */
export type OdProtosRubricV2Services_QuestionFilter_ExprInput = {
  expr?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_Expr_ExprOneofInput>;
};

export type OdProtosRubricV2Services_QuestionFilter_Expr_ExprOneofInput = {
  and?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_AndInput>;
  or?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_OrInput>;
  pred?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_AnswerPredicateInput>;
};

export type OdProtosRubricV2Services_QuestionFilter_OrInput = {
  exprs?: InputMaybe<Array<OdProtosRubricV2Services_QuestionFilter_ExprInput>>;
};

export enum OdProtosRubricV2Services_QuestionFilter_SetRelation {
  SUBSET = 'SUBSET',
  SUPERSET = 'SUPERSET'
}

export type OdProtosRubricV2Services_RemovePromptGroupRequestInput = {
  promptGroupKey?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosRubricV2Services_RepeatedIdentifierInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Services_ReplaceVisitRubricContentRequestInput = {
  rubricId?: InputMaybe<Scalars['String']['input']>;
  visitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosRubricV2Services_SearchReportQuestionsRequestInput = {
  /** If specified, only restrict the search to reports attached to the given address. */
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If specified, restrict the search to reports submitted in the last `lookback_seconds` */
  lookbackSeconds?: InputMaybe<Scalars['Float']['input']>;
  /**
   * If specified, a filter to apply to the questions asked in the reports. At least one
   * question must match the filter in order for the report it is attached to to match.
   */
  questionFilter?: InputMaybe<OdProtosRubricV2Services_SearchReportQuestionsRequest_ExprInput>;
};

export type OdProtosRubricV2Services_SearchReportQuestionsRequest_AndInput = {
  exprs?: InputMaybe<Array<OdProtosRubricV2Services_SearchReportQuestionsRequest_ExprInput>>;
};

/**
 * We wrap the filter in a oneof struct so that we can gracefully extend the interface
 * with boolean combinators (and, or) in the future if needed. They are not yet needed,
 * so we haven't implemented them.
 */
export type OdProtosRubricV2Services_SearchReportQuestionsRequest_ExprInput = {
  expr?: InputMaybe<OdProtosRubricV2Services_SearchReportQuestionsRequest_Expr_ExprOneofInput>;
};

export type OdProtosRubricV2Services_SearchReportQuestionsRequest_Expr_ExprOneofInput = {
  and?: InputMaybe<OdProtosRubricV2Services_SearchReportQuestionsRequest_AndInput>;
  filter?: InputMaybe<OdProtosRubricV2Services_QuestionFilterInput>;
  or?: InputMaybe<OdProtosRubricV2Services_SearchReportQuestionsRequest_OrInput>;
};

export type OdProtosRubricV2Services_SearchReportQuestionsRequest_OrInput = {
  exprs?: InputMaybe<Array<OdProtosRubricV2Services_SearchReportQuestionsRequest_ExprInput>>;
};

export type OdProtosRubricV2Services_UpdateReportRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  rubric?: InputMaybe<OdProtosRubricV2Data_RubricInput>;
};

/**
 * Indicates when the next follow-up action should be taken for a card.
 * Used to schedule follow-up activities (e.g. today, tomorrow, after tomorrow).
 */
export enum OdProtosSalesCrmData_ActionFor {
  ACTION_FOR_AFTER_TOMORROW = 'ACTION_FOR_AFTER_TOMORROW',
  ACTION_FOR_TODAY = 'ACTION_FOR_TODAY',
  ACTION_FOR_TOMORROW = 'ACTION_FOR_TOMORROW',
  ACTION_FOR_UNSPECIFIED = 'ACTION_FOR_UNSPECIFIED'
}

export enum OdProtosSalesCrmData_AlertSeverity {
  ALERT_SEVERITY_CRITICAL = 'ALERT_SEVERITY_CRITICAL',
  ALERT_SEVERITY_UNSPECIFIED = 'ALERT_SEVERITY_UNSPECIFIED',
  ALERT_SEVERITY_WARNING = 'ALERT_SEVERITY_WARNING'
}

export enum OdProtosSalesCrmData_AlertStatus {
  ALERT_STATUS_CORRECT = 'ALERT_STATUS_CORRECT',
  ALERT_STATUS_FALSE_POSITIVE = 'ALERT_STATUS_FALSE_POSITIVE',
  ALERT_STATUS_OPEN = 'ALERT_STATUS_OPEN',
  ALERT_STATUS_UNSPECIFIED = 'ALERT_STATUS_UNSPECIFIED'
}

/** AssignedHSA represents either a human or a virtual agent assigned to a card. */
export type OdProtosSalesCrmData_AssignedHsaInput = {
  type?: InputMaybe<OdProtosSalesCrmData_AssignedHsa_TypeOneofInput>;
};

/** A human assigned to the card. */
export type OdProtosSalesCrmData_AssignedHsa_HumanInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosSalesCrmData_AssignedHsa_TypeOneofInput = {
  human?: InputMaybe<OdProtosSalesCrmData_AssignedHsa_HumanInput>;
  virtualAgent?: InputMaybe<OdProtosSalesCrmData_AssignedHsa_VirtualAgentInput>;
};

/** A virtual agent assigned to the card. */
export type OdProtosSalesCrmData_AssignedHsa_VirtualAgentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosSalesCrmData_CallOutcome {
  CALL_OUTCOME_ASSESSMENT_SCHEDULED = 'CALL_OUTCOME_ASSESSMENT_SCHEDULED',
  CALL_OUTCOME_BUSY = 'CALL_OUTCOME_BUSY',
  CALL_OUTCOME_FAILED = 'CALL_OUTCOME_FAILED',
  CALL_OUTCOME_MEETING_BOOKED = 'CALL_OUTCOME_MEETING_BOOKED',
  CALL_OUTCOME_NO_ANSWER = 'CALL_OUTCOME_NO_ANSWER',
  CALL_OUTCOME_SCHEDULING_FAILED = 'CALL_OUTCOME_SCHEDULING_FAILED',
  CALL_OUTCOME_SPOKE_TO_CUSTOMER = 'CALL_OUTCOME_SPOKE_TO_CUSTOMER',
  CALL_OUTCOME_UNSPECIFIED = 'CALL_OUTCOME_UNSPECIFIED',
  CALL_OUTCOME_VOICEMAIL = 'CALL_OUTCOME_VOICEMAIL'
}

/** A message for aggregating filters. */
export type OdProtosSalesCrmData_CardFiltersInput = {
  /**
   * Assignee human ID is a field that allows to filter cards by the assigned
   * human ID.
   */
  assigneeHumanId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by card flavor */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /**
   * Follow up timing is a field that allows to filter cards by the time when
   * a follow up action should be taken.
   */
  followUpTiming?: InputMaybe<OdProtosSalesCrmData_ActionFor>;
  /** Filter by whether the offer has been refreshed */
  isOfferRefreshed?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  /** Filter by card type */
  type?: InputMaybe<OdProtosSalesCrmData_CardType>;
};

/** Card should contain all data visible on a single card in the Prospect View. */
export type OdProtosSalesCrmData_CardInput = {
  /** The assigned HSA to the card */
  assignedHsa?: InputMaybe<OdProtosSalesCrmData_AssignedHsaInput>;
  /** The human ID assigned to this card. */
  assigneeHumanId?: InputMaybe<Scalars['String']['input']>;
  /** The time card was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Precise follow up action date and time */
  expectedActionAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The experiment */
  experiment?: InputMaybe<OdProtosSalesCrmData_Card_ExperimentOneofInput>;
  /** The flavor of the card (ALO, Non-ALO, D2C) */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /**
   * Follow up timing is a field that allows to filter cards by the time when
   * a follow up action should be taken.
   */
  followUpTiming?: InputMaybe<OdProtosSalesCrmData_ActionFor>;
  /** Whether the offer has been refreshed */
  isOfferRefreshed?: InputMaybe<Scalars['Boolean']['input']>;
  /** I.e. ALO, Overdue */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * This is a language code used to register this card in the onboarding process.
   * The format is two-letter ISO 639-1 code, e.g. "en", "es", "fr".
   */
  languageCode?: InputMaybe<Scalars['String']['input']>;
  /** The Lead Token that that belongs to the card. */
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** Number of times the card was moved to no-contact stage */
  noContactAttempts?: InputMaybe<Scalars['Float']['input']>;
  /** A stage of the card. */
  stage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  /** I.e. Contact made - not interested. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * A task sequence state of the card.
   * E.g. `Day 5` or `Day 3`.
   */
  taskSequenceState?: InputMaybe<Scalars['String']['input']>;
  /** The type of the card (prospect or lead) */
  type?: InputMaybe<OdProtosSalesCrmData_CardType>;
  /** The time card was updated */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** CardType represents the type of a card. */
export enum OdProtosSalesCrmData_CardType {
  CARD_TYPE_LEAD = 'CARD_TYPE_LEAD',
  CARD_TYPE_PROSPECT = 'CARD_TYPE_PROSPECT',
  CARD_TYPE_UNSPECIFIED = 'CARD_TYPE_UNSPECIFIED'
}

export type OdProtosSalesCrmData_Card_ExperimentOneofInput = {
  higherOffer?: InputMaybe<OdProtosSalesCrmData_ExperimentHigherOfferInput>;
  odlo?: InputMaybe<OdProtosSalesCrmData_ExperimentOdloInput>;
  odloHigherOffer?: InputMaybe<OdProtosSalesCrmData_ExperimentOdloHigherOfferInput>;
};

export type OdProtosSalesCrmData_CheckRunAlertFiltersInput = {
  checkName?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<OdProtosSalesCrmData_AlertSeverity>;
  status?: InputMaybe<OdProtosSalesCrmData_AlertStatus>;
};

/** CommunicationType defines the types of communication channels */
export enum OdProtosSalesCrmData_CommunicationType {
  COMMUNICATION_TYPE_SMS = 'COMMUNICATION_TYPE_SMS',
  COMMUNICATION_TYPE_UNSPECIFIED = 'COMMUNICATION_TYPE_UNSPECIFIED'
}

/** DistributionConfig defines the complete distribution configuration. */
export type OdProtosSalesCrmData_DistributionConfigInput = {
  /**
   * List of distribution rules (percentages must sum to 100)
   * Used as fallback when no score rule matches, or when score data is not available.
   */
  rules?: InputMaybe<Array<OdProtosSalesCrmData_DistributionRuleInput>>;
  /**
   * ScoreRules are evaluated first, in order. If a score rule matches, its distribution is used.
   * Optional - if not provided, percentage-based rules are used exclusively.
   */
  scoreRules?: InputMaybe<Array<OdProtosSalesCrmData_ScoreRuleInput>>;
};

/**
 * DistributionRule defines a single rule for distributing cards to HSAs.
 * Each rule assigns a percentage of cards to either a group or a specific agent.
 */
export type OdProtosSalesCrmData_DistributionRuleInput = {
  /**
   * Percentage of cards this rule should handle (0-100)
   * All rule percentages must sum to 100
   */
  percentage?: InputMaybe<Scalars['Float']['input']>;
  /** The target for this distribution rule (either a group or specific agent) */
  target?: InputMaybe<OdProtosSalesCrmData_DistributionRule_TargetOneofInput>;
};

export type OdProtosSalesCrmData_DistributionRule_TargetOneofInput = {
  /** Specific agent's human ID */
  agentId?: InputMaybe<Scalars['String']['input']>;
  /** HSA group to distribute evenly among all HSAs in this group */
  group?: InputMaybe<OdProtosSalesCrmData_HsaGroup>;
};

/** ExpectedOutcome represents the expected outcome for a card */
export enum OdProtosSalesCrmData_ExpectedOutcome {
  EXPECTED_OUTCOME_ASSESSMENT_SCHEDULED = 'EXPECTED_OUTCOME_ASSESSMENT_SCHEDULED',
  EXPECTED_OUTCOME_OFFER_REVIEW = 'EXPECTED_OUTCOME_OFFER_REVIEW',
  EXPECTED_OUTCOME_UNSPECIFIED = 'EXPECTED_OUTCOME_UNSPECIFIED'
}

/** A list of available experiments */
export enum OdProtosSalesCrmData_Experiment {
  /** Higher Offer. */
  EXPERIMENT_HIGHER_OFFER = 'EXPERIMENT_HIGHER_OFFER',
  /** ALO but without agents. */
  EXPERIMENT_ODLO = 'EXPERIMENT_ODLO',
  /** ODLO Higher Offer. */
  EXPERIMENT_ODLO_HIGHER_OFFER = 'EXPERIMENT_ODLO_HIGHER_OFFER',
  EXPERIMENT_UNSPECIFIED = 'EXPERIMENT_UNSPECIFIED'
}

/** A message for aggregating experiment card filters. */
export type OdProtosSalesCrmData_ExperimentCardFiltersInput = {
  /**
   * Assignee human ID is a field that allows to filter cards by the assigned
   * human ID.
   */
  assigneeHumanId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Experiment cards to fetch.
   * No experiment specified means all cards from all experiments will be returned.
   */
  experiment?: InputMaybe<Array<OdProtosSalesCrmData_Experiment>>;
  /** Filter by card flavor */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /** Filter by whether the offer has been refreshed */
  isOfferRefreshed?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  /** Filter by tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by card type */
  type?: InputMaybe<OdProtosSalesCrmData_CardType>;
};

/**
 * Higher Offer
 * ODLO Experiment: treatment_higher_offer
 */
export type OdProtosSalesCrmData_ExperimentHigherOfferInput = {
  selectedAssessmentTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * ALO but without agents and with Higher Offer
 * ODLO Experiment: treatment_higher_offer_odlo
 */
export type OdProtosSalesCrmData_ExperimentOdloHigherOfferInput = {
  selectedAssessmentTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * ALO but without agents (ODLO)
 * ODLO Experiment: treatment
 */
export type OdProtosSalesCrmData_ExperimentOdloInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Flavor represents the flavor of a card. */
export enum OdProtosSalesCrmData_Flavor {
  /** Agent-Led Offer */
  FLAVOR_ALO = 'FLAVOR_ALO',
  /** Direct to Consumer */
  FLAVOR_D2C = 'FLAVOR_D2C',
  /** Direct to Consumer - Button Clicked */
  FLAVOR_D2C_BUTTON_CLICKED = 'FLAVOR_D2C_BUTTON_CLICKED',
  /** Non Agent-Led Offer */
  FLAVOR_NON_ALO = 'FLAVOR_NON_ALO',
  FLAVOR_UNSPECIFIED = 'FLAVOR_UNSPECIFIED'
}

/** HSAGroup defines the available groups for HSAs. */
export enum OdProtosSalesCrmData_HsaGroup {
  HSA_GROUP_AI = 'HSA_GROUP_AI',
  HSA_GROUP_DEFAULT = 'HSA_GROUP_DEFAULT',
  HSA_GROUP_MEXICO_TEAM = 'HSA_GROUP_MEXICO_TEAM',
  HSA_GROUP_UNSPECIFIED = 'HSA_GROUP_UNSPECIFIED'
}

/** HSAVirtualAgentConfig holds the configuration for a virtual sales agent */
export type OdProtosSalesCrmData_HsaVirtualAgentConfigInput = {
  /** Initial delay in minutes before starting the sequence (optional, nil means use default) */
  initialDelayInMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the virtual agent */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Hour to schedule the first action when a card is created outside business hours */
  outsideHoursFirstActionHour?: InputMaybe<Scalars['Int']['input']>;
  /** Phone number for the virtual agent */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** RetellAI configuration */
  retellConfig?: InputMaybe<OdProtosSalesCrmData_RetellAiConfigInput>;
  /** Sequence configuration */
  sequence?: InputMaybe<OdProtosSalesCrmData_SequenceConfigInput>;
  /** Human-readable sequence description for UI display */
  sequenceDescription?: InputMaybe<Scalars['String']['input']>;
  /** Sequence type for filtering and categorization */
  sequenceType?: InputMaybe<OdProtosSalesCrmData_SequenceType>;
  /** Testing configuration (optional) */
  testing?: InputMaybe<OdProtosSalesCrmData_VirtualAgentTestingConfigInput>;
  /** Version of the virtual agent */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** LLMAction represents the action determined by the LLM. */
export enum OdProtosSalesCrmData_LlmAction {
  LLM_ACTION_CONFIRM = 'LLM_ACTION_CONFIRM',
  LLM_ACTION_ESCALATE_TO_HUMAN = 'LLM_ACTION_ESCALATE_TO_HUMAN',
  LLM_ACTION_NO_ACTION = 'LLM_ACTION_NO_ACTION',
  LLM_ACTION_SEND_CALENDLY_LINK = 'LLM_ACTION_SEND_CALENDLY_LINK',
  LLM_ACTION_SEND_SMS = 'LLM_ACTION_SEND_SMS',
  LLM_ACTION_UNSPECIFIED = 'LLM_ACTION_UNSPECIFIED'
}

/** LLMIntent represents the detected intent for event that triggered the LLM processing. */
export enum OdProtosSalesCrmData_LlmIntent {
  LLM_INTENT_ASK_QUESTION = 'LLM_INTENT_ASK_QUESTION',
  LLM_INTENT_CANCEL_TOUR = 'LLM_INTENT_CANCEL_TOUR',
  LLM_INTENT_CONFIRM_TOUR = 'LLM_INTENT_CONFIRM_TOUR',
  LLM_INTENT_NOT_INTERESTED = 'LLM_INTENT_NOT_INTERESTED',
  LLM_INTENT_OTHER = 'LLM_INTENT_OTHER',
  LLM_INTENT_RESCHEDULE_TOUR = 'LLM_INTENT_RESCHEDULE_TOUR',
  LLM_INTENT_SCHEDULE_TOUR = 'LLM_INTENT_SCHEDULE_TOUR',
  LLM_INTENT_UNSPECIFIED = 'LLM_INTENT_UNSPECIFIED'
}

/** LLMInteractionStatus represents the processing status of an interaction. */
export enum OdProtosSalesCrmData_LlmInteractionStatus {
  LLM_INTERACTION_STATUS_FAILED = 'LLM_INTERACTION_STATUS_FAILED',
  LLM_INTERACTION_STATUS_PENDING = 'LLM_INTERACTION_STATUS_PENDING',
  LLM_INTERACTION_STATUS_PROCESSED = 'LLM_INTERACTION_STATUS_PROCESSED',
  LLM_INTERACTION_STATUS_UNSPECIFIED = 'LLM_INTERACTION_STATUS_UNSPECIFIED'
}

/** LLMPromptConfigurationType defines the types of prompt configurations. */
export enum OdProtosSalesCrmData_LlmPromptConfigurationType {
  LLM_PROMPT_CONFIGURATION_TYPE_SMS = 'LLM_PROMPT_CONFIGURATION_TYPE_SMS',
  LLM_PROMPT_CONFIGURATION_TYPE_UNSPECIFIED = 'LLM_PROMPT_CONFIGURATION_TYPE_UNSPECIFIED'
}

/** LLMPromptConfigurationVariables describes variables used in prompt templates */
export type OdProtosSalesCrmData_LlmPromptConfigurationVariablesInput = {
  appointmentDetails?: InputMaybe<Scalars['String']['input']>;
  availabilityTimeSlots?: InputMaybe<Array<Scalars['String']['input']>>;
  cardStage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  currentTime?: InputMaybe<Scalars['DateTime']['input']>;
  homeAddress?: InputMaybe<Scalars['String']['input']>;
  isAssessmentCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  smsCommunicationHistory?: InputMaybe<Array<OdProtosSalesCrmData_SmsCommunicationInput>>;
};

export type OdProtosSalesCrmData_PhoneCallFiltersInput = {
  agents?: InputMaybe<Array<OdProtosSalesCrmData_VirtualAgentFilterInput>>;
  callIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxDurationSeconds?: InputMaybe<Scalars['Float']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
  minDurationSeconds?: InputMaybe<Scalars['Float']['input']>;
  outcomes?: InputMaybe<Array<OdProtosSalesCrmData_CallOutcome>>;
  /** Generic search string that matches against lead_token or call_id */
  search?: InputMaybe<Scalars['String']['input']>;
  sequences?: InputMaybe<Array<OdProtosSalesCrmData_SequenceType>>;
};

export type OdProtosSalesCrmData_PhoneCallSortInput = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<OdProtosSalesCrmData_PhoneCallSort_Field>;
};

export enum OdProtosSalesCrmData_PhoneCallSort_Field {
  CALLED_AT = 'CALLED_AT',
  DURATION = 'DURATION'
}

/** RetellAIConfig holds the configuration for RetellAI provider */
export type OdProtosSalesCrmData_RetellAiConfigInput = {
  /** RetellAI agent ID */
  agentId?: InputMaybe<Scalars['String']['input']>;
  /** RetellAI agent version */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosSalesCrmData_SmsCommunicationDirection {
  SMS_COMMUNICATION_DIRECTION_INBOUND = 'SMS_COMMUNICATION_DIRECTION_INBOUND',
  SMS_COMMUNICATION_DIRECTION_OUTBOUND = 'SMS_COMMUNICATION_DIRECTION_OUTBOUND',
  SMS_COMMUNICATION_DIRECTION_UNSPECIFIED = 'SMS_COMMUNICATION_DIRECTION_UNSPECIFIED'
}

export type OdProtosSalesCrmData_SmsCommunicationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<OdProtosSalesCrmData_SmsCommunicationDirection>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

/** ScoreRule filters cards by propensity score, then distributes by percentage. */
export type OdProtosSalesCrmData_ScoreRuleInput = {
  /**
   * Distribution defines how to distribute cards that match this score range.
   * Percentages must sum to 100.
   */
  distribution?: InputMaybe<Array<OdProtosSalesCrmData_DistributionRuleInput>>;
  /**
   * MaxScore is the maximum propensity score (exclusive) for this rule to match.
   * Use 0 or check the actual value to distinguish from "not set".
   */
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  /**
   * MinScore is the minimum propensity score (inclusive) for this rule to match.
   * Use 0 or check the actual value to distinguish from "not set".
   */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /**
   * ScoreType specifies whether to use "score" (TRUE_SELLER_PREDICTION_SCORE)
   * or "percentile" (TRUE_SELLER_PERCENTILE). Defaults to SCORE_TYPE_SCORE for backward compatibility.
   */
  scoreType?: InputMaybe<OdProtosSalesCrmData_ScoreType>;
};

/** ScoreType defines the type of score used for routing. */
export enum OdProtosSalesCrmData_ScoreType {
  /** Uses TRUE_SELLER_PERCENTILE for routing */
  SCORE_TYPE_PERCENTILE = 'SCORE_TYPE_PERCENTILE',
  /** Uses TRUE_SELLER_PREDICTION_SCORE for routing */
  SCORE_TYPE_SCORE = 'SCORE_TYPE_SCORE',
  SCORE_TYPE_UNSPECIFIED = 'SCORE_TYPE_UNSPECIFIED'
}

/** SequenceAction defines an action within a sequence day */
export type OdProtosSalesCrmData_SequenceActionInput = {
  action?: InputMaybe<OdProtosSalesCrmData_SequenceAction_ActionOneofInput>;
  /** Delay in minutes before executing this action */
  delayInMinutes?: InputMaybe<Scalars['Float']['input']>;
};

/** SequenceActionType defines the type of action in a sequence */
export enum OdProtosSalesCrmData_SequenceActionType {
  SEQUENCE_ACTION_TYPE_CALL = 'SEQUENCE_ACTION_TYPE_CALL',
  SEQUENCE_ACTION_TYPE_SMS = 'SEQUENCE_ACTION_TYPE_SMS',
  SEQUENCE_ACTION_TYPE_UNSPECIFIED = 'SEQUENCE_ACTION_TYPE_UNSPECIFIED'
}

export type OdProtosSalesCrmData_SequenceAction_ActionOneofInput = {
  phoneCall?: InputMaybe<OdProtosSalesCrmData_SequenceAction_PhoneCallInput>;
  sms?: InputMaybe<OdProtosSalesCrmData_SequenceAction_SmsInput>;
};

export type OdProtosSalesCrmData_SequenceAction_PhoneCallInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosSalesCrmData_SequenceAction_SmsInput = {
  /** SMS template */
  template?: InputMaybe<Scalars['String']['input']>;
};

/** SequenceConfig defines the complete sequence configuration */
export type OdProtosSalesCrmData_SequenceConfigInput = {
  /** List of sequence days */
  days?: InputMaybe<Array<OdProtosSalesCrmData_SequenceDayInput>>;
  /** Version of the sequence configuration */
  version?: InputMaybe<Scalars['Float']['input']>;
};

/** SequenceDay defines the actions for a specific day in the sequence */
export type OdProtosSalesCrmData_SequenceDayInput = {
  /** List of actions for this day */
  actions?: InputMaybe<Array<OdProtosSalesCrmData_SequenceActionInput>>;
  /** Business days to wait before next stage */
  nextStageInDays?: InputMaybe<Scalars['Float']['input']>;
  /** Stage of the sequence (e.g., "1", "3", "5") */
  stage?: InputMaybe<Scalars['String']['input']>;
};

/** SequenceType defines the type of sequence for virtual agent campaigns */
export enum OdProtosSalesCrmData_SequenceType {
  SEQUENCE_TYPE_EARLY_DROP_OFF = 'SEQUENCE_TYPE_EARLY_DROP_OFF',
  SEQUENCE_TYPE_SCHEDULING_NOT_SUBMITTED = 'SEQUENCE_TYPE_SCHEDULING_NOT_SUBMITTED',
  SEQUENCE_TYPE_UNSPECIFIED = 'SEQUENCE_TYPE_UNSPECIFIED'
}

/** Stage is a stage of a card in Sales CRM. */
export enum OdProtosSalesCrmData_Stage {
  STAGE_CONTACT_MADE = 'STAGE_CONTACT_MADE',
  STAGE_HANDOFF_COMPLETE = 'STAGE_HANDOFF_COMPLETE',
  STAGE_NEW_LEAD = 'STAGE_NEW_LEAD',
  STAGE_NOT_INTERESTED = 'STAGE_NOT_INTERESTED',
  STAGE_NO_CONTACT = 'STAGE_NO_CONTACT',
  STAGE_UNSPECIFIED = 'STAGE_UNSPECIFIED'
}

export enum OdProtosSalesCrmData_TextConversationDirection {
  TEXT_CONVERSATION_DIRECTION_INBOUND = 'TEXT_CONVERSATION_DIRECTION_INBOUND',
  TEXT_CONVERSATION_DIRECTION_OUTBOUND = 'TEXT_CONVERSATION_DIRECTION_OUTBOUND',
  TEXT_CONVERSATION_DIRECTION_UNSPECIFIED = 'TEXT_CONVERSATION_DIRECTION_UNSPECIFIED'
}

export type OdProtosSalesCrmData_TextConversationFiltersInput = {
  agents?: InputMaybe<Array<OdProtosSalesCrmData_VirtualAgentFilterInput>>;
  direction?: InputMaybe<OdProtosSalesCrmData_TextConversationDirection>;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosSalesCrmData_TextConversationSortInput = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<OdProtosSalesCrmData_TextConversationSort_Field>;
};

export enum OdProtosSalesCrmData_TextConversationSort_Field {
  FIELD_UNSPECIFIED = 'FIELD_UNSPECIFIED',
  LAST_ACTIVITY = 'LAST_ACTIVITY'
}

/** TranscriptAnchor describes where the comment is placed in transcript text */
export type OdProtosSalesCrmData_TranscriptAnchorInput = {
  endCharOffset?: InputMaybe<Scalars['Float']['input']>;
  endSegmentId?: InputMaybe<Scalars['String']['input']>;
  endWordIndex?: InputMaybe<Scalars['Float']['input']>;
  startCharOffset?: InputMaybe<Scalars['Float']['input']>;
  startSegmentId?: InputMaybe<Scalars['String']['input']>;
  startWordIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosSalesCrmData_VirtualAgentFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional - if empty, matches any version */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** VirtualAgentTestingConfig holds testing configuration for overriding phone numbers */
export type OdProtosSalesCrmData_VirtualAgentTestingConfigInput = {
  /** Disable business hours and business days checks (optional) */
  disableBusinessHoursCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** Override customer phone number for calls (optional) */
  overwriteCustomerPhoneNumberForCalls?: InputMaybe<Scalars['String']['input']>;
  /** Override customer phone number for SMS (optional) */
  overwriteCustomerPhoneNumberForSms?: InputMaybe<Scalars['String']['input']>;
  /** Override customer timezone (optional) */
  overwriteCustomerTimezone?: InputMaybe<Scalars['String']['input']>;
};

/** Request to assign a card to a virtual agent */
export type OdProtosSalesCrmServices_AssignCardToVirtualAgentRequestInput = {
  /** Required. The human ID of the virtual agent to assign the card to */
  humanId?: InputMaybe<Scalars['String']['input']>;
  /** Required. The lead token of the card to assign */
  leadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSalesCrmServices_BatchGetFinalOfferContractPropensityScoresRequestInput = {
  /** Required. The address tokens to look up propensity scores for. */
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** ConfirmCheckRunAlertRequest marks an alert as a true alert (correct). */
export type OdProtosSalesCrmServices_ConfirmCheckRunAlertRequestInput = {
  /** Required. The ID of the alert to confirm. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Optional. A reviewer note explaining the confirmation. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** CreateCommentReplyRequest is used to create a reply to an existing comment. */
export type OdProtosSalesCrmServices_CreateCommentReplyRequestInput = {
  /** Required. Reply content. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Required. Parent comment ID to reply to. */
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
};

/** CreateCommentRequest is used to create a root comment with anchor. */
export type OdProtosSalesCrmServices_CreateCommentRequestInput = {
  /** Required. Comment anchor, defining the exact location of the comment */
  anchor?: InputMaybe<OdProtosSalesCrmServices_CreateCommentRequest_AnchorOneofInput>;
  /** Required. Comment content. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Required. The ID of the resource that the comment is attributed to. */
  resourceId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSalesCrmServices_CreateCommentRequest_AnchorOneofInput = {
  transcriptAnchor?: InputMaybe<OdProtosSalesCrmData_TranscriptAnchorInput>;
};

/** CreateHSARequest is used to create a new HSA. */
export type OdProtosSalesCrmServices_CreateHsaRequestInput = {
  /** Optional. Virtual agent configuration for the HSA. */
  config?: InputMaybe<OdProtosSalesCrmData_HsaVirtualAgentConfigInput>;
  /** Required. The group the HSA belongs to. */
  group?: InputMaybe<OdProtosSalesCrmData_HsaGroup>;
  /** Required. The human ID of the HSA. */
  humanId?: InputMaybe<Scalars['String']['input']>;
};

/** CreateLLMPromptConfigurationRequest is used to create a new LLM prompt configuration. */
export type OdProtosSalesCrmServices_CreateLlmPromptConfigurationRequestInput = {
  /** Optional. Template for context injection. */
  contextTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Optional. Human-readable description of the configuration. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional. Maximum tokens for response. */
  maxTokens?: InputMaybe<Scalars['Float']['input']>;
  /** Optional. Minimum intent confidence threshold. */
  minIntentConfidence?: InputMaybe<Scalars['Float']['input']>;
  /** Required. LLM model name. */
  modelName?: InputMaybe<Scalars['String']['input']>;
  /** Optional. Human-readable name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Required. LLM prompt configuration type */
  promptType?: InputMaybe<OdProtosSalesCrmData_LlmPromptConfigurationType>;
  /** Required. The system prompt text. */
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Optional. Temperature setting (0.0-1.0). */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Optional. Version string. */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** DeleteCommentRequest is used to soft delete a comment or reply. */
export type OdProtosSalesCrmServices_DeleteCommentRequestInput = {
  /** Required. Comment ID to delete. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** DeleteLLMPromptConfigurationRequest is used to delete a configuration. */
export type OdProtosSalesCrmServices_DeleteLlmPromptConfigurationRequestInput = {
  /** Required. The ID of the configuration to delete. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** DismissCheckRunAlertRequest marks an alert as a false positive. */
export type OdProtosSalesCrmServices_DismissCheckRunAlertRequestInput = {
  /** Required. The ID of the alert to dismiss. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Optional. A reviewer note explaining the dismissal. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** EditHSARequest is used to edit an existing HSA. */
export type OdProtosSalesCrmServices_EditHsaRequestInput = {
  /** A virtual agent config. */
  config?: InputMaybe<OdProtosSalesCrmData_HsaVirtualAgentConfigInput>;
  /** Optional. New group for the HSA (if HSA_GROUP_UNSPECIFIED, group won't be updated). */
  group?: InputMaybe<OdProtosSalesCrmData_HsaGroup>;
  /** Required. The human ID of the HSA to edit. */
  humanId?: InputMaybe<Scalars['String']['input']>;
};

/** GetAllHSAsRequest is used to retrieve all active HSAs. */
export type OdProtosSalesCrmServices_GetAllHsAsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * GetAssignedHumanIDsRequest is used to retrieve a list of human IDs
 * that are assigned to at least one card.
 */
export type OdProtosSalesCrmServices_GetAssignedHumanIDsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Request to get all version history for an outcome type and optional flavor */
export type OdProtosSalesCrmServices_GetAssignmentConfigHistoryRequestInput = {
  /**
   * Optional. The card flavor to filter history for.
   * If FLAVOR_UNSPECIFIED, returns history for the fallback config.
   */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  outcomeType?: InputMaybe<OdProtosSalesCrmData_ExpectedOutcome>;
};

/** GetCardRequest is used to retrieve a single card by its lead token. */
export type OdProtosSalesCrmServices_GetCardRequestInput = {
  /** Required. The token of the lead to retrieve. */
  leadToken?: InputMaybe<Scalars['String']['input']>;
};

/**
 * GetCardsRequest is used to retrieve a list of cards based on the provided
 * filters.
 */
export type OdProtosSalesCrmServices_GetCardsRequestInput = {
  /** Card filters to apply. */
  filters?: InputMaybe<OdProtosSalesCrmData_CardFiltersInput>;
  /**
   * Limit the number of results returned.
   * If not set, defaults to 20.
   */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Optional. If set, the next page of results will be returned. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
};

/** GetCommentsRequest is used to retrieve comments. */
export type OdProtosSalesCrmServices_GetCommentsRequestInput = {
  /** Required. The ID of the resource that the comment is attributed to */
  resourceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * GetExperimentCardsRequest is used to retrieve a list of experiment cards
 * based on the provided filters.
 */
export type OdProtosSalesCrmServices_GetExperimentCardsRequestInput = {
  /** Card filters to apply. */
  filters?: InputMaybe<OdProtosSalesCrmData_ExperimentCardFiltersInput>;
  /**
   * Limit the number of results returned.
   * If not set, defaults to 20.
   */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Optional. If set, the next page of results will be returned. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSalesCrmServices_GetFinalOfferContractPropensityScoreRequestInput = {
  /** Required. The address token to look up the propensity score for. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** GetHSARequest is used to retrieve a single HSA by human ID. */
export type OdProtosSalesCrmServices_GetHsaRequestInput = {
  /** Required. The human ID of the HSA to retrieve. */
  humanId?: InputMaybe<Scalars['String']['input']>;
};

/** GetLLMPromptConfigurationRequest is used to retrieve a configuration by ID. */
export type OdProtosSalesCrmServices_GetLlmPromptConfigurationRequestInput = {
  /** Required. The ID of the configuration. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** GetLLMRequestsByExternalIDsRequest is used to get LLM analysis data by SMS UUIDs. */
export type OdProtosSalesCrmServices_GetLlmRequestsByExternalIDsRequestInput = {
  communicationType?: InputMaybe<OdProtosSalesCrmData_CommunicationType>;
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosSalesCrmServices_GetMarketInsightsRequestInput = {
  /** Required. The postal code to look up market insights for. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

/** GetOverviewStatsRequest is used to retrieve overview statistics for a date range. */
export type OdProtosSalesCrmServices_GetOverviewStatsRequestInput = {
  /** Start of the date range. */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** End of the date range. */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** GetPhoneCallDetailsRequest is used to retrieve detailed information for a single phone call. */
export type OdProtosSalesCrmServices_GetPhoneCallDetailsRequestInput = {
  callId?: InputMaybe<Scalars['String']['input']>;
};

/** GetPhoneCallsRequest is used to retrieve a paginated list of phone calls. */
export type OdProtosSalesCrmServices_GetPhoneCallsRequestInput = {
  filters?: InputMaybe<OdProtosSalesCrmData_PhoneCallFiltersInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sort?: InputMaybe<OdProtosSalesCrmData_PhoneCallSortInput>;
};

/** GetTextConversationsRequest is used to retrieve a paginated list of text conversations. */
export type OdProtosSalesCrmServices_GetTextConversationsRequestInput = {
  filters?: InputMaybe<OdProtosSalesCrmData_TextConversationFiltersInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sort?: InputMaybe<OdProtosSalesCrmData_TextConversationSortInput>;
};

/** GetVirtualAgentTextPromptRequest is used to get prompt configuration. */
export type OdProtosSalesCrmServices_GetVirtualAgentTextPromptRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** GetVirtualAgentTextPromptVariablesRequest is used to get prompt configuration variables for particular lead token */
export type OdProtosSalesCrmServices_GetVirtualAgentTextPromptVariablesRequestInput = {
  leadToken?: InputMaybe<Scalars['String']['input']>;
};

/** GetVirtualAgentsRequest is used to retrieve a list of virtual agents. */
export type OdProtosSalesCrmServices_GetVirtualAgentsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ListCheckRunAlertsRequest is used to retrieve a paginated list of check run alerts. */
export type OdProtosSalesCrmServices_ListCheckRunAlertsRequestInput = {
  filters?: InputMaybe<OdProtosSalesCrmData_CheckRunAlertFiltersInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

/** ListLLMPromptConfigurationsRequest is used to list all configurations. */
export type OdProtosSalesCrmServices_ListLlmPromptConfigurationsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** RestoreHSARequest is used to restore a soft-deleted HSA. */
export type OdProtosSalesCrmServices_RestoreHsaRequestInput = {
  /** Required. The human ID of the HSA to restore. */
  humanId?: InputMaybe<Scalars['String']['input']>;
};

/** Request to rollback to a specific configuration version */
export type OdProtosSalesCrmServices_RollbackAssignmentConfigRequestInput = {
  /**
   * Optional. The card flavor for the config to rollback.
   * If FLAVOR_UNSPECIFIED, rolls back the fallback config.
   */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /** The outcome type to rollback */
  outcomeType?: InputMaybe<OdProtosSalesCrmData_ExpectedOutcome>;
  /** The version to rollback to */
  targetVersion?: InputMaybe<Scalars['Float']['input']>;
};

/** SoftDeleteHSARequest is used to soft delete an HSA. */
export type OdProtosSalesCrmServices_SoftDeleteHsaRequestInput = {
  /** Required. The human ID of the HSA to delete. */
  humanId?: InputMaybe<Scalars['String']['input']>;
};

/** TestVirtualAgentPromptRequest is used to test a prompt with custom variables. */
export type OdProtosSalesCrmServices_TestVirtualAgentPromptRequestInput = {
  promptConfigId?: InputMaybe<Scalars['String']['input']>;
  promptConfigurationVariables?: InputMaybe<OdProtosSalesCrmData_LlmPromptConfigurationVariablesInput>;
  systemPromptOverride?: InputMaybe<Scalars['String']['input']>;
  userPromptOverride?: InputMaybe<Scalars['String']['input']>;
};

/** Request to update an assignment configuration */
export type OdProtosSalesCrmServices_UpdateAssignmentConfigRequestInput = {
  /** The distribution configuration */
  config?: InputMaybe<OdProtosSalesCrmData_DistributionConfigInput>;
  /**
   * Optional. The card flavor for more granular assignment control.
   * If FLAVOR_UNSPECIFIED, creates a fallback config that applies to all cards of the outcome type.
   */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /** The outcome type this config applies to */
  outcomeType?: InputMaybe<OdProtosSalesCrmData_ExpectedOutcome>;
};

/** UpdateCardRequest is used to update a card with the provided lead token. */
export type OdProtosSalesCrmServices_UpdateCardRequestInput = {
  /**
   * Precise follow up action date and time.
   * It has higher priority than follow_up_in_days if both are set.
   */
  expectedActionAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optional. A field that allows to set the number of days after when
   * a new action should be taken.
   */
  followUpInDays?: InputMaybe<Scalars['Float']['input']>;
  /** Required. The token of the lead that will be updated. */
  leadToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional. A new stage that the lead will be moved to. */
  stage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  /**
   * Optional. I.e. Contact made - not interested. This field will fully
   * overwrite the existing tags if any.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional. A field that allows to set the task sequence state. */
  taskSequenceState?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateCommentRequest is used to update an existing comment or reply. */
export type OdProtosSalesCrmServices_UpdateCommentRequestInput = {
  /** Required. New comment content. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Required. Comment ID to update. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateLLMPromptConfigurationRequest is used to update a configuration. */
export type OdProtosSalesCrmServices_UpdateLlmPromptConfigurationRequestInput = {
  /** Optional. New context template. */
  contextTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Optional. New description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Required. The ID of the configuration to update. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Optional. New max tokens setting. */
  maxTokens?: InputMaybe<Scalars['Float']['input']>;
  /** Optional. New min intent confidence. */
  minIntentConfidence?: InputMaybe<Scalars['Float']['input']>;
  /** Optional. New model name. */
  modelName?: InputMaybe<Scalars['String']['input']>;
  /** Optional. New name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional. New system prompt text. */
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Optional. New temperature setting. */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Optional. New version. */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** UpsertCardResponse is used to return the upserted card. */
export type OdProtosSalesCrmServices_UpsertCardRequestInput = {
  /** Required. The card to upsert. */
  card?: InputMaybe<OdProtosSalesCrmData_CardInput>;
};

/** Next ID: 7 */
export type OdProtosScroogeData_AllocationLoanDataInput = {
  /** The current advance amount for the home */
  advanceAmountCents?: InputMaybe<Scalars['Float']['input']>;
  /** When the allocation funds should be advanced */
  advanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The BPO value of the home */
  bpoValueCents?: InputMaybe<Scalars['Float']['input']>;
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /** When the allocation funds should be released */
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The transaction that requires an allocation. */
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

export type OdProtosScroogeData_Allocation_SourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosScroogeData_Allocation_Source_SourceType>;
};

export enum OdProtosScroogeData_Allocation_Source_SourceType {
  /** @deprecated No longer supported */
  OPENDOOR_BACKED_OFFER = 'OPENDOOR_BACKED_OFFER',
  SELL_DIRECT = 'SELL_DIRECT',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

/** Indicates the state of the allocation */
export enum OdProtosScroogeData_Allocation_State {
  ALLOCATED_ACQUIRED = 'ALLOCATED_ACQUIRED',
  ALLOCATED_ADVANCED = 'ALLOCATED_ADVANCED',
  ALLOCATED_IN_CONTRACT = 'ALLOCATED_IN_CONTRACT',
  ALLOCATED_SOLD = 'ALLOCATED_SOLD',
  DEALLOCATED_RELEASED = 'DEALLOCATED_RELEASED',
  DEALLOCATED_WITHDRAWN = 'DEALLOCATED_WITHDRAWN',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Represents the flip data needed to make an automatic allocation of an owner entity to a home
 * Next ID: 20
 */
export type OdProtosScroogeData_AutomaticAllocationFlipDataInput = {
  /** The lot size of the home in acreage */
  acreage?: InputMaybe<Scalars['Float']['input']>;
  /** The identifier of the user that requested the allocation */
  allocatingUserDirectoryToken?: InputMaybe<Scalars['String']['input']>;
  /** The proxy for BPO value of the home */
  bpoValueProxyCents?: InputMaybe<Scalars['Float']['input']>;
  /** The Casa-resolved uuid of the home */
  casaAddressUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * The flip token for the home to be allocated
   * Deprecated: use source.
   */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /** Flag that indicates whether the home has a solar lien */
  hasSolarLien?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag that indicates whether the home has unpermitted additions */
  hasUnpermittedAdditions?: InputMaybe<Scalars['Boolean']['input']>;
  /** The headline price of the home */
  headlinePriceCents?: InputMaybe<Scalars['Float']['input']>;
  /** Flag that indicates whether the home is in a flood zone */
  inFloodZone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag that indicates whether the home is distressed or real estate owned */
  isDistressedOrReo?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of bathrooms of the home */
  numBathroomsCents?: InputMaybe<Scalars['Float']['input']>;
  /** The number of bedrooms of the home */
  numBedrooms?: InputMaybe<Scalars['Float']['input']>;
  /** The postal code of the home */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Number of pre possession days, relevant for Opendoor Backed Offers only */
  prePossessionDays?: InputMaybe<Scalars['Float']['input']>;
  /** The property type of the home */
  propertyType?: InputMaybe<Scalars['String']['input']>;
  /** The region ID the home is located in */
  regionId?: InputMaybe<Scalars['Float']['input']>;
  /** The transaction that requires an allocation. */
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
  /** The US state of the home */
  usState?: InputMaybe<Scalars['String']['input']>;
  /** The year the home was built */
  yearBuilt?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_EntityMaxCumulativeBpoValueInput = {
  maxDollars?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_EntityMaxCumulativeHomesInput = {
  maxCount?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_EntityMaxOutstandingLoanInput = {
  maxDollars?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents an entity ruleset */
export type OdProtosScroogeData_EntityRulesetInput = {
  /** Timestamps for when the rule was created and last updated */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entityMaxCumulativeBpoValue?: InputMaybe<OdProtosScroogeData_EntityMaxCumulativeBpoValueInput>;
  entityMaxCumulativeHomes?: InputMaybe<OdProtosScroogeData_EntityMaxCumulativeHomesInput>;
  entityMaxOutstandingLoan?: InputMaybe<OdProtosScroogeData_EntityMaxOutstandingLoanInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosScroogeData_FacilityDeclineHomeInRegionsInput = {
  regionIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosScroogeData_FacilityMaxDollarsInAnyRegionInput = {
  maxDollars?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxDollarsInNewRegionsInput = {
  maxDollars?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxDollarsInRegionsInput = {
  regionToMaxDollarsMap?: InputMaybe<Array<OdProtosScroogeData_FacilityMaxDollarsInRegions_RegionToMaxDollarsMapEntryInput>>;
};

/** `OdProtosScroogeData_FacilityMaxDollarsInRegions_RegionToMaxDollarsMapEntryInput` represents the `region_to_max_dollars_map` map in `od_protos.scrooge.data.FacilityMaxDollarsInRegions`. */
export type OdProtosScroogeData_FacilityMaxDollarsInRegions_RegionToMaxDollarsMapEntryInput = {
  key?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxDollarsInStatesInput = {
  stateToMaxDollarsMap?: InputMaybe<Array<OdProtosScroogeData_FacilityMaxDollarsInStates_StateToMaxDollarsMapEntryInput>>;
};

/** `OdProtosScroogeData_FacilityMaxDollarsInStates_StateToMaxDollarsMapEntryInput` represents the `state_to_max_dollars_map` map in `od_protos.scrooge.data.FacilityMaxDollarsInStates`. */
export type OdProtosScroogeData_FacilityMaxDollarsInStates_StateToMaxDollarsMapEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxHomesWithSolarLienInput = {
  maxCount?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxOutstandingLoanInput = {
  maxDollars?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesBuiltBeforeYearInput = {
  maxPct?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesInAnyRegionInput = {
  maxPct?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesInRegionsWithinHeadlinePriceRangeInput = {
  headlinePriceCentsRange?: InputMaybe<OdProtosScroogeData_UInt32RangeInput>;
  maxPct?: InputMaybe<Scalars['Float']['input']>;
  regionIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesInStatesInput = {
  stateToMaxPctMap?: InputMaybe<Array<OdProtosScroogeData_FacilityMaxPctHomesInStates_StateToMaxPctMapEntryInput>>;
};

/** `OdProtosScroogeData_FacilityMaxPctHomesInStates_StateToMaxPctMapEntryInput` represents the `state_to_max_pct_map` map in `od_protos.scrooge.data.FacilityMaxPctHomesInStates`. */
export type OdProtosScroogeData_FacilityMaxPctHomesInStates_StateToMaxPctMapEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypesInput = {
  propertyTypeToMaxPctMap?: InputMaybe<Array<OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypes_PropertyTypeToMaxPctMapEntryInput>>;
};

/** `OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypes_PropertyTypeToMaxPctMapEntryInput` represents the `property_type_to_max_pct_map` map in `od_protos.scrooge.data.FacilityMaxPctHomesOfPropertyTypes`. */
export type OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypes_PropertyTypeToMaxPctMapEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesWithGtXHeadlinePriceInput = {
  headlinePriceCents?: InputMaybe<Scalars['Float']['input']>;
  maxPct?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesWithLtXBathInput = {
  maxPct?: InputMaybe<Scalars['Float']['input']>;
  numBathroomsCents?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesWithLtXBedInput = {
  maxPct?: InputMaybe<Scalars['Float']['input']>;
  numBedrooms?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityMaxPrePossessionDaysInput = {
  maxPrePossessionDays?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_FacilityOboDisallowedInput = {
  yes?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents a facility ruleset
 * Next ID: 27
 */
export type OdProtosScroogeData_FacilityRulesetInput = {
  /** Timestamps for when the rule was created and last updated */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  facilityDeclineHomeInRegions?: InputMaybe<OdProtosScroogeData_FacilityDeclineHomeInRegionsInput>;
  facilityMaxDollarsInAnyRegion?: InputMaybe<OdProtosScroogeData_FacilityMaxDollarsInAnyRegionInput>;
  facilityMaxDollarsInNewRegions?: InputMaybe<OdProtosScroogeData_FacilityMaxDollarsInNewRegionsInput>;
  facilityMaxDollarsInRegions?: InputMaybe<OdProtosScroogeData_FacilityMaxDollarsInRegionsInput>;
  facilityMaxDollarsInStates?: InputMaybe<OdProtosScroogeData_FacilityMaxDollarsInStatesInput>;
  facilityMaxHomesWithSolarLien?: InputMaybe<OdProtosScroogeData_FacilityMaxHomesWithSolarLienInput>;
  facilityMaxOutstandingLoan?: InputMaybe<OdProtosScroogeData_FacilityMaxOutstandingLoanInput>;
  facilityMaxPctHomesBuiltBeforeYear?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesBuiltBeforeYearInput>;
  facilityMaxPctHomesInAnyRegion?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesInAnyRegionInput>;
  facilityMaxPctHomesInRegionsWithinHeadlinePriceRange?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesInRegionsWithinHeadlinePriceRangeInput>;
  facilityMaxPctHomesInStates?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesInStatesInput>;
  facilityMaxPctHomesOfPropertyTypes?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypesInput>;
  facilityMaxPctHomesWithGtXHeadlinePrice?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesWithGtXHeadlinePriceInput>;
  facilityMaxPctHomesWithLtXBath?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesWithLtXBathInput>;
  facilityMaxPctHomesWithLtXBed?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesWithLtXBedInput>;
  facilityMaxPrePossessionDays?: InputMaybe<OdProtosScroogeData_FacilityMaxPrePossessionDaysInput>;
  facilityOboDisallowed?: InputMaybe<OdProtosScroogeData_FacilityOboDisallowedInput>;
  homeHasNoUnpermittedAdditions?: InputMaybe<OdProtosScroogeData_HomeHasNoUnpermittedAdditionsInput>;
  homeMaxAcreage?: InputMaybe<OdProtosScroogeData_HomeMaxAcreageInput>;
  /** New rules should be added below in order for backwards compatibility */
  homeMaxHeadlinePrice?: InputMaybe<OdProtosScroogeData_HomeMaxHeadlinePriceInput>;
  homeMinHeadlinePrice?: InputMaybe<OdProtosScroogeData_HomeMinHeadlinePriceInput>;
  homeNotDistressedOrReo?: InputMaybe<OdProtosScroogeData_HomeNotDistressedOrReoInput>;
  homeNotInFloodZone?: InputMaybe<OdProtosScroogeData_HomeNotInFloodZoneInput>;
  homeNotInPostalCodes?: InputMaybe<OdProtosScroogeData_HomeNotInPostalCodesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosScroogeData_HomeHasNoUnpermittedAdditionsInput = {
  yes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosScroogeData_HomeMaxAcreageInput = {
  maxAcreage?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_HomeMaxHeadlinePriceInput = {
  maxDollars?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_HomeMinHeadlinePriceInput = {
  minDollars?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeData_HomeNotDistressedOrReoInput = {
  yes?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * IMPORTANT:
 * Source of truth for these rules: https://docs.google.com/document/d/1a2aZv2tbW_YXU7vd-wqyhOflHJnqlFTg_VVLTrjVVW8/edit
 * Please update that Google doc if you make changes in this file
 */
export type OdProtosScroogeData_HomeNotInFloodZoneInput = {
  yes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosScroogeData_HomeNotInPostalCodesInput = {
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosScroogeData_ManualAllocationInput = {
  allocatingUserDirectoryToken?: InputMaybe<Scalars['String']['input']>;
  entityUuid?: InputMaybe<Scalars['String']['input']>;
  facilityUuid?: InputMaybe<Scalars['String']['input']>;
  isMisallocation?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

/**
 * Set of all facility and entity rules.
 * Next ID: 27
 */
export enum OdProtosScroogeData_RuleType {
  ENTITY_MAX_CUMULATIVE_BPO_VALUE = 'ENTITY_MAX_CUMULATIVE_BPO_VALUE',
  ENTITY_MAX_CUMULATIVE_HOMES = 'ENTITY_MAX_CUMULATIVE_HOMES',
  /** Entity rules */
  ENTITY_MAX_OUTSTANDING_LOAN = 'ENTITY_MAX_OUTSTANDING_LOAN',
  FACILITY_DECLINE_HOME_IN_REGIONS = 'FACILITY_DECLINE_HOME_IN_REGIONS',
  /** Internal facility rules */
  FACILITY_MAX_CUMULATIVE_HOMES_INTERNAL = 'FACILITY_MAX_CUMULATIVE_HOMES_INTERNAL',
  FACILITY_MAX_DOLLARS_IN_ANY_REGION = 'FACILITY_MAX_DOLLARS_IN_ANY_REGION',
  FACILITY_MAX_DOLLARS_IN_NEW_REGIONS = 'FACILITY_MAX_DOLLARS_IN_NEW_REGIONS',
  FACILITY_MAX_DOLLARS_IN_REGIONS = 'FACILITY_MAX_DOLLARS_IN_REGIONS',
  FACILITY_MAX_DOLLARS_IN_STATES = 'FACILITY_MAX_DOLLARS_IN_STATES',
  FACILITY_MAX_HOMES_WITH_SOLAR_LIEN = 'FACILITY_MAX_HOMES_WITH_SOLAR_LIEN',
  FACILITY_MAX_OUTSTANDING_LOAN = 'FACILITY_MAX_OUTSTANDING_LOAN',
  FACILITY_MAX_PCT_HOMES_BUILT_BEFORE_YEAR = 'FACILITY_MAX_PCT_HOMES_BUILT_BEFORE_YEAR',
  FACILITY_MAX_PCT_HOMES_IN_ANY_REGION = 'FACILITY_MAX_PCT_HOMES_IN_ANY_REGION',
  FACILITY_MAX_PCT_HOMES_IN_REGIONS_WITHIN_HEADLINE_PRICE_RANGE = 'FACILITY_MAX_PCT_HOMES_IN_REGIONS_WITHIN_HEADLINE_PRICE_RANGE',
  FACILITY_MAX_PCT_HOMES_IN_STATES = 'FACILITY_MAX_PCT_HOMES_IN_STATES',
  FACILITY_MAX_PCT_HOMES_OF_PROPERTY_TYPES = 'FACILITY_MAX_PCT_HOMES_OF_PROPERTY_TYPES',
  FACILITY_MAX_PCT_HOMES_WITH_GT_X_HEADLINE_PRICE = 'FACILITY_MAX_PCT_HOMES_WITH_GT_X_HEADLINE_PRICE',
  FACILITY_MAX_PCT_HOMES_WITH_LT_X_BATH = 'FACILITY_MAX_PCT_HOMES_WITH_LT_X_BATH',
  FACILITY_MAX_PCT_HOMES_WITH_LT_X_BED = 'FACILITY_MAX_PCT_HOMES_WITH_LT_X_BED',
  /** @deprecated No longer supported */
  FACILITY_OBO_DISALLOWED = 'FACILITY_OBO_DISALLOWED',
  HOME_HAS_NO_UNPERMITTED_ADDITIONS = 'HOME_HAS_NO_UNPERMITTED_ADDITIONS',
  HOME_MAX_ACREAGE = 'HOME_MAX_ACREAGE',
  HOME_MAX_HEADLINE_PRICE = 'HOME_MAX_HEADLINE_PRICE',
  HOME_MIN_HEADLINE_PRICE = 'HOME_MIN_HEADLINE_PRICE',
  /** Facility rules */
  HOME_NOT_IN_FLOOD_ZONE = 'HOME_NOT_IN_FLOOD_ZONE',
  HOME_NOT_IN_POSTAL_CODES = 'HOME_NOT_IN_POSTAL_CODES',
  RULE_TYPE_UNKNOWN = 'RULE_TYPE_UNKNOWN'
}

export type OdProtosScroogeData_UInt32RangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeServices_AllocationTestRequestInput = {
  entityUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Optional values to only test the provided faciilities/entities. If not provided
   * all active facilities/entities will be tested.
   */
  facilityUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  flipData?: InputMaybe<Array<OdProtosScroogeData_AutomaticAllocationFlipDataInput>>;
};

export type OdProtosScroogeServices_AutomaticAllocationRequestInput = {
  flipData?: InputMaybe<OdProtosScroogeData_AutomaticAllocationFlipDataInput>;
  /**
   * The allocation engine is bypassed when an override entity and facility uuid
   * are both specified.
   */
  overrideEntityUuid?: InputMaybe<Scalars['String']['input']>;
  overrideFacilityUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_BatchCreateAllocationLoanDataRequestInput = {
  allocations?: InputMaybe<Array<OdProtosScroogeServices_CreateAllocationLoanDataRequestInput>>;
};

/** Next ID: 3 */
export type OdProtosScroogeServices_CreateAllocationLoanDataRequestInput = {
  allocationLoanData?: InputMaybe<OdProtosScroogeData_AllocationLoanDataInput>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

export type OdProtosScroogeServices_CreateBrokerageRegionRequestInput = {
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  regionId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeServices_CreateEntityRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facilityUuid?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_CreateFacilityRequestInput = {
  isInTitlingTrust?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  loanToCostPct?: InputMaybe<Scalars['Float']['input']>;
  loanToValuePct?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_DeleteBrokerageRegionRequestInput = {
  regionId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosScroogeServices_FacilityAllocationPctRowInput = {
  allocationPct?: InputMaybe<Scalars['Float']['input']>;
  facilityUuid?: InputMaybe<Scalars['String']['input']>;
};

/** GetAllActiveFacilitiesRequest does not take arguments */
export type OdProtosScroogeServices_GetAllActiveFacilitiesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** GetAllFacilitiesEntitiesRequest does not take arguments */
export type OdProtosScroogeServices_GetAllFacilitiesEntitiesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosScroogeServices_GetAllocationLoanDataRequestInput = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_GetBrokerageRegionsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 3 */
export type OdProtosScroogeServices_GetCurrentAllocationRequestInput = {
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

export type OdProtosScroogeServices_GetEntitiesForFacilityRequestInput = {
  facilityUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_GetEntityByIdRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_GetEntityRulesetRequestInput = {
  entityUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_GetFacilityByIdRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_GetFacilityRulesetRequestInput = {
  facilityUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 8 */
export type OdProtosScroogeServices_ManualAllocationRequestInput = {
  allocatingUserDirectoryToken?: InputMaybe<Scalars['String']['input']>;
  entityUuid?: InputMaybe<Scalars['String']['input']>;
  facilityUuid?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  isMisallocation?: InputMaybe<Scalars['Boolean']['input']>;
  manualAllocations?: InputMaybe<Array<OdProtosScroogeData_ManualAllocationInput>>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

/** Next ID: 4 */
export type OdProtosScroogeServices_UpdateAllocationStateRequestInput = {
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
  state?: InputMaybe<OdProtosScroogeData_Allocation_State>;
};

export type OdProtosScroogeServices_UpdateEntityRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facilityUuid?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_UpdateEntityRulesetRequestInput = {
  entityRules?: InputMaybe<OdProtosScroogeData_EntityRulesetInput>;
  entityUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_UpdateFacilityAllocationPctsRequestInput = {
  facilityAllocationPcts?: InputMaybe<Array<OdProtosScroogeServices_FacilityAllocationPctRowInput>>;
};

export type OdProtosScroogeServices_UpdateFacilityRequestInput = {
  isInTitlingTrust?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  loanToCostPct?: InputMaybe<Scalars['Float']['input']>;
  loanToValuePct?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosScroogeServices_UpdateFacilityRulesetRequestInput = {
  facilityRules?: InputMaybe<OdProtosScroogeData_FacilityRulesetInput>;
  facilityUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosScroogeServices_UpdateFlipProjectionDatesRequestInput = {
  acquisitionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  resaleDate?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

/**
 * Denial reason if the customer was denied for a product.
 * Next ID: 76
 */
export enum OdProtosSellCommon_DenialReason {
  /** already an active offer for this address */
  ACTIVE_OFFER = 'ACTIVE_OFFER',
  /** home is not in a region serviced by Opendoor */
  ADDRESS = 'ADDRESS',
  /** this address has been explicitly denied */
  ADDRESS_OVERRIDE = 'ADDRESS_OVERRIDE',
  /** customer is an agent representative of the homeowner */
  AGENT_RELATION = 'AGENT_RELATION',
  /** home is in an age restricted community */
  AGE_RESTRICTED_COMMUNITY = 'AGE_RESTRICTED_COMMUNITY',
  /** seasonal age restriction for certain market */
  AGE_RESTRICTED_SEASONAL = 'AGE_RESTRICTED_SEASONAL',
  /** home has asbestos siding */
  ASBESTOS_SIDING = 'ASBESTOS_SIDING',
  /** home was built before 1960 */
  BEFORE_1960 = 'BEFORE_1960',
  /** San Francisco-specific program for low-middle income buyers */
  BELOW_MARKET_RATE_OWNERSHIP = 'BELOW_MARKET_RATE_OWNERSHIP',
  /** buyers are currently unavailable to make an offer on the home */
  BUYER_UNAVAILABLE = 'BUYER_UNAVAILABLE',
  /** Boston and NY/NJ only, for homes with a cesspool */
  CESSPOOL = 'CESSPOOL',
  /** pause all acq offers for COVID-19 */
  COVID_19 = 'COVID_19',
  /** they were also denied for opendoor_direct, so they're not eligible for this other product */
  DENIED_FOR_OPENDOOR_DIRECT = 'DENIED_FOR_OPENDOOR_DIRECT',
  /** they were also denied for sell_with_upside, so they're not eligible for this other product */
  DENIED_FOR_SELL_WITH_UPSIDE = 'DENIED_FOR_SELL_WITH_UPSIDE',
  /** dependent ruleset evaluation is incompatible with this product */
  DEPENDENT_RULESET = 'DEPENDENT_RULESET',
  /** duplicate lead on address */
  DUPLICATE_LEAD = 'DUPLICATE_LEAD',
  /** home type is not within the set of types purchased by Opendoor */
  DWELLING_TYPE = 'DWELLING_TYPE',
  /** expected levered gross margin (LGM) does not meet experience criteria */
  EXPECTED_LGM = 'EXPECTED_LGM',
  /** fees on offer are too high */
  FEES_TOO_HIGH = 'FEES_TOO_HIGH',
  /** home has previous or current fire damage */
  FIRE_DAMAGE = 'FIRE_DAMAGE',
  /** home has a history of flooding */
  FLOOD_HISTORY = 'FLOOD_HISTORY',
  /** home is in a flood zone. */
  FLOOD_ZONE = 'FLOOD_ZONE',
  /** home has known foundation issues */
  FOUNDATION = 'FOUNDATION',
  /** home is in a gated community */
  GATED_COMMUNITY = 'GATED_COMMUNITY',
  /** home is in a guard-gated community */
  GUARD_GATED_COMMUNITY = 'GUARD_GATED_COMMUNITY',
  /** home is in an ineligible HOA - requires rental history, SSN, etc. */
  INELIGIBLE_HOA = 'INELIGIBLE_HOA',
  /** home is in contract or in contingencies released with Opendoor */
  IN_CONTRACT_WITH_OPENDOOR = 'IN_CONTRACT_WITH_OPENDOOR',
  /** home does not have adequate comps */
  LACK_OF_ADEQUATE_COMPS = 'LACK_OF_ADEQUATE_COMPS',
  /** home has leased solar panels */
  LEASED_SOLAR_PANELS = 'LEASED_SOLAR_PANELS',
  /** Opendoor has listed the home for sale */
  LISTED_BY_OPENDOOR = 'LISTED_BY_OPENDOOR',
  /** livestock on property */
  LIVESTOCK = 'LIVESTOCK',
  /** home's lot sq ft is too large */
  LOT_SQ_FT = 'LOT_SQ_FT',
  /** For use with partner API, controls display of OD offers in partner's website UI */
  MLS_LISTING_STATUS = 'MLS_LISTING_STATUS',
  /** mobile or manufactured home */
  MOBILE_MANUFACTURED_HOME = 'MOBILE_MANUFACTURED_HOME',
  /** home dwelling type is not in buybox */
  NON_BUYBOX_DWELLING_TYPE = 'NON_BUYBOX_DWELLING_TYPE',
  /** seller is not serious yet */
  NON_SERIOUS_SELLER = 'NON_SERIOUS_SELLER',
  NOT_IN_AUTODENIAL_LISTING_EXP = 'NOT_IN_AUTODENIAL_LISTING_EXP',
  /**
   * seller is not in the lwod experiment
   * @deprecated No longer supported
   */
  NOT_IN_LWOD_PILOT = 'NOT_IN_LWOD_PILOT',
  /**
   * Not in the Sell w/ Upside experiment
   * @deprecated No longer supported
   */
  NOT_IN_SELL_WITH_UPSIDE_PILOT = 'NOT_IN_SELL_WITH_UPSIDE_PILOT',
  NOT_IN_SIDE_BY_SIDE_EXP = 'NOT_IN_SIDE_BY_SIDE_EXP',
  /** home is not denied */
  NO_DENIAL = 'NO_DENIAL',
  /**
   * Deprecated, used only for the ShouldDenyBasedOnFlipStatus web GRPC endpoint
   * @deprecated No longer supported
   */
  OFFER_IN_PROGRESS = 'OFFER_IN_PROGRESS',
  /** home has been deemed an outlier at pre-offer time */
  OFFER_OUTLIER = 'OFFER_OUTLIER',
  /** other unspecified reason */
  OTHER_DENIAL = 'OTHER_DENIAL',
  /**
   * denial code used externally to present that we are missing a
   * particular piece of information necessary to value a home.
   * For backwards compatibility this denial_reason does not
   * have a more reasonable name like OTHER_DENIAL_VALUATION
   */
  OTHER_DENIAL_DETAIL = 'OTHER_DENIAL_DETAIL',
  /**
   * denial code used externally to present that we have some uncategorized
   * reason for denying a given address for a given product.
   */
  OTHER_DENIAL_GENERAL = 'OTHER_DENIAL_GENERAL',
  /** home has high risk factors */
  OTHER_HIGH_RISK = 'OTHER_HIGH_RISK',
  /** Opendoor owns the home */
  OWNED_BY_OPENDOOR = 'OWNED_BY_OPENDOOR',
  /** seller is working with a partner, could be homebuilder or other */
  PARTNERSHIP = 'PARTNERSHIP',
  /** home has polybutylene piping */
  POLYBUTYLENE_PIPING = 'POLYBUTYLENE_PIPING',
  /** already an active offer request for this address, still preparing offer */
  PREPARING_OFFER = 'PREPARING_OFFER',
  /** private pool */
  PRIVATE_POOL = 'PRIVATE_POOL',
  /** the product is not active in the current market */
  PRODUCT_INACTIVE = 'PRODUCT_INACTIVE',
  /**
   * they're qualified for list with opendoor, which is incompatible with this product
   * @deprecated No longer supported
   */
  QUALIFIED_FOR_LWOD = 'QUALIFIED_FOR_LWOD',
  /** they're qualified for opendoor direct, which is incompatible with this product */
  QUALIFIED_FOR_OPENDOOR_DIRECT = 'QUALIFIED_FOR_OPENDOOR_DIRECT',
  /** lead will be passed to external brokerage */
  RESERVED_FOR_EXTERNAL_BROKER = 'RESERVED_FOR_EXTERNAL_BROKER',
  /** the home is in a region that Pricing has deemed too risky */
  RISK_PROHIBITED_REGION = 'RISK_PROHIBITED_REGION',
  /** sale timeline is not compatible with the experience */
  SALE_TIMELINE = 'SALE_TIMELINE',
  /** rejected seller triage documentation */
  SELLER_TRIAGE = 'SELLER_TRIAGE',
  /** home has a septic system */
  SEPTIC = 'SEPTIC',
  /** home has a shared entrance with neighbors */
  SHARED_ENTRANCE = 'SHARED_ENTRANCE',
  /** home has a shared lot with neighbors */
  SHARED_LOT = 'SHARED_LOT',
  /** home is tenant occupied (has lease) */
  TENANT_OCCUPIED = 'TENANT_OCCUPIED',
  /** seller is a trade-in customer */
  TRADE_IN = 'TRADE_IN',
  /** opendoor cannot value the home. */
  UNABLE_TO_VALUE = 'UNABLE_TO_VALUE',
  /** NY/NJ specific - homes commonly have underground oil tanks that can be costly */
  UNDERGROUND_OIL_TANK = 'UNDERGROUND_OIL_TANK',
  /** tenants in common, co-op programs */
  UNIQUE_OWNERSHIP_STRUCTURE = 'UNIQUE_OWNERSHIP_STRUCTURE',
  /** home has unpermitted additions */
  UNPERMITTED_ADDITION = 'UNPERMITTED_ADDITION',
  /** home's value is outside of buybox range */
  VALUATION_TOO_HIGH = 'VALUATION_TOO_HIGH',
  /** home's value is outside of buybox range */
  VALUATION_TOO_LOW = 'VALUATION_TOO_LOW',
  /** valuation is significantly lower than list price */
  VALUATION_TOO_LOW_LISTED = 'VALUATION_TOO_LOW_LISTED',
  /** home has a private well as the primary water source */
  WELL_WATER = 'WELL_WATER',
  /** customer is working with a homebuilder partner */
  WORKING_WITH_HOMEBUILDER = 'WORKING_WITH_HOMEBUILDER',
  /** home was built too long ago */
  YEAR_BUILT = 'YEAR_BUILT'
}

/**
 * The marketing channel the seller came in from.
 * Next ID: 4
 */
export enum OdProtosSellCommon_MarketingChannel {
  /** From our mobile application. */
  APP = 'APP',
  /** From the main website opendoor.com. */
  DEFAULT = 'DEFAULT',
  /** From our home value report emails. */
  HOME_VALUE = 'HOME_VALUE',
  UNKNOWN_CHANNEL = 'UNKNOWN_CHANNEL'
}

/**
 * Partner home builders that refers sellers to us.
 * Next ID: 22
 */
export enum OdProtosSellCommon_Partnership {
  CALATLANTIC = 'CALATLANTIC',
  CENTURY_COMMUNITIES = 'CENTURY_COMMUNITIES',
  CHAFIN = 'CHAFIN',
  DAVID_WEEKLEY = 'DAVID_WEEKLEY',
  DR_HORTON = 'DR_HORTON',
  FRONTDOOR = 'FRONTDOOR',
  GOODALL = 'GOODALL',
  KB_HOME = 'KB_HOME',
  LENNAR = 'LENNAR',
  MATTAMY = 'MATTAMY',
  MERITAGE = 'MERITAGE',
  MI_HOMES = 'MI_HOMES',
  NONE = 'NONE',
  OTHER_BUILDER = 'OTHER_BUILDER',
  PARDEE = 'PARDEE',
  PULTE = 'PULTE',
  RYAN = 'RYAN',
  SHEA_HOMES_TRILOGY = 'SHEA_HOMES_TRILOGY',
  SMITHDOUGLAS = 'SMITHDOUGLAS',
  TAYLOR_MORRISON = 'TAYLOR_MORRISON',
  TOLL_BROTHERS = 'TOLL_BROTHERS',
  UNKNOWN = 'UNKNOWN',
  WOODSIDE = 'WOODSIDE'
}

/**
 * A Product that we can offer to the seller.
 * Next ID: 13
 */
export enum OdProtosSellCommon_Product {
  /**
   * Refer to an agent to help them sell their home
   * @deprecated No longer supported
   */
  AGENT_REFERRAL = 'AGENT_REFERRAL',
  /**
   * Buy a home from Opendoor
   * @deprecated No longer supported
   */
  BUY_WITH_OPENDOOR = 'BUY_WITH_OPENDOOR',
  /** Buy a home through an external listing agent */
  EXTERNAL_LISTING_AGENT = 'EXTERNAL_LISTING_AGENT',
  /** Home insights dashboard */
  HOME_INSIGHTS = 'HOME_INSIGHTS',
  /** List your home and get an Opendoor cash offer as a fallback */
  LIST_WITH_CERTAINTY = 'LIST_WITH_CERTAINTY',
  /**
   * List your home with Opendoor
   * @deprecated No longer supported
   */
  LIST_WITH_OPENDOOR = 'LIST_WITH_OPENDOOR',
  /** No product selected - used to reset/clear product selection */
  NO_PRODUCT = 'NO_PRODUCT',
  /**
   * Make a cash offer on any listed home, using Opendoor cash
   * @deprecated No longer supported
   */
  OPENDOOR_BACKED_OFFERS = 'OPENDOOR_BACKED_OFFERS',
  /** Sell directly to Opendoor */
  OPENDOOR_DIRECT = 'OPENDOOR_DIRECT',
  /** Sell to a REIT (Real Estate Investment Trust) */
  REIT = 'REIT',
  /**
   * Sell your home on Exclusives
   * @deprecated No longer supported
   */
  SELL_WITH_EXCLUSIVES = 'SELL_WITH_EXCLUSIVES',
  /** Sell directly with upside */
  SELL_WITH_UPSIDE = 'SELL_WITH_UPSIDE',
  /** Product with an unknown name. This should rarely happen */
  UNKNOWN_PRODUCT = 'UNKNOWN_PRODUCT'
}

/**
 * Segments that classify types of sellers
 * Next ID: 5
 */
export enum OdProtosSellCommon_Segment {
  BUYER = 'BUYER',
  HOMEBUILDER = 'HOMEBUILDER',
  HOMEOWNER = 'HOMEOWNER',
  STAYING_IN_MARKET = 'STAYING_IN_MARKET',
  WORKING_WITH_AGENT = 'WORKING_WITH_AGENT'
}

/**
 * SelfServiceVirtualAssessmentExperimentGroup determines what experiment group the seller is in with regards to the Self Service
 * Virtual Assessment Experiment, where the seller has the option to upload a set of recordings of their home
 * in order to finalize their headline price. Depending on what group the seller falls into will determine
 * the user experience in terms of how they're presented with this option.
 * Next ID: 6
 */
export enum OdProtosSellCommon_SelfServiceVirtualAssessmentExperimentGroup {
  /** Agent is presented the self-serve virtual assessment option with a heavier bias towards self-service. */
  AGENT_ASSERTIVE = 'AGENT_ASSERTIVE',
  /** Agent is in the control group of the experiment */
  AGENT_CONTROL = 'AGENT_CONTROL',
  /**
   * Seller is presented with a heavier bias towards the self service option, and must explicitly opt out
   * of that experience.
   */
  ASSERTIVE = 'ASSERTIVE',
  /**
   * Seller is presented with both uploading the self service and scheduling a virtual assessment call with no
   * bias towards either option.
   */
  BALANCED = 'BALANCED',
  /** Seller is in the control group of the experiment */
  CONTROL = 'CONTROL',
  /** Seller is not in the experiment. */
  NOT_IN_EXPERIMENT = 'NOT_IN_EXPERIMENT'
}

/**
 * The timeline the seller has when looking to sell their home.
 * Next ID: 6
 */
export enum OdProtosSellCommon_Timeline {
  ASAP = 'ASAP',
  JUST_BROWSING = 'JUST_BROWSING',
  UNKNOWN_TIMELINE = 'UNKNOWN_TIMELINE',
  /** 2 - 4 weeks */
  WEEKS_2_4 = 'WEEKS_2_4',
  /** 4 - 6 weeks */
  WEEKS_4_6 = 'WEEKS_4_6',
  /** 6+ weeks */
  WEEKS_6_PLUS = 'WEEKS_6_PLUS'
}

/**
 * Config keyed by Market (as a Fence Region).
 * PBDB Key: Fence Region ID
 * Next ID: 16
 */
export type OdProtosSellConfig_MarketConfigInput = {
  /** calendly link for agent team */
  agentCalendlyCalendar?: InputMaybe<Scalars['String']['input']>;
  /** Brokerages ID of the brokerage used in this market. */
  brokerageId?: InputMaybe<Scalars['String']['input']>;
  /** default calendly link */
  calendlyCalendar?: InputMaybe<Scalars['String']['input']>;
  /** calendly link for seller to schedule immediate offer review, usually when offer is ready */
  calendlyCalendarImmediate?: InputMaybe<Scalars['String']['input']>;
  /** calendly link for cep pilot team */
  cepPilotCalendlyCalendar?: InputMaybe<Scalars['String']['input']>;
  /** calendly link for cep pilot team for immediate offer review, usually when offer is ready */
  cepPilotCalendlyCalendarImmediate?: InputMaybe<Scalars['String']['input']>;
  /** CEP region the market belongs to (CEP regionalization) */
  cepRegion?: InputMaybe<Scalars['String']['input']>;
  /** calendly link for home reserves pilot team */
  homeReservesCepCalendlyCalendar?: InputMaybe<Scalars['String']['input']>;
  /** calendly link for lwod cep pilot team */
  lwodCepCalendlyCalendar?: InputMaybe<Scalars['String']['input']>;
  /** Directory ID of the organization that manages this market. */
  orgId?: InputMaybe<Scalars['String']['input']>;
  /** calendly link for partnership licensed team */
  partnershipLicensedCalendlyCalendar?: InputMaybe<Scalars['String']['input']>;
  /** Fence ID of the region covered by this market. This is also the identifier (e.g. "phoenix"). */
  regionId?: InputMaybe<Scalars['String']['input']>;
  /** calendly link for trade-in specific lead */
  tradeInCalendlyCalendar?: InputMaybe<Scalars['String']['input']>;
  /** calendly link for trade-in specific lead for immediate offer review, usually when offer is ready */
  tradeInCalendlyCalendarImmediate?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosSellOpsTasks_OfferReviewData_PreviousCallOutcome {
  /** follow up will be a virtual assessment call */
  INCOMPLETE_VIRTUAL_ASSESSMENT = 'INCOMPLETE_VIRTUAL_ASSESSMENT',
  /** follow up will be with CEP */
  NO_SHOW = 'NO_SHOW',
  /** no follow up */
  ORVA_COMPLETE = 'ORVA_COMPLETE',
  /** follow up will be with CEP */
  SELLER_NOT_READY = 'SELLER_NOT_READY',
  /**
   * deprecating in favor of SELLER_NOT_READY. Do not use for new integrations.
   * @deprecated No longer supported
   */
  SELLER_NOT_READY_FOR_LISTING_APPOINTMENT = 'SELLER_NOT_READY_FOR_LISTING_APPOINTMENT',
  /** follow up will be with listing agent */
  SELLER_NOT_READY_LISTING_AGENT_FOLLOW_UP = 'SELLER_NOT_READY_LISTING_AGENT_FOLLOW_UP',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Answers collected from the seller as part of the seller flow.
 * Next ID: 163
 */
export type OdProtosSellReceptionData_AnswersInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Float']['input']>;
  aboveGradeSqFtOverrideReason?: InputMaybe<Scalars['String']['input']>;
  /** Seller related answers */
  activelyLooking?: InputMaybe<Scalars['String']['input']>;
  /** Home related answers */
  addition?: InputMaybe<Scalars['String']['input']>;
  agent?: InputMaybe<Scalars['String']['input']>;
  agentLedOfferEmail?: InputMaybe<Scalars['String']['input']>;
  agentLedOfferFullName?: InputMaybe<Scalars['String']['input']>;
  agentLedOfferPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  agentStatus?: InputMaybe<Scalars['String']['input']>;
  agentType?: InputMaybe<Scalars['String']['input']>;
  appSmsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  backYardCondition?: InputMaybe<Scalars['String']['input']>;
  backYardSlope?: InputMaybe<Scalars['String']['input']>;
  backYardSlopeRetainingWall?: InputMaybe<Scalars['Boolean']['input']>;
  backYardSlopeType?: InputMaybe<Scalars['String']['input']>;
  basement?: InputMaybe<Scalars['String']['input']>;
  basementFinishedSqFt?: InputMaybe<Scalars['Float']['input']>;
  basementSqFt?: InputMaybe<Scalars['Float']['input']>;
  basementSqFtOverrideReason?: InputMaybe<Scalars['String']['input']>;
  basementSqFtTriage?: InputMaybe<Scalars['String']['input']>;
  basementUnfinishedSqFt?: InputMaybe<Scalars['Float']['input']>;
  /** Deprecated. Use master_bathroom */
  bathroomCondition?: InputMaybe<Scalars['String']['input']>;
  bathroomFeatures?: InputMaybe<OdProtosSellReceptionData_Answers_BathroomFeaturesInput>;
  bathroomRemodel?: InputMaybe<Scalars['String']['input']>;
  bathroomSellerScore?: InputMaybe<Scalars['String']['input']>;
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  bathroomsFull?: InputMaybe<Scalars['Float']['input']>;
  bathroomsHalf?: InputMaybe<Scalars['Float']['input']>;
  bathroomsOverrideReason?: InputMaybe<Scalars['String']['input']>;
  bedrooms?: InputMaybe<Scalars['Float']['input']>;
  bedroomsOverrideReason?: InputMaybe<Scalars['String']['input']>;
  bedroomsTriage?: InputMaybe<Scalars['String']['input']>;
  brokerage?: InputMaybe<Scalars['String']['input']>;
  /** deprecated */
  buyerZones?: InputMaybe<Array<OdProtosSellReceptionData_Answers_BuyerZoneInput>>;
  buyingNextHome?: InputMaybe<Scalars['Boolean']['input']>;
  buyingNextHomeStatus?: InputMaybe<Scalars['String']['input']>;
  buyingPower?: InputMaybe<OdProtosSellReceptionData_Answers_BuyingPowerInput>;
  buyingStage?: InputMaybe<Scalars['String']['input']>;
  buyingTimeline?: InputMaybe<Scalars['String']['input']>;
  carportSpaces?: InputMaybe<Scalars['Float']['input']>;
  chatQuestions?: InputMaybe<Scalars['String']['input']>;
  chatbotPhotoRequest?: InputMaybe<OdProtosSellReceptionData_Answers_ChatbotPhotoRequestInput>;
  currentlyInSellingProcess?: InputMaybe<Scalars['String']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<OdProtosSellReceptionData_Answers_EligibilityCriteriaInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  entryTypes?: InputMaybe<OdProtosSellReceptionData_Answers_EntryTypesInput>;
  exclusivesCashOfferSentiment?: InputMaybe<Scalars['String']['input']>;
  exclusivesCustomerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  exclusivesHomesTouredAmount?: InputMaybe<Scalars['String']['input']>;
  exclusivesInitialSellerOptionsInterest?: InputMaybe<OdProtosSellReceptionData_Answers_ExclusivesInitialSellerOptionsInterestInput>;
  exclusivesPrequalificationStatus?: InputMaybe<Scalars['String']['input']>;
  exclusivesShareWithSeriousBuyers?: InputMaybe<Scalars['Boolean']['input']>;
  exclusivesTasksForPotentiallyHigherOffer?: InputMaybe<OdProtosSellReceptionData_Answers_ExclusivesTasksForPotentiallyHigherOfferInput>;
  exclusivesThreeMonthTimeline?: InputMaybe<Scalars['Boolean']['input']>;
  experimental?: InputMaybe<Array<OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswerInput>>;
  exploringFinancing?: InputMaybe<Scalars['String']['input']>;
  exteriorAttributes?: InputMaybe<OdProtosSellReceptionData_Answers_ExteriorAttributesInput>;
  exteriorFacade?: InputMaybe<Scalars['String']['input']>;
  exteriorSellerScore?: InputMaybe<Scalars['String']['input']>;
  exteriorStories?: InputMaybe<Scalars['Float']['input']>;
  /** Not used since April 2019 */
  financingReferral?: InputMaybe<Scalars['String']['input']>;
  financingReferralOpendoorMortgage?: InputMaybe<Scalars['String']['input']>;
  financingReferralTrustedLender?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  floodHistoryTriage?: InputMaybe<OdProtosSellReceptionData_Answers_FloodHistoryTriageInput>;
  floodZoneTriage?: InputMaybe<Scalars['String']['input']>;
  flooringAllFloorTypes?: InputMaybe<OdProtosSellReceptionData_Answers_FloorTypesInput>;
  flooringCarpetCondition?: InputMaybe<Scalars['String']['input']>;
  flooringCarpetRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  flooringFollowUpLiving?: InputMaybe<Scalars['String']['input']>;
  flooringFollowUpMasterBedroom?: InputMaybe<Scalars['String']['input']>;
  flooringHardwoodCondition?: InputMaybe<Scalars['String']['input']>;
  flooringHardwoodRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  flooringLaminateCondition?: InputMaybe<Scalars['String']['input']>;
  flooringLaminateRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  flooringMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
  flooringOtherRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  flooringPrimaryFloorCondition?: InputMaybe<Scalars['String']['input']>;
  flooringPrimaryFloorType?: InputMaybe<Scalars['String']['input']>;
  flooringSecondaryFloorCondition?: InputMaybe<Scalars['String']['input']>;
  flooringSecondaryFloorType?: InputMaybe<Scalars['String']['input']>;
  flooringTileCondition?: InputMaybe<Scalars['String']['input']>;
  flooringTileRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  foundationIssue?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  garageSpaces?: InputMaybe<Scalars['Float']['input']>;
  hasUpgrades?: InputMaybe<Scalars['Boolean']['input']>;
  hoa?: InputMaybe<Scalars['Boolean']['input']>;
  hoaFees?: InputMaybe<Scalars['Float']['input']>;
  hoaTypes?: InputMaybe<OdProtosSellReceptionData_Answers_HoaTypesInput>;
  homeBuilder?: InputMaybe<Scalars['String']['input']>;
  homeBuilderCommunity?: InputMaybe<Scalars['String']['input']>;
  homeBuilderEmail?: InputMaybe<Scalars['String']['input']>;
  homeBuilderOther?: InputMaybe<Scalars['String']['input']>;
  homeBuyingProcess?: InputMaybe<Scalars['String']['input']>;
  homeBuyingProcessOther?: InputMaybe<Scalars['String']['input']>;
  homeGuideRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  initialFinancingStatus?: InputMaybe<Scalars['String']['input']>;
  interiorAttributes?: InputMaybe<OdProtosSellReceptionData_Answers_InteriorAttributesInput>;
  interiorPaintCondition?: InputMaybe<Scalars['String']['input']>;
  interiorPaintNeutral?: InputMaybe<Scalars['String']['input']>;
  kitchenApplianceType?: InputMaybe<Scalars['String']['input']>;
  kitchenCondition?: InputMaybe<Scalars['String']['input']>;
  kitchenCounterType?: InputMaybe<Scalars['String']['input']>;
  kitchenFeatures?: InputMaybe<OdProtosSellReceptionData_Answers_KitchenFeaturesInput>;
  kitchenRemodel?: InputMaybe<Scalars['String']['input']>;
  /** Seller Score */
  kitchenSellerScore?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leasedSolarPanelsTriage?: InputMaybe<Scalars['String']['input']>;
  /** Customer-provided listing status when ODLS shows the home is listed */
  listed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Agent info related answers */
  listingAgentEmail?: InputMaybe<Scalars['String']['input']>;
  listingAgentFullName?: InputMaybe<Scalars['String']['input']>;
  livingRoomSellerScore?: InputMaybe<Scalars['String']['input']>;
  lotOwnership?: InputMaybe<Scalars['String']['input']>;
  masterBathroomCondition?: InputMaybe<Scalars['String']['input']>;
  masterBedroomFloor?: InputMaybe<Scalars['Float']['input']>;
  mlsAgentId?: InputMaybe<Scalars['String']['input']>;
  mortgageAbad?: InputMaybe<Scalars['String']['input']>;
  moveInReady?: InputMaybe<Scalars['String']['input']>;
  movingAway?: InputMaybe<Scalars['String']['input']>;
  optedIntoExclusiveOffers?: InputMaybe<Scalars['Boolean']['input']>;
  otherInformation?: InputMaybe<Scalars['String']['input']>;
  otherSellingWays?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photosUploaded?: InputMaybe<Array<OdProtosSellReceptionData_Answers_PhotoInput>>;
  poolType?: InputMaybe<Scalars['String']['input']>;
  priceEstimateCents?: InputMaybe<Scalars['Float']['input']>;
  priceEstimateRange?: InputMaybe<OdProtosSellReceptionData_Answers_PriceEstimateRangeInput>;
  priceEstimateTriage?: InputMaybe<Scalars['String']['input']>;
  propertyCondition?: InputMaybe<Scalars['String']['input']>;
  realtorEmailOverride?: InputMaybe<Scalars['Boolean']['input']>;
  realtorNameOverride?: InputMaybe<Scalars['Boolean']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  referralSourceOther?: InputMaybe<Scalars['String']['input']>;
  referralSourceRadio?: InputMaybe<Scalars['String']['input']>;
  relationToOwner?: InputMaybe<Scalars['String']['input']>;
  relationToOwnerOther?: InputMaybe<Scalars['String']['input']>;
  saleTimeline?: InputMaybe<Scalars['String']['input']>;
  scheduleOfferReview?: InputMaybe<Scalars['String']['input']>;
  selfServiceVirtualAssessmentChoice?: InputMaybe<Scalars['String']['input']>;
  sellingReason?: InputMaybe<OdProtosSellReceptionData_Answers_SellingReasonInput>;
  sellingReasonOther?: InputMaybe<Scalars['String']['input']>;
  sellingTimelineFlexibility?: InputMaybe<Scalars['String']['input']>;
  setupBuyerFeed?: InputMaybe<OdProtosSellReceptionData_Answers_SetupBuyerFeedInput>;
  sharedEntrance?: InputMaybe<Scalars['Boolean']['input']>;
  showingPreference?: InputMaybe<Scalars['String']['input']>;
  signedListingAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  solarPanelsOwnershipType?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Use above_grade_sq_ft */
  sqFt?: InputMaybe<Scalars['Float']['input']>;
  sqFtTriage?: InputMaybe<Scalars['String']['input']>;
  userVerifiedAddress?: InputMaybe<Scalars['Boolean']['input']>;
  verificationPrimaryOwner?: InputMaybe<Scalars['String']['input']>;
  willingnessForTours?: InputMaybe<Scalars['String']['input']>;
  workingWithHomeBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  yearBuilt?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 6 */
export type OdProtosSellReceptionData_Answers_BathroomFeaturesInput = {
  doubleSink?: InputMaybe<Scalars['Boolean']['input']>;
  graniteCountertops?: InputMaybe<Scalars['Boolean']['input']>;
  separateShowerTub?: InputMaybe<Scalars['Boolean']['input']>;
  tileSurround?: InputMaybe<Scalars['Boolean']['input']>;
  updatedTileFloors?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 11 */
export type OdProtosSellReceptionData_Answers_BuyerZoneInput = {
  breadcrumbPath?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayablePropertiesCount?: InputMaybe<Scalars['Float']['input']>;
  gdsId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNearby?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
  parents?: InputMaybe<Array<OdProtosSellReceptionData_Answers_BuyerZone_ZoneParentInput>>;
  value?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosSellReceptionData_Answers_BuyerZone_ZoneParentInput = {
  breadcrumbPath?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSellReceptionData_Answers_BuyingPowerInput = {
  /** annual income in cents. */
  annualHouseholdIncome?: InputMaybe<Scalars['Float']['input']>;
  /** credit score range. */
  creditScoreIndicated?: InputMaybe<OdProtosMortgageData_CreditRangeInput>;
  /** down payment in cents. */
  downPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  /** monthly debt/expenses in cents. */
  monthlyDebt?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellReceptionData_Answers_ChatbotPhotoRequestInput = {
  status?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 20 */
export type OdProtosSellReceptionData_Answers_EligibilityCriteriaInput = {
  ageRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  asbestosSiding?: InputMaybe<Scalars['Boolean']['input']>;
  belowMarketRateOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  cesspool?: InputMaybe<Scalars['Boolean']['input']>;
  fireDamage?: InputMaybe<Scalars['Boolean']['input']>;
  gatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  historyOfChemicalContamination?: InputMaybe<Scalars['Boolean']['input']>;
  knownFoundationIssues?: InputMaybe<Scalars['Boolean']['input']>;
  leasedSolarPanels?: InputMaybe<Scalars['Boolean']['input']>;
  livestock?: InputMaybe<Scalars['Boolean']['input']>;
  mobileManufacturedHome?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSolarPanels?: InputMaybe<Scalars['Boolean']['input']>;
  permittedAddition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not used since Oct 2018 */
  polybutylenePiping?: InputMaybe<Scalars['Boolean']['input']>;
  rentControlledTenantOccupied?: InputMaybe<Scalars['Boolean']['input']>;
  septic?: InputMaybe<Scalars['Boolean']['input']>;
  undergroundOilTank?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueOwnershipStructure?: InputMaybe<Scalars['Boolean']['input']>;
  unpermittedAddition?: InputMaybe<Scalars['Boolean']['input']>;
  wellWater?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_EntryTypesInput = {
  directEntry?: InputMaybe<Scalars['Boolean']['input']>;
  sharedEntranceCondo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_ExclusivesInitialSellerOptionsInterestInput = {
  exclusives?: InputMaybe<Scalars['Boolean']['input']>;
  sellDirect?: InputMaybe<Scalars['Boolean']['input']>;
  traditionalListing?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 5 */
export type OdProtosSellReceptionData_Answers_ExclusivesTasksForPotentiallyHigherOfferInput = {
  forSaleSign?: InputMaybe<Scalars['Boolean']['input']>;
  haveAnOpenHouse?: InputMaybe<Scalars['Boolean']['input']>;
  listHomeTraditionally?: InputMaybe<Scalars['Boolean']['input']>;
  makeRepairs?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswerInput = {
  questionKey?: InputMaybe<Scalars['String']['input']>;
  selectedValues?: InputMaybe<OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswer_SelectedValuesOneofInput>;
};

export type OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswer_SelectedValuesOneofInput = {
  doubleValue?: InputMaybe<Scalars['Float']['input']>;
  stringValues?: InputMaybe<OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswer_StringValuesInput>;
};

export type OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswer_StringValuesInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 11 */
export type OdProtosSellReceptionData_Answers_ExteriorAttributesInput = {
  deck?: InputMaybe<Scalars['Boolean']['input']>;
  dock?: InputMaybe<Scalars['Boolean']['input']>;
  hasNewRoof?: InputMaybe<Scalars['Boolean']['input']>;
  hasNewWindows?: InputMaybe<Scalars['Boolean']['input']>;
  hasNiceBackyard?: InputMaybe<Scalars['Boolean']['input']>;
  patio?: InputMaybe<Scalars['Boolean']['input']>;
  porch?: InputMaybe<Scalars['Boolean']['input']>;
  sprinkler?: InputMaybe<Scalars['Boolean']['input']>;
  upgradedPool?: InputMaybe<Scalars['Boolean']['input']>;
  vinylSiding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosSellReceptionData_Answers_FeedPropertyTypesInput = {
  apartment?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['Boolean']['input']>;
  multiFamily?: InputMaybe<Scalars['Boolean']['input']>;
  townhome?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 6 */
export type OdProtosSellReceptionData_Answers_FloodHistoryTriageInput = {
  harvey?: InputMaybe<Scalars['Boolean']['input']>;
  memorialDay?: InputMaybe<Scalars['Boolean']['input']>;
  notSure?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  taxDay?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 6 */
export type OdProtosSellReceptionData_Answers_FloorTypesInput = {
  carpet?: InputMaybe<Scalars['Boolean']['input']>;
  hardwood?: InputMaybe<Scalars['Boolean']['input']>;
  laminate?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  tile?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_HoaTypesInput = {
  ageRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  gatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  guardedGatedCommunity?: InputMaybe<Scalars['String']['input']>;
  sharedEntranceCondo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 9 */
export type OdProtosSellReceptionData_Answers_InteriorAttributesInput = {
  basementWindows?: InputMaybe<Scalars['Boolean']['input']>;
  finishedLoft?: InputMaybe<Scalars['Boolean']['input']>;
  hasFireplace?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenFloorPlan?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalkInCloset?: InputMaybe<Scalars['Boolean']['input']>;
  kitchenIsland?: InputMaybe<Scalars['Boolean']['input']>;
  laundry?: InputMaybe<Scalars['Boolean']['input']>;
  sunroom?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_KitchenFeaturesInput = {
  kitchenIsland?: InputMaybe<Scalars['Boolean']['input']>;
  newCabinets?: InputMaybe<Scalars['Boolean']['input']>;
  tileBacksplash?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 5 */
export type OdProtosSellReceptionData_Answers_PhotoInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellReceptionData_Answers_PriceEstimateRangeInput = {
  maxPrice?: InputMaybe<Scalars['String']['input']>;
  minPrice?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 7 */
export type OdProtosSellReceptionData_Answers_RoomsInput = {
  dining?: InputMaybe<Scalars['Boolean']['input']>;
  kitchen?: InputMaybe<Scalars['Boolean']['input']>;
  living?: InputMaybe<Scalars['Boolean']['input']>;
  masterBathroom?: InputMaybe<Scalars['Boolean']['input']>;
  masterBedroom?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 8 */
export type OdProtosSellReceptionData_Answers_SellingReasonInput = {
  downsizing?: InputMaybe<Scalars['Boolean']['input']>;
  investmentProperty?: InputMaybe<Scalars['Boolean']['input']>;
  needCash?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  relocating?: InputMaybe<Scalars['Boolean']['input']>;
  retiring?: InputMaybe<Scalars['Boolean']['input']>;
  upgrading?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 7 */
export type OdProtosSellReceptionData_Answers_SetupBuyerFeedInput = {
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minBathrooms?: InputMaybe<Scalars['Float']['input']>;
  minBedrooms?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  propertyTypes?: InputMaybe<OdProtosSellReceptionData_Answers_FeedPropertyTypesInput>;
  zones?: InputMaybe<Array<OdProtosSellReceptionData_Answers_BuyerZoneInput>>;
};

export enum OdProtosSellReceptionData_SellerInput_AddressVerifiedStatus {
  /** seller has implicitly confirmed their address, able to change their address */
  AUTO_VERIFIED = 'AUTO_VERIFIED',
  /** seller has explicitly confirmed their address or moved to a state where their address cannot be changed */
  CONFIRMED_VERIFIED = 'CONFIRMED_VERIFIED',
  /** default for new seller inputs */
  NOT_VERIFIED = 'NOT_VERIFIED'
}

/** Next ID: 2 */
export type OdProtosSellReceptionData_SellerInput_AnalyticsMetadataInput = {
  addressEntry?: InputMaybe<OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_AddressEntryInput>;
};

export type OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_AddressEntryInput = {
  product?: InputMaybe<OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_Product>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export enum OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_Product {
  OPENDOOR_COMPLETE = 'OPENDOOR_COMPLETE',
  /** @deprecated No longer supported */
  OPENDOOR_EXCLUSIVES = 'OPENDOOR_EXCLUSIVES',
  SELL_DIRECT = 'SELL_DIRECT',
  UNKNOWN = 'UNKNOWN'
}

/**
 * The channel the seller came in from, used to determine the overall experience
 * the seller will go through.
 * Next ID: 21
 */
export enum OdProtosSellReceptionData_SellerInput_Channel {
  /** AGENT_REQUEST is used for agent requested leads. */
  AGENT_REQUEST = 'AGENT_REQUEST',
  /** AGENT_REQUEST_LISTED is used for agent requested leads on listed homes. */
  AGENT_REQUEST_LISTED = 'AGENT_REQUEST_LISTED',
  /** APP is used for leads from the mobile app. */
  APP = 'APP',
  /** BUY_SELL_FLOW is used for the combined buy and sell flow launched by Buyer in 2021 */
  BUY_SELL_FLOW = 'BUY_SELL_FLOW',
  /**
   * CAKE_LANDING_PAGE is for leads starting from the /tradeins landing page,
   * intended to reach the new customer dashboard.
   */
  CAKE_LANDING_PAGE = 'CAKE_LANDING_PAGE',
  /** CCPA_OPT_OUT is used for leads that have opted out of CCPA */
  CCPA_OPT_OUT = 'CCPA_OPT_OUT',
  /** DEFAULT is the standard channel for incoming leads. */
  DEFAULT = 'DEFAULT',
  /** EMAIL_PROSPECTING is used for leads from the cold email prospecting experiment. */
  EMAIL_PROSPECTING = 'EMAIL_PROSPECTING',
  /**
   * EXCLUSIVE_OFFER is used for exclusive offers program
   * @deprecated No longer supported
   */
  EXCLUSIVE_OFFERS = 'EXCLUSIVE_OFFERS',
  /**
   * FLYWHEEL is used for leads from the address entry in the app before a
   * buyer unlocks a home, as derived from project Flywheel
   */
  FLYWHEEL = 'FLYWHEEL',
  /**
   * HOME_RESERVE is used for Home reserve landing page
   * @deprecated No longer supported
   */
  HOME_RESERVE = 'HOME_RESERVE',
  /** HOME_VALUE is used for leads from the /home-value landing page. */
  HOME_VALUE = 'HOME_VALUE',
  /**
   * OPENDOOR_BACKED_OFFER is used for bwod obo program
   * @deprecated No longer supported
   */
  OPENDOOR_BACKED_OFFER = 'OPENDOOR_BACKED_OFFER',
  /** OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */
  OUTBOUND_OFFERS_LISTED = 'OUTBOUND_OFFERS_LISTED',
  /** OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that will be underwritten and sent out as final offers */
  OUTBOUND_OFFERS_UNDERWRITTEN = 'OUTBOUND_OFFERS_UNDERWRITTEN',
  /** PARTNER_API is used for seller inputs created via the partner API */
  PARTNER_API = 'PARTNER_API',
  /** REIT_BULK_REQUEST is used for bulk acquisition requests from REITs */
  REIT_BULK_REQUEST = 'REIT_BULK_REQUEST',
  REIT_BULK_REQUEST_LISTED = 'REIT_BULK_REQUEST_LISTED',
  /** SELLER_REQUEST_LISTED is used for seller requested leads on listed homes. */
  SELLER_REQUEST_LISTED = 'SELLER_REQUEST_LISTED',
  /**
   * TRADE_IN is used for leads from the /trade-in landing page.
   * @deprecated No longer supported
   */
  TRADE_IN = 'TRADE_IN',
  /** DO NOT USE, this represents an unset enum value. */
  UNSET_CHANNEL = 'UNSET_CHANNEL'
}

export enum OdProtosSellSellerData_AcquisitionState {
  ACQUISITION_STATE_DENIED = 'ACQUISITION_STATE_DENIED',
  ACQUISITION_STATE_OTHER_WALK = 'ACQUISITION_STATE_OTHER_WALK',
  ACQUISITION_STATE_QUALIFIED = 'ACQUISITION_STATE_QUALIFIED',
  ACQUISITION_STATE_UNDERWRITING_WALK = 'ACQUISITION_STATE_UNDERWRITING_WALK',
  ACQUISITION_STATE_UNKNOWN = 'ACQUISITION_STATE_UNKNOWN'
}

export enum OdProtosSellSellerData_AddOn_AddOnType {
  /** @deprecated No longer supported */
  BWOD = 'BWOD',
  /** @deprecated No longer supported */
  HOME_RESERVE = 'HOME_RESERVE',
  /** @deprecated No longer supported */
  UNKNOWN_ADD_ON = 'UNKNOWN_ADD_ON'
}

export enum OdProtosSellSellerData_AgentReferralDetails_AgentBio_Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  NON_BINARY = 'NON_BINARY',
  UNKNOWN_GENDER = 'UNKNOWN_GENDER'
}

export enum OdProtosSellSellerData_HomeReserveMetadata_HomeReserveAttributionSource {
  /**
   * The seller became eligible for Home Reserve by an operator submitting offer review notes
   * @deprecated No longer supported
   */
  OFFER_REVIEW_DISPOSITION = 'OFFER_REVIEW_DISPOSITION',
  /**
   * The seller became eligible for Home Reserve by answering questions in the seller flow
   * @deprecated No longer supported
   */
  SELLER_FLOW = 'SELLER_FLOW',
  /** @deprecated No longer supported */
  UNKNOWN = 'UNKNOWN'
}

/**
 * LeadId represents a lead input, currently including a lead id (seller_uuid) or a lead source (e.g. reception type and seller_input_uuid).
 * Next ID: 3
 */
export type OdProtosSellSellerData_LeadIdInput = {
  lead?: InputMaybe<OdProtosSellSellerData_LeadId_LeadOneofInput>;
};

export type OdProtosSellSellerData_LeadId_LeadOneofInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
};

/**
 * A qualified sell lead.
 * Next ID: 27
 */
export type OdProtosSellSellerData_LeadInput = {
  /** The address of the lead. */
  addressId?: InputMaybe<Scalars['String']['input']>;
  /**
   * JSON answers that the seller provided (e.g. home details, sale timeline).
   * Example: "{ \"home.bedrooms\": 3, \"seller.email\": \"test@test.com\" }"
   */
  answersJson?: InputMaybe<Scalars['String']['input']>;
  /** The user token of the broker representing the brokerage. Optional. */
  brokerId?: InputMaybe<Scalars['String']['input']>;
  /** The brokerage that is representing the transaction. */
  brokerageId?: InputMaybe<Scalars['String']['input']>;
  /** Channel that the lead belongs to */
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  /** User token of the assigned closing manager. */
  closingManagerId?: InputMaybe<Scalars['String']['input']>;
  /** The time the lead was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The customer who originated the lead. */
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp of decision_call for customers receiving both lwod and od_direct offer. */
  decisionCallAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Experiment entity ID to be used with Optimizely and other experiments. */
  experimentEntityId?: InputMaybe<Scalars['String']['input']>;
  /** User token of the assigned home adviser. */
  homeAdviserId?: InputMaybe<Scalars['String']['input']>;
  /** Home details record referencing the seller's answers. */
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  /** Primary identifier for a lead. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The time of the offer review if the customer opted for one. */
  offerReview?: InputMaybe<OdProtosSellSellerData_OfferReviewInput>;
  /** Policies attached to this lead. */
  policy?: InputMaybe<OdProtosSellSellerData_PolicyInput>;
  /** All the product offerings associated with the lead. */
  productOfferings?: InputMaybe<Array<OdProtosSellSellerData_ProductOfferingInput>>;
  /** Records when a refresh was requested for this lead */
  refreshRequestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Name of the market region the home is in. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The product that the seller has selected */
  selectedProduct?: InputMaybe<OdProtosSellCommon_Product>;
  /** Identifier for the sell request in ODLS. */
  sellRequestId?: InputMaybe<Scalars['String']['input']>;
  /** Information provided by the seller. */
  sellerDetails?: InputMaybe<OdProtosSellSellerData_SellerDetailsInput>;
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
  /**
   * List of users who are participants of the lead. This will initially
   * be empty. When an offer is accepted we will prompt the customer to
   * create an account or log in at which point we can associate the first
   * participant to the lead. Thereafter participants can invite others
   * to join (e.g. spouses, other legal owners).
   */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Which system generated the lead. */
export type OdProtosSellSellerData_Lead_SourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosSellSellerData_Lead_Source_Type>;
};

export enum OdProtosSellSellerData_Lead_Source_Type {
  PARTNERSHIP = 'PARTNERSHIP',
  RECEPTION = 'RECEPTION',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

/** Next ID: 5 */
export type OdProtosSellSellerData_LoanDetailsInput = {
  estimatedBalanceCents?: InputMaybe<Scalars['Float']['input']>;
  interestRatePercent?: InputMaybe<Scalars['Float']['input']>;
  loanType?: InputMaybe<Scalars['String']['input']>;
  originationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 35 */
export enum OdProtosSellSellerData_OfferRequest_Source {
  AGENT_LED_OFFERS_REACTIVATE = 'AGENT_LED_OFFERS_REACTIVATE',
  AGENT_LED_OFFER_AUTO_REFRESH = 'AGENT_LED_OFFER_AUTO_REFRESH',
  AGENT_LED_OFFER_DROPOUT = 'AGENT_LED_OFFER_DROPOUT',
  /** AUTOMATED_AGENT_REENGAGEMENT_OFFER is used for agent refreshes triggered via the daily DAG */
  AUTOMATED_AGENT_REENGAGEMENT_OFFER = 'AUTOMATED_AGENT_REENGAGEMENT_OFFER',
  /** AUTOMATED_MSRE_REFRESH_OFFER is used for auto offer refreshes for MSRE leads daily */
  AUTOMATED_MSRE_REFRESH_OFFER = 'AUTOMATED_MSRE_REFRESH_OFFER',
  AUTOMATED_REENGAGEMENT_OFFER = 'AUTOMATED_REENGAGEMENT_OFFER',
  /** EMAIL_PROSPECTING is used for offer requests on leads from the EMAIL_PROSPECTING channel */
  EMAIL_PROSPECTING = 'EMAIL_PROSPECTING',
  /** @deprecated No longer supported */
  EXCLUSIVE_OFFERS = 'EXCLUSIVE_OFFERS',
  /** FLYWHEEL is used for offer requests on leads from the FLYWHEEL channel */
  FLYWHEEL = 'FLYWHEEL',
  /** HOMEPAGE_RETURN_EXPERIENCE is used for offer refreshes that are triggered from the homepage */
  HOMEPAGE_RETURN_EXPERIENCE = 'HOMEPAGE_RETURN_EXPERIENCE',
  /** HOME_RESERVE is used for offers requests on leads from the HOME_RESERVE channel */
  HOME_RESERVE = 'HOME_RESERVE',
  /** HSA_FO_REFRESH_OUTREACH is used for final offer refresh experiment outreach after seller schedules with HSA */
  HSA_FO_REFRESH_OUTREACH = 'HSA_FO_REFRESH_OUTREACH',
  INCOMPLETE_INITIAL_LEAD_FLOW = 'INCOMPLETE_INITIAL_LEAD_FLOW',
  INITIAL_LEAD_FLOW = 'INITIAL_LEAD_FLOW',
  MOBILE_APP = 'MOBILE_APP',
  OFFER_REENGAGEMENT_CAMPAIGN = 'OFFER_REENGAGEMENT_CAMPAIGN',
  OFFER_REVIEW = 'OFFER_REVIEW',
  /** OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */
  OUTBOUND_OFFERS_LISTED = 'OUTBOUND_OFFERS_LISTED',
  /** OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that should auto-start underwriting and skip assessments */
  OUTBOUND_OFFERS_UNDERWRITTEN = 'OUTBOUND_OFFERS_UNDERWRITTEN',
  REFRESH_ADMIN = 'REFRESH_ADMIN',
  /** REFRESH_ASSESSMENT_COMPLETED is used when a customer completes a virtual assessment but their offer has expired */
  REFRESH_ASSESSMENT_COMPLETED = 'REFRESH_ASSESSMENT_COMPLETED',
  REFRESH_BROKERAGE_OFFER_DASHBOARD = 'REFRESH_BROKERAGE_OFFER_DASHBOARD',
  REFRESH_CORRECTED_SQ_FT_DATA = 'REFRESH_CORRECTED_SQ_FT_DATA',
  /** REFRESH_FROM_ENG is used for backfilling any refresh properties that expierenced a break in flow due to an error */
  REFRESH_FROM_ENG = 'REFRESH_FROM_ENG',
  /** REFRESH_HOME_DETAILS is used for offer refreshes from the offer dashboard home details page */
  REFRESH_HOME_DETAILS = 'REFRESH_HOME_DETAILS',
  REFRESH_OFFER_DASHBOARD = 'REFRESH_OFFER_DASHBOARD',
  /** REFRESH_PARTNER_CTA is used for offer requests that come from Opendoor partners */
  REFRESH_PARTNER_CTA = 'REFRESH_PARTNER_CTA',
  /** REFRESH_PARTNER_REFERRAL is used for offers refreshed from the partnerships referral dashboard */
  REFRESH_PARTNER_REFERRAL = 'REFRESH_PARTNER_REFERRAL',
  REFRESH_PREVIOUSLY_DENIED = 'REFRESH_PREVIOUSLY_DENIED',
  REFRESH_REENGAGEMENT_EMAILS = 'REFRESH_REENGAGEMENT_EMAILS',
  REFRESH_SELLER_FEEDBACK = 'REFRESH_SELLER_FEEDBACK',
  REIT_BULK_REQUEST = 'REIT_BULK_REQUEST',
  /**
   * Restore offer because of an LWOD Listing agreement being signed
   * @deprecated No longer supported
   */
  RESTORE_LWOD_LISTING_AGREEMENT_SIGNED = 'RESTORE_LWOD_LISTING_AGREEMENT_SIGNED',
  /** RETURN_TO_HUB_AUTO_REFRESH is used for offer refreshes automatically made when users return to the Hub */
  RETURN_TO_HUB_AUTO_REFRESH = 'RETURN_TO_HUB_AUTO_REFRESH',
  UNKNOWN_OFFER_SOURCE = 'UNKNOWN_OFFER_SOURCE'
}

/**
 * OfferReview is a scheduled offer review session between the customer and a HA.
 * Next ID: 6
 */
export type OdProtosSellSellerData_OfferReviewInput = {
  /** Calendly's invitee identifier for the scheduled event. */
  calendlyInviteeUuid?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identifier for the offer review. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The time that the offer review is scheduled to start and end. */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosSellSellerData_Offer_Source_Type {
  AGENT_REFERRAL = 'AGENT_REFERRAL',
  CLEARINGHOUSE = 'CLEARINGHOUSE',
  LASER = 'LASER',
  UNKOWN_TYPE = 'UNKOWN_TYPE',
  WEB_BROKERAGE_OFFER = 'WEB_BROKERAGE_OFFER',
  WEB_OFFER = 'WEB_OFFER'
}

/**
 * State represents a state machine for offers.
 * Next ID: 10
 */
export enum OdProtosSellSellerData_Offer_State {
  /**
   * Accepted means the seller has accepted the offer and is ready
   * to proceed. This is not legally binding.
   */
  ACCEPTED = 'ACCEPTED',
  /**
   * Closed means the transaction has been successfully completed. In the
   * case of a direct sale, this means they have sold their home.
   */
  CLOSED = 'CLOSED',
  /**
   * Contingencies released means all contingencies have been released on
   * the transaction.
   */
  CONTINGENCIES_RELEASED = 'CONTINGENCIES_RELEASED',
  /**
   * Expired means the seller did not take action before the expiry of
   * the offer, and the offer is now invalid.
   */
  EXPIRED = 'EXPIRED',
  /**
   * In contract means the seller has signed the purchase agreement and
   * we now have a contractual relationship with the seller.
   */
  IN_CONTRACT = 'IN_CONTRACT',
  /**
   * Received means we have received an offer from a buyer, but
   * have yet to notify the seller of the offer.
   */
  RECEIVED = 'RECEIVED',
  /** Rejected means the seller has rejected the offer. */
  REJECTED = 'REJECTED',
  /**
   * Sent means we have notified the seller of the offer, and are
   * waiting on their response.
   */
  SENT = 'SENT',
  /** This is an unknown or invalid state. */
  UNKNOWN_STATE = 'UNKNOWN_STATE',
  /** Withdrawn means the seller has withdrawn from the transaction. */
  WITHDRAWN = 'WITHDRAWN'
}

/**
 * Policy contains simple data fields which govern what actions should
 * be taken for the lead.
 *
 * Next ID: 9
 */
export type OdProtosSellSellerData_PolicyInput = {
  /**
   * Experiment flags
   *
   * 100% rollout of CEP CX role (Feb 2020)
   */
  expAug2019CepPilot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the lead is qualified for marketplace or not. */
  marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  /** Opendoor direct offer will be an automated offer. */
  opendoorDirectAutomatedOffer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether we can show comps as part of the offer or not. */
  showComps?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * ProductOffering represents a product that we can offer to the seller.
 * Next ID: 9
 */
export type OdProtosSellSellerData_ProductOfferingInput = {
  denialNotes?: InputMaybe<Scalars['String']['input']>;
  /** Following fields are only set if denied. */
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  /** The time that lead was denied for this product (auto or manual denial) */
  deniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** User token of the actor who denied the product. */
  deniedBy?: InputMaybe<Scalars['String']['input']>;
  /** The time that lead was initially qualified for this product */
  initialQualifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The interest level of a seller towards a specific product */
  interestLevel?: InputMaybe<OdProtosSellSellerData_ProductOffering_InterestLevel>;
  /** Reason that opendoor walked from the product */
  opendoorWalkReason?: InputMaybe<OdProtosCommonSell_OpendoorWalkReason>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
  /** Reason that the seller walked from the product */
  sellerWalkReason?: InputMaybe<OdProtosCommonSell_SellerWalkReason>;
  state?: InputMaybe<OdProtosSellSellerData_ProductOffering_State>;
};

/** InterestLevel represents the interest level of a seller towards a product */
export enum OdProtosSellSellerData_ProductOffering_InterestLevel {
  INTERESTED = 'INTERESTED',
  NOT_INTERESTED = 'NOT_INTERESTED',
  UNKNOWN_INTEREST_LEVEL = 'UNKNOWN_INTEREST_LEVEL'
}

export enum OdProtosSellSellerData_ProductOffering_State {
  DENIED = 'DENIED',
  QUALIFIED = 'QUALIFIED',
  UNKNOWN_STATE = 'UNKNOWN_STATE',
  WITHDRAWN = 'WITHDRAWN'
}

/**
 * SellerDetails contains information provided to us from the seller or
 * set by the source service (e.g. Reception or Partnership). Data specified
 * here may be updated if it is updated in the source service.
 *
 * Next ID: 22
 */
export type OdProtosSellSellerData_SellerDetailsInput = {
  /** Whether or not the customer answered that they are actively looking to buy */
  activelyLooking?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the customer is an agent representing the home seller. */
  agent?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Following 4 fields are inputs to calculating buying power using the mortgage service,
   * so types are kept consistent with those in prequalification answers.
   * Seller's annual income in cents.
   */
  annualIncomeCents?: InputMaybe<Scalars['Float']['input']>;
  /** The channel the seller came through */
  channel?: InputMaybe<OdProtosSellCommon_MarketingChannel>;
  /** Seller's credit score range. */
  creditScoreRange?: InputMaybe<OdProtosMortgageData_CreditRangeInput>;
  /** Seller's down payment in cents for their next home. */
  downPaymentCents?: InputMaybe<Scalars['Float']['input']>;
  /** Determines if customer is eligible for an assumable loan from Roam */
  eligibleForRoamAssumableLoan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Seller's goal price. */
  goalPriceCents?: InputMaybe<Scalars['Float']['input']>;
  /** Whether or not the customer has visited the new dynamic moving hub */
  hasVisitedHub?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the user is in the new trade-in dashboard experience. */
  isTradeInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home is currently listed or not. */
  listed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Seller's monthly debt/expenses in cents. */
  monthlyDebtsCents?: InputMaybe<Scalars['Float']['input']>;
  /** Whether or not the customer has visited the offer dashboard. */
  offerDashboardVisited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies the time the offer should be delivered to the customer. */
  offerDeliveryTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The home builder partnership the seller came in through, if any. */
  partnership?: InputMaybe<OdProtosSellCommon_Partnership>;
  /** Photos submitted by the seller as a list of cabinet ids. */
  photoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Seller's own estimate of the value of their home. */
  priceEstimateCents?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Customer UUID for the representative of the partner
   * organization that referred the lead to Opendoor.
   */
  referrerContactId?: InputMaybe<Scalars['String']['input']>;
  /** Specifies loan details from Roam */
  roamAssumableLoanDetails?: InputMaybe<OdProtosSellSellerData_LoanDetailsInput>;
  /** Seller's sale timeline. */
  timeline?: InputMaybe<OdProtosSellCommon_Timeline>;
  /** Whether the home is a potential trade in or not. */
  tradeIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the home is a potential trade in bundle (sell + buy + finance). */
  tradeInBundle?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosSellSellerData_SellerExperience {
  SELLER_EXPERIENCE_AGENT_ACQUISITION = 'SELLER_EXPERIENCE_AGENT_ACQUISITION',
  SELLER_EXPERIENCE_AGENT_LED_OFFERS = 'SELLER_EXPERIENCE_AGENT_LED_OFFERS',
  SELLER_EXPERIENCE_DENIED = 'SELLER_EXPERIENCE_DENIED',
  SELLER_EXPERIENCE_DIRECT_TO_CONSUMER = 'SELLER_EXPERIENCE_DIRECT_TO_CONSUMER',
  SELLER_EXPERIENCE_UNKNOWN = 'SELLER_EXPERIENCE_UNKNOWN'
}

export enum OdProtosSellSellerData_TradeInSpecificData_Interest {
  INTERESTED = 'INTERESTED',
  NOT_INTERESTED = 'NOT_INTERESTED',
  UNSET = 'UNSET'
}

/** RecordedFeature is the feature of the home being recorded. */
export enum OdProtosSellSellerData_VirtualAssessmentRecording_RecordedFeature {
  BACKYARD = 'BACKYARD',
  FRONTYARD = 'FRONTYARD',
  KITCHEN = 'KITCHEN',
  LIVING_ROOM = 'LIVING_ROOM',
  MASTER_BEDROOM_AND_BATHROOM = 'MASTER_BEDROOM_AND_BATHROOM',
  SELLER_DISCLOSURE_DOCUMENT = 'SELLER_DISCLOSURE_DOCUMENT',
  UNKNOWN = 'UNKNOWN',
  UTILITIES = 'UTILITIES',
  WHOLE_HOME = 'WHOLE_HOME'
}

export enum OdProtosSellSellerEvents_SellerLeadEvent_AcquisitionUnderwritingDecisionDetermined_Decision {
  PROCEED = 'PROCEED',
  UNKNOWN_DECISION = 'UNKNOWN_DECISION',
  WALK = 'WALK'
}

export enum OdProtosSellSellerServices_AreAllOffersReadyResponse_Ready {
  /** We have all the offers we expect. */
  ALL_OFFERS_ARE_READY = 'ALL_OFFERS_ARE_READY',
  /** We expect to receive offers, but haven't received all of them. */
  NOT_ALL_OFFERS_ARE_READY = 'NOT_ALL_OFFERS_ARE_READY',
  /** We don't expect any offers because there are no qualified products. */
  NO_QUALIFIED_PRODUCTS = 'NO_QUALIFIED_PRODUCTS',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 2 */
export type OdProtosSellSellerServices_ClearCustomerAssociationRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_CreateLeadRequestInput = {
  lead?: InputMaybe<OdProtosSellSellerData_LeadInput>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_CustomerIdsInput = {
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_DenyLeadRequestInput = {
  denialNotes?: InputMaybe<Scalars['String']['input']>;
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  deniedBy?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
};

/** Next: 6 */
export enum OdProtosSellSellerServices_Experience {
  AGENT_LED_OFERS = 'AGENT_LED_OFERS',
  /** Also known as OpenDoor Led Offers (ODLO) */
  DIRECT_TO_CONSUMER = 'DIRECT_TO_CONSUMER',
  SELL_DIRECT_AGENT = 'SELL_DIRECT_AGENT',
  SELL_DIRECT_CORE = 'SELL_DIRECT_CORE',
  SELL_YOUR_WAY = 'SELL_YOUR_WAY',
  UNKNOWN_EXPERIENCE = 'UNKNOWN_EXPERIENCE'
}

/** Next ID: 1 */
export type OdProtosSellSellerServices_GetAcquisitionStateRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_GetHomeDetailsRequestInput = {
  leadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_GetInitialOfferRequestSourceRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSellSellerServices_GetLatestLeadByAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_GetLatestLeadRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_GetLeadBySourceRequestInput = {
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_GetLeadRequestInput = {
  lead?: InputMaybe<OdProtosSellSellerServices_GetLeadRequest_LeadOneofInput>;
};

export type OdProtosSellSellerServices_GetLeadRequest_LeadOneofInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
};

/** Next: 2 */
export type OdProtosSellSellerServices_GetProductsExperiencesRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSellSellerServices_GetSelectedSellerProductRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_GetSellerDetailsHistoryRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next: 2 */
export type OdProtosSellSellerServices_GetSellerExperienceRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_IsEligibleForRoamAssumableLoanRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_LeadIdsInput = {
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_ListLeadsByAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_ListLeadsBySourceIdRequestInput = {
  sourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_ListLeadsOnUniqueAddressesRequestInput = {
  /** Response will be limited to latest 20 leads */
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_ListLeadsRequestInput = {
  identifiers?: InputMaybe<OdProtosSellSellerServices_ListLeadsRequest_IdentifiersOneofInput>;
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosSellSellerServices_ListLeadsRequest_IdentifiersOneofInput = {
  /** Response will be limited to latest 200 leads */
  customerIds?: InputMaybe<OdProtosSellSellerServices_CustomerIdsInput>;
  leadUuids?: InputMaybe<OdProtosSellSellerServices_LeadIdsInput>;
};

/** Next ID: 4 */
export type OdProtosSellSellerServices_OfferViewedRequestInput = {
  /**
   * Setting lead_id instead of offer_id will send a viewed event for all qualified products.
   * Also while we still track REIT/Agent Referral offers, it'll set those offers to viewed
   * for qualified products.
   */
  leadId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  /** The time the offer was viewed. If blank, the current time will be used */
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_QualifyLeadRequestInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
};

/** Next ID: 4 */
export type OdProtosSellSellerServices_RefreshOffersRequestInput = {
  leadIds?: InputMaybe<Array<OdProtosSellSellerData_LeadIdInput>>;
  offerRequestSource?: InputMaybe<OdProtosSellSellerData_OfferRequest_Source>;
  offerRequestSourceCommon?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_RefreshOffersSingleLeadRequestInput = {
  leadId?: InputMaybe<OdProtosSellSellerData_LeadIdInput>;
  offerRequestSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
};

/** Next: 3 */
export type OdProtosSellSellerServices_SelectProductRequestInput = {
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellSellerServices_SetSellerDetailsRequestInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  sellerDetails?: InputMaybe<OdProtosSellSellerData_SellerDetailsInput>;
  updatedByToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSellSellerServices_SubmitAgentLedOfferDataRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  leadUuid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 8 */
export type OdProtosSellSellerServices_UpdateLeadRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  /**
   * JSON changed answers that should be updated.
   * Example: "{ \"home.bedrooms\": 3 }"
   */
  answers?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<OdProtosSellSellerServices_UpdateLeadRequest_LeadOneofInput>;
};

export type OdProtosSellSellerServices_UpdateLeadRequest_LeadOneofInput = {
  leadId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
};

/** Next ID: 10 */
export type OdProtosSellSellerServices_UpdateSellerDetailsRequestInput = {
  annualIncomeCents?: InputMaybe<Scalars['Float']['input']>;
  creditScoreRange?: InputMaybe<OdProtosMortgageData_CreditRangeInput>;
  downPaymentCents?: InputMaybe<Scalars['Float']['input']>;
  goalPriceCents?: InputMaybe<Scalars['Float']['input']>;
  hasVisitedHub?: InputMaybe<Scalars['Boolean']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  monthlyDebtsCents?: InputMaybe<Scalars['Float']['input']>;
  offerDashboardVisited?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosSellSellerServices_WithdrawFromProductRequestInput = {
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  withdrawalDetails?: InputMaybe<Scalars['String']['input']>;
  withdrawalReason?: InputMaybe<OdProtosSellSellerServices_WithdrawFromProductRequest_WithdrawalReasonOneofInput>;
};

export type OdProtosSellSellerServices_WithdrawFromProductRequest_WithdrawalReasonOneofInput = {
  opendoorWalkReason?: InputMaybe<OdProtosCommonSell_OpendoorWalkReason>;
  sellerWalkReason?: InputMaybe<OdProtosCommonSell_SellerWalkReason>;
};

/** Next ID: 7 */
export enum OdProtosSellWebEvents_LeadEvent_PricingRoutingEventCreated_Strategy {
  AD_HOC_REFRESH = 'AD_HOC_REFRESH',
  AUTOMATED = 'AUTOMATED',
  CONSISTENT_VALUATIONS = 'CONSISTENT_VALUATIONS',
  FORCE_AUTOMATED = 'FORCE_AUTOMATED',
  OUTLIER_VALUATIONS = 'OUTLIER_VALUATIONS',
  REPEAT = 'REPEAT',
  UNKNOWN_STRATEGY = 'UNKNOWN_STRATEGY'
}

/**
 * any filters we want to query by, beyond the required zip + market
 * Next ID: 3
 */
export type OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput = {
  bathrooms?: InputMaybe<Scalars['String']['input']>;
  bedrooms?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellerDashboardMetricsServices_GetChangedListingsRequestInput = {
  /** required argument. if we cannot find data for that zip, we fall back to market */
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** zip of the neighborhood for which you want listings change data */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosSellerDashboardMetricsServices_GetClosedListingsRequestInput = {
  /** whether or not to only query for homes bought by opendoor */
  boughtByOpendoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** required argument. if we cannot find data for that zip, we fall back to market */
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** number of listings bought by opendoor; if this is specified, opendoor listings will be pushed to the front of results */
  numBoughtByOpendoor?: InputMaybe<Scalars['Float']['input']>;
  /** how many closed listings to return */
  numListings?: InputMaybe<Scalars['Float']['input']>;
  /** zip of the neighborhood for which you want new listings data */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellerDashboardMetricsServices_GetHistoricalHomeValuesRequestInput = {
  /** today's ballpark home valuation */
  currentHomeValuationCents?: InputMaybe<Scalars['Float']['input']>;
  /** time frame of home values desired */
  monthsOfData?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsRequestInput = {
  filters?: InputMaybe<OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput>;
  numWeeks?: InputMaybe<Scalars['Float']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellerDashboardMetricsServices_GetHistoricalOffersRequestInput = {
  /** address token */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** customer unique identifier */
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  /** months of data */
  monthsOfData?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetHomeEquityEstimateRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosSellerDashboardMetricsServices_GetHomeValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  homeDetailId?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellerDashboardMetricsServices_GetListingsMetricsRequestInput = {
  /** required argument. if we cannot find data for that zip, we fall back to city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Postal code of the neighborhood for which you want new listings data */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export enum OdProtosSellerDashboardMetricsServices_GetMarketHomePriceAppreciationIncrementEnum {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  TWICE_MONTHLY = 'TWICE_MONTHLY'
}

/** Next ID: 5 */
export type OdProtosSellerDashboardMetricsServices_GetMarketHomePriceAppreciationRequestInput = {
  endDate?: InputMaybe<OdProtosCommon_DateInput>;
  increment?: InputMaybe<OdProtosSellerDashboardMetricsServices_GetMarketHomePriceAppreciationIncrementEnum>;
  marketIdentifier?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetMarketMetricsRequestInput = {
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetMlsPhotosRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosSellerDashboardMetricsServices_GetNewListingsRequestInput = {
  /** whether or not to only query for homes listed by opendoor */
  listedByOpendoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** required argument. if we cannot find data for that zip, we fall back to market */
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  numListedByOpendoor?: InputMaybe<Scalars['Float']['input']>;
  /** how many listings to return */
  numListings?: InputMaybe<Scalars['Float']['input']>;
  /** zip of the neighborhood for which you want new listings data */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetNonOwnerOccupiedAddressesRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosSellerDashboardMetricsServices_GetOffMarketListingsRequestInput = {
  /** required argument. if we cannot find data for that zip, we fall back to market */
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** zip of the neighborhood for which you want off market listings data */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetSalePricePredictionRequestInput = {
  /** address token for */
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export enum OdProtosServiceRegistry_DbSyncTransform_ObfuscateColumns_ObfuscateColumn_Type {
  /**
   * TODO: Deterministically generate fakes from actual values so that
   * columns are comparable.
   *
   * Generates fake emails
   */
  EMAIL = 'EMAIL',
  /** SHA256 of column contents */
  HASH = 'HASH',
  /** Set column to NULL */
  NULL = 'NULL',
  /** Generates fake phone numbers */
  PHONE = 'PHONE',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 2 */
export type OdProtosServiceRegistry_GetOrganizationRequestInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServiceRegistry_GetServiceRequestInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServiceRegistry_GetTeamRequestInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 1 */
export type OdProtosServiceRegistry_ListOrganizationsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 1 */
export type OdProtosServiceRegistry_ListServicesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 1 */
export type OdProtosServiceRegistry_ListTeamsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosServiceRegistry_Service_Type {
  LIBRARY = 'LIBRARY',
  SERVICE = 'SERVICE',
  UNKNOWN = 'UNKNOWN'
}

/**
 * UtilityType is an enum that represents the possible types of utilities
 * or services that can be set up within a home.
 *
 * Next ID: 6
 */
export enum OdProtosServicehubData_UtilityTask_UtilityType {
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  SEWAGE = 'SEWAGE',
  TRASH = 'TRASH',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  WATER = 'WATER'
}

export type OdProtosServicehubServices_SfSyncRequest_GetUtilityStatusesByAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosServicehubServices_SfSyncRequest_GetUtilityStatusesByFlipTokenInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncCommunication_RequestInput = {
  /** ID of the communication */
  comradsId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncCustardContact_RequestInput = {
  /** ID of the Contact */
  contactId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncElementsUtilityContext_RequestInput = {
  /** ID of the context */
  contextId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncElementsUtilityTask_RequestInput = {
  /** ID of the task */
  taskId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncProperty_RequestInput = {
  /** AddressToken of the property */
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncWebLeadRoles_RequestInput = {
  /** ID of the lead */
  leadId?: InputMaybe<Scalars['String']['input']>;
  rolesToSync?: InputMaybe<Array<OdProtosServicehubServices_SyncWebLeadRoles_Role>>;
};

/**
 * These roles only have meaning as they relate to web's view of participants.
 * We maintain no guarantees how they will map to roles maintained within servicehub
 */
export enum OdProtosServicehubServices_SyncWebLeadRoles_Role {
  ACQ_AE = 'ACQ_AE',
  INVALID_ROLE = 'INVALID_ROLE'
}

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncWebLead_RequestInput = {
  /** ID of the Lead */
  leadId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncWebNote_RequestInput = {
  /** ID of the note */
  noteId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncWebOffer_RequestInput = {
  /** Web ID of the Offer */
  offerId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents an Agent (either Buyers or Sellers)
 * Next ID: 3
 */
export type OdProtosSettlerData_AgentInput = {
  /** Commission rate as a percentage (e.g. 70 not 0.7) */
  commissionPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Contact details of the Agent */
  individual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
};

/** List of the supported coordinator types */
export enum OdProtosSettlerData_Coordinator_Type {
  CLOSER = 'CLOSER',
  PRECLOSER = 'PRECLOSER',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Represents a corporation that is transacting on a property
 * Next ID: 6
 */
export type OdProtosSettlerData_CorporationInput = {
  /** Contact details for this Corporation */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Corporation identifier: Web uses customer uuid to represent institutional participants */
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  isOpendoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mailing Address */
  mailingAddress?: InputMaybe<OdProtosCommon_MailingAddressInput>;
  /** Name of the corporation */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Corporation identifier: Clearinghouse uses organization uuids to represent institutional participants */
  organizationUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Legal document associated with a transaction.
 *
 * Next ID: 4
 */
export type OdProtosSettlerData_DocumentInput = {
  /**
   * Where the document originated from. Contains metadata about the originators
   * document.
   */
  source?: InputMaybe<OdProtosSettlerData_DocumentSourceInput>;
  /** Where the document is stored. */
  storage?: InputMaybe<OdProtosSettlerData_DocumentStorageInput>;
  /** The type of the document. */
  type?: InputMaybe<OdProtosSettlerData_Document_Type>;
  /**
   * UUID identifier for the document. This identifier may be used to filter which
   * documents are synced with our title partners if we think the same document
   * has already been synced.
   */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSettlerData_DocumentSourceInput = {
  /** Originators document ID. For example, Resware's DocumentID, or Web's document_uuid. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The document source type is where the document originated from. */
  type?: InputMaybe<OdProtosSettlerData_DocumentSource_Type>;
};

export enum OdProtosSettlerData_DocumentSource_Type {
  CLEARINGHOUSE = 'CLEARINGHOUSE',
  OLA = 'OLA',
  REITHOUSE = 'REITHOUSE',
  RESWARE = 'RESWARE',
  SPRUCE = 'SPRUCE',
  UNKNOWN = 'UNKNOWN',
  WEB = 'WEB'
}

export type OdProtosSettlerData_DocumentStorageInput = {
  /**
   * Document storage ID. It could be a document s3 key in the case of web, or a
   * cabinet uuid.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Where the document file is stored. */
  type?: InputMaybe<OdProtosSettlerData_DocumentStorage_Type>;
};

export enum OdProtosSettlerData_DocumentStorage_Type {
  CABINET = 'CABINET',
  UNKNOWN = 'UNKNOWN',
  WEB = 'WEB'
}

/**
 * List of all possible document types that Settler needs for title and escrow.
 *
 * Next ID: 56
 */
export enum OdProtosSettlerData_Document_Type {
  /** Affiliated business arrangement disclosure */
  ABAD = 'ABAD',
  ADDENDUM = 'ADDENDUM',
  ADDENDUM_RESALE = 'ADDENDUM_RESALE',
  AGENT_REFERRAL_FORM = 'AGENT_REFERRAL_FORM',
  AGENT_REFERRAL_W9 = 'AGENT_REFERRAL_W9',
  AGREED_SETTLEMENT_STATEMENT = 'AGREED_SETTLEMENT_STATEMENT',
  BRN_CREDIT_ADDENDUM = 'BRN_CREDIT_ADDENDUM',
  BUYER_BORROWER_CLOSING_DOCS_UNSIGNED_MERGED = 'BUYER_BORROWER_CLOSING_DOCS_UNSIGNED_MERGED',
  BUYER_CLOSING_DOCS = 'BUYER_CLOSING_DOCS',
  CANCELLATION = 'CANCELLATION',
  CCR = 'CCR',
  CHECKLIST_HOA_SOU = 'CHECKLIST_HOA_SOU',
  CIC_RECEIPT = 'CIC_RECEIPT',
  CLOSING_STATEMENT_FOR_APPROVAL = 'CLOSING_STATEMENT_FOR_APPROVAL',
  COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM = 'COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM',
  COMMISSION_INSTRUCTIONS = 'COMMISSION_INSTRUCTIONS',
  COUNTER_OFFER = 'COUNTER_OFFER',
  DEED = 'DEED',
  EARNEST_MONEY_RECEIPT = 'EARNEST_MONEY_RECEIPT',
  FINAL_REPAIR_ASK = 'FINAL_REPAIR_ASK',
  FINAL_SETTLEMENT_STATEMENT = 'FINAL_SETTLEMENT_STATEMENT',
  /** Homeowner's association addendum */
  HOA_ADDENDUM = 'HOA_ADDENDUM',
  HOA_BUYER_APPROVAL = 'HOA_BUYER_APPROVAL',
  HOA_CCRS = 'HOA_CCRS',
  HOA_DEMAND = 'HOA_DEMAND',
  HOA_DEMAND_SUB = 'HOA_DEMAND_SUB',
  HOA_ESTOPPEL_LETTER_UPDATED = 'HOA_ESTOPPEL_LETTER_UPDATED',
  /** List of HOA Fees, etc */
  HOA_PACKAGE = 'HOA_PACKAGE',
  HOA_STATUS_LETTER = 'HOA_STATUS_LETTER',
  HOA_VIOLATION_RESOLUTION = 'HOA_VIOLATION_RESOLUTION',
  /** Same thing as Closing Statement but on an official govt doc */
  HUD = 'HUD',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  LAND_SURVEY = 'LAND_SURVEY',
  /** Lead based paint addendum */
  LBP_ADDENDUM = 'LBP_ADDENDUM',
  LCO_ADDENDUM = 'LCO_ADDENDUM',
  LIEN_SEARCH = 'LIEN_SEARCH',
  MARKED_COMMITMENT = 'MARKED_COMMITMENT',
  /** https://opendoor.atlassian.net/browse/TITLE-52 */
  NATURAL_HAZARD_DISCLOSURE = 'NATURAL_HAZARD_DISCLOSURE',
  /** Never synced to Web */
  OD_FINAL_FEES = 'OD_FINAL_FEES',
  OPENDOOR_ADDENDUM = 'OPENDOOR_ADDENDUM',
  /** ENGBUGS-15350 - Outbound addednum is a repair ask on aquisition */
  OUTBOUND_ADDENDUM = 'OUTBOUND_ADDENDUM',
  OWNERS_POLICY = 'OWNERS_POLICY',
  PRELIM_EXECUTED_CLOSING_DOCS = 'PRELIM_EXECUTED_CLOSING_DOCS',
  PREPARED_DEED = 'PREPARED_DEED',
  PURCHASE_CONTRACT = 'PURCHASE_CONTRACT',
  RESALE_COMMISSION_INSTRUCTIONS = 'RESALE_COMMISSION_INSTRUCTIONS',
  SELLER_CLOSING_DOCS_UNSIGNED_MERGED = 'SELLER_CLOSING_DOCS_UNSIGNED_MERGED',
  SELLER_SIGNED_CLOSING_DOCS = 'SELLER_SIGNED_CLOSING_DOCS',
  SOLAR_INFORMATION = 'SOLAR_INFORMATION',
  T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT = 'T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT',
  TAX_CERTIFICATE = 'TAX_CERTIFICATE',
  TITLE_COMMITMENT = 'TITLE_COMMITMENT',
  TRANSFER_ADDENDUM = 'TRANSFER_ADDENDUM',
  /** https://docs.google.com/document/d/1FyN-FsXLhWgqjd4uwj2K2c1Q_Nfhj13o_b_KFa5Ef_M/edit */
  TRIAL_LISTING_AGREEMENT = 'TRIAL_LISTING_AGREEMENT',
  UCC_TERMINATION = 'UCC_TERMINATION',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosSettlerData_FileType {
  FILE_TYPE_REVIEW_ONLY = 'FILE_TYPE_REVIEW_ONLY',
  FILE_TYPE_STANDARD = 'FILE_TYPE_STANDARD',
  FILE_TYPE_TITLE_ONLY = 'FILE_TYPE_TITLE_ONLY',
  FILE_TYPE_UNSPECIFIED = 'FILE_TYPE_UNSPECIFIED'
}

export enum OdProtosSettlerData_File_PartnerType {
  EMAIL = 'EMAIL',
  RESWARE = 'RESWARE',
  UNKNOWN = 'UNKNOWN'
}

/** Indicates the state of the file in Escrow */
export enum OdProtosSettlerData_File_State {
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  INITIAL = 'INITIAL',
  OPENED = 'OPENED'
}

/**
 * Represents an individual who is transacting with one of our properties
 * Next ID: 7
 */
export type OdProtosSettlerData_IndividualInput = {
  /** Contact details for this individual */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pre and post close mailing addresses. Post close address is optional, and
   * will default to the pre close address if unset.
   */
  mailingAddress?: InputMaybe<OdProtosCommon_MailingAddressInput>;
  /** First and last name of the Individual */
  name?: InputMaybe<OdProtosCommon_NameInput>;
  postCloseMailingAddress?: InputMaybe<OdProtosCommon_MailingAddressInput>;
  preferredLanguageAlpha2?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents multiple individuals who act as a single entity
 * (e.g. married couple who both have their names on the deed)
 * Next ID: 4
 */
export type OdProtosSettlerData_IndividualPartnershipInput = {
  /** Contact details for this Partnership */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** List of individuals in this partnership */
  individuals?: InputMaybe<Array<OdProtosSettlerData_IndividualInput>>;
};

/**
 * Loans associated with a file
 * Next ID: 3
 */
export type OdProtosSettlerData_LoanInput = {
  loanAmountCents?: InputMaybe<Scalars['Float']['input']>;
  /** Some unique identifier for a loan */
  loanNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Milestone for a particular file. There are typically many milestones that are
 * updated over time as a particular file nears its close of escrow date.
 *
 * Next ID: 5
 */
export type OdProtosSettlerData_MilestoneInput = {
  /** File UUID that is the parent of this milestone. */
  fileUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * MilestoneStatusLog is a list of statuses and dates, which represent the
   * progress made on a particular milestone.
   */
  log?: InputMaybe<Array<OdProtosSettlerData_MilestoneStatusLogInput>>;
  type?: InputMaybe<OdProtosSettlerData_Milestone_MilestoneType>;
};

export type OdProtosSettlerData_MilestoneStatusLogInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A JSON representation of the metadata associated with a milestone. in  the future,
   * we should have this typed and deprecated this field, but for now we can transmit it as a
   * string.
   */
  jsonmetadata?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OdProtosSettlerData_MilestoneStatusLog_MilestoneStatus>;
};

/**
 * List of all the possible milestone statuses
 *
 * Next ID: 6
 */
export enum OdProtosSettlerData_MilestoneStatusLog_MilestoneStatus {
  CURATIVE = 'CURATIVE',
  EXPIRED = 'EXPIRED',
  RECEIVED = 'RECEIVED',
  REQUESTED = 'REQUESTED',
  SENT = 'SENT',
  UNKNOWN = 'UNKNOWN'
}

/**
 * List of all the possible milestone types
 *
 * Next ID: 13
 */
export enum OdProtosSettlerData_Milestone_MilestoneType {
  AGENT_COMMISSION_INSTRUCTIONS_SENT = 'AGENT_COMMISSION_INSTRUCTIONS_SENT',
  BALANCED_WITH_LENDER = 'BALANCED_WITH_LENDER',
  /** When the buyer information is recevied in a Resale */
  BUYER_INFORMATION = 'BUYER_INFORMATION',
  BUYER_SELLER_DOCS_SENT = 'BUYER_SELLER_DOCS_SENT',
  CLEAR_TITLE = 'CLEAR_TITLE',
  COE_DATE_CHANGED = 'COE_DATE_CHANGED',
  CONGRATS_EMAIL_SENT = 'CONGRATS_EMAIL_SENT',
  EARNEST_MONEY_RECEIPT = 'EARNEST_MONEY_RECEIPT',
  FILE_STATUS_UPDATED = 'FILE_STATUS_UPDATED',
  FUNDED = 'FUNDED',
  HOA_PACKAGE = 'HOA_PACKAGE',
  PAYOFF = 'PAYOFF',
  PRELIMINARY_DOCS_UPLOADED = 'PRELIMINARY_DOCS_UPLOADED',
  PRELIMINARY_SETTLEMENT_STATEMENT_PREPARED = 'PRELIMINARY_SETTLEMENT_STATEMENT_PREPARED',
  PRELIM_TITLE_COMMITMENT = 'PRELIM_TITLE_COMMITMENT',
  /** When the seller information is received in an Aquisition */
  SELLER_INFORMATION = 'SELLER_INFORMATION',
  SIGNING_APPOINTMENT_CONFIRMED = 'SIGNING_APPOINTMENT_CONFIRMED',
  SIGNING_APPOINTMENT_SCHEDULED = 'SIGNING_APPOINTMENT_SCHEDULED',
  TITLE_SEARCH = 'TITLE_SEARCH',
  UNKNOWN = 'UNKNOWN'
}

/**
 * ReswareHuman associates a resware employee ID
 * Next ID: 3
 */
export type OdProtosSettlerData_ReswareHumanInput = {
  reswareEmployeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents someone who has been assigned a role on the file
 * E.g. Precloser (a.k.a Escrow Assistant)
 * Next ID: 5
 */
export type OdProtosSettlerData_RoleAssignmentInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** The employee_id in external title software. */
  externalEmployeeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleType?: InputMaybe<OdProtosSettlerData_RoleAssignment_Type>;
};

/** Next ID: 4 */
export enum OdProtosSettlerData_RoleAssignment_Type {
  /** Closing Coordinator does back office functions */
  CLOSING_COORDINATOR = 'CLOSING_COORDINATOR',
  /** Closing Manager is the customer's point of contact at Opendoor */
  CLOSING_MANAGER = 'CLOSING_MANAGER',
  PRECLOSER = 'PRECLOSER',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Status of a sync
 * NextID: 3
 */
export enum OdProtosSettlerData_SyncStatus {
  /** Indicates that something failed (either sync or async) */
  FAILURE = 'FAILURE',
  /**
   * Indicates that something has been queued up successfully and is
   * being asynchronously processed
   */
  PENDING = 'PENDING',
  /** Indicates that something was successful (either sync or async) */
  SUCCESS = 'SUCCESS',
  /** Indicates that a document was successfully emailed (not over API) */
  UNCONFIRMED = 'UNCONFIRMED'
}

export enum OdProtosSettlerEvents_RecordsTitleEscrowLifecycleEvent_TitleEscrowLifecycleEvent_EventSource {
  SETTLER = 'SETTLER',
  UNKNOWN = 'UNKNOWN',
  WEB = 'WEB'
}

export enum OdProtosSettlerEvents_RecordsTitleEscrowLifecycleEvent_TitleEscrowLifecycleEvent_Transaction_TransactionType {
  ACQ = 'ACQ',
  BUYER = 'BUYER',
  CLEARINGHOUSE = 'CLEARINGHOUSE',
  RSL = 'RSL',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Request for AddDocuments method
 * Next ID: 3
 */
export type OdProtosSettlerServices_AddDocumentsRequestInput = {
  documents?: InputMaybe<Array<OdProtosSettlerData_DocumentInput>>;
  fileUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for CancelFile method
 * Next ID: 2
 */
export type OdProtosSettlerServices_CancelFileRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for CloseFile method
 * Next ID: 11
 */
export type OdProtosSettlerServices_CloseFileRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for CreateFile method
 * Next ID: 34
 */
export type OdProtosSettlerServices_CreateFileRequestInput = {
  /** Specifies partnership channel for the acquisition lead */
  acquisitionPartnership?: InputMaybe<Scalars['String']['input']>;
  /** Address uuid for the relevant property */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** The Buyer in this file */
  buyer?: InputMaybe<OdProtosSettlerServices_CreateFileRequest_BuyerOneofInput>;
  /** Buyers agent information */
  buyersAgent?: InputMaybe<OdProtosSettlerData_AgentInput>;
  /**
   * File number in the client. Intended for use by humans when referring
   * to this File. In Web this is the Flip Token
   */
  clientFileNumber?: InputMaybe<Scalars['String']['input']>;
  closeOfEscrowDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * consumer_reference and consumer_service_reference will uniquely identify this file
   * in the service that calls Settler. This allows us to make CreateFile
   * idempotent
   */
  consumerReference?: InputMaybe<Scalars['String']['input']>;
  consumerServiceReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * List of various documents required to create a new file with our title
   * partner. The purchase contract document is required, other document types
   * are optional and can be later added with the AddDocument method.
   */
  documents?: InputMaybe<Array<OdProtosSettlerData_DocumentInput>>;
  /** The contact for the Escrow organization */
  escrowOrganizationContactUserToken?: InputMaybe<Scalars['String']['input']>;
  /** The organization providing Escrow services */
  escrowOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional identifiers if we have already created a title file with an external
   * title partner. If these fields are populated, Settler will simply create a
   * new internal record, but won't attempt to create a file externally.
   */
  externalFileId?: InputMaybe<Scalars['String']['input']>;
  externalFileNumber?: InputMaybe<Scalars['String']['input']>;
  /** Specifies if the property was acquired */
  isAcquired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies if the transaction is a mainstay (True) or opendoor (False) transaction */
  isMainstayTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unified Lender object to replace org objects above. */
  lenderUuid?: InputMaybe<Scalars['String']['input']>;
  /** If channel = exclusive, we will use a different product type. */
  listingOfferChannel?: InputMaybe<Scalars['String']['input']>;
  /** Any relevant Loans taken by the Buyer. Optional. */
  loans?: InputMaybe<Array<OdProtosSettlerData_LoanInput>>;
  /**
   * APN (assessor's parcel number) for this property.
   * Required by 3rd Party Title/Escrow Software
   */
  propertyApn?: InputMaybe<Scalars['String']['input']>;
  /** The contact for the brokerage that is asking Escrow to open a file */
  requestingOrganizationContactUserToken?: InputMaybe<Scalars['String']['input']>;
  /** The organization that is requesting Escrow open a file */
  requestingOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  /** External employees that should be assigned to this File. Optional. */
  roleAssignments?: InputMaybe<Array<OdProtosSettlerData_RoleAssignmentInput>>;
  /** The price the property will sell for */
  salesPriceCents?: InputMaybe<Scalars['Float']['input']>;
  /** The Seller in this file */
  seller?: InputMaybe<OdProtosSettlerServices_CreateFileRequest_SellerOneofInput>;
  /** Sellers agent information */
  sellersAgent?: InputMaybe<OdProtosSettlerData_AgentInput>;
};

export type OdProtosSettlerServices_CreateFileRequest_BuyerOneofInput = {
  buyerCorporation?: InputMaybe<OdProtosSettlerData_CorporationInput>;
  buyerIndividual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
  buyerPartnership?: InputMaybe<OdProtosSettlerData_IndividualPartnershipInput>;
};

export type OdProtosSettlerServices_CreateFileRequest_SellerOneofInput = {
  sellerCorporation?: InputMaybe<OdProtosSettlerData_CorporationInput>;
  sellerIndividual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
  sellerPartnership?: InputMaybe<OdProtosSettlerData_IndividualPartnershipInput>;
};

export type OdProtosSettlerServices_CreateMilestoneRequestInput = {
  milestone?: InputMaybe<OdProtosSettlerData_MilestoneInput>;
};

export type OdProtosSettlerServices_GetCoordinatorsRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for GetFile method
 * Next ID: 2
 */
export type OdProtosSettlerServices_GetFileRequestInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for GetMilestones rpc
 * Next ID: 2
 */
export type OdProtosSettlerServices_GetMilestonesRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Title members that can handle a particular region
 * and a particular type of offer
 *
 * Next ID: 3
 */
export type OdProtosSettlerServices_GetTitleMembersRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  titleMemberFilter?: InputMaybe<OdProtosSettlerServices_GetTitleMembersRequest_TitleMemberFilter>;
};

/** Next ID: 3 */
export enum OdProtosSettlerServices_GetTitleMembersRequest_TitleMemberFilter {
  ACQUISITION = 'ACQUISITION',
  RESALE = 'RESALE',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosSettlerServices_ListCoordinatorsForFilesRequestInput = {
  params?: InputMaybe<OdProtosSettlerServices_ListCoordinatorsForFilesRequest_ParamsOneofInput>;
};

export type OdProtosSettlerServices_ListCoordinatorsForFilesRequest_ParamsOneofInput = {
  search?: InputMaybe<OdProtosSettlerServices_ListCoordinatorsForFilesRequest_SearchInput>;
};

export type OdProtosSettlerServices_ListCoordinatorsForFilesRequest_SearchInput = {
  fileCreatedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  fileCreatedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Request for ListDocumentsSyncs rpc
 * Next ID: 2
 */
export type OdProtosSettlerServices_ListDocumentSyncsRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for ListDocuments rpc
 * Next ID: 2
 */
export type OdProtosSettlerServices_ListDocumentsRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for ListFiles method
 * Next ID: 4
 */
export type OdProtosSettlerServices_ListFilesRequestInput = {
  addressuuids?: InputMaybe<Array<Scalars['String']['input']>>;
  externalfilenumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosSettlerServices_ListReswareHumansRequestInput = {
  reswareEmployeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosSettlerServices_UpdateFileParticipantsRequestInput = {
  /** The Buyer in this file */
  buyer?: InputMaybe<OdProtosSettlerServices_UpdateFileParticipantsRequest_BuyerOneofInput>;
  /** Buyers agent information */
  buyersAgent?: InputMaybe<OdProtosSettlerData_AgentInput>;
  fileUuid?: InputMaybe<Scalars['String']['input']>;
  /** The Seller in this file */
  seller?: InputMaybe<OdProtosSettlerServices_UpdateFileParticipantsRequest_SellerOneofInput>;
  /** Sellers agent information */
  sellersAgent?: InputMaybe<OdProtosSettlerData_AgentInput>;
};

export type OdProtosSettlerServices_UpdateFileParticipantsRequest_BuyerOneofInput = {
  buyerCorporation?: InputMaybe<OdProtosSettlerData_CorporationInput>;
  buyerIndividual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
  buyerPartnership?: InputMaybe<OdProtosSettlerData_IndividualPartnershipInput>;
};

export type OdProtosSettlerServices_UpdateFileParticipantsRequest_SellerOneofInput = {
  sellerCorporation?: InputMaybe<OdProtosSettlerData_CorporationInput>;
  sellerIndividual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
  sellerPartnership?: InputMaybe<OdProtosSettlerData_IndividualPartnershipInput>;
};

/**
 * Request for UpdateFile method
 * Next ID: 3
 */
export type OdProtosSettlerServices_UpdateFileRequestInput = {
  externalFileNumber?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSettlerServices_UpdateFileTitlePrecloserRequestInput = {
  /** The contact for the Escrow organization */
  escrowOrganizationContactUserToken?: InputMaybe<Scalars['String']['input']>;
  /** The role assignment information for the new contact */
  roleAssignment?: InputMaybe<OdProtosSettlerData_RoleAssignmentInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSettlerServices_UpdateReswareHumanRequestInput = {
  reswareHuman?: InputMaybe<OdProtosSettlerData_ReswareHumanInput>;
};

export enum OdProtosSignalsData_BackYardConditionMessage_BackYardCondition {
  FULLY_LANDSCAPED = 'FULLY_LANDSCAPED',
  NEEDS_WORK = 'NEEDS_WORK',
  NO_YARD = 'NO_YARD',
  PARTIALLY_LANDSCAPED = 'PARTIALLY_LANDSCAPED',
  UNKNOWN = 'UNKNOWN'
}

/** comps specified to be used in NNOVM */
export type OdProtosSignalsData_CompInput = {
  /** comps address token */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * sometimes Surveyor has multiple comps per address token
   * this serves to uniquely identify a comp within the request when filled in
   */
  compNumber?: InputMaybe<Scalars['Int']['input']>;
  fListingStatus?: InputMaybe<Scalars['String']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  overlay?: InputMaybe<OdProtosSignalsData_OverlayInput>;
};

export enum OdProtosSignalsData_ConditionMessage_Condition {
  GREAT_CONDITION = 'GREAT_CONDITION',
  NEEDS_WORK = 'NEEDS_WORK',
  TYPICAL_USE = 'TYPICAL_USE',
  UNKNOWN = 'UNKNOWN'
}

/** Fractional home condition score */
export type OdProtosSignalsData_ConditionScoreInput = {
  score?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosSignalsData_DwellingTypeMessage_DwellingType {
  APARTMENT = 'APARTMENT',
  HALF_DUPLEX = 'HALF_DUPLEX',
  MANUFACTURED_HOME = 'MANUFACTURED_HOME',
  MOBILE_HOME = 'MOBILE_HOME',
  PATIO = 'PATIO',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
  TOWNHOUSE = 'TOWNHOUSE',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosSignalsData_FloorConditionMessage_FloorCondition {
  GREAT_CONDITION = 'GREAT_CONDITION',
  HEAVILY_WORN = 'HEAVILY_WORN',
  TYPICAL_USE = 'TYPICAL_USE',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosSignalsData_FloorTypeMessage_FloorType {
  CARPET = 'CARPET',
  HARDWOOD = 'HARDWOOD',
  LAMINATE = 'LAMINATE',
  LINOLEUM = 'LINOLEUM',
  OTHER = 'OTHER',
  TILE = 'TILE',
  UNKNOWN = 'UNKNOWN',
  VINYL = 'VINYL',
  VINYL_PLANK = 'VINYL_PLANK'
}

export enum OdProtosSignalsData_KitchenApplianceTypeMessage_KitchenApplianceType {
  BLACK = 'BLACK',
  MIXED = 'MIXED',
  OTHER = 'OTHER',
  STAINLESS_STEEL = 'STAINLESS_STEEL',
  UNKNOWN = 'UNKNOWN',
  WHITE = 'WHITE'
}

export enum OdProtosSignalsData_KitchenCounterTopMessage_KitchenCounterTop {
  CORIAN = 'CORIAN',
  FORMICA = 'FORMICA',
  GRANITE = 'GRANITE',
  GRANITE_SLAB = 'GRANITE_SLAB',
  GRANITE_TILE = 'GRANITE_TILE',
  MARBLE = 'MARBLE',
  OTHER = 'OTHER',
  OTHER_TILE = 'OTHER_TILE',
  QUARTZ = 'QUARTZ',
  TILE = 'TILE',
  UNKNOWN = 'UNKNOWN'
}

/** acceptable model name for nnovm */
export enum OdProtosSignalsData_ModelName {
  HYBRIDOVM = 'HYBRIDOVM',
  LIGHTNING = 'LIGHTNING',
  UNKNOWN = 'UNKNOWN'
}

/**
 * home detail overlay fields and value options copied from
 * https://github.com/opendoor-labs/signals/blob/01689bbb/signals/api/constants.py#L3
 * and https://github.com/opendoor-labs/renaissance/blob/42d304b4/renaissance/nn_ovm/model_serving/constants.py#L6
 * but ignore some that don't get interpreated in renaissance.
 */
export type OdProtosSignalsData_OverlayInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Float']['input']>;
  backYardCondition?: InputMaybe<OdProtosSignalsData_BackYardConditionMessage_BackYardCondition>;
  backYardRetainingWall?: InputMaybe<Scalars['String']['input']>;
  backYardSlope?: InputMaybe<Scalars['String']['input']>;
  backYardSlopeType?: InputMaybe<Scalars['String']['input']>;
  basementFinishedSqFt?: InputMaybe<Scalars['Float']['input']>;
  basementUnfinishedSqFt?: InputMaybe<Scalars['Float']['input']>;
  bathroomCondition?: InputMaybe<OdProtosSignalsData_ConditionMessage_Condition>;
  bathroomConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  bathroomsFull?: InputMaybe<Scalars['Int']['input']>;
  bathroomsHalf?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  busyRoadTypeArterialConnectorStrength?: InputMaybe<Scalars['Float']['input']>;
  carportSpaces?: InputMaybe<Scalars['Int']['input']>;
  dwellingType?: InputMaybe<OdProtosSignalsData_DwellingTypeMessage_DwellingType>;
  exteriorConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  exteriorStories?: InputMaybe<Scalars['Int']['input']>;
  floorCondition?: InputMaybe<OdProtosSignalsData_FloorConditionMessage_FloorCondition>;
  garageSpaces?: InputMaybe<Scalars['Int']['input']>;
  hasRenovation?: InputMaybe<Scalars['Boolean']['input']>;
  interiorConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  isGatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  kitchenApplianceType?: InputMaybe<OdProtosSignalsData_KitchenApplianceTypeMessage_KitchenApplianceType>;
  kitchenCondition?: InputMaybe<OdProtosSignalsData_ConditionMessage_Condition>;
  kitchenConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  kitchenCountertop?: InputMaybe<OdProtosSignalsData_KitchenCounterTopMessage_KitchenCounterTop>;
  lotSqFt?: InputMaybe<Scalars['Float']['input']>;
  paintCondition?: InputMaybe<OdProtosSignalsData_ConditionMessage_Condition>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  primaryFloorCondition?: InputMaybe<OdProtosSignalsData_FloorConditionMessage_FloorCondition>;
  primaryFloorType?: InputMaybe<OdProtosSignalsData_FloorTypeMessage_FloorType>;
  propertyConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  renovationAmount?: InputMaybe<Scalars['Int']['input']>;
  secondaryFloorCondition?: InputMaybe<OdProtosSignalsData_FloorConditionMessage_FloorCondition>;
  secondaryFloorType?: InputMaybe<OdProtosSignalsData_FloorTypeMessage_FloorType>;
  slopedBackYardStrength?: InputMaybe<Scalars['Float']['input']>;
  sqFtDiscrepancy?: InputMaybe<Scalars['Float']['input']>;
  totalFinishedSqFt?: InputMaybe<Scalars['Float']['input']>;
  viewsStrength?: InputMaybe<Scalars['Float']['input']>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosSignalsData_RequestIdInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSignalsData_RequestorIdInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSignalsData_SubjectInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  overlay?: InputMaybe<OdProtosSignalsData_OverlayInput>;
};

export enum OdProtosSignalsServices_FeatureCategory_Category {
  ABOVE_GRADE_SQFT = 'ABOVE_GRADE_SQFT',
  AS_IS_SALE = 'AS_IS_SALE',
  BASEMENT_FIN_SQFT = 'BASEMENT_FIN_SQFT',
  BASEMENT_UNFIN_SQFT = 'BASEMENT_UNFIN_SQFT',
  BATHROOMS = 'BATHROOMS',
  BEDROOMS = 'BEDROOMS',
  CARPORT_SPACES = 'CARPORT_SPACES',
  CONSTRUCTION_BRICK = 'CONSTRUCTION_BRICK',
  CUL_DE_SAC = 'CUL_DE_SAC',
  DRIVEWAY_TYPE = 'DRIVEWAY_TYPE',
  DWELLING_STYLE = 'DWELLING_STYLE',
  DWELLING_TYPE = 'DWELLING_TYPE',
  FLOORING = 'FLOORING',
  GARAGE_SPACES = 'GARAGE_SPACES',
  GRANITE = 'GRANITE',
  HAS_FIREPLACE = 'HAS_FIREPLACE',
  HAS_PREV_DELISTING = 'HAS_PREV_DELISTING',
  HAS_RESORT_STYLE = 'HAS_RESORT_STYLE',
  HAS_SPA = 'HAS_SPA',
  HAS_UPGRADES = 'HAS_UPGRADES',
  HOA = 'HOA',
  INTERIOR_NEEDS_REPAIR = 'INTERIOR_NEEDS_REPAIR',
  IS_BUSY_ROAD = 'IS_BUSY_ROAD',
  IS_CASH_ONLY = 'IS_CASH_ONLY',
  IS_GOLF_LOT = 'IS_GOLF_LOT',
  IS_LAKE_LOT = 'IS_LAKE_LOT',
  IS_PARK_LOT = 'IS_PARK_LOT',
  IS_RECENT_BUILD = 'IS_RECENT_BUILD',
  KITCHEN_ISLAND = 'KITCHEN_ISLAND',
  LOT_SQFT = 'LOT_SQFT',
  MOTIVATED_SELLER = 'MOTIVATED_SELLER',
  NEARBY_ROADS = 'NEARBY_ROADS',
  NEW_CONSTRUCTION = 'NEW_CONSTRUCTION',
  NICE_BACKYARD = 'NICE_BACKYARD',
  NICE_CURB_APPEAL = 'NICE_CURB_APPEAL',
  POOL = 'POOL',
  PREV_DELISTED_DOM_MONTH_WEIGHTED = 'PREV_DELISTED_DOM_MONTH_WEIGHTED',
  RESTB_SCORES = 'RESTB_SCORES',
  SELLER_CONCESSIONS = 'SELLER_CONCESSIONS',
  SLC_AGE_RESTRICTED = 'SLC_AGE_RESTRICTED',
  SLC_AGE_RESTRICTED_DEPRECATED = 'SLC_AGE_RESTRICTED_DEPRECATED',
  SLC_AUCTION = 'SLC_AUCTION',
  SLC_COURT_APPROVAL_REQ = 'SLC_COURT_APPROVAL_REQ',
  SLC_EXCLUSIONS = 'SLC_EXCLUSIONS',
  SLC_GATED_COMMUNITY = 'SLC_GATED_COMMUNITY',
  SLC_HUD_OWNED = 'SLC_HUD_OWNED',
  SLC_LENDER_APPROVED_SHORT_SALE = 'SLC_LENDER_APPROVED_SHORT_SALE',
  SLC_LENDER_OWNED_REO = 'SLC_LENDER_OWNED_REO',
  SLC_OWNER_AGENT = 'SLC_OWNER_AGENT',
  SLC_OWNER_OCCUPANCY_REQ = 'SLC_OWNER_OCCUPANCY_REQ',
  SLC_PREV_APPROVED_SHORT_SALE = 'SLC_PREV_APPROVED_SHORT_SALE',
  SLC_PRE_FORECLOSURE = 'SLC_PRE_FORECLOSURE',
  SLC_PROBATE_ESTATE = 'SLC_PROBATE_ESTATE',
  SLC_RELO_CORP_APPROVAL_REQ = 'SLC_RELO_CORP_APPROVAL_REQ',
  SLC_SHORT_SALE_APPROVAL_REQ = 'SLC_SHORT_SALE_APPROVAL_REQ',
  SLC_SPECIAL_SALE = 'SLC_SPECIAL_SALE',
  SPECIAL_LISTING = 'SPECIAL_LISTING',
  STAINLESS_STEEL = 'STAINLESS_STEEL',
  STORIES = 'STORIES',
  TOTAL_FINISHED_SQFTBAD_INTERIOR_QUALITY = 'TOTAL_FINISHED_SQFTBAD_INTERIOR_QUALITY',
  UNKNOWN = 'UNKNOWN',
  YEAR_BUILT = 'YEAR_BUILT'
}

export type OdProtosSignalsServices_FetchCompsAvailabilityRequestInput = {
  /**
   * The Asof date. For a historical valuation, comps beyond this date is not usable; for regular valuations,
   * it's the time when the request is made
   */
  asofDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Comps with their address tokens and home detail overlay */
  comps?: InputMaybe<Array<OdProtosSignalsData_CompInput>>;
  /** suggest a specific OVM version to use, default is current production if none specified */
  featureFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  requestId?: InputMaybe<OdProtosSignalsData_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosSignalsData_RequestorIdInput>;
  /** Subject address token and home details overlay */
  subject?: InputMaybe<OdProtosSignalsData_SubjectInput>;
};

export type OdProtosSignalsServices_FetchHpiRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Whether allow the timeseries to be partial (allow missing certain time point value). */
  allowPartial?: InputMaybe<Scalars['Boolean']['input']>;
  /** end as timestamp */
  end?: InputMaybe<Scalars['Float']['input']>;
  /** end date of hpi series */
  endDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Whether to return the full timeseries or just the value at [start, end]. */
  fullTimeseries?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** metadata */
  requestId?: InputMaybe<OdProtosSignalsData_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosSignalsData_RequestorIdInput>;
  /** start as timestamp */
  start?: InputMaybe<Scalars['Float']['input']>;
  /** start date of hpi series */
  startDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosSignalsServices_FetchHybridOvmLineItemAdjustmentsRequestInput = {
  /**
   * The Asof date. For a historical valuation, comps beyond this date is not usable; for regular valuations,
   * it's the time when the request is made
   */
  asofDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Comps with their address tokens and home detail overlay */
  manualOverrideComps?: InputMaybe<Array<OdProtosSignalsData_CompInput>>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** This is for logging purpose, use "HybridOVM" */
  model?: InputMaybe<OdProtosSignalsData_ModelName>;
  requestId?: InputMaybe<OdProtosSignalsData_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosSignalsData_RequestorIdInput>;
  subject?: InputMaybe<OdProtosSignalsData_SubjectInput>;
};

export enum OdProtosSignalsServices_InputCategory_Category {
  NON_SURVEYOR_INPUT = 'NON_SURVEYOR_INPUT',
  SURVEYOR_INPUT = 'SURVEYOR_INPUT',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosSignalsServices_UnusableReasonCategoryMessage_UnusableReasonCategory {
  COMP_NOT_IN_SERVING_TABLE_OR_IN_DIFFERENT_MLS_FROM_SUBJECT = 'COMP_NOT_IN_SERVING_TABLE_OR_IN_DIFFERENT_MLS_FROM_SUBJECT',
  HOME_DETAILS_FILTERED = 'HOME_DETAILS_FILTERED',
  OTHER = 'OTHER',
  SPECIAL_SALE = 'SPECIAL_SALE',
  STALE_LISTING_IN_OVM = 'STALE_LISTING_IN_OVM',
  UNKNOWN = 'UNKNOWN',
  UNUSABLE_LISTING_STATUS = 'UNUSABLE_LISTING_STATUS'
}

export enum OdProtosSupportData_AgentVerificationStatus {
  AGENT_VERIFICATION_DENIED = 'AGENT_VERIFICATION_DENIED',
  AGENT_VERIFICATION_FULLY_VERIFIED = 'AGENT_VERIFICATION_FULLY_VERIFIED',
  AGENT_VERIFICATION_REQUIRES_VERIFICATION = 'AGENT_VERIFICATION_REQUIRES_VERIFICATION',
  AGENT_VERIFICATION_UNKNOWN = 'AGENT_VERIFICATION_UNKNOWN',
  AGENT_VERIFICATION_VERIFIED = 'AGENT_VERIFICATION_VERIFIED'
}

export type OdProtosSupportData_AssessmentFailureInformationInput = {
  reasonForCancellation?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportData_AssociatedRecordInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportData_BrokerRejectionOfDocumentInformationInput = {
  documentRejectionReason?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<OdProtosSupportData_DocumentType>;
};

export type OdProtosSupportData_ContractChangeInformationInput = {
  currentUgm?: InputMaybe<Scalars['Float']['input']>;
  feeCostCents?: InputMaybe<Scalars['Float']['input']>;
  impliedUgm?: InputMaybe<Scalars['Float']['input']>;
  internalFeeCostCents?: InputMaybe<Scalars['Float']['input']>;
  maximumSubsidyCents?: InputMaybe<Scalars['Int']['input']>;
  partnershipTypes?: InputMaybe<Array<OdProtosSupportData_PartnershipType>>;
  purchaseAgreementCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  requestSubsidyTypes?: InputMaybe<Array<OdProtosWebData_SubsidyType>>;
  subsidyAmountCents?: InputMaybe<Scalars['Float']['input']>;
  totalRepairCostCents?: InputMaybe<Scalars['Int']['input']>;
};

export enum OdProtosSupportData_CustomerType {
  CUSTOMER_TYPE_AGENT = 'CUSTOMER_TYPE_AGENT',
  CUSTOMER_TYPE_APPRAISER = 'CUSTOMER_TYPE_APPRAISER',
  CUSTOMER_TYPE_DIRECT_CUSTOMER = 'CUSTOMER_TYPE_DIRECT_CUSTOMER',
  CUSTOMER_TYPE_INSPECTOR = 'CUSTOMER_TYPE_INSPECTOR'
}

export enum OdProtosSupportData_DocumentType {
  ABAD = 'ABAD',
  CLOSING_DOCS = 'CLOSING_DOCS',
  EARNEST_MONEY_RECEIPT = 'EARNEST_MONEY_RECEIPT',
  FINAL_SETTLEMENT_STATEMENT = 'FINAL_SETTLEMENT_STATEMENT',
  OD_ADDENDUM = 'OD_ADDENDUM',
  PURCHASE_AGREEMENT = 'PURCHASE_AGREEMENT',
  TAX_CERTIFICATE = 'TAX_CERTIFICATE',
  TITLE_COMMITMENT = 'TITLE_COMMITMENT'
}

export enum OdProtosSupportData_EscalationType {
  FINAL_OFFER_STATUS = 'FINAL_OFFER_STATUS',
  OTHER_ESCALATION_REASON = 'OTHER_ESCALATION_REASON',
  REPAIR_LINE_ITEM_REVIEW = 'REPAIR_LINE_ITEM_REVIEW',
  /**
   * deprecated in favor of REPAIR_LINE_ITEM_REVIEW
   * @deprecated No longer supported
   */
  REPAIR_REVIEW = 'REPAIR_REVIEW',
  SECURITY_DEPOSIT_HOLDBACK = 'SECURITY_DEPOSIT_HOLDBACK'
}

export enum OdProtosSupportData_HoldbackReason {
  /** @deprecated No longer supported */
  DEBRIS_DAMAGE = 'DEBRIS_DAMAGE',
  HOLDBACK_OTHER = 'HOLDBACK_OTHER',
  HOME_DAMAGE = 'HOME_DAMAGE',
  /** @deprecated No longer supported */
  LCO_OVERSTAY = 'LCO_OVERSTAY'
}

export enum OdProtosSupportData_HomeInspectionRequestType {
  ACCESS_INSTRUCTIONS_UPDATE = 'ACCESS_INSTRUCTIONS_UPDATE',
  /** @deprecated No longer supported */
  DEBRIS_REVIEW = 'DEBRIS_REVIEW',
  DIGITAL_CHECKOUT_LOCKBOX_DROP_OFF = 'DIGITAL_CHECKOUT_LOCKBOX_DROP_OFF',
  /** @deprecated No longer supported */
  INSTALL_EXCLUSIVES_COMING_SOON_SIGNAGE = 'INSTALL_EXCLUSIVES_COMING_SOON_SIGNAGE',
  IN_PERSON_ASSESSMENT_OCCUPIED = 'IN_PERSON_ASSESSMENT_OCCUPIED',
  /** @deprecated No longer supported */
  IN_PERSON_ASSESSMENT_VACANT = 'IN_PERSON_ASSESSMENT_VACANT',
  /** @deprecated No longer supported */
  ONE_DAY_RESCHEDULE_REQUEST = 'ONE_DAY_RESCHEDULE_REQUEST',
  OTHER = 'OTHER',
  SPECIFIC_ASSESSMENT = 'SPECIFIC_ASSESSMENT'
}

/** Represents additional information needed for a Home Issues (Acquisition) ticket */
export type OdProtosSupportData_HomeIssuesAcquisitionInformationInput = {
  homeInspectionRequest?: InputMaybe<OdProtosSupportData_HomeInspectionRequestType>;
};

export type OdProtosSupportData_IdentityEscalationInformationInput = {
  buyerNameInContract?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerType?: InputMaybe<OdProtosSupportData_CustomerType>;
  frmmsQuestionsAsked?: InputMaybe<Scalars['Boolean']['input']>;
  informationSaved?: InputMaybe<Scalars['Boolean']['input']>;
  mlsMarketName?: InputMaybe<Scalars['String']['input']>;
  sellerTransactionId?: InputMaybe<Scalars['String']['input']>;
  vendorCompany?: InputMaybe<Scalars['String']['input']>;
  vendorType?: InputMaybe<OdProtosSupportData_VendorType>;
};

/** Represents additional information needed for an In Person VA Request (Acquisition) ticket */
export type OdProtosSupportData_InPersonVaRequestAcquisitionInformationInput = {
  isOccupied?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents additional information needed for a Market Ops Escalations ticket */
export type OdProtosSupportData_MarketOpsEscalationsInformationInput = {
  escalationType?: InputMaybe<OdProtosSupportData_EscalationType>;
  holdbackReason?: InputMaybe<OdProtosSupportData_HoldbackReason>;
  repairReviewType?: InputMaybe<OdProtosSupportData_RepairReviewType>;
};

/** TODO: Replace TransactionIdentifier with OriginatingRecordIdentifier */
export type OdProtosSupportData_OriginatingRecordIdentifierInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosSupportData_PartnershipType {
  AGENT = 'AGENT',
  HOMEBUILDER = 'HOMEBUILDER',
  NO_PARTNERSHIP = 'NO_PARTNERSHIP'
}

export enum OdProtosSupportData_RepairReviewType {
  ADDITION = 'ADDITION',
  COST_ADJUSTMENT = 'COST_ADJUSTMENT',
  REMOVAL = 'REMOVAL'
}

export enum OdProtosSupportData_SellerType {
  SELLER_TYPE_AGENT = 'SELLER_TYPE_AGENT',
  SELLER_TYPE_DIRECT_CUSTOMER = 'SELLER_TYPE_DIRECT_CUSTOMER'
}

export enum OdProtosSupportData_SolarCompanyFinancingStatus {
  FINANCED = 'FINANCED',
  LEASED = 'LEASED',
  OWNED = 'OWNED'
}

/** Represents additional information needed for a Solar Escalation Ticket */
export type OdProtosSupportData_SolarTicketInformationInput = {
  financingStatus?: InputMaybe<OdProtosSupportData_SolarCompanyFinancingStatus>;
  solarCompanyContactInformation?: InputMaybe<Scalars['String']['input']>;
};

/** next id: 52 */
export enum OdProtosSupportData_TicketForm {
  ACCESS_REQUESTS = 'ACCESS_REQUESTS',
  ACQUISITION_TC_COMMS = 'ACQUISITION_TC_COMMS',
  ACQUISITION_TE_TRANSACTION_COORDINATION = 'ACQUISITION_TE_TRANSACTION_COORDINATION',
  AEP_MANAGER_ESCALATIONS = 'AEP_MANAGER_ESCALATIONS',
  AEP_MANAGER_OWNED_COE_CHANGE_REQUEST = 'AEP_MANAGER_OWNED_COE_CHANGE_REQUEST',
  AEP_MANAGER_OWNED_CONTRACT_CANCELLATION_REQUEST = 'AEP_MANAGER_OWNED_CONTRACT_CANCELLATION_REQUEST',
  AEP_MANAGER_OWNED_OTHER_APPROVAL_REQUEST = 'AEP_MANAGER_OWNED_OTHER_APPROVAL_REQUEST',
  AEP_MANAGER_OWNED_SUBSIDY_CHANGE_REQUEST = 'AEP_MANAGER_OWNED_SUBSIDY_CHANGE_REQUEST',
  AGENT_BILLING = 'AGENT_BILLING',
  AGENT_OPS_AGENT = 'AGENT_OPS_AGENT',
  AGENT_OPS_CUSTOMER = 'AGENT_OPS_CUSTOMER',
  AGENT_RECRUITING_AND_ONBOARDING = 'AGENT_RECRUITING_AND_ONBOARDING',
  ALA_DECLARATION_ESCALATION = 'ALA_DECLARATION_ESCALATION',
  ASSESSMENT_FAILURE = 'ASSESSMENT_FAILURE',
  BRN_BUDGET_REVIEW = 'BRN_BUDGET_REVIEW',
  BRN_EXECUTION = 'BRN_EXECUTION',
  BROKER_REJECTION_OF_DOCUMENT = 'BROKER_REJECTION_OF_DOCUMENT',
  CEP_EMAIL = 'CEP_EMAIL',
  CEP_MANAGER_OWNED_COE_CHANGE_REQUEST = 'CEP_MANAGER_OWNED_COE_CHANGE_REQUEST',
  CEP_MANAGER_OWNED_OTHER_APPROVAL_REQUEST = 'CEP_MANAGER_OWNED_OTHER_APPROVAL_REQUEST',
  CEP_MANAGER_OWNED_SUBSIDY_CHANGE_REQUEST = 'CEP_MANAGER_OWNED_SUBSIDY_CHANGE_REQUEST',
  CEP_MANAGER_TO_XA_MANAGER_ESCALATIONS = 'CEP_MANAGER_TO_XA_MANAGER_ESCALATIONS',
  CONTRACT_CANCELLATION_REQUEST = 'CONTRACT_CANCELLATION_REQUEST',
  EXTERNAL_LISTINGS = 'EXTERNAL_LISTINGS',
  GENERAL_SUPPORT_TICKET = 'GENERAL_SUPPORT_TICKET',
  HOA = 'HOA',
  HOA_APPLICATIONS = 'HOA_APPLICATIONS',
  HOA_ASSESSMENTS = 'HOA_ASSESSMENTS',
  HOA_DEMAND = 'HOA_DEMAND',
  HOA_GENERAL_SUPPORT = 'HOA_GENERAL_SUPPORT',
  HOA_LITIGATIONS = 'HOA_LITIGATIONS',
  HOA_OTHERMISC = 'HOA_OTHERMISC',
  HOA_REQUEST_NON_VIOLATION = 'HOA_REQUEST_NON_VIOLATION',
  HOA_VIOLATIONS = 'HOA_VIOLATIONS',
  HOC_SUPPORT_EMAIL = 'HOC_SUPPORT_EMAIL',
  HOME_ISSUES_ACQUISITION = 'HOME_ISSUES_ACQUISITION',
  HOME_ISSUES_RESALE = 'HOME_ISSUES_RESALE',
  HOME_MAINTENANCE = 'HOME_MAINTENANCE',
  HQI_FEEDBACK = 'HQI_FEEDBACK',
  IDENTITY_ESCALATION_ACCOUNT_MERGE = 'IDENTITY_ESCALATION_ACCOUNT_MERGE',
  IDENTITY_ESCALATION_AGENT = 'IDENTITY_ESCALATION_AGENT',
  IDENTITY_ESCALATION_DIRECT_CUSTOMER = 'IDENTITY_ESCALATION_DIRECT_CUSTOMER',
  IDENTITY_ESCALATION_SELLER = 'IDENTITY_ESCALATION_SELLER',
  IDENTITY_ESCALATION_VENDOR = 'IDENTITY_ESCALATION_VENDOR',
  IN_PERSON_VA_REQUEST_ACQUISITION = 'IN_PERSON_VA_REQUEST_ACQUISITION',
  MARKET_OPS_ESCALATIONS = 'MARKET_OPS_ESCALATIONS',
  REPAIR_ADJUSTMENT_REQUEST = 'REPAIR_ADJUSTMENT_REQUEST',
  RESALE_EP_EMAIL = 'RESALE_EP_EMAIL',
  RESALE_TE_TRANSACTION_COORDINATION = 'RESALE_TE_TRANSACTION_COORDINATION',
  SEPTIC_INSPECTION_REVIEW = 'SEPTIC_INSPECTION_REVIEW',
  SOLAR_ESCALATION_ACQUISITION = 'SOLAR_ESCALATION_ACQUISITION',
  SOLAR_ESCALATION_RESALE = 'SOLAR_ESCALATION_RESALE',
  SOLAR_TRANSACTION_COORDINATION = 'SOLAR_TRANSACTION_COORDINATION',
  UNKNOWN_FORM = 'UNKNOWN_FORM',
  VISITOR_CAMPAIGN = 'VISITOR_CAMPAIGN',
  XA_MANAGER_TO_CEP_MANAGER_ESCALATIONS = 'XA_MANAGER_TO_CEP_MANAGER_ESCALATIONS',
  XA_TO_ACQ_EP_ESCALATION = 'XA_TO_ACQ_EP_ESCALATION',
  XA_TO_RESALE_EP_ESCALATION = 'XA_TO_RESALE_EP_ESCALATION'
}

export enum OdProtosSupportData_TicketPriority {
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  UNKNOWN_PRIORITY = 'UNKNOWN_PRIORITY',
  URGENT = 'URGENT'
}

export enum OdProtosSupportData_TicketStatus {
  CLOSED = 'CLOSED',
  HOLD = 'HOLD',
  NEW = 'NEW',
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  SOLVED = 'SOLVED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosSupportData_TransactionIdentifierInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosSupportData_TransactionIdentifier_Type>;
};

export enum OdProtosSupportData_TransactionIdentifier_Type {
  LISTING_OFFER = 'LISTING_OFFER',
  OFFER = 'OFFER'
}

export enum OdProtosSupportData_VendorType {
  VENDOR_TYPE_APPRAISER = 'VENDOR_TYPE_APPRAISER',
  VENDOR_TYPE_INSPECTOR = 'VENDOR_TYPE_INSPECTOR'
}

export type OdProtosSupportServices_AddCommentToTicketRequestInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  author?: InputMaybe<OdProtosSupportServices_AddCommentToTicketRequest_AuthorOneofInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<OdProtosSupportServices_AddCommentToTicketRequest_IdentifierOneofInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosSupportServices_AddCommentToTicketRequest_AuthorOneofInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportServices_AddCommentToTicketRequest_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosSupportServices_AssignTicketRequestInput = {
  identifier?: InputMaybe<OdProtosSupportServices_AssignTicketRequest_IdentifierOneofInput>;
  ticketId?: InputMaybe<Scalars['String']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportServices_AssignTicketRequest_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosSupportServices_AssociateRecordToTicketRequestInput = {
  /**
   * This comment will be pushed to Zendesk after the
   * object is associated with the ticket
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<OdProtosSupportServices_AssociateRecordToTicketRequest_IdentifierOneofInput>;
  record?: InputMaybe<OdProtosSupportData_AssociatedRecordInput>;
  ticketId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportServices_AssociateRecordToTicketRequest_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']['input']>;
};

/** next id: 27 */
export type OdProtosSupportServices_CreateTicketRequestInput = {
  /**
   * Optional: Adds tags to the ticket. Some tickets have default tags
   * this will append to that default tag list.
   */
  addTags?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalTicketFields?: InputMaybe<OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneofInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  assigneeToken?: InputMaybe<Scalars['String']['input']>;
  attachmentAssets?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  forceInitialCommentPublic?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<OdProtosSupportData_TicketForm>;
  /** when non-empty, this will override the "description" field with an HTML-formatted ticket comment */
  htmlDescription?: InputMaybe<Scalars['String']['input']>;
  originatingRecord?: InputMaybe<OdProtosSupportData_OriginatingRecordIdentifierInput>;
  priority?: InputMaybe<OdProtosSupportData_TicketPriority>;
  requester?: InputMaybe<OdProtosSupportServices_CreateTicketRequest_RequesterOneofInput>;
  status?: InputMaybe<OdProtosSupportData_TicketStatus>;
  /** Optional: This overrides the default subject for all ticket forms */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** only use external email addresses here - opendoor addresses will be ignored */
  ticketCcEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneofInput = {
  assessmentFailureFields?: InputMaybe<OdProtosSupportData_AssessmentFailureInformationInput>;
  brokerRejectionOfDocumentFields?: InputMaybe<OdProtosSupportData_BrokerRejectionOfDocumentInformationInput>;
  contractChangeFields?: InputMaybe<OdProtosSupportData_ContractChangeInformationInput>;
  homeIssuesAcquisitionFields?: InputMaybe<OdProtosSupportData_HomeIssuesAcquisitionInformationInput>;
  identityEscalationFields?: InputMaybe<OdProtosSupportData_IdentityEscalationInformationInput>;
  inPersonVaRequestAcquisitionFields?: InputMaybe<OdProtosSupportData_InPersonVaRequestAcquisitionInformationInput>;
  marketOpsEscalationsFields?: InputMaybe<OdProtosSupportData_MarketOpsEscalationsInformationInput>;
  solarTicketFields?: InputMaybe<OdProtosSupportData_SolarTicketInformationInput>;
};

export type OdProtosSupportServices_CreateTicketRequest_RequesterOneofInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  requesterEmail?: InputMaybe<Scalars['String']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportServices_DisassociateRecordFromTicketRequestInput = {
  /**
   * This comment will be pushed to Zendesk after the
   * object is disassociated with the ticket
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<OdProtosSupportServices_DisassociateRecordFromTicketRequest_IdentifierOneofInput>;
  record?: InputMaybe<OdProtosSupportData_AssociatedRecordInput>;
  ticketId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportServices_DisassociateRecordFromTicketRequest_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosSupportServices_GetTicketRequestInput = {
  ticketId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosSupportServices_PageParamsInput = {
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** max page size is 1000 */
  size?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * These fields are AND'd when searching.
 * Pagination is currently not currently needed since there are only
 * a handful of tasks per transaction, home, customer, and even assignee.
 */
export type OdProtosSupportServices_SearchTicketsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  assigneeUserToken?: InputMaybe<Scalars['String']['input']>;
  associatedRecord?: InputMaybe<OdProtosSupportData_AssociatedRecordInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  originatingRecord?: InputMaybe<OdProtosSupportData_OriginatingRecordIdentifierInput>;
  page?: InputMaybe<OdProtosSupportServices_PageParamsInput>;
  sortBy?: InputMaybe<OdProtosSupportServices_SortByInput>;
  /** Deprecated: use ticket_forms instead */
  ticketForm?: InputMaybe<OdProtosSupportData_TicketForm>;
  ticketForms?: InputMaybe<Array<OdProtosSupportData_TicketForm>>;
  ticketPriority?: InputMaybe<OdProtosSupportData_TicketPriority>;
  /** Deprecated: use ticket_statuses instead */
  ticketStatus?: InputMaybe<OdProtosSupportData_TicketStatus>;
  ticketStatuses?: InputMaybe<Array<OdProtosSupportData_TicketStatus>>;
  /** deprecating in favor of using originating_record which allows us to query on more than offer and listing offer types */
  transactionId?: InputMaybe<OdProtosSupportData_TransactionIdentifierInput>;
};

export type OdProtosSupportServices_SetTicketStatusRequestInput = {
  ticketId?: InputMaybe<Scalars['String']['input']>;
  ticketStatus?: InputMaybe<OdProtosSupportData_TicketStatus>;
};

export enum OdProtosSupportServices_SortByFields {
  CREATED_AT = 'CREATED_AT',
  PRIORITY = 'PRIORITY',
  STATUS = 'STATUS'
}

export type OdProtosSupportServices_SortByInput = {
  /** Descending order if true. Default is ascending */
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  /** defaults to sorting by created_at */
  field?: InputMaybe<OdProtosSupportServices_SortByFields>;
};

export type OdProtosSupportServices_UpdateOriginatingRecordForTicketRequestInput = {
  originatingRecord?: InputMaybe<OdProtosSupportData_OriginatingRecordIdentifierInput>;
  ticketIdentifier?: InputMaybe<OdProtosSupportServices_UpdateOriginatingRecordForTicketRequest_TicketIdentifierOneofInput>;
};

export type OdProtosSupportServices_UpdateOriginatingRecordForTicketRequest_TicketIdentifierOneofInput = {
  /** TODO: build functionality for ticket UUID support */
  zendeskTicketId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosTangoData_ActionType {
  CANCEL_APPOINTMENTS_ACTION = 'CANCEL_APPOINTMENTS_ACTION',
  HPM_VISIT_ACTION = 'HPM_VISIT_ACTION',
  HQI_FEEDBACK_ACTION = 'HQI_FEEDBACK_ACTION',
  INVESTIGATE_ACTION = 'INVESTIGATE_ACTION',
  PROTECT_ACTION = 'PROTECT_ACTION',
  SERVICE_REQUEST_ACTION = 'SERVICE_REQUEST_ACTION',
  UNKNOWN_ACTION = 'UNKNOWN_ACTION',
  WORK_ORDER_ACTION = 'WORK_ORDER_ACTION'
}

export type OdProtosTangoData_AreasDamagedInput = {
  list?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosTangoData_CustomerInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTangoData_CustomersInput = {
  list?: InputMaybe<Array<OdProtosTangoData_CustomerInput>>;
};

export type OdProtosTangoData_IncidentReportUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  patrolDispatched?: InputMaybe<Scalars['Boolean']['input']>;
  reporterContact?: InputMaybe<Scalars['String']['input']>;
  reporterEmail?: InputMaybe<Scalars['String']['input']>;
  reporterName?: InputMaybe<Scalars['String']['input']>;
  reporterPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  reporterRole?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  submitterId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Used to perform partial updates of investigations
 *
 * Null values will not be updated
 */
export type OdProtosTangoData_InvestigationUpdateInput = {
  addedToSecurityRoute?: InputMaybe<Scalars['Boolean']['input']>;
  areasDamaged?: InputMaybe<OdProtosTangoData_AreasDamagedInput>;
  attributedCustomers?: InputMaybe<OdProtosTangoData_CustomersInput>;
  estimatedCostCents?: InputMaybe<Scalars['Float']['input']>;
  modeOfEntry?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  occurred?: InputMaybe<OdProtosTangoData_OccurredInput>;
  reportedHardwareIssues?: InputMaybe<OdProtosTangoData_ReportedHardwareIssuesInput>;
  securityRouteDurationDays?: InputMaybe<Scalars['Float']['input']>;
  securityRouteStart?: InputMaybe<OdProtosTangoData_SecurityRouteStartInput>;
  tags?: InputMaybe<OdProtosTangoData_TagsInput>;
  tier?: InputMaybe<OdProtosTangoData_TierInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** An object which represents an incident report to be created */
export type OdProtosTangoData_NewIncidentReportInput = {
  /** Any descriptive information which might be useful during investigation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Which flip the incident occurred at */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /** If a patrol was dispatched due to this report */
  patrolDispatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** How to contact the reporter */
  reporterContact?: InputMaybe<Scalars['String']['input']>;
  /** The reporter's email address */
  reporterEmail?: InputMaybe<Scalars['String']['input']>;
  /** Who reported the incident */
  reporterName?: InputMaybe<Scalars['String']['input']>;
  /** The reporter's phone number */
  reporterPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** What role the reporter has in relation to Opendoor */
  reporterRole?: InputMaybe<Scalars['String']['input']>;
  /** A string tag indicating the kind of source for the report */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Which human is submitting the report */
  submitterId?: InputMaybe<Scalars['String']['input']>;
  /** A set of tags representing what kind of incident(s) occurred */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosTangoData_OccurredInput = {
  value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosTangoData_ReportedHardwareIssuesInput = {
  list?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Information about what caused the current home access restriction */
export type OdProtosTangoData_RestrictionCauseInput = {
  /** If the cause was an incident, the corresponding incident report token */
  incidentReportToken?: InputMaybe<Scalars['String']['input']>;
  /** If the cause was an operator, this is their human token */
  operatorToken?: InputMaybe<Scalars['String']['input']>;
  /** A stringly-typed reason for the restriction */
  trigger?: InputMaybe<OdProtosTangoData_RestrictionTrigger>;
};

/** An enumeration which describes the currently allowed access to the home */
export enum OdProtosTangoData_RestrictionLevel {
  /** No special restrictions */
  NO_RESTRICTION = 'NO_RESTRICTION',
  /** Property Protection Mode, more stringent checks required to tour */
  PROTECTED = 'PROTECTED',
  /** Restricted Home Access mode, no customers allowed to tour */
  RESTRICTED = 'RESTRICTED',
  /** Unknown/uninitialized value */
  UNKNOWN_RESTRICTION = 'UNKNOWN_RESTRICTION'
}

export enum OdProtosTangoData_RestrictionTrigger {
  /** This state was set during a backfill */
  BACKFILL_TRIGGER = 'BACKFILL_TRIGGER',
  /** This restriction was triggered by a filed incident */
  INCIDENT_TRIGGER = 'INCIDENT_TRIGGER',
  /** An operator set this state */
  OPERATOR_TRIGGER = 'OPERATOR_TRIGGER',
  /** It is unknown what triggered this restriction */
  UNKNOWN_TRIGGER = 'UNKNOWN_TRIGGER'
}

export type OdProtosTangoData_SecurityRouteStartInput = {
  value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosTangoData_TagsInput = {
  list?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosTangoData_TierInput = {
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosTangoServices_ClearHomeAccessRestrictionRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTangoServices_GetHomeAccessRestrictionRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTangoServices_GetIncidentReportInvestigationRequestInput = {
  /** The incident report token for the related investigation */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTangoServices_GetIncidentReportRequestInput = {
  includeInvestigation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The incident report token for the incident to retrieve */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTangoServices_ListActionsByIncidentReportRequestInput = {
  /** The incident report token for the incident actions to retrieve */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTangoServices_ListIncidentReportsByAddressRequestInput = {
  /** The address to retrieve incident reports for */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  includeInvestigations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosTangoServices_ListIncidentReportsByCustomerRequestInput = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  includeInvestigations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosTangoServices_ListIncidentReportsByFlipRequestInput = {
  /** The flip token to retrieve incident reports for */
  flipToken?: InputMaybe<Scalars['String']['input']>;
  includeInvestigations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosTangoServices_ListIncidentReportsRequestInput = {
  includeInvestigations?: InputMaybe<Scalars['Boolean']['input']>;
  /** The tokens to retrieve incident reports for */
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosTangoServices_ReportIncidentRequestInput = {
  includeActions?: InputMaybe<Scalars['Boolean']['input']>;
  includeInvestigation?: InputMaybe<Scalars['Boolean']['input']>;
  report?: InputMaybe<OdProtosTangoData_NewIncidentReportInput>;
};

export type OdProtosTangoServices_RestrictHomeAccessRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  cause?: InputMaybe<OdProtosTangoData_RestrictionCauseInput>;
  restriction?: InputMaybe<OdProtosTangoData_RestrictionLevel>;
};

export type OdProtosTangoServices_UpdateIncidentReportRequestInput = {
  includeInvestigation?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OdProtosTangoData_IncidentReportUpdateInput>;
};

export type OdProtosTangoServices_UpdateInvestigationRequestInput = {
  update?: InputMaybe<OdProtosTangoData_InvestigationUpdateInput>;
};

export type OdProtosTestingBasic_SimpleRequestInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  enum?: InputMaybe<OdProtosTestingBasic_SimpleRequest_Enum>;
  list?: InputMaybe<Array<Scalars['String']['input']>>;
  listNested?: InputMaybe<Array<OdProtosTestingBasic_SimpleRequest_NestedInput>>;
  nested?: InputMaybe<OdProtosTestingBasic_SimpleRequest_NestedInput>;
  string?: InputMaybe<Scalars['String']['input']>;
  struct?: InputMaybe<GoogleProtobuf_StructInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosTestingBasic_SimpleRequest_Enum {
  DEFAULT = 'DEFAULT',
  FIRST = 'FIRST'
}

export type OdProtosTestingBasic_SimpleRequest_NestedInput = {
  string?: InputMaybe<Scalars['String']['input']>;
};

/** State indicates the current state of a ThirdPartyMarketplaceListing */
export enum OdProtosThirdPartyMarketplaceListingData_State {
  /**
   * The seller has a buyer committed to purchase the property.
   * @deprecated No longer supported
   */
  COMMITTED_BUYER = 'COMMITTED_BUYER',
  /**
   * The ThirdPartyMarketplaceListing lifecycle has been created and the
   * seller is enrolled in the program, however it is in a holding state
   * because we haven't received confirmation that the seller wants to
   * proceed yet.
   * @deprecated No longer supported
   */
  PENDING_COMMITMENT = 'PENDING_COMMITMENT',
  /**
   * The seller has confirmed that they want to proceed with the
   * ThirdPartyMarketplaceListing program, and the property is now being
   * prepared for sale.
   * @deprecated No longer supported
   */
  PREPARING = 'PREPARING',
  /**
   * The property may now be sold, and all ThirdPartyMarketplaceListing
   * preparation has been completed. Any active channels may expose the
   * property as for sale.
   * @deprecated No longer supported
   */
  SELLABLE = 'SELLABLE',
  /**
   * The ThirdPartyMarketplaceListing lifecycle has been terminated,
   * typically because the property has been sold.
   * @deprecated No longer supported
   */
  TERMINATED = 'TERMINATED',
  /** @deprecated No longer supported */
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/**
 * TerminationReason indicates the reason a ThirdPartyMarketplaceListing
 * entity was terminated
 */
export enum OdProtosThirdPartyMarketplaceListingData_TerminationReason {
  /**
   * The ThirdPartyMarketplaceListing was canceled by the seller
   * @deprecated No longer supported
   */
  SALE_CANCELED = 'SALE_CANCELED',
  /**
   * Home has been sold
   * @deprecated No longer supported
   */
  SOLD = 'SOLD',
  /** @deprecated No longer supported */
  UNKNOWN_TERMINATION_REASON = 'UNKNOWN_TERMINATION_REASON'
}

/** Next ID: 6 */
export type OdProtosTodoData_ItemInput = {
  /** When the item was first created. */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The long form contents of the todo item. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Primary identifier for the item. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The short form title for the item. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** When the item was last updated. */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_CreateItemRequestInput = {
  item?: InputMaybe<OdProtosTodoData_ItemInput>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_DeleteItemRequestInput = {
  itemId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_GetItemRequestInput = {
  itemId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_ListItemsRequestInput = {
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_UpdateItemRequestInput = {
  item?: InputMaybe<OdProtosTodoData_ItemInput>;
};

export type OdProtosTrippyData_CancellationReasonInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  structuredReasons?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 3 */
export type OdProtosTrippyData_VisitOrderingInput = {
  column?: InputMaybe<OdProtosTrippyData_VisitOrdering_Column>;
  isDescending?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next ID: 13 */
export enum OdProtosTrippyData_VisitOrdering_Column {
  ADDRESS_ID = 'ADDRESS_ID',
  ASSIGNED_ORGANIZATION_ID = 'ASSIGNED_ORGANIZATION_ID',
  ASSIGNED_USER_TOKEN = 'ASSIGNED_USER_TOKEN',
  CANCELLED_AT = 'CANCELLED_AT',
  CHECK_IN_AT = 'CHECK_IN_AT',
  CHECK_OUT_AT = 'CHECK_OUT_AT',
  CREATED_AT = 'CREATED_AT',
  DUE_BY = 'DUE_BY',
  SCHEDULE_START_AT = 'SCHEDULE_START_AT',
  SCHEDULE_STOP_AT = 'SCHEDULE_STOP_AT',
  UPDATED_AT = 'UPDATED_AT',
  VISIT_TYPE_ID = 'VISIT_TYPE_ID'
}

export enum OdProtosTrippyData_VisitStatus {
  VISIT_STATUS_CANCELLED = 'VISIT_STATUS_CANCELLED',
  VISIT_STATUS_COMPLETED = 'VISIT_STATUS_COMPLETED',
  VISIT_STATUS_CONFIRMED = 'VISIT_STATUS_CONFIRMED',
  VISIT_STATUS_UNSPECIFIED = 'VISIT_STATUS_UNSPECIFIED',
  VISIT_STATUS_UPCOMING = 'VISIT_STATUS_UPCOMING'
}

export type OdProtosTrippyServices_BackfillEnrollmentsRequestInput = {
  domainId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosTrippyServices_CancelVisitRequestInput = {
  cancellationReason?: InputMaybe<OdProtosTrippyData_CancellationReasonInput>;
  cancellationSource?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrippyServices_ChangeAddressRequestInput = {
  enrollmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  newAddressId?: InputMaybe<Scalars['String']['input']>;
  oldAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrippyServices_CheckIntoVisitRequestInput = {
  checkInTime?: InputMaybe<Scalars['DateTime']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrippyServices_CheckOutFromVisitRequestInput = {
  checkOutTime?: InputMaybe<Scalars['DateTime']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrippyServices_CreateDomainRequestInput = {
  /** Name of the domain */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization who will own this entity */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** RFC 4122 compliant UUID to enforce idempotence */
  requestToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 23 */
export type OdProtosTrippyServices_CreateVisitRequestInput = {
  /** required */
  addressId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated */
  assignedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  /** Leave blank to use new assigned_organization_token field */
  assignedOrganizationToken?: InputMaybe<Scalars['String']['input']>;
  /** Must have at least one: assigned_user_token or assigned_organization_token */
  assignedUserToken?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkInAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdByOrganizationId?: InputMaybe<Scalars['String']['input']>;
  dueBy?: InputMaybe<Scalars['DateTime']['input']>;
  /** optional */
  enrollmentId?: InputMaybe<Scalars['String']['input']>;
  followupTime?: InputMaybe<Scalars['DateTime']['input']>;
  isScheduleSlotBased?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** RFC 4122 compliant UUID to enforce idempotence */
  requestToken?: InputMaybe<Scalars['String']['input']>;
  /** required */
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  upcomingTime?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** required */
  visitTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrippyServices_CreateVisitTypeRequestInput = {
  /** ID of the domain this entity will belong to */
  domainId?: InputMaybe<Scalars['String']['input']>;
  /** Label for the visit type */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for this request to enforce idempotence */
  requestToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrippyServices_GetDomainsRequestInput = {
  /** ID of the domain */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of the domain */
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosTrippyServices_GetVisitTypesRequestInput = {
  /** ID of the domain to filter by */
  domainId?: InputMaybe<Scalars['String']['input']>;
  /** label of the visit type to filter by */
  label?: InputMaybe<Scalars['String']['input']>;
  /** ID of the visit type */
  visitTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosTrippyServices_GetVisitsRequestInput = {
  assignedUserToken?: InputMaybe<Scalars['String']['input']>;
  visitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosTrippyServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrippyServices_RejectVisitRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 21 */
export type OdProtosTrippyServices_SearchVisitsRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedUserTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  cancelledAt?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  checkInAt?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  checkOutAt?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  createdAtRange?: InputMaybe<OdProtosTrippyServices_TimestampRangeInput>;
  createdByOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * domain_ids filters out visits that have a visit type that belongs to one of the
   * specified domains. It will be ignored if visit_type_ids is set.
   */
  domainIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dueBy?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  enrollmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  ordering?: InputMaybe<Array<OdProtosTrippyData_VisitOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  scheduledStartAtRange?: InputMaybe<OdProtosTrippyServices_TimestampRangeInput>;
  /** Optional timestamp fields that can be unset have TimestampParams */
  scheduledStopAt?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  updatedAtRange?: InputMaybe<OdProtosTrippyServices_TimestampRangeInput>;
  visitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visitTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosTrippyServices_TimestampParamInput = {
  params?: InputMaybe<OdProtosTrippyServices_TimestampParam_ParamsOneofInput>;
};

export type OdProtosTrippyServices_TimestampParam_ParamsOneofInput = {
  timeRange?: InputMaybe<OdProtosTrippyServices_TimestampRangeInput>;
  /** Filter visits solely by whether this time field is set (to anything) or not */
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosTrippyServices_TimestampRangeInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** If start and end are both null, this will not apply any filtering and will return both set and unset values. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Next ID: 18 */
export type OdProtosTrippyServices_UpdateVisitRequestInput = {
  assignedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  assignedUserToken?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<OdProtosTrippyData_CancellationReasonInput>;
  cancellationSource?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueBy?: InputMaybe<Scalars['DateTime']['input']>;
  followupTime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']['input']>;
  unsetCancelledAt?: InputMaybe<Scalars['Boolean']['input']>;
  unsetConfirmedAt?: InputMaybe<Scalars['Boolean']['input']>;
  upcomingTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosTrustData_CreateIdentityReviewInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  identityReviewType?: InputMaybe<Array<OdProtosTrustData_IdentityReviewType>>;
};

export enum OdProtosTrustData_FalsePositive {
  NEEDS_FURTHER_REVIEW = 'NEEDS_FURTHER_REVIEW',
  NO = 'NO',
  YES = 'YES'
}

export enum OdProtosTrustData_HomeAccessStatus {
  ALLOW = 'ALLOW',
  DENY = 'DENY',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  REQUIRES_VERIFICATION = 'REQUIRES_VERIFICATION',
  UNDEFINED = 'UNDEFINED',
  UNRESTRICTED = 'UNRESTRICTED'
}

export enum OdProtosTrustData_IdVerificationAttempt_IdType {
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  STATE_ID = 'STATE_ID',
  UNKNOWN_ID_TYPE = 'UNKNOWN_ID_TYPE'
}

export enum OdProtosTrustData_IdVerificationAttempt_Result {
  /** The service provider was unable to process the ID, likely because of image quality */
  COULD_NOT_PROCESS = 'COULD_NOT_PROCESS',
  /** The ID was expired */
  FAILED_EXPIRED = 'FAILED_EXPIRED',
  /** e.g. the front was a passport and the back was from a driver's license */
  FAILED_INCONSISTENT = 'FAILED_INCONSISTENT',
  /** The ID verification did not include date of birth */
  FAILED_MISSING_DOB = 'FAILED_MISSING_DOB',
  /** The name on the ID does not match the expected name */
  FAILED_NAME_MISMATCHING = 'FAILED_NAME_MISMATCHING',
  /** The ID has been used for verification too many times */
  FAILED_RETRY_THRESHOLD = 'FAILED_RETRY_THRESHOLD',
  FAILED_SELFIE_FACE_MISMATCH = 'FAILED_SELFIE_FACE_MISMATCH',
  FAILED_SELFIE_MANIPULATED = 'FAILED_SELFIE_MANIPULATED',
  /** Stripe selfie-specific failures */
  FAILED_SELFIE_MISSING_PHOTO = 'FAILED_SELFIE_MISSING_PHOTO',
  FAILED_SELFIE_UNVERIFIED = 'FAILED_SELFIE_UNVERIFIED',
  /** The ID belongs to a minor */
  FAILED_UNDERAGE = 'FAILED_UNDERAGE',
  /** Opendoor doesn't support that type of ID */
  FAILED_UNSUPPORTED_ID_TYPE = 'FAILED_UNSUPPORTED_ID_TYPE',
  /** The service provider processed the ID and it failed verification */
  FAILED_VERIFICATION = 'FAILED_VERIFICATION',
  /** The service provider processed the ID and the ID was verified */
  ID_VERIFIED = 'ID_VERIFIED',
  UNKNOWN_RESULT = 'UNKNOWN_RESULT'
}

/** The status of our request to a 3rd party to verify an ID */
export enum OdProtosTrustData_IdVerificationAttempt_Status {
  API_ERROR = 'API_ERROR',
  ATTEMPTED = 'ATTEMPTED',
  COMPLETE = 'COMPLETE',
  TIMED_OUT = 'TIMED_OUT',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export enum OdProtosTrustData_IdentityReviewTask_IdentityReviewType {
  ACCESS_CHANGE_REVIEW = 'ACCESS_CHANGE_REVIEW',
  DEVICE_OVERLAP_REVIEW = 'DEVICE_OVERLAP_REVIEW',
  DEVICE_SCORE_REVIEW = 'DEVICE_SCORE_REVIEW',
  DUPLICATE_PHONE_REVIEW = 'DUPLICATE_PHONE_REVIEW',
  EMAIL_FIRST_SEEN_REVIEW = 'EMAIL_FIRST_SEEN_REVIEW',
  IDV_REVIEW = 'IDV_REVIEW',
  IP_ADDRESS_AT_UNLOCK_REVIEW = 'IP_ADDRESS_AT_UNLOCK_REVIEW',
  MISSING_CUSTOMER_INFO_REVIEW = 'MISSING_CUSTOMER_INFO_REVIEW',
  REPORT_FRAUD_REVIEW = 'REPORT_FRAUD_REVIEW',
  REQUIRES_VERIFICATION_REVIEW = 'REQUIRES_VERIFICATION_REVIEW',
  RISKY_SIGNAL_REVIEW = 'RISKY_SIGNAL_REVIEW',
  SELLER_REVIEW = 'SELLER_REVIEW',
  SHOWING_TIME_CUSTOMER_REVIEW = 'SHOWING_TIME_CUSTOMER_REVIEW',
  SMS_UNSUBSCRIBE_REVIEW = 'SMS_UNSUBSCRIBE_REVIEW',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosTrustData_IdentityReviewType {
  ACCESS_CHANGE_REVIEW = 'ACCESS_CHANGE_REVIEW',
  DEVICE_OVERLAP_REVIEW = 'DEVICE_OVERLAP_REVIEW',
  DEVICE_SCORE_REVIEW = 'DEVICE_SCORE_REVIEW',
  DUPLICATE_PHONE_REVIEW = 'DUPLICATE_PHONE_REVIEW',
  EMAIL_FIRST_SEEN_REVIEW = 'EMAIL_FIRST_SEEN_REVIEW',
  IDV_REVIEW = 'IDV_REVIEW',
  IP_ADDRESS_AT_UNLOCK_REVIEW = 'IP_ADDRESS_AT_UNLOCK_REVIEW',
  MISSING_CUSTOMER_INFO_REVIEW = 'MISSING_CUSTOMER_INFO_REVIEW',
  REPORT_FRAUD_REVIEW = 'REPORT_FRAUD_REVIEW',
  REQUIRES_VERIFICATION_REVIEW = 'REQUIRES_VERIFICATION_REVIEW',
  RISKY_SIGNAL_REVIEW = 'RISKY_SIGNAL_REVIEW',
  SELLER_REVIEW = 'SELLER_REVIEW',
  SHOWING_TIME_CUSTOMER_REVIEW = 'SHOWING_TIME_CUSTOMER_REVIEW',
  SMS_UNSUBSCRIBE_REVIEW = 'SMS_UNSUBSCRIBE_REVIEW',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosTrustData_ReviewStatus {
  REQUESTED = 'REQUESTED',
  REVIEW_CANCELLED_BY_SYSTEM = 'REVIEW_CANCELLED_BY_SYSTEM',
  REVIEW_COMPLETED = 'REVIEW_COMPLETED',
  UNDER_REVIEW = 'UNDER_REVIEW'
}

/** Reason buckets */
export enum OdProtosTrustData_RiskAssessmentResult_Reason {
  BLOCK_FIXED_IP_ORG = 'BLOCK_FIXED_IP_ORG',
  BLOCK_NON_US_TRUE_IP_GEO = 'BLOCK_NON_US_TRUE_IP_GEO',
  CROSS_MARKET_UNLOCKS = 'CROSS_MARKET_UNLOCKS',
  CROSS_MARKET_UNLOCKS_BY_AGENT = 'CROSS_MARKET_UNLOCKS_BY_AGENT',
  DENIED_AGENT = 'DENIED_AGENT',
  DENY_DEVICE_ID = 'DENY_DEVICE_ID',
  DUPLICATE_PHONE_NUMBER_ALREADY_DENIED = 'DUPLICATE_PHONE_NUMBER_ALREADY_DENIED',
  EKATA_DIR_BUYER_COMMERCIAL_ADDRESS = 'EKATA_DIR_BUYER_COMMERCIAL_ADDRESS',
  EKATA_HIGH_IDENTITY_CHECK_SCORE = 'EKATA_HIGH_IDENTITY_CHECK_SCORE',
  EKATA_INVALID_EMAIL_ADDRESS = 'EKATA_INVALID_EMAIL_ADDRESS',
  EKATA_INVALID_PHONE_NUMBER = 'EKATA_INVALID_PHONE_NUMBER',
  EKATA_TRUSTED = 'EKATA_TRUSTED',
  EMAIL_WITH_BAD_IDENTITY_SCORE = 'EMAIL_WITH_BAD_IDENTITY_SCORE',
  EXCEEDED_OFFER_REQUESTS = 'EXCEEDED_OFFER_REQUESTS',
  FAILED_ID_VERIFICATION = 'FAILED_ID_VERIFICATION',
  FULLY_VERIFIED_AGENT = 'FULLY_VERIFIED_AGENT',
  HAS_ANONYMOUS_PREPAID_PHONE_TYPE = 'HAS_ANONYMOUS_PREPAID_PHONE_TYPE',
  HAS_BLACKLISTED_CARRIER = 'HAS_BLACKLISTED_CARRIER',
  HAS_HIGH_RISKSCORE = 'HAS_HIGH_RISKSCORE',
  HAS_HIGH_RISK_EMAIL_DOMAIN = 'HAS_HIGH_RISK_EMAIL_DOMAIN',
  HAS_INVALID_PHONE_NUMBER = 'HAS_INVALID_PHONE_NUMBER',
  HAS_OLD_PROFILE = 'HAS_OLD_PROFILE',
  HAS_REPEATED_VISITS_TO_SAME_HOME = 'HAS_REPEATED_VISITS_TO_SAME_HOME',
  HAS_RISKY_PHONE_TYPE = 'HAS_RISKY_PHONE_TYPE',
  IDV_RETRY_THRESHOLD = 'IDV_RETRY_THRESHOLD',
  INVALID_NAME = 'INVALID_NAME',
  MANUAL_VERIFICATION = 'MANUAL_VERIFICATION',
  NO_PHONE_NUMBER = 'NO_PHONE_NUMBER',
  OFF_HOUR_UNLOCK_REQUEST = 'OFF_HOUR_UNLOCK_REQUEST',
  OPENDOOR_INTERNAL_USER = 'OPENDOOR_INTERNAL_USER',
  PASSED_ID_VERIFICATION = 'PASSED_ID_VERIFICATION',
  PASSED_RISKASSESSMENT = 'PASSED_RISKASSESSMENT',
  RECENT_EMAIL_WITH_BAD_IDENTITY_SCORE = 'RECENT_EMAIL_WITH_BAD_IDENTITY_SCORE',
  REQUIRES_VERIFICATION_AGENT = 'REQUIRES_VERIFICATION_AGENT',
  SAME_MARKET_UNLOCK_WITHIN_SHORT_PERIOD = 'SAME_MARKET_UNLOCK_WITHIN_SHORT_PERIOD',
  TRUE_IP_ROUTING_TYPE = 'TRUE_IP_ROUTING_TYPE',
  TRUST_CHANGED_VIA_SMS = 'TRUST_CHANGED_VIA_SMS',
  UNKNOWN_REASON = 'UNKNOWN_REASON',
  UNVERIFIED_AGENT = 'UNVERIFIED_AGENT',
  VERIFIED_AGENT = 'VERIFIED_AGENT',
  VISITED_SPREAD_PRICED_HOMES = 'VISITED_SPREAD_PRICED_HOMES'
}

export enum OdProtosTrustData_RiskAssessmentResult_RuleSet {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

/** Result of user risk assessment */
export enum OdProtosTrustData_RiskAssessmentResult_TrustLevel {
  ALLOW = 'ALLOW',
  /** @deprecated No longer supported */
  BLACKLISTED = 'BLACKLISTED',
  DENY = 'DENY',
  /** @deprecated No longer supported */
  GRAYLISTED = 'GRAYLISTED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  /** @deprecated No longer supported */
  PASSED = 'PASSED',
  REQUIRES_VERIFICATION = 'REQUIRES_VERIFICATION',
  UNKNOWN = 'UNKNOWN',
  UNRESTRICTED = 'UNRESTRICTED'
}

export type OdProtosTrustData_UpdateIdentityReviewInput = {
  falsePositive?: InputMaybe<OdProtosTrustData_FalsePositive>;
  homeAccessStatusAfterReview?: InputMaybe<OdProtosTrustData_HomeAccessStatus>;
  id?: InputMaybe<Scalars['Float']['input']>;
  investigatorNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<OdProtosTrustData_ReviewStatus>;
};

export type OdProtosTrustServices_AddOffHourUnlockEventRequestInput = {
  /** Optional: address UUID for enriching the customer note body. */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /** The customer to set this trust level to. */
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_AddTrustEventRequestInput = {
  /** The customer to set this trust level to. */
  customerId?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<OdProtosTrustServices_AddTrustEventRequest_EventType>;
  /** The reason of this change. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Optional: The human who is manually setting this trust level. */
  settingHumanId?: InputMaybe<Scalars['String']['input']>;
  /** The new trust level to set for the given customer. */
  trustLevel?: InputMaybe<OdProtosTrustData_RiskAssessmentResult_TrustLevel>;
};

export enum OdProtosTrustServices_AddTrustEventRequest_EventType {
  MANUAL_EVALUATION = 'MANUAL_EVALUATION',
  OFF_HOUR_UNLOCK_ATTEMPT = 'OFF_HOUR_UNLOCK_ATTEMPT',
  SMS_EVENT = 'SMS_EVENT'
}

export type OdProtosTrustServices_AssessCustomerRiskRequestInput = {
  assessmentPurpose?: InputMaybe<OdProtosTrustServices_AssessCustomerRiskRequest_AssessmentPurpose>;
  /**
   * The token of the customer who we associate with the phone number.
   * This field is required.
   * Note that this is commonly the Customer.UUID, not the Customer.Token
   */
  customerToken?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Optional: for indicating specific evaluation situations; if not provided,
 * it will default to running the buyer ruleSet in CRA
 */
export enum OdProtosTrustServices_AssessCustomerRiskRequest_AssessmentPurpose {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

export type OdProtosTrustServices_CreateIdentityReviewRequestInput = {
  identityReviewRequest?: InputMaybe<OdProtosTrustData_CreateIdentityReviewInput>;
};

/** Stripe Identity Verification - Session Creation */
export type OdProtosTrustServices_CreateStripeIdVerificationSessionRequestInput = {
  /** Required: Opendoor customer/contact UUID */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** If true, bypass already-verified and retry threshold checks */
  forceNewSession?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OdProtosTrustServices_CreateStripeIdVerificationSessionResponse_DenialReason {
  /** Customer already has a successful IDV */
  ALREADY_VERIFIED = 'ALREADY_VERIFIED',
  DENIAL_REASON_UNSPECIFIED = 'DENIAL_REASON_UNSPECIFIED',
  /** Stripe IDV not enabled */
  FEATURE_DISABLED = 'FEATURE_DISABLED',
  /** Too many attempts */
  RETRY_THRESHOLD_REACHED = 'RETRY_THRESHOLD_REACHED',
  /** Stripe API timed out */
  TIMED_OUT = 'TIMED_OUT'
}

export type OdProtosTrustServices_GetBypassIdVerificationRequestInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_GetEkataRequestInput = {
  customerToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_GetIdVerificationAttemptsRequestInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_GetIdentityReviewRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 3 */
export type OdProtosTrustServices_GetPhoneNumberTelesignReportRequestInput = {
  /**
   * The token of the customer who we associate with the phone number. This field
   * is optional, but should be provided if available.
   */
  customerToken?: InputMaybe<Scalars['String']['input']>;
  /** The phone number for whose owner we want to identify. This field is required */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_GetRelatedCustomersWithDeviceOverlapRequestInput = {
  customerToken?: InputMaybe<Scalars['String']['input']>;
};

/** Stripe Identity Verification - Session Status Query */
export type OdProtosTrustServices_GetStripeSessionStatusRequestInput = {
  /** Required: Opendoor contact UUID */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Stripe session ID (vs_xxx). If empty, returns the latest Stripe IDV attempt for the contact. */
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_GetSuccessfulIdVerificationRequestInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_GetThreatMetrixRequestInput = {
  customerToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosTrustServices_IdentifyPhoneNumberRequestInput = {
  /**
   * The token of the customer who we associate with the phone number. This field
   * is optional, but should be provided if available.
   */
  customerToken?: InputMaybe<Scalars['String']['input']>;
  /** The phone number for whose owner we want to identify. This field is required */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_MergeCustomerTrustRelatedEventsRequestInput = {
  mergedCustomerUuid?: InputMaybe<Scalars['String']['input']>;
  mergedIntoCustomerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Stripe Identity Verification - Webhook Processing */
export type OdProtosTrustServices_ProcessStripeIdVerificationWebhookRequestInput = {
  /** Raw webhook body (required for signature verification) */
  payload?: InputMaybe<Scalars['String']['input']>;
  /** Stripe-Signature header value */
  stripeSignature?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_ProfileDeviceRequestInput = {
  attributes?: InputMaybe<OdProtosTrustServices_ProfileDeviceRequest_AttributesInput>;
  /** This is an ID associated to a ThreatMetrix profiling event. */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** This is also known as the human's token */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Metadata about the human to which the session_id is associated.
 * These will be used as a snapshot of the provided user's info.
 */
export type OdProtosTrustServices_ProfileDeviceRequest_AttributesInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_SetManualTrustLevelRequestInput = {
  /** The customer to set this trust level to. */
  customerId?: InputMaybe<Scalars['String']['input']>;
  /** The reason of this change. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The human who is manually setting this trust level. */
  settingHumanId?: InputMaybe<Scalars['String']['input']>;
  /** The new trust level to set for the given customer. */
  trustLevel?: InputMaybe<OdProtosTrustData_RiskAssessmentResult_TrustLevel>;
};

export type OdProtosTrustServices_UpdateIdentityReviewRequestInput = {
  updateIdentityReview?: InputMaybe<OdProtosTrustData_UpdateIdentityReviewInput>;
};

/** Attempts to determine if the phone number and email address belong to this customer */
export type OdProtosTrustServices_VerifyCustomerContactRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosTrustServices_VerifyIdRequestInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  idBackPdf417?: InputMaybe<Scalars['String']['input']>;
  idFrontBase64?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosValidataData_ConfidenceAttributeName {
  ABOVE_GRADE_SQ_FT = 'ABOVE_GRADE_SQ_FT',
  /** UNEXPECTED UNALLOWED */
  ATTRIBUTE_NAME_UNKNOWN = 'ATTRIBUTE_NAME_UNKNOWN'
}

export enum OdProtosValidataData_ConfidenceLevel {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosValidataData_ConfidenceReason {
  CONFIDENCE_REASON_CONFLICITING_INTERNAL_EDITS = 'CONFIDENCE_REASON_CONFLICITING_INTERNAL_EDITS',
  CONFIDENCE_REASON_CONFLICTING_DATA = 'CONFIDENCE_REASON_CONFLICTING_DATA',
  CONFIDENCE_REASON_CONFLICTING_DEPENDENCY_CONDITION = 'CONFIDENCE_REASON_CONFLICTING_DEPENDENCY_CONDITION',
  CONFIDENCE_REASON_CONFLICTING_FLOOR_PLAN_SCAN = 'CONFIDENCE_REASON_CONFLICTING_FLOOR_PLAN_SCAN',
  CONFIDENCE_REASON_COULD_NOT_VERIFY = 'CONFIDENCE_REASON_COULD_NOT_VERIFY',
  /**
   * Medium confidence reasons
   * (start at 20 to make room for more low conf. reasons)
   */
  CONFIDENCE_REASON_EXTERNAL_SOURCES_AGREE = 'CONFIDENCE_REASON_EXTERNAL_SOURCES_AGREE',
  CONFIDENCE_REASON_HPM_INPUT = 'CONFIDENCE_REASON_HPM_INPUT',
  /**
   * High confidence reasons
   * (start at 40 to make room for more medium conf. reasons)
   */
  CONFIDENCE_REASON_INTERNALLY_VERIFIED = 'CONFIDENCE_REASON_INTERNALLY_VERIFIED',
  /** Low confidence reasons */
  CONFIDENCE_REASON_NO_DATA = 'CONFIDENCE_REASON_NO_DATA',
  CONFIDENCE_REASON_ONLY_IMPUTED = 'CONFIDENCE_REASON_ONLY_IMPUTED',
  CONFIDENCE_REASON_ONLY_SELLER_INPUTS = 'CONFIDENCE_REASON_ONLY_SELLER_INPUTS',
  CONFIDENCE_REASON_OUT_OF_RANGE = 'CONFIDENCE_REASON_OUT_OF_RANGE',
  CONFIDENCE_REASON_UNKNOWN = 'CONFIDENCE_REASON_UNKNOWN'
}

export type OdProtosValidataData_ConfidenceThresholdsInput = {
  attribute?: InputMaybe<OdProtosValidataData_ConfidenceAttributeName>;
  threshold?: InputMaybe<OdProtosValidataData_ConfidenceThresholds_ThresholdOneofInput>;
};

export type OdProtosValidataData_ConfidenceThresholds_ThresholdOneofInput = {
  absoluteValueThreshold?: InputMaybe<Scalars['Float']['input']>;
  percentageThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosValidataData_FloorPlanAssetInputInput = {
  assetType?: InputMaybe<OdProtosValidataData_FloorPlanAssetType>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosValidataData_FloorPlanAssetType {
  FLOOR_PLAN_ASSET_TYPE_GLA = 'FLOOR_PLAN_ASSET_TYPE_GLA',
  FLOOR_PLAN_ASSET_TYPE_JSON = 'FLOOR_PLAN_ASSET_TYPE_JSON',
  FLOOR_PLAN_ASSET_TYPE_LISTING_NO_DIMENSIONS = 'FLOOR_PLAN_ASSET_TYPE_LISTING_NO_DIMENSIONS',
  FLOOR_PLAN_ASSET_TYPE_LISTING_WITH_DIMENSIONS = 'FLOOR_PLAN_ASSET_TYPE_LISTING_WITH_DIMENSIONS',
  FLOOR_PLAN_ASSET_TYPE_UNKNOWN = 'FLOOR_PLAN_ASSET_TYPE_UNKNOWN'
}

export enum OdProtosValidataData_FloorPlanFileType {
  FLOOR_PLAN_FILE_TYPE_JPEG = 'FLOOR_PLAN_FILE_TYPE_JPEG',
  FLOOR_PLAN_FILE_TYPE_JSON = 'FLOOR_PLAN_FILE_TYPE_JSON',
  FLOOR_PLAN_FILE_TYPE_PDF = 'FLOOR_PLAN_FILE_TYPE_PDF',
  FLOOR_PLAN_FILE_TYPE_PNG = 'FLOOR_PLAN_FILE_TYPE_PNG',
  FLOOR_PLAN_FILE_TYPE_SVG = 'FLOOR_PLAN_FILE_TYPE_SVG',
  FLOOR_PLAN_FILE_TYPE_UNKNOWN = 'FLOOR_PLAN_FILE_TYPE_UNKNOWN'
}

export type OdProtosValidataData_HomeDataAssetFeedbackInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  assessmentId?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<Scalars['String']['input']>;
  feedbacks?: InputMaybe<Array<Scalars['String']['input']>>;
  feedbacksCreatedBy?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosValidataData_OptOutType {
  /** "all" means this home is opting out of floor plan scans at any point */
  OPT_OUT_TYPE_ALL = 'OPT_OUT_TYPE_ALL',
  /** "none" is way of opting in */
  OPT_OUT_TYPE_NONE = 'OPT_OUT_TYPE_NONE',
  /**
   * "pre-acquisition" means we'll opt out of floor plan scans while a seller still
   * occupies the home, but we will do a scan once acquired
   */
  OPT_OUT_TYPE_PRE_ACQUISITION = 'OPT_OUT_TYPE_PRE_ACQUISITION',
  OPT_OUT_TYPE_UNKNOWN = 'OPT_OUT_TYPE_UNKNOWN'
}

export enum OdProtosValidataData_ScanEligibility {
  SCAN_ELIGIBILITY_POST_ACQUISITION = 'SCAN_ELIGIBILITY_POST_ACQUISITION',
  SCAN_ELIGIBILITY_PRE_ACQUISITION = 'SCAN_ELIGIBILITY_PRE_ACQUISITION',
  SCAN_ELIGIBILITY_UNKNOWN = 'SCAN_ELIGIBILITY_UNKNOWN'
}

export enum OdProtosValidataData_TaskType {
  REVIEW_FLOOR_PLAN = 'REVIEW_FLOOR_PLAN',
  UNKNOWN_TASK_TYPE = 'UNKNOWN_TASK_TYPE',
  /** Renamed from VALIDATE_DATA */
  VERIFY_DATA = 'VERIFY_DATA',
  VERIFY_DATA_ESCALATION = 'VERIFY_DATA_ESCALATION',
  VERIFY_DATA_MANUAL = 'VERIFY_DATA_MANUAL'
}

export type OdProtosValidataData_VerificationResultInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  finalValue?: InputMaybe<Scalars['String']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosValidataServices_BatchGetConfidenceSignalsByFieldsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional threshold config on a per attribute basis */
  thresholdConfig?: InputMaybe<Array<OdProtosValidataData_ConfidenceThresholdsInput>>;
};

/** CompleteDataQualityTask */
export type OdProtosValidataServices_CompleteDataQualityTaskRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  taskNotes?: InputMaybe<Scalars['String']['input']>;
  verificationResults?: InputMaybe<Array<OdProtosValidataData_VerificationResultInput>>;
};

export type OdProtosValidataServices_CreateAssetFeedbackRequestInput = {
  feedbacks?: InputMaybe<OdProtosValidataData_HomeDataAssetFeedbackInput>;
};

/** CreateDataQualityTask */
export type OdProtosValidataServices_CreateDataQualityTaskRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** To Do: Maybe Deprecate after Cutover */
  caseyTaskId?: InputMaybe<Scalars['String']['input']>;
  floorPlanScanId?: InputMaybe<Scalars['String']['input']>;
  /** Related Object Ids, optional, if included will create related_object records in casey */
  leadId?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<OdProtosValidataData_TaskType>;
};

/** Delete DataQualitytask */
export type OdProtosValidataServices_DeleteDataQualityTaskRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_GetConfidenceSignalsByFieldsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional threshold config on a per attribute basis */
  thresholdConfig?: InputMaybe<Array<OdProtosValidataData_ConfidenceThresholdsInput>>;
};

export type OdProtosValidataServices_GetCubicasaQuickEditLinkRequestInput = {
  cubicasaModelId?: InputMaybe<Scalars['String']['input']>;
};

/** Get DataQualityTask */
export type OdProtosValidataServices_GetDataQualityTaskRequestInput = {
  /** To Do: Deprecate after Cutover */
  caseyTaskId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_GetFloorPlanEligibilityRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Calculate eligibility regardless of user opt-out. This is useful
   * when powering UIs that allow opting in/out of floor plan scans,
   * so you can know what the eligiblity would be if the user opted-in
   */
  ignoreOptOut?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosValidataServices_GetFloorPlanScanUploadOverdueRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_GetGoToScanUrlRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_GetLatestAttributeVerificationsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosValidataServices_ListAssetFeedbackRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_ListFloorPlanOptOutsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosValidataServices_MarkFloorPlanScanCompleteRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  scanCompletedBy?: InputMaybe<Scalars['String']['input']>;
  scanVisitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_MarkFloorPlanScanStartedRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosValidataServices_ProcessCompletedCubicasaOrderRequestInput = {
  cubicasaOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_ProcessCompletedCubicasaTicketRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  cubicasaModelId?: InputMaybe<Scalars['String']['input']>;
  cubicasaTicketId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_ProcessCreatedCubicasaOrderRequestInput = {
  cubicasaOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_ProcessCreatedCubicasaTicketRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  cubicasaTicketId?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_RejectFloorPlanScanRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  rejectNotes?: InputMaybe<Scalars['String']['input']>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  rejectedBy?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_RequestFloorPlanScanRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  requestReason?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_SearchFloorPlanAssetsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosValidataServices_SearchFloorPlanDetailsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  floorPlanScanIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosValidataServices_SearchFloorPlanScansRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosValidataServices_SetFloorPlanOptOutRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosValidataData_OptOutType>;
};

/** StartDataQualityTask */
export type OdProtosValidataServices_StartDataQualityTaskRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_SubmitFloorPlanAssetsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  floorPlanAssetInputs?: InputMaybe<Array<OdProtosValidataData_FloorPlanAssetInputInput>>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosValidataServices_UpdateAssetFeedbackRequestInput = {
  feedbacks?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosValuationsDataMergedcomps_ListingStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  COMING_SOON = 'COMING_SOON',
  EXPIRED = 'EXPIRED',
  INCOMPLETE = 'INCOMPLETE',
  PENDING = 'PENDING',
  TEMP_OFF_MARKET = 'TEMP_OFF_MARKET',
  UNKNOWN_LISTING_STATUS = 'UNKNOWN_LISTING_STATUS'
}

export type OdProtosValuationsServicesValuationsGraphql_ListValuationsRequestInput = {
  valuationIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosValuationsServicesValuations_GetMergedCompsForClosestValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  windowEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Inclusive bounds on the candidate valuation's completed_at timestamp.
   * Among valuations whose completed_at falls in this window and which have
   * comps, the one whose completed_at is closest to the midpoint of
   * [window_start, window_end] is selected.
   */
  windowStart?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosValuationsServicesValuations_GetMergedCompsForClosestValuationResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  /** No valuation with comps was found in the window. */
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequestInput = {
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  valuationKind?: InputMaybe<OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequest_ValuationKindOneofInput>;
};

export type OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequest_ValuationKindOneofInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
  valuationId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosValuationsServicesValuations_GetMergedCompsForValuationResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
  VALUATION_INCOMPLETE = 'VALUATION_INCOMPLETE'
}

export type OdProtosValuationsServicesValuations_GetValuationRequestInput = {
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  valuationId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosValuationsServicesValuations_GetValuationResponse_Error_Code {
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

/**
 * ExperimentVariant is used to assign a user to a given experiment bucket.
 * Next ID: 3
 */
export type OdProtosVariantData_ExperimentVariantInput = {
  experimentId?: InputMaybe<Scalars['String']['input']>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
};

/**
 * FeatureFlagVariant is used to assign a user to a given feature flag bucket.
 * Next ID: 3
 */
export type OdProtosVariantData_FeatureFlagVariantInput = {
  featureFlagId?: InputMaybe<Scalars['String']['input']>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Grain is used to identify the entity that will be bucketed and supports multiple identifiers.
 * Next ID: 4
 */
export type OdProtosVariantData_GrainInput = {
  grain?: InputMaybe<OdProtosVariantData_Grain_GrainOneofInput>;
  /** Deprecated: use grain instead */
  id?: InputMaybe<OdProtosVariantData_Grain_IdOneofInput>;
};

export type OdProtosVariantData_Grain_CustomerGrainInput = {
  primaryId?: InputMaybe<OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput>;
  temporaryId?: InputMaybe<OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput>;
};

export type OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVariantData_Grain_GrainOneofInput = {
  customer?: InputMaybe<OdProtosVariantData_Grain_CustomerGrainInput>;
  operator?: InputMaybe<OdProtosVariantData_Grain_OperatorGrainInput>;
  property?: InputMaybe<OdProtosVariantData_Grain_PropertyGrainInput>;
};

export type OdProtosVariantData_Grain_IdOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVariantData_Grain_OperatorGrainInput = {
  primaryId?: InputMaybe<OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput>;
};

export type OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVariantData_Grain_PropertyGrainInput = {
  primaryId?: InputMaybe<OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput>;
  temporaryId?: InputMaybe<OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput>;
};

export type OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosVariantServices_AddUserToVariantsRequestInput = {
  /** the experiment variants the grain should be bucketed into */
  experiments?: InputMaybe<Array<OdProtosVariantData_ExperimentVariantInput>>;
  /** the feature flag variants the grain should be bucketed into */
  featureFlags?: InputMaybe<Array<OdProtosVariantData_FeatureFlagVariantInput>>;
  /** grain is the identifier for the entity that will be bucketed into a variant. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
};

/** Next ID: 4 */
export type OdProtosVariantServices_GetFeatureFlagsRequestInput = {
  /** grain is the identifier for the entity that will be bucketed into a variant. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  /** keys are the identifiers of the feature flags. */
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** props is for any additional data that is needed for determining which variant to bucket the entity in. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 5 */
export type OdProtosVariantServices_GetVariantRequestInput = {
  /** Set auto_impression to true if you want an impression automatically set. */
  autoImpression?: InputMaybe<Scalars['Boolean']['input']>;
  /** grain is the identifier for the entity that will be bucketed into a variant. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  /** key is the identifier of an experiment or feature flag. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** props is for any additional data that is needed for determining which variant to bucket the entity in. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 4 */
export type OdProtosVariantServices_GetVariantsRequestInput = {
  /** grain is the identifier for the entity that will be bucketed into a variant. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  /** keys are the identifiers of experiments and/or feature flags. */
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** props is for any additional data that is needed for determining which variant to bucket the entity in. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 4 */
export type OdProtosVariantServices_SetImpressionRequestInput = {
  /** grain is the identifier for the entity that will have an impression set. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  /** key is the identifier of the experiment that the impression is for. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** variant_value is the variant the entity was exposed to. */
  variantValue?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Assignment Event is used to track the assignment of a variant for an entity.
 * Next ID: 4
 */
export type OdProtosVariantV2Data_AssignmentEventInput = {
  /** grain is the identifier for the entity that received an assignment. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** key is the identifier of the flag that the assignment is for. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** variant is the variant the entity was assigned. */
  variant?: InputMaybe<Scalars['String']['input']>;
};

/**
 * ForceExperimentVariant is used to force a user to be assigned a specific variant for an experiment.
 * Next ID: 3
 */
export type OdProtosVariantV2Data_ForceExperimentVariantInput = {
  experimentId?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/**
 * ForceFeatureFlagVariant is used to force a user to be assigned a specific variant for a feature flag.
 * Next ID: 3
 */
export type OdProtosVariantV2Data_ForceFeatureFlagVariantInput = {
  featureFlagId?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Grain is used to identify the entity that will be bucketed and supports multiple identifiers.
 * Next ID: 5
 */
export type OdProtosVariantV2Data_GrainInput = {
  grain?: InputMaybe<OdProtosVariantV2Data_Grain_GrainOneofInput>;
};

export type OdProtosVariantV2Data_Grain_CustomerGrainInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  temporaryId?: InputMaybe<OdProtosVariantV2Data_Grain_CustomerGrain_TemporaryIdOneofInput>;
};

export type OdProtosVariantV2Data_Grain_CustomerGrain_TemporaryIdOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVariantV2Data_Grain_GrainOneofInput = {
  customer?: InputMaybe<OdProtosVariantV2Data_Grain_CustomerGrainInput>;
  lead?: InputMaybe<OdProtosVariantV2Data_Grain_LeadGrainInput>;
  operator?: InputMaybe<OdProtosVariantV2Data_Grain_OperatorGrainInput>;
  property?: InputMaybe<OdProtosVariantV2Data_Grain_PropertyGrainInput>;
};

export type OdProtosVariantV2Data_Grain_LeadGrainInput = {
  customer?: InputMaybe<OdProtosVariantV2Data_Grain_CustomerGrainInput>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVariantV2Data_Grain_OperatorGrainInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVariantV2Data_Grain_PropertyGrainInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  temporaryId?: InputMaybe<OdProtosVariantV2Data_Grain_PropertyGrain_TemporaryIdOneofInput>;
};

export type OdProtosVariantV2Data_Grain_PropertyGrain_TemporaryIdOneofInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosVariantV2Services_AssignExperimentVariantRequestInput = {
  /** Set auto_impression to true if you want an impression automatically tracked. */
  autoImpression?: InputMaybe<Scalars['Boolean']['input']>;
  /** grain is the identifier for the entity that a variant is being requested for. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** key is the identifier of an experiment. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** props is for any additional data that is needed for determining eligibility for the experiment. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 4 */
export type OdProtosVariantV2Services_AssignFeatureFlagVariantsRequestInput = {
  /** grain is the identifier for the entity that variants are being requested for. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** keys are the identifiers of the feature flags. */
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** props is for any additional data that is needed for determining eligibility for the feature. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 4 */
export type OdProtosVariantV2Services_ForceVariantAssignmentsForTestsRequestInput = {
  /** the experiment variants the grain should be bucketed into */
  experiments?: InputMaybe<Array<OdProtosVariantV2Data_ForceExperimentVariantInput>>;
  /** the feature flag variants the grain should be bucketed into */
  featureFlags?: InputMaybe<Array<OdProtosVariantV2Data_ForceFeatureFlagVariantInput>>;
  /** grain is the identifier for the entity that will be assigned the variant. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
};

/** Next ID: 3 */
export type OdProtosVariantV2Services_GetExperimentImpressionsRequestInput = {
  /** grain is the identifier for the entity that received the impressions. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** keys are the identifiers of experiments. */
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 3 */
export type OdProtosVariantV2Services_GetExperimentVariantsRequestInput = {
  /** grain is the identifier for the entity that the variants were assigned to. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** keys are the identifiers of experiments. */
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 4 */
export type OdProtosVariantV2Services_TrackExperimentImpressionRequestInput = {
  /** grain is the identifier for the entity that was impressed. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /**
   * if this flag is true and this experiment already has an impression, then do not send another one
   * if this flag is false always send an impression
   */
  isIdempotent?: InputMaybe<Scalars['Boolean']['input']>;
  /** key is the identifier of an experiment. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** variant is the experience that was impressed. */
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosVariantV2Services_TrackLocalAssignmentsRequestInput = {
  /** Batch of assignment events, maximum batch size of 1000. */
  assignments?: InputMaybe<Array<OdProtosVariantV2Data_AssignmentEventInput>>;
};

/** CapabilitiesValue is a wrapper value for input purposes */
export type OdProtosVendorsData_CapabilitiesValueInput = {
  capabilities?: InputMaybe<Array<OdProtosVendorsData_CapabilityInput>>;
};

/** Next ID: 6 */
export type OdProtosVendorsData_CapabilityInput = {
  capabilityType?: InputMaybe<OdProtosVendorsData_CapabilityType>;
  configuration?: InputMaybe<OdProtosVendorsData_Capability_ConfigurationOneofInput>;
  inspect?: InputMaybe<Scalars['Boolean']['input']>;
  install?: InputMaybe<Scalars['Boolean']['input']>;
  maintenance?: InputMaybe<Scalars['Boolean']['input']>;
  repair?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Next ID: 72
 * NOTE: When you update this, please also create a migration to update dwh_capabilities_view
 */
export enum OdProtosVendorsData_CapabilityType {
  AGENT = 'AGENT',
  APPLIANCE = 'APPLIANCE',
  BATHTUB_RESURFACING = 'BATHTUB_RESURFACING',
  BRN_AND_LRR = 'BRN_AND_LRR',
  BROKER = 'BROKER',
  CABINETS = 'CABINETS',
  CARPET_CLEANING = 'CARPET_CLEANING',
  CHIMNEY = 'CHIMNEY',
  CLEANING = 'CLEANING',
  CLEANING_MAINTENANCE = 'CLEANING_MAINTENANCE',
  CONCRETE_FLATWORK = 'CONCRETE_FLATWORK',
  COUNTERTOP = 'COUNTERTOP',
  COUNTERTOP_RESURFACING = 'COUNTERTOP_RESURFACING',
  CRAWL_SPACE = 'CRAWL_SPACE',
  DATA_LABELING = 'DATA_LABELING',
  DAY_ONE_WALK = 'DAY_ONE_WALK',
  DISPATCH = 'DISPATCH',
  ELECTRICAL = 'ELECTRICAL',
  ENGINEERING = 'ENGINEERING',
  FENCING = 'FENCING',
  FIREPLACE = 'FIREPLACE',
  FLOORING = 'FLOORING',
  FLOOR_REFINISHING = 'FLOOR_REFINISHING',
  FOUNDATION = 'FOUNDATION',
  GARAGE_DOOR = 'GARAGE_DOOR',
  GAS_LINE_SERVICE = 'GAS_LINE_SERVICE',
  GENERAL_CONTRACTOR = 'GENERAL_CONTRACTOR',
  GENERAL_INSPECTOR = 'GENERAL_INSPECTOR',
  GLASS_WINDOW = 'GLASS_WINDOW',
  GUTTERS = 'GUTTERS',
  HANDYMAN = 'HANDYMAN',
  HARDSCAPE_LANDSCAPE = 'HARDSCAPE_LANDSCAPE',
  HOME_ASSESSMENT = 'HOME_ASSESSMENT',
  HVAC = 'HVAC',
  IRRIGATION = 'IRRIGATION',
  JUNK_REMOVAL = 'JUNK_REMOVAL',
  LANDSCAPING_MAINTENANCE = 'LANDSCAPING_MAINTENANCE',
  LAND_SURVEYING = 'LAND_SURVEYING',
  LIVING_AREA_MEASUREMENT = 'LIVING_AREA_MEASUREMENT',
  LOCKSMITH = 'LOCKSMITH',
  MASONRY = 'MASONRY',
  MOLD_REMEDIATION = 'MOLD_REMEDIATION',
  ODOR_REMEDIATION = 'ODOR_REMEDIATION',
  OD_SELECT = 'OD_SELECT',
  OIL_TANK_SERVICES = 'OIL_TANK_SERVICES',
  PAINTING = 'PAINTING',
  PESTS = 'PESTS',
  PHOTOGRAPHY = 'PHOTOGRAPHY',
  PLUMBING = 'PLUMBING',
  POOL = 'POOL',
  POOL_REPAIR = 'POOL_REPAIR',
  PRESSURE_WASHING = 'PRESSURE_WASHING',
  RADON_TESTING = 'RADON_TESTING',
  RENO_VALUATIONS = 'RENO_VALUATIONS',
  RESTORATION = 'RESTORATION',
  ROOF = 'ROOF',
  SECURITY = 'SECURITY',
  SEPTIC = 'SEPTIC',
  SEWER_INSPECTIONS_AND_REPAIRS = 'SEWER_INSPECTIONS_AND_REPAIRS',
  SIDING = 'SIDING',
  SNOW = 'SNOW',
  STRUCTURAL = 'STRUCTURAL',
  TREE_SERVICES = 'TREE_SERVICES',
  VALUATIONS = 'VALUATIONS',
  WELLS = 'WELLS',
  WILDLIFE = 'WILDLIFE'
}

export type OdProtosVendorsData_Capability_ConfigurationOneofInput = {
  d1wConfiguration?: InputMaybe<OdProtosVendorsData_D1WConfigurationInput>;
};

/**
 * Next ID: 2
 * NOTE: When you update this, please also create a migration to update dwh_compliance_view
 */
export enum OdProtosVendorsData_ComplianceStatus {
  COMPLIANT = 'COMPLIANT',
  NOT_COMPLIANT = 'NOT_COMPLIANT'
}

/** Next ID: 2 */
export type OdProtosVendorsData_ComplianceStatusValueInput = {
  status?: InputMaybe<OdProtosVendorsData_ComplianceStatus>;
};

export type OdProtosVendorsData_D1WConfigurationInput = {
  maxD1wsPerDay?: InputMaybe<Scalars['Float']['input']>;
  maxD1wsPerWeek?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosVendorsData_Persona {
  PARTNER = 'PARTNER',
  PREFERRED = 'PREFERRED',
  RESERVE = 'RESERVE',
  ROOKIE = 'ROOKIE',
  STRATEGIC = 'STRATEGIC',
  UNSET = 'UNSET'
}

export type OdProtosVendorsData_PersonaValueInput = {
  value?: InputMaybe<OdProtosVendorsData_Persona>;
};

/**
 * Next ID: 3
 * NOTE: When you update this, please also create a migration to update dwh_branches_view
 */
export enum OdProtosVendorsData_Status {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING'
}

/** Next ID: 2 */
export type OdProtosVendorsData_StatusValueInput = {
  value?: InputMaybe<OdProtosVendorsData_Status>;
};

export type OdProtosVendorsData_VendorBranchCreateInput = {
  capabilities?: InputMaybe<Array<OdProtosVendorsData_CapabilityInput>>;
  /** fence_id is the service area of a VendorBranch */
  fenceId?: InputMaybe<Scalars['String']['input']>;
  maxConcurrentWorkOrders?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<OdProtosVendorsData_Persona>;
  status?: InputMaybe<OdProtosVendorsData_Status>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVendorsData_VendorBranchUpdateInput = {
  /** if the field is set all capabilities are replaced by the given capabilities */
  capabilities?: InputMaybe<OdProtosVendorsData_CapabilitiesValueInput>;
  d1wConfiguration?: InputMaybe<OdProtosVendorsData_D1WConfigurationInput>;
  /** fence_id is the service area of a VendorBranch */
  fenceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxConcurrentWorkOrders?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<OdProtosVendorsData_PersonaValueInput>;
  status?: InputMaybe<OdProtosVendorsData_StatusValueInput>;
};

/** Next ID: 8 */
export type OdProtosVendorsData_VendorComplianceInput = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  autoInsuranceExpires?: InputMaybe<Scalars['String']['input']>;
  complianceStatus?: InputMaybe<OdProtosVendorsData_ComplianceStatus>;
  generalLiabilityInsuranceExpires?: InputMaybe<Scalars['String']['input']>;
  netvendorId?: InputMaybe<Scalars['String']['input']>;
  workersCompExempt?: InputMaybe<Scalars['Boolean']['input']>;
  workersCompExpires?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosVendorsData_VendorCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  netvendorId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 9 */
export type OdProtosVendorsData_VendorFeedbackInput = {
  associatedObjectId?: InputMaybe<Scalars['String']['input']>;
  associatedObjectType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdByUserToken?: InputMaybe<Scalars['String']['input']>;
  /** JSON representing feedback */
  feedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosVendorsData_VendorUpdateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  netvendorId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVendorsServices_AvgTradePartnerFeedbackV1RequestInput = {
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_CreateFeedbackForVendorRequestInput = {
  feedback?: InputMaybe<OdProtosVendorsData_VendorFeedbackInput>;
};

/** Next ID: 8 */
export type OdProtosVendorsServices_CreateInvoiceForWorkOrderRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_AddressInput>;
  lineItems?: InputMaybe<Array<OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_LineItemInput>>;
  totalCost?: InputMaybe<Scalars['String']['input']>;
  vendorAddress?: InputMaybe<OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_AddressInput>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  vendorPhone?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_LineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_CreateOrUpdateVendorComplianceRequestInput = {
  vendorCompliance?: InputMaybe<OdProtosVendorsData_VendorComplianceInput>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_CreateVendorBranchRequestInput = {
  vendorBranch?: InputMaybe<OdProtosVendorsData_VendorBranchCreateInput>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_CreateVendorRequestInput = {
  vendor?: InputMaybe<OdProtosVendorsData_VendorCreateInput>;
};

/** Next ID: 3 */
export type OdProtosVendorsServices_GetVendorByExternalIdRequestInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_ListExternalIdsRequestInput = {
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 1 */
export type OdProtosVendorsServices_SayHelloBenderRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** If a variable is not set it won't be used to filter */
export type OdProtosVendorsServices_SearchVendorBranchesPaginatedRequestInput = {
  /**
   * capabilities are filtered as UNIONed
   * I.E. Show me POOL and HVAC vendors
   */
  capabilities?: InputMaybe<Array<OdProtosVendorsData_CapabilityInput>>;
  compliance?: InputMaybe<OdProtosVendorsData_ComplianceStatusValueInput>;
  location?: InputMaybe<OdProtosVendorsServices_SearchVendorBranchesPaginatedRequest_LocationOneofInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OdProtosVendorsData_StatusValueInput>;
  vendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosVendorsServices_SearchVendorBranchesPaginatedRequest_LocationOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  casaAddress?: InputMaybe<OdProtosCasaData_AddressInput>;
  regionIds?: InputMaybe<OdProtosVendorsServices_IdentifierListRequestInput>;
};

export type OdProtosVendorsServices_SearchVendorMatchesRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  capability?: InputMaybe<OdProtosVendorsData_CapabilityInput>;
  filterBrnVendors?: InputMaybe<Scalars['Boolean']['input']>;
  /** limit: how many results should be returned */
  limit?: InputMaybe<Scalars['Float']['input']>;
  workOrderKind?: InputMaybe<OdProtosHomeworkData_WorkOrder_Kind>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_UpdateVendorBranchRequestInput = {
  vendorBranch?: InputMaybe<OdProtosVendorsData_VendorBranchUpdateInput>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_UpdateVendorRequestInput = {
  vendor?: InputMaybe<OdProtosVendorsData_VendorUpdateInput>;
};

export type OdProtosVisitanteServices_BackfillAppointmentRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  appointmentId?: InputMaybe<Scalars['String']['input']>;
  attendee?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosVisitanteServices_BackfillFeedbackCreatedRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  feedbackId?: InputMaybe<Scalars['String']['input']>;
  isTraditional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWatsonData_AiContextInput = {
  defaultPriceInCents?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  exclusion?: InputMaybe<Scalars['String']['input']>;
  inclusion?: InputMaybe<Scalars['String']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  repairStandardsDefectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scope?: InputMaybe<Scalars['String']['input']>;
  summaryItem?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWatsonData_Cache {
  COOCCURRANCE = 'COOCCURRANCE',
  PREFILL = 'PREFILL',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWatsonData_NewDefectInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWatsonData_NewFeatureInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 8 */
export type OdProtosWatsonData_PrefillDefinitionForUpsertInput = {
  aiContext?: InputMaybe<OdProtosWatsonData_AiContextInput>;
  issueTaxonomy?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  prefillId?: InputMaybe<Scalars['String']['input']>;
  pricingUnit?: InputMaybe<OdProtosCommon_MeasurementUnit>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  updatedByEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 6 */
export type OdProtosWatsonData_PrefillMarketConfigForUpsertInput = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
  prefillId?: InputMaybe<Scalars['String']['input']>;
  pricePerUnitUsdCents?: InputMaybe<Scalars['Float']['input']>;
  updatedByEmail?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWatsonData_Question_QuestionType {
  DIMENSION_AREA = 'DIMENSION_AREA',
  FLOORING_MATERIAL_AND_DIMENSIONS = 'FLOORING_MATERIAL_AND_DIMENSIONS',
  MEASUREMENT = 'MEASUREMENT',
  MULTI_SELCT = 'MULTI_SELCT',
  NUMERIC = 'NUMERIC',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TWO_STEPS_SELECT = 'TWO_STEPS_SELECT'
}

/** Next Id: 3 */
export enum OdProtosWatsonData_RepairScopePrefill_State {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  HIDDEN = 'HIDDEN',
  UNDEFINED = 'UNDEFINED'
}

export type OdProtosWatsonServices_CategoricalDataRequests_GetInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWatsonServices_DefectsRequests_InsertInput = {
  defect?: InputMaybe<OdProtosWatsonData_NewDefectInput>;
};

export type OdProtosWatsonServices_FeaturesRequests_InsertInput = {
  feature?: InputMaybe<OdProtosWatsonData_NewFeatureInput>;
};

export type OdProtosWatsonServices_IdentifierRequests_GetInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWatsonServices_IdentifierRequests_ListInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_MostFrequentDefectsByFeaturesRequests_GetInput = {
  casaId?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_MostFrequentFeaturesByAreasRequests_GetInput = {
  casaId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWatsonServices_PermissionCheckRequests_PrefillWriteAccessFromContextInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RebuildCacheRequests_GetInput = {
  cache?: InputMaybe<OdProtosWatsonData_Cache>;
};

export type OdProtosWatsonServices_RegionalCategoricalDataRequests_GetInput = {
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairRiskFactorRequests_GetInput = {
  casaId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. This field will be ignored */
  price?: InputMaybe<Scalars['Float']['input']>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_CopyPrefillMarketConfigsInput = {
  destinationMarketIdentifier?: InputMaybe<Scalars['String']['input']>;
  originMarketIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_DeletePrefillDefinitionInput = {
  prefillId?: InputMaybe<Scalars['String']['input']>;
  updatedByEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 4 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetByTaxonomyInput = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  taxonomy?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetDefinitionsInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetDeletedDefinitionsInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetFromAddressInput = {
  casaId?: InputMaybe<Scalars['String']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetFromMarketInput = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetInput = {
  prefillId?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetMarketConfigsInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next Id: 4 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetMostFrequentInput = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_ListInput = {
  /** prefill market definition IDs */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_RestorePrefillDefinitionInput = {
  prefillId?: InputMaybe<Scalars['String']['input']>;
  updatedByEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_UpsertPrefillDefinitionInput = {
  repairScopePrefillDefinition?: InputMaybe<OdProtosWatsonData_PrefillDefinitionForUpsertInput>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_UpsertPrefillMarketConfigInput = {
  repairScopePrefillMarketConfig?: InputMaybe<OdProtosWatsonData_PrefillMarketConfigForUpsertInput>;
};

/** TODO: Define enum in web/data or web/customer_ops then deprecate this. */
export enum OdProtosWebDataEvents_EventType {
  AGENT_REFERRAL_CREATED = 'AGENT_REFERRAL_CREATED',
  AGENT_REFERRAL_OFFER_SMS_SENT = 'AGENT_REFERRAL_OFFER_SMS_SENT',
  AGENT_REFERRAL_UPDATED = 'AGENT_REFERRAL_UPDATED',
  ANALYTICS = 'ANALYTICS',
  ASSOCIATION = 'ASSOCIATION',
  ASSOCIATION_CHANGED = 'ASSOCIATION_CHANGED',
  ATTRIBUTE_CHANGED = 'ATTRIBUTE_CHANGED',
  BLACKLIST_UNLOCK_ATTEMPT = 'BLACKLIST_UNLOCK_ATTEMPT',
  BUYER_ATTENTION_WORTHY_SIGNAL = 'BUYER_ATTENTION_WORTHY_SIGNAL',
  BUYER_LEAD_FROM_SELLER = 'BUYER_LEAD_FROM_SELLER',
  BUYER_SIGNUP = 'BUYER_SIGNUP',
  CENTRALIZED_SHOWING_SERVICE_FEEDBACK = 'CENTRALIZED_SHOWING_SERVICE_FEEDBACK',
  CODELESS_UNLOCK_FAILED_ATTEMPT = 'CODELESS_UNLOCK_FAILED_ATTEMPT',
  CODE_MISSING_UNLOCK_ATTEMPT = 'CODE_MISSING_UNLOCK_ATTEMPT',
  COMBINED_DECISION_CALL_OUTCOME = 'COMBINED_DECISION_CALL_OUTCOME',
  CONVERSATION_REASSIGNED = 'CONVERSATION_REASSIGNED',
  COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT = 'COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT',
  CUSTOMER_DATA = 'CUSTOMER_DATA',
  DELIGHTED_SMS_SURVEY_REQUEST = 'DELIGHTED_SMS_SURVEY_REQUEST',
  DELIGHTED_SURVEY_REQUEST = 'DELIGHTED_SURVEY_REQUEST',
  DELIGHTED_SURVEY_RESPONSE = 'DELIGHTED_SURVEY_RESPONSE',
  DEVICE_INSTALL = 'DEVICE_INSTALL',
  EMAIL = 'EMAIL',
  EXTERNAL_INTEREST = 'EXTERNAL_INTEREST',
  GRAYLIST_UNLOCK_ATTEMPT = 'GRAYLIST_UNLOCK_ATTEMPT',
  HOMEBUILDER_OR_OUTCOME = 'HOMEBUILDER_OR_OUTCOME',
  HOME_FEEDBACK_LEFT = 'HOME_FEEDBACK_LEFT',
  HOME_ISSUE_REPORTED = 'HOME_ISSUE_REPORTED',
  ID_VERIFICATION = 'ID_VERIFICATION',
  INITIAL_UNLOCK_ATTEMPT = 'INITIAL_UNLOCK_ATTEMPT',
  INSUFFICIENT_VERSION_UNLOCK_ATTEMPT = 'INSUFFICIENT_VERSION_UNLOCK_ATTEMPT',
  LISTING_INTEREST = 'LISTING_INTEREST',
  LISTING_NOT_FOUND_UNLOCK_ATTEMPT = 'LISTING_NOT_FOUND_UNLOCK_ATTEMPT',
  LISTING_OFFER_NOTIFICATION = 'LISTING_OFFER_NOTIFICATION',
  LISTING_OFFER_SUBMITTED = 'LISTING_OFFER_SUBMITTED',
  LISTING_RESERVATION = 'LISTING_RESERVATION',
  /** @deprecated No longer supported */
  LWOD_OFFER_SENT = 'LWOD_OFFER_SENT',
  /** @deprecated No longer supported */
  LWOD_OR_OUTCOME = 'LWOD_OR_OUTCOME',
  MERGE = 'MERGE',
  NEEDS_ATTENTION_FOLLOWUP_TIME = 'NEEDS_ATTENTION_FOLLOWUP_TIME',
  NEEDS_ATTENTION_RESOLVED = 'NEEDS_ATTENTION_RESOLVED',
  NOTE = 'NOTE',
  OFFER_ON_INTERESTED_HOME = 'OFFER_ON_INTERESTED_HOME',
  OFFER_SENT = 'OFFER_SENT',
  OPEN_LISTINGS_OFFER_STATE = 'OPEN_LISTINGS_OFFER_STATE',
  OPEN_LISTINGS_TOUR_COMPLETED = 'OPEN_LISTINGS_TOUR_COMPLETED',
  OR_VA_OUTCOME = 'OR_VA_OUTCOME',
  OUTREACH_OUTCOME = 'OUTREACH_OUTCOME',
  OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT = 'OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT',
  OUT_OF_OFFICE_REPLY = 'OUT_OF_OFFICE_REPLY',
  PARTICIPANT_CHANGED = 'PARTICIPANT_CHANGED',
  PHONE_CALL = 'PHONE_CALL',
  POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT = 'POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT',
  PPM_UNLOCK_ATTEMPT = 'PPM_UNLOCK_ATTEMPT',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  REPEAT_VISIT = 'REPEAT_VISIT',
  /** @deprecated No longer supported */
  REQUEST_FOR_LWOD_AGENT = 'REQUEST_FOR_LWOD_AGENT',
  SCHEDULE_TOUR_REQUEST = 'SCHEDULE_TOUR_REQUEST',
  SELF_TOUR_FEEDBACK = 'SELF_TOUR_FEEDBACK',
  SHOWINGTIME_FEEDBACK = 'SHOWINGTIME_FEEDBACK',
  SMS = 'SMS',
  SMS_OPT_OUT_NOTIFICATION = 'SMS_OPT_OUT_NOTIFICATION',
  SOLD_UNLOCK_ATTEMPT = 'SOLD_UNLOCK_ATTEMPT',
  SYSTEM = 'SYSTEM',
  TOM_UNLOCK_ATTEMPT = 'TOM_UNLOCK_ATTEMPT',
  TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD = 'TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD',
  TRUST = 'TRUST',
  UNDER_COVID_LOCKDOWN = 'UNDER_COVID_LOCKDOWN',
  UNKNOWN = 'UNKNOWN',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNLOCK = 'UNLOCK',
  VISIT_EXPERIENCE_FEEDBACK_APPRECIATION = 'VISIT_EXPERIENCE_FEEDBACK_APPRECIATION',
  VISIT_EXPERIENCE_FEEDBACK_REQUEST = 'VISIT_EXPERIENCE_FEEDBACK_REQUEST',
  VISIT_EXPERIENCE_FEEDBACK_RESPONSE = 'VISIT_EXPERIENCE_FEEDBACK_RESPONSE',
  VISIT_EXPERIENCE_SCORE_REQUEST = 'VISIT_EXPERIENCE_SCORE_REQUEST',
  VISIT_EXPERIENCE_SCORE_RESPONSE = 'VISIT_EXPERIENCE_SCORE_RESPONSE',
  VOICEMAIL = 'VOICEMAIL',
  WEB_CHAT = 'WEB_CHAT'
}

export type OdProtosWebDataSellDirect_GetContractInfoRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebDataSellDirect_GetServiceProviderInfoRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebDataSellDirect_HoaInfo_Fee_Frequency {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY',
  ONE_OFF = 'ONE_OFF',
  QUARTERLY = 'QUARTERLY',
  SEMI_ANNUALLY = 'SEMI_ANNUALLY',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebDataSellDirect_OfferReview_CallType {
  PHONE = 'PHONE',
  UNKNOWN_CALL_TYPE = 'UNKNOWN_CALL_TYPE',
  VIDEO = 'VIDEO'
}

export enum OdProtosWebDataSellDirect_OfferReview_CancelReason {
  CUSTOMER_CANNOT_MAKE_IT = 'CUSTOMER_CANNOT_MAKE_IT',
  OPENDOOR_CANNOT_MAKE_IT = 'OPENDOOR_CANNOT_MAKE_IT',
  UNKNOWN_CANCEL_REASON = 'UNKNOWN_CANCEL_REASON'
}

export enum OdProtosWebDataSellDirect_OfferReview_Outcome {
  AGENT_CUSTOMER_HANDED_OFF_TO_AEP = 'AGENT_CUSTOMER_HANDED_OFF_TO_AEP',
  CALL_NOT_COMPLETE_RESCHEDULE_OR = 'CALL_NOT_COMPLETE_RESCHEDULE_OR',
  CALL_NOT_COMPLETE_SENT_SSVA = 'CALL_NOT_COMPLETE_SENT_SSVA',
  CAN_COMPLETE_OR = 'CAN_COMPLETE_OR',
  DID_NOT_CONVERT = 'DID_NOT_CONVERT',
  NO_SHOW = 'NO_SHOW',
  OPENDOOR_CANNOT_PURCHASE_OOBB = 'OPENDOOR_CANNOT_PURCHASE_OOBB',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 11 */
export enum OdProtosWebDataSellDirect_OfferStepName {
  OFFER_STEP_ADDENDUM_SIGNING = 'OFFER_STEP_ADDENDUM_SIGNING',
  OFFER_STEP_ASSESSMENT = 'OFFER_STEP_ASSESSMENT',
  OFFER_STEP_AWAITING_CLOSE = 'OFFER_STEP_AWAITING_CLOSE',
  OFFER_STEP_CONTRACT_SIGNING = 'OFFER_STEP_CONTRACT_SIGNING',
  OFFER_STEP_DILIGENCE_VISIT = 'OFFER_STEP_DILIGENCE_VISIT',
  OFFER_STEP_HOLDING_OFFER = 'OFFER_STEP_HOLDING_OFFER',
  OFFER_STEP_HOLD_OFFER_DECISION = 'OFFER_STEP_HOLD_OFFER_DECISION',
  OFFER_STEP_OFFER_CREATED = 'OFFER_STEP_OFFER_CREATED',
  OFFER_STEP_POST_DV_DECISION = 'OFFER_STEP_POST_DV_DECISION',
  OFFER_STEP_UNDERWRITING = 'OFFER_STEP_UNDERWRITING',
  OFFER_STEP_UNKNOWN = 'OFFER_STEP_UNKNOWN'
}

/**
 * Sell Direct offer price types
 * Next ID: 2
 */
export enum OdProtosWebDataSellDirect_PriceType {
  /** final close of escrow fee */
  CLOSE_OF_ESCROW_FEE = 'CLOSE_OF_ESCROW_FEE',
  /** proposed close of escrow fee */
  REQUESTED_CLOSE_OF_ESCROW_FEE = 'REQUESTED_CLOSE_OF_ESCROW_FEE',
  UNKNOWN_PRICE_TYPE = 'UNKNOWN_PRICE_TYPE'
}

/**
 * Next ID: 8
 * SoT for key events throughout a customer's sell direct experience
 */
export enum OdProtosWebDataSellDirect_SellDirectEventType {
  /** The customer's final offer has been sent. Occurs after underwriting has been completed. */
  FINAL_OFFER_SENT = 'FINAL_OFFER_SENT',
  /** The customer has viewed their final offer. Correlates with the "accepted" offer state. */
  FINAL_OFFER_VIEWED = 'FINAL_OFFER_VIEWED',
  /** The customer has completed the transaction with Opendoor. Correlates with the "closed" offer state. */
  OFFER_CLOSED = 'OFFER_CLOSED',
  /** The customer has signed the purchase agreement. Correlates with the "contingency_released" offer state. */
  OFFER_CONTINGENCY_RELEASED = 'OFFER_CONTINGENCY_RELEASED',
  /** The customer did not sign the purchase agreement in the allotted time. Correlates with the "expired" offer state. */
  OFFER_EXPIRED = 'OFFER_EXPIRED',
  /** The transaction has been canceled by Opendoor or the customer after the contract has been signed. Correlates with the "withdrawn" offer state. */
  OFFER_WITHDRAWN = 'OFFER_WITHDRAWN',
  /** The customer's preliminary offer has been sent. Correlates with the "sent" offer state. */
  PRELIM_OFFER_SENT = 'PRELIM_OFFER_SENT',
  UNKNOWN = 'UNKNOWN'
}

/** Addendum types are defined in web/config/addendum_types.yml.erb */
export enum OdProtosWebData_AddendumType {
  APPLIANCES_ADDENDUM = 'APPLIANCES_ADDENDUM',
  CHANGE_ASSESSMENT_ASK_DUE = 'CHANGE_ASSESSMENT_ASK_DUE',
  CLOSE_OF_ESCROW = 'CLOSE_OF_ESCROW',
  CREDIT_TO_SELLER = 'CREDIT_TO_SELLER',
  CREDIT_TO_SELLER_CENTS = 'CREDIT_TO_SELLER_CENTS',
  LCO_TERMINATION_ADDENDUM = 'LCO_TERMINATION_ADDENDUM',
  OPTION_EXPIRATION_DATE = 'OPTION_EXPIRATION_DATE',
  OTHER = 'OTHER',
  SELLER_AGENT_DISCLOSURE = 'SELLER_AGENT_DISCLOSURE',
  SELLER_COMPLETED_REPAIR_CREDIT = 'SELLER_COMPLETED_REPAIR_CREDIT',
  SELLER_CONTINGENCY_RETURN_CREDIT = 'SELLER_CONTINGENCY_RETURN_CREDIT',
  SELLER_CREDIT_TO_BUYER = 'SELLER_CREDIT_TO_BUYER',
  SELLER_NAME_CHANGE = 'SELLER_NAME_CHANGE',
  TRADE_IN_INCENTIVE_CREDIT = 'TRADE_IN_INCENTIVE_CREDIT'
}

export enum OdProtosWebData_AvailabityCalendarType {
  ASSESSMENT_VISIT = 'ASSESSMENT_VISIT',
  DILIGENCE_VISIT = 'DILIGENCE_VISIT',
  UNKNOWN_VISIT = 'UNKNOWN_VISIT'
}

export enum OdProtosWebData_CoeChangeReason {
  HOA = 'HOA',
  OD_FWT_MISS = 'OD_FWT_MISS',
  OD_INSP_AVAILABILITY = 'OD_INSP_AVAILABILITY',
  OD_NEGOTIATING_REPAIRS = 'OD_NEGOTIATING_REPAIRS',
  OD_OTHER = 'OD_OTHER',
  OD_REPAIRS_NOT_READY = 'OD_REPAIRS_NOT_READY',
  SELLER_CHANGE_IN_PLANS = 'SELLER_CHANGE_IN_PLANS',
  SELLER_HANDLING_REPAIRS = 'SELLER_HANDLING_REPAIRS',
  SELLER_INFORMATION_SHEET = 'SELLER_INFORMATION_SHEET',
  SELLER_MOVING_ISSUE = 'SELLER_MOVING_ISSUE',
  SELLER_NEXT_HOME = 'SELLER_NEXT_HOME',
  SELLER_OTHER = 'SELLER_OTHER',
  SELLER_UNREALISTIC_COE = 'SELLER_UNREALISTIC_COE',
  SELLER_UNRESPONSIVE = 'SELLER_UNRESPONSIVE',
  SOLAR_TRANSFER = 'SOLAR_TRANSFER',
  TITLE_CLOSING_APPT = 'TITLE_CLOSING_APPT',
  TITLE_COMMITMENT = 'TITLE_COMMITMENT',
  TITLE_FUNDING = 'TITLE_FUNDING',
  TITLE_HOA = 'TITLE_HOA',
  TITLE_MORTGAGE_PAYOFF = 'TITLE_MORTGAGE_PAYOFF',
  TITLE_OTHER = 'TITLE_OTHER',
  TITLE_SURVEY = 'TITLE_SURVEY',
  TITLE_UNRESPONSIVE = 'TITLE_UNRESPONSIVE'
}

export type OdProtosWebData_CoeChangeRequestInput = {
  changeReason?: InputMaybe<OdProtosWebData_CoeChangeReason>;
  newCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebData_CancellationRequestInput = {
  primaryReason?: InputMaybe<OdProtosWebData_PrimaryCancellationReason>;
  secondaryReason?: InputMaybe<OdProtosWebData_CancellationRequest_SecondaryReasonOneofInput>;
};

export type OdProtosWebData_CancellationRequest_SecondaryReasonOneofInput = {
  opendoorWalkReason?: InputMaybe<OdProtosWebData_OpendoorWalkSecondaryCancellationReason>;
  sellerInitiatedReason?: InputMaybe<OdProtosWebData_SellerInitiatedSecondaryCancellationReason>;
};

export enum OdProtosWebData_CommunicationType {
  /** coming soon: phone comm types */
  EMAIL_CONVERSATION = 'EMAIL_CONVERSATION'
}

export enum OdProtosWebData_Customer_TrustLevel {
  ALLOW = 'ALLOW',
  DENY = 'DENY',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  REQUIRES_VERIFICATION = 'REQUIRES_VERIFICATION',
  UNRESTRICTED = 'UNRESTRICTED'
}

export enum OdProtosWebData_DiligenceVisitStep_DiligenceVisitState {
  COMPLETED = 'COMPLETED',
  IN_REVIEW = 'IN_REVIEW',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  SCHEDULED = 'SCHEDULED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosWebData_DiligenceVisitType {
  DILIGENCE_VISIT_TYPE_INSPECTIFY = 'DILIGENCE_VISIT_TYPE_INSPECTIFY',
  DILIGENCE_VISIT_TYPE_OPENDOOR = 'DILIGENCE_VISIT_TYPE_OPENDOOR',
  DILIGENCE_VISIT_TYPE_UNKNOWN = 'DILIGENCE_VISIT_TYPE_UNKNOWN'
}

/** Next ID: 7 */
export enum OdProtosWebData_DocumentSource_Type {
  CUSTARD_CUSTOMER = 'CUSTARD_CUSTOMER',
  HUMAN = 'HUMAN',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  MESSAGE_THREAD = 'MESSAGE_THREAD',
  ORGANIZATION = 'ORGANIZATION',
  TASKS_HELLO_SIGN_TASK = 'TASKS_HELLO_SIGN_TASK',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebData_DocumentType {
  ACQ_OUTBOUND_ADDENDUM = 'ACQ_OUTBOUND_ADDENDUM',
  ADDENDUM = 'ADDENDUM',
  CHANGE_CLOSE_OF_ESCROW_ADDENDUM = 'CHANGE_CLOSE_OF_ESCROW_ADDENDUM',
  COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM = 'COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM',
  LATE_CHECKOUT_ADDENDUM = 'LATE_CHECKOUT_ADDENDUM',
  REPAIR_ADDENDUM = 'REPAIR_ADDENDUM'
}

/** Next ID: 8 */
export enum OdProtosWebData_Document_SourceChannel {
  /** @deprecated No longer supported */
  BWOD_CHANNEL = 'BWOD_CHANNEL',
  CLOSING_DASHBOARD_CHANNEL = 'CLOSING_DASHBOARD_CHANNEL',
  HELLO_SIGN_TASK_CHANNEL = 'HELLO_SIGN_TASK_CHANNEL',
  NOMAD_CHANNEL = 'NOMAD_CHANNEL',
  OFFER_PORTAL_CHANNEL = 'OFFER_PORTAL_CHANNEL',
  RESALE_CLOSING_DASHBOARD_CHANNEL = 'RESALE_CLOSING_DASHBOARD_CHANNEL',
  SETTLER_CHANNEL = 'SETTLER_CHANNEL',
  TOOLING_HUB_CHANNEL = 'TOOLING_HUB_CHANNEL',
  UNKNOWN_CHANNEL = 'UNKNOWN_CHANNEL'
}

/** Next ID: 186 */
export enum OdProtosWebData_Document_Type {
  ABAD = 'ABAD',
  ACQ_AGENT_REFERRAL_FORM = 'ACQ_AGENT_REFERRAL_FORM',
  ACQ_DEED = 'ACQ_DEED',
  ACQ_EMR = 'ACQ_EMR',
  ACQ_FINAL_SETTLEMENT_STATEMENT = 'ACQ_FINAL_SETTLEMENT_STATEMENT',
  ACQ_HOA_DEMAND = 'ACQ_HOA_DEMAND',
  ACQ_HOA_GOVERNING_DOCS = 'ACQ_HOA_GOVERNING_DOCS',
  ACQ_HOA_RECEIPT = 'ACQ_HOA_RECEIPT',
  ACQ_LAND_SURVEY = 'ACQ_LAND_SURVEY',
  ACQ_NATURAL_HAZARD_DISCLOSURE = 'ACQ_NATURAL_HAZARD_DISCLOSURE',
  ACQ_OUTBOUND_ADDENDUM = 'ACQ_OUTBOUND_ADDENDUM',
  ACQ_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT = 'ACQ_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT',
  ACQ_TAX_CERTIFICATE = 'ACQ_TAX_CERTIFICATE',
  ACQ_TITLE_COMMITMENT = 'ACQ_TITLE_COMMITMENT',
  ACQ_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT = 'ACQ_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT',
  ADDENDUM = 'ADDENDUM',
  AGENT_REFERRAL_W9 = 'AGENT_REFERRAL_W9',
  AMENDMENT = 'AMENDMENT',
  APPRAISAL_REPORT = 'APPRAISAL_REPORT',
  ASSESSMENT_REPORT = 'ASSESSMENT_REPORT',
  AVID_BUYER = 'AVID_BUYER',
  AVID_SELLER = 'AVID_SELLER',
  BINDING_COUNTER_OFFER = 'BINDING_COUNTER_OFFER',
  BINSR = 'BINSR',
  BRN_CREDIT_ADDENDUM = 'BRN_CREDIT_ADDENDUM',
  BRN_RESPONSE = 'BRN_RESPONSE',
  BROKER_PRICE_OPINION = 'BROKER_PRICE_OPINION',
  BUYER_CLOSING_DOCS = 'BUYER_CLOSING_DOCS',
  CANCEL_BINSR = 'CANCEL_BINSR',
  CASH_AGREEMENT = 'CASH_AGREEMENT',
  CASH_PLUS_AGREEMENT = 'CASH_PLUS_AGREEMENT',
  CCR = 'CCR',
  CHANGE_CLOSE_OF_ESCROW_ADDENDUM = 'CHANGE_CLOSE_OF_ESCROW_ADDENDUM',
  CHECKLIST_HOA_SOU = 'CHECKLIST_HOA_SOU',
  CIC_RECEIPT = 'CIC_RECEIPT',
  CLOSING_STATEMENT_FOR_APPROVAL = 'CLOSING_STATEMENT_FOR_APPROVAL',
  CLUE = 'CLUE',
  COMBINED = 'COMBINED',
  COMBINED_FILE = 'COMBINED_FILE',
  COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM = 'COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM',
  COMMISSION_INSTRUCTIONS = 'COMMISSION_INSTRUCTIONS',
  CONFIRMATION_OF_NO_HOA = 'CONFIRMATION_OF_NO_HOA',
  CONTINGENCY = 'CONTINGENCY',
  CONTINGENCY_REMOVAL = 'CONTINGENCY_REMOVAL',
  COUNTER = 'COUNTER',
  DEED = 'DEED',
  DILIGENCE_VISIT_FLOOR_PLAN = 'DILIGENCE_VISIT_FLOOR_PLAN',
  DILIGENCE_VISIT_HOME_INSPECTION = 'DILIGENCE_VISIT_HOME_INSPECTION',
  EOI = 'EOI',
  FINALIZE_BINSR = 'FINALIZE_BINSR',
  FINAL_OFFER_PDF = 'FINAL_OFFER_PDF',
  FINAL_REPAIR_ASK = 'FINAL_REPAIR_ASK',
  FINAL_SETTLEMENT_STATEMENT = 'FINAL_SETTLEMENT_STATEMENT',
  FIRPTA = 'FIRPTA',
  HOA = 'HOA',
  HOA_ADDENDUM = 'HOA_ADDENDUM',
  HOA_BUYER_APPROVAL = 'HOA_BUYER_APPROVAL',
  HOA_CCRS = 'HOA_CCRS',
  HOA_CCR_AMENDMENT = 'HOA_CCR_AMENDMENT',
  HOA_DEMAND = 'HOA_DEMAND',
  HOA_DEMAND_SUB = 'HOA_DEMAND_SUB',
  HOA_ESTOPPEL_LETTER_UPDATED = 'HOA_ESTOPPEL_LETTER_UPDATED',
  HOA_PACKAGE = 'HOA_PACKAGE',
  HOA_STATUS_LETTER = 'HOA_STATUS_LETTER',
  HOA_VIOLATION_RESOLUTION = 'HOA_VIOLATION_RESOLUTION',
  HOME_CONDITION_BRANDED = 'HOME_CONDITION_BRANDED',
  HOME_CONDITION_UNBRANDED = 'HOME_CONDITION_UNBRANDED',
  HOME_WARRANTY_INVOICE = 'HOME_WARRANTY_INVOICE',
  INITIAL_BINSR_REQUEST = 'INITIAL_BINSR_REQUEST',
  INITIAL_REPAIR_ASK = 'INITIAL_REPAIR_ASK',
  INSPECTION_REPORT_ELECTRICAL = 'INSPECTION_REPORT_ELECTRICAL',
  INSPECTION_REPORT_FOUNDATION = 'INSPECTION_REPORT_FOUNDATION',
  INSPECTION_REPORT_GENERAL = 'INSPECTION_REPORT_GENERAL',
  INSPECTION_REPORT_HVAC = 'INSPECTION_REPORT_HVAC',
  INSPECTION_REPORT_OTHER = 'INSPECTION_REPORT_OTHER',
  INSPECTION_REPORT_PLUMBING = 'INSPECTION_REPORT_PLUMBING',
  INSPECTION_REPORT_POOL = 'INSPECTION_REPORT_POOL',
  INSPECTION_REPORT_ROOF = 'INSPECTION_REPORT_ROOF',
  INSPECTION_REPORT_SHERLOCK = 'INSPECTION_REPORT_SHERLOCK',
  INSPECTION_REPORT_TERMITE = 'INSPECTION_REPORT_TERMITE',
  INSURANCE_CLAIM = 'INSURANCE_CLAIM',
  INVOICE = 'INVOICE',
  LAND_SURVEY = 'LAND_SURVEY',
  LATE_CHECKOUT_ADDENDUM = 'LATE_CHECKOUT_ADDENDUM',
  LBP_ADDENDUM = 'LBP_ADDENDUM',
  LEASED_FIXTURES = 'LEASED_FIXTURES',
  LIEN_SEARCH = 'LIEN_SEARCH',
  LIGHTWEIGHT_PURCHASE_AGREEMENT = 'LIGHTWEIGHT_PURCHASE_AGREEMENT',
  LISTING_DISCLOSURE = 'LISTING_DISCLOSURE',
  LISTING_PACKET = 'LISTING_PACKET',
  LOSS_HISTORY_REPORT = 'LOSS_HISTORY_REPORT',
  /** @deprecated No longer supported */
  LWOD_OFFER_REVIEW = 'LWOD_OFFER_REVIEW',
  MARKET_CONDITIONS_ADVISORY = 'MARKET_CONDITIONS_ADVISORY',
  MEASUREMENT_REPORT = 'MEASUREMENT_REPORT',
  MINERAL_OIL_GAS = 'MINERAL_OIL_GAS',
  MISC = 'MISC',
  NAME_CHANGE = 'NAME_CHANGE',
  NON_BINDING_COUNTER_OFFER = 'NON_BINDING_COUNTER_OFFER',
  NON_REQUIRED_DOCS = 'NON_REQUIRED_DOCS',
  OD_ADDENDUM = 'OD_ADDENDUM',
  OD_GUARANTEE = 'OD_GUARANTEE',
  OD_SERVICES_ADDENDUM = 'OD_SERVICES_ADDENDUM',
  OUTBOUND_PURCHASE_AGREEMENT = 'OUTBOUND_PURCHASE_AGREEMENT',
  OWNERS_POLICY = 'OWNERS_POLICY',
  /** NOTE, DIFFERENT THAN THE RUBY NAME CAUSE &'s DON'T TRANSLATE WELL */
  O_AND_E_RECEIPT = 'O_AND_E_RECEIPT',
  PREPARED_DEED = 'PREPARED_DEED',
  PREQUAL = 'PREQUAL',
  PROOF_OF_FUNDS = 'PROOF_OF_FUNDS',
  PROPERTY_DISCLOSURE = 'PROPERTY_DISCLOSURE',
  PROPOSED_AMENDMENT = 'PROPOSED_AMENDMENT',
  PTL = 'PTL',
  PURCHASE_AGREEMENT = 'PURCHASE_AGREEMENT',
  PURCHASE_AGREEMENT_TERMINATION = 'PURCHASE_AGREEMENT_TERMINATION',
  REALTOR_DISCLOSURE = 'REALTOR_DISCLOSURE',
  REIT_RESALE_PURCHASE_CONTRACT = 'REIT_RESALE_PURCHASE_CONTRACT',
  REJECTED_SETTLEMENT_STATEMENT = 'REJECTED_SETTLEMENT_STATEMENT',
  RENOVATION_PROPOSAL = 'RENOVATION_PROPOSAL',
  REPAIR_ADDENDUM = 'REPAIR_ADDENDUM',
  RESALE_ADDENDUM = 'RESALE_ADDENDUM',
  RESALE_EMR = 'RESALE_EMR',
  RESALE_FINAL_SETTLEMENT_STATEMENT = 'RESALE_FINAL_SETTLEMENT_STATEMENT',
  RESALE_SIGNED_SELLER_CLOSING_DOCS = 'RESALE_SIGNED_SELLER_CLOSING_DOCS',
  RS_ADDENDUM = 'RS_ADDENDUM',
  RS_ADDENDUM_CONTINGENCY = 'RS_ADDENDUM_CONTINGENCY',
  RS_ADDENDUM_HOA = 'RS_ADDENDUM_HOA',
  RS_ADDENDUM_LBP = 'RS_ADDENDUM_LBP',
  RS_ADDENDUM_MINERAL_OIL_GAS = 'RS_ADDENDUM_MINERAL_OIL_GAS',
  RS_ADDENDUM_TPF = 'RS_ADDENDUM_TPF',
  RS_AGENT_REFERRAL_FORM = 'RS_AGENT_REFERRAL_FORM',
  RS_AMENDMENT = 'RS_AMENDMENT',
  RS_BRN_CREDIT_ADDENDUM = 'RS_BRN_CREDIT_ADDENDUM',
  RS_BRN_FINAL = 'RS_BRN_FINAL',
  RS_BRN_FINAL_CREDIT_ADDENDUM = 'RS_BRN_FINAL_CREDIT_ADDENDUM',
  RS_BRN_INITIAL = 'RS_BRN_INITIAL',
  RS_BUYER_CLOSING_DOCS = 'RS_BUYER_CLOSING_DOCS',
  RS_BUYER_INSPECTION_FOUNDATION = 'RS_BUYER_INSPECTION_FOUNDATION',
  RS_BUYER_INSPECTION_GENERAL = 'RS_BUYER_INSPECTION_GENERAL',
  RS_BUYER_INSPECTION_HVAC = 'RS_BUYER_INSPECTION_HVAC',
  RS_BUYER_INSPECTION_OTHER = 'RS_BUYER_INSPECTION_OTHER',
  RS_BUYER_INSPECTION_ROOF = 'RS_BUYER_INSPECTION_ROOF',
  RS_BUYER_INSPECTION_TERMITE = 'RS_BUYER_INSPECTION_TERMITE',
  RS_CANCEL_DOCUMENT = 'RS_CANCEL_DOCUMENT',
  RS_CIC_RECEIPT = 'RS_CIC_RECEIPT',
  RS_COUNTER = 'RS_COUNTER',
  RS_CURE_NOTICE = 'RS_CURE_NOTICE',
  RS_DEED = 'RS_DEED',
  RS_FHA_LOAN_AMENDATORY = 'RS_FHA_LOAN_AMENDATORY',
  RS_FINAL_SETTLEMENT_STATEMENT = 'RS_FINAL_SETTLEMENT_STATEMENT',
  RS_HOA_DEMAND = 'RS_HOA_DEMAND',
  RS_HOA_DOCS = 'RS_HOA_DOCS',
  RS_HOA_RECEIPT = 'RS_HOA_RECEIPT',
  RS_HOME_WARRANTY_INVOICE = 'RS_HOME_WARRANTY_INVOICE',
  RS_LAND_SURVEY = 'RS_LAND_SURVEY',
  RS_LOAN_STATUS_UPDATE = 'RS_LOAN_STATUS_UPDATE',
  RS_NATURAL_HAZARD_DISCLOSURE = 'RS_NATURAL_HAZARD_DISCLOSURE',
  RS_PRE_CLOSE_WALKTHROUGH = 'RS_PRE_CLOSE_WALKTHROUGH',
  RS_REALTOR_DISCLOSURE_AGENCY = 'RS_REALTOR_DISCLOSURE_AGENCY',
  RS_RECEIPT_EM = 'RS_RECEIPT_EM',
  RS_RECEIPT_OTHER = 'RS_RECEIPT_OTHER',
  RS_SELLER_SIGNED_CLOSING_DOCS = 'RS_SELLER_SIGNED_CLOSING_DOCS',
  RS_SURVEY = 'RS_SURVEY',
  RS_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT = 'RS_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT',
  RS_TAX_CERTIFICATE = 'RS_TAX_CERTIFICATE',
  RS_TITLE_COMMITMENT = 'RS_TITLE_COMMITMENT',
  RS_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT = 'RS_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT',
  RS_USER_MISC = 'RS_USER_MISC',
  RS_VA_LOAN_AMENDATORY = 'RS_VA_LOAN_AMENDATORY',
  RS_W9 = 'RS_W9',
  SELLER_DISCLOSURES = 'SELLER_DISCLOSURES',
  SEPTIC_PERMIT = 'SEPTIC_PERMIT',
  SHERLOCK_ASSESSMENT_REPORT = 'SHERLOCK_ASSESSMENT_REPORT',
  SOLAR_INFORMATION = 'SOLAR_INFORMATION',
  SOLAR_MISC = 'SOLAR_MISC',
  SOLAR_PAYOFF = 'SOLAR_PAYOFF',
  SOLAR_TRANSFER_AGREEMENT = 'SOLAR_TRANSFER_AGREEMENT',
  SPDS = 'SPDS',
  STATE_OR_COUNTY_DISCLOSURES = 'STATE_OR_COUNTY_DISCLOSURES',
  SWU_ESTIMATED_NET_SHEET_PDF = 'SWU_ESTIMATED_NET_SHEET_PDF',
  TAX_CERTIFICATE = 'TAX_CERTIFICATE',
  /** @deprecated No longer supported */
  THIRD_PARTY_ADDENDUM = 'THIRD_PARTY_ADDENDUM',
  TITLE_COMMITMENT = 'TITLE_COMMITMENT',
  TITLE_COMPANY_CHANGE = 'TITLE_COMPANY_CHANGE',
  TITLE_DISCLOSURE = 'TITLE_DISCLOSURE',
  TRUTH_IN_SALE_OF_HOUSING_INSPECTION = 'TRUTH_IN_SALE_OF_HOUSING_INSPECTION',
  UCC_TERMINATION = 'UCC_TERMINATION',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT'
}

/** Next ID: 3 */
export type OdProtosWebData_DocumentableInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosWebData_Documentable_Type>;
};

/** Next ID: 13 */
export enum OdProtosWebData_Documentable_Type {
  BRN = 'BRN',
  BROKERAGE_OFFER = 'BROKERAGE_OFFER',
  CONSTRUCTION_WORK_ORDER = 'CONSTRUCTION_WORK_ORDER',
  FLIP = 'FLIP',
  HOME_CONDITION_REPORT = 'HOME_CONDITION_REPORT',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  INVOICE = 'INVOICE',
  LISTING = 'LISTING',
  LISTING_OFFER = 'LISTING_OFFER',
  MAINTENANCE_SCHEDULE = 'MAINTENANCE_SCHEDULE',
  OFFER = 'OFFER',
  UNKNOWN = 'UNKNOWN',
  WORK_ORDER = 'WORK_ORDER',
  WORK_ORDER_ITEM = 'WORK_ORDER_ITEM'
}

export enum OdProtosWebData_EnsembledValuation_Methodology {
  LIST_PRICE = 'LIST_PRICE',
  UNDERWRITING = 'UNDERWRITING',
  UNKNOWN_METHODOLOGY = 'UNKNOWN_METHODOLOGY'
}

export enum OdProtosWebData_EnsembledValuation_Status {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  ESCALATED = 'ESCALATED',
  IN_PROGRESS = 'IN_PROGRESS',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

/** Next ID: 9 */
export enum OdProtosWebData_ExperimentsEnum {
  GUARANTEE_AT_PRELIM_OFFER = 'GUARANTEE_AT_PRELIM_OFFER',
  LWC_WITH_ALA = 'LWC_WITH_ALA',
  MSRE_OFFER_LOCK = 'MSRE_OFFER_LOCK',
  NO_VIRTUAL_ASSESSMENT = 'NO_VIRTUAL_ASSESSMENT',
  /** @deprecated No longer supported */
  OFFER_CALENDAR = 'OFFER_CALENDAR',
  SELLER_LOW_OFFER_CONFIDENCE = 'SELLER_LOW_OFFER_CONFIDENCE',
  SELL_THREE_WAYS_MVP_EXPERIENCE = 'SELL_THREE_WAYS_MVP_EXPERIENCE',
  /** @deprecated No longer supported */
  SELL_YOUR_WAY_INCLUDE_CASH_PLUS = 'SELL_YOUR_WAY_INCLUDE_CASH_PLUS',
  UNKNOWN_EXPERIMENT = 'UNKNOWN_EXPERIMENT'
}

/** Next ID: 4 */
export enum OdProtosWebData_ExteriorAssessmentCustomerNotification_NotificationType {
  ALL = 'ALL',
  ARRIVAL_NOTIFICATION = 'ARRIVAL_NOTIFICATION',
  PREVIOUS_DAY_NOTIFICATION = 'PREVIOUS_DAY_NOTIFICATION',
  SCAN_EXPLAINER = 'SCAN_EXPLAINER'
}

/** Next ID: 2 */
export enum OdProtosWebData_ExteriorAssessmentCustomerNotification_Status {
  FAILED = 'FAILED',
  SENT = 'SENT'
}

export enum OdProtosWebData_ExternalListingWeeklyFeedback_State {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

/** Next ID: 2 */
export enum OdProtosWebData_FeatureFlagEnum {
  UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING = 'UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING',
  UNKNOWN_FEATURE_FLAG = 'UNKNOWN_FEATURE_FLAG'
}

export enum OdProtosWebData_FileUploadTask_FileType {
  DOCUMENT = 'DOCUMENT',
  UNKNOWN_FILE_TYPE = 'UNKNOWN_FILE_TYPE',
  VIDEO = 'VIDEO'
}

/**
 * The order of these states matters as HighWaterMark in web uses
 * the indices in `at_or_above_mark`? If you have to insert a state in
 * the middle, you may have to rewrite the initializer code for the STATES
 * member of Flips in web, as it currently uses the protobuf values for
 * ordering so any new states will end up at the end.
 */
export enum OdProtosWebData_FlipState {
  /** @deprecated No longer supported */
  ACQ_ACCEPTED_LWOD = 'ACQ_ACCEPTED_LWOD',
  ACQ_ACCEPTED_OTHER = 'ACQ_ACCEPTED_OTHER',
  ACQ_EXPIRED = 'ACQ_EXPIRED',
  ACQ_WITHDRAWN = 'ACQ_WITHDRAWN',
  CONTINGENCIES_RELEASED = 'CONTINGENCIES_RELEASED',
  DENIED = 'DENIED',
  EARLY_ACCESS = 'EARLY_ACCESS',
  IN_CONTRACT = 'IN_CONTRACT',
  IN_RENOVATION = 'IN_RENOVATION',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  LISTED = 'LISTED',
  OFFERED = 'OFFERED',
  OFFER_REQUESTED = 'OFFER_REQUESTED',
  PRE_LISTING = 'PRE_LISTING',
  PRE_RENOVATION = 'PRE_RENOVATION',
  /** @deprecated No longer supported */
  REFERRED_TO_MARKETPLACE = 'REFERRED_TO_MARKETPLACE',
  RESALE_CONTINGENCIES_RELEASED = 'RESALE_CONTINGENCIES_RELEASED',
  RESALE_IN_CONTRACT = 'RESALE_IN_CONTRACT',
  RESALE_SOLD_BROKERAGE = 'RESALE_SOLD_BROKERAGE',
  SOLD = 'SOLD',
  /** @deprecated No longer supported */
  THIRD_PARTY_RESALE_CONTINGENCIES_RELEASED = 'THIRD_PARTY_RESALE_CONTINGENCIES_RELEASED',
  /**
   * The 3p states will precede the 1p states for purposes of Web HighWaterMark ordering
   * @deprecated No longer supported
   */
  THIRD_PARTY_RESALE_IN_CONTRACT = 'THIRD_PARTY_RESALE_IN_CONTRACT',
  /** @deprecated No longer supported */
  THIRD_PARTY_SOLD = 'THIRD_PARTY_SOLD',
  /** @deprecated No longer supported */
  THIRD_PARTY_SOLD_BACKED_OFFER = 'THIRD_PARTY_SOLD_BACKED_OFFER',
  UNDEFINED = 'UNDEFINED',
  UNQUALIFIED = 'UNQUALIFIED'
}

/** Next ID: 3 */
export type OdProtosWebData_GetAllowedToReengageParamsInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** last customer interaction date */
  customerInteractionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosWebData_InspectionStep_InspectionStepState {
  COMPLETED = 'COMPLETED',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  SCHEDULED = 'SCHEDULED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosWebData_InspectionStep_InspectionType {
  /**
   * Exterior assessment
   * @deprecated No longer supported
   */
  EA = 'EA',
  /** Expert handoff assessment (e.g. Showami) */
  EXPERT_HANDOFF = 'EXPERT_HANDOFF',
  /** Home assessment */
  HA = 'HA',
  UNKNOWN_INSPECTION_TYPE = 'UNKNOWN_INSPECTION_TYPE'
}

export enum OdProtosWebData_Inspection_Kind {
  ACQUIRE_INITIAL_INSPECTION = 'ACQUIRE_INITIAL_INSPECTION',
  AFTER_RENOVATION_INSPECTION = 'AFTER_RENOVATION_INSPECTION',
  BRN_INSPECTION = 'BRN_INSPECTION',
  OTHER = 'OTHER',
  QUALITY_CONTROL = 'QUALITY_CONTROL',
  SELF_QUALITY_CONTROL = 'SELF_QUALITY_CONTROL',
  TRAINING_INITIAL_INSPECTION = 'TRAINING_INITIAL_INSPECTION',
  UKNOWN = 'UKNOWN'
}

export enum OdProtosWebData_Inspection_State {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  SUBMITTED_FOR_REVIEW = 'SUBMITTED_FOR_REVIEW',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebData_Invoice_State {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  DRAFT = 'DRAFT',
  NOT_KNOWN = 'NOT_KNOWN',
  REQUEST_APPROVED = 'REQUEST_APPROVED',
  SUBMITTED = 'SUBMITTED'
}

/**
 * Request object used by ListLeadsRequest.
 * Next ID: 5
 */
export type OdProtosWebData_LeadIdentifierInput = {
  /** the lead is duplicated out of GetLeadRequest for reuse. */
  lead?: InputMaybe<OdProtosWebData_LeadIdentifier_LeadOneofInput>;
};

export type OdProtosWebData_LeadIdentifier_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/**
 * LeadParams represents parameters to query a lead by (e.g. address token and customer uuid).
 * Next ID: 3
 */
export type OdProtosWebData_LeadQueryParamsInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Which system generated the lead.
 * Next ID: 3
 */
export type OdProtosWebData_LeadSourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosWebData_LeadSource_Type>;
};

export enum OdProtosWebData_LeadSource_Type {
  PARTNERSHIP = 'PARTNERSHIP',
  RECEPTION = 'RECEPTION',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

export enum OdProtosWebData_Lead_SellYourWayProduct {
  LIST_WITH_CERTAINTY = 'LIST_WITH_CERTAINTY',
  SELL_DIRECT = 'SELL_DIRECT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebData_LenderInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosWebData_Lender_LenderType>;
};

export enum OdProtosWebData_Lender_LenderType {
  NON_PARTNER = 'NON_PARTNER',
  OPENDOOR_HOME_LOANS = 'OPENDOOR_HOME_LOANS',
  TRUSTED_LENDER = 'TRUSTED_LENDER',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebData_ListingOfferBrn_FollowHomesProcessCode {
  ACTIVE_ISSUES = 'ACTIVE_ISSUES',
  BUYER_CIRCUMSTANCE = 'BUYER_CIRCUMSTANCE',
  BUYER_PREFERENCE = 'BUYER_PREFERENCE',
  COST_DIFFERENCE = 'COST_DIFFERENCE',
  CREDIT_MAX = 'CREDIT_MAX',
  HIGH_COST_BRN_CREDIT = 'HIGH_COST_BRN_CREDIT',
  LENDER_REQUIRED_REPAIRS = 'LENDER_REQUIRED_REPAIRS',
  MAJOR_SYSTEMS_STRUCTURAL = 'MAJOR_SYSTEMS_STRUCTURAL',
  NEGOTIATION = 'NEGOTIATION',
  REPAIRS_IN_CONTRACT = 'REPAIRS_IN_CONTRACT',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebData_ListingOfferDetails_FinancingStatus {
  CASH = 'CASH',
  CONVENTIONAL = 'CONVENTIONAL',
  DONT_KNOW = 'DONT_KNOW',
  FHA_LOAN = 'FHA_LOAN',
  MORTGAGE_PARTNER = 'MORTGAGE_PARTNER',
  TX_VA_LOAN = 'TX_VA_LOAN',
  USDA_LOAN = 'USDA_LOAN',
  VA_LOAN = 'VA_LOAN'
}

export enum OdProtosWebData_ListingOfferDetails_OfferedByType {
  DIRECT_BUYER = 'DIRECT_BUYER',
  MLS_AGENT = 'MLS_AGENT',
  NON_MLS_AGENT = 'NON_MLS_AGENT',
  OFFERED_BY_UNKNOWN = 'OFFERED_BY_UNKNOWN'
}

export enum OdProtosWebData_ListingOfferDetails_StateTransition {
  ACTIVATE_BACKUP = 'ACTIVATE_BACKUP',
  BUYER_WALK = 'BUYER_WALK',
  CANCEL = 'CANCEL',
  CLOSE = 'CLOSE',
  CONTRACT_FALL_THROUGH = 'CONTRACT_FALL_THROUGH',
  ENTER_CONTRACT = 'ENTER_CONTRACT',
  MAKE_BACKUP = 'MAKE_BACKUP',
  NEGOTIATE = 'NEGOTIATE',
  REJECT = 'REJECT',
  RELEASE_CONTINGENCY = 'RELEASE_CONTINGENCY',
  REVERSE_CLOSE = 'REVERSE_CLOSE',
  SEND_CONTRACT = 'SEND_CONTRACT',
  TO_ATTORNEY_REVIEW = 'TO_ATTORNEY_REVIEW',
  UNKNOWN = 'UNKNOWN',
  WAIT_FOR_SIGNATURE = 'WAIT_FOR_SIGNATURE'
}

export enum OdProtosWebData_ListingOfferParticipantType {
  ADDITIONAL_PARTICIPANT = 'ADDITIONAL_PARTICIPANT',
  AGENT_TC_PARTICIPANT = 'AGENT_TC_PARTICIPANT',
  BUYER_2_PARTICIPANT = 'BUYER_2_PARTICIPANT',
  BUYER_PARTICIPANT = 'BUYER_PARTICIPANT',
  CONTACT_PARTICIPANT = 'CONTACT_PARTICIPANT',
  UNKNOWN_PARTICIPANT = 'UNKNOWN_PARTICIPANT'
}

export enum OdProtosWebData_ListingOfferTask_State {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  ERRORED = 'ERRORED',
  PENDING = 'PENDING'
}

export enum OdProtosWebData_ListingOffer_Channel {
  BROKERAGE = 'BROKERAGE',
  /** Deprecated */
  BROKERAGE_REFERRAL = 'BROKERAGE_REFERRAL',
  DIRECT = 'DIRECT',
  /** @deprecated No longer supported */
  EXCLUSIVE = 'EXCLUSIVE',
  /** @deprecated No longer supported */
  EXCLUSIVE_THIRD_PARTY = 'EXCLUSIVE_THIRD_PARTY',
  EXTERNAL = 'EXTERNAL',
  OPENDOOR_BACKED_OFFER_RESALE = 'OPENDOOR_BACKED_OFFER_RESALE',
  REIT = 'REIT'
}

/**
 * Next ID: 10
 * Got the values from: https://github.com/opendoor-labs/web/blob/e24581102256fde2c4e9eea679e574477f123db6/app/models/listing_offer.rb#L67
 */
export enum OdProtosWebData_ListingOffer_Source {
  APP = 'APP',
  /** @deprecated No longer supported */
  BUY_DIRECT = 'BUY_DIRECT',
  /** @deprecated No longer supported */
  BUY_WITH_OPENDOOR = 'BUY_WITH_OPENDOOR',
  /** @deprecated No longer supported */
  EXCLUSIVE_SOURCE = 'EXCLUSIVE_SOURCE',
  EXTERNAL_AGENT = 'EXTERNAL_AGENT',
  MANUAL = 'MANUAL',
  OPEN_LISTINGS = 'OPEN_LISTINGS',
  PORTAL = 'PORTAL',
  REIT_BID = 'REIT_BID',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebData_LowOfferConfidenceVariant {
  CONTROL = 'CONTROL',
  INELIGIBLE = 'INELIGIBLE',
  TREATMENT = 'TREATMENT',
  UNKNOWN_VARIANT = 'UNKNOWN_VARIANT'
}

export type OdProtosWebData_MaintenanceRequest_FrequencyInput = {
  frequencyAmount?: InputMaybe<Scalars['Float']['input']>;
  frequencyKind?: InputMaybe<OdProtosWebData_MaintenanceRequest_FrequencyKind>;
};

export enum OdProtosWebData_MaintenanceRequest_FrequencyKind {
  DAY = 'DAY',
  MONTH = 'MONTH',
  ONE_OFF = 'ONE_OFF',
  WEEK = 'WEEK'
}

export enum OdProtosWebData_MaintenanceRequest_Kind {
  CLEANING = 'CLEANING',
  HVAC = 'HVAC',
  LANDSCAPING = 'LANDSCAPING',
  NONE = 'NONE',
  OTHER = 'OTHER',
  POOL = 'POOL',
  SNOW = 'SNOW'
}

export enum OdProtosWebData_MaintenanceRequest_State {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  DENIED = 'DENIED',
  INVALID = 'INVALID',
  INVOICED = 'INVOICED',
  MISSED = 'MISSED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PENDING = 'PENDING'
}

export enum OdProtosWebData_MaintenanceScheduleState {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  FINISHED = 'FINISHED',
  INVALID = 'INVALID'
}

/** Next ID: 2 */
export enum OdProtosWebData_OrvaCancellationReason {
  CEP_CANNOT_MAKE_IT = 'CEP_CANNOT_MAKE_IT',
  CUSTOMER_CANNOT_MAKE_IT = 'CUSTOMER_CANNOT_MAKE_IT'
}

/** Next ID: 5 */
export enum OdProtosWebData_OrvaState {
  ORVA_ATTEMPTED = 'ORVA_ATTEMPTED',
  ORVA_COMPLETED = 'ORVA_COMPLETED',
  ORVA_EXPIRED = 'ORVA_EXPIRED',
  ORVA_NOT_STARTED = 'ORVA_NOT_STARTED',
  ORVA_SCHEDULED = 'ORVA_SCHEDULED'
}

export enum OdProtosWebData_OrvaStep_OrvaState {
  COMPLETED = 'COMPLETED',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  SCHEDULED = 'SCHEDULED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosWebData_OrvaStep_OrvaSubtype {
  DEFAULT = 'DEFAULT',
  UNKNOWN_ORVA_SUBTYPE = 'UNKNOWN_ORVA_SUBTYPE',
  WITH_EVA = 'WITH_EVA'
}

/** Next ID: 5 */
export enum OdProtosWebData_OccupancyAtVa {
  LIVE_FAR_AWAY = 'LIVE_FAR_AWAY',
  OTHER_OCCUPANCY = 'OTHER_OCCUPANCY',
  OWNER_OCCUPIED = 'OWNER_OCCUPIED',
  TENANT_OCCUPIED = 'TENANT_OCCUPIED',
  UNKNOWN_OCCUPANCY = 'UNKNOWN_OCCUPANCY'
}

/** Next ID: 2 */
export type OdProtosWebData_OfferIdentifiersInput = {
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * OfferQueryParams represents parameters to query offers by (e.g. address token and customer uuid).
 * Next ID: 3
 */
export type OdProtosWebData_OfferQueryParamsInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Using the human token will only retrieve a limited amount of offers (20) for performance reasons
   * You probably want to use a combination of Lead fetching/Offer fetching in order to grab every single offer for a given human
   */
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebData_OfferReviewStep_OfferReviewState {
  /** @deprecated No longer supported */
  COMPLETED = 'COMPLETED',
  /** @deprecated No longer supported */
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  /** @deprecated No longer supported */
  SCHEDULED = 'SCHEDULED',
  /** @deprecated No longer supported */
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosWebData_OfferReviewStep_OfferReviewType {
  /** @deprecated No longer supported */
  DEFAULT = 'DEFAULT',
  /** @deprecated No longer supported */
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  /** @deprecated No longer supported */
  WITH_VIRTUAL_WALKTHROUGH = 'WITH_VIRTUAL_WALKTHROUGH',
  /** @deprecated No longer supported */
  WITH_VIRTUAL_WALKTHROUGH_AND_EVA = 'WITH_VIRTUAL_WALKTHROUGH_AND_EVA'
}

/** Next ID: 16 */
export enum OdProtosWebData_Offer_State {
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_OFFER = 'ACCEPTED_OFFER',
  CLOSED = 'CLOSED',
  CONTINGENCY_RELEASED = 'CONTINGENCY_RELEASED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  /** final offer is ready, but not yet released to the seller */
  FINAL_OFFER_UNRELEASED = 'FINAL_OFFER_UNRELEASED',
  IN_CONTRACT = 'IN_CONTRACT',
  READY_TO_SEND = 'READY_TO_SEND',
  REQUESTED_TO_LIST = 'REQUESTED_TO_LIST',
  SEND_IN_PROGRESS = 'SEND_IN_PROGRESS',
  SENT = 'SENT',
  /** States all defined in web/app/models/offer.rb */
  UNKNOWN = 'UNKNOWN',
  VIEWING = 'VIEWING',
  /** @deprecated No longer supported */
  WAITING_FOR_LIST_WITH_CERTAINTY = 'WAITING_FOR_LIST_WITH_CERTAINTY',
  /** @deprecated No longer supported */
  WAITING_FOR_OTHER_OFFERS = 'WAITING_FOR_OTHER_OFFERS',
  WITHDRAWN = 'WITHDRAWN'
}

/** Deprecated: Use od_protos.common.sell.OpendoorWalkReason */
export enum OdProtosWebData_OpendoorWalkSecondaryCancellationReason {
  ADJACENT_TO_STABILIZATION = 'ADJACENT_TO_STABILIZATION',
  FAILED_ELIGIBILITY_RECHECK = 'FAILED_ELIGIBILITY_RECHECK',
  OPENDOOR_ADDENDUM = 'OPENDOOR_ADDENDUM',
  PRICING_UNCERTAINTY = 'PRICING_UNCERTAINTY',
  REPAIR_ASSESSMENT_INCOMPLETE = 'REPAIR_ASSESSMENT_INCOMPLETE',
  REPAIR_SCOPE_OF_WORK_TOO_LARGE = 'REPAIR_SCOPE_OF_WORK_TOO_LARGE',
  SEE_UNDERWRITING = 'SEE_UNDERWRITING'
}

/** Next ID: 7 */
export type OdProtosWebData_ParticipantInput = {
  /** Time the participant was created at */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  humanId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<OdProtosWebData_ParticipantRole>>;
};

/** List of known participant roles in web, from web/app/models/concerns/participant_roles.rb */
export enum OdProtosWebData_ParticipantRole {
  ACQ_AE = 'ACQ_AE',
  ACQ_AGENT = 'ACQ_AGENT',
  ACQ_CX = 'ACQ_CX',
  ACQ_EM = 'ACQ_EM',
  ACQ_SDR = 'ACQ_SDR',
  ACQ_TC = 'ACQ_TC',
  BROKER = 'BROKER',
  CONSISTENT_VALUATIONS = 'CONSISTENT_VALUATIONS',
  ESTIMATOR = 'ESTIMATOR',
  FINANCE_TC = 'FINANCE_TC',
  HOLDING_SUPPORT = 'HOLDING_SUPPORT',
  HPM = 'HPM',
  INITIATOR = 'INITIATOR',
  OUTLIER_VALUATIONS = 'OUTLIER_VALUATIONS',
  PORTFOLIO_MANAGER = 'PORTFOLIO_MANAGER',
  RENO_MANAGER = 'RENO_MANAGER',
  RESALE_ACX = 'RESALE_ACX',
  RESALE_AGENT = 'RESALE_AGENT',
  RESALE_CC = 'RESALE_CC',
  RESALE_CX_SALES = 'RESALE_CX_SALES',
  RESALE_CX_SALES_ASSOCIATE = 'RESALE_CX_SALES_ASSOCIATE',
  RESALE_CX_VISITOR = 'RESALE_CX_VISITOR',
  RESALE_TC = 'RESALE_TC',
  ROLE_UNKNOWN = 'ROLE_UNKNOWN',
  SECURITY_SUPPORT = 'SECURITY_SUPPORT',
  SELLER_PARTICIPANT = 'SELLER_PARTICIPANT',
  SIGNATORY = 'SIGNATORY',
  SOFT_RESALE_ACX = 'SOFT_RESALE_ACX',
  SYSTEM = 'SYSTEM',
  TC_SUPPORT = 'TC_SUPPORT',
  UNDERWRITER = 'UNDERWRITER',
  UTILITY_SUPPORT = 'UTILITY_SUPPORT',
  VALUATIONS = 'VALUATIONS',
  VENDOR_DRIVER = 'VENDOR_DRIVER'
}

/** Next ID: 2 */
export type OdProtosWebData_ParticipantRolesForAccessInput = {
  participantRolesForAccess?: InputMaybe<Array<OdProtosWebData_ParticipantRole>>;
};

export type OdProtosWebData_ParticipantsInput = {
  participants?: InputMaybe<Array<OdProtosWebData_ParticipantInput>>;
};

export enum OdProtosWebData_PostDiligenceAddendumType {
  POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_BUYER = 'POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_BUYER',
  POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_SELLER = 'POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_SELLER',
  POST_DILIGENCE_ADDENDUM_TYPE_UNKNOWN = 'POST_DILIGENCE_ADDENDUM_TYPE_UNKNOWN'
}

/** Deprecated: Use od_protos.common.sell.WalkInitiator */
export enum OdProtosWebData_PrimaryCancellationReason {
  OPENDOOR_WALK = 'OPENDOOR_WALK',
  SELLER_INITIATED = 'SELLER_INITIATED'
}

/** Next ID: 5 */
export enum OdProtosWebData_Reaction {
  OKAY = 'OKAY',
  SATISFIED = 'SATISFIED',
  UNSATISFIED = 'UNSATISFIED',
  VERY_SATISFIED = 'VERY_SATISFIED',
  VERY_UNSATISFIED = 'VERY_UNSATISFIED'
}

/**
 * The enum here should match with the following defined in Web
 * https://github.com/opendoor-labs/web/blob/4ec863aaf36a82b0c9df10b4de196020d142c7c6/app/models/virtual_assessment_recording.rb#L8
 * Next ID: 10
 */
export enum OdProtosWebData_RecordedFeature {
  BACKYARD = 'BACKYARD',
  FRONTYARD = 'FRONTYARD',
  INTERIOR = 'INTERIOR',
  KITCHEN = 'KITCHEN',
  LIVING_ROOM = 'LIVING_ROOM',
  MASTER_BEDROOM_AND_BATHROOM = 'MASTER_BEDROOM_AND_BATHROOM',
  SELLER_DISCLOSURE_DOCUMENT = 'SELLER_DISCLOSURE_DOCUMENT',
  UNKNOWN_RECORDED_FEATURE = 'UNKNOWN_RECORDED_FEATURE',
  UTILITIES = 'UTILITIES',
  WHOLE_HOME = 'WHOLE_HOME'
}

/** From https://github.com/opendoor-labs/web/blob/0d7f7ed424/app/models/renovation.rb#L11-L17 */
export enum OdProtosWebData_Renovation_State {
  /** "canceled" */
  CANCELED = 'CANCELED',
  /** "completed" */
  COMPLETED = 'COMPLETED',
  /** "draft" */
  DRAFT = 'DRAFT',
  /** "in_progress" */
  IN_PROGRESS = 'IN_PROGRESS',
  /** "setup_completed" */
  SETUP_COMPLETED = 'SETUP_COMPLETED',
  /** Does not correspond to any state web/models/renovation.rb */
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebData_RepairAdjustmentInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebData_ResaleConcessionInput = {
  costCents?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosWebData_ResaleConcession_ConcessionType>;
};

export enum OdProtosWebData_ResaleConcession_ConcessionType {
  APPRAISAL = 'APPRAISAL',
  BUYER_AGENT_CONCESSIONS = 'BUYER_AGENT_CONCESSIONS',
  BUYER_BROKERAGE_PAYMENT = 'BUYER_BROKERAGE_PAYMENT',
  CLOSING_COSTS = 'CLOSING_COSTS',
  COE_EXTENSION_EXPENSES = 'COE_EXTENSION_EXPENSES',
  DIRECT_BUYER_INCENTIVE = 'DIRECT_BUYER_INCENTIVE',
  EXCLUSIVES_BBC_INCENTIVE = 'EXCLUSIVES_BBC_INCENTIVE',
  MORTGAGE_INCENTIVE = 'MORTGAGE_INCENTIVE',
  OPENDOOR_PAID_IN_THIRD_PARTY_TRANSACTION = 'OPENDOOR_PAID_IN_THIRD_PARTY_TRANSACTION',
  OTHER = 'OTHER',
  RATE_LOCK_FEE = 'RATE_LOCK_FEE',
  REINSPECTION_COSTS = 'REINSPECTION_COSTS'
}

export enum OdProtosWebData_ResaleState {
  RESALE_STATE_LISTED = 'RESALE_STATE_LISTED',
  RESALE_STATE_NOT_LISTED = 'RESALE_STATE_NOT_LISTED',
  RESALE_STATE_SOLD = 'RESALE_STATE_SOLD',
  RESALE_STATE_UNKNOWN = 'RESALE_STATE_UNKNOWN'
}

/** Next ID: 3 */
export enum OdProtosWebData_SsvaState {
  SSVA_COMPLETED = 'SSVA_COMPLETED',
  SSVA_IN_PROGRESS = 'SSVA_IN_PROGRESS',
  SSVA_NOT_STARTED = 'SSVA_NOT_STARTED'
}

export enum OdProtosWebData_SsvaStep_SsvaState {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosWebData_SsvaStep_SsvaSubtype {
  DEFAULT = 'DEFAULT',
  DISCLOSURE = 'DISCLOSURE',
  UNKNOWN_SSVA_SUBTYPE = 'UNKNOWN_SSVA_SUBTYPE',
  WHOLE_HOME = 'WHOLE_HOME'
}

export type OdProtosWebData_ScheduleAssessmentInputInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  /** required */
  selectedAssessmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Scheduling can be done with either seller_input_uuid or offer_uuid */
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional seller contact information */
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebData_ScheduleExteriorAssessmentInputInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  /** required */
  selectedInspectionTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Scheduling can be done with either seller_input_uuid or offer_uuid */
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebData_SellWithUpsideState {
  SWU_ACCEPTED = 'SWU_ACCEPTED',
  SWU_ACQUISITION_PROCEEDS_PAID = 'SWU_ACQUISITION_PROCEEDS_PAID',
  SWU_CREATED = 'SWU_CREATED',
  SWU_DECLINED = 'SWU_DECLINED',
  SWU_ELIGIBLE = 'SWU_ELIGIBLE',
  SWU_NOT_ELIGIBLE = 'SWU_NOT_ELIGIBLE',
  SWU_RESALE_PROCEEDS_PAID = 'SWU_RESALE_PROCEEDS_PAID',
  SWU_UNKNOWN = 'SWU_UNKNOWN',
  SWU_WITHDRAWN = 'SWU_WITHDRAWN'
}

/** Next ID: 2 */
export enum OdProtosWebData_SellerDisclosureState {
  SELLER_DISCLOSURE_COMPLETE = 'SELLER_DISCLOSURE_COMPLETE',
  SELLER_DISCLOSURE_NEEDED = 'SELLER_DISCLOSURE_NEEDED'
}

/** Deprecated: Use od_protos.common.sell.SellerWalkReason */
export enum OdProtosWebData_SellerInitiatedSecondaryCancellationReason {
  CANNOT_FIND_NEW_HOME = 'CANNOT_FIND_NEW_HOME',
  CLOSE_OF_ESCROW_EXTENSION_DENIED = 'CLOSE_OF_ESCROW_EXTENSION_DENIED',
  COMPETITION_OR_INVESTOR_OFFER = 'COMPETITION_OR_INVESTOR_OFFER',
  HOA_SOLAR_CITY_INSPECTION = 'HOA_SOLAR_CITY_INSPECTION',
  HOME_IS_LISTED = 'HOME_IS_LISTED',
  LEGAL_ISSUES = 'LEGAL_ISSUES',
  NET_CASH = 'NET_CASH',
  NOT_SELLING = 'NOT_SELLING',
  OTHER_REASON = 'OTHER_REASON',
  POST_INSPECTION_OPENDOOR_ASK = 'POST_INSPECTION_OPENDOOR_ASK'
}

export enum OdProtosWebData_SpecialFlagType {
  DANGER = 'DANGER',
  DEFAULT = 'DEFAULT',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export enum OdProtosWebData_StructuredTouchpointKind {
  DECISION_CALL = 'DECISION_CALL',
  FINAL_OFFER_2024_REVIEW = 'FINAL_OFFER_2024_REVIEW',
  FINAL_OFFER_REVIEW = 'FINAL_OFFER_REVIEW',
  OFFER_REVIEW = 'OFFER_REVIEW',
  OPTIONS_REVIEW_AND_VIRTUAL_ASSESSMENT = 'OPTIONS_REVIEW_AND_VIRTUAL_ASSESSMENT',
  RESALE_FEEDBACK_FORM = 'RESALE_FEEDBACK_FORM'
}

export type OdProtosWebData_SubsidyRequestInput = {
  amountCents?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<OdProtosWebData_SubsidyType>;
};

export enum OdProtosWebData_SubsidyType {
  /** @deprecated No longer supported */
  AGENT = 'AGENT',
  AGENT_GROWTH = 'AGENT_GROWTH',
  /** @deprecated No longer supported */
  COMPETITOR_MATCH = 'COMPETITOR_MATCH',
  CX_SUBSIDY = 'CX_SUBSIDY',
  /** @deprecated No longer supported */
  EMPLOYEE_SUBSIDY = 'EMPLOYEE_SUBSIDY',
  HERO_CREDIT = 'HERO_CREDIT',
  HOMEBUILDER_GROWTH = 'HOMEBUILDER_GROWTH',
  /** @deprecated No longer supported */
  HOME_BUILDER = 'HOME_BUILDER',
  /** @deprecated No longer supported */
  NEW_PARTNERSHIP = 'NEW_PARTNERSHIP',
  /** @deprecated No longer supported */
  OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE = 'OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE',
  /** @deprecated No longer supported */
  OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE = 'OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE',
  POST_INSPECTION = 'POST_INSPECTION',
  PRE_CONTRACT_MARKETING = 'PRE_CONTRACT_MARKETING',
  PRICING_VAL_SUBSIDY = 'PRICING_VAL_SUBSIDY',
  /** @deprecated No longer supported */
  REPAIR_ADJUSTMENT = 'REPAIR_ADJUSTMENT',
  /** @deprecated No longer supported */
  VAL_CREDIT_SUBSIDY = 'VAL_CREDIT_SUBSIDY'
}

export type OdProtosWebData_TouchpointableInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosWebData_Touchpointable_Type>;
};

export enum OdProtosWebData_Touchpointable_Type {
  ADDRESS = 'ADDRESS',
  LEAD = 'LEAD',
  OFFER = 'OFFER'
}

/** Next ID: 3 */
export enum OdProtosWebData_TradeInIncentiveType {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 3 */
export enum OdProtosWebData_Transaction_OpendoorTransactionType {
  ACQUISITION = 'ACQUISITION',
  RESALE = 'RESALE',
  UNKNOWN_TRANSACTION_TYPE = 'UNKNOWN_TRANSACTION_TYPE'
}

/** Next ID: 8 */
export enum OdProtosWebData_Transaction_State {
  CLOSED = 'CLOSED',
  DISCARDED = 'DISCARDED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  OPEN = 'OPEN',
  REJECTED = 'REJECTED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export enum OdProtosWebData_Transaction_TransactionSource_Web_Type {
  LISTING_OFFER = 'LISTING_OFFER',
  OFFER = 'OFFER',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 6 */
export enum OdProtosWebData_Underwriting_State {
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  ESCALATED = 'ESCALATED',
  /** States defined in web/app/models/underwriting.rb */
  UNKNOWN = 'UNKNOWN',
  WALKED = 'WALKED'
}

/** The source type indicates where this unified valuation was derived from. */
export enum OdProtosWebData_UnifiedValuation_SourceType {
  /** Derived from an EnsembledValuation */
  ENSEMBLED_VALUATION = 'ENSEMBLED_VALUATION',
  /** Derived from a single Valuation */
  SINGLE_VALUATION = 'SINGLE_VALUATION',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE'
}

/** Status enum to check completion state. */
export enum OdProtosWebData_UnifiedValuation_Status {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export enum OdProtosWebData_Valuation_Methodology {
  DESK = 'DESK',
  LIGHT_WITH_COMPS = 'LIGHT_WITH_COMPS',
  LIST_PRICE = 'LIST_PRICE',
  LIST_PRICE_OVERRIDE = 'LIST_PRICE_OVERRIDE',
  LIST_PRICE_REVIEW = 'LIST_PRICE_REVIEW',
  LIST_PRICE_SHADOW = 'LIST_PRICE_SHADOW',
  ODSELECT_POST_RENO = 'ODSELECT_POST_RENO',
  ODSELECT_PRE_RENO = 'ODSELECT_PRE_RENO',
  OVM_DEBUG = 'OVM_DEBUG',
  /** OVM valuation with CubiCasa home details for post-DV pricing review */
  POST_DV = 'POST_DV',
  UNDERWRITING = 'UNDERWRITING',
  UNDERWRITING_ESCALATION = 'UNDERWRITING_ESCALATION',
  UNDERWRITING_SHADOW = 'UNDERWRITING_SHADOW',
  UNKNOWN_METHODOLOGY = 'UNKNOWN_METHODOLOGY',
  VALUATION_REPORT = 'VALUATION_REPORT',
  WALK_OVERRIDE = 'WALK_OVERRIDE'
}

export enum OdProtosWebData_Valuation_Status {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

/** Next ID: 5 */
export type OdProtosWebData_VirtualAssessmentRecordingInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  preSignedRecordingUrl?: InputMaybe<Scalars['String']['input']>;
  recordedFeature?: InputMaybe<OdProtosWebData_RecordedFeature>;
  s3Directory?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebData_VirtualAssessmentStep_VirtualAssessmentType {
  ORVA = 'ORVA',
  SSVA = 'SSVA',
  UNKNOWN_VIRTUAL_ASSESSMENT_TYPE = 'UNKNOWN_VIRTUAL_ASSESSMENT_TYPE',
  /** Either VA type is valid */
  VA = 'VA'
}

/**
 * Defines who is responsible for doing the Virtual Assessment.
 * Next ID: 3
 */
export enum OdProtosWebData_VirtualAssessment_Actor {
  CUSTOMER = 'CUSTOMER',
  /** LWC Partner Agent refers to the partner agent assigned to LWC leads */
  LWC_PARTNER_AGENT = 'LWC_PARTNER_AGENT',
  UNKNOWN_ACTOR = 'UNKNOWN_ACTOR'
}

export enum OdProtosWebData_VirtualAssessment_AssessmentType {
  ORVA = 'ORVA',
  SSVA = 'SSVA',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebEvents_HelloSignContractEvent_Signature_Status {
  AWAITING_SIGNATURE = 'AWAITING_SIGNATURE',
  DECLINED = 'DECLINED',
  SIGNED = 'SIGNED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebEvents_ListingEvent_PreviousState {
  ACTIVE = 'ACTIVE',
  ATTORNEY_REVIEW = 'ATTORNEY_REVIEW',
  CANCELED = 'CANCELED',
  CONTINGENCY_RELEASED = 'CONTINGENCY_RELEASED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  SOLD = 'SOLD',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesAddendum_AddendumsForOfferRequestInput = {
  offerId?: InputMaybe<Scalars['Float']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAddendum_CreateAddendumRequestInput = {
  addendumText?: InputMaybe<Scalars['String']['input']>;
  addendumType?: InputMaybe<OdProtosWebData_AddendumType>;
  documentType?: InputMaybe<OdProtosWebData_DocumentType>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAddendum_CreateCreditToBuyerCombinedAmountAddendumRequestInput = {
  additionalCreditAmountCents?: InputMaybe<Scalars['Float']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  send?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesAddendum_CreatePostDiligenceAddendumRequestInput = {
  addendumText?: InputMaybe<Scalars['String']['input']>;
  addendumType?: InputMaybe<OdProtosWebData_PostDiligenceAddendumType>;
  creditAmountCents?: InputMaybe<Scalars['Float']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  send?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesAddendum_SendPostDiligenceAddendumRequestInput = {
  addendumId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesAgentReferral_CustomerOptionPreference {
  CUSTOMER_OPTION_PREFERENCE_CASH = 'CUSTOMER_OPTION_PREFERENCE_CASH',
  CUSTOMER_OPTION_PREFERENCE_CASH_PLUS = 'CUSTOMER_OPTION_PREFERENCE_CASH_PLUS',
  CUSTOMER_OPTION_PREFERENCE_LIST = 'CUSTOMER_OPTION_PREFERENCE_LIST',
  CUSTOMER_OPTION_PREFERENCE_UNSPECIFIED = 'CUSTOMER_OPTION_PREFERENCE_UNSPECIFIED'
}

/** Next ID: 12 */
export type OdProtosWebServicesAgentReferral_ReferToCleverRealEstateRequestInput = {
  answerBathroomCondition?: InputMaybe<Scalars['String']['input']>;
  answerExteriorCondition?: InputMaybe<Scalars['String']['input']>;
  answerKitchenCondition?: InputMaybe<Scalars['String']['input']>;
  answerLivingRoomCondition?: InputMaybe<Scalars['String']['input']>;
  answerSaleTimeline?: InputMaybe<Scalars['String']['input']>;
  customerOptionPreference?: InputMaybe<OdProtosWebServicesAgentReferral_CustomerOptionPreference>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 6 */
export type OdProtosWebServicesAgentReferral_ReferToJasonMitchellGroupRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAgentReferral_ReferToMarkSpainRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosWebServicesAgentReferral_ReferToParnRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAgentReferral_ReferToRedfinRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAssessment_ExteriorAssessmentCustomerNotificationRequests_GetCustomerSmsMessageForPhoneNumbersRequestInput = {
  customerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  eaCustomerNotificationCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  opendoorPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAssessment_ExteriorAssessmentCustomerNotificationRequests_GetLatestInput = {
  notificationType?: InputMaybe<OdProtosWebData_ExteriorAssessmentCustomerNotification_NotificationType>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAssessment_ExteriorAssessmentCustomerNotificationRequests_SendNotificationInput = {
  notificationType?: InputMaybe<OdProtosWebData_ExteriorAssessmentCustomerNotification_NotificationType>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAssessment_GetAllAssessmentSlotsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAssessment_GetLatestVirtualAssessmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAssessment_GetVirtualAssessmentQuestionsRequestInput = {
  virtualAssessmentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesAssessment_ScheduleAssessmentRequestInput = {
  /** required */
  input?: InputMaybe<OdProtosWebData_ScheduleAssessmentInputInput>;
};

export type OdProtosWebServicesAssessment_UpdateAssessmentRequestInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  selectedAssessmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBap_CreateAuctionForElaFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBap_CreateCounterOfferRequestInput = {
  counterOfferBrokerCommissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  counterOfferPriceUsd?: InputMaybe<Scalars['Float']['input']>;
  countererEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesBap_EscalatePrelistRequestInput = {
  escalatableId?: InputMaybe<Scalars['Float']['input']>;
  escalationNote?: InputMaybe<Scalars['String']['input']>;
  odaUgm?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesBap_EscalateRequestInput = {
  listingOfferId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesBap_GetActiveFlipsWithOffersRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesBap_GetWebBapFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBap_GetWebBapListingOffersRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBap_UpdateIsFinalOfferRequestInput = {
  isFinalOffer?: InputMaybe<Scalars['Boolean']['input']>;
  listingOfferId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesBap_UpsertBidReviewerNoteRequestInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<OdProtosCommon_DateInput>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  listingOfferId?: InputMaybe<Scalars['Float']['input']>;
  noteType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesBap_UpsertOfferDecisionNoteRequestInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<OdProtosCommon_DateInput>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  listingOfferId?: InputMaybe<Scalars['Float']['input']>;
  noteType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesBrokerageRegion_GetAllBrokerageRegionsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesBrokerageRegion_GetBrokerageRegionForFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBrokerageRegion_GetBrokerageRegionsForMarketRequestInput = {
  marketIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBudgetReview_AreReadyForReviewByAddressRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesBudgetReview_AssessmentStatusRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBudgetReview_CompleteRepairBudgetReviewRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBudgetReview_GetBudgetReviewForOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBudgetReview_SendSellerRepairDetailsRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBudgetReview_UpdateRepairScopeRequestInput = {
  customerFacingDescription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesBuyDirect_Requests_CancelBuyDirectOfferInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
  listingOfferUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 12 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOfferInput = {
  addOns?: InputMaybe<Array<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn>>;
  buyer?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput>;
  closeOfEscrow?: InputMaybe<OdProtosCommon_DateInput>;
  coBuyer?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput>;
  downPaymentCents?: InputMaybe<Scalars['Float']['input']>;
  financingType?: InputMaybe<OdProtosWebData_ListingOfferDetails_FinancingStatus>;
  listing?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput>;
  preApprovalLetter?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput>;
  requestedHeroesHomeCredit?: InputMaybe<Scalars['Boolean']['input']>;
  tradeInAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 7 */
export enum OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn {
  /**
   * Replaced by EARLY_MOVEIN
   * @deprecated No longer supported
   */
  EARLY_CHECKOUT = 'EARLY_CHECKOUT',
  EARLY_MOVEIN = 'EARLY_MOVEIN',
  MOVING_SERVICES = 'MOVING_SERVICES',
  NONE = 'NONE',
  OSN_TITLE_ESCROW = 'OSN_TITLE_ESCROW',
  POWERWALL = 'POWERWALL',
  /**
   * Deprecated: Warranty is available to buyers by default and no longer needs to be selected.
   * @deprecated No longer supported
   */
  WARRANTY = 'WARRANTY'
}

/** Next ID: 4 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput = {
  /** Finds the latest listing for the address. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyerInput = {
  listing?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyer_ListingOneofInput>;
};

export type OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyer_ListingOneofInput = {
  /** Finds the latest listing for the address. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesBuyDirect_Requests_RequestContractInput = {
  listingOfferUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesBuyDirect_Responses_CancelBuyDirectOffer_Status {
  SUCCESS_OFFER_CANCELLED = 'SUCCESS_OFFER_CANCELLED',
  SUCCESS_TASK_CREATED = 'SUCCESS_TASK_CREATED',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebServicesBuyDirect_Responses_NotifyAepOfContingentBuyer_Status {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}

export enum OdProtosWebServicesBuyDirect_Responses_RequestContract_Status {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}

export type OdProtosWebServicesCalendly_GetAvailabilityRequestInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCalendly_GetCalendlyEventRequestInput = {
  calendlyEventId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCalendly_GetCalendlyEventsByIdsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesCalendly_TrackCalendlySchedulingAvailabilityRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCheckout_ApproveDigitalCheckoutRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  overridePhotoRequirement?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesCheckout_DeleteDigitalCheckoutPhotoRequestInput = {
  digitalCheckoutPhotoId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesCheckout_DigitalCheckoutForOfferRequestInput = {
  offerId?: InputMaybe<Scalars['Float']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCheckout_DigitalCheckoutPhotoUploadInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCheckout_GetDigitalCheckoutRequestInput = {
  dcoIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosWebServicesCheckout_LockboxShippingInfoRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCheckout_OverridePhotoRequirementRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCheckout_SendCheckoutLinkRequestInput = {
  checkoutUrl?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCheckout_UploadDigitalCheckoutPhotosRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<OdProtosWebServicesCheckout_DigitalCheckoutPhotoUploadInput>>;
};

export type OdProtosWebServicesCommunication_GetFlattenedMessagesByClearinghouseTransactionRequestInput = {
  clearinghouseTransactionId?: InputMaybe<Scalars['String']['input']>;
};

/** results are a union of all messages found using the conditions provided */
export type OdProtosWebServicesCommunication_GetFlattenedMessagesByCustomersRequestInput = {
  /** if provided, will return only messages created after this timestamp */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** if provided, result includes messages involving these custard contacts (customers) */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** if provided, result includes messages involving custard contacts (customers) identified by these numbers */
  phoneNumbers?: InputMaybe<Array<OdProtosCommon_PhoneNumberInput>>;
};

export type OdProtosWebServicesContractChange_AllowContractChangeWithoutApprovalRequestInput = {
  newCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContractChange_CancelContractRequestInput = {
  cancellationInfo?: InputMaybe<OdProtosWebData_CancellationRequestInput>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  withdrawalDetails?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContractChange_ChangeCoeRequestInput = {
  coeChange?: InputMaybe<OdProtosWebData_CoeChangeRequestInput>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContractChange_GrantSubsidyRequestInput = {
  approvedSubsidies?: InputMaybe<Array<OdProtosWebData_SubsidyRequestInput>>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContractChange_RequestContractChangeRequestInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  cancellationInfo?: InputMaybe<OdProtosWebData_CancellationRequestInput>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  requestedCoeChange?: InputMaybe<OdProtosWebData_CoeChangeRequestInput>;
  requestedRepairAdjustment?: InputMaybe<OdProtosWebData_RepairAdjustmentInput>;
  subsidyAmountCents?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosWebServicesContract_AgreementStatus {
  AGREEMENT_STATUS_FULLY_AGREED = 'AGREEMENT_STATUS_FULLY_AGREED',
  AGREEMENT_STATUS_NOT_AGREED = 'AGREEMENT_STATUS_NOT_AGREED',
  AGREEMENT_STATUS_PARTIALLY_AGREED = 'AGREEMENT_STATUS_PARTIALLY_AGREED',
  AGREEMENT_STATUS_UNSPECIFIED = 'AGREEMENT_STATUS_UNSPECIFIED'
}

export enum OdProtosWebServicesContract_AgreementType {
  AGREEMENT_TYPE_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM = 'AGREEMENT_TYPE_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM',
  AGREEMENT_TYPE_UNSPECIFIED = 'AGREEMENT_TYPE_UNSPECIFIED'
}

export type OdProtosWebServicesContract_CreateContractConfigurationRequestInput = {
  brokerageRegionIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  contractType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_CreateContractTemplateRequestInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_DeleteContractTemplateRequestInput = {
  contractTemplateUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_GetContractConfigurationRequestInput = {
  contractConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_GetContractTemplateRequestInput = {
  contractTemplateUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_GetFullContractConfigurationRequestInput = {
  contractConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_GetLatestPricingAgreementRequestInput = {
  agreementStatus?: InputMaybe<OdProtosWebServicesContract_AgreementStatus>;
  agreementType?: InputMaybe<OdProtosWebServicesContract_AgreementType>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_MergeContractConfigurationsRequestInput = {
  mergingFromContractConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
  mergingIntoContractConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_RefreshTemplateFieldsRequestInput = {
  contractTemplateUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_Requests_GetDownloadUrlInput = {
  /** Internally, this is called the hello_sign_task_id */
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesContract_SearchContractConfigurationsRequestInput = {
  brokerageRegionName?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesContract_SearchContractTemplatesRequestInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_SetConfigurationTemplateEntryInput = {
  conditionsJson?: InputMaybe<Scalars['String']['input']>;
  contractTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  requiredParameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesContract_SetConfigurationTemplatesRequestInput = {
  contractConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
  entries?: InputMaybe<Array<OdProtosWebServicesContract_SetConfigurationTemplateEntryInput>>;
};

export type OdProtosWebServicesContract_SplitContractConfigurationRequestInput = {
  brokerageRegionIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  contractConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesContract_UpdateContractConfigurationRequestInput = {
  contractConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesContract_UpdateContractTemplateRequestInput = {
  contractTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCustomerData_CustomerDataRequests_GetInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesCustomerEvent_CustomerEventRequests_ListForCustomersInput = {
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesCustomerEvent_CustomerEventRequests_SearchForCustomerInput = {
  /** These fields get added to the query where clause. */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<Array<OdProtosWebDataEvents_EventType>>;
  /** Number of events to return. Default is 10. */
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesDiagnostics_ListWebAssetsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesDocument_BackfillDocReviewRequestInput = {
  endDocReviewId?: InputMaybe<Scalars['Float']['input']>;
  startDocReviewId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesDocument_BackfillDocsRequestInput = {
  endDocId?: InputMaybe<Scalars['Float']['input']>;
  startDocId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_DeleteInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_GetDeedDetailsByDocumentUuidInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_GetInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_GetPurchaseDetailsByDocumentUuidInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_ListInput = {
  params?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneofInput>;
};

/**
 * finds documents for listing offer and all related
 * listing offers up to and including this one
 */
export type OdProtosWebServicesDocument_DocumentRequests_List_AllListingOfferDocumentsInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_List_CurrentLeadDocumentsInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_List_DocumentableInput = {
  documentable?: InputMaybe<OdProtosWebData_DocumentableInput>;
};

export type OdProtosWebServicesDocument_DocumentRequests_List_IdsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneofInput = {
  currentLead?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_CurrentLeadDocumentsInput>;
  documentable?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_DocumentableInput>;
  ids?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_IdsInput>;
  listingOffer?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_AllListingOfferDocumentsInput>;
};

export type OdProtosWebServicesDocument_DocumentRequests_ReviewInput = {
  /** Only intended for DMS to web sync */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Only intended for DMS to web sync */
  reviewerToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_Review_ReviewStatus>;
  type?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_Review_ReviewType>;
  /** Only intended for DMS to web sync */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OdProtosWebServicesDocument_DocumentRequests_Review_ReviewStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export enum OdProtosWebServicesDocument_DocumentRequests_Review_ReviewType {
  DUE_DILIGENCE = 'DUE_DILIGENCE',
  TRANSACTION_COORDINATOR = 'TRANSACTION_COORDINATOR',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesDocument_DocumentRequests_UpdateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OdProtosWebData_Document_Type>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_UploadInput = {
  params?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_Upload_ParamsOneofInput>;
};

export type OdProtosWebServicesDocument_DocumentRequests_Upload_DocumentInput = {
  /** Only intended for migration from web to DMS */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentable?: InputMaybe<OdProtosWebData_DocumentableInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceChannel?: InputMaybe<OdProtosWebData_Document_SourceChannel>;
  /** Only intended for migration from web to DMS */
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** Only intended for migration from web to DMS */
  sourceTypeId?: InputMaybe<Scalars['String']['input']>;
  storage?: InputMaybe<OdProtosSettlerData_DocumentStorageInput>;
  type?: InputMaybe<OdProtosWebData_Document_Type>;
  /** Only intended for migration from web to DMS */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only intended for migration from web to DMS */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_Upload_ParamsOneofInput = {
  document?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_Upload_DocumentInput>;
};

export type OdProtosWebServicesFlip_FlipSolarPanelDataRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesFlip_GetFlipMetadataRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesFlip_GetFlipsByContextRequestInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  contextType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesFlip_GetOdaReservePriceRequestInput = {
  flipTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesFlip_ListFlipsRequestInput = {
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesFlip_PropertyDetailsFromFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesFlip_RefreshOfferRequestInput = {
  executeSynchronously?: InputMaybe<Scalars['Boolean']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  offerRequestSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
};

/** Next ID: 2 */
export type OdProtosWebServicesFlip_SpecialFlagsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequestInput = {
  /**
   * The maximum number of items to return. The service may return fewer than
   * this value.
   * If unspecified, at most 200 items will be returned.
   */
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  /**
   * A page token, received from a previous call.
   * Provide this to retrieve the subsequent page.
   *
   * When paginating, all other parameters provided to this endpoint must match
   * the call that provided the page token.
   */
  pageToken?: InputMaybe<Scalars['String']['input']>;
  primaryFilter?: InputMaybe<OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequest_PrimaryFilterOneofInput>;
};

export type OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequest_PrimaryFilterOneofInput = {
  humanId?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHpmGeoAssignment_GetPrimaryByAddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHumanAvailability_HumanAvailabilityRequest_BulkGetInput = {
  humanTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesHumanAvailability_HumanAvailabilityRequest_GetInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHuman_GetAdminPreferenceRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHuman_GetCurrentHumanRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesHuman_GetHumansRequestInput = {
  humanToken?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesHuman_GetVoicemailGreetingRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHuman_IsListWithOpendoorAgentRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHuman_ResetPasswordRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHuman_UpdateCurrentHumanRequestInput = {
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  reswareEmployeeId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesHuman_UpdateFullNameEmailRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesIdVerification_GetSessionStatusRequestInput = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesInvoice_ListInvoicesRequestInput = {
  by?: InputMaybe<OdProtosWebServicesInvoice_ListInvoicesRequest_ByOneofInput>;
};

export type OdProtosWebServicesInvoice_ListInvoicesRequest_ByOneofInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesIterable_AddressTokenInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesIterable_AddressTokensInput = {
  addressTokens?: InputMaybe<Array<OdProtosWebServicesIterable_AddressTokenInput>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesIterable_QueueSidekiqJobForCustomerRequestInput = {
  addressTokens?: InputMaybe<OdProtosWebServicesIterable_AddressTokensInput>;
};

/** Next ID: 2 */
export type OdProtosWebServicesIterable_SyncCustomerLatestLeadRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingFeedbacks_CreateListingFeedbackRequestInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  ticketCreationRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListingFeedbacks_GetListingFeedbackLabelsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListingFeedbacks_GetListingFeedbackRequestInput = {
  listingFeedbackId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequest_IdentifierOneofInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesListingOffer_ListingOfferEmailTemplate {
  BACKUP_POST_FALLTHROUGH = 'BACKUP_POST_FALLTHROUGH',
  BRN_ADDENDUM_RECEIVED = 'BRN_ADDENDUM_RECEIVED',
  BRN_NOT_SUBMITTED_CHECK_IN = 'BRN_NOT_SUBMITTED_CHECK_IN',
  BRN_RESPONSE_FOLLOWUP = 'BRN_RESPONSE_FOLLOWUP',
  BRN_RESPONSE_TO_CONTRACT_ATTORNEY = 'BRN_RESPONSE_TO_CONTRACT_ATTORNEY',
  /** @deprecated No longer supported */
  BUY_DIRECT_BRN_ADDENDUM_RECEIVED = 'BUY_DIRECT_BRN_ADDENDUM_RECEIVED',
  /** @deprecated No longer supported */
  BUY_DIRECT_BRN_NOT_SUBMITTED_CHECK_IN = 'BUY_DIRECT_BRN_NOT_SUBMITTED_CHECK_IN',
  /** @deprecated No longer supported */
  BUY_DIRECT_BRN_RESPONSE_FOLLOWUP = 'BUY_DIRECT_BRN_RESPONSE_FOLLOWUP',
  /** @deprecated No longer supported */
  BUY_DIRECT_CREATE_AND_DELIVER_BRN_RESPONSE = 'BUY_DIRECT_CREATE_AND_DELIVER_BRN_RESPONSE',
  /** @deprecated No longer supported */
  BUY_DIRECT_EARNEST_MONEY_NOT_DEPOSITED = 'BUY_DIRECT_EARNEST_MONEY_NOT_DEPOSITED',
  /** @deprecated No longer supported */
  BUY_DIRECT_FINANCING_CONTINGENCY_CHECKIN = 'BUY_DIRECT_FINANCING_CONTINGENCY_CHECKIN',
  /** @deprecated No longer supported */
  BUY_DIRECT_SEND_ACCESS_INSTRUCTIONS = 'BUY_DIRECT_SEND_ACCESS_INSTRUCTIONS',
  /** @deprecated No longer supported */
  BUY_DIRECT_SEND_CONTRACT_KICKOFF_EMAIL = 'BUY_DIRECT_SEND_CONTRACT_KICKOFF_EMAIL',
  /** @deprecated No longer supported */
  BUY_DIRECT_SEND_POSTCLOSE_EMAIL = 'BUY_DIRECT_SEND_POSTCLOSE_EMAIL',
  /** @deprecated No longer supported */
  BUY_DIRECT_SEND_PRECLOSE_READINESS_EMAIL = 'BUY_DIRECT_SEND_PRECLOSE_READINESS_EMAIL',
  /** @deprecated No longer supported */
  BUY_DIRECT_SEND_UTILITIES_INFO = 'BUY_DIRECT_SEND_UTILITIES_INFO',
  COMMUNICATE_HIGHEST_AND_BEST_DEADLINE = 'COMMUNICATE_HIGHEST_AND_BEST_DEADLINE',
  CONFIRM_CLEAR_TO_CLOSE = 'CONFIRM_CLEAR_TO_CLOSE',
  CREATE_AND_DELIVER_BRN_RESPONSE = 'CREATE_AND_DELIVER_BRN_RESPONSE',
  DELIVER_LENDER_REQUIRED_REPAIRS_ADDENDUM = 'DELIVER_LENDER_REQUIRED_REPAIRS_ADDENDUM',
  EARNEST_MONEY_NOT_DEPOSITED = 'EARNEST_MONEY_NOT_DEPOSITED',
  FINANCING_CONTINGENCY_CHECKIN = 'FINANCING_CONTINGENCY_CHECKIN',
  LENDER_REQUIRED_REPAIRS_ADDENDUM_FOLLOWUP = 'LENDER_REQUIRED_REPAIRS_ADDENDUM_FOLLOWUP',
  NONE = 'NONE',
  ODA_CONTRACT_KICKOFF_EMAIL = 'ODA_CONTRACT_KICKOFF_EMAIL',
  ODA_DUE_DILIGENCE_EXPIRING = 'ODA_DUE_DILIGENCE_EXPIRING',
  ODA_SEND_ACCESS_INSTRUCTIONS = 'ODA_SEND_ACCESS_INSTRUCTIONS',
  OUTSTANDING_UNSIGNED_CONTRACT = 'OUTSTANDING_UNSIGNED_CONTRACT',
  PRE_CONTRACT_FOLLOWUP = 'PRE_CONTRACT_FOLLOWUP',
  SEND_ACCESS_INSTRUCTIONS = 'SEND_ACCESS_INSTRUCTIONS',
  SEND_ATTORNEY_REVIEW_KICKOFF_EMAIL = 'SEND_ATTORNEY_REVIEW_KICKOFF_EMAIL',
  SEND_CONTRACT_KICKOFF_EMAIL = 'SEND_CONTRACT_KICKOFF_EMAIL',
  SEND_POSTCLOSE_EMAIL = 'SEND_POSTCLOSE_EMAIL',
  SEND_PRECLOSE_READINESS_EMAIL = 'SEND_PRECLOSE_READINESS_EMAIL',
  SEND_UTILITIES_INFO = 'SEND_UTILITIES_INFO',
  SET_AND_COMMUNICATE_HIGHEST_AND_BEST = 'SET_AND_COMMUNICATE_HIGHEST_AND_BEST'
}

export type OdProtosWebServicesListingOffer_Requests_CounterInput = {
  additionalContractTerms?: InputMaybe<Scalars['String']['input']>;
  appraisalContingencyReleaseDate?: InputMaybe<OdProtosCommon_DateInput>;
  appraisalPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  brokerCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  closeOfEscrow?: InputMaybe<OdProtosCommon_DateInput>;
  concessions?: InputMaybe<Array<OdProtosWebData_ResaleConcessionInput>>;
  downPaymentCents?: InputMaybe<Scalars['Float']['input']>;
  earnestDepositCents?: InputMaybe<Scalars['Float']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  financingContingenciesReleasedDate?: InputMaybe<OdProtosCommon_DateInput>;
  financingPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  homeWarrantyCents?: InputMaybe<Scalars['Float']['input']>;
  homeWarrantyType?: InputMaybe<OdProtosWebServicesListingOffer_Requests_Counter_WarrantyType>;
  inspectionContingenciesReleasedDate?: InputMaybe<OdProtosCommon_DateInput>;
  inspectionPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  isVerbalOffer?: InputMaybe<Scalars['Boolean']['input']>;
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  receivedDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export enum OdProtosWebServicesListingOffer_Requests_Counter_WarrantyType {
  NO_WARRANTY_INCLUDED = 'NO_WARRANTY_INCLUDED',
  WARRANTY_PAID_BY_BUYER = 'WARRANTY_PAID_BY_BUYER',
  WARRANTY_PAID_BY_OPENDOOR = 'WARRANTY_PAID_BY_OPENDOOR'
}

export type OdProtosWebServicesListingOffer_Requests_CreateListingOfferInput = {
  assignedHumanId?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  closeOfEscrow?: InputMaybe<OdProtosCommon_DateInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  financingType?: InputMaybe<Scalars['String']['input']>;
  inspectionContingenciesReleased?: InputMaybe<OdProtosCommon_DateInput>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  manualOfferDetails?: InputMaybe<OdProtosWebServicesListingOffer_Requests_ManualOfferDetailsInput>;
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  receivedDate?: InputMaybe<OdProtosCommon_DateInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  warrantyDeclined?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_FetchListingOfferEmailTemplateInput = {
  emailTemplate?: InputMaybe<OdProtosWebServicesListingOffer_ListingOfferEmailTemplate>;
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetBrnForListingOfferRequestInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetClosedListingOfferIdByListingIdInput = {
  listingId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetClosedOrPendingListingOfferIdByListingIdInput = {
  listingId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetCustomersInput = {
  listingOfferId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetListingOfferChainInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetListingOfferInput = {
  identifier?: InputMaybe<OdProtosWebServicesListingOffer_Requests_GetListingOffer_IdentifierOneofInput>;
};

export type OdProtosWebServicesListingOffer_Requests_GetListingOffer_IdentifierOneofInput = {
  listingOfferId?: InputMaybe<Scalars['Float']['input']>;
  listingOfferUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetParticipantsInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_ListOffersInput = {
  identifier?: InputMaybe<OdProtosWebServicesListingOffer_Requests_ListOffers_IdentifierOneofInput>;
};

export type OdProtosWebServicesListingOffer_Requests_ListOffers_IdentifierOneofInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_ManualOfferDetailsInput = {
  isManualOffer?: InputMaybe<Scalars['Boolean']['input']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SendListingOfferEmailInput = {
  emailTemplate?: InputMaybe<OdProtosWebServicesListingOffer_ListingOfferEmailTemplate>;
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomersInput = {
  agentTc?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_AgentTcOneofInput>;
  buyer?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_BuyerOneofInput>;
  buyer2?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_Buyer2OneofInput>;
  contact?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_ContactOneofInput>;
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_AgentTcOneofInput = {
  agentTcCustomerId?: InputMaybe<Scalars['String']['input']>;
  nullifyAgentTcCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_BasicCustomerInfoInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_Buyer2OneofInput = {
  buyer2CustomerId?: InputMaybe<Scalars['String']['input']>;
  buyer2Info?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_BasicCustomerInfoInput>;
  nullifyBuyer2Customer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_BuyerOneofInput = {
  buyerCustomerId?: InputMaybe<Scalars['String']['input']>;
  buyerInfo?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_BasicCustomerInfoInput>;
  nullifyBuyerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_ContactOneofInput = {
  contactCustomerId?: InputMaybe<Scalars['String']['input']>;
  nullifyContactCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetLenderRequestInput = {
  lender?: InputMaybe<OdProtosWebData_LenderInput>;
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetListingOfferTagsInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesListingOffer_Requests_SetStatusNoteRequestInput = {
  listingOfferId?: InputMaybe<Scalars['String']['input']>;
  statusNote?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_BackListingOnMarketRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  renovationComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListing_BuyerWalkRequestInput = {
  buyerWalkCode?: InputMaybe<OdProtosWebServicesListing_BuyerWalkRequest_BuyerWalkCode>;
  buyerWalkReason?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesListing_BuyerWalkRequest_BuyerWalkCode {
  APPRAISAL_CONCERN = 'APPRAISAL_CONCERN',
  BUYING_OTHER_HOME = 'BUYING_OTHER_HOME',
  BUYING_WITH_AGENT = 'BUYING_WITH_AGENT',
  FINANCING_ISSUES = 'FINANCING_ISSUES',
  HOME_CONDITION = 'HOME_CONDITION',
  MULTI_OFFER = 'MULTI_OFFER',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  OTHER = 'OTHER',
  PRICING = 'PRICING',
  SPECIAL_TAX_ASSESSMENT = 'SPECIAL_TAX_ASSESSMENT',
  WENT_DARK = 'WENT_DARK'
}

export type OdProtosWebServicesListing_CancelListingRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_CancelViewingAppointmentsRequestInput = {
  listingId?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosWebServicesListing_ClaimWebDiscoTaskRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_CloseListingRequestInput = {
  isSold?: InputMaybe<Scalars['Boolean']['input']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_CreateListingRequestInput = {
  acqCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_DeleteListingPhotosRequestInput = {
  deletedListingPhotoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_DropListPricesRequestInput = {
  updates?: InputMaybe<Array<OdProtosWebServicesListing_DropListPricesRequest_ListPriceUpdateInput>>;
};

export type OdProtosWebServicesListing_DropListPricesRequest_ListPriceUpdateInput = {
  listPriceInDollars?: InputMaybe<Scalars['Float']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_GenerateTaskRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesListing_GetExternalListingRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListing_GetExternalListingRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListing_GetExternalListingRequest_IdentifierOneofInput = {
  /** listing_id is the serial id */
  listingId?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_GetListingDescriptionRequestInput = {
  additionalAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  addressToken?: InputMaybe<Scalars['String']['input']>;
  fetchAttributesFromHds?: InputMaybe<Scalars['Boolean']['input']>;
  includeAddressLine?: InputMaybe<Scalars['Boolean']['input']>;
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListing_GetListingIndexInfoRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosWebServicesListing_GetListingRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListing_GetListingRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListing_GetListingRequest_IdentifierOneofInput = {
  /** Finds the latest listing for the address. */
  addressToken?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /** listing_id is the serial id */
  listingId?: InputMaybe<Scalars['String']['input']>;
  listingUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_GetListingsBasicByAddressTokensRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesListing_GetListingsByAddressTokensRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesListing_GetListingsByFlipTokensRequestInput = {
  flipTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesListing_GetListingsRequestInput = {
  /** The ids of the listings to return */
  listingIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesListing_GetPriceDropStatusRequestInput = {
  jobToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesListing_GetPriceDropStatusResponse_PriceDropStatusType {
  ENQUEUED = 'ENQUEUED',
  FAILED = 'FAILED',
  NOT_FOUND = 'NOT_FOUND',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesListing_GetUploadHistoryDocsRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequest_IdentifierOneofInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesListing_ListVisitingCustomersForListingRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListing_ListVisitingCustomersForListingRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListing_ListVisitingCustomersForListingRequest_IdentifierOneofInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_ListingStatusUpdateRequestInput = {
  offerPropertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_RejectRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  rejectCode?: InputMaybe<OdProtosWebServicesListing_RejectRequest_RejectCode>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesListing_RejectRequest_RejectCode {
  BWA = 'BWA',
  COE_TOO_LONG = 'COE_TOO_LONG',
  CONTINGENT_OFFER = 'CONTINGENT_OFFER',
  FHA_INELIGIBLE = 'FHA_INELIGIBLE',
  MULTI_OFFER = 'MULTI_OFFER',
  NOT_FINANCIALLY_QUALIFIED = 'NOT_FINANCIALLY_QUALIFIED',
  OFFER_BELOW_ACCEPTABLE = 'OFFER_BELOW_ACCEPTABLE',
  OTHER = 'OTHER',
  UNACCEPTABLE_RENO_REQUEST = 'UNACCEPTABLE_RENO_REQUEST'
}

export enum OdProtosWebServicesListing_SearchListingType {
  /**
   * Homes that are currently displayed as available to buy or available
   * soon on the exclusives platform
   */
  EXCLUSIVE_LISTINGS = 'EXCLUSIVE_LISTINGS',
  UNKNOWN_SEARCH_TYPE = 'UNKNOWN_SEARCH_TYPE'
}

export type OdProtosWebServicesListing_SearchListingsRequestInput = {
  externalListing?: InputMaybe<Scalars['Boolean']['input']>;
  /** if non-nil, filter on listings in any of the given states */
  listingStates?: InputMaybe<Array<Scalars['String']['input']>>;
  /** if non-nil, return all listings with the given security_system_type */
  securitySystemType?: InputMaybe<Scalars['String']['input']>;
  traditionalListing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListing_SetListingTypeRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  isTraditionalListing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesListing_TakeListingOffMarketRequestInput = {
  expectedBomDate?: InputMaybe<OdProtosCommon_DateInput>;
  fallThroughHome?: InputMaybe<Scalars['Boolean']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  newPhotosNeededAtBom?: InputMaybe<Scalars['Boolean']['input']>;
  tomReason?: InputMaybe<OdProtosWebServicesListing_TomReason>;
  workSummary?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesListing_TomReason {
  ADDITIONAL_RENOVATIONS = 'ADDITIONAL_RENOVATIONS',
  ADDITIONAL_RENOVATIONS_POST_FALLTHROUGH = 'ADDITIONAL_RENOVATIONS_POST_FALLTHROUGH',
  DAMAGE_IN_HOME = 'DAMAGE_IN_HOME',
  LEGAL_ISSUE = 'LEGAL_ISSUE',
  PESTS = 'PESTS',
  SELLER_DISCLOSURE_UPDATE = 'SELLER_DISCLOSURE_UPDATE',
  TOM_REASON_UNSPECIFIED = 'TOM_REASON_UNSPECIFIED',
  TRUST_AND_SAFETY = 'TRUST_AND_SAFETY',
  UTILITY_ISSUE = 'UTILITY_ISSUE',
  WEATHER = 'WEATHER'
}

export type OdProtosWebServicesListing_UpdateListingDescriptionRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  listingDescription?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesListing_UpdateListingPhotosRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']['input']>;
  updatedListingPhotos?: InputMaybe<Array<OdProtosWebServicesListing_UpdateListingPhotosRequest_UpdatedListingPhotoInput>>;
};

export type OdProtosWebServicesListing_UpdateListingPhotosRequest_UpdatedListingPhotoInput = {
  photoId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesListing_UploadDiscoDocToAdminRequestInput = {
  completeTask?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  keyForS3?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_AddWebPhotoRequestInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  picableId?: InputMaybe<Scalars['String']['input']>;
  picableType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_AddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_CreateMaintenanceInvoiceRequestInput = {
  endPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  startPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesMaintenance_CreateMaintenanceScheduleRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<OdProtosWebData_MaintenanceRequest_FrequencyInput>;
  kind?: InputMaybe<OdProtosWebData_MaintenanceRequest_Kind>;
  requestedStartDate?: InputMaybe<OdProtosCommon_DateInput>;
  unitCostCents?: InputMaybe<Scalars['Float']['input']>;
  vendorOrganizationToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_GetBeforeAndAfterPhotosRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_GetFeedbackRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_GetInvoiceableCentsForVendorAndPeriodRequestInput = {
  endPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  startPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  vendorOrganizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_GetMessageThreadRequestInput = {
  requestType?: InputMaybe<OdProtosWebServicesMaintenance_GetMessageThreadRequest_RequestTypeOneofInput>;
};

export type OdProtosWebServicesMaintenance_GetMessageThreadRequest_RequestTypeOneofInput = {
  requestIdentifier?: InputMaybe<OdProtosWebServicesMaintenance_MaintenanceRequestIdentifierRequestInput>;
};

export type OdProtosWebServicesMaintenance_GetOnsiteWorkersForOrgRequestInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_GetPhotoRequirementsRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_GetPresignedUploadUrlRequestInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_ListMaintenanceRequestsForVendorRequestInput = {
  endPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  startPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  states?: InputMaybe<Array<OdProtosWebData_MaintenanceRequest_State>>;
  vendorOrganizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequestInput = {
  pagination?: InputMaybe<OdProtosWebServicesMaintenance_PaginationRequestInput>;
  requestType?: InputMaybe<OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequest_RequestTypeOneofInput>;
};

export type OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequest_RequestTypeOneofInput = {
  addressRequest?: InputMaybe<OdProtosWebServicesMaintenance_AddressRequestInput>;
  vendorRequest?: InputMaybe<OdProtosWebServicesMaintenance_ListMaintenanceRequestsForVendorRequestInput>;
};

export type OdProtosWebServicesMaintenance_ListMaintenanceSchedulesRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_MaintenanceRequestApproveRequestInput = {
  approvalFeedback?: InputMaybe<Scalars['String']['input']>;
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_MaintenanceRequestCancelRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_MaintenanceRequestDenyRequestInput = {
  denialFeedback?: InputMaybe<Scalars['String']['input']>;
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_MaintenanceRequestIdentifierRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_MarkMaintenanceRequestAsMissedRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_MarkMaintenanceRequestAsNeedsReviewRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_PaginationRequestInput = {
  offset?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesMaintenance_PostToMessageThreadRequestInput = {
  authorUserToken?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  messageThreadId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_RemoveWebPhotoRequestInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  originalFilename?: InputMaybe<Scalars['String']['input']>;
  picableId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_UpdateMaintenanceRequestScheduledDateRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
  newScheduledDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesMaintenance_UpdateOnsiteWorkerRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']['input']>;
  memberToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMaintenance_ValidateInvoiceablePeriodSignatureRequestInput = {
  endPeriod?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  startPeriod?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesMarketing_GetAllowedToReengageBulkRequestInput = {
  getAllowedToReengageParams?: InputMaybe<Array<OdProtosWebData_GetAllowedToReengageParamsInput>>;
};

/** Next ID: 4 */
export type OdProtosWebServicesMarketing_GetAllowedToReengageRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesMarketplace_SendSavedSearchAgentEmailRequestInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesMultipartUploads_AbortMultipartUploadRequestInput = {
  uploadToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesMultipartUploads_CompleteMultipartUploadRequestInput = {
  /**
   * Array of MultipartUploadPart entries, each containing the etag returned from S3 for the successful
   *   part upload as well as the part index the etag corresponds to. The server will order these parts
   *   and call S3 to complete the upload here:
   *   https://github.com/fog/fog-aws/blob/66a4183efb4ae4aa392fa7694ce2258636c6a714/lib/fog/aws/requests/storage/complete_multipart_upload.rb#L27
   */
  multipartUploadParts?: InputMaybe<Array<OdProtosWebServicesMultipartUploads_MultipartUploadPartInput>>;
  uploadToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesMultipartUploads_GenerateMultipartUploadUrlsRequestInput = {
  partIndexEnd?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The response will include a unique pre-signed URL for each file part on the range
   *   [part_index_start, part_index_end]. The client, not the server, will dictate how
   *   many parts to split the upload into (based on the full upload size).
   */
  partIndexStart?: InputMaybe<Scalars['Float']['input']>;
  uploadToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesMultipartUploads_InitiateMultipartUploadRequestInput = {
  bucketName?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesMultipartUploads_MultipartUploadPartInput = {
  etag?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesNote_CreateNoteRequestInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  contextIdentifier?: InputMaybe<Scalars['String']['input']>;
  contextType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesNote_GetNoteRequestInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesOffer_Requests_GetOfferIdByFlipTokenInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesOffer_Requests_GetOffersByOfferIdsInput = {
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesOperator_Requests_GetOperatorDataInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesPassword_Requests_ResetPasswordInput = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesPassword_Requests_UpdatePasswordInput = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesPassword_Requests_ValidateResetPasswordTokenInput = {
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesPasswordless_AppType {
  BUYER_APP = 'BUYER_APP',
  BUYER_APP_DEV = 'BUYER_APP_DEV',
  KEY_AGENT = 'KEY_AGENT',
  UNSET_APP_TYPE = 'UNSET_APP_TYPE'
}

/** Next ID: 5 */
export type OdProtosWebServicesPasswordless_GenerateMagicLinkRequestInput = {
  additionalQueryParams?: InputMaybe<Array<OdProtosWebServicesPasswordless_MagicLinkQueryParamInput>>;
  /** Human token identifying which human should user be authorized as when they click the magic link */
  authorizedAsHumanToken?: InputMaybe<Scalars['String']['input']>;
  maxAllowedUsages?: InputMaybe<Scalars['Float']['input']>;
  path?: InputMaybe<OdProtosWebServicesPasswordless_MagicLinkPath>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  sessionDurationHours?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesPasswordless_GenerateSelfMagicLinkRequestInput = {
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesPasswordless_GetActiveTokenRequestInput = {
  params?: InputMaybe<OdProtosWebServicesPasswordless_GetActiveTokenRequest_ParamsOneofInput>;
};

export type OdProtosWebServicesPasswordless_GetActiveTokenRequest_ParamsOneofInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesPasswordless_HumanIDsInput = {
  humanIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OdProtosWebServicesPasswordless_MagicLinkPath {
  MAGIC_LINK_PATH_HANDOFF = 'MAGIC_LINK_PATH_HANDOFF',
  MAGIC_LINK_PATH_TOKEN = 'MAGIC_LINK_PATH_TOKEN',
  MAGIC_LINK_PATH_UNKNOWN = 'MAGIC_LINK_PATH_UNKNOWN'
}

export type OdProtosWebServicesPasswordless_MagicLinkQueryParamInput = {
  key?: InputMaybe<OdProtosWebServicesPasswordless_MagicLinkQueryParamKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesPasswordless_MagicLinkQueryParamKey {
  HANDOFF_ID = 'HANDOFF_ID',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosWebServicesPasswordless_RequestNewTokenRequestInput = {
  appType?: InputMaybe<OdProtosWebServicesPasswordless_AppType>;
  email?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesPasswordless_RequestNewTokensRequestInput = {
  humanIds?: InputMaybe<OdProtosWebServicesPasswordless_HumanIDsInput>;
};

export type OdProtosWebServicesPasswordless_RevokeTokenRequestInput = {
  revokeAt?: InputMaybe<Scalars['DateTime']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesPricingQa_GetPricingQaForOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesPricingQa_ListUnderwritingsRequestInput = {
  underwritingIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesProductGuidance_GetProductGuidanceRequestInput = {
  leadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesProject_GetFlipForProjectRequestInput = {
  /** project_id = Homework.Project.Id */
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesRenovation_ListRenovationsRequestInput = {
  ids?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OdProtosWebServicesRepairScope_SyncFromAbraRequestInput = {
  repairScopeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesSellDirect_AssignExperiencePartnerRequestInput = {
  experiencePartnerToken?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_CalculateCloseOfEscrowCostRequestInput = {
  closeOfEscrowDate?: InputMaybe<OdProtosCommon_DateInput>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_CalculateLateCheckoutCostRequestInput = {
  lateCheckoutDate?: InputMaybe<OdProtosCommon_DateInput>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_CancelLateCheckoutRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_CancelOrvaRequestInput = {
  cancelReason?: InputMaybe<OdProtosWebData_OrvaCancellationReason>;
  cancelSource?: InputMaybe<Scalars['String']['input']>;
  virtualAssessmentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_CancelOfferReviewRequestInput = {
  cancelReason?: InputMaybe<OdProtosWebDataSellDirect_OfferReview_CancelReason>;
  offerReviewId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_CheckAgentLedAssessmentsEnabledRequestInput = {
  leadIdentifier?: InputMaybe<OdProtosWebData_LeadIdentifierInput>;
};

/**
 * Request object for ClearLastSSVARecordingByRecordedFeature
 * Next ID: 5
 */
export type OdProtosWebServicesSellDirect_ClearLastSsvaRecordingByRecordedFeatureRequestInput = {
  clearAll?: InputMaybe<Scalars['Boolean']['input']>;
  lead?: InputMaybe<OdProtosWebServicesSellDirect_ClearLastSsvaRecordingByRecordedFeatureRequest_LeadOneofInput>;
  recordedFeature?: InputMaybe<OdProtosWebData_RecordedFeature>;
};

export type OdProtosWebServicesSellDirect_ClearLastSsvaRecordingByRecordedFeatureRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_CompleteLateCheckoutRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_CreateSsvaRequestInput = {
  /** deprecated in favor for seller_lead_uuid */
  addressId?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_CreateUnscheduledOrvaRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_CreateUnscheduledOfferReviewRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_DeleteParticipantRequestInput = {
  /** So we can fetch the lead via different ways (e.g. params, token) */
  lead?: InputMaybe<OdProtosWebServicesSellDirect_DeleteParticipantRequest_LeadOneofInput>;
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_DeleteParticipantRequest_LeadOneofInput = {
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

/**
 * Request object for DeleteSSVAFile
 * Next ID: 4
 */
export type OdProtosWebServicesSellDirect_DeleteSsvaFileRequestInput = {
  filePath?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<OdProtosWebServicesSellDirect_DeleteSsvaFileRequest_LeadOneofInput>;
};

export type OdProtosWebServicesSellDirect_DeleteSsvaFileRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_DenyLeadRequestInput = {
  denialNotes?: InputMaybe<Scalars['String']['input']>;
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_DenyLeadWithReasonRequestInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosWebServicesSellDirect_EligibilityDataForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  saleTimeline?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_EnrollInLateCheckoutRequestInput = {
  lateCheckoutDate?: InputMaybe<OdProtosCommon_DateInput>;
  numberOfFreeDays?: InputMaybe<Scalars['Float']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_ExpireOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetAloEligibityDataRequestInput = {
  leadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetAcquisitionDataRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetActiveOfferBySellerLeadUuidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request object for GetAddressesByCustomerUUID
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_GetAddressesByCustomerUuidRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_GetAllExteriorAssessmentSlotsRequestInput = {
  calendarType?: InputMaybe<OdProtosWebData_AvailabityCalendarType>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  /** Fetching can be done with either param */
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_GetAssessmentStepsRequestInput = {
  /** deprecated in favor for seller_lead_uuid */
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetCurrentOfferBySellerLeadUuidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetLatestLeadByAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetLatestLeadRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetLatestOfferByAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetLeadByUnderwritingPropertyEngagementIdRequestInput = {
  underwritingPropertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request/Response objects for GetLead
 * Next ID: 7
 */
export type OdProtosWebServicesSellDirect_GetLeadRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneofInput>;
  /**
   * Customer participant roles to use for access (e.g. seller_participant, signatory, etc).
   * Access will be granted if the user matches a participant in at least one of the roles listed.
   * Will not require the role to be associated with the user for internal access.
   */
  participantRolesForAccess?: InputMaybe<OdProtosWebData_ParticipantRolesForAccessInput>;
  userEmailForAccess?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetOfferAcquisitionTitleOrganizationRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetOfferClosingExperienceDataRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOfferPricesRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request/Response objects for GetOffer
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_GetOfferRequestInput = {
  excludeComps?: InputMaybe<Scalars['Boolean']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetOfferReviewsRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesSellDirect_GetOfferReviewsRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesSellDirect_GetOfferReviewsRequest_IdentifierOneofInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOfferStepsRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOffersFromAddressesForIterableRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesSellDirect_GetOffersFromLeadByTokenRequestInput = {
  leadToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOffersFromLeadsRequestInput = {
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOrvaAndSoldDatesByCustomerUuidRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetParticipantsRequestInput = {
  /** So we can fetch the lead via different ways (e.g. params, token) */
  lead?: InputMaybe<OdProtosWebServicesSellDirect_GetParticipantsRequest_LeadOneofInput>;
};

export type OdProtosWebServicesSellDirect_GetParticipantsRequest_LeadOneofInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_GetPostContractAssessmentStepsRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetPrivateLatestOfferByAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_GetPrivateOfferRequestInput = {
  excludeComps?: InputMaybe<Scalars['Boolean']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetSsvaStepDetailsRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetSellDirectOfferByTokenRequestInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_LateCheckoutCostsRequestInput = {
  numberOfDays?: InputMaybe<Scalars['Float']['input']>;
  numberOfFreeDays?: InputMaybe<Scalars['Float']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_ListExteriorAssessmentAvailabilitySlotsRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_ListLeadsByTokenRequestInput = {
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesSellDirect_ListLeadsByTokenV2RequestInput = {
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * ListLeadsOnUniqueAddressesRequest will return a list of leads a customer
 * has but will filter the leads by unique addresses.
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_ListLeadsRequestInput = {
  /**
   * Using the human token will only retrieve a limited amount of offers (20) for performance reasons
   * You probably want to use a combination of Lead fetching/Offer fetching in order to grab every single offer for a given human
   * Using human_token, it will return BOTH the human owns and the human participates in!
   */
  humanToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * NOTE: You should only pass in either lead_identifiers or human_token
   * These fields should be treated as oneof, but that would be a breaking change.
   */
  leadIdentifiers?: InputMaybe<Array<OdProtosWebData_LeadIdentifierInput>>;
  /** Active means the lead's state is qualified */
  returnOnlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesSellDirect_ListOffersByTokenRequestInput = {
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_ListOffersRequestInput = {
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offers?: InputMaybe<OdProtosWebServicesSellDirect_ListOffersRequest_OffersOneofInput>;
};

export type OdProtosWebServicesSellDirect_ListOffersRequest_OffersOneofInput = {
  ids?: InputMaybe<OdProtosWebData_OfferIdentifiersInput>;
  params?: InputMaybe<OdProtosWebData_OfferQueryParamsInput>;
};

export type OdProtosWebServicesSellDirect_ListPrivateVirtualAssessmentsByOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request object for ListVirtualAssessmentsByFlip
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_ListVirtualAssessmentsByFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request object for ListVirtualAssessmentsByOffer
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_ListVirtualAssessmentsByOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request object for ListVirtualAssessments
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_ListVirtualAssessmentsRequestInput = {
  virtualAssessmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_MarkFinalOfferViewedRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_MaybeBucketForLowOfferConfidenceExperimentRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 5 */
export type OdProtosWebServicesSellDirect_PerformAgentToCustomerHandoffRequestInput = {
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFirstName?: InputMaybe<Scalars['String']['input']>;
  customerLastName?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_PerformLeadHandoffRequestInput = {
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  customer?: InputMaybe<OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_CustomerOneofInput>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated, use customer oneof instead. */
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  leadToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_CustomerOneofInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  newCustomer?: InputMaybe<OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_NewCustomerForHandoffInput>;
};

export type OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_NewCustomerForHandoffInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAgent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_PrelaunchVirtualAssessmentMeetingRequestInput = {
  virtualAssessmentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_QualifyLeadRequestInput = {
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_ReenableSsvaUploadRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  recordedFeature?: InputMaybe<OdProtosWebData_RecordedFeature>;
};

/**
 * Request/Response objects for refresh offers
 * Next ID: 4
 */
export type OdProtosWebServicesSellDirect_RefreshOfferRequestInput = {
  offerRequestSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  startUnderwritingWithExistingAssessments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesSellDirect_RegeneratePurchaseContractRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  pricingUuid?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_ReleaseOfferFromHoldingStateRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_RequestChangeCloseOfEscrowRequestInput = {
  closeOfEscrowDate?: InputMaybe<OdProtosCommon_DateInput>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_ResendListedOfferEmailRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_ResendParticipantInviteRequestInput = {
  /** So we can fetch the lead via different ways (e.g. params, token) */
  lead?: InputMaybe<OdProtosWebServicesSellDirect_ResendParticipantInviteRequest_LeadOneofInput>;
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_ResendParticipantInviteRequest_LeadOneofInput = {
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_ResetSsvaRequestInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_RestoreOfferRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_RollbackToAcceptedRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  walkReason?: InputMaybe<OdProtosWebServicesSellDirect_RollbackToAcceptedRequest_WalkReasonOneofInput>;
};

export type OdProtosWebServicesSellDirect_RollbackToAcceptedRequest_WalkReasonOneofInput = {
  opendoorWalkReason?: InputMaybe<OdProtosCommonSell_OpendoorWalkReason>;
  sellerWalkReason?: InputMaybe<OdProtosCommonSell_SellerWalkReason>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_ScheduleExteriorAssessmentRequestInput = {
  /** required */
  input?: InputMaybe<OdProtosWebData_ScheduleExteriorAssessmentInputInput>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_SendHelloSignEmailRequestInput = {
  signerEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_SetAssociatedCustomersRequestInput = {
  associatedCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  primaryCustomerId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_SetSsvaReminderSmsRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_SetSsvaReminderSmsRequest_LeadOneofInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_SetSsvaReminderSmsRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_SubmitOrvaRecordingUrlRequestInput = {
  recordingUrl?: InputMaybe<Scalars['String']['input']>;
  virtualAssessmentId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_SubmitOfferReviewRecordingUrlRequestInput = {
  offerReviewId?: InputMaybe<Scalars['String']['input']>;
  recordingUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_SubmitSsvaRecordedFeatureRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_SubmitSsvaRecordedFeatureRequest_LeadOneofInput>;
  recordedFeature?: InputMaybe<OdProtosWebData_RecordedFeature>;
};

export type OdProtosWebServicesSellDirect_SubmitSsvaRecordedFeatureRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_UndenyLeadRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_UpdateHomeDetailsForOfferRequestInput = {
  /** The home detail to be written. Address UUID, source information, and timestamp are required. */
  homeDetail?: InputMaybe<OdProtosHomeDataStore_HomeDetailInput>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_UpdateLateCheckoutSecurityAmountRetainedRequestInput = {
  amountRetainedCents?: InputMaybe<Scalars['Float']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_UpdateNetProceedsCalculationFieldsRequestInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  estimatedRepairCostCents?: InputMaybe<Scalars['Float']['input']>;
  mortgagePayoffAmountCents?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesSellDirect_UpdateOverstayDateRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  overstayChargeCents?: InputMaybe<Scalars['Float']['input']>;
  overstayDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/**
 * Request object for UpdateSSVARecordings
 * Next ID: 4
 */
export type OdProtosWebServicesSellDirect_UpdateSsvaRecordingsRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_UpdateSsvaRecordingsRequest_LeadOneofInput>;
  recordings?: InputMaybe<Array<OdProtosWebData_VirtualAssessmentRecordingInput>>;
};

export type OdProtosWebServicesSellDirect_UpdateSsvaRecordingsRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_UpdateStatusNoteRequestInput = {
  leadToken?: InputMaybe<Scalars['String']['input']>;
  statusNote?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_UpsertParticipantRequestInput = {
  /** So we can fetch the lead via different ways (e.g. params, token) */
  lead?: InputMaybe<OdProtosWebServicesSellDirect_UpsertParticipantRequest_LeadOneofInput>;
  participants?: InputMaybe<OdProtosWebData_ParticipantsInput>;
};

export type OdProtosWebServicesSellDirect_UpsertParticipantRequest_LeadOneofInput = {
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_VerifyActiveOfferRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  sellerInputUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_VerifyHubAccessRequestInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<OdProtosWebServicesSellDirect_VerifyHubAccessRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesSellDirect_VerifyHubAccessRequest_IdentifierOneofInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_ViewedSsvaPageRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_ViewedSsvaPageRequest_LeadOneofInput>;
};

export type OdProtosWebServicesSellDirect_ViewedSsvaPageRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_WithdrawOfferRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  walkReason?: InputMaybe<OdProtosWebServicesSellDirect_WithdrawOfferRequest_WalkReasonOneofInput>;
  withdrawalDetails?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellDirect_WithdrawOfferRequest_WalkReasonOneofInput = {
  opendoorWalkReason?: InputMaybe<OdProtosCommonSell_OpendoorWalkReason>;
  sellerWalkReason?: InputMaybe<OdProtosCommonSell_SellerWalkReason>;
};

export type OdProtosWebServicesSellWithUpside_AcceptRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_AcquisitionProceedsPaidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_AddAgentPricingRequestInput = {
  estimatedListPriceCents?: InputMaybe<Scalars['Float']['input']>;
  sellerAgentCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_DeclineRequestInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_EligibleRequestInput = {
  /**
   * If true, marks eligibility as manually overridden to prevent
   * automatic eligibility checks from changing this decision.
   */
  permanentlyOverride?: InputMaybe<Scalars['Boolean']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_GetNetSheetPdfRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_GetOrCreateProductRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, skips eligibility checks and forces the product to be marked as eligible.
   * This should only be used when explicitly overriding eligibility rules,
   * such as for manual admin actions.
   */
  ignoreEligibility?: InputMaybe<Scalars['Boolean']['input']>;
  sellDirectOfferUuid?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_GetProductRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_GetResaleInfoRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_NotEligibleRequestInput = {
  /**
   * If true, marks eligibility as manually overridden to prevent
   * automatic eligibility checks from changing this decision.
   */
  permanentlyOverride?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_RecheckEligibilityRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_ResaleProceedsPaidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_SetNotesRequestInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesSellWithUpside_UpdatePricingInputsRequestInput = {
  desiredCashAdvanceCents?: InputMaybe<Scalars['Float']['input']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
  sellerProjectedSalesPriceCents?: InputMaybe<Scalars['Float']['input']>;
  skipDeriveNewPricing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdProtosWebServicesSellWithUpside_WithdrawRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesStructuredTouchpoint_Requests_SearchInput = {
  kind?: InputMaybe<OdProtosWebData_StructuredTouchpointKind>;
  query?: InputMaybe<OdProtosWebServicesStructuredTouchpoint_Requests_Search_QueryOneofInput>;
};

export type OdProtosWebServicesStructuredTouchpoint_Requests_Search_QueryOneofInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  touchpointable?: InputMaybe<OdProtosWebData_TouchpointableInput>;
};

export type OdProtosWebServicesTask_Requests_CancelTasksByFlipInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  taskTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesTask_Requests_CompleteTaskInput = {
  completionMethod?: InputMaybe<OdProtosWebServicesTask_TaskCompletionMethod>;
  taskId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosWebServicesTask_TaskCompletionMethod {
  AUTOMATIC = 'AUTOMATIC',
  EMAIL = 'EMAIL',
  MANUAL = 'MANUAL',
  NOT_RELEVANT = 'NOT_RELEVANT',
  PHONE_CALL = 'PHONE_CALL',
  SMS = 'SMS'
}

export type OdProtosWebServicesTransaction_TransactionRequests_GetInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesTransaction_TransactionRequests_ListInput = {
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWebServicesTransaction_TransactionRequests_SearchInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  escrowNumber?: InputMaybe<Scalars['String']['input']>;
  fileUuid?: InputMaybe<Scalars['String']['input']>;
  flipToken?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwritingQcResult_GetCompleteQcCaseyTaskArgumentsErrorCode_Code {
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwritingQcResult_GetCompleteQcCaseyTaskArgumentsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  /** aka flip_token */
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

/** Next ID: 10 */
export type OdProtosWebServicesUnderwriting_CalculateFeesRequestInput = {
  /**
   * When true, calculates fees without persisting any records.
   * Returns unit_economic_id=0 and unit_economics_json with the computed result.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  lgmOverride?: InputMaybe<OdProtosWebServicesUnderwriting_CalculateFeesRequest_LgmOverrideInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateUnderwritingUea?: InputMaybe<Scalars['Boolean']['input']>;
  valuation?: InputMaybe<OdProtosWebServicesUnderwriting_CalculateFeesRequest_ValuationOneofInput>;
};

/** Next ID: 4 */
export type OdProtosWebServicesUnderwriting_CalculateFeesRequest_LgmOverrideInput = {
  humanToken?: InputMaybe<Scalars['String']['input']>;
  overrideBps?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesUnderwriting_CalculateFeesRequest_OverrideValuationInput = {
  /**
   * TODO: migrate to common.Money (cents). Currently float dollars for consistency
   * with CreateDirectOverrideValuationRequest.override_ci50margin.
   */
  overrideCi50margin?: InputMaybe<Scalars['Float']['input']>;
  overridePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosWebServicesUnderwriting_CalculateFeesRequest_ValuationOneofInput = {
  /** ensembled valuation (e.g. OVM + human) */
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
  /** direct override valuation params - created inline during fee calculation */
  overrideValuation?: InputMaybe<OdProtosWebServicesUnderwriting_CalculateFeesRequest_OverrideValuationInput>;
  /** single valuation */
  valuationId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosWebServicesUnderwriting_CalculateFeesResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 2 */
export type OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_Error_Code {
  /** property_engagement_group_id or other request parameters are invalid */
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  /** no offer found for property_engagement_group_id */
  OFFER_NOT_FOUND = 'OFFER_NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_Success_Ineligible_Code {
  /** offer found, but in a state that is invalid for UW to start */
  INVALID_OFFER_STATE = 'INVALID_OFFER_STATE',
  /** no valid assessment/inspection found for the property_engagement_group_id */
  MISSING_INSPECTION = 'MISSING_INSPECTION',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_CreateDirectOverrideValuationRequestInput = {
  overrideCi50margin?: InputMaybe<Scalars['Float']['input']>;
  overridePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  uwPropertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  valuatorToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_CreateDirectOverrideValuationResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_CreateEnsembledValuationRequestInput = {
  /** Optional - when set, web mocks the EV */
  mockConfiguration?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockValuationInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  uwPropertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  valuationPropertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_CreateEnsembledValuationResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Create OVM valuation with home details overlay (POST_DV methodology)
 * Used by validata to create a new valuation when CubiCasa scan reveals home details discrepancy during DV.
 */
export type OdProtosWebServicesUnderwriting_CreateOvmValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  overlay?: InputMaybe<OdProtosWebServicesUnderwriting_HomeDetailsInput>;
};

export enum OdProtosWebServicesUnderwriting_CreateOvmValuationResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  SIGNALS_ERROR = 'SIGNALS_ERROR',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_CreateUnderwritingTasksRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  taskParams?: InputMaybe<OdProtosWebServicesUnderwriting_CreateUnderwritingTasksRequest_TaskParamsOneofInput>;
};

export type OdProtosWebServicesUnderwriting_CreateUnderwritingTasksRequest_TaskParamsOneofInput = {
  pricingDecision?: InputMaybe<OdProtosWebServicesUnderwriting_PricingDecisionTaskParamsInput>;
  valuation?: InputMaybe<OdProtosWebServicesUnderwriting_ValuationTaskParamsInput>;
};

export enum OdProtosWebServicesUnderwriting_CreateUnderwritingTasksResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 3 */
export type OdProtosWebServicesUnderwriting_GetCalculatedFeesRequestInput = {
  unitEconomicIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** underwriting property engagement id */
  uwPropertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_GetCalculatedFeesResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 3 */
export type OdProtosWebServicesUnderwriting_GetEnsembledRepairLineItemsRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_GetEnsembledRepairLineItemsResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_GetEnsembledValuationWalkProposalsRequestInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosWebServicesUnderwriting_GetEnsembledValuationWalkProposalsResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_GetEstimatedClosingCostsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  offerPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export enum OdProtosWebServicesUnderwriting_GetEstimatedClosingCostsResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 2 */
export type OdProtosWebServicesUnderwriting_GetPreliminaryOfferValuationRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_GetPreliminaryOfferValuationResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 2 */
export type OdProtosWebServicesUnderwriting_GetRepairBudgetReviewWalkProposalRequestInput = {
  repairBudgetReviewId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosWebServicesUnderwriting_GetRepairBudgetReviewWalkProposalResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export enum OdProtosWebServicesUnderwriting_GetReusableRiskAssessmentDetailsErrorCode_Code {
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

/** Next ID: 5 */
export type OdProtosWebServicesUnderwriting_GetReusableRiskAssessmentDetailsRequestInput = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosWebServicesUnderwriting_GetReusableUnderwritingRequestInput = {
  /** optional */
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  /** flip token */
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_GetReusableUnderwritingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_GetRiskTierRequestInput = {
  target?: InputMaybe<OdProtosWebServicesUnderwriting_GetRiskTierRequest_TargetOneofInput>;
};

export type OdProtosWebServicesUnderwriting_GetRiskTierRequest_TargetOneofInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_GetRiskTierResponse_RiskTier {
  /** risk_tier = 1 */
  HIGH = 'HIGH',
  /**
   * from web.market_service_area.risk_tier
   *
   * risk_tier = 0
   */
  LOW = 'LOW',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_GetUnderwritingByOfferUuidRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesUnderwriting_GetUnderwritingPricingRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

/** Home details for OVM overlay (CubiCasa data) */
export type OdProtosWebServicesUnderwriting_HomeDetailsInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Int']['input']>;
  bathroomsFull?: InputMaybe<Scalars['Int']['input']>;
  bathroomsHalf?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
};

export type OdProtosWebServicesUnderwriting_InitiateMockUnderwritingRequestInput = {
  /** Optional custom mock configuration. If provided, overrides the default happy-path config. */
  mockConfiguration?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwritingInput>;
  /** The flip token */
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesUnderwriting_PricingDecisionTaskParamsInput = {
  unitEconomicId?: InputMaybe<Scalars['Float']['input']>;
  valuation?: InputMaybe<OdProtosWebServicesUnderwriting_PricingDecisionTaskParams_ValuationOneofInput>;
};

export type OdProtosWebServicesUnderwriting_PricingDecisionTaskParams_ValuationOneofInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
  singleValuationId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesUnderwriting_UpdateUnderwritingRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Use state field instead. */
  shouldWalk?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Underwriting object will have its contents copied from source_unit_economic_id */
  sourceUnitEconomicId?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Determines the final state to set on the web underwriting.
   * - UNCHANGED: do not change the web underwriting state
   * - WALKED: try to set the web underwriting state to 'walked'
   * - COMPLETED: try to set the web underwriting state to 'completed'
   */
  state?: InputMaybe<OdProtosWebServicesUnderwriting_UpdateUnderwritingRequest_State>;
};

export enum OdProtosWebServicesUnderwriting_UpdateUnderwritingRequest_State {
  COMPLETED = 'COMPLETED',
  STATE_UNSPECIFIED = 'STATE_UNSPECIFIED',
  UNCHANGED = 'UNCHANGED',
  WALKED = 'WALKED'
}

export enum OdProtosWebServicesUnderwriting_UpdateUnderwritingResponse_Error_Code {
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_UpdateUnderwritingWithWalkRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']['input']>;
  propertyEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWebServicesUnderwriting_UpdateUnderwritingWithWalkResponse_Error_Code {
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWebServicesUnderwriting_ValuationTaskParamsInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesUnlock_UnlockRequests_SearchInput = {
  params?: InputMaybe<OdProtosWebServicesUnlock_UnlockRequests_Search_ParamsOneofInput>;
};

export type OdProtosWebServicesUnlock_UnlockRequests_Search_AddressInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesUnlock_UnlockRequests_Search_ContactInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesUnlock_UnlockRequests_Search_ParamsOneofInput = {
  address?: InputMaybe<OdProtosWebServicesUnlock_UnlockRequests_Search_AddressInput>;
  contact?: InputMaybe<OdProtosWebServicesUnlock_UnlockRequests_Search_ContactInput>;
};

/** Home details used for fee calculation */
export type OdProtosWebServicesValuation_FeeCalculationHomeDetailsInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Float']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']['input']>;
  hasHoa?: InputMaybe<Scalars['Boolean']['input']>;
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  hdsPropertyConditionScore?: InputMaybe<Scalars['Float']['input']>;
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  isGatedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  yearBuilt?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesValuation_GetEnsembledValuationRequestInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesValuation_GetLatestValuationForFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * OPTIONAL. When set, the service returns exactly the referenced
   * valuation and skips lifecycle-aware resolution. Use this when the
   * caller has already resolved a specific valuation and needs
   * downstream services to evaluate against that same one.
   */
  valuationRef?: InputMaybe<OdProtosPricingsServicesPricings_ValuationRefInput>;
};

export type OdProtosWebServicesValuation_GetValuationForSellRequestIdRequestInput = {
  odlsSellRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesValuation_GetValuationParamsRequestInput = {
  flipToken?: InputMaybe<Scalars['String']['input']>;
  homeDetails?: InputMaybe<OdProtosWebServicesValuation_FeeCalculationHomeDetailsInput>;
  valuationKind?: InputMaybe<OdProtosWebServicesValuation_GetValuationParamsRequest_ValuationKindOneofInput>;
};

export type OdProtosWebServicesValuation_GetValuationParamsRequest_ValuationKindOneofInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
  valuationId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWebServicesValuation_GetValuationsForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** You should not be using this endpoint directly. Use GetMergedCompsForValuation from the Valuations service instead. */
export type OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequestInput = {
  valuationKind?: InputMaybe<OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequest_ValuationKindOneofInput>;
};

export type OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequest_ValuationKindOneofInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']['input']>;
  valuationId?: InputMaybe<Scalars['Float']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesVirtualAssessment_GetLatestVirtualAssessmentByAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesVirtualAssessment_UpdateVirtualAssessmentWithReviewUrlRequestInput = {
  reviewUrl?: InputMaybe<Scalars['String']['input']>;
  virtualAssessmentId?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesWebMarket_GetMarketRequestInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesWebMarket_ListMarketsRequestInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesWebMarket_ListMlsesRequestInput = {
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesWorkOrder_CreateTaskForCompletedWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWebServicesWorkOrder_Requests_CompletedWorkOrderInput = {
  workOrderId?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdProtosWingmanCommon_TaskStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_FOUND = 'NOT_FOUND',
  PENDING = 'PENDING',
  UNKNOWN_TASK_STATUS = 'UNKNOWN_TASK_STATUS'
}

export enum OdProtosWingmanCommon_TaskType {
  CALL_INSIGHTS = 'CALL_INSIGHTS',
  COMMUNICATION_INSIGHT = 'COMMUNICATION_INSIGHT',
  CONTEXTUALIZE_REPAIR_ASK = 'CONTEXTUALIZE_REPAIR_ASK',
  FINAL_OFFER_REPAIR_NARRATIVE = 'FINAL_OFFER_REPAIR_NARRATIVE',
  LISTING_DESCRIPTION = 'LISTING_DESCRIPTION',
  MAINTENANCE_VALIDATION = 'MAINTENANCE_VALIDATION',
  SCRIPT = 'SCRIPT',
  TRANSCRIBE = 'TRANSCRIBE',
  UNKNOWN_TASK_TYPE = 'UNKNOWN_TASK_TYPE',
  URS_JUSTIFICATION = 'URS_JUSTIFICATION',
  WORK_ORDER_MESSAGE_GENERATION = 'WORK_ORDER_MESSAGE_GENERATION'
}

export enum OdProtosWingmanData_AuditLabel {
  APPROVED = 'APPROVED',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN'
}

export type OdProtosWingmanData_CallInsightsInputInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  prompt1?: InputMaybe<Scalars['String']['input']>;
  prompt2?: InputMaybe<Scalars['String']['input']>;
  requestedUserToken?: InputMaybe<Scalars['String']['input']>;
  requesterUserToken?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OdProtosWingmanData_CommunicationInsightInputInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifierType?: InputMaybe<OdProtosWingmanData_IdentifierType>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanData_ContextualizeRepairAskInputInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWingmanData_DataSourceType {
  EXTERIOR_ASSESSMENT = 'EXTERIOR_ASSESSMENT',
  FULL_ONSITE_ASSESSMENT = 'FULL_ONSITE_ASSESSMENT',
  IMAGE = 'IMAGE',
  ORVA_QUESTIONNAIRE = 'ORVA_QUESTIONNAIRE',
  SSVA_QUESTIONNAIRE = 'SSVA_QUESTIONNAIRE',
  UNKNOWN_SOURCE_TYPE = 'UNKNOWN_SOURCE_TYPE',
  VIRTUAL_FULL_ASSESSMENT = 'VIRTUAL_FULL_ASSESSMENT',
  VIRTUAL_INTERIOR_ASSESSMENT = 'VIRTUAL_INTERIOR_ASSESSMENT'
}

export type OdProtosWingmanData_FeedbackCategoriesInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWingmanData_FinalOfferRepairNarrativeInputInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export enum OdProtosWingmanData_IdentifierType {
  ADDRESS_ID = 'ADDRESS_ID',
  GONG_CALL_ID = 'GONG_CALL_ID',
  SMS_CUSTOMER_ID = 'SMS_CUSTOMER_ID',
  TEXT = 'TEXT',
  UNKNOWN_IDENTIFIER_TYPE = 'UNKNOWN_IDENTIFIER_TYPE'
}

/** Enum for JustificationStatus */
export enum OdProtosWingmanData_JustificationStatus {
  JUSTIFIED = 'JUSTIFIED',
  NOT_JUSTIFIED = 'NOT_JUSTIFIED',
  UNKNOWN_JUSTIFICATION = 'UNKNOWN_JUSTIFICATION'
}

export type OdProtosWingmanData_ListingDescriptionInputInput = {
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  addressLine?: InputMaybe<Scalars['String']['input']>;
  listingDescriptionAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OdProtosWingmanData_MaintenanceValidationTaskInput = {
  maintenanceId?: InputMaybe<Scalars['Float']['input']>;
};

export type OdProtosWingmanData_ParametersInput = {
  parameters?: InputMaybe<Array<OdProtosWingmanData_Parameters_ParametersEntryInput>>;
};

/** `OdProtosWingmanData_Parameters_ParametersEntryInput` represents the `parameters` map in `od_protos.wingman.data.Parameters`. */
export type OdProtosWingmanData_Parameters_ParametersEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanData_ScriptTaskInputInput = {
  parameters?: InputMaybe<OdProtosWingmanData_ParametersInput>;
  scriptType?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanData_TranscribeInputInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  audioPath?: InputMaybe<Scalars['String']['input']>;
  callDate?: InputMaybe<Scalars['DateTime']['input']>;
  callType?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  partnerToken?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanData_UrsJustificationTaskInputInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanData_WorkOrderMessageGenerationTaskInput = {
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanServices_CancelEnqueuedTaskRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanServices_CreateFeedbackRequestInput = {
  feedbackCategories?: InputMaybe<OdProtosWingmanData_FeedbackCategoriesInput>;
  feedbackFullTaskOutput?: InputMaybe<Scalars['String']['input']>;
  feedbackRating?: InputMaybe<Scalars['Float']['input']>;
  freeformFeedback?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanServices_GetLastResponseForTaskRequestInput = {
  input?: InputMaybe<OdProtosWingmanServices_GetLastResponseForTaskRequest_InputOneofInput>;
};

export type OdProtosWingmanServices_GetLastResponseForTaskRequest_InputOneofInput = {
  requestId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanServices_GetLastResponseForTasksRequestInput = {
  input?: InputMaybe<Array<OdProtosWingmanServices_GetLastResponseForTaskRequestInput>>;
};

export type OdProtosWingmanServices_GetTaskStatusRequestInput = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanServices_GetTasksForFiltersInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastEvaluatedKey?: InputMaybe<Array<OdProtosWingmanServices_GetTasksForFilters_LastEvaluatedKeyEntryInput>>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** `OdProtosWingmanServices_GetTasksForFilters_LastEvaluatedKeyEntryInput` represents the `last_evaluated_key` map in `od_protos.wingman.services.GetTasksForFilters`. */
export type OdProtosWingmanServices_GetTasksForFilters_LastEvaluatedKeyEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OdProtosWingmanServices_LastEvaluatedKeyValueInput>;
};

/**
 * Dynamodb will return primary-key and sort-key as key, and value in those columns as value
 * In our case, the value will always be text, hence string.
 * This value can then be used to query the next page of results.
 */
export type OdProtosWingmanServices_LastEvaluatedKeyValueInput = {
  pair?: InputMaybe<Array<OdProtosWingmanServices_LastEvaluatedKeyValue_PairEntryInput>>;
};

/** `OdProtosWingmanServices_LastEvaluatedKeyValue_PairEntryInput` represents the `pair` map in `od_protos.wingman.services.LastEvaluatedKeyValue`. */
export type OdProtosWingmanServices_LastEvaluatedKeyValue_PairEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanServices_ModelInputInput = {
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanServices_SearchFeedbackRequestInput = {
  minRating?: InputMaybe<Scalars['Int']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type OdProtosWingmanServices_TaskRequestInput = {
  input?: InputMaybe<OdProtosWingmanServices_TaskRequest_InputOneofInput>;
  modelInput?: InputMaybe<OdProtosWingmanServices_ModelInputInput>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  timeoutSeconds?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<OdProtosWingmanCommon_TaskType>;
};

export type OdProtosWingmanServices_TaskRequest_InputOneofInput = {
  callInsightsInput?: InputMaybe<OdProtosWingmanData_CallInsightsInputInput>;
  communicationInsightInput?: InputMaybe<OdProtosWingmanData_CommunicationInsightInputInput>;
  contextualizeRepairAskInput?: InputMaybe<OdProtosWingmanData_ContextualizeRepairAskInputInput>;
  finalOfferRepairNarrativeInput?: InputMaybe<OdProtosWingmanData_FinalOfferRepairNarrativeInputInput>;
  listingDescriptionInput?: InputMaybe<OdProtosWingmanData_ListingDescriptionInputInput>;
  maintenanceValidationTask?: InputMaybe<OdProtosWingmanData_MaintenanceValidationTaskInput>;
  scriptTaskInput?: InputMaybe<OdProtosWingmanData_ScriptTaskInputInput>;
  transcribeInput?: InputMaybe<OdProtosWingmanData_TranscribeInputInput>;
  ursJustificationTaskInput?: InputMaybe<OdProtosWingmanData_UrsJustificationTaskInputInput>;
  workOrderMessageGenerationTask?: InputMaybe<OdProtosWingmanData_WorkOrderMessageGenerationTaskInput>;
};

export enum OfferSnapshotSource {
  BUY_DIRECT = 'BUY_DIRECT'
}

export enum OfferSnapshotState {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  IN_CONTRACT = 'IN_CONTRACT',
  IN_REVIEW = 'IN_REVIEW',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN'
}

export type OtherHomeInfoTaskInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  hadPlumbingRepairs?: InputMaybe<Scalars['Boolean']['input']>;
  hadPlumbingRepairsDetails?: InputMaybe<Scalars['String']['input']>;
  hasDispute?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputeDetails?: InputMaybe<Scalars['String']['input']>;
  hasEncroachedOrSharedProperty?: InputMaybe<Scalars['Boolean']['input']>;
  hasEncroachedOrSharedPropertyDetails?: InputMaybe<Scalars['String']['input']>;
  hasWaterDamage?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterDamageDetails?: InputMaybe<Scalars['String']['input']>;
  mailboxNumber?: InputMaybe<Scalars['String']['input']>;
  occupancyStatusAtAcquisition?: InputMaybe<Scalars['String']['input']>;
  recyclingCollection?: InputMaybe<Scalars['String']['input']>;
  trashCollection?: InputMaybe<Scalars['String']['input']>;
};

export type PageInput = {
  /** Returns the elements in the list that come after the specified cursor. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Returns the elements in the list that come before the specified cursor. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Returns the first _n_ elements from the list. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Returns the last _n_ elements from the list. */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoInput = {
  fileName: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  photoIdentifier: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type PolygonBounds = {
  east: Scalars['Float']['input'];
  north: Scalars['Float']['input'];
  south: Scalars['Float']['input'];
  west: Scalars['Float']['input'];
};

export type PricingCompsInput = {
  pricingUuid: Scalars['String']['input'];
};

export type PropertiesInput = {
  addressIds: Array<Scalars['String']['input']>;
};

export type PropertyAddressAutocompleteInput = {
  allowInvalidAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  excludeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  fetchProperties?: InputMaybe<Scalars['Boolean']['input']>;
  fuzziness?: InputMaybe<PropertyFuzziness>;
  includeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  query: Scalars['String']['input'];
};

export type PropertyFieldsSearchInput = {
  filters?: InputMaybe<PropertyFilters>;
  pageInput: PageInput;
  sortKey?: InputMaybe<PropertyQuerySortKey>;
};

export type PropertyFilters = {
  aboveGradeSqFt?: InputMaybe<MinMaxFilter>;
  basementSqFt?: InputMaybe<MinMaxFilter>;
  bathroomsTotal?: InputMaybe<MinMaxFloatFilter>;
  bedrooms?: InputMaybe<MinMaxFilter>;
  currentListPrice?: InputMaybe<MinMaxFilter>;
  dwellingTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeAddressIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  gteIndexedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gteListedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gtePendingAt?: InputMaybe<Scalars['DateTime']['input']>;
  gteSoldAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPhotos?: InputMaybe<Scalars['Boolean']['input']>;
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayable?: InputMaybe<Scalars['Boolean']['input']>;
  isFhaEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  isOpendoorOwned?: InputMaybe<Scalars['Boolean']['input']>;
  listingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  lotSqFt?: InputMaybe<MinMaxFilter>;
  ltIndexedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ltListedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ltPendingAt?: InputMaybe<Scalars['DateTime']['input']>;
  ltSoldAt?: InputMaybe<Scalars['DateTime']['input']>;
  monthlyHoaDues?: InputMaybe<MinMaxFilter>;
  photoThresholdSeconds?: InputMaybe<Scalars['Int']['input']>;
  selfTourAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  soldPrice?: InputMaybe<MinMaxFilter>;
  stories?: InputMaybe<MinMaxFilter>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  totalLivingSqFt?: InputMaybe<MinMaxFilter>;
  yearBuilt?: InputMaybe<MinMaxFilter>;
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PropertyFuzziness {
  FUZZINESS_AUTO = 'FUZZINESS_AUTO',
  FUZZINESS_NONE = 'FUZZINESS_NONE'
}

export type PropertyGeoSearchInput = {
  filters?: InputMaybe<PropertyFilters>;
  pageInput: PageInput;
  shape: Scalars['String']['input'];
  sortKey?: InputMaybe<PropertyQuerySortKey>;
};

export type PropertyInput = {
  addressId: Scalars['String']['input'];
};

export enum PropertyQuerySortKey {
  SORT_KEY_CURRENT_LIST_PRICE_ASC = 'SORT_KEY_CURRENT_LIST_PRICE_ASC',
  SORT_KEY_CURRENT_LIST_PRICE_DESC = 'SORT_KEY_CURRENT_LIST_PRICE_DESC',
  SORT_KEY_DEFAULT = 'SORT_KEY_DEFAULT',
  SORT_KEY_INDEXED_AT_ASC = 'SORT_KEY_INDEXED_AT_ASC',
  SORT_KEY_INDEXED_AT_DESC = 'SORT_KEY_INDEXED_AT_DESC',
  SORT_KEY_LISTED_AT_ASC = 'SORT_KEY_LISTED_AT_ASC',
  SORT_KEY_LISTED_AT_DESC = 'SORT_KEY_LISTED_AT_DESC',
  SORT_KEY_NONE = 'SORT_KEY_NONE',
  SORT_KEY_TOTAL_LIVING_SQ_FT_ASC = 'SORT_KEY_TOTAL_LIVING_SQ_FT_ASC',
  SORT_KEY_TOTAL_LIVING_SQ_FT_DESC = 'SORT_KEY_TOTAL_LIVING_SQ_FT_DESC'
}

export type PropertySearchBounds = {
  market?: InputMaybe<Scalars['String']['input']>;
  vertices?: InputMaybe<Array<GeoPoint>>;
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filters for property search */
export type PropertySearchFilters = {
  /** An arbitrary query string to search for properties that match the query */
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  /** The boundary to search within */
  geoBoundary?: InputMaybe<GeoBoundaryInput>;
  /** Does the property have a private pool? */
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a single story home? */
  hasSingleStory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the property available for self-touring? */
  isSelfTourEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** The listing state of the property */
  listingState?: InputMaybe<ListingState>;
  /** The maximum monthly HOA fee(s) */
  maxHoaMonthlyFee?: InputMaybe<Scalars['Float']['input']>;
  /** The maximum list price */
  maxListPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The maximum square footage of the property */
  maxSquareFootage?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum year the property was built */
  maxYearBuilt?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum number of bathrooms */
  minBathrooms?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum number of bedrooms */
  minBeds?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum list price */
  minListPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum square footage of the property */
  minSquareFootage?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum year the property was built */
  minYearBuilt?: InputMaybe<Scalars['Int']['input']>;
  /** The types of properties to include */
  propertyType?: InputMaybe<Array<PropertyType>>;
  /** Natural language text query for hybrid semantic + keyword search against property attributes and listing descriptions */
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

/** Used to sort the results of a property search (optional) */
export enum PropertySortBy {
  LIST_DATE_ASC = 'LIST_DATE_ASC',
  LIST_DATE_DSC = 'LIST_DATE_DSC',
  LIST_PRICE_ASC = 'LIST_PRICE_ASC',
  LIST_PRICE_DSC = 'LIST_PRICE_DSC',
  SQUARE_FOOTAGE_ASC = 'SQUARE_FOOTAGE_ASC',
  SQUARE_FOOTAGE_DSC = 'SQUARE_FOOTAGE_DSC',
  YEAR_BUILT_ASC = 'YEAR_BUILT_ASC',
  YEAR_BUILT_DSC = 'YEAR_BUILT_DSC'
}

export type PropertyTextSearchInput = {
  filters?: InputMaybe<PropertyFilters>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  pageInput: PageInput;
  query: Scalars['String']['input'];
};

/**
 * PropertyType represents the type of property
 * Is this exhaustive? Do we need less or more?
 */
export enum PropertyType {
  CONDO = 'CONDO',
  HOUSE = 'HOUSE',
  OTHER = 'OTHER',
  TOWNHOUSE = 'TOWNHOUSE'
}

export enum ProprietaryCompType {
  OD_ACQ_COMING_SOON = 'OD_ACQ_COMING_SOON',
  UW = 'UW'
}

export type ProprietaryCompsRequestInput = {
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
};

/** Filter input for purchase offers */
export type PurchaseOfferFilter = {
  /** Filter by specific offer ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum PurchaseOfferNoticeType {
  /** High-urgency notice displayed in red */
  CRITICAL = 'CRITICAL'
}

/**
 * Funding source can have two types:
 *   - Mortgage
 *   - Cash
 */
export enum PurchaseTransactionFundingSource {
  /** The funding source is cash */
  CASH = 'CASH',
  /** The funding source is a mortgage */
  MORTGAGE = 'MORTGAGE'
}

export enum QualMoveTimelineOption {
  just_browsing = 'just_browsing',
  less_than_one_month = 'less_than_one_month',
  not_actively_looking = 'not_actively_looking',
  one_to_three_months = 'one_to_three_months',
  three_plus_months = 'three_plus_months'
}

/** Input for requesting the purchase agreement contract */
export type RequestContractInput = {
  /** The listing offer uuid to request the contract for */
  offerUuid: Scalars['ID']['input'];
};

export enum S3ClientName {
  /** Uses a client that can list, read, and put to https://s3.console.aws.amazon.com/s3/buckets/imgdrop-production?region=us-east-1 */
  IMGDROP_PRODUCTION = 'IMGDROP_PRODUCTION'
}

export type S3CreatePutObjectPresignedUrlInput = {
  clientName: S3ClientName;
  /**
   * default 1 hour. Max expiration time is complicated depending on the nature of the AWS credentials that are used to create the presigned URL;
   * ref https://docs.aws.amazon.com/AmazonS3/latest/userguide/using-presigned-url.html#PresignedUrlUploadObject-LimitCapabilities
   */
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
};

export type S3ListObjectsCommandInput = {
  clientName: S3ClientName;
  continuationToken?: InputMaybe<Scalars['String']['input']>;
  maxKeys?: InputMaybe<Scalars['Int']['input']>;
  objectPrefix?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleExteriorAssessmentInput = {
  occupant?: InputMaybe<OccupantInfo>;
  reminderPhone?: InputMaybe<Scalars['String']['input']>;
  selectedInspectionTime: Scalars['DateTime']['input'];
  sellerInputUUID: Scalars['String']['input'];
};

/** Input for selecting a product for a seller */
export type SelectProductInput = {
  product: OdProtosSellCommon_Product;
  sellerLeadUuid: Scalars['ID']['input'];
};

/** States of a sell direct offer */
export enum SellDirectOfferState {
  /** Final offer state - offer has been finalized */
  FINAL = 'FINAL',
  /** Offer is in contract - customer has accepted */
  IN_CONTRACT = 'IN_CONTRACT',
  /** Preliminary offer state - initial offer provided */
  PRELIMINARY = 'PRELIMINARY',
  /** Offer has been terminated */
  TERMINATED = 'TERMINATED',
  /** Unknown or unrecognized offer state */
  UNKNOWN = 'UNKNOWN',
  /** Unreleased final offer - finalized but not yet released to customer */
  UNRELEASED_FINAL = 'UNRELEASED_FINAL'
}

export type SellerLeadAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
};

export type SendOfferFollowupSmsInput = {
  phoneNumber: Scalars['String']['input'];
  sellerLeadUuid: Scalars['String']['input'];
};

export type ServiceAccountsTaskInput = {
  coolingType?: InputMaybe<Scalars['String']['input']>;
  electricity?: InputMaybe<Scalars['String']['input']>;
  gas?: InputMaybe<Scalars['String']['input']>;
  hasExistingWaterIssue?: InputMaybe<Scalars['Boolean']['input']>;
  hasExistingWaterIssueDetails?: InputMaybe<Scalars['String']['input']>;
  hasSewerSepticIssue?: InputMaybe<Scalars['Boolean']['input']>;
  hasSewerSepticIssueDetails?: InputMaybe<Scalars['String']['input']>;
  heatingType?: InputMaybe<Scalars['String']['input']>;
  water?: InputMaybe<Scalars['String']['input']>;
};

export type SetCloseDateTaskInput = {
  selectedDate?: InputMaybe<Scalars['String']['input']>;
};

export type SetSignatoriesTaskInput = {
  signerNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SignalsCompOverrideInput = {
  address_token: Scalars['String']['input'];
  overlays: SignalsOverlayInput;
};

export enum SignalsEntityType {
  ADDRESS_TOKEN = 'ADDRESS_TOKEN'
}

export type SignalsHumanAdjustmentsInput = {
  comps: Array<SignalsHumanFeaturesInput>;
  market: Scalars['String']['input'];
  skip_list?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: SignalsHumanFeaturesInput;
};

export type SignalsHumanFeaturesInput = {
  appliances?: InputMaybe<Scalars['String']['input']>;
  basement_finished_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  basement_unfinished_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  bathroom_finish?: InputMaybe<Scalars['Float']['input']>;
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  bathrooms_full?: InputMaybe<Scalars['Float']['input']>;
  bathrooms_half?: InputMaybe<Scalars['Float']['input']>;
  bedrooms?: InputMaybe<Scalars['Float']['input']>;
  busy_road_type_arterial_connector_strength?: InputMaybe<Scalars['Float']['input']>;
  busy_road_type_freeway_highway_strength?: InputMaybe<Scalars['Float']['input']>;
  busy_road_type_main_within_subdivision_strength?: InputMaybe<Scalars['Float']['input']>;
  carport_spaces?: InputMaybe<Scalars['Float']['input']>;
  commercial_type?: InputMaybe<Scalars['String']['input']>;
  construction_quality?: InputMaybe<Scalars['String']['input']>;
  covered_patio?: InputMaybe<Scalars['Float']['input']>;
  covered_porch?: InputMaybe<Scalars['Float']['input']>;
  cul_de_sac?: InputMaybe<Scalars['Float']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  exterior_finish?: InputMaybe<Scalars['Float']['input']>;
  f_close_price?: InputMaybe<Scalars['Float']['input']>;
  f_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  f_is_pending?: InputMaybe<Scalars['Boolean']['input']>;
  floor_type?: InputMaybe<Scalars['String']['input']>;
  garage_spaces?: InputMaybe<Scalars['Float']['input']>;
  golf_lot_strength?: InputMaybe<Scalars['Float']['input']>;
  hardwood_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  implied_price_per_sq_ft_except_basement?: InputMaybe<Scalars['Float']['input']>;
  kitchen_cabinets_material?: InputMaybe<Scalars['String']['input']>;
  kitchen_counters?: InputMaybe<Scalars['String']['input']>;
  kitchen_finish?: InputMaybe<Scalars['Float']['input']>;
  kitchen_fixtures_material?: InputMaybe<Scalars['String']['input']>;
  lake_lot_strength?: InputMaybe<Scalars['Float']['input']>;
  laminate_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  layout_score?: InputMaybe<Scalars['Float']['input']>;
  list_date?: InputMaybe<Scalars['String']['input']>;
  living_room_finish?: InputMaybe<Scalars['Float']['input']>;
  neighbors_commercial_strength?: InputMaybe<Scalars['Float']['input']>;
  neighbors_industrial_strength?: InputMaybe<Scalars['Float']['input']>;
  neighbors_multi_family_strength?: InputMaybe<Scalars['Float']['input']>;
  neighbors_school_strength?: InputMaybe<Scalars['Float']['input']>;
  other_attractor_strength?: InputMaybe<Scalars['Float']['input']>;
  other_detractor_strength?: InputMaybe<Scalars['Float']['input']>;
  park_lot_strength?: InputMaybe<Scalars['Float']['input']>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  pool_type?: InputMaybe<Scalars['String']['input']>;
  powerline_type?: InputMaybe<Scalars['String']['input']>;
  powerline_type_high_voltage_powerline_pole_strength?: InputMaybe<Scalars['Float']['input']>;
  powerline_type_high_voltage_powerline_tower_strength?: InputMaybe<Scalars['Float']['input']>;
  powerline_type_high_voltage_powerline_wire_strength?: InputMaybe<Scalars['Float']['input']>;
  powerline_type_low_voltage_powerline_strength?: InputMaybe<Scalars['Float']['input']>;
  powerline_type_powerline_station_strength?: InputMaybe<Scalars['Float']['input']>;
  primary_floor_type?: InputMaybe<Scalars['Float']['input']>;
  primary_flooring_material?: InputMaybe<Scalars['String']['input']>;
  primary_hardwood_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  primary_laminate_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  primary_tile_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  railroad_strength?: InputMaybe<Scalars['Float']['input']>;
  roof_type?: InputMaybe<Scalars['String']['input']>;
  secondary_floor_type?: InputMaybe<Scalars['Float']['input']>;
  secondary_flooring_material?: InputMaybe<Scalars['String']['input']>;
  secondary_hardwood_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  secondary_laminate_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  secondary_tile_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  slc_lender_owned_reo?: InputMaybe<Scalars['Float']['input']>;
  slc_short_sale?: InputMaybe<Scalars['Float']['input']>;
  sloped_back_yard_strength?: InputMaybe<Scalars['Float']['input']>;
  sloped_driveway_strength?: InputMaybe<Scalars['Float']['input']>;
  tile_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  total_hardwood_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  total_laminate_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  total_tile_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  townhouse_end_unit?: InputMaybe<Scalars['Float']['input']>;
  views_strength?: InputMaybe<Scalars['Float']['input']>;
  yard_landscaping_strength?: InputMaybe<Scalars['Float']['input']>;
};

export type SignalsHybridOvmValuationInput = {
  entityId: Scalars['String']['input'];
  entityType: SignalsEntityType;
  featureFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  historicalTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  manualOverrideComps?: InputMaybe<Array<SignalsCompOverrideInput>>;
  market: Scalars['String']['input'];
  modelType?: InputMaybe<Scalars['String']['input']>;
  responseIncludeFeatures?: InputMaybe<Scalars['Boolean']['input']>;
  responseIncludeRisk?: InputMaybe<Scalars['Boolean']['input']>;
  subjectOverlay?: InputMaybe<SignalsOverlayInput>;
};

export type SignalsOverlayInput = {
  above_grade_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  basement_finished_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  basement_unfinished_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  bathroom_condition_score?: InputMaybe<Scalars['Float']['input']>;
  bathrooms_full?: InputMaybe<Scalars['Float']['input']>;
  bathrooms_half?: InputMaybe<Scalars['Float']['input']>;
  bedrooms?: InputMaybe<Scalars['Float']['input']>;
  busy_road_type_arterial_connector_strength?: InputMaybe<Scalars['Float']['input']>;
  busy_road_type_freeway_highway_strength?: InputMaybe<Scalars['Float']['input']>;
  busy_road_type_main_within_subdivision_strength?: InputMaybe<Scalars['Float']['input']>;
  carport_spaces?: InputMaybe<Scalars['Float']['input']>;
  cul_de_sac?: InputMaybe<Scalars['Float']['input']>;
  dwelling_type?: InputMaybe<Scalars['String']['input']>;
  exterior_condition_score?: InputMaybe<Scalars['Float']['input']>;
  exterior_stories?: InputMaybe<Scalars['Float']['input']>;
  garage_spaces?: InputMaybe<Scalars['Float']['input']>;
  golf_lot_strength?: InputMaybe<Scalars['Float']['input']>;
  has_patio?: InputMaybe<Scalars['Boolean']['input']>;
  has_porch?: InputMaybe<Scalars['Boolean']['input']>;
  interior_condition_score?: InputMaybe<Scalars['Float']['input']>;
  kitchen_appliance_type?: InputMaybe<Scalars['String']['input']>;
  kitchen_condition_score?: InputMaybe<Scalars['Float']['input']>;
  kitchen_countertop?: InputMaybe<Scalars['String']['input']>;
  lake_lot_strength?: InputMaybe<Scalars['Float']['input']>;
  lot_sq_ft?: InputMaybe<Scalars['Float']['input']>;
  neighbors_commercial_strength?: InputMaybe<Scalars['Float']['input']>;
  neighbors_industrial_strength?: InputMaybe<Scalars['Float']['input']>;
  neighbors_multi_family_strength?: InputMaybe<Scalars['Float']['input']>;
  neighbors_school_strength?: InputMaybe<Scalars['Float']['input']>;
  park_lot_strength?: InputMaybe<Scalars['Float']['input']>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  powerline_type_high_voltage_powerline_pole_strength?: InputMaybe<Scalars['Float']['input']>;
  powerline_type_high_voltage_powerline_tower_strength?: InputMaybe<Scalars['Float']['input']>;
  powerline_type_high_voltage_powerline_wire_strength?: InputMaybe<Scalars['Float']['input']>;
  powerline_type_low_voltage_powerline_strength?: InputMaybe<Scalars['Float']['input']>;
  powerline_type_powerline_station_strength?: InputMaybe<Scalars['Float']['input']>;
  primary_floor_type?: InputMaybe<Scalars['String']['input']>;
  property_condition_score?: InputMaybe<Scalars['Float']['input']>;
  railroad_strength?: InputMaybe<Scalars['Float']['input']>;
  secondary_floor_type?: InputMaybe<Scalars['String']['input']>;
  sloped_back_yard_strength?: InputMaybe<Scalars['Float']['input']>;
  sloped_driveway_strength?: InputMaybe<Scalars['Float']['input']>;
  views_strength?: InputMaybe<Scalars['Float']['input']>;
  yard_landscaping_strength?: InputMaybe<Scalars['Float']['input']>;
  year_built?: InputMaybe<Scalars['Float']['input']>;
};

export type SignalsSubdivisionStatsInput = {
  compAddressTokens: Array<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  subjectAddressToken: Scalars['String']['input'];
};

export type SimilarListingsInput = {
  minusBedrooms?: InputMaybe<Scalars['Int']['input']>;
  pageInput: PageInput;
  plusBedrooms?: InputMaybe<Scalars['Int']['input']>;
  priceDcrPct?: InputMaybe<Scalars['Float']['input']>;
  priceIncrPct?: InputMaybe<Scalars['Float']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  sortKey?: InputMaybe<PropertyQuerySortKey>;
};

export enum SprinklerTimer {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
  UNKNOWN = 'UNKNOWN'
}

export type SurveyorValuationCompRequestInput = {
  /** id of the comp we are querying for (eg. '3288535') */
  id: Scalars['String']['input'];
  /** mls type we are requesting from (eg. 'cmls') */
  type: Scalars['String']['input'];
};

export type SurveyorValuationCompsRequestInput = {
  bounds?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  includeManuallyAddedComps?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * if mergeComps: 'false', returns only saved comps from valuation.details.comps
   *    mergeComps: 'true', returns all possible comps from dwellings
   */
  mergeComps?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};

export type SurveyorValuationRequestInput = {
  /**
   * Either `id` or `webValuationId` must be provided in input. If both are provided,
   * `id` is used over `webValuationId`. If neither are provided, TypeError is thrown.
   */
  id?: InputMaybe<Scalars['Int']['input']>;
  webValuationId?: InputMaybe<Scalars['Int']['input']>;
};

/** The type of action for a task CTA */
export enum TaskActionType {
  /** Opens a modal dialog */
  DISPLAY_MODAL = 'DISPLAY_MODAL',
  /** Opens an external URL */
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  /** Triggers the initiateCustomerTask mutation */
  INITIATE_TASK = 'INITIATE_TASK',
  /** Reveals hidden content (e.g., access code) */
  REVEAL_CONTENT = 'REVEAL_CONTENT'
}

export enum TaskActionVariant {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

/** Icons for task groups */
export enum TaskGroupIcon {
  /** Clipboard/search icon for escrow tasks */
  CLIPBOARD_SEARCH = 'CLIPBOARD_SEARCH',
  /** Door icon for access-related tasks */
  DOOR = 'DOOR',
  /** Document/file icon for offer-related tasks */
  FILE_DESCRIPTION = 'FILE_DESCRIPTION',
  /** Home icon for closing tasks */
  HOME = 'HOME'
}

/** Unique identifiers for task groups */
export enum TaskGroupId {
  /** Escrow and closing tasks group */
  ESCROW_CLOSING = 'ESCROW_CLOSING',
  /** Offer-related tasks group */
  OFFER = 'OFFER',
  /** Welcome home tasks group */
  WELCOME_HOME = 'WELCOME_HOME'
}

export enum TaskType {
  HOA_FEES = 'HOA_FEES',
  HVAC_ROOF_INFO = 'HVAC_ROOF_INFO',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  OTHER_HOME_INFO = 'OTHER_HOME_INFO',
  SERVICE_ACCOUNTS = 'SERVICE_ACCOUNTS',
  SET_CLOSE_DATE = 'SET_CLOSE_DATE',
  SET_SIGNATORIES = 'SET_SIGNATORIES',
  SIGN_CHANGE_CLOSE_OF_ESCROW_ADDENDUM = 'SIGN_CHANGE_CLOSE_OF_ESCROW_ADDENDUM',
  SIGN_COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM = 'SIGN_COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM',
  SIGN_FORM_ADDENDUM = 'SIGN_FORM_ADDENDUM',
  SIGN_LATE_CHECKOUT_ADDENDUM = 'SIGN_LATE_CHECKOUT_ADDENDUM',
  UNKNOWN = 'UNKNOWN'
}

/**
 * This enum captures the comprehensive states that should be presented to a customer.
 * The value can be determined by a combination of different values in the backend across
 * systems. States are organized into phases: Offer Review, Contract Signing, In Contract,
 * and Terminal states (successful or unsuccessful). See app/models/listing_offer.rb in
 * the web repo. Specifically the aasm definition.
 */
export enum TransactionState {
  /**
   * The initial state for an offer
   * :active in the backend
   */
  ACTIVE = 'ACTIVE',
  /**
   * Contract is under attorney review (required in some states)
   * :attorney_review in the backend
   */
  ATTORNEY_REVIEW = 'ATTORNEY_REVIEW',
  /** @deprecated Doesn't map to anything in the backend */
  AWAITING_COUNTERSIGNATURE = 'AWAITING_COUNTERSIGNATURE',
  /**
   * Contract is ready and awaiting buyer's signature
   * :awaiting_signature in the backend
   */
  AWAITING_CUSTOMER_SIGNATURE = 'AWAITING_CUSTOMER_SIGNATURE',
  /**
   * Backup offer expired - home was sold to another buyer
   * :backup_already_sold in the backend
   */
  BACKUP_EXPIRED = 'BACKUP_EXPIRED',
  /**
   * Offer is in backup position behind another accepted offer
   * :backup in the backend
   */
  BACKUP_OFFER = 'BACKUP_OFFER',
  /**
   * Offer was canceled by the buyer
   * :buyer_walked in the backend
   */
  BUYER_WALKED = 'BUYER_WALKED',
  /** @deprecated Use AWAITING_COUNTERSIGNATURE instead */
  BUY_DIRECT_AWAITING_COUNTERSIGNATURE = 'BUY_DIRECT_AWAITING_COUNTERSIGNATURE',
  /** @deprecated Use BACKUP_OFFER instead */
  BUY_DIRECT_BACKUP = 'BUY_DIRECT_BACKUP',
  /** @deprecated Use IN_CONTRACT instead */
  BUY_DIRECT_IN_CONTRACT = 'BUY_DIRECT_IN_CONTRACT',
  /** @deprecated Use AWAITING_SIGNATURE instead */
  BUY_DIRECT_UNSIGNED_CONTRACT = 'BUY_DIRECT_UNSIGNED_CONTRACT',
  /**
   * Offer was canceled
   * :canceled in the backend
   */
  CANCELED = 'CANCELED',
  /** @deprecated Use CANCELED instead */
  CANCELED_OFFER = 'CANCELED_OFFER',
  /** @deprecated Use CLOSED instead */
  CLOSE = 'CLOSE',
  /**
   * Transaction completed successfully - buyer now owns the home
   * :closed in the backend
   */
  CLOSED = 'CLOSED',
  /**
   * All contingencies have been released - final steps before close
   * :contingency_released in the backend
   */
  CONTINGENCIES_RELEASED = 'CONTINGENCIES_RELEASED',
  /**
   * Contract fell through after being in contract
   * :contract_fell_through in the backend
   */
  CONTRACT_FELL_THROUGH = 'CONTRACT_FELL_THROUGH',
  /**
   * Opendoor has made a counter offer - buyer action required
   * :countered in the backend
   */
  COUNTER_OFFER_PENDING = 'COUNTER_OFFER_PENDING',
  /**
   * Contract is fully executed and active - proceeding toward close
   * :in_contract in the backend
   */
  IN_CONTRACT = 'IN_CONTRACT',
  /**
   * Offer is being actively negotiated between buyer and Opendoor
   * :in_negotiation in the backend
   */
  IN_NEGOTIATION = 'IN_NEGOTIATION',
  /** @deprecated Doesn't map to anything in the backend */
  PENDING_REVIEW = 'PENDING_REVIEW',
  /**
   * Offer was rejected by Opendoor
   * :rejected in the backend
   */
  REJECTED = 'REJECTED',
  /** Catch-all state if we're unable to map the backend state */
  UNKNOWN = 'UNKNOWN'
}

/**
 * This enum is used to distinguish between Buy Direct transactions and traditional
 * Buy with Opendoor 3P transactions
 */
export enum TransactionType {
  BUY_DIRECT = 'BUY_DIRECT'
}

export type UpdateAgentVerificationStatusInput = {
  agentVerificationStatus: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};

export type UpdateBuyerDataInput = {
  customer_uuid: Scalars['String']['input'];
  data: BuyerDataInput;
};

export type UpdateContentInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateExteriorAssessmentInput = {
  occupant?: InputMaybe<OccupantInfo>;
  reminderPhone?: InputMaybe<Scalars['String']['input']>;
  selectedInspectionTime: Scalars['DateTime']['input'];
  sellerInputUUID: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type WebCreateDocumentInput = {
  documentType: Scalars['String']['input'];
  documentableId: Scalars['String']['input'];
  documentableType: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  externalSource: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sourceChannel: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type WebIncidentParams = {
  location?: InputMaybe<Scalars['String']['input']>;
  tags: Array<InputMaybe<Scalars['String']['input']>>;
};

export type WebListingOfferInput = {
  addendumCounter?: InputMaybe<Scalars['Int']['input']>;
  additionalContractTerms?: InputMaybe<Scalars['String']['input']>;
  agentFirstName?: InputMaybe<Scalars['String']['input']>;
  agentLastName?: InputMaybe<Scalars['String']['input']>;
  agentLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  agentMlsId?: InputMaybe<Scalars['String']['input']>;
  agentOfficeId?: InputMaybe<Scalars['String']['input']>;
  buyer2CustomerId?: InputMaybe<Scalars['Int']['input']>;
  buyer2Email?: InputMaybe<Scalars['String']['input']>;
  buyer2Name?: InputMaybe<Scalars['String']['input']>;
  buyer2Phone?: InputMaybe<Scalars['String']['input']>;
  buyerCustomerId?: InputMaybe<Scalars['Int']['input']>;
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  buyerName?: InputMaybe<Scalars['String']['input']>;
  buyerPhone?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  closeOfEscrow?: InputMaybe<Scalars['RubyTimestamp']['input']>;
  coSellingAgentFirstName?: InputMaybe<Scalars['String']['input']>;
  coSellingAgentLastName?: InputMaybe<Scalars['String']['input']>;
  coSellingAgentMlsId?: InputMaybe<Scalars['String']['input']>;
  concessionForPurchaseContractCents?: InputMaybe<Scalars['Int']['input']>;
  concessionFromSellerCents?: InputMaybe<Scalars['Int']['input']>;
  contactCustomerId?: InputMaybe<Scalars['Int']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  downPaymentCents?: InputMaybe<Scalars['Int']['input']>;
  earnestDepositCents?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  financingStatus?: InputMaybe<Scalars['String']['input']>;
  financingType?: InputMaybe<Scalars['String']['input']>;
  homeWarrantyCents?: InputMaybe<Scalars['Int']['input']>;
  homeWarrantyType?: InputMaybe<Scalars['String']['input']>;
  initialOfferNotes?: InputMaybe<Scalars['String']['input']>;
  inspectionContingenciesReleased?: InputMaybe<Scalars['RubyTimestamp']['input']>;
  inspectionPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  lenderContactEmail?: InputMaybe<Scalars['String']['input']>;
  lenderContactName?: InputMaybe<Scalars['String']['input']>;
  lenderContactPhone?: InputMaybe<Scalars['String']['input']>;
  lenderOrganizationName?: InputMaybe<Scalars['String']['input']>;
  lenderType?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  listingState?: InputMaybe<Scalars['String']['input']>;
  loanAmountCents?: InputMaybe<Scalars['Int']['input']>;
  mlsConcessionType?: InputMaybe<Scalars['String']['input']>;
  priceCents?: InputMaybe<Scalars['Int']['input']>;
  receivedDate?: InputMaybe<Scalars['RubyTimestamp']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  titleContactId?: InputMaybe<Scalars['String']['input']>;
  titleOrgId?: InputMaybe<Scalars['String']['input']>;
  warrantyDeclined?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WebNewCloseOfEscrowRequestState {
  ACCEPTED = 'ACCEPTED',
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  DENIED = 'DENIED'
}

export type WebSavedEmailInput = {
  helpscoutThreadId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  messageableId?: InputMaybe<Scalars['ID']['input']>;
  messageableType?: InputMaybe<Scalars['String']['input']>;
};

export type WebUpdateDocumentInput = {
  documentType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** enum WebVisitType */
export enum WebVisitType {
  ASSESSMENT_VISIT = 'ASSESSMENT_VISIT',
  DILIGENCE_VISIT = 'DILIGENCE_VISIT'
}

export enum ZoneShapeOption {
  EXCLUDE = 'EXCLUDE',
  FULL_SIZE = 'FULL_SIZE',
  SIMPLIFY = 'SIMPLIFY'
}
